!function(e, t) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).RevealHighlight = t();
}(this, function() {
    "use strict";
    function e(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
    }
    function t(e) {
        return e instanceof Map ? e.clear = e.delete = e.set = function() {
            throw new Error("map is read-only");
        } : e instanceof Set && (e.add = e.clear = e.delete = function() {
            throw new Error("set is read-only");
        }), Object.freeze(e), Object.getOwnPropertyNames(e).forEach((a)=>{
            const n = e[a], i = typeof n;
            "object" !== i && "function" !== i || Object.isFrozen(n) || t(n);
        }), e;
    }
    class a {
        constructor(e){
            void 0 === e.data && (e.data = {}), this.data = e.data, this.isMatchIgnored = !1;
        }
        ignoreMatch() {
            this.isMatchIgnored = !0;
        }
    }
    function n(e) {
        return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
    }
    function i(e, ...t) {
        const a = Object.create(null);
        for(const t in e)a[t] = e[t];
        return t.forEach(function(e) {
            for(const t in e)a[t] = e[t];
        }), a;
    }
    const r = (e)=>!!e.scope;
    class o {
        constructor(e, t){
            this.buffer = "", this.classPrefix = t.classPrefix, e.walk(this);
        }
        addText(e) {
            this.buffer += n(e);
        }
        openNode(e) {
            if (!r(e)) return;
            const t = ((e, { prefix: t })=>{
                if (e.startsWith("language:")) return e.replace("language:", "language-");
                if (e.includes(".")) {
                    const a = e.split(".");
                    return [
                        `${t}${a.shift()}`,
                        ...a.map((e, t)=>`${e}${"_".repeat(t + 1)}`)
                    ].join(" ");
                }
                return `${t}${e}`;
            })(e.scope, {
                prefix: this.classPrefix
            });
            this.span(t);
        }
        closeNode(e) {
            r(e) && (this.buffer += "</span>");
        }
        value() {
            return this.buffer;
        }
        span(e) {
            this.buffer += `<span class="${e}">`;
        }
    }
    const s = (e = {})=>{
        const t = {
            children: []
        };
        return Object.assign(t, e), t;
    };
    class l {
        constructor(){
            this.rootNode = s(), this.stack = [
                this.rootNode
            ];
        }
        get top() {
            return this.stack[this.stack.length - 1];
        }
        get root() {
            return this.rootNode;
        }
        add(e) {
            this.top.children.push(e);
        }
        openNode(e) {
            const t = s({
                scope: e
            });
            this.add(t), this.stack.push(t);
        }
        closeNode() {
            if (this.stack.length > 1) return this.stack.pop();
        }
        closeAllNodes() {
            for(; this.closeNode(););
        }
        toJSON() {
            return JSON.stringify(this.rootNode, null, 4);
        }
        walk(e) {
            return this.constructor._walk(e, this.rootNode);
        }
        static _walk(e, t) {
            return "string" == typeof t ? e.addText(t) : t.children && (e.openNode(t), t.children.forEach((t)=>this._walk(e, t)), e.closeNode(t)), e;
        }
        static _collapse(e) {
            "string" != typeof e && e.children && (e.children.every((e)=>"string" == typeof e) ? e.children = [
                e.children.join("")
            ] : e.children.forEach((e)=>{
                l._collapse(e);
            }));
        }
    }
    class c extends l {
        constructor(e){
            super(), this.options = e;
        }
        addText(e) {
            "" !== e && this.add(e);
        }
        startScope(e) {
            this.openNode(e);
        }
        endScope() {
            this.closeNode();
        }
        __addSublanguage(e, t) {
            const a = e.root;
            t && (a.scope = `language:${t}`), this.add(a);
        }
        toHTML() {
            return new o(this, this.options).value();
        }
        finalize() {
            return this.closeAllNodes(), !0;
        }
    }
    function _(e) {
        return e ? "string" == typeof e ? e : e.source : null;
    }
    function d(e) {
        return u("(?=", e, ")");
    }
    function m(e) {
        return u("(?:", e, ")*");
    }
    function p(e) {
        return u("(?:", e, ")?");
    }
    function u(...e) {
        return e.map((e)=>_(e)).join("");
    }
    function g(...e) {
        const t = function(e) {
            const t = e[e.length - 1];
            return "object" == typeof t && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
        }(e);
        return "(" + (t.capture ? "" : "?:") + e.map((e)=>_(e)).join("|") + ")";
    }
    function E(e) {
        return new RegExp(e.toString() + "|").exec("").length - 1;
    }
    const S = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
    function b(e, { joinWith: t }) {
        let a = 0;
        return e.map((e)=>{
            a += 1;
            const t = a;
            let n = _(e), i = "";
            for(; n.length > 0;){
                const e = S.exec(n);
                if (!e) {
                    i += n;
                    break;
                }
                i += n.substring(0, e.index), n = n.substring(e.index + e[0].length), "\\" === e[0][0] && e[1] ? i += "\\" + String(Number(e[1]) + t) : (i += e[0], "(" === e[0] && a++);
            }
            return i;
        }).map((e)=>`(${e})`).join(t);
    }
    const T = "[a-zA-Z]\\w*", C = "[a-zA-Z_]\\w*", f = "\\b\\d+(\\.\\d+)?", R = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", N = "\\b(0b[01]+)", O = {
        begin: "\\\\[\\s\\S]",
        relevance: 0
    }, h = {
        scope: "string",
        begin: "'",
        end: "'",
        illegal: "\\n",
        contains: [
            O
        ]
    }, v = {
        scope: "string",
        begin: '"',
        end: '"',
        illegal: "\\n",
        contains: [
            O
        ]
    }, I = function(e, t, a = {}) {
        const n = i({
            scope: "comment",
            begin: e,
            end: t,
            contains: []
        }, a);
        n.contains.push({
            scope: "doctag",
            begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
            end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
            excludeBegin: !0,
            relevance: 0
        });
        const r = g("I", "a", "is", "so", "us", "to", "at", "if", "in", "it", "on", /[A-Za-z]+['](d|ve|re|ll|t|s|n)/, /[A-Za-z]+[-][a-z]+/, /[A-Za-z][a-z]{2,}/);
        return n.contains.push({
            begin: u(/[ ]+/, "(", r, /[.]?[:]?([.][ ]|[ ])/, "){3}")
        }), n;
    }, A = I("//", "$"), y = I("/\\*", "\\*/"), D = I("#", "$"), M = {
        scope: "number",
        begin: f,
        relevance: 0
    }, L = {
        scope: "number",
        begin: R,
        relevance: 0
    }, x = {
        scope: "number",
        begin: N,
        relevance: 0
    }, w = {
        scope: "regexp",
        begin: /\/(?=[^/\n]*\/)/,
        end: /\/[gimuy]*/,
        contains: [
            O,
            {
                begin: /\[/,
                end: /\]/,
                relevance: 0,
                contains: [
                    O
                ]
            }
        ]
    }, P = {
        scope: "title",
        begin: T,
        relevance: 0
    }, k = {
        scope: "title",
        begin: C,
        relevance: 0
    }, U = {
        begin: "\\.\\s*" + C,
        relevance: 0
    };
    var F = Object.freeze({
        __proto__: null,
        APOS_STRING_MODE: h,
        BACKSLASH_ESCAPE: O,
        BINARY_NUMBER_MODE: x,
        BINARY_NUMBER_RE: N,
        COMMENT: I,
        C_BLOCK_COMMENT_MODE: y,
        C_LINE_COMMENT_MODE: A,
        C_NUMBER_MODE: L,
        C_NUMBER_RE: R,
        END_SAME_AS_BEGIN: function(e) {
            return Object.assign(e, {
                "on:begin": (e, t)=>{
                    t.data._beginMatch = e[1];
                },
                "on:end": (e, t)=>{
                    t.data._beginMatch !== e[1] && t.ignoreMatch();
                }
            });
        },
        HASH_COMMENT_MODE: D,
        IDENT_RE: T,
        MATCH_NOTHING_RE: /\b\B/,
        METHOD_GUARD: U,
        NUMBER_MODE: M,
        NUMBER_RE: f,
        PHRASAL_WORDS_MODE: {
            begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
        },
        QUOTE_STRING_MODE: v,
        REGEXP_MODE: w,
        RE_STARTERS_RE: "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~",
        SHEBANG: (e = {})=>{
            const t = /^#![ ]*\//;
            return e.binary && (e.begin = u(t, /.*\b/, e.binary, /\b.*/)), i({
                scope: "meta",
                begin: t,
                end: /$/,
                relevance: 0,
                "on:begin": (e, t)=>{
                    0 !== e.index && t.ignoreMatch();
                }
            }, e);
        },
        TITLE_MODE: P,
        UNDERSCORE_IDENT_RE: C,
        UNDERSCORE_TITLE_MODE: k
    });
    function B(e, t) {
        "." === e.input[e.index - 1] && t.ignoreMatch();
    }
    function G(e, t) {
        void 0 !== e.className && (e.scope = e.className, delete e.className);
    }
    function Y(e, t) {
        t && e.beginKeywords && (e.begin = "\\b(" + e.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", e.__beforeBegin = B, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, void 0 === e.relevance && (e.relevance = 0));
    }
    function H(e, t) {
        Array.isArray(e.illegal) && (e.illegal = g(...e.illegal));
    }
    function V(e, t) {
        if (e.match) {
            if (e.begin || e.end) throw new Error("begin & end are not supported with match");
            e.begin = e.match, delete e.match;
        }
    }
    function q(e, t) {
        void 0 === e.relevance && (e.relevance = 1);
    }
    const z = (e, t)=>{
        if (!e.beforeMatch) return;
        if (e.starts) throw new Error("beforeMatch cannot be used with starts");
        const a = Object.assign({}, e);
        Object.keys(e).forEach((t)=>{
            delete e[t];
        }), e.keywords = a.keywords, e.begin = u(a.beforeMatch, d(a.begin)), e.starts = {
            relevance: 0,
            contains: [
                Object.assign(a, {
                    endsParent: !0
                })
            ]
        }, e.relevance = 0, delete a.beforeMatch;
    }, $ = [
        "of",
        "and",
        "for",
        "in",
        "not",
        "or",
        "if",
        "then",
        "parent",
        "list",
        "value"
    ], W = "keyword";
    function Q(e, t, a = W) {
        const n = Object.create(null);
        return "string" == typeof e ? i(a, e.split(" ")) : Array.isArray(e) ? i(a, e) : Object.keys(e).forEach(function(a) {
            Object.assign(n, Q(e[a], t, a));
        }), n;
        function i(e, a) {
            t && (a = a.map((e)=>e.toLowerCase())), a.forEach(function(t) {
                const a = t.split("|");
                n[a[0]] = [
                    e,
                    K(a[0], a[1])
                ];
            });
        }
    }
    function K(e, t) {
        return t ? Number(t) : function(e) {
            return $.includes(e.toLowerCase());
        }(e) ? 0 : 1;
    }
    const j = {}, X = (e)=>{
        console.error(e);
    }, Z = (e, ...t)=>{
        console.log(`WARN: ${e}`, ...t);
    }, J = (e, t)=>{
        j[`${e}/${t}`] || (console.log(`Deprecated as of ${e}. ${t}`), j[`${e}/${t}`] = !0);
    }, ee = new Error;
    function te(e, t, { key: a }) {
        let n = 0;
        const i = e[a], r = {}, o = {};
        for(let e = 1; e <= t.length; e++)o[e + n] = i[e], r[e + n] = !0, n += E(t[e - 1]);
        e[a] = o, e[a]._emit = r, e[a]._multi = !0;
    }
    function ae(e) {
        !function(e) {
            e.scope && "object" == typeof e.scope && null !== e.scope && (e.beginScope = e.scope, delete e.scope);
        }(e), "string" == typeof e.beginScope && (e.beginScope = {
            _wrap: e.beginScope
        }), "string" == typeof e.endScope && (e.endScope = {
            _wrap: e.endScope
        }), function(e) {
            if (Array.isArray(e.begin)) {
                if (e.skip || e.excludeBegin || e.returnBegin) throw X("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), ee;
                if ("object" != typeof e.beginScope || null === e.beginScope) throw X("beginScope must be object"), ee;
                te(e, e.begin, {
                    key: "beginScope"
                }), e.begin = b(e.begin, {
                    joinWith: ""
                });
            }
        }(e), function(e) {
            if (Array.isArray(e.end)) {
                if (e.skip || e.excludeEnd || e.returnEnd) throw X("skip, excludeEnd, returnEnd not compatible with endScope: {}"), ee;
                if ("object" != typeof e.endScope || null === e.endScope) throw X("endScope must be object"), ee;
                te(e, e.end, {
                    key: "endScope"
                }), e.end = b(e.end, {
                    joinWith: ""
                });
            }
        }(e);
    }
    function ne(e) {
        function t(t, a) {
            return new RegExp(_(t), "m" + (e.case_insensitive ? "i" : "") + (e.unicodeRegex ? "u" : "") + (a ? "g" : ""));
        }
        class a {
            constructor(){
                this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
            }
            addRule(e, t) {
                t.position = this.position++, this.matchIndexes[this.matchAt] = t, this.regexes.push([
                    t,
                    e
                ]), this.matchAt += E(e) + 1;
            }
            compile() {
                0 === this.regexes.length && (this.exec = ()=>null);
                const e = this.regexes.map((e)=>e[1]);
                this.matcherRe = t(b(e, {
                    joinWith: "|"
                }), !0), this.lastIndex = 0;
            }
            exec(e) {
                this.matcherRe.lastIndex = this.lastIndex;
                const t = this.matcherRe.exec(e);
                if (!t) return null;
                const a = t.findIndex((e, t)=>t > 0 && void 0 !== e), n = this.matchIndexes[a];
                return t.splice(0, a), Object.assign(t, n);
            }
        }
        class n {
            constructor(){
                this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
            }
            getMatcher(e) {
                if (this.multiRegexes[e]) return this.multiRegexes[e];
                const t = new a;
                return this.rules.slice(e).forEach(([e, a])=>t.addRule(e, a)), t.compile(), this.multiRegexes[e] = t, t;
            }
            resumingScanAtSamePosition() {
                return 0 !== this.regexIndex;
            }
            considerAll() {
                this.regexIndex = 0;
            }
            addRule(e, t) {
                this.rules.push([
                    e,
                    t
                ]), "begin" === t.type && this.count++;
            }
            exec(e) {
                const t = this.getMatcher(this.regexIndex);
                t.lastIndex = this.lastIndex;
                let a = t.exec(e);
                if (this.resumingScanAtSamePosition()) {
                    if (a && a.index === this.lastIndex) ;
                    else {
                        const t = this.getMatcher(0);
                        t.lastIndex = this.lastIndex + 1, a = t.exec(e);
                    }
                }
                return a && (this.regexIndex += a.position + 1, this.regexIndex === this.count && this.considerAll()), a;
            }
        }
        if (e.compilerExtensions || (e.compilerExtensions = []), e.contains && e.contains.includes("self")) throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
        return e.classNameAliases = i(e.classNameAliases || {}), function a(r, o) {
            const s = r;
            if (r.isCompiled) return s;
            [
                G,
                V,
                ae,
                z
            ].forEach((e)=>e(r, o)), e.compilerExtensions.forEach((e)=>e(r, o)), r.__beforeBegin = null, [
                Y,
                H,
                q
            ].forEach((e)=>e(r, o)), r.isCompiled = !0;
            let l = null;
            return "object" == typeof r.keywords && r.keywords.$pattern && (r.keywords = Object.assign({}, r.keywords), l = r.keywords.$pattern, delete r.keywords.$pattern), l = l || /\w+/, r.keywords && (r.keywords = Q(r.keywords, e.case_insensitive)), s.keywordPatternRe = t(l, !0), o && (r.begin || (r.begin = /\B|\b/), s.beginRe = t(s.begin), r.end || r.endsWithParent || (r.end = /\B|\b/), r.end && (s.endRe = t(s.end)), s.terminatorEnd = _(s.end) || "", r.endsWithParent && o.terminatorEnd && (s.terminatorEnd += (r.end ? "|" : "") + o.terminatorEnd)), r.illegal && (s.illegalRe = t(r.illegal)), r.contains || (r.contains = []), r.contains = [].concat(...r.contains.map(function(e) {
                return function(e) {
                    e.variants && !e.cachedVariants && (e.cachedVariants = e.variants.map(function(t) {
                        return i(e, {
                            variants: null
                        }, t);
                    }));
                    if (e.cachedVariants) return e.cachedVariants;
                    if (ie(e)) return i(e, {
                        starts: e.starts ? i(e.starts) : null
                    });
                    if (Object.isFrozen(e)) return i(e);
                    return e;
                }("self" === e ? r : e);
            })), r.contains.forEach(function(e) {
                a(e, s);
            }), r.starts && a(r.starts, o), s.matcher = function(e) {
                const t = new n;
                return e.contains.forEach((e)=>t.addRule(e.begin, {
                        rule: e,
                        type: "begin"
                    })), e.terminatorEnd && t.addRule(e.terminatorEnd, {
                    type: "end"
                }), e.illegal && t.addRule(e.illegal, {
                    type: "illegal"
                }), t;
            }(s), s;
        }(e);
    }
    function ie(e) {
        return !!e && (e.endsWithParent || ie(e.starts));
    }
    class re extends Error {
        constructor(e, t){
            super(e), this.name = "HTMLInjectionError", this.html = t;
        }
    }
    const oe = n, se = i, le = Symbol("nomatch"), ce = function(e) {
        const n = Object.create(null), i = Object.create(null), r = [];
        let o = !0;
        const s = "Could not find the language '{}', did you forget to load/include a language module?", l = {
            disableAutodetect: !0,
            name: "Plain text",
            contains: []
        };
        let _ = {
            ignoreUnescapedHTML: !1,
            throwUnescapedHTML: !1,
            noHighlightRe: /^(no-?highlight)$/i,
            languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
            classPrefix: "hljs-",
            cssSelector: "pre code",
            languages: null,
            __emitter: c
        };
        function E(e) {
            return _.noHighlightRe.test(e);
        }
        function S(e, t, a) {
            let n = "", i = "";
            "object" == typeof t ? (n = e, a = t.ignoreIllegals, i = t.language) : (J("10.7.0", "highlight(lang, code, ...args) has been deprecated."), J("10.7.0", "Please use highlight(code, options) instead.\nhttps://github.com/highlightjs/highlight.js/issues/2277"), i = e, n = t), void 0 === a && (a = !0);
            const r = {
                code: n,
                language: i
            };
            v("before:highlight", r);
            const o = r.result ? r.result : b(r.language, r.code, a);
            return o.code = r.code, v("after:highlight", o), o;
        }
        function b(e, t, i, r) {
            const l = Object.create(null);
            function c() {
                if (!v.keywords) return void A.addText(y);
                let e = 0;
                v.keywordPatternRe.lastIndex = 0;
                let t = v.keywordPatternRe.exec(y), a = "";
                for(; t;){
                    a += y.substring(e, t.index);
                    const i = R.case_insensitive ? t[0].toLowerCase() : t[0], r = (n = i, v.keywords[n]);
                    if (r) {
                        const [e, n] = r;
                        if (A.addText(a), a = "", l[i] = (l[i] || 0) + 1, l[i] <= 7 && (D += n), e.startsWith("_")) a += t[0];
                        else {
                            const a = R.classNameAliases[e] || e;
                            m(t[0], a);
                        }
                    } else a += t[0];
                    e = v.keywordPatternRe.lastIndex, t = v.keywordPatternRe.exec(y);
                }
                var n;
                a += y.substring(e), A.addText(a);
            }
            function d() {
                null != v.subLanguage ? function() {
                    if ("" === y) return;
                    let e = null;
                    if ("string" == typeof v.subLanguage) {
                        if (!n[v.subLanguage]) return void A.addText(y);
                        e = b(v.subLanguage, y, !0, I[v.subLanguage]), I[v.subLanguage] = e._top;
                    } else e = T(y, v.subLanguage.length ? v.subLanguage : null);
                    v.relevance > 0 && (D += e.relevance), A.__addSublanguage(e._emitter, e.language);
                }() : c(), y = "";
            }
            function m(e, t) {
                "" !== e && (A.startScope(t), A.addText(e), A.endScope());
            }
            function p(e, t) {
                let a = 1;
                const n = t.length - 1;
                for(; a <= n;){
                    if (!e._emit[a]) {
                        a++;
                        continue;
                    }
                    const n = R.classNameAliases[e[a]] || e[a], i = t[a];
                    n ? m(i, n) : (y = i, c(), y = ""), a++;
                }
            }
            function u(e, t) {
                return e.scope && "string" == typeof e.scope && A.openNode(R.classNameAliases[e.scope] || e.scope), e.beginScope && (e.beginScope._wrap ? (m(y, R.classNameAliases[e.beginScope._wrap] || e.beginScope._wrap), y = "") : e.beginScope._multi && (p(e.beginScope, t), y = "")), v = Object.create(e, {
                    parent: {
                        value: v
                    }
                }), v;
            }
            function g(e, t, n) {
                let i = function(e, t) {
                    const a = e && e.exec(t);
                    return a && 0 === a.index;
                }(e.endRe, n);
                if (i) {
                    if (e["on:end"]) {
                        const n = new a(e);
                        e["on:end"](t, n), n.isMatchIgnored && (i = !1);
                    }
                    if (i) {
                        for(; e.endsParent && e.parent;)e = e.parent;
                        return e;
                    }
                }
                if (e.endsWithParent) return g(e.parent, t, n);
            }
            function E(e) {
                return 0 === v.matcher.regexIndex ? (y += e[0], 1) : (x = !0, 0);
            }
            function S(e) {
                const a = e[0], n = t.substring(e.index), i = g(v, e, n);
                if (!i) return le;
                const r = v;
                v.endScope && v.endScope._wrap ? (d(), m(a, v.endScope._wrap)) : v.endScope && v.endScope._multi ? (d(), p(v.endScope, e)) : r.skip ? y += a : (r.returnEnd || r.excludeEnd || (y += a), d(), r.excludeEnd && (y = a));
                do v.scope && A.closeNode(), v.skip || v.subLanguage || (D += v.relevance), v = v.parent;
                while (v !== i.parent);
                return i.starts && u(i.starts, e), r.returnEnd ? 0 : a.length;
            }
            let C = {};
            function f(n, r) {
                const s = r && r[0];
                if (y += n, null == s) return d(), 0;
                if ("begin" === C.type && "end" === r.type && C.index === r.index && "" === s) {
                    if (y += t.slice(r.index, r.index + 1), !o) {
                        const t = new Error(`0 width match regex (${e})`);
                        throw t.languageName = e, t.badRule = C.rule, t;
                    }
                    return 1;
                }
                if (C = r, "begin" === r.type) return function(e) {
                    const t = e[0], n = e.rule, i = new a(n), r = [
                        n.__beforeBegin,
                        n["on:begin"]
                    ];
                    for (const a of r)if (a && (a(e, i), i.isMatchIgnored)) return E(t);
                    return n.skip ? y += t : (n.excludeBegin && (y += t), d(), n.returnBegin || n.excludeBegin || (y = t)), u(n, e), n.returnBegin ? 0 : t.length;
                }(r);
                if ("illegal" === r.type && !i) {
                    const e = new Error('Illegal lexeme "' + s + '" for mode "' + (v.scope || "<unnamed>") + '"');
                    throw e.mode = v, e;
                }
                if ("end" === r.type) {
                    const e = S(r);
                    if (e !== le) return e;
                }
                if ("illegal" === r.type && "" === s) return 1;
                if (L > 1e5 && L > 3 * r.index) throw new Error("potential infinite loop, way more iterations than matches");
                return y += s, s.length;
            }
            const R = N(e);
            if (!R) throw X(s.replace("{}", e)), new Error('Unknown language: "' + e + '"');
            const O = ne(R);
            let h = "", v = r || O;
            const I = {}, A = new _.__emitter(_);
            !function() {
                const e = [];
                for(let t = v; t !== R; t = t.parent)t.scope && e.unshift(t.scope);
                e.forEach((e)=>A.openNode(e));
            }();
            let y = "", D = 0, M = 0, L = 0, x = !1;
            try {
                if (R.__emitTokens) R.__emitTokens(t, A);
                else {
                    for(v.matcher.considerAll();;){
                        L++, x ? x = !1 : v.matcher.considerAll(), v.matcher.lastIndex = M;
                        const e = v.matcher.exec(t);
                        if (!e) break;
                        const a = f(t.substring(M, e.index), e);
                        M = e.index + a;
                    }
                    f(t.substring(M));
                }
                return A.finalize(), h = A.toHTML(), {
                    language: e,
                    value: h,
                    relevance: D,
                    illegal: !1,
                    _emitter: A,
                    _top: v
                };
            } catch (a) {
                if (a.message && a.message.includes("Illegal")) return {
                    language: e,
                    value: oe(t),
                    illegal: !0,
                    relevance: 0,
                    _illegalBy: {
                        message: a.message,
                        index: M,
                        context: t.slice(M - 100, M + 100),
                        mode: a.mode,
                        resultSoFar: h
                    },
                    _emitter: A
                };
                if (o) return {
                    language: e,
                    value: oe(t),
                    illegal: !1,
                    relevance: 0,
                    errorRaised: a,
                    _emitter: A,
                    _top: v
                };
                throw a;
            }
        }
        function T(e, t) {
            t = t || _.languages || Object.keys(n);
            const a = function(e) {
                const t = {
                    value: oe(e),
                    illegal: !1,
                    relevance: 0,
                    _top: l,
                    _emitter: new _.__emitter(_)
                };
                return t._emitter.addText(e), t;
            }(e), i = t.filter(N).filter(h).map((t)=>b(t, e, !1));
            i.unshift(a);
            const r = i.sort((e, t)=>{
                if (e.relevance !== t.relevance) return t.relevance - e.relevance;
                if (e.language && t.language) {
                    if (N(e.language).supersetOf === t.language) return 1;
                    if (N(t.language).supersetOf === e.language) return -1;
                }
                return 0;
            }), [o, s] = r, c = o;
            return c.secondBest = s, c;
        }
        function C(e) {
            let t = null;
            const a = function(e) {
                let t = e.className + " ";
                t += e.parentNode ? e.parentNode.className : "";
                const a = _.languageDetectRe.exec(t);
                if (a) {
                    const t = N(a[1]);
                    return t || (Z(s.replace("{}", a[1])), Z("Falling back to no-highlight mode for this block.", e)), t ? a[1] : "no-highlight";
                }
                return t.split(/\s+/).find((e)=>E(e) || N(e));
            }(e);
            if (E(a)) return;
            if (v("before:highlightElement", {
                el: e,
                language: a
            }), e.dataset.highlighted) return void console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", e);
            if (e.children.length > 0 && (_.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(e)), _.throwUnescapedHTML)) throw new re("One of your code blocks includes unescaped HTML.", e.innerHTML);
            t = e;
            const n = t.textContent, r = a ? S(n, {
                language: a,
                ignoreIllegals: !0
            }) : T(n);
            e.innerHTML = r.value, e.dataset.highlighted = "yes", function(e, t, a) {
                const n = t && i[t] || a;
                e.classList.add("hljs"), e.classList.add(`language-${n}`);
            }(e, a, r.language), e.result = {
                language: r.language,
                re: r.relevance,
                relevance: r.relevance
            }, r.secondBest && (e.secondBest = {
                language: r.secondBest.language,
                relevance: r.secondBest.relevance
            }), v("after:highlightElement", {
                el: e,
                result: r,
                text: n
            });
        }
        let f = !1;
        function R() {
            if ("loading" === document.readyState) return void (f = !0);
            document.querySelectorAll(_.cssSelector).forEach(C);
        }
        function N(e) {
            return e = (e || "").toLowerCase(), n[e] || n[i[e]];
        }
        function O(e, { languageName: t }) {
            "string" == typeof e && (e = [
                e
            ]), e.forEach((e)=>{
                i[e.toLowerCase()] = t;
            });
        }
        function h(e) {
            const t = N(e);
            return t && !t.disableAutodetect;
        }
        function v(e, t) {
            const a = e;
            r.forEach(function(e) {
                e[a] && e[a](t);
            });
        }
        "undefined" != typeof window && window.addEventListener && window.addEventListener("DOMContentLoaded", function() {
            f && R();
        }, !1), Object.assign(e, {
            highlight: S,
            highlightAuto: T,
            highlightAll: R,
            highlightElement: C,
            highlightBlock: function(e) {
                return J("10.7.0", "highlightBlock will be removed entirely in v12.0"), J("10.7.0", "Please use highlightElement now."), C(e);
            },
            configure: function(e) {
                _ = se(_, e);
            },
            initHighlighting: ()=>{
                R(), J("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
            },
            initHighlightingOnLoad: function() {
                R(), J("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
            },
            registerLanguage: function(t, a) {
                let i = null;
                try {
                    i = a(e);
                } catch (e) {
                    if (X("Language definition for '{}' could not be registered.".replace("{}", t)), !o) throw e;
                    X(e), i = l;
                }
                i.name || (i.name = t), n[t] = i, i.rawDefinition = a.bind(null, e), i.aliases && O(i.aliases, {
                    languageName: t
                });
            },
            unregisterLanguage: function(e) {
                delete n[e];
                for (const t of Object.keys(i))i[t] === e && delete i[t];
            },
            listLanguages: function() {
                return Object.keys(n);
            },
            getLanguage: N,
            registerAliases: O,
            autoDetection: h,
            inherit: se,
            addPlugin: function(e) {
                !function(e) {
                    e["before:highlightBlock"] && !e["before:highlightElement"] && (e["before:highlightElement"] = (t)=>{
                        e["before:highlightBlock"](Object.assign({
                            block: t.el
                        }, t));
                    }), e["after:highlightBlock"] && !e["after:highlightElement"] && (e["after:highlightElement"] = (t)=>{
                        e["after:highlightBlock"](Object.assign({
                            block: t.el
                        }, t));
                    });
                }(e), r.push(e);
            },
            removePlugin: function(e) {
                const t = r.indexOf(e);
                -1 !== t && r.splice(t, 1);
            }
        }), e.debugMode = function() {
            o = !1;
        }, e.safeMode = function() {
            o = !0;
        }, e.versionString = "11.9.0", e.regex = {
            concat: u,
            lookahead: d,
            either: g,
            optional: p,
            anyNumberOfTimes: m
        };
        for(const e in F)"object" == typeof F[e] && t(F[e]);
        return Object.assign(e, F), e;
    }, _e = ce({});
    _e.newInstance = ()=>ce({});
    var de, me, pe, ue, ge, Ee, Se, be, Te, Ce, fe, Re, Ne, Oe, he, ve, Ie, Ae, ye, De, Me, Le, xe, we, Pe, ke, Ue, Fe, Be, Ge, Ye, He, Ve, qe, ze, $e, We, Qe, Ke, je, Xe, Ze, Je, et, tt, at, nt, it, rt, ot, st, lt, ct, _t, dt, mt, pt, ut, gt, Et, St, bt, Tt, Ct, ft, Rt, Nt, Ot, ht, vt, It, At, yt, Dt, Mt, Lt, xt, wt, Pt, kt, Ut, Ft, Bt, Gt, Yt, Ht, Vt, qt, zt, $t, Wt, Qt, Kt, jt, Xt, Zt, Jt, ea, ta, aa, na, ia, ra, oa, sa, la, ca, _a, da, ma, pa, ua, ga, Ea, Sa, ba, Ta, Ca, fa, Ra, Na, Oa, ha, va, Ia, Aa, ya, Da, Ma, La, xa, wa, Pa, ka, Ua, Fa, Ba, Ga, Ya, Ha, Va, qa, za, $a, Wa, Qa, Ka, ja, Xa, Za, Ja, en, tn, an, nn, rn, on, sn, ln, cn, _n, dn, mn, pn, un, gn, En, Sn, bn, Tn, Cn, fn, Rn, Nn, On, hn, vn, In, An, yn, Dn, Mn, Ln, xn, wn, Pn, kn, Un, Fn, Bn, Gn, Yn, Hn, Vn, qn, zn, $n, Wn, Qn, Kn, jn, Xn, Zn, Jn, ei, ti, ai, ni, ii, ri, oi, si, li, ci, _i, di, mi, pi, ui, gi, Ei, Si, bi, Ti, Ci, fi, Ri, Ni, Oi, hi, vi, Ii, Ai, yi, Di, Mi, Li, xi, wi, Pi, ki, Ui, Fi, Bi, Gi, Yi, Hi, Vi, qi, zi, $i, Wi, Qi, Ki, ji, Xi, Zi, Ji, er, tr, ar, nr, ir, rr, or, sr, lr, cr, _r, dr, mr, pr, ur, gr, Er, Sr, br, Tr, Cr, fr, Rr, Nr, Or, hr, vr, Ir, Ar, yr, Dr, Mr, Lr, xr, wr, Pr, kr, Ur, Fr, Br, Gr, Yr, Hr, Vr, qr, zr, $r, Wr, Qr, Kr, jr, Xr, Zr, Jr, eo, to, ao, no, io, ro, oo, so, lo, co, _o, mo, po, uo, go, Eo, So, bo, To, Co, fo, Ro, No, Oo, ho, vo, Io, Ao, yo, Do, Mo, Lo, xo, wo, Po, ko, Uo, Fo, Bo, Go, Yo, Ho, Vo, qo, zo, $o, Wo, Qo, Ko, jo, Xo, Zo, Jo, es, ts, as, ns, is, rs, os, ss, ls, cs, _s, ds, ms, ps, us, gs, Es, Ss, bs, Ts = _e;
    _e.HighlightJS = _e, _e.default = _e;
    var Cs = Ts;
    Cs.registerLanguage("1c", (me || (me = 1, de = function(e) {
        const t = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]+", a = "\u0434\u0430\u043B\u0435\u0435 \u0432\u043E\u0437\u0432\u0440\u0430\u0442 \u0432\u044B\u0437\u0432\u0430\u0442\u044C\u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0434\u043B\u044F \u0435\u0441\u043B\u0438 \u0438 \u0438\u0437 \u0438\u043B\u0438 \u0438\u043D\u0430\u0447\u0435 \u0438\u043D\u0430\u0447\u0435\u0435\u0441\u043B\u0438 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043A\u043E\u043D\u0435\u0446\u0435\u0441\u043B\u0438 \u043A\u043E\u043D\u0435\u0446\u043F\u043E\u043F\u044B\u0442\u043A\u0438 \u043A\u043E\u043D\u0435\u0446\u0446\u0438\u043A\u043B\u0430 \u043D\u0435 \u043D\u043E\u0432\u044B\u0439 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043F\u0435\u0440\u0435\u043C \u043F\u043E \u043F\u043E\u043A\u0430 \u043F\u043E\u043F\u044B\u0442\u043A\u0430 \u043F\u0440\u0435\u0440\u0432\u0430\u0442\u044C \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0442\u043E\u0433\u0434\u0430 \u0446\u0438\u043A\u043B \u044D\u043A\u0441\u043F\u043E\u0440\u0442 ", n = "null \u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u043E\u0436\u044C \u043D\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043E", i = e.inherit(e.NUMBER_MODE), r = {
            className: "string",
            begin: '"|\\|',
            end: '"|$',
            contains: [
                {
                    begin: '""'
                }
            ]
        }, o = {
            begin: "'",
            end: "'",
            excludeBegin: !0,
            excludeEnd: !0,
            contains: [
                {
                    className: "number",
                    begin: "\\d{4}([\\.\\\\/:-]?\\d{2}){0,5}"
                }
            ]
        }, s = e.inherit(e.C_LINE_COMMENT_MODE);
        return {
            name: "1C:Enterprise",
            case_insensitive: !0,
            keywords: {
                $pattern: t,
                keyword: a,
                built_in: "\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0440\u043E\u043A \u0441\u0438\u043C\u0432\u043E\u043B\u0442\u0430\u0431\u0443\u043B\u044F\u0446\u0438\u0438 ansitooem oemtoansi \u0432\u0432\u0435\u0441\u0442\u0438\u0432\u0438\u0434\u0441\u0443\u0431\u043A\u043E\u043D\u0442\u043E \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0435 \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u0435\u0440\u0438\u043E\u0434 \u0432\u0432\u0435\u0441\u0442\u0438\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u0434\u0430\u0442\u0430\u0433\u043E\u0434 \u0434\u0430\u0442\u0430\u043C\u0435\u0441\u044F\u0446 \u0434\u0430\u0442\u0430\u0447\u0438\u0441\u043B\u043E \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0441\u0442\u0440\u043E\u043A\u0443 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0441\u0442\u0440\u043E\u043A\u0438 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0438\u0431 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A\u043E\u0434\u0441\u0438\u043C\u0432 \u043A\u043E\u043D\u0433\u043E\u0434\u0430 \u043A\u043E\u043D\u0435\u0446\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043A\u043E\u043D\u0435\u0446\u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u043D\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043A\u043E\u043D\u0435\u0446\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430 \u043A\u043E\u043D\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043A\u043E\u043D\u043C\u0435\u0441\u044F\u0446\u0430 \u043A\u043E\u043D\u043D\u0435\u0434\u0435\u043B\u0438 \u043B\u043E\u0433 \u043B\u043E\u043310 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u0441\u0443\u0431\u043A\u043E\u043D\u0442\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\u043D\u0430\u0431\u043E\u0440\u0430\u043F\u0440\u0430\u0432 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C\u0432\u0438\u0434 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C\u0441\u0447\u0435\u0442 \u043D\u0430\u0439\u0442\u0438\u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0431\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430 \u043D\u0430\u0447\u0433\u043E\u0434\u0430 \u043D\u0430\u0447\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043D\u0430\u0447\u043C\u0435\u0441\u044F\u0446\u0430 \u043D\u0430\u0447\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u043E\u043C\u0435\u0440\u0434\u043D\u044F\u0433\u043E\u0434\u0430 \u043D\u043E\u043C\u0435\u0440\u0434\u043D\u044F\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u043E\u043C\u0435\u0440\u043D\u0435\u0434\u0435\u043B\u0438\u0433\u043E\u0434\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0430\u0441\u0447\u0435\u0442\u043E\u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u043F\u043B\u0430\u043D\u0441\u0447\u0435\u0442\u043E\u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439\u044F\u0437\u044B\u043A \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u043E\u043A\u043D\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434\u0441\u0442\u0440 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u0430\u0442\u0443\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0443\u0441\u0442\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0442\u0430 \u043F\u0440\u0435\u0444\u0438\u043A\u0441\u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u043E\u043F\u0438\u0441\u044C \u043F\u0443\u0441\u0442\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u043C \u0440\u0430\u0437\u043E\u0431\u0440\u0430\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043D\u0430 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043F\u043E \u0441\u0438\u043C\u0432 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442 \u0441\u0442\u0430\u0442\u0443\u0441\u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0441\u0442\u0440\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u0441\u0442\u0440\u043E\u043A \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u043F\u043E\u0437\u0438\u0446\u0438\u044E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0441\u0447\u0435\u0442\u043F\u043E\u043A\u043E\u0434\u0443 \u0442\u0435\u043A\u0443\u0449\u0435\u0435\u0432\u0440\u0435\u043C\u044F \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0441\u0442\u0440 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0442\u0430\u043D\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0442\u0430\u043F\u043E \u0444\u0438\u043A\u0441\u0448\u0430\u0431\u043B\u043E\u043D \u0448\u0430\u0431\u043B\u043E\u043D acos asin atan base64\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 base64\u0441\u0442\u0440\u043E\u043A\u0430 cos exp log log10 pow sin sqrt tan xml\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 xml\u0441\u0442\u0440\u043E\u043A\u0430 xml\u0442\u0438\u043F xml\u0442\u0438\u043F\u0437\u043D\u0447 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0435\u043E\u043A\u043D\u043E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0443\u043B\u0435\u0432\u043E \u0432\u0432\u0435\u0441\u0442\u0438\u0434\u0430\u0442\u0443 \u0432\u0432\u0435\u0441\u0442\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0432\u0435\u0441\u0442\u0438\u0441\u0442\u0440\u043E\u043A\u0443 \u0432\u0432\u0435\u0441\u0442\u0438\u0447\u0438\u0441\u043B\u043E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C\u0447\u0442\u0435\u043D\u0438\u044Fxml \u0432\u043E\u043F\u0440\u043E\u0441 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u0433 \u0432\u044B\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u043F\u0440\u0430\u0432\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0432\u044B\u0447\u0438\u0441\u043B\u0438\u0442\u044C \u0433\u043E\u0434 \u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B\u0432\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0434\u0430\u0442\u0430 \u0434\u0435\u043D\u044C \u0434\u0435\u043D\u044C\u0433\u043E\u0434\u0430 \u0434\u0435\u043D\u044C\u043D\u0435\u0434\u0435\u043B\u0438 \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C\u043C\u0435\u0441\u044F\u0446 \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0434\u043B\u044F\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u0437\u0430\u043A\u0440\u044B\u0442\u044C\u0441\u043F\u0440\u0430\u0432\u043A\u0443 \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044Cjson \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044Cxml \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u044C\u0434\u0430\u0442\u0443json \u0437\u0430\u043F\u0438\u0441\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0441\u0432\u043E\u0439\u0441\u0442\u0432 \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C\u0441\u0438\u0441\u0442\u0435\u043C\u0443 \u0437\u0430\u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0441\u0442\u0440\u043E\u043A\u0443\u0432\u043D\u0443\u0442\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0432\u0444\u0430\u0439\u043B \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0441\u0442\u0440\u043E\u043A\u0438\u0432\u043D\u0443\u0442\u0440 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0437\u0444\u0430\u0439\u043B\u0430 \u0438\u0437xml\u0442\u0438\u043F\u0430 \u0438\u043C\u043F\u043E\u0440\u0442\u043C\u043E\u0434\u0435\u043B\u0438xdto \u0438\u043C\u044F\u043A\u043E\u043C\u043F\u044C\u044E\u0442\u0435\u0440\u0430 \u0438\u043C\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043D\u0438\u0446\u0438\u0430\u043B\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435\u0434\u0430\u043D\u043D\u044B\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u043E\u0431\u043E\u0448\u0438\u0431\u043A\u0435 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0438\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0433\u043E\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445\u0444\u0430\u0439\u043B\u043E\u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u043A\u043E\u0434\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043A\u043E\u0434\u0441\u0438\u043C\u0432\u043E\u043B\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043A\u043E\u043D\u0435\u0446\u0433\u043E\u0434\u0430 \u043A\u043E\u043D\u0435\u0446\u0434\u043D\u044F \u043A\u043E\u043D\u0435\u0446\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043A\u043E\u043D\u0435\u0446\u043C\u0435\u0441\u044F\u0446\u0430 \u043A\u043E\u043D\u0435\u0446\u043C\u0438\u043D\u0443\u0442\u044B \u043A\u043E\u043D\u0435\u0446\u043D\u0435\u0434\u0435\u043B\u0438 \u043A\u043E\u043D\u0435\u0446\u0447\u0430\u0441\u0430 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430\u0434\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0438 \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0444\u043E\u0440\u043C\u044B \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0444\u0430\u0439\u043B \u043A\u0440\u0430\u0442\u043A\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043B\u0435\u0432 \u043C\u0430\u043A\u0441 \u043C\u0435\u0441\u0442\u043D\u043E\u0435\u0432\u0440\u0435\u043C\u044F \u043C\u0435\u0441\u044F\u0446 \u043C\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430 \u043C\u043E\u043D\u043E\u043F\u043E\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u043D\u0430\u0439\u0442\u0438 \u043D\u0430\u0439\u0442\u0438\u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u044Bxml \u043D\u0430\u0439\u0442\u0438\u043E\u043A\u043D\u043E\u043F\u043E\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0441\u0441\u044B\u043B\u043A\u0435 \u043D\u0430\u0439\u0442\u0438\u043F\u043E\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435\u043D\u0430\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043D\u0430\u0439\u0442\u0438\u043F\u043E\u0441\u0441\u044B\u043B\u043A\u0430\u043C \u043D\u0430\u0439\u0442\u0438\u0444\u0430\u0439\u043B\u044B \u043D\u0430\u0447\u0430\u043B\u043E\u0433\u043E\u0434\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u0434\u043D\u044F \u043D\u0430\u0447\u0430\u043B\u043E\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u043C\u0435\u0441\u044F\u0446\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u043E\u043D\u0435\u0434\u0435\u043B\u0438 \u043D\u0430\u0447\u0430\u043B\u043E\u0447\u0430\u0441\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0437\u0430\u043F\u0440\u043E\u0441\u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u0437\u0430\u043F\u0443\u0441\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u0438\u0441\u043A\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0445\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0447\u0435\u0433\u043E\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u0437\u0444\u0430\u0439\u043B\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0430 \u043D\u0430\u0447\u0430\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435\u0444\u0430\u0439\u043B\u043E\u0432 \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043D\u0430\u0447\u0430\u0442\u044C\u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0443\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043D\u0435\u0434\u0435\u043B\u044F\u0433\u043E\u0434\u0430 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u044C\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u043D\u043E\u043C\u0435\u0440\u0441\u0435\u0430\u043D\u0441\u0430\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043D\u043E\u043C\u0435\u0440\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043D\u0440\u0435\u0433 \u043D\u0441\u0442\u0440 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u044E\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u044B\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043F\u0440\u0435\u0440\u044B\u0432\u0430\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043E\u0431\u044A\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043E\u043A\u0440 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043E\u043F\u043E\u0432\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0441\u0442\u0438\u0442\u044C\u043E\u0431\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0437\u0430\u043F\u0440\u043E\u0441\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0438\u043D\u0434\u0435\u043A\u0441\u0441\u043F\u0440\u0430\u0432\u043A\u0438 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435\u0441\u043F\u0440\u0430\u0432\u043A\u0438 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0441\u043F\u0440\u0430\u0432\u043A\u0443 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0444\u043E\u0440\u043C\u0443 \u043E\u0442\u043A\u0440\u044B\u0442\u044C\u0444\u043E\u0440\u043C\u0443\u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u044C\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u0435\u0440\u0435\u0439\u0442\u0438\u043F\u043E\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u0437\u0430\u043F\u0440\u043E\u0441\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u043F\u043E\u0434\u0440\u043E\u0431\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043E\u0448\u0438\u0431\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0434\u0430\u0442\u044B \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0441\u0442\u0440\u043E\u043A\u0438 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u0432\u043E\u0434\u0447\u0438\u0441\u043B\u0430 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0432\u043E\u043F\u0440\u043E\u0441 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E\u043E\u0431\u043E\u0448\u0438\u0431\u043A\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043D\u0430\u043A\u0430\u0440\u0442\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C\u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u043D\u043E\u0435\u0438\u043C\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044Ccom\u043E\u0431\u044A\u0435\u043A\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044Cxml\u0442\u0438\u043F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0430\u0434\u0440\u0435\u0441\u043F\u043E\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0443\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043F\u044F\u0449\u0435\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0441\u044B\u043F\u0430\u043D\u0438\u044F\u043F\u0430\u0441\u0441\u0438\u0432\u043D\u043E\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0432\u044B\u0431\u043E\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u043A\u043E\u0434\u044B\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0447\u0430\u0441\u043E\u0432\u044B\u0435\u043F\u043E\u044F\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0437\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043C\u044F\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0444\u0430\u0439\u043B\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043C\u044F\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E\u044D\u043A\u0440\u0430\u043D\u043E\u0432\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043A\u0440\u0430\u0442\u043A\u0438\u0439\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u043A\u0435\u0442\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0430\u0441\u043A\u0443\u0432\u0441\u0435\u0444\u0430\u0439\u043B\u044B\u0441\u0435\u0440\u0432\u0435\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0435\u0441\u0442\u043E\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0430\u0434\u0440\u0435\u0441\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E\u0434\u043B\u0438\u043D\u0443\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E\u0441\u0441\u044B\u043B\u043A\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u0443\u044E\u0441\u0441\u044B\u043B\u043A\u0443\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u0449\u0438\u0439\u043C\u0430\u043A\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0431\u0449\u0443\u044E\u0444\u043E\u0440\u043C\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u043A\u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u0443\u044E\u043E\u0442\u043C\u0435\u0442\u043A\u0443\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E\u0440\u0435\u0436\u0438\u043C\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445\u043E\u043F\u0446\u0438\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u043E\u043B\u043D\u043E\u0435\u0438\u043C\u044F\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445\u0441\u0441\u044B\u043B\u043E\u043A \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438\u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u0435\u043B\u044C\u043F\u0443\u0442\u0438\u0441\u0435\u0440\u0432\u0435\u0440\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0435\u0430\u043D\u0441\u044B\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430odata \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0443\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0441\u0435\u0430\u043D\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u043E\u0440\u043C\u0443 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E\u043E\u043F\u0446\u0438\u044E \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0443\u044E\u043E\u043F\u0446\u0438\u044E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438\u043E\u0441 \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0432\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0435\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435 \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u043F\u0440\u0430\u0432 \u043F\u0440\u0430\u0432\u043E\u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043A\u043E\u0434\u0430\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0430\u0432\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0447\u0430\u0441\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u044F\u0441\u0430 \u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u043A\u0440\u0430\u0442\u0438\u0442\u044C\u0440\u0430\u0431\u043E\u0442\u0443\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C\u0432\u044B\u0437\u043E\u0432 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044Cjson \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044Cxml \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u044C\u0434\u0430\u0442\u0443json \u043F\u0443\u0441\u0442\u0430\u044F\u0441\u0442\u0440\u043E\u043A\u0430 \u0440\u0430\u0431\u043E\u0447\u0438\u0439\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0434\u043B\u044F\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C\u0444\u0430\u0439\u043B \u0440\u0430\u0437\u043E\u0440\u0432\u0430\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0441\u0432\u043D\u0435\u0448\u043D\u0438\u043C\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u043C\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u0440\u043E\u043B\u044C\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0430 \u0441\u0438\u0433\u043D\u0430\u043B \u0441\u0438\u043C\u0432\u043E\u043B \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u043B\u0435\u0442\u043D\u0435\u0433\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0441\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C\u0431\u0443\u0444\u0435\u0440\u044B\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u043A\u0430\u0442\u0430\u043B\u043E\u0433 \u0441\u043E\u0437\u0434\u0430\u0442\u044C\u0444\u0430\u0431\u0440\u0438\u043A\u0443xdto \u0441\u043E\u043A\u0440\u043B \u0441\u043E\u043A\u0440\u043B\u043F \u0441\u043E\u043A\u0440\u043F \u0441\u043E\u043E\u0431\u0449\u0438\u0442\u044C \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0440\u0435\u0434 \u0441\u0442\u0440\u0434\u043B\u0438\u043D\u0430 \u0441\u0442\u0440\u0437\u0430\u043A\u0430\u043D\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F\u043D\u0430 \u0441\u0442\u0440\u0437\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u043D\u0430\u0439\u0442\u0438 \u0441\u0442\u0440\u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F\u0441 \u0441\u0442\u0440\u043E\u043A\u0430 \u0441\u0442\u0440\u043E\u043A\u0430\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0441\u0442\u0440\u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0441\u0442\u0440\u043E\u043A\u0443 \u0441\u0442\u0440\u0440\u0430\u0437\u0434\u0435\u043B\u0438\u0442\u044C \u0441\u0442\u0440\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u0441\u0440\u0430\u0432\u043D\u0438\u0442\u044C \u0441\u0442\u0440\u0447\u0438\u0441\u043B\u043E\u0432\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u0439 \u0441\u0442\u0440\u0447\u0438\u0441\u043B\u043E\u0441\u0442\u0440\u043E\u043A \u0441\u0442\u0440\u0448\u0430\u0431\u043B\u043E\u043D \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0434\u0430\u0442\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0434\u0430\u0442\u0430\u0441\u0435\u0430\u043D\u0441\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u0430\u044F\u0434\u0430\u0442\u0430 \u0442\u0435\u043A\u0443\u0449\u0430\u044F\u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u0430\u044F\u0434\u0430\u0442\u0430\u0432\u043C\u0438\u043B\u043B\u0438\u0441\u0435\u043A\u0443\u043D\u0434\u0430\u0445 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u0448\u0440\u0438\u0444\u0442\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u043A\u043E\u0434\u043B\u043E\u043A\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u044F\u0437\u044B\u043A \u0442\u0435\u043A\u0443\u0449\u0438\u0439\u044F\u0437\u044B\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0442\u0438\u043F \u0442\u0438\u043F\u0437\u043D\u0447 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F\u0430\u043A\u0442\u0438\u0432\u043D\u0430 \u0442\u0440\u0435\u0433 \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0434\u0430\u043D\u043D\u044B\u0435\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0438\u0437\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u044C\u0444\u0430\u0439\u043B\u044B \u0443\u043D\u0438\u0432\u0435\u0440\u0441\u0430\u043B\u044C\u043D\u043E\u0435\u0432\u0440\u0435\u043C\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0443\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u043D\u0435\u0448\u043D\u044E\u044E\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0443 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F\u0441\u043F\u044F\u0449\u0435\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u0437\u0430\u0441\u044B\u043F\u0430\u043D\u0438\u044F\u043F\u0430\u0441\u0441\u0438\u0432\u043D\u043E\u0433\u043E\u0441\u0435\u0430\u043D\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0432\u0440\u0435\u043C\u044F\u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043A\u0440\u0430\u0442\u043A\u0438\u0439\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043E\u043A\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E\u0434\u043B\u0438\u043D\u0443\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043C\u043E\u043D\u043E\u043F\u043E\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E\u0440\u0435\u0436\u0438\u043C\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0444\u0443\u043D\u043A\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445\u043E\u043F\u0446\u0438\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443\u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438\u043F\u0430\u0440\u043E\u043B\u0435\u0439\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0435\u0439 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0442\u044B\u0441\u0444\u0430\u0439\u043B\u0430\u043C\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0441\u0432\u043D\u0435\u0448\u043D\u0438\u043C\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u043C\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0438\u0444\u043E\u0440\u043C\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430odata \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C\u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0441\u0435\u0430\u043D\u0441\u0430 \u0444\u043E\u0440\u043C\u0430\u0442 \u0446\u0435\u043B \u0447\u0430\u0441 \u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441 \u0447\u0430\u0441\u043E\u0432\u043E\u0439\u043F\u043E\u044F\u0441\u0441\u0435\u0430\u043D\u0441\u0430 \u0447\u0438\u0441\u043B\u043E \u0447\u0438\u0441\u043B\u043E\u043F\u0440\u043E\u043F\u0438\u0441\u044C\u044E \u044D\u0442\u043E\u0430\u0434\u0440\u0435\u0441\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430 ws\u0441\u0441\u044B\u043B\u043A\u0438 \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043C\u0430\u043A\u0435\u0442\u043E\u0432\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u0441\u0442\u0438\u043B\u0435\u0439 \u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u044B \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0432\u043D\u0435\u0448\u043D\u0438\u0435\u043E\u0442\u0447\u0435\u0442\u044B \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435\u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0433\u043B\u0430\u0432\u043D\u044B\u0439\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u0433\u043B\u0430\u0432\u043D\u044B\u0439\u0441\u0442\u0438\u043B\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u0436\u0443\u0440\u043D\u0430\u043B\u044B\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0437\u0430\u0434\u0430\u0447\u0438 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u043E\u0431\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0431\u043E\u0447\u0435\u0439\u0434\u0430\u0442\u044B \u0438\u0441\u0442\u043E\u0440\u0438\u044F\u0440\u0430\u0431\u043E\u0442\u044B\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u043A\u043E\u043D\u0441\u0442\u0430\u043D\u0442\u044B \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u0438\u043E\u0442\u0431\u043E\u0440\u0430 \u043C\u0435\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u043A\u043B\u0430\u043C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u043E\u0442\u0447\u0435\u0442\u044B \u043F\u0430\u043D\u0435\u043B\u044C\u0437\u0430\u0434\u0430\u0447\u043E\u0441 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0437\u0430\u043F\u0443\u0441\u043A\u0430 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0441\u0435\u0430\u043D\u0441\u0430 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u043D\u044B\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043F\u043B\u0430\u043D\u044B\u0432\u0438\u0434\u043E\u0432\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u043F\u043B\u0430\u043D\u044B\u043E\u0431\u043C\u0435\u043D\u0430 \u043F\u043B\u0430\u043D\u044B\u0441\u0447\u0435\u0442\u043E\u0432 \u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u043F\u043E\u0438\u0441\u043A \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0438\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0439\u0431\u0430\u0437\u044B \u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445\u043F\u043E\u043A\u0443\u043F\u043E\u043A \u0440\u0430\u0431\u043E\u0447\u0430\u044F\u0434\u0430\u0442\u0430 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u044B\u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u044B\u0435\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440xdto \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u0433\u0435\u043E\u043F\u043E\u0437\u0438\u0446\u0438\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043C\u0443\u043B\u044C\u0442\u0438\u043C\u0435\u0434\u0438\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0440\u0435\u043A\u043B\u0430\u043C\u044B \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u043F\u043E\u0447\u0442\u044B \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430\u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0438\u0438 \u0444\u0430\u0431\u0440\u0438\u043A\u0430xdto \u0444\u0430\u0439\u043B\u043E\u0432\u044B\u0435\u043F\u043E\u0442\u043E\u043A\u0438 \u0444\u043E\u043D\u043E\u0432\u044B\u0435\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432\u043E\u0442\u0447\u0435\u0442\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043E\u0431\u0449\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u0434\u0438\u043D\u0430\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0445\u0441\u043F\u0438\u0441\u043A\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043E\u0442\u0447\u0435\u0442\u043E\u0432 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0441\u0438\u0441\u0442\u0435\u043C\u043D\u044B\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A ",
                class: "web\u0446\u0432\u0435\u0442\u0430 windows\u0446\u0432\u0435\u0442\u0430 windows\u0448\u0440\u0438\u0444\u0442\u044B \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u0440\u0430\u043C\u043A\u0438\u0441\u0442\u0438\u043B\u044F \u0441\u0438\u043C\u0432\u043E\u043B\u044B \u0446\u0432\u0435\u0442\u0430\u0441\u0442\u0438\u043B\u044F \u0448\u0440\u0438\u0444\u0442\u044B\u0441\u0442\u0438\u043B\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C\u044B\u0432\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u044F\u0432\u0444\u043E\u0440\u043C\u0435 \u0430\u0432\u0442\u043E\u0440\u0430\u0437\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435\u0441\u0435\u0440\u0438\u0439 \u0430\u043D\u0438\u043C\u0430\u0446\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0438\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u043E\u0432 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0432\u044B\u0441\u043E\u0442\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u0430\u044F\u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0430\u0444\u043E\u0440\u043C\u044B \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u0432\u0438\u0434\u0433\u0440\u0443\u043F\u043F\u044B\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0434\u0435\u043A\u043E\u0440\u0430\u0446\u0438\u0438\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u0438\u0434\u043A\u043D\u043E\u043F\u043A\u0438\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0430\u0442\u0435\u043B\u044F \u0432\u0438\u0434\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u0432\u0438\u0434\u043F\u043E\u043B\u044F\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0444\u043B\u0430\u0436\u043A\u0430 \u0432\u043B\u0438\u044F\u043D\u0438\u0435\u0440\u0430\u0437\u043C\u0435\u0440\u0430\u043D\u0430\u043F\u0443\u0437\u044B\u0440\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0435\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0430\u043A\u043E\u043B\u043E\u043D\u043E\u043A \u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0430\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0444\u043E\u0440\u043C\u044B \u0433\u0440\u0443\u043F\u043F\u044B\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439\u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F\u043F\u0435\u0440\u0435\u0442\u0430\u0441\u043A\u0438\u0432\u0430\u043D\u0438\u044F \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u043C\u0435\u0436\u0434\u0443\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043C\u0438\u0444\u043E\u0440\u043C\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0432\u044B\u0432\u043E\u0434\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u043B\u043E\u0441\u044B\u043F\u0440\u043E\u043A\u0440\u0443\u0442\u043A\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u043E\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u043E\u0447\u043A\u0438\u0431\u0438\u0440\u0436\u0435\u0432\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0438\u0441\u0442\u043E\u0440\u0438\u044F\u0432\u044B\u0431\u043E\u0440\u0430\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043E\u0441\u0438\u0442\u043E\u0447\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0440\u0430\u0437\u043C\u0435\u0440\u0430\u043F\u0443\u0437\u044B\u0440\u044C\u043A\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u044B\u043A\u043E\u043C\u0430\u043D\u0434 \u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C\u0441\u0435\u0440\u0438\u0439 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0435\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0434\u0435\u0440\u0435\u0432\u0430 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0435\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0441\u043F\u0438\u0441\u043A\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u043C\u0435\u0442\u043E\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u043C\u0435\u0442\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u043B\u0435\u0433\u0435\u043D\u0434\u0435\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u043A\u043D\u043E\u043F\u043E\u043A \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0438\u0437\u043C\u0435\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043D\u043E\u043F\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043D\u043E\u043F\u043A\u0438\u0432\u044B\u0431\u043E\u0440\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0431\u0441\u0443\u0436\u0434\u0435\u043D\u0438\u0439\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043F\u0443\u0437\u044B\u0440\u044C\u043A\u043E\u0432\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0430\u043D\u0435\u043B\u0438\u043F\u043E\u0438\u0441\u043A\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u0443\u043F\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u044F\u043F\u0440\u0438\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0440\u0430\u0437\u043C\u0435\u0442\u043A\u0438\u043F\u043E\u043B\u043E\u0441\u044B\u0440\u0435\u0433\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0444\u043E\u0440\u043C\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0444\u0438\u0433\u0443\u0440\u044B\u043A\u043D\u043E\u043F\u043A\u0438 \u043F\u0430\u043B\u0438\u0442\u0440\u0430\u0446\u0432\u0435\u0442\u043E\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435\u043E\u0431\u044B\u0447\u043D\u043E\u0439\u0433\u0440\u0443\u043F\u043F\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0438\u0441\u043A\u0432\u0442\u0430\u0431\u043B\u0438\u0446\u0435\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438\u043A\u043D\u043E\u043F\u043A\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439\u043F\u0430\u043D\u0435\u043B\u0438\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0439\u043F\u0430\u043D\u0435\u043B\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0444\u043E\u0440\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043E\u043F\u043E\u0440\u043D\u043E\u0439\u0442\u043E\u0447\u043A\u0438\u043E\u0442\u0440\u0438\u0441\u043E\u0432\u043A\u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439\u0448\u043A\u0430\u043B\u044B\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0438\u0437\u043C\u0435\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u0442\u0440\u043E\u043A\u0438\u043F\u043E\u0438\u0441\u043A\u0430 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u043B\u0438\u043D\u0438\u0438 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u043E\u0438\u0441\u043A\u043E\u043C \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u043A\u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u043E\u0439\u0433\u0438\u0441\u0442\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u0441\u0435\u0440\u0438\u0439\u0432\u043B\u0435\u0433\u0435\u043D\u0434\u0435\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0430\u0437\u043C\u0435\u0440\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0430\u0441\u0442\u044F\u0433\u0438\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u0432\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0432\u0432\u043E\u0434\u0430\u0441\u0442\u0440\u043E\u043A\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0431\u043E\u0440\u0430\u043D\u0435\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0434\u0430\u0442\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0441\u0442\u0440\u043E\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0440\u0435\u0436\u0438\u043C\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0437\u043C\u0435\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0441\u0432\u044F\u0437\u0430\u043D\u043D\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u043F\u0435\u0447\u0430\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0440\u0435\u0436\u0438\u043C\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u043E\u043A\u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u043E\u043A\u043D\u0430\u0444\u043E\u0440\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0441\u0435\u0440\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u0440\u0438\u0441\u043E\u0432\u043A\u0438\u0441\u0435\u0442\u043A\u0438\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u0443\u043F\u0440\u043E\u0437\u0440\u0430\u0447\u043D\u043E\u0441\u0442\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0431\u0435\u043B\u043E\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0440\u0435\u0436\u0438\u043C\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043A\u043E\u043B\u043E\u043D\u043A\u0438 \u0440\u0435\u0436\u0438\u043C\u0441\u0433\u043B\u0430\u0436\u0438\u0432\u0430\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0440\u0435\u0436\u0438\u043C\u0441\u0433\u043B\u0430\u0436\u0438\u0432\u0430\u043D\u0438\u044F\u0438\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0441\u043F\u0438\u0441\u043A\u0430\u0437\u0430\u0434\u0430\u0447 \u0441\u043A\u0432\u043E\u0437\u043D\u043E\u0435\u0432\u044B\u0440\u0430\u0432\u043D\u0438\u0432\u0430\u043D\u0438\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u0444\u043E\u0440\u043C\u044B\u0432\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0448\u043A\u0430\u043B\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0441\u043F\u043E\u0441\u043E\u0431\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430\u044F\u0433\u0440\u0443\u043F\u043F\u0430\u043A\u043E\u043C\u0430\u043D\u0434 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0435\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441\u0442\u0438\u043B\u044C\u0441\u0442\u0440\u0435\u043B\u043A\u0438 \u0442\u0438\u043F\u0430\u043F\u043F\u0440\u043E\u043A\u0441\u0438\u043C\u0430\u0446\u0438\u0438\u043B\u0438\u043D\u0438\u0438\u0442\u0440\u0435\u043D\u0434\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0435\u0434\u0438\u043D\u0438\u0446\u044B\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0442\u0438\u043F\u0438\u043C\u043F\u043E\u0440\u0442\u0430\u0441\u0435\u0440\u0438\u0439\u0441\u043B\u043E\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u043C\u0430\u0440\u043A\u0435\u0440\u0430\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043C\u0430\u0440\u043A\u0435\u0440\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0441\u0435\u0440\u0438\u0438\u0441\u043B\u043E\u044F\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u0447\u043D\u043E\u0433\u043E\u043E\u0431\u044A\u0435\u043A\u0442\u0430\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0448\u043A\u0430\u043B\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043B\u0435\u0433\u0435\u043D\u0434\u044B\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043F\u043E\u0438\u0441\u043A\u0430\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u043F\u0440\u043E\u0435\u043A\u0446\u0438\u0438\u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0440\u0430\u043C\u043A\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u0432\u044F\u0437\u0438\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u0433\u0430\u043D\u0442\u0430 \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u043F\u043E\u0441\u0435\u0440\u0438\u044F\u043C\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0442\u043E\u0447\u0435\u043A\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439\u043B\u0438\u043D\u0438\u0438 \u0442\u0438\u043F\u0441\u0442\u043E\u0440\u043E\u043D\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0442\u0438\u043F\u0444\u043E\u0440\u043C\u044B\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0448\u043A\u0430\u043B\u044B\u0440\u0430\u0434\u0430\u0440\u043D\u043E\u0439\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0444\u0430\u043A\u0442\u043E\u0440\u043B\u0438\u043D\u0438\u0438\u0442\u0440\u0435\u043D\u0434\u0430\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B \u0444\u0438\u0433\u0443\u0440\u0430\u043A\u043D\u043E\u043F\u043A\u0438 \u0444\u0438\u0433\u0443\u0440\u044B\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0439\u0441\u0445\u0435\u043C\u044B \u0444\u0438\u043A\u0441\u0430\u0446\u0438\u044F\u0432\u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u0434\u043D\u044F\u0448\u043A\u0430\u043B\u044B\u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u0444\u043E\u0440\u043C\u0430\u0442\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0448\u0438\u0440\u0438\u043D\u0430\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0434\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0438\u0438 \u0432\u0438\u0434\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0432\u0438\u0434\u0441\u0447\u0435\u0442\u0430 \u0432\u0438\u0434\u0442\u043E\u0447\u043A\u0438\u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0430\u0433\u0440\u0435\u0433\u0430\u0442\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0435\u0436\u0438\u043C\u0430\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u0440\u0435\u0437\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0430\u0433\u0440\u0435\u0433\u0430\u0442\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u0432\u0440\u0435\u043C\u044F \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0438\u0441\u0438\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0430\u0432\u0442\u043E\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0439 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439\u043D\u043E\u043C\u0435\u0440\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043E\u0440\u0438\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u043A\u043E\u043B\u043E\u043D\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u0441\u0442\u0440\u043E\u043A\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430\u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u0447\u0442\u0435\u043D\u0438\u044F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0434\u0432\u0443\u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0435\u0439\u043F\u0435\u0447\u0430\u0442\u0438 \u0442\u0438\u043F\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043A\u0443\u0440\u0441\u043E\u0440\u043E\u0432\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u0440\u0438\u0441\u0443\u043D\u043A\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043B\u0438\u043D\u0438\u0438\u044F\u0447\u0435\u0439\u043A\u0438\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0432\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043B\u0438\u043D\u0438\u0439\u0441\u0432\u043E\u0434\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0440\u0438\u0441\u0443\u043D\u043A\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0441\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0443\u0437\u043E\u0440\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u0444\u0430\u0439\u043B\u0430\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u043E\u0447\u043D\u043E\u0441\u0442\u044C\u043F\u0435\u0447\u0430\u0442\u0438 \u0447\u0435\u0440\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u0441\u0442\u0440\u0430\u043D\u0438\u0446 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u0432\u0440\u0435\u043C\u0435\u043D\u0438\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A\u0430 \u0442\u0438\u043F\u0444\u0430\u0439\u043B\u0430\u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043E\u0431\u0445\u043E\u0434\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0437\u0430\u043F\u0438\u0441\u0438\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0432\u0438\u0434\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u043E\u0442\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0438\u0442\u043E\u0433\u043E\u0432 \u0434\u043E\u0441\u0442\u0443\u043F\u043A\u0444\u0430\u0439\u043B\u0443 \u0440\u0435\u0436\u0438\u043C\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u0432\u044B\u0431\u043E\u0440\u0430\u0444\u0430\u0439\u043B\u0430 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0444\u0430\u0439\u043B\u0430 \u0442\u0438\u043F\u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044F\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0432\u0438\u0434\u0434\u0430\u043D\u043D\u044B\u0445\u0430\u043D\u0430\u043B\u0438\u0437\u0430 \u043C\u0435\u0442\u043E\u0434\u043A\u043B\u0430\u0441\u0442\u0435\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0442\u0438\u043F\u0435\u0434\u0438\u043D\u0438\u0446\u044B\u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B\u0430\u0432\u0440\u0435\u043C\u0435\u043D\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0447\u0438\u0441\u043B\u043E\u0432\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u0430\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u0434\u0435\u0440\u0435\u0432\u043E\u0440\u0435\u0448\u0435\u043D\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043A\u043B\u0430\u0441\u0442\u0435\u0440\u0438\u0437\u0430\u0446\u0438\u044F \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0430\u044F\u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0438\u0441\u043A\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439 \u0442\u0438\u043F\u043A\u043E\u043B\u043E\u043D\u043A\u0438\u043C\u043E\u0434\u0435\u043B\u0438\u043F\u0440\u043E\u0433\u043D\u043E\u0437\u0430 \u0442\u0438\u043F\u043C\u0435\u0440\u044B\u0440\u0430\u0441\u0441\u0442\u043E\u044F\u043D\u0438\u044F\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0442\u0441\u0435\u0447\u0435\u043D\u0438\u044F\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0438 \u0442\u0438\u043F\u043F\u043E\u043B\u044F\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0438\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u0430\u0432\u0438\u043B\u0430\u0441\u0441\u043E\u0446\u0438\u0430\u0446\u0438\u0438\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u043E\u0440\u044F\u0434\u043E\u0447\u0438\u0432\u0430\u043D\u0438\u044F\u0448\u0430\u0431\u043B\u043E\u043D\u043E\u0432\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0443\u043F\u0440\u043E\u0449\u0435\u043D\u0438\u044F\u0434\u0435\u0440\u0435\u0432\u0430\u0440\u0435\u0448\u0435\u043D\u0438\u0439 ws\u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442xpathxs \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0437\u0430\u043F\u0438\u0441\u0438\u0434\u0430\u0442\u044Bjson \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0432\u0438\u0434\u0433\u0440\u0443\u043F\u043F\u044B\u043C\u043E\u0434\u0435\u043B\u0438xs \u0432\u0438\u0434\u0444\u0430\u0441\u0435\u0442\u0430xdto \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044Fdom \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u0441\u043E\u0441\u0442\u0430\u0432\u043D\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u0441\u0445\u0435\u043C\u044Bxs \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043D\u044B\u0435\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u0438\u0434\u0435\u043D\u0442\u0438\u0447\u043D\u043E\u0441\u0442\u0438xs \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0438\u043C\u0435\u043Dxs \u043C\u0435\u0442\u043E\u0434\u043D\u0430\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u044Fxs \u043C\u043E\u0434\u0435\u043B\u044C\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043Exs \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0442\u0438\u043F\u0430xml \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0435\u043F\u043E\u0434\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438xs \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0445\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432xs \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0433\u043Exs \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u043E\u0442\u0431\u043E\u0440\u0430\u0443\u0437\u043B\u043E\u0432dom \u043F\u0435\u0440\u0435\u043D\u043E\u0441\u0441\u0442\u0440\u043E\u043Ajson \u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0432\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0435dom \u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u044Bxml \u0442\u0438\u043F\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xml \u0442\u0438\u043F\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fjson \u0442\u0438\u043F\u043A\u0430\u043D\u043E\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043Exml \u0442\u0438\u043F\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044Bxs \u0442\u0438\u043F\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438xml \u0442\u0438\u043F\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430domxpath \u0442\u0438\u043F\u0443\u0437\u043B\u0430dom \u0442\u0438\u043F\u0443\u0437\u043B\u0430xml \u0444\u043E\u0440\u043C\u0430xml \u0444\u043E\u0440\u043C\u0430\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044Fxs \u0444\u043E\u0440\u043C\u0430\u0442\u0434\u0430\u0442\u044Bjson \u044D\u043A\u0440\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432json \u0432\u0438\u0434\u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0432\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0438\u0442\u043E\u0433\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u0435\u0439\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0431\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440\u0441\u043A\u043E\u0433\u043E\u043E\u0441\u0442\u0430\u0442\u043A\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0432\u044B\u0432\u043E\u0434\u0430\u0442\u0435\u043A\u0441\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0433\u0440\u0443\u043F\u043F\u044B\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432\u043E\u0442\u0431\u043E\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0430\u043F\u043E\u043B\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043E\u0441\u0442\u0430\u0442\u043A\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u0442\u0435\u043A\u0441\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u0441\u0432\u044F\u0437\u0438\u043D\u0430\u0431\u043E\u0440\u043E\u0432\u0434\u0430\u043D\u043D\u044B\u0445\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043B\u0435\u0433\u0435\u043D\u0434\u044B\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u044B\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043E\u0442\u0431\u043E\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0430\u0432\u0442\u043E\u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432\u0432\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0444\u0438\u043A\u0441\u0430\u0446\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0443\u0441\u043B\u043E\u0432\u043D\u043E\u0433\u043E\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u0430\u0436\u043D\u043E\u0441\u0442\u044C\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0442\u0435\u043A\u0441\u0442\u0430\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0432\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u043D\u0435ascii\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0442\u0435\u043A\u0441\u0442\u0430\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u043F\u0440\u043E\u0442\u043E\u043A\u043E\u043B\u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u044B \u0441\u0442\u0430\u0442\u0443\u0441\u0440\u0430\u0437\u0431\u043E\u0440\u0430\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438\u0437\u0430\u043F\u0438\u0441\u0438\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438\u0437\u0430\u043F\u0438\u0441\u0438\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0440\u0435\u0436\u0438\u043C\u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0438\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0442\u0438\u043F\u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0432\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430\u0438\u043C\u0435\u043D\u0444\u0430\u0439\u043B\u043E\u0432\u0432zip\u0444\u0430\u0439\u043B\u0435 \u043C\u0435\u0442\u043E\u0434\u0441\u0436\u0430\u0442\u0438\u044Fzip \u043C\u0435\u0442\u043E\u0434\u0448\u0438\u0444\u0440\u043E\u0432\u0430\u043D\u0438\u044Fzip \u0440\u0435\u0436\u0438\u043C\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043F\u0443\u0442\u0435\u0439\u0444\u0430\u0439\u043B\u043E\u0432zip \u0440\u0435\u0436\u0438\u043C\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u043F\u043E\u0434\u043A\u0430\u0442\u0430\u043B\u043E\u0433\u043E\u0432zip \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u043F\u0443\u0442\u0435\u0439zip \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0441\u0436\u0430\u0442\u0438\u044Fzip \u0437\u0432\u0443\u043A\u043E\u0432\u043E\u0435\u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430\u043A\u0441\u0442\u0440\u043E\u043A\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u044F\u0432\u043F\u043E\u0442\u043E\u043A\u0435 \u043F\u043E\u0440\u044F\u0434\u043E\u043A\u0431\u0430\u0439\u0442\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0435\u0436\u0438\u043C\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u043E\u0439\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0435\u0440\u0432\u0438\u0441\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0445\u043F\u043E\u043A\u0443\u043F\u043E\u043A \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0444\u043E\u043D\u043E\u0432\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0442\u0438\u043F\u043F\u043E\u0434\u043F\u0438\u0441\u0447\u0438\u043A\u0430\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044Fftp \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043E\u0440\u044F\u0434\u043A\u0430\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F\u043F\u0435\u0440\u0438\u043E\u0434\u0430\u043C\u0438\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u043E\u0439\u0442\u043E\u0447\u043A\u0438\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043E\u0431\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0439\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u0442\u0438\u043F\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F\u0441\u0445\u0435\u043C\u044B\u0437\u0430\u043F\u0440\u043E\u0441\u0430 http\u043C\u0435\u0442\u043E\u0434 \u0430\u0432\u0442\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0430\u0432\u0442\u043E\u043F\u0440\u0435\u0444\u0438\u043A\u0441\u043D\u043E\u043C\u0435\u0440\u0430\u0437\u0430\u0434\u0430\u0447\u0438 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u043E\u0433\u043E\u044F\u0437\u044B\u043A\u0430 \u0432\u0438\u0434\u0438\u0435\u0440\u0430\u0440\u0445\u0438\u0438 \u0432\u0438\u0434\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u044C\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0439\u043F\u0440\u0438\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043F\u043E\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0435\u0439 \u0438\u043D\u0434\u0435\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0431\u0430\u0437\u044B\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E\u0432\u044B\u0431\u043E\u0440\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u0434\u0447\u0438\u043D\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0430\u0437\u0434\u0435\u043B\u044F\u0435\u043C\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u043F\u0435\u0440\u0430\u0442\u0438\u0432\u043D\u043E\u0435\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0432\u0438\u0434\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0432\u0438\u0434\u0430\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A\u0438 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0437\u0430\u0434\u0430\u0447\u0438 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043B\u0430\u043D\u0430\u043E\u0431\u043C\u0435\u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435\u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u0447\u0435\u0442\u0430 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u0435\u0433\u0440\u0430\u043D\u0438\u0446\u044B\u043F\u0440\u0438\u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u043D\u043E\u043C\u0435\u0440\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u043D\u043E\u043C\u0435\u0440\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0441\u0432\u0435\u0434\u0435\u043D\u0438\u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0430\u0435\u043C\u044B\u0445\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u043F\u043E\u0438\u0441\u043A\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u043F\u0440\u0438\u043D\u0430\u0434\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u044C\u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u043E\u0431\u0449\u0435\u0433\u043E\u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u0430 \u0440\u0435\u0436\u0438\u043C\u0430\u0432\u0442\u043E\u043D\u0443\u043C\u0435\u0440\u0430\u0446\u0438\u0438\u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0438\u0441\u0438\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u044B\u0445\u0432\u044B\u0437\u043E\u0432\u043E\u0432\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B\u0438\u0432\u043D\u0435\u0448\u043D\u0438\u0445\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442 \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u0433\u043E\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0435\u0430\u043D\u0441\u043E\u0432 \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u044B\u0431\u043E\u0440\u0430\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u0438 \u0440\u0435\u0436\u0438\u043C\u0441\u043E\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u043E\u0441\u0442\u0438\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430 \u0440\u0435\u0436\u0438\u043C\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u043E\u0439\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0445\u0430\u0440\u0430\u043A\u0442\u0435\u0440\u0438\u0441\u0442\u0438\u043A \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u043F\u043B\u0430\u043D\u0430\u0441\u0447\u0435\u0442\u043E\u0432 \u0441\u0435\u0440\u0438\u0438\u043A\u043E\u0434\u043E\u0432\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u044B\u0431\u043E\u0440\u0430 \u0441\u043F\u043E\u0441\u043E\u0431\u043F\u043E\u0438\u0441\u043A\u0430\u0441\u0442\u0440\u043E\u043A\u0438\u043F\u0440\u0438\u0432\u0432\u043E\u0434\u0435\u043F\u043E\u0441\u0442\u0440\u043E\u043A\u0435 \u0441\u043F\u043E\u0441\u043E\u0431\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0442\u0438\u043F\u0434\u0430\u043D\u043D\u044B\u0445\u0442\u0430\u0431\u043B\u0438\u0446\u044B\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0438\u043F\u043A\u043E\u0434\u0430\u043F\u043B\u0430\u043D\u0430\u0432\u0438\u0434\u043E\u0432\u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0442\u0438\u043F\u043A\u043E\u0434\u0430\u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0442\u0438\u043F\u043C\u0430\u043A\u0435\u0442\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0431\u0438\u0437\u043D\u0435\u0441\u043F\u0440\u043E\u0446\u0435\u0441\u0441\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0442\u0438\u043F\u043D\u043E\u043C\u0435\u0440\u0430\u0437\u0430\u0434\u0430\u0447\u0438 \u0442\u0438\u043F\u0444\u043E\u0440\u043C\u044B \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0435\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0439 \u0432\u0430\u0436\u043D\u043E\u0441\u0442\u044C\u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B\u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0438\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430\u0444\u043E\u0440\u043C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0433\u043E\u0448\u0440\u0438\u0444\u0442\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0439\u0434\u0430\u0442\u044B\u043D\u0430\u0447\u0430\u043B\u0430 \u0432\u0438\u0434\u0433\u0440\u0430\u043D\u0438\u0446\u044B \u0432\u0438\u0434\u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0438 \u0432\u0438\u0434\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0432\u0438\u0434\u0440\u0430\u043C\u043A\u0438 \u0432\u0438\u0434\u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0446\u0432\u0435\u0442\u0430 \u0432\u0438\u0434\u0447\u0438\u0441\u043B\u043E\u0432\u043E\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0432\u0438\u0434\u0448\u0440\u0438\u0444\u0442\u0430 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u0430\u044F\u0434\u043B\u0438\u043D\u0430 \u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B\u0439\u0437\u043D\u0430\u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435byteordermark \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C\u0435\u0442\u0430\u0434\u0430\u043D\u043D\u044B\u0445\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0439\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u043A\u043B\u0430\u0432\u0438\u0448\u0430 \u043A\u043E\u0434\u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430\u0434\u0438\u0430\u043B\u043E\u0433\u0430 \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430xbase \u043A\u043E\u0434\u0438\u0440\u043E\u0432\u043A\u0430\u0442\u0435\u043A\u0441\u0442\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u043E\u0438\u0441\u043A\u0430 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0435\u0434\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u0438\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043F\u0430\u043D\u0435\u043B\u0438\u0440\u0430\u0437\u0434\u0435\u043B\u043E\u0432 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430\u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u0434\u0438\u0430\u043B\u043E\u0433\u0430\u0432\u043E\u043F\u0440\u043E\u0441 \u0440\u0435\u0436\u0438\u043C\u0437\u0430\u043F\u0443\u0441\u043A\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0444\u043E\u0440\u043C\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0440\u0435\u0436\u0438\u043C\u043F\u043E\u043B\u043D\u043E\u0442\u0435\u043A\u0441\u0442\u043E\u0432\u043E\u0433\u043E\u043F\u043E\u0438\u0441\u043A\u0430 \u0441\u043A\u043E\u0440\u043E\u0441\u0442\u044C\u043A\u043B\u0438\u0435\u043D\u0442\u0441\u043A\u043E\u0433\u043E\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u044F \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E\u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0435\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u043F\u043E\u0441\u043E\u0431\u0432\u044B\u0431\u043E\u0440\u0430\u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430windows \u0441\u043F\u043E\u0441\u043E\u0431\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0442\u0440\u043E\u043A\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u044F \u0442\u0438\u043F\u0432\u043D\u0435\u0448\u043D\u0435\u0439\u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u0442\u0438\u043F\u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B \u0442\u0438\u043F\u043F\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u044F\u043A\u043B\u0430\u0432\u0438\u0448\u0438enter \u0442\u0438\u043F\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438\u043E\u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438\u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438\u0431\u0430\u0437\u044B\u0434\u0430\u043D\u043D\u044B\u0445 \u0443\u0440\u043E\u0432\u0435\u043D\u044C\u0438\u0437\u043E\u043B\u044F\u0446\u0438\u0438\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u0445\u0435\u0448\u0444\u0443\u043D\u043A\u0446\u0438\u044F \u0447\u0430\u0441\u0442\u0438\u0434\u0430\u0442\u044B",
                type: "com\u043E\u0431\u044A\u0435\u043A\u0442 ftp\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 http\u0437\u0430\u043F\u0440\u043E\u0441 http\u0441\u0435\u0440\u0432\u0438\u0441\u043E\u0442\u0432\u0435\u0442 http\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 ws\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F ws\u043F\u0440\u043E\u043A\u0441\u0438 xbase \u0430\u043D\u0430\u043B\u0438\u0437\u0434\u0430\u043D\u043D\u044B\u0445 \u0430\u043D\u043D\u043E\u0442\u0430\u0446\u0438\u044Fxs \u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u043A\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u0431\u0443\u0444\u0435\u0440\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435xs \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0433\u0435\u043D\u0435\u0440\u0430\u0442\u043E\u0440\u0441\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445\u0447\u0438\u0441\u0435\u043B \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0430\u044F\u0441\u0445\u0435\u043C\u0430 \u0433\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0435\u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B \u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0430\u044F\u0441\u0445\u0435\u043C\u0430 \u0433\u0440\u0443\u043F\u043F\u0430\u043C\u043E\u0434\u0435\u043B\u0438xs \u0434\u0430\u043D\u043D\u044B\u0435\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0435\u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u0435\u043D\u0434\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430\u0433\u0430\u043D\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0444\u0430\u0439\u043B\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0446\u0432\u0435\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0432\u044B\u0431\u043E\u0440\u0430\u0448\u0440\u0438\u0444\u0442\u0430 \u0434\u0438\u0430\u043B\u043E\u0433\u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044F\u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0434\u0438\u0430\u043B\u043E\u0433\u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0433\u043E\u043F\u0435\u0440\u0438\u043E\u0434\u0430 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442dom \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442html \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044Fxs \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0435\u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u044Cdom \u0437\u0430\u043F\u0438\u0441\u044Cfastinfoset \u0437\u0430\u043F\u0438\u0441\u044Chtml \u0437\u0430\u043F\u0438\u0441\u044Cjson \u0437\u0430\u043F\u0438\u0441\u044Cxml \u0437\u0430\u043F\u0438\u0441\u044Czip\u0444\u0430\u0439\u043B\u0430 \u0437\u0430\u043F\u0438\u0441\u044C\u0434\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u044C\u0442\u0435\u043A\u0441\u0442\u0430 \u0437\u0430\u043F\u0438\u0441\u044C\u0443\u0437\u043B\u043E\u0432dom \u0437\u0430\u043F\u0440\u043E\u0441 \u0437\u0430\u0449\u0438\u0449\u0435\u043D\u043D\u043E\u0435\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435openssl \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043F\u043E\u043B\u0435\u0439\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0437\u0432\u043B\u0435\u0447\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430 \u0438\u043C\u043F\u043E\u0440\u0442xs \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u0430 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0435\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u043E\u0447\u0442\u043E\u0432\u044B\u0439\u043F\u0440\u043E\u0444\u0438\u043B\u044C \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u043F\u0440\u043E\u043A\u0441\u0438 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F\u0434\u043B\u044F\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044Fxs \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0442\u0435\u0440\u0430\u0442\u043E\u0440\u0443\u0437\u043B\u043E\u0432dom \u043A\u0430\u0440\u0442\u0438\u043D\u043A\u0430 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0434\u0430\u0442\u044B \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0434\u0432\u043E\u0438\u0447\u043D\u044B\u0445\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0441\u0442\u0440\u043E\u043A\u0438 \u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B\u0447\u0438\u0441\u043B\u0430 \u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u0449\u0438\u043A\u043C\u0430\u043A\u0435\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u0449\u0438\u043A\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u043C\u0430\u043A\u0435\u0442\u0430\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043A\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u043E\u0440\u0444\u043E\u0440\u043C\u0430\u0442\u043D\u043E\u0439\u0441\u0442\u0440\u043E\u043A\u0438 \u043B\u0438\u043D\u0438\u044F \u043C\u0430\u043A\u0435\u0442\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u043A\u0435\u0442\u043E\u0431\u043B\u0430\u0441\u0442\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u043A\u0435\u0442\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043C\u0430\u0441\u043A\u0430xs \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u043D\u0430\u0431\u043E\u0440\u0441\u0445\u0435\u043Cxml \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u0438json \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u043A\u0430\u0440\u0442\u0438\u043D\u043E\u043A \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0430\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u0431\u0445\u043E\u0434\u0434\u0435\u0440\u0435\u0432\u0430dom \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0430xs \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u043D\u043E\u0442\u0430\u0446\u0438\u0438xs \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435\u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430xs \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0434\u043E\u0441\u0442\u0443\u043F\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\u0441\u043E\u0431\u044B\u0442\u0438\u044F\u043E\u0442\u043A\u0430\u0437\u0432\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u0436\u0443\u0440\u043D\u0430\u043B\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438\u0440\u0430\u0441\u0448\u0438\u0444\u0440\u043E\u0432\u043A\u0438\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0435\u043C\u043E\u0433\u043E\u0444\u0430\u0439\u043B\u0430 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0442\u0438\u043F\u043E\u0432 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u0430\u0442\u0440\u0438\u0431\u0443\u0442\u043E\u0432xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0433\u0440\u0443\u043F\u043F\u044B\u043C\u043E\u0434\u0435\u043B\u0438xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u0438\u0434\u0435\u043D\u0442\u0438\u0447\u043D\u043E\u0441\u0442\u0438xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u043F\u0440\u043E\u0441\u0442\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0441\u043E\u0441\u0442\u0430\u0432\u043D\u043E\u0433\u043E\u0442\u0438\u043F\u0430xs \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435\u0442\u0438\u043F\u0430\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430dom \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044Fxpathxs \u043E\u0442\u0431\u043E\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0430\u043A\u0435\u0442\u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u043C\u044B\u0445\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0432\u044B\u0431\u043E\u0440\u0430 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0437\u0430\u043F\u0438\u0441\u0438json \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0437\u0430\u043F\u0438\u0441\u0438xml \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B\u0447\u0442\u0435\u043D\u0438\u044Fxml \u043F\u0435\u0440\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435xs \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0449\u0438\u043A \u043F\u043E\u043B\u0435\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043B\u0435\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044Cdom \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043E\u0442\u0447\u0435\u0442\u0430 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043E\u0442\u0447\u0435\u0442\u0430\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0434\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0445\u0435\u043Cxml \u043F\u043E\u0442\u043E\u043A \u043F\u043E\u0442\u043E\u043A\u0432\u043F\u0430\u043C\u044F\u0442\u0438 \u043F\u043E\u0447\u0442\u0430 \u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0435\u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435xsl \u043F\u0440\u0435\u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043A\u043A\u0430\u043D\u043E\u043D\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443xml \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0432\u044B\u0432\u043E\u0434\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u043A\u043E\u043B\u043B\u0435\u043A\u0446\u0438\u044E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u0432\u044B\u0432\u043E\u0434\u0430\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445\u0432\u0442\u0430\u0431\u043B\u0438\u0447\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0440\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0437\u044B\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0438\u043C\u0435\u043Ddom \u0440\u0430\u043C\u043A\u0430 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435\u0440\u0435\u0433\u043B\u0430\u043C\u0435\u043D\u0442\u043D\u043E\u0433\u043E\u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u043D\u043E\u0435\u0438\u043C\u044Fxml \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0447\u0442\u0435\u043D\u0438\u044F\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0432\u043E\u0434\u043D\u0430\u044F\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u043C\u0430 \u0441\u0432\u044F\u0437\u044C\u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u0432\u044B\u0431\u043E\u0440\u0430 \u0441\u0432\u044F\u0437\u044C\u043F\u043E\u0442\u0438\u043F\u0443 \u0441\u0432\u044F\u0437\u044C\u043F\u043E\u0442\u0438\u043F\u0443\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0435\u0440\u0438\u0430\u043B\u0438\u0437\u0430\u0442\u043E\u0440xdto \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u043B\u0438\u0435\u043D\u0442\u0430windows \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u043B\u0438\u0435\u043D\u0442\u0430\u0444\u0430\u0439\u043B \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043A\u0440\u0438\u043F\u0442\u043E\u0433\u0440\u0430\u0444\u0438\u0438 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B\u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u0445\u0446\u0435\u043D\u0442\u0440\u043E\u0432windows \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u044B\u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u044F\u044E\u0449\u0438\u0445\u0446\u0435\u043D\u0442\u0440\u043E\u0432\u0444\u0430\u0439\u043B \u0441\u0436\u0430\u0442\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0430\u044F\u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044E \u0441\u043E\u0447\u0435\u0442\u0430\u043D\u0438\u0435\u043A\u043B\u0430\u0432\u0438\u0448 \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u0430\u044F\u0434\u0430\u0442\u0430\u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439\u043F\u0435\u0440\u0438\u043E\u0434 \u0441\u0445\u0435\u043C\u0430xml \u0441\u0445\u0435\u043C\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u0430\u0431\u043B\u0438\u0447\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0442\u0435\u0441\u0442\u0438\u0440\u0443\u0435\u043C\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u0438\u043F\u0434\u0430\u043D\u043D\u044B\u0445xml \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439\u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0444\u0430\u0431\u0440\u0438\u043A\u0430xdto \u0444\u0430\u0439\u043B \u0444\u0430\u0439\u043B\u043E\u0432\u044B\u0439\u043F\u043E\u0442\u043E\u043A \u0444\u0430\u0441\u0435\u0442\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430\u0440\u0430\u0437\u0440\u044F\u0434\u043E\u0432\u0434\u0440\u043E\u0431\u043D\u043E\u0439\u0447\u0430\u0441\u0442\u0438xs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0438\u0441\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E\u0438\u0441\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0435\u0433\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439\u0434\u043B\u0438\u043D\u044Bxs \u0444\u0430\u0441\u0435\u0442\u043E\u0431\u0440\u0430\u0437\u0446\u0430xs \u0444\u0430\u0441\u0435\u0442\u043E\u0431\u0449\u0435\u0433\u043E\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430\u0440\u0430\u0437\u0440\u044F\u0434\u043E\u0432xs \u0444\u0430\u0441\u0435\u0442\u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044Fxs \u0444\u0430\u0441\u0435\u0442\u043F\u0440\u043E\u0431\u0435\u043B\u044C\u043D\u044B\u0445\u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432xs \u0444\u0438\u043B\u044C\u0442\u0440\u0443\u0437\u043B\u043E\u0432dom \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F\u0441\u0442\u0440\u043E\u043A\u0430 \u0444\u043E\u0440\u043C\u0430\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0444\u0440\u0430\u0433\u043C\u0435\u043D\u0442xs \u0445\u0435\u0448\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0445\u0440\u0430\u043D\u0438\u043B\u0438\u0449\u0435\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0446\u0432\u0435\u0442 \u0447\u0442\u0435\u043D\u0438\u0435fastinfoset \u0447\u0442\u0435\u043D\u0438\u0435html \u0447\u0442\u0435\u043D\u0438\u0435json \u0447\u0442\u0435\u043D\u0438\u0435xml \u0447\u0442\u0435\u043D\u0438\u0435zip\u0444\u0430\u0439\u043B\u0430 \u0447\u0442\u0435\u043D\u0438\u0435\u0434\u0430\u043D\u043D\u044B\u0445 \u0447\u0442\u0435\u043D\u0438\u0435\u0442\u0435\u043A\u0441\u0442\u0430 \u0447\u0442\u0435\u043D\u0438\u0435\u0443\u0437\u043B\u043E\u0432dom \u0448\u0440\u0438\u0444\u0442 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043A\u043E\u043C\u043F\u043E\u043D\u043E\u0432\u043A\u0438\u0434\u0430\u043D\u043D\u044B\u0445 comsafearray \u0434\u0435\u0440\u0435\u0432\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043C\u0430\u0441\u0441\u0438\u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u0441\u043F\u0438\u0441\u043E\u043A\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0442\u0430\u0431\u043B\u0438\u0446\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u0430\u044F\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435\u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0435 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u043C\u0430\u0441\u0441\u0438\u0432 ",
                literal: n
            },
            contains: [
                {
                    className: "meta",
                    begin: "#|&",
                    end: "$",
                    keywords: {
                        $pattern: t,
                        keyword: a + "\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C\u0438\u0437\u0444\u0430\u0439\u043B\u0430 \u0432\u0435\u0431\u043A\u043B\u0438\u0435\u043D\u0442 \u0432\u043C\u0435\u0441\u0442\u043E \u0432\u043D\u0435\u0448\u043D\u0435\u0435\u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442 \u043A\u043E\u043D\u0435\u0446\u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043A\u043B\u0438\u0435\u043D\u0442 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0441\u0435\u0440\u0432\u0435\u0440 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435\u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u043D\u0430\u043A\u043B\u0438\u0435\u043D\u0442\u0435\u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435\u0431\u0435\u0437\u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430 \u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435 \u043D\u0430\u0441\u0435\u0440\u0432\u0435\u0440\u0435\u0431\u0435\u0437\u043A\u043E\u043D\u0442\u0435\u043A\u0441\u0442\u0430 \u043E\u0431\u043B\u0430\u0441\u0442\u044C \u043F\u0435\u0440\u0435\u0434 \u043F\u043E\u0441\u043B\u0435 \u0441\u0435\u0440\u0432\u0435\u0440 \u0442\u043E\u043B\u0441\u0442\u044B\u0439\u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0431\u044B\u0447\u043D\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u043E\u043B\u0441\u0442\u044B\u0439\u043A\u043B\u0438\u0435\u043D\u0442\u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u043E\u0435\u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u0442\u043E\u043D\u043A\u0438\u0439\u043A\u043B\u0438\u0435\u043D\u0442 "
                    },
                    contains: [
                        s
                    ]
                },
                {
                    className: "function",
                    variants: [
                        {
                            begin: "\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430|\u0444\u0443\u043D\u043A\u0446\u0438\u044F",
                            end: "\\)",
                            keywords: "\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u0430 \u0444\u0443\u043D\u043A\u0446\u0438\u044F"
                        },
                        {
                            begin: "\u043A\u043E\u043D\u0435\u0446\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B|\u043A\u043E\u043D\u0435\u0446\u0444\u0443\u043D\u043A\u0446\u0438\u0438",
                            keywords: "\u043A\u043E\u043D\u0435\u0446\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B \u043A\u043E\u043D\u0435\u0446\u0444\u0443\u043D\u043A\u0446\u0438\u0438"
                        }
                    ],
                    contains: [
                        {
                            begin: "\\(",
                            end: "\\)",
                            endsParent: !0,
                            contains: [
                                {
                                    className: "params",
                                    begin: t,
                                    end: ",",
                                    excludeEnd: !0,
                                    endsWithParent: !0,
                                    keywords: {
                                        $pattern: t,
                                        keyword: "\u0437\u043D\u0430\u0447",
                                        literal: n
                                    },
                                    contains: [
                                        i,
                                        r,
                                        o
                                    ]
                                },
                                s
                            ]
                        },
                        e.inherit(e.TITLE_MODE, {
                            begin: t
                        })
                    ]
                },
                s,
                {
                    className: "symbol",
                    begin: "~",
                    end: ";|:",
                    excludeEnd: !0
                },
                i,
                r,
                o
            ]
        };
    }), de)), Cs.registerLanguage("abnf", (ue || (ue = 1, pe = function(e) {
        const t = e.regex, a = e.COMMENT(/;/, /$/);
        return {
            name: "Augmented Backus-Naur Form",
            illegal: /[!@#$^&',?+~`|:]/,
            keywords: [
                "ALPHA",
                "BIT",
                "CHAR",
                "CR",
                "CRLF",
                "CTL",
                "DIGIT",
                "DQUOTE",
                "HEXDIG",
                "HTAB",
                "LF",
                "LWSP",
                "OCTET",
                "SP",
                "VCHAR",
                "WSP"
            ],
            contains: [
                {
                    scope: "operator",
                    match: /=\/?/
                },
                {
                    scope: "attribute",
                    match: t.concat(/^[a-zA-Z][a-zA-Z0-9-]*/, /(?=\s*=)/)
                },
                a,
                {
                    scope: "symbol",
                    match: /%b[0-1]+(-[0-1]+|(\.[0-1]+)+)?/
                },
                {
                    scope: "symbol",
                    match: /%d[0-9]+(-[0-9]+|(\.[0-9]+)+)?/
                },
                {
                    scope: "symbol",
                    match: /%x[0-9A-F]+(-[0-9A-F]+|(\.[0-9A-F]+)+)?/
                },
                {
                    scope: "symbol",
                    match: /%[si](?=".*")/
                },
                e.QUOTE_STRING_MODE,
                e.NUMBER_MODE
            ]
        };
    }), pe)), Cs.registerLanguage("accesslog", (Ee || (Ee = 1, ge = function(e) {
        const t = e.regex, a = [
            "GET",
            "POST",
            "HEAD",
            "PUT",
            "DELETE",
            "CONNECT",
            "OPTIONS",
            "PATCH",
            "TRACE"
        ];
        return {
            name: "Apache Access Log",
            contains: [
                {
                    className: "number",
                    begin: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?\b/,
                    relevance: 5
                },
                {
                    className: "number",
                    begin: /\b\d+\b/,
                    relevance: 0
                },
                {
                    className: "string",
                    begin: t.concat(/"/, t.either(...a)),
                    end: /"/,
                    keywords: a,
                    illegal: /\n/,
                    relevance: 5,
                    contains: [
                        {
                            begin: /HTTP\/[12]\.\d'/,
                            relevance: 5
                        }
                    ]
                },
                {
                    className: "string",
                    begin: /\[\d[^\]\n]{8,}\]/,
                    illegal: /\n/,
                    relevance: 1
                },
                {
                    className: "string",
                    begin: /\[/,
                    end: /\]/,
                    illegal: /\n/,
                    relevance: 0
                },
                {
                    className: "string",
                    begin: /"Mozilla\/\d\.\d \(/,
                    end: /"/,
                    illegal: /\n/,
                    relevance: 3
                },
                {
                    className: "string",
                    begin: /"/,
                    end: /"/,
                    illegal: /\n/,
                    relevance: 0
                }
            ]
        };
    }), ge)), Cs.registerLanguage("actionscript", (be || (be = 1, Se = function(e) {
        const t = e.regex, a = /[a-zA-Z_$][a-zA-Z0-9_$]*/, n = t.concat(a, t.concat("(\\.", a, ")*")), i = {
            className: "rest_arg",
            begin: /[.]{3}/,
            end: a,
            relevance: 10
        };
        return {
            name: "ActionScript",
            aliases: [
                "as"
            ],
            keywords: {
                keyword: [
                    "as",
                    "break",
                    "case",
                    "catch",
                    "class",
                    "const",
                    "continue",
                    "default",
                    "delete",
                    "do",
                    "dynamic",
                    "each",
                    "else",
                    "extends",
                    "final",
                    "finally",
                    "for",
                    "function",
                    "get",
                    "if",
                    "implements",
                    "import",
                    "in",
                    "include",
                    "instanceof",
                    "interface",
                    "internal",
                    "is",
                    "namespace",
                    "native",
                    "new",
                    "override",
                    "package",
                    "private",
                    "protected",
                    "public",
                    "return",
                    "set",
                    "static",
                    "super",
                    "switch",
                    "this",
                    "throw",
                    "try",
                    "typeof",
                    "use",
                    "var",
                    "void",
                    "while",
                    "with"
                ],
                literal: [
                    "true",
                    "false",
                    "null",
                    "undefined"
                ]
            },
            contains: [
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.C_NUMBER_MODE,
                {
                    match: [
                        /\bpackage/,
                        /\s+/,
                        n
                    ],
                    className: {
                        1: "keyword",
                        3: "title.class"
                    }
                },
                {
                    match: [
                        /\b(?:class|interface|extends|implements)/,
                        /\s+/,
                        a
                    ],
                    className: {
                        1: "keyword",
                        3: "title.class"
                    }
                },
                {
                    className: "meta",
                    beginKeywords: "import include",
                    end: /;/,
                    keywords: {
                        keyword: "import include"
                    }
                },
                {
                    beginKeywords: "function",
                    end: /[{;]/,
                    excludeEnd: !0,
                    illegal: /\S/,
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            className: "title.function"
                        }),
                        {
                            className: "params",
                            begin: /\(/,
                            end: /\)/,
                            contains: [
                                e.APOS_STRING_MODE,
                                e.QUOTE_STRING_MODE,
                                e.C_LINE_COMMENT_MODE,
                                e.C_BLOCK_COMMENT_MODE,
                                i
                            ]
                        },
                        {
                            begin: t.concat(/:\s*/, /([*]|[a-zA-Z_$][a-zA-Z0-9_$]*)/)
                        }
                    ]
                },
                e.METHOD_GUARD
            ],
            illegal: /#/
        };
    }), Se)), Cs.registerLanguage("ada", (Ce || (Ce = 1, Te = function(e) {
        const t = "\\d(_|\\d)*", a = "[eE][-+]?" + t, n = "\\b(" + t + "#\\w+(\\.\\w+)?#(" + a + ")?|" + t + "(\\." + t + ")?(" + a + ")?)", i = "[A-Za-z](_?[A-Za-z0-9.])*", r = "[]\\{\\}%#'\"", o = e.COMMENT("--", "$"), s = {
            begin: "\\s+:\\s+",
            end: "\\s*(:=|;|\\)|=>|$)",
            illegal: r,
            contains: [
                {
                    beginKeywords: "loop for declare others",
                    endsParent: !0
                },
                {
                    className: "keyword",
                    beginKeywords: "not null constant access function procedure in out aliased exception"
                },
                {
                    className: "type",
                    begin: i,
                    endsParent: !0,
                    relevance: 0
                }
            ]
        };
        return {
            name: "Ada",
            case_insensitive: !0,
            keywords: {
                keyword: [
                    "abort",
                    "else",
                    "new",
                    "return",
                    "abs",
                    "elsif",
                    "not",
                    "reverse",
                    "abstract",
                    "end",
                    "accept",
                    "entry",
                    "select",
                    "access",
                    "exception",
                    "of",
                    "separate",
                    "aliased",
                    "exit",
                    "or",
                    "some",
                    "all",
                    "others",
                    "subtype",
                    "and",
                    "for",
                    "out",
                    "synchronized",
                    "array",
                    "function",
                    "overriding",
                    "at",
                    "tagged",
                    "generic",
                    "package",
                    "task",
                    "begin",
                    "goto",
                    "pragma",
                    "terminate",
                    "body",
                    "private",
                    "then",
                    "if",
                    "procedure",
                    "type",
                    "case",
                    "in",
                    "protected",
                    "constant",
                    "interface",
                    "is",
                    "raise",
                    "use",
                    "declare",
                    "range",
                    "delay",
                    "limited",
                    "record",
                    "when",
                    "delta",
                    "loop",
                    "rem",
                    "while",
                    "digits",
                    "renames",
                    "with",
                    "do",
                    "mod",
                    "requeue",
                    "xor"
                ],
                literal: [
                    "True",
                    "False"
                ]
            },
            contains: [
                o,
                {
                    className: "string",
                    begin: /"/,
                    end: /"/,
                    contains: [
                        {
                            begin: /""/,
                            relevance: 0
                        }
                    ]
                },
                {
                    className: "string",
                    begin: /'.'/
                },
                {
                    className: "number",
                    begin: n,
                    relevance: 0
                },
                {
                    className: "symbol",
                    begin: "'" + i
                },
                {
                    className: "title",
                    begin: "(\\bwith\\s+)?(\\bprivate\\s+)?\\bpackage\\s+(\\bbody\\s+)?",
                    end: "(is|$)",
                    keywords: "package body",
                    excludeBegin: !0,
                    excludeEnd: !0,
                    illegal: r
                },
                {
                    begin: "(\\b(with|overriding)\\s+)?\\b(function|procedure)\\s+",
                    end: "(\\bis|\\bwith|\\brenames|\\)\\s*;)",
                    keywords: "overriding function procedure with is renames return",
                    returnBegin: !0,
                    contains: [
                        o,
                        {
                            className: "title",
                            begin: "(\\bwith\\s+)?\\b(function|procedure)\\s+",
                            end: "(\\(|\\s+|$)",
                            excludeBegin: !0,
                            excludeEnd: !0,
                            illegal: r
                        },
                        s,
                        {
                            className: "type",
                            begin: "\\breturn\\s+",
                            end: "(\\s+|;|$)",
                            keywords: "return",
                            excludeBegin: !0,
                            excludeEnd: !0,
                            endsParent: !0,
                            illegal: r
                        }
                    ]
                },
                {
                    className: "type",
                    begin: "\\b(sub)?type\\s+",
                    end: "\\s+",
                    keywords: "type",
                    excludeBegin: !0,
                    illegal: r
                },
                s
            ]
        };
    }), Te)), Cs.registerLanguage("angelscript", (Re || (Re = 1, fe = function(e) {
        const t = {
            className: "built_in",
            begin: "\\b(void|bool|int8|int16|int32|int64|int|uint8|uint16|uint32|uint64|uint|string|ref|array|double|float|auto|dictionary)"
        }, a = {
            className: "symbol",
            begin: "[a-zA-Z0-9_]+@"
        }, n = {
            className: "keyword",
            begin: "<",
            end: ">",
            contains: [
                t,
                a
            ]
        };
        return t.contains = [
            n
        ], a.contains = [
            n
        ], {
            name: "AngelScript",
            aliases: [
                "asc"
            ],
            keywords: [
                "for",
                "in|0",
                "break",
                "continue",
                "while",
                "do|0",
                "return",
                "if",
                "else",
                "case",
                "switch",
                "namespace",
                "is",
                "cast",
                "or",
                "and",
                "xor",
                "not",
                "get|0",
                "in",
                "inout|10",
                "out",
                "override",
                "set|0",
                "private",
                "public",
                "const",
                "default|0",
                "final",
                "shared",
                "external",
                "mixin|10",
                "enum",
                "typedef",
                "funcdef",
                "this",
                "super",
                "import",
                "from",
                "interface",
                "abstract|0",
                "try",
                "catch",
                "protected",
                "explicit",
                "property"
            ],
            illegal: "(^using\\s+[A-Za-z0-9_\\.]+;$|\\bfunction\\s*[^\\(])",
            contains: [
                {
                    className: "string",
                    begin: "'",
                    end: "'",
                    illegal: "\\n",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ],
                    relevance: 0
                },
                {
                    className: "string",
                    begin: '"""',
                    end: '"""'
                },
                {
                    className: "string",
                    begin: '"',
                    end: '"',
                    illegal: "\\n",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ],
                    relevance: 0
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "string",
                    begin: "^\\s*\\[",
                    end: "\\]"
                },
                {
                    beginKeywords: "interface namespace",
                    end: /\{/,
                    illegal: "[;.\\-]",
                    contains: [
                        {
                            className: "symbol",
                            begin: "[a-zA-Z0-9_]+"
                        }
                    ]
                },
                {
                    beginKeywords: "class",
                    end: /\{/,
                    illegal: "[;.\\-]",
                    contains: [
                        {
                            className: "symbol",
                            begin: "[a-zA-Z0-9_]+",
                            contains: [
                                {
                                    begin: "[:,]\\s*",
                                    contains: [
                                        {
                                            className: "symbol",
                                            begin: "[a-zA-Z0-9_]+"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                t,
                a,
                {
                    className: "literal",
                    begin: "\\b(null|true|false)"
                },
                {
                    className: "number",
                    relevance: 0,
                    begin: "(-?)(\\b0[xXbBoOdD][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?f?|\\.\\d+f?)([eE][-+]?\\d+f?)?)"
                }
            ]
        };
    }), fe)), Cs.registerLanguage("apache", (Oe || (Oe = 1, Ne = function(e) {
        const t = {
            className: "number",
            begin: /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5})?/
        };
        return {
            name: "Apache config",
            aliases: [
                "apacheconf"
            ],
            case_insensitive: !0,
            contains: [
                e.HASH_COMMENT_MODE,
                {
                    className: "section",
                    begin: /<\/?/,
                    end: />/,
                    contains: [
                        t,
                        {
                            className: "number",
                            begin: /:\d{1,5}/
                        },
                        e.inherit(e.QUOTE_STRING_MODE, {
                            relevance: 0
                        })
                    ]
                },
                {
                    className: "attribute",
                    begin: /\w+/,
                    relevance: 0,
                    keywords: {
                        _: [
                            "order",
                            "deny",
                            "allow",
                            "setenv",
                            "rewriterule",
                            "rewriteengine",
                            "rewritecond",
                            "documentroot",
                            "sethandler",
                            "errordocument",
                            "loadmodule",
                            "options",
                            "header",
                            "listen",
                            "serverroot",
                            "servername"
                        ]
                    },
                    starts: {
                        end: /$/,
                        relevance: 0,
                        keywords: {
                            literal: "on off all deny allow"
                        },
                        contains: [
                            {
                                className: "meta",
                                begin: /\s\[/,
                                end: /\]$/
                            },
                            {
                                className: "variable",
                                begin: /[\$%]\{/,
                                end: /\}/,
                                contains: [
                                    "self",
                                    {
                                        className: "number",
                                        begin: /[$%]\d+/
                                    }
                                ]
                            },
                            t,
                            {
                                className: "number",
                                begin: /\b\d+/
                            },
                            e.QUOTE_STRING_MODE
                        ]
                    }
                }
            ],
            illegal: /\S/
        };
    }), Ne)), Cs.registerLanguage("applescript", (ve || (ve = 1, he = function(e) {
        const t = e.regex, a = e.inherit(e.QUOTE_STRING_MODE, {
            illegal: null
        }), n = {
            className: "params",
            begin: /\(/,
            end: /\)/,
            contains: [
                "self",
                e.C_NUMBER_MODE,
                a
            ]
        }, i = e.COMMENT(/--/, /$/), r = [
            i,
            e.COMMENT(/\(\*/, /\*\)/, {
                contains: [
                    "self",
                    i
                ]
            }),
            e.HASH_COMMENT_MODE
        ];
        return {
            name: "AppleScript",
            aliases: [
                "osascript"
            ],
            keywords: {
                keyword: "about above after against and around as at back before beginning behind below beneath beside between but by considering contain contains continue copy div does eighth else end equal equals error every exit fifth first for fourth from front get given global if ignoring in into is it its last local me middle mod my ninth not of on onto or over prop property put ref reference repeat returning script second set seventh since sixth some tell tenth that the|0 then third through thru timeout times to transaction try until where while whose with without",
                literal: "AppleScript false linefeed return pi quote result space tab true",
                built_in: "alias application boolean class constant date file integer list number real record string text activate beep count delay launch log offset read round run say summarize write character characters contents day frontmost id item length month name|0 paragraph paragraphs rest reverse running time version weekday word words year"
            },
            contains: [
                a,
                e.C_NUMBER_MODE,
                {
                    className: "built_in",
                    begin: t.concat(/\b/, t.either(/clipboard info/, /the clipboard/, /info for/, /list (disks|folder)/, /mount volume/, /path to/, /(close|open for) access/, /(get|set) eof/, /current date/, /do shell script/, /get volume settings/, /random number/, /set volume/, /system attribute/, /system info/, /time to GMT/, /(load|run|store) script/, /scripting components/, /ASCII (character|number)/, /localized string/, /choose (application|color|file|file name|folder|from list|remote application|URL)/, /display (alert|dialog)/), /\b/)
                },
                {
                    className: "built_in",
                    begin: /^\s*return\b/
                },
                {
                    className: "literal",
                    begin: /\b(text item delimiters|current application|missing value)\b/
                },
                {
                    className: "keyword",
                    begin: t.concat(/\b/, t.either(/apart from/, /aside from/, /instead of/, /out of/, /greater than/, /isn't|(doesn't|does not) (equal|come before|come after|contain)/, /(greater|less) than( or equal)?/, /(starts?|ends|begins?) with/, /contained by/, /comes (before|after)/, /a (ref|reference)/, /POSIX (file|path)/, /(date|time) string/, /quoted form/), /\b/)
                },
                {
                    beginKeywords: "on",
                    illegal: /[${=;\n]/,
                    contains: [
                        e.UNDERSCORE_TITLE_MODE,
                        n
                    ]
                },
                ...r
            ],
            illegal: /\/\/|->|=>|\[\[/
        };
    }), he)), Cs.registerLanguage("arcade", (Ae || (Ae = 1, Ie = function(e) {
        const t = "[A-Za-z_][0-9A-Za-z_]*", a = {
            keyword: [
                "if",
                "for",
                "while",
                "var",
                "new",
                "function",
                "do",
                "return",
                "void",
                "else",
                "break"
            ],
            literal: [
                "BackSlash",
                "DoubleQuote",
                "false",
                "ForwardSlash",
                "Infinity",
                "NaN",
                "NewLine",
                "null",
                "PI",
                "SingleQuote",
                "Tab",
                "TextFormatting",
                "true",
                "undefined"
            ],
            built_in: [
                "Abs",
                "Acos",
                "All",
                "Angle",
                "Any",
                "Area",
                "AreaGeodetic",
                "Array",
                "Asin",
                "Atan",
                "Atan2",
                "Attachments",
                "Average",
                "Back",
                "Bearing",
                "Boolean",
                "Buffer",
                "BufferGeodetic",
                "Ceil",
                "Centroid",
                "Clip",
                "Concatenate",
                "Console",
                "Constrain",
                "Contains",
                "ConvertDirection",
                "Cos",
                "Count",
                "Crosses",
                "Cut",
                "Date",
                "DateAdd",
                "DateDiff",
                "Day",
                "Decode",
                "DefaultValue",
                "Densify",
                "DensifyGeodetic",
                "Dictionary",
                "Difference",
                "Disjoint",
                "Distance",
                "DistanceGeodetic",
                "Distinct",
                "Domain",
                "DomainCode",
                "DomainName",
                "EnvelopeIntersects",
                "Equals",
                "Erase",
                "Exp",
                "Expects",
                "Extent",
                "Feature",
                "FeatureSet",
                "FeatureSetByAssociation",
                "FeatureSetById",
                "FeatureSetByName",
                "FeatureSetByPortalItem",
                "FeatureSetByRelationshipName",
                "Filter",
                "Find",
                "First",
                "Floor",
                "FromCharCode",
                "FromCodePoint",
                "FromJSON",
                "GdbVersion",
                "Generalize",
                "Geometry",
                "GetFeatureSet",
                "GetUser",
                "GroupBy",
                "Guid",
                "Hash",
                "HasKey",
                "Hour",
                "IIf",
                "Includes",
                "IndexOf",
                "Insert",
                "Intersection",
                "Intersects",
                "IsEmpty",
                "IsNan",
                "ISOMonth",
                "ISOWeek",
                "ISOWeekday",
                "ISOYear",
                "IsSelfIntersecting",
                "IsSimple",
                "Left|0",
                "Length",
                "Length3D",
                "LengthGeodetic",
                "Log",
                "Lower",
                "Map",
                "Max",
                "Mean",
                "Mid",
                "Millisecond",
                "Min",
                "Minute",
                "Month",
                "MultiPartToSinglePart",
                "Multipoint",
                "NextSequenceValue",
                "None",
                "Now",
                "Number",
                "Offset|0",
                "OrderBy",
                "Overlaps",
                "Point",
                "Polygon",
                "Polyline",
                "Pop",
                "Portal",
                "Pow",
                "Proper",
                "Push",
                "Random",
                "Reduce",
                "Relate",
                "Replace",
                "Resize",
                "Reverse",
                "Right|0",
                "RingIsClockwise",
                "Rotate",
                "Round",
                "Schema",
                "Second",
                "SetGeometry",
                "Simplify",
                "Sin",
                "Slice",
                "Sort",
                "Splice",
                "Split",
                "Sqrt",
                "Stdev",
                "SubtypeCode",
                "SubtypeName",
                "Subtypes",
                "Sum",
                "SymmetricDifference",
                "Tan",
                "Text",
                "Timestamp",
                "ToCharCode",
                "ToCodePoint",
                "Today",
                "ToHex",
                "ToLocal",
                "Top|0",
                "Touches",
                "ToUTC",
                "TrackAccelerationAt",
                "TrackAccelerationWindow",
                "TrackCurrentAcceleration",
                "TrackCurrentDistance",
                "TrackCurrentSpeed",
                "TrackCurrentTime",
                "TrackDistanceAt",
                "TrackDistanceWindow",
                "TrackDuration",
                "TrackFieldWindow",
                "TrackGeometryWindow",
                "TrackIndex",
                "TrackSpeedAt",
                "TrackSpeedWindow",
                "TrackStartTime",
                "TrackWindow",
                "Trim",
                "TypeOf",
                "Union",
                "Upper",
                "UrlEncode",
                "Variance",
                "Week",
                "Weekday",
                "When",
                "Within",
                "Year"
            ]
        }, n = {
            className: "number",
            variants: [
                {
                    begin: "\\b(0[bB][01]+)"
                },
                {
                    begin: "\\b(0[oO][0-7]+)"
                },
                {
                    begin: e.C_NUMBER_RE
                }
            ],
            relevance: 0
        }, i = {
            className: "subst",
            begin: "\\$\\{",
            end: "\\}",
            keywords: a,
            contains: []
        }, r = {
            className: "string",
            begin: "`",
            end: "`",
            contains: [
                e.BACKSLASH_ESCAPE,
                i
            ]
        };
        i.contains = [
            e.APOS_STRING_MODE,
            e.QUOTE_STRING_MODE,
            r,
            n,
            e.REGEXP_MODE
        ];
        const o = i.contains.concat([
            e.C_BLOCK_COMMENT_MODE,
            e.C_LINE_COMMENT_MODE
        ]);
        return {
            name: "ArcGIS Arcade",
            case_insensitive: !0,
            keywords: a,
            contains: [
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                r,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "symbol",
                    begin: "\\$[datastore|feature|layer|map|measure|sourcefeature|sourcelayer|targetfeature|targetlayer|value|view]+"
                },
                n,
                {
                    begin: /[{,]\s*/,
                    relevance: 0,
                    contains: [
                        {
                            begin: t + "\\s*:",
                            returnBegin: !0,
                            relevance: 0,
                            contains: [
                                {
                                    className: "attr",
                                    begin: t,
                                    relevance: 0
                                }
                            ]
                        }
                    ]
                },
                {
                    begin: "(" + e.RE_STARTERS_RE + "|\\b(return)\\b)\\s*",
                    keywords: "return",
                    contains: [
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE,
                        e.REGEXP_MODE,
                        {
                            className: "function",
                            begin: "(\\(.*?\\)|" + t + ")\\s*=>",
                            returnBegin: !0,
                            end: "\\s*=>",
                            contains: [
                                {
                                    className: "params",
                                    variants: [
                                        {
                                            begin: t
                                        },
                                        {
                                            begin: /\(\s*\)/
                                        },
                                        {
                                            begin: /\(/,
                                            end: /\)/,
                                            excludeBegin: !0,
                                            excludeEnd: !0,
                                            keywords: a,
                                            contains: o
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    relevance: 0
                },
                {
                    beginKeywords: "function",
                    end: /\{/,
                    excludeEnd: !0,
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            className: "title.function",
                            begin: t
                        }),
                        {
                            className: "params",
                            begin: /\(/,
                            end: /\)/,
                            excludeBegin: !0,
                            excludeEnd: !0,
                            contains: o
                        }
                    ],
                    illegal: /\[|%/
                },
                {
                    begin: /\$[(.]/
                }
            ],
            illegal: /#(?!!)/
        };
    }), Ie)), Cs.registerLanguage("arduino", (De || (De = 1, ye = function(e) {
        const t = {
            type: [
                "boolean",
                "byte",
                "word",
                "String"
            ],
            built_in: [
                "KeyboardController",
                "MouseController",
                "SoftwareSerial",
                "EthernetServer",
                "EthernetClient",
                "LiquidCrystal",
                "RobotControl",
                "GSMVoiceCall",
                "EthernetUDP",
                "EsploraTFT",
                "HttpClient",
                "RobotMotor",
                "WiFiClient",
                "GSMScanner",
                "FileSystem",
                "Scheduler",
                "GSMServer",
                "YunClient",
                "YunServer",
                "IPAddress",
                "GSMClient",
                "GSMModem",
                "Keyboard",
                "Ethernet",
                "Console",
                "GSMBand",
                "Esplora",
                "Stepper",
                "Process",
                "WiFiUDP",
                "GSM_SMS",
                "Mailbox",
                "USBHost",
                "Firmata",
                "PImage",
                "Client",
                "Server",
                "GSMPIN",
                "FileIO",
                "Bridge",
                "Serial",
                "EEPROM",
                "Stream",
                "Mouse",
                "Audio",
                "Servo",
                "File",
                "Task",
                "GPRS",
                "WiFi",
                "Wire",
                "TFT",
                "GSM",
                "SPI",
                "SD"
            ],
            _hints: [
                "setup",
                "loop",
                "runShellCommandAsynchronously",
                "analogWriteResolution",
                "retrieveCallingNumber",
                "printFirmwareVersion",
                "analogReadResolution",
                "sendDigitalPortPair",
                "noListenOnLocalhost",
                "readJoystickButton",
                "setFirmwareVersion",
                "readJoystickSwitch",
                "scrollDisplayRight",
                "getVoiceCallStatus",
                "scrollDisplayLeft",
                "writeMicroseconds",
                "delayMicroseconds",
                "beginTransmission",
                "getSignalStrength",
                "runAsynchronously",
                "getAsynchronously",
                "listenOnLocalhost",
                "getCurrentCarrier",
                "readAccelerometer",
                "messageAvailable",
                "sendDigitalPorts",
                "lineFollowConfig",
                "countryNameWrite",
                "runShellCommand",
                "readStringUntil",
                "rewindDirectory",
                "readTemperature",
                "setClockDivider",
                "readLightSensor",
                "endTransmission",
                "analogReference",
                "detachInterrupt",
                "countryNameRead",
                "attachInterrupt",
                "encryptionType",
                "readBytesUntil",
                "robotNameWrite",
                "readMicrophone",
                "robotNameRead",
                "cityNameWrite",
                "userNameWrite",
                "readJoystickY",
                "readJoystickX",
                "mouseReleased",
                "openNextFile",
                "scanNetworks",
                "noInterrupts",
                "digitalWrite",
                "beginSpeaker",
                "mousePressed",
                "isActionDone",
                "mouseDragged",
                "displayLogos",
                "noAutoscroll",
                "addParameter",
                "remoteNumber",
                "getModifiers",
                "keyboardRead",
                "userNameRead",
                "waitContinue",
                "processInput",
                "parseCommand",
                "printVersion",
                "readNetworks",
                "writeMessage",
                "blinkVersion",
                "cityNameRead",
                "readMessage",
                "setDataMode",
                "parsePacket",
                "isListening",
                "setBitOrder",
                "beginPacket",
                "isDirectory",
                "motorsWrite",
                "drawCompass",
                "digitalRead",
                "clearScreen",
                "serialEvent",
                "rightToLeft",
                "setTextSize",
                "leftToRight",
                "requestFrom",
                "keyReleased",
                "compassRead",
                "analogWrite",
                "interrupts",
                "WiFiServer",
                "disconnect",
                "playMelody",
                "parseFloat",
                "autoscroll",
                "getPINUsed",
                "setPINUsed",
                "setTimeout",
                "sendAnalog",
                "readSlider",
                "analogRead",
                "beginWrite",
                "createChar",
                "motorsStop",
                "keyPressed",
                "tempoWrite",
                "readButton",
                "subnetMask",
                "debugPrint",
                "macAddress",
                "writeGreen",
                "randomSeed",
                "attachGPRS",
                "readString",
                "sendString",
                "remotePort",
                "releaseAll",
                "mouseMoved",
                "background",
                "getXChange",
                "getYChange",
                "answerCall",
                "getResult",
                "voiceCall",
                "endPacket",
                "constrain",
                "getSocket",
                "writeJSON",
                "getButton",
                "available",
                "connected",
                "findUntil",
                "readBytes",
                "exitValue",
                "readGreen",
                "writeBlue",
                "startLoop",
                "IPAddress",
                "isPressed",
                "sendSysex",
                "pauseMode",
                "gatewayIP",
                "setCursor",
                "getOemKey",
                "tuneWrite",
                "noDisplay",
                "loadImage",
                "switchPIN",
                "onRequest",
                "onReceive",
                "changePIN",
                "playFile",
                "noBuffer",
                "parseInt",
                "overflow",
                "checkPIN",
                "knobRead",
                "beginTFT",
                "bitClear",
                "updateIR",
                "bitWrite",
                "position",
                "writeRGB",
                "highByte",
                "writeRed",
                "setSpeed",
                "readBlue",
                "noStroke",
                "remoteIP",
                "transfer",
                "shutdown",
                "hangCall",
                "beginSMS",
                "endWrite",
                "attached",
                "maintain",
                "noCursor",
                "checkReg",
                "checkPUK",
                "shiftOut",
                "isValid",
                "shiftIn",
                "pulseIn",
                "connect",
                "println",
                "localIP",
                "pinMode",
                "getIMEI",
                "display",
                "noBlink",
                "process",
                "getBand",
                "running",
                "beginSD",
                "drawBMP",
                "lowByte",
                "setBand",
                "release",
                "bitRead",
                "prepare",
                "pointTo",
                "readRed",
                "setMode",
                "noFill",
                "remove",
                "listen",
                "stroke",
                "detach",
                "attach",
                "noTone",
                "exists",
                "buffer",
                "height",
                "bitSet",
                "circle",
                "config",
                "cursor",
                "random",
                "IRread",
                "setDNS",
                "endSMS",
                "getKey",
                "micros",
                "millis",
                "begin",
                "print",
                "write",
                "ready",
                "flush",
                "width",
                "isPIN",
                "blink",
                "clear",
                "press",
                "mkdir",
                "rmdir",
                "close",
                "point",
                "yield",
                "image",
                "BSSID",
                "click",
                "delay",
                "read",
                "text",
                "move",
                "peek",
                "beep",
                "rect",
                "line",
                "open",
                "seek",
                "fill",
                "size",
                "turn",
                "stop",
                "home",
                "find",
                "step",
                "tone",
                "sqrt",
                "RSSI",
                "SSID",
                "end",
                "bit",
                "tan",
                "cos",
                "sin",
                "pow",
                "map",
                "abs",
                "max",
                "min",
                "get",
                "run",
                "put"
            ],
            literal: [
                "DIGITAL_MESSAGE",
                "FIRMATA_STRING",
                "ANALOG_MESSAGE",
                "REPORT_DIGITAL",
                "REPORT_ANALOG",
                "INPUT_PULLUP",
                "SET_PIN_MODE",
                "INTERNAL2V56",
                "SYSTEM_RESET",
                "LED_BUILTIN",
                "INTERNAL1V1",
                "SYSEX_START",
                "INTERNAL",
                "EXTERNAL",
                "DEFAULT",
                "OUTPUT",
                "INPUT",
                "HIGH",
                "LOW"
            ]
        }, a = function(e) {
            const t = e.regex, a = e.COMMENT("//", "$", {
                contains: [
                    {
                        begin: /\\\n/
                    }
                ]
            }), n = "decltype\\(auto\\)", i = "[a-zA-Z_]\\w*::", r = "(?!struct)(" + n + "|" + t.optional(i) + "[a-zA-Z_]\\w*" + t.optional("<[^<>]+>") + ")", o = {
                className: "type",
                begin: "\\b[a-z\\d_]*_t\\b"
            }, s = {
                className: "string",
                variants: [
                    {
                        begin: '(u8?|U|L)?"',
                        end: '"',
                        illegal: "\\n",
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: "(u8?|U|L)?'(\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)|.)",
                        end: "'",
                        illegal: "."
                    },
                    e.END_SAME_AS_BEGIN({
                        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                        end: /\)([^()\\ ]{0,16})"/
                    })
                ]
            }, l = {
                className: "number",
                variants: [
                    {
                        begin: "\\b(0b[01']+)"
                    },
                    {
                        begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)"
                    },
                    {
                        begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
                    }
                ],
                relevance: 0
            }, c = {
                className: "meta",
                begin: /#\s*[a-z]+\b/,
                end: /$/,
                keywords: {
                    keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
                },
                contains: [
                    {
                        begin: /\\\n/,
                        relevance: 0
                    },
                    e.inherit(s, {
                        className: "string"
                    }),
                    {
                        className: "string",
                        begin: /<.*?>/
                    },
                    a,
                    e.C_BLOCK_COMMENT_MODE
                ]
            }, _ = {
                className: "title",
                begin: t.optional(i) + e.IDENT_RE,
                relevance: 0
            }, d = t.optional(i) + e.IDENT_RE + "\\s*\\(", m = {
                type: [
                    "bool",
                    "char",
                    "char16_t",
                    "char32_t",
                    "char8_t",
                    "double",
                    "float",
                    "int",
                    "long",
                    "short",
                    "void",
                    "wchar_t",
                    "unsigned",
                    "signed",
                    "const",
                    "static"
                ],
                keyword: [
                    "alignas",
                    "alignof",
                    "and",
                    "and_eq",
                    "asm",
                    "atomic_cancel",
                    "atomic_commit",
                    "atomic_noexcept",
                    "auto",
                    "bitand",
                    "bitor",
                    "break",
                    "case",
                    "catch",
                    "class",
                    "co_await",
                    "co_return",
                    "co_yield",
                    "compl",
                    "concept",
                    "const_cast|10",
                    "consteval",
                    "constexpr",
                    "constinit",
                    "continue",
                    "decltype",
                    "default",
                    "delete",
                    "do",
                    "dynamic_cast|10",
                    "else",
                    "enum",
                    "explicit",
                    "export",
                    "extern",
                    "false",
                    "final",
                    "for",
                    "friend",
                    "goto",
                    "if",
                    "import",
                    "inline",
                    "module",
                    "mutable",
                    "namespace",
                    "new",
                    "noexcept",
                    "not",
                    "not_eq",
                    "nullptr",
                    "operator",
                    "or",
                    "or_eq",
                    "override",
                    "private",
                    "protected",
                    "public",
                    "reflexpr",
                    "register",
                    "reinterpret_cast|10",
                    "requires",
                    "return",
                    "sizeof",
                    "static_assert",
                    "static_cast|10",
                    "struct",
                    "switch",
                    "synchronized",
                    "template",
                    "this",
                    "thread_local",
                    "throw",
                    "transaction_safe",
                    "transaction_safe_dynamic",
                    "true",
                    "try",
                    "typedef",
                    "typeid",
                    "typename",
                    "union",
                    "using",
                    "virtual",
                    "volatile",
                    "while",
                    "xor",
                    "xor_eq"
                ],
                literal: [
                    "NULL",
                    "false",
                    "nullopt",
                    "nullptr",
                    "true"
                ],
                built_in: [
                    "_Pragma"
                ],
                _type_hints: [
                    "any",
                    "auto_ptr",
                    "barrier",
                    "binary_semaphore",
                    "bitset",
                    "complex",
                    "condition_variable",
                    "condition_variable_any",
                    "counting_semaphore",
                    "deque",
                    "false_type",
                    "future",
                    "imaginary",
                    "initializer_list",
                    "istringstream",
                    "jthread",
                    "latch",
                    "lock_guard",
                    "multimap",
                    "multiset",
                    "mutex",
                    "optional",
                    "ostringstream",
                    "packaged_task",
                    "pair",
                    "promise",
                    "priority_queue",
                    "queue",
                    "recursive_mutex",
                    "recursive_timed_mutex",
                    "scoped_lock",
                    "set",
                    "shared_future",
                    "shared_lock",
                    "shared_mutex",
                    "shared_timed_mutex",
                    "shared_ptr",
                    "stack",
                    "string_view",
                    "stringstream",
                    "timed_mutex",
                    "thread",
                    "true_type",
                    "tuple",
                    "unique_lock",
                    "unique_ptr",
                    "unordered_map",
                    "unordered_multimap",
                    "unordered_multiset",
                    "unordered_set",
                    "variant",
                    "vector",
                    "weak_ptr",
                    "wstring",
                    "wstring_view"
                ]
            }, p = {
                className: "function.dispatch",
                relevance: 0,
                keywords: {
                    _hint: [
                        "abort",
                        "abs",
                        "acos",
                        "apply",
                        "as_const",
                        "asin",
                        "atan",
                        "atan2",
                        "calloc",
                        "ceil",
                        "cerr",
                        "cin",
                        "clog",
                        "cos",
                        "cosh",
                        "cout",
                        "declval",
                        "endl",
                        "exchange",
                        "exit",
                        "exp",
                        "fabs",
                        "floor",
                        "fmod",
                        "forward",
                        "fprintf",
                        "fputs",
                        "free",
                        "frexp",
                        "fscanf",
                        "future",
                        "invoke",
                        "isalnum",
                        "isalpha",
                        "iscntrl",
                        "isdigit",
                        "isgraph",
                        "islower",
                        "isprint",
                        "ispunct",
                        "isspace",
                        "isupper",
                        "isxdigit",
                        "labs",
                        "launder",
                        "ldexp",
                        "log",
                        "log10",
                        "make_pair",
                        "make_shared",
                        "make_shared_for_overwrite",
                        "make_tuple",
                        "make_unique",
                        "malloc",
                        "memchr",
                        "memcmp",
                        "memcpy",
                        "memset",
                        "modf",
                        "move",
                        "pow",
                        "printf",
                        "putchar",
                        "puts",
                        "realloc",
                        "scanf",
                        "sin",
                        "sinh",
                        "snprintf",
                        "sprintf",
                        "sqrt",
                        "sscanf",
                        "std",
                        "stderr",
                        "stdin",
                        "stdout",
                        "strcat",
                        "strchr",
                        "strcmp",
                        "strcpy",
                        "strcspn",
                        "strlen",
                        "strncat",
                        "strncmp",
                        "strncpy",
                        "strpbrk",
                        "strrchr",
                        "strspn",
                        "strstr",
                        "swap",
                        "tan",
                        "tanh",
                        "terminate",
                        "to_underlying",
                        "tolower",
                        "toupper",
                        "vfprintf",
                        "visit",
                        "vprintf",
                        "vsprintf"
                    ]
                },
                begin: t.concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!switch)/, /(?!while)/, e.IDENT_RE, t.lookahead(/(<[^<>]+>|)\s*\(/))
            }, u = [
                p,
                c,
                o,
                a,
                e.C_BLOCK_COMMENT_MODE,
                l,
                s
            ], g = {
                variants: [
                    {
                        begin: /=/,
                        end: /;/
                    },
                    {
                        begin: /\(/,
                        end: /\)/
                    },
                    {
                        beginKeywords: "new throw return else",
                        end: /;/
                    }
                ],
                keywords: m,
                contains: u.concat([
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: m,
                        contains: u.concat([
                            "self"
                        ]),
                        relevance: 0
                    }
                ]),
                relevance: 0
            }, E = {
                className: "function",
                begin: "(" + r + "[\\*&\\s]+)+" + d,
                returnBegin: !0,
                end: /[{;=]/,
                excludeEnd: !0,
                keywords: m,
                illegal: /[^\w\s\*&:<>.]/,
                contains: [
                    {
                        begin: n,
                        keywords: m,
                        relevance: 0
                    },
                    {
                        begin: d,
                        returnBegin: !0,
                        contains: [
                            _
                        ],
                        relevance: 0
                    },
                    {
                        begin: /::/,
                        relevance: 0
                    },
                    {
                        begin: /:/,
                        endsWithParent: !0,
                        contains: [
                            s,
                            l
                        ]
                    },
                    {
                        relevance: 0,
                        match: /,/
                    },
                    {
                        className: "params",
                        begin: /\(/,
                        end: /\)/,
                        keywords: m,
                        relevance: 0,
                        contains: [
                            a,
                            e.C_BLOCK_COMMENT_MODE,
                            s,
                            l,
                            o,
                            {
                                begin: /\(/,
                                end: /\)/,
                                keywords: m,
                                relevance: 0,
                                contains: [
                                    "self",
                                    a,
                                    e.C_BLOCK_COMMENT_MODE,
                                    s,
                                    l,
                                    o
                                ]
                            }
                        ]
                    },
                    o,
                    a,
                    e.C_BLOCK_COMMENT_MODE,
                    c
                ]
            };
            return {
                name: "C++",
                aliases: [
                    "cc",
                    "c++",
                    "h++",
                    "hpp",
                    "hh",
                    "hxx",
                    "cxx"
                ],
                keywords: m,
                illegal: "</",
                classNameAliases: {
                    "function.dispatch": "built_in"
                },
                contains: [].concat(g, E, p, u, [
                    c,
                    {
                        begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function)\\s*<(?!<)",
                        end: ">",
                        keywords: m,
                        contains: [
                            "self",
                            o
                        ]
                    },
                    {
                        begin: e.IDENT_RE + "::",
                        keywords: m
                    },
                    {
                        match: [
                            /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
                            /\s+/,
                            /\w+/
                        ],
                        className: {
                            1: "keyword",
                            3: "title.class"
                        }
                    }
                ])
            };
        }(e), n = a.keywords;
        return n.type = [
            ...n.type,
            ...t.type
        ], n.literal = [
            ...n.literal,
            ...t.literal
        ], n.built_in = [
            ...n.built_in,
            ...t.built_in
        ], n._hints = t._hints, a.name = "Arduino", a.aliases = [
            "ino"
        ], a.supersetOf = "cpp", a;
    }), ye)), Cs.registerLanguage("armasm", (Le || (Le = 1, Me = function(e) {
        const t = {
            variants: [
                e.COMMENT("^[ \\t]*(?=#)", "$", {
                    relevance: 0,
                    excludeBegin: !0
                }),
                e.COMMENT("[;@]", "$", {
                    relevance: 0
                }),
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE
            ]
        };
        return {
            name: "ARM Assembly",
            case_insensitive: !0,
            aliases: [
                "arm"
            ],
            keywords: {
                $pattern: "\\.?" + e.IDENT_RE,
                meta: ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .arm .thumb .code16 .code32 .force_thumb .thumb_func .ltorg ALIAS ALIGN ARM AREA ASSERT ATTR CN CODE CODE16 CODE32 COMMON CP DATA DCB DCD DCDU DCDO DCFD DCFDU DCI DCQ DCQU DCW DCWU DN ELIF ELSE END ENDFUNC ENDIF ENDP ENTRY EQU EXPORT EXPORTAS EXTERN FIELD FILL FUNCTION GBLA GBLL GBLS GET GLOBAL IF IMPORT INCBIN INCLUDE INFO KEEP LCLA LCLL LCLS LTORG MACRO MAP MEND MEXIT NOFP OPT PRESERVE8 PROC QN READONLY RELOC REQUIRE REQUIRE8 RLIST FN ROUT SETA SETL SETS SN SPACE SUBT THUMB THUMBX TTL WHILE WEND ",
                built_in: "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 w0 w1 w2 w3 w4 w5 w6 w7 w8 w9 w10 w11 w12 w13 w14 w15 w16 w17 w18 w19 w20 w21 w22 w23 w24 w25 w26 w27 w28 w29 w30 x0 x1 x2 x3 x4 x5 x6 x7 x8 x9 x10 x11 x12 x13 x14 x15 x16 x17 x18 x19 x20 x21 x22 x23 x24 x25 x26 x27 x28 x29 x30 pc lr sp ip sl sb fp a1 a2 a3 a4 v1 v2 v3 v4 v5 v6 v7 v8 f0 f1 f2 f3 f4 f5 f6 f7 p0 p1 p2 p3 p4 p5 p6 p7 p8 p9 p10 p11 p12 p13 p14 p15 c0 c1 c2 c3 c4 c5 c6 c7 c8 c9 c10 c11 c12 c13 c14 c15 q0 q1 q2 q3 q4 q5 q6 q7 q8 q9 q10 q11 q12 q13 q14 q15 cpsr_c cpsr_x cpsr_s cpsr_f cpsr_cx cpsr_cxs cpsr_xs cpsr_xsf cpsr_sf cpsr_cxsf spsr_c spsr_x spsr_s spsr_f spsr_cx spsr_cxs spsr_xs spsr_xsf spsr_sf spsr_cxsf s0 s1 s2 s3 s4 s5 s6 s7 s8 s9 s10 s11 s12 s13 s14 s15 s16 s17 s18 s19 s20 s21 s22 s23 s24 s25 s26 s27 s28 s29 s30 s31 d0 d1 d2 d3 d4 d5 d6 d7 d8 d9 d10 d11 d12 d13 d14 d15 d16 d17 d18 d19 d20 d21 d22 d23 d24 d25 d26 d27 d28 d29 d30 d31 {PC} {VAR} {TRUE} {FALSE} {OPT} {CONFIG} {ENDIAN} {CODESIZE} {CPU} {FPU} {ARCHITECTURE} {PCSTOREOFFSET} {ARMASM_VERSION} {INTER} {ROPI} {RWPI} {SWST} {NOSWST} . @"
            },
            contains: [
                {
                    className: "keyword",
                    begin: "\\b(adc|(qd?|sh?|u[qh]?)?add(8|16)?|usada?8|(q|sh?|u[qh]?)?(as|sa)x|and|adrl?|sbc|rs[bc]|asr|b[lx]?|blx|bxj|cbn?z|tb[bh]|bic|bfc|bfi|[su]bfx|bkpt|cdp2?|clz|clrex|cmp|cmn|cpsi[ed]|cps|setend|dbg|dmb|dsb|eor|isb|it[te]{0,3}|lsl|lsr|ror|rrx|ldm(([id][ab])|f[ds])?|ldr((s|ex)?[bhd])?|movt?|mvn|mra|mar|mul|[us]mull|smul[bwt][bt]|smu[as]d|smmul|smmla|mla|umlaal|smlal?([wbt][bt]|d)|mls|smlsl?[ds]|smc|svc|sev|mia([bt]{2}|ph)?|mrr?c2?|mcrr2?|mrs|msr|orr|orn|pkh(tb|bt)|rbit|rev(16|sh)?|sel|[su]sat(16)?|nop|pop|push|rfe([id][ab])?|stm([id][ab])?|str(ex)?[bhd]?|(qd?)?sub|(sh?|q|u[qh]?)?sub(8|16)|[su]xt(a?h|a?b(16)?)|srs([id][ab])?|swpb?|swi|smi|tst|teq|wfe|wfi|yield)(eq|ne|cs|cc|mi|pl|vs|vc|hi|ls|ge|lt|gt|le|al|hs|lo)?[sptrx]?(?=\\s)"
                },
                t,
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    begin: "'",
                    end: "[^\\\\]'",
                    relevance: 0
                },
                {
                    className: "title",
                    begin: "\\|",
                    end: "\\|",
                    illegal: "\\n",
                    relevance: 0
                },
                {
                    className: "number",
                    variants: [
                        {
                            begin: "[#$=]?0x[0-9a-f]+"
                        },
                        {
                            begin: "[#$=]?0b[01]+"
                        },
                        {
                            begin: "[#$=]\\d+"
                        },
                        {
                            begin: "\\b\\d+"
                        }
                    ],
                    relevance: 0
                },
                {
                    className: "symbol",
                    variants: [
                        {
                            begin: "^[ \\t]*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
                        },
                        {
                            begin: "^[a-z_\\.\\$][a-z0-9_\\.\\$]+"
                        },
                        {
                            begin: "[=#]\\w+"
                        }
                    ],
                    relevance: 0
                }
            ]
        };
    }), Me)), Cs.registerLanguage("xml", (we || (we = 1, xe = function(e) {
        const t = e.regex, a = t.concat(/[\p{L}_]/u, t.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), n = {
            className: "symbol",
            begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
        }, i = {
            begin: /\s/,
            contains: [
                {
                    className: "keyword",
                    begin: /#?[a-z_][a-z1-9_-]+/,
                    illegal: /\n/
                }
            ]
        }, r = e.inherit(i, {
            begin: /\(/,
            end: /\)/
        }), o = e.inherit(e.APOS_STRING_MODE, {
            className: "string"
        }), s = e.inherit(e.QUOTE_STRING_MODE, {
            className: "string"
        }), l = {
            endsWithParent: !0,
            illegal: /</,
            relevance: 0,
            contains: [
                {
                    className: "attr",
                    begin: /[\p{L}0-9._:-]+/u,
                    relevance: 0
                },
                {
                    begin: /=\s*/,
                    relevance: 0,
                    contains: [
                        {
                            className: "string",
                            endsParent: !0,
                            variants: [
                                {
                                    begin: /"/,
                                    end: /"/,
                                    contains: [
                                        n
                                    ]
                                },
                                {
                                    begin: /'/,
                                    end: /'/,
                                    contains: [
                                        n
                                    ]
                                },
                                {
                                    begin: /[^\s"'=<>`]+/
                                }
                            ]
                        }
                    ]
                }
            ]
        };
        return {
            name: "HTML, XML",
            aliases: [
                "html",
                "xhtml",
                "rss",
                "atom",
                "xjb",
                "xsd",
                "xsl",
                "plist",
                "wsf",
                "svg"
            ],
            case_insensitive: !0,
            unicodeRegex: !0,
            contains: [
                {
                    className: "meta",
                    begin: /<![a-z]/,
                    end: />/,
                    relevance: 10,
                    contains: [
                        i,
                        s,
                        o,
                        r,
                        {
                            begin: /\[/,
                            end: /\]/,
                            contains: [
                                {
                                    className: "meta",
                                    begin: /<![a-z]/,
                                    end: />/,
                                    contains: [
                                        i,
                                        r,
                                        s,
                                        o
                                    ]
                                }
                            ]
                        }
                    ]
                },
                e.COMMENT(/<!--/, /-->/, {
                    relevance: 10
                }),
                {
                    begin: /<!\[CDATA\[/,
                    end: /\]\]>/,
                    relevance: 10
                },
                n,
                {
                    className: "meta",
                    end: /\?>/,
                    variants: [
                        {
                            begin: /<\?xml/,
                            relevance: 10,
                            contains: [
                                s
                            ]
                        },
                        {
                            begin: /<\?[a-z][a-z0-9]+/
                        }
                    ]
                },
                {
                    className: "tag",
                    begin: /<style(?=\s|>)/,
                    end: />/,
                    keywords: {
                        name: "style"
                    },
                    contains: [
                        l
                    ],
                    starts: {
                        end: /<\/style>/,
                        returnEnd: !0,
                        subLanguage: [
                            "css",
                            "xml"
                        ]
                    }
                },
                {
                    className: "tag",
                    begin: /<script(?=\s|>)/,
                    end: />/,
                    keywords: {
                        name: "script"
                    },
                    contains: [
                        l
                    ],
                    starts: {
                        end: /<\/script>/,
                        returnEnd: !0,
                        subLanguage: [
                            "javascript",
                            "handlebars",
                            "xml"
                        ]
                    }
                },
                {
                    className: "tag",
                    begin: /<>|<\/>/
                },
                {
                    className: "tag",
                    begin: t.concat(/</, t.lookahead(t.concat(a, t.either(/\/>/, />/, /\s/)))),
                    end: /\/?>/,
                    contains: [
                        {
                            className: "name",
                            begin: a,
                            relevance: 0,
                            starts: l
                        }
                    ]
                },
                {
                    className: "tag",
                    begin: t.concat(/<\//, t.lookahead(t.concat(a, />/))),
                    contains: [
                        {
                            className: "name",
                            begin: a,
                            relevance: 0
                        },
                        {
                            begin: />/,
                            relevance: 0,
                            endsParent: !0
                        }
                    ]
                }
            ]
        };
    }), xe)), Cs.registerLanguage("asciidoc", (ke || (ke = 1, Pe = function(e) {
        const t = e.regex, a = [
            {
                className: "strong",
                begin: /\*{2}([^\n]+?)\*{2}/
            },
            {
                className: "strong",
                begin: t.concat(/\*\*/, /((\*(?!\*)|\\[^\n]|[^*\n\\])+\n)+/, /(\*(?!\*)|\\[^\n]|[^*\n\\])*/, /\*\*/),
                relevance: 0
            },
            {
                className: "strong",
                begin: /\B\*(\S|\S[^\n]*?\S)\*(?!\w)/
            },
            {
                className: "strong",
                begin: /\*[^\s]([^\n]+\n)+([^\n]+)\*/
            }
        ], n = [
            {
                className: "emphasis",
                begin: /_{2}([^\n]+?)_{2}/
            },
            {
                className: "emphasis",
                begin: t.concat(/__/, /((_(?!_)|\\[^\n]|[^_\n\\])+\n)+/, /(_(?!_)|\\[^\n]|[^_\n\\])*/, /__/),
                relevance: 0
            },
            {
                className: "emphasis",
                begin: /\b_(\S|\S[^\n]*?\S)_(?!\w)/
            },
            {
                className: "emphasis",
                begin: /_[^\s]([^\n]+\n)+([^\n]+)_/
            },
            {
                className: "emphasis",
                begin: "\\B'(?!['\\s])",
                end: "(\\n{2}|')",
                contains: [
                    {
                        begin: "\\\\'\\w",
                        relevance: 0
                    }
                ],
                relevance: 0
            }
        ];
        return {
            name: "AsciiDoc",
            aliases: [
                "adoc"
            ],
            contains: [
                e.COMMENT("^/{4,}\\n", "\\n/{4,}$", {
                    relevance: 10
                }),
                e.COMMENT("^//", "$", {
                    relevance: 0
                }),
                {
                    className: "title",
                    begin: "^\\.\\w.*$"
                },
                {
                    begin: "^[=\\*]{4,}\\n",
                    end: "\\n^[=\\*]{4,}$",
                    relevance: 10
                },
                {
                    className: "section",
                    relevance: 10,
                    variants: [
                        {
                            begin: "^(={1,6})[ \t].+?([ \t]\\1)?$"
                        },
                        {
                            begin: "^[^\\[\\]\\n]+?\\n[=\\-~\\^\\+]{2,}$"
                        }
                    ]
                },
                {
                    className: "meta",
                    begin: "^:.+?:",
                    end: "\\s",
                    excludeEnd: !0,
                    relevance: 10
                },
                {
                    className: "meta",
                    begin: "^\\[.+?\\]$",
                    relevance: 0
                },
                {
                    className: "quote",
                    begin: "^_{4,}\\n",
                    end: "\\n_{4,}$",
                    relevance: 10
                },
                {
                    className: "code",
                    begin: "^[\\-\\.]{4,}\\n",
                    end: "\\n[\\-\\.]{4,}$",
                    relevance: 10
                },
                {
                    begin: "^\\+{4,}\\n",
                    end: "\\n\\+{4,}$",
                    contains: [
                        {
                            begin: "<",
                            end: ">",
                            subLanguage: "xml",
                            relevance: 0
                        }
                    ],
                    relevance: 10
                },
                {
                    className: "bullet",
                    begin: "^(\\*+|-+|\\.+|[^\\n]+?::)\\s+"
                },
                {
                    className: "symbol",
                    begin: "^(NOTE|TIP|IMPORTANT|WARNING|CAUTION):\\s+",
                    relevance: 10
                },
                {
                    begin: /\\[*_`]/
                },
                {
                    begin: /\\\\\*{2}[^\n]*?\*{2}/
                },
                {
                    begin: /\\\\_{2}[^\n]*_{2}/
                },
                {
                    begin: /\\\\`{2}[^\n]*`{2}/
                },
                {
                    begin: /[:;}][*_`](?![*_`])/
                },
                ...a,
                ...n,
                {
                    className: "string",
                    variants: [
                        {
                            begin: "``.+?''"
                        },
                        {
                            begin: "`.+?'"
                        }
                    ]
                },
                {
                    className: "code",
                    begin: /`{2}/,
                    end: /(\n{2}|`{2})/
                },
                {
                    className: "code",
                    begin: "(`.+?`|\\+.+?\\+)",
                    relevance: 0
                },
                {
                    className: "code",
                    begin: "^[ \\t]",
                    end: "$",
                    relevance: 0
                },
                {
                    begin: "^'{3,}[ \\t]*$",
                    relevance: 10
                },
                {
                    begin: "(link:)?(http|https|ftp|file|irc|image:?):\\S+?\\[[^[]*?\\]",
                    returnBegin: !0,
                    contains: [
                        {
                            begin: "(link|image:?):",
                            relevance: 0
                        },
                        {
                            className: "link",
                            begin: "\\w",
                            end: "[^\\[]+",
                            relevance: 0
                        },
                        {
                            className: "string",
                            begin: "\\[",
                            end: "\\]",
                            excludeBegin: !0,
                            excludeEnd: !0,
                            relevance: 0
                        }
                    ],
                    relevance: 10
                }
            ]
        };
    }), Pe)), Cs.registerLanguage("aspectj", (Fe || (Fe = 1, Ue = function(e) {
        const t = e.regex, a = [
            "false",
            "synchronized",
            "int",
            "abstract",
            "float",
            "private",
            "char",
            "boolean",
            "static",
            "null",
            "if",
            "const",
            "for",
            "true",
            "while",
            "long",
            "throw",
            "strictfp",
            "finally",
            "protected",
            "import",
            "native",
            "final",
            "return",
            "void",
            "enum",
            "else",
            "extends",
            "implements",
            "break",
            "transient",
            "new",
            "catch",
            "instanceof",
            "byte",
            "super",
            "volatile",
            "case",
            "assert",
            "short",
            "package",
            "default",
            "double",
            "public",
            "try",
            "this",
            "switch",
            "continue",
            "throws",
            "privileged",
            "aspectOf",
            "adviceexecution",
            "proceed",
            "cflowbelow",
            "cflow",
            "initialization",
            "preinitialization",
            "staticinitialization",
            "withincode",
            "target",
            "within",
            "execution",
            "getWithinTypeName",
            "handler",
            "thisJoinPoint",
            "thisJoinPointStaticPart",
            "thisEnclosingJoinPointStaticPart",
            "declare",
            "parents",
            "warning",
            "error",
            "soft",
            "precedence",
            "thisAspectInstance"
        ], n = [
            "get",
            "set",
            "args",
            "call"
        ];
        return {
            name: "AspectJ",
            keywords: a,
            illegal: /<\/|#/,
            contains: [
                e.COMMENT(/\/\*\*/, /\*\//, {
                    relevance: 0,
                    contains: [
                        {
                            begin: /\w+@/,
                            relevance: 0
                        },
                        {
                            className: "doctag",
                            begin: /@[A-Za-z]+/
                        }
                    ]
                }),
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                {
                    className: "class",
                    beginKeywords: "aspect",
                    end: /[{;=]/,
                    excludeEnd: !0,
                    illegal: /[:;"\[\]]/,
                    contains: [
                        {
                            beginKeywords: "extends implements pertypewithin perthis pertarget percflowbelow percflow issingleton"
                        },
                        e.UNDERSCORE_TITLE_MODE,
                        {
                            begin: /\([^\)]*/,
                            end: /[)]+/,
                            keywords: a.concat(n),
                            excludeEnd: !1
                        }
                    ]
                },
                {
                    className: "class",
                    beginKeywords: "class interface",
                    end: /[{;=]/,
                    excludeEnd: !0,
                    relevance: 0,
                    keywords: "class interface",
                    illegal: /[:"\[\]]/,
                    contains: [
                        {
                            beginKeywords: "extends implements"
                        },
                        e.UNDERSCORE_TITLE_MODE
                    ]
                },
                {
                    beginKeywords: "pointcut after before around throwing returning",
                    end: /[)]/,
                    excludeEnd: !1,
                    illegal: /["\[\]]/,
                    contains: [
                        {
                            begin: t.concat(e.UNDERSCORE_IDENT_RE, /\s*\(/),
                            returnBegin: !0,
                            contains: [
                                e.UNDERSCORE_TITLE_MODE
                            ]
                        }
                    ]
                },
                {
                    begin: /[:]/,
                    returnBegin: !0,
                    end: /[{;]/,
                    relevance: 0,
                    excludeEnd: !1,
                    keywords: a,
                    illegal: /["\[\]]/,
                    contains: [
                        {
                            begin: t.concat(e.UNDERSCORE_IDENT_RE, /\s*\(/),
                            keywords: a.concat(n),
                            relevance: 0
                        },
                        e.QUOTE_STRING_MODE
                    ]
                },
                {
                    beginKeywords: "new throw",
                    relevance: 0
                },
                {
                    className: "function",
                    begin: /\w+ +\w+(\.\w+)?\s*\([^\)]*\)\s*((throws)[\w\s,]+)?[\{;]/,
                    returnBegin: !0,
                    end: /[{;=]/,
                    keywords: a,
                    excludeEnd: !0,
                    contains: [
                        {
                            begin: t.concat(e.UNDERSCORE_IDENT_RE, /\s*\(/),
                            returnBegin: !0,
                            relevance: 0,
                            contains: [
                                e.UNDERSCORE_TITLE_MODE
                            ]
                        },
                        {
                            className: "params",
                            begin: /\(/,
                            end: /\)/,
                            relevance: 0,
                            keywords: a,
                            contains: [
                                e.APOS_STRING_MODE,
                                e.QUOTE_STRING_MODE,
                                e.C_NUMBER_MODE,
                                e.C_BLOCK_COMMENT_MODE
                            ]
                        },
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                e.C_NUMBER_MODE,
                {
                    className: "meta",
                    begin: /@[A-Za-z]+/
                }
            ]
        };
    }), Ue)), Cs.registerLanguage("autohotkey", (Ge || (Ge = 1, Be = function(e) {
        const t = {
            begin: "`[\\s\\S]"
        };
        return {
            name: "AutoHotkey",
            case_insensitive: !0,
            aliases: [
                "ahk"
            ],
            keywords: {
                keyword: "Break Continue Critical Exit ExitApp Gosub Goto New OnExit Pause return SetBatchLines SetTimer Suspend Thread Throw Until ahk_id ahk_class ahk_pid ahk_exe ahk_group",
                literal: "true false NOT AND OR",
                built_in: "ComSpec Clipboard ClipboardAll ErrorLevel"
            },
            contains: [
                t,
                e.inherit(e.QUOTE_STRING_MODE, {
                    contains: [
                        t
                    ]
                }),
                e.COMMENT(";", "$", {
                    relevance: 0
                }),
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "number",
                    begin: e.NUMBER_RE,
                    relevance: 0
                },
                {
                    className: "variable",
                    begin: "%[a-zA-Z0-9#_$@]+%"
                },
                {
                    className: "built_in",
                    begin: "^\\s*\\w+\\s*(,|%)"
                },
                {
                    className: "title",
                    variants: [
                        {
                            begin: '^[^\\n";]+::(?!=)'
                        },
                        {
                            begin: '^[^\\n";]+:(?!=)',
                            relevance: 0
                        }
                    ]
                },
                {
                    className: "meta",
                    begin: "^\\s*#\\w+",
                    end: "$",
                    relevance: 0
                },
                {
                    className: "built_in",
                    begin: "A_[a-zA-Z0-9]+"
                },
                {
                    begin: ",\\s*,"
                }
            ]
        };
    }), Be)), Cs.registerLanguage("autoit", (He || (He = 1, Ye = function(e) {
        const t = {
            variants: [
                e.COMMENT(";", "$", {
                    relevance: 0
                }),
                e.COMMENT("#cs", "#ce"),
                e.COMMENT("#comments-start", "#comments-end")
            ]
        }, a = {
            begin: "\\$[A-z0-9_]+"
        }, n = {
            className: "string",
            variants: [
                {
                    begin: /"/,
                    end: /"/,
                    contains: [
                        {
                            begin: /""/,
                            relevance: 0
                        }
                    ]
                },
                {
                    begin: /'/,
                    end: /'/,
                    contains: [
                        {
                            begin: /''/,
                            relevance: 0
                        }
                    ]
                }
            ]
        }, i = {
            variants: [
                e.BINARY_NUMBER_MODE,
                e.C_NUMBER_MODE
            ]
        };
        return {
            name: "AutoIt",
            case_insensitive: !0,
            illegal: /\/\*/,
            keywords: {
                keyword: "ByRef Case Const ContinueCase ContinueLoop Dim Do Else ElseIf EndFunc EndIf EndSelect EndSwitch EndWith Enum Exit ExitLoop For Func Global If In Local Next ReDim Return Select Static Step Switch Then To Until Volatile WEnd While With",
                built_in: "Abs ACos AdlibRegister AdlibUnRegister Asc AscW ASin Assign ATan AutoItSetOption AutoItWinGetTitle AutoItWinSetTitle Beep Binary BinaryLen BinaryMid BinaryToString BitAND BitNOT BitOR BitRotate BitShift BitXOR BlockInput Break Call CDTray Ceiling Chr ChrW ClipGet ClipPut ConsoleRead ConsoleWrite ConsoleWriteError ControlClick ControlCommand ControlDisable ControlEnable ControlFocus ControlGetFocus ControlGetHandle ControlGetPos ControlGetText ControlHide ControlListView ControlMove ControlSend ControlSetText ControlShow ControlTreeView Cos Dec DirCopy DirCreate DirGetSize DirMove DirRemove DllCall DllCallAddress DllCallbackFree DllCallbackGetPtr DllCallbackRegister DllClose DllOpen DllStructCreate DllStructGetData DllStructGetPtr DllStructGetSize DllStructSetData DriveGetDrive DriveGetFileSystem DriveGetLabel DriveGetSerial DriveGetType DriveMapAdd DriveMapDel DriveMapGet DriveSetLabel DriveSpaceFree DriveSpaceTotal DriveStatus EnvGet EnvSet EnvUpdate Eval Execute Exp FileChangeDir FileClose FileCopy FileCreateNTFSLink FileCreateShortcut FileDelete FileExists FileFindFirstFile FileFindNextFile FileFlush FileGetAttrib FileGetEncoding FileGetLongName FileGetPos FileGetShortcut FileGetShortName FileGetSize FileGetTime FileGetVersion FileInstall FileMove FileOpen FileOpenDialog FileRead FileReadLine FileReadToArray FileRecycle FileRecycleEmpty FileSaveDialog FileSelectFolder FileSetAttrib FileSetEnd FileSetPos FileSetTime FileWrite FileWriteLine Floor FtpSetProxy FuncName GUICreate GUICtrlCreateAvi GUICtrlCreateButton GUICtrlCreateCheckbox GUICtrlCreateCombo GUICtrlCreateContextMenu GUICtrlCreateDate GUICtrlCreateDummy GUICtrlCreateEdit GUICtrlCreateGraphic GUICtrlCreateGroup GUICtrlCreateIcon GUICtrlCreateInput GUICtrlCreateLabel GUICtrlCreateList GUICtrlCreateListView GUICtrlCreateListViewItem GUICtrlCreateMenu GUICtrlCreateMenuItem GUICtrlCreateMonthCal GUICtrlCreateObj GUICtrlCreatePic GUICtrlCreateProgress GUICtrlCreateRadio GUICtrlCreateSlider GUICtrlCreateTab GUICtrlCreateTabItem GUICtrlCreateTreeView GUICtrlCreateTreeViewItem GUICtrlCreateUpdown GUICtrlDelete GUICtrlGetHandle GUICtrlGetState GUICtrlRead GUICtrlRecvMsg GUICtrlRegisterListViewSort GUICtrlSendMsg GUICtrlSendToDummy GUICtrlSetBkColor GUICtrlSetColor GUICtrlSetCursor GUICtrlSetData GUICtrlSetDefBkColor GUICtrlSetDefColor GUICtrlSetFont GUICtrlSetGraphic GUICtrlSetImage GUICtrlSetLimit GUICtrlSetOnEvent GUICtrlSetPos GUICtrlSetResizing GUICtrlSetState GUICtrlSetStyle GUICtrlSetTip GUIDelete GUIGetCursorInfo GUIGetMsg GUIGetStyle GUIRegisterMsg GUISetAccelerators GUISetBkColor GUISetCoord GUISetCursor GUISetFont GUISetHelp GUISetIcon GUISetOnEvent GUISetState GUISetStyle GUIStartGroup GUISwitch Hex HotKeySet HttpSetProxy HttpSetUserAgent HWnd InetClose InetGet InetGetInfo InetGetSize InetRead IniDelete IniRead IniReadSection IniReadSectionNames IniRenameSection IniWrite IniWriteSection InputBox Int IsAdmin IsArray IsBinary IsBool IsDeclared IsDllStruct IsFloat IsFunc IsHWnd IsInt IsKeyword IsNumber IsObj IsPtr IsString Log MemGetStats Mod MouseClick MouseClickDrag MouseDown MouseGetCursor MouseGetPos MouseMove MouseUp MouseWheel MsgBox Number ObjCreate ObjCreateInterface ObjEvent ObjGet ObjName OnAutoItExitRegister OnAutoItExitUnRegister Ping PixelChecksum PixelGetColor PixelSearch ProcessClose ProcessExists ProcessGetStats ProcessList ProcessSetPriority ProcessWait ProcessWaitClose ProgressOff ProgressOn ProgressSet Ptr Random RegDelete RegEnumKey RegEnumVal RegRead RegWrite Round Run RunAs RunAsWait RunWait Send SendKeepActive SetError SetExtended ShellExecute ShellExecuteWait Shutdown Sin Sleep SoundPlay SoundSetWaveVolume SplashImageOn SplashOff SplashTextOn Sqrt SRandom StatusbarGetText StderrRead StdinWrite StdioClose StdoutRead String StringAddCR StringCompare StringFormat StringFromASCIIArray StringInStr StringIsAlNum StringIsAlpha StringIsASCII StringIsDigit StringIsFloat StringIsInt StringIsLower StringIsSpace StringIsUpper StringIsXDigit StringLeft StringLen StringLower StringMid StringRegExp StringRegExpReplace StringReplace StringReverse StringRight StringSplit StringStripCR StringStripWS StringToASCIIArray StringToBinary StringTrimLeft StringTrimRight StringUpper Tan TCPAccept TCPCloseSocket TCPConnect TCPListen TCPNameToIP TCPRecv TCPSend TCPShutdown, UDPShutdown TCPStartup, UDPStartup TimerDiff TimerInit ToolTip TrayCreateItem TrayCreateMenu TrayGetMsg TrayItemDelete TrayItemGetHandle TrayItemGetState TrayItemGetText TrayItemSetOnEvent TrayItemSetState TrayItemSetText TraySetClick TraySetIcon TraySetOnEvent TraySetPauseIcon TraySetState TraySetToolTip TrayTip UBound UDPBind UDPCloseSocket UDPOpen UDPRecv UDPSend VarGetType WinActivate WinActive WinClose WinExists WinFlash WinGetCaretPos WinGetClassList WinGetClientSize WinGetHandle WinGetPos WinGetProcess WinGetState WinGetText WinGetTitle WinKill WinList WinMenuSelectItem WinMinimizeAll WinMinimizeAllUndo WinMove WinSetOnTop WinSetState WinSetTitle WinSetTrans WinWait WinWaitActive WinWaitClose WinWaitNotActive",
                literal: "True False And Null Not Or Default"
            },
            contains: [
                t,
                a,
                n,
                i,
                {
                    className: "meta",
                    begin: "#",
                    end: "$",
                    keywords: {
                        keyword: [
                            "EndRegion",
                            "forcedef",
                            "forceref",
                            "ignorefunc",
                            "include",
                            "include-once",
                            "NoTrayIcon",
                            "OnAutoItStartRegister",
                            "pragma",
                            "Region",
                            "RequireAdmin",
                            "Tidy_Off",
                            "Tidy_On",
                            "Tidy_Parameters"
                        ]
                    },
                    contains: [
                        {
                            begin: /\\\n/,
                            relevance: 0
                        },
                        {
                            beginKeywords: "include",
                            keywords: {
                                keyword: "include"
                            },
                            end: "$",
                            contains: [
                                n,
                                {
                                    className: "string",
                                    variants: [
                                        {
                                            begin: "<",
                                            end: ">"
                                        },
                                        {
                                            begin: /"/,
                                            end: /"/,
                                            contains: [
                                                {
                                                    begin: /""/,
                                                    relevance: 0
                                                }
                                            ]
                                        },
                                        {
                                            begin: /'/,
                                            end: /'/,
                                            contains: [
                                                {
                                                    begin: /''/,
                                                    relevance: 0
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        n,
                        t
                    ]
                },
                {
                    className: "symbol",
                    begin: "@[A-z0-9_]+"
                },
                {
                    beginKeywords: "Func",
                    end: "$",
                    illegal: "\\$|\\[|%",
                    contains: [
                        e.inherit(e.UNDERSCORE_TITLE_MODE, {
                            className: "title.function"
                        }),
                        {
                            className: "params",
                            begin: "\\(",
                            end: "\\)",
                            contains: [
                                a,
                                n,
                                i
                            ]
                        }
                    ]
                }
            ]
        };
    }), Ye)), Cs.registerLanguage("avrasm", (qe || (qe = 1, Ve = function(e) {
        return {
            name: "AVR Assembly",
            case_insensitive: !0,
            keywords: {
                $pattern: "\\.?" + e.IDENT_RE,
                keyword: "adc add adiw and andi asr bclr bld brbc brbs brcc brcs break breq brge brhc brhs brid brie brlo brlt brmi brne brpl brsh brtc brts brvc brvs bset bst call cbi cbr clc clh cli cln clr cls clt clv clz com cp cpc cpi cpse dec eicall eijmp elpm eor fmul fmuls fmulsu icall ijmp in inc jmp ld ldd ldi lds lpm lsl lsr mov movw mul muls mulsu neg nop or ori out pop push rcall ret reti rjmp rol ror sbc sbr sbrc sbrs sec seh sbi sbci sbic sbis sbiw sei sen ser ses set sev sez sleep spm st std sts sub subi swap tst wdr",
                built_in: "r0 r1 r2 r3 r4 r5 r6 r7 r8 r9 r10 r11 r12 r13 r14 r15 r16 r17 r18 r19 r20 r21 r22 r23 r24 r25 r26 r27 r28 r29 r30 r31 x|0 xh xl y|0 yh yl z|0 zh zl ucsr1c udr1 ucsr1a ucsr1b ubrr1l ubrr1h ucsr0c ubrr0h tccr3c tccr3a tccr3b tcnt3h tcnt3l ocr3ah ocr3al ocr3bh ocr3bl ocr3ch ocr3cl icr3h icr3l etimsk etifr tccr1c ocr1ch ocr1cl twcr twdr twar twsr twbr osccal xmcra xmcrb eicra spmcsr spmcr portg ddrg ping portf ddrf sreg sph spl xdiv rampz eicrb eimsk gimsk gicr eifr gifr timsk tifr mcucr mcucsr tccr0 tcnt0 ocr0 assr tccr1a tccr1b tcnt1h tcnt1l ocr1ah ocr1al ocr1bh ocr1bl icr1h icr1l tccr2 tcnt2 ocr2 ocdr wdtcr sfior eearh eearl eedr eecr porta ddra pina portb ddrb pinb portc ddrc pinc portd ddrd pind spdr spsr spcr udr0 ucsr0a ucsr0b ubrr0l acsr admux adcsr adch adcl porte ddre pine pinf",
                meta: ".byte .cseg .db .def .device .dseg .dw .endmacro .equ .eseg .exit .include .list .listmac .macro .nolist .org .set"
            },
            contains: [
                e.C_BLOCK_COMMENT_MODE,
                e.COMMENT(";", "$", {
                    relevance: 0
                }),
                e.C_NUMBER_MODE,
                e.BINARY_NUMBER_MODE,
                {
                    className: "number",
                    begin: "\\b(\\$[a-zA-Z0-9]+|0o[0-7]+)"
                },
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    begin: "'",
                    end: "[^\\\\]'",
                    illegal: "[^\\\\][^']"
                },
                {
                    className: "symbol",
                    begin: "^[A-Za-z0-9_.$]+:"
                },
                {
                    className: "meta",
                    begin: "#",
                    end: "$"
                },
                {
                    className: "subst",
                    begin: "@[0-9]+"
                }
            ]
        };
    }), Ve)), Cs.registerLanguage("awk", ($e || ($e = 1, ze = function(e) {
        return {
            name: "Awk",
            keywords: {
                keyword: "BEGIN END if else while do for in break continue delete next nextfile function func exit|10"
            },
            contains: [
                {
                    className: "variable",
                    variants: [
                        {
                            begin: /\$[\w\d#@][\w\d_]*/
                        },
                        {
                            begin: /\$\{(.*?)\}/
                        }
                    ]
                },
                {
                    className: "string",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ],
                    variants: [
                        {
                            begin: /(u|b)?r?'''/,
                            end: /'''/,
                            relevance: 10
                        },
                        {
                            begin: /(u|b)?r?"""/,
                            end: /"""/,
                            relevance: 10
                        },
                        {
                            begin: /(u|r|ur)'/,
                            end: /'/,
                            relevance: 10
                        },
                        {
                            begin: /(u|r|ur)"/,
                            end: /"/,
                            relevance: 10
                        },
                        {
                            begin: /(b|br)'/,
                            end: /'/
                        },
                        {
                            begin: /(b|br)"/,
                            end: /"/
                        },
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE
                    ]
                },
                e.REGEXP_MODE,
                e.HASH_COMMENT_MODE,
                e.NUMBER_MODE
            ]
        };
    }), ze)), Cs.registerLanguage("axapta", (Qe || (Qe = 1, We = function(e) {
        const t = e.UNDERSCORE_IDENT_RE, a = {
            keyword: [
                "abstract",
                "as",
                "asc",
                "avg",
                "break",
                "breakpoint",
                "by",
                "byref",
                "case",
                "catch",
                "changecompany",
                "class",
                "client",
                "client",
                "common",
                "const",
                "continue",
                "count",
                "crosscompany",
                "delegate",
                "delete_from",
                "desc",
                "display",
                "div",
                "do",
                "edit",
                "else",
                "eventhandler",
                "exists",
                "extends",
                "final",
                "finally",
                "firstfast",
                "firstonly",
                "firstonly1",
                "firstonly10",
                "firstonly100",
                "firstonly1000",
                "flush",
                "for",
                "forceliterals",
                "forcenestedloop",
                "forceplaceholders",
                "forceselectorder",
                "forupdate",
                "from",
                "generateonly",
                "group",
                "hint",
                "if",
                "implements",
                "in",
                "index",
                "insert_recordset",
                "interface",
                "internal",
                "is",
                "join",
                "like",
                "maxof",
                "minof",
                "mod",
                "namespace",
                "new",
                "next",
                "nofetch",
                "notexists",
                "optimisticlock",
                "order",
                "outer",
                "pessimisticlock",
                "print",
                "private",
                "protected",
                "public",
                "readonly",
                "repeatableread",
                "retry",
                "return",
                "reverse",
                "select",
                "server",
                "setting",
                "static",
                "sum",
                "super",
                "switch",
                "this",
                "throw",
                "try",
                "ttsabort",
                "ttsbegin",
                "ttscommit",
                "unchecked",
                "update_recordset",
                "using",
                "validtimestate",
                "void",
                "where",
                "while"
            ],
            built_in: [
                "anytype",
                "boolean",
                "byte",
                "char",
                "container",
                "date",
                "double",
                "enum",
                "guid",
                "int",
                "int64",
                "long",
                "real",
                "short",
                "str",
                "utcdatetime",
                "var"
            ],
            literal: [
                "default",
                "false",
                "null",
                "true"
            ]
        }, n = {
            variants: [
                {
                    match: [
                        /(class|interface)\s+/,
                        t,
                        /\s+(extends|implements)\s+/,
                        t
                    ]
                },
                {
                    match: [
                        /class\s+/,
                        t
                    ]
                }
            ],
            scope: {
                2: "title.class",
                4: "title.class.inherited"
            },
            keywords: a
        };
        return {
            name: "X++",
            aliases: [
                "x++"
            ],
            keywords: a,
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE,
                {
                    className: "meta",
                    begin: "#",
                    end: "$"
                },
                n
            ]
        };
    }), We)), Cs.registerLanguage("bash", (je || (je = 1, Ke = function(e) {
        const t = e.regex, a = {}, n = {
            begin: /\$\{/,
            end: /\}/,
            contains: [
                "self",
                {
                    begin: /:-/,
                    contains: [
                        a
                    ]
                }
            ]
        };
        Object.assign(a, {
            className: "variable",
            variants: [
                {
                    begin: t.concat(/\$[\w\d#@][\w\d_]*/, "(?![\\w\\d])(?![$])")
                },
                n
            ]
        });
        const i = {
            className: "subst",
            begin: /\$\(/,
            end: /\)/,
            contains: [
                e.BACKSLASH_ESCAPE
            ]
        }, r = {
            begin: /<<-?\s*(?=\w+)/,
            starts: {
                contains: [
                    e.END_SAME_AS_BEGIN({
                        begin: /(\w+)/,
                        end: /(\w+)/,
                        className: "string"
                    })
                ]
            }
        }, o = {
            className: "string",
            begin: /"/,
            end: /"/,
            contains: [
                e.BACKSLASH_ESCAPE,
                a,
                i
            ]
        };
        i.contains.push(o);
        const s = {
            begin: /\$?\(\(/,
            end: /\)\)/,
            contains: [
                {
                    begin: /\d+#[0-9a-f]+/,
                    className: "number"
                },
                e.NUMBER_MODE,
                a
            ]
        }, l = e.SHEBANG({
            binary: `(${[
                "fish",
                "bash",
                "zsh",
                "sh",
                "csh",
                "ksh",
                "tcsh",
                "dash",
                "scsh"
            ].join("|")})`,
            relevance: 10
        }), c = {
            className: "function",
            begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
            returnBegin: !0,
            contains: [
                e.inherit(e.TITLE_MODE, {
                    begin: /\w[\w\d_]*/
                })
            ],
            relevance: 0
        };
        return {
            name: "Bash",
            aliases: [
                "sh"
            ],
            keywords: {
                $pattern: /\b[a-z][a-z0-9._-]+\b/,
                keyword: [
                    "if",
                    "then",
                    "else",
                    "elif",
                    "fi",
                    "for",
                    "while",
                    "until",
                    "in",
                    "do",
                    "done",
                    "case",
                    "esac",
                    "function",
                    "select"
                ],
                literal: [
                    "true",
                    "false"
                ],
                built_in: [
                    "break",
                    "cd",
                    "continue",
                    "eval",
                    "exec",
                    "exit",
                    "export",
                    "getopts",
                    "hash",
                    "pwd",
                    "readonly",
                    "return",
                    "shift",
                    "test",
                    "times",
                    "trap",
                    "umask",
                    "unset",
                    "alias",
                    "bind",
                    "builtin",
                    "caller",
                    "command",
                    "declare",
                    "echo",
                    "enable",
                    "help",
                    "let",
                    "local",
                    "logout",
                    "mapfile",
                    "printf",
                    "read",
                    "readarray",
                    "source",
                    "type",
                    "typeset",
                    "ulimit",
                    "unalias",
                    "set",
                    "shopt",
                    "autoload",
                    "bg",
                    "bindkey",
                    "bye",
                    "cap",
                    "chdir",
                    "clone",
                    "comparguments",
                    "compcall",
                    "compctl",
                    "compdescribe",
                    "compfiles",
                    "compgroups",
                    "compquote",
                    "comptags",
                    "comptry",
                    "compvalues",
                    "dirs",
                    "disable",
                    "disown",
                    "echotc",
                    "echoti",
                    "emulate",
                    "fc",
                    "fg",
                    "float",
                    "functions",
                    "getcap",
                    "getln",
                    "history",
                    "integer",
                    "jobs",
                    "kill",
                    "limit",
                    "log",
                    "noglob",
                    "popd",
                    "print",
                    "pushd",
                    "pushln",
                    "rehash",
                    "sched",
                    "setcap",
                    "setopt",
                    "stat",
                    "suspend",
                    "ttyctl",
                    "unfunction",
                    "unhash",
                    "unlimit",
                    "unsetopt",
                    "vared",
                    "wait",
                    "whence",
                    "where",
                    "which",
                    "zcompile",
                    "zformat",
                    "zftp",
                    "zle",
                    "zmodload",
                    "zparseopts",
                    "zprof",
                    "zpty",
                    "zregexparse",
                    "zsocket",
                    "zstyle",
                    "ztcp",
                    "chcon",
                    "chgrp",
                    "chown",
                    "chmod",
                    "cp",
                    "dd",
                    "df",
                    "dir",
                    "dircolors",
                    "ln",
                    "ls",
                    "mkdir",
                    "mkfifo",
                    "mknod",
                    "mktemp",
                    "mv",
                    "realpath",
                    "rm",
                    "rmdir",
                    "shred",
                    "sync",
                    "touch",
                    "truncate",
                    "vdir",
                    "b2sum",
                    "base32",
                    "base64",
                    "cat",
                    "cksum",
                    "comm",
                    "csplit",
                    "cut",
                    "expand",
                    "fmt",
                    "fold",
                    "head",
                    "join",
                    "md5sum",
                    "nl",
                    "numfmt",
                    "od",
                    "paste",
                    "ptx",
                    "pr",
                    "sha1sum",
                    "sha224sum",
                    "sha256sum",
                    "sha384sum",
                    "sha512sum",
                    "shuf",
                    "sort",
                    "split",
                    "sum",
                    "tac",
                    "tail",
                    "tr",
                    "tsort",
                    "unexpand",
                    "uniq",
                    "wc",
                    "arch",
                    "basename",
                    "chroot",
                    "date",
                    "dirname",
                    "du",
                    "echo",
                    "env",
                    "expr",
                    "factor",
                    "groups",
                    "hostid",
                    "id",
                    "link",
                    "logname",
                    "nice",
                    "nohup",
                    "nproc",
                    "pathchk",
                    "pinky",
                    "printenv",
                    "printf",
                    "pwd",
                    "readlink",
                    "runcon",
                    "seq",
                    "sleep",
                    "stat",
                    "stdbuf",
                    "stty",
                    "tee",
                    "test",
                    "timeout",
                    "tty",
                    "uname",
                    "unlink",
                    "uptime",
                    "users",
                    "who",
                    "whoami",
                    "yes"
                ]
            },
            contains: [
                l,
                e.SHEBANG(),
                c,
                s,
                e.HASH_COMMENT_MODE,
                r,
                {
                    match: /(\/[a-z._-]+)+/
                },
                o,
                {
                    match: /\\"/
                },
                {
                    className: "string",
                    begin: /'/,
                    end: /'/
                },
                {
                    match: /\\'/
                },
                a
            ]
        };
    }), Ke)), Cs.registerLanguage("basic", (Ze || (Ze = 1, Xe = function(e) {
        return {
            name: "BASIC",
            case_insensitive: !0,
            illegal: "^.",
            keywords: {
                $pattern: "[a-zA-Z][a-zA-Z0-9_$%!#]*",
                keyword: [
                    "ABS",
                    "ASC",
                    "AND",
                    "ATN",
                    "AUTO|0",
                    "BEEP",
                    "BLOAD|10",
                    "BSAVE|10",
                    "CALL",
                    "CALLS",
                    "CDBL",
                    "CHAIN",
                    "CHDIR",
                    "CHR$|10",
                    "CINT",
                    "CIRCLE",
                    "CLEAR",
                    "CLOSE",
                    "CLS",
                    "COLOR",
                    "COM",
                    "COMMON",
                    "CONT",
                    "COS",
                    "CSNG",
                    "CSRLIN",
                    "CVD",
                    "CVI",
                    "CVS",
                    "DATA",
                    "DATE$",
                    "DEFDBL",
                    "DEFINT",
                    "DEFSNG",
                    "DEFSTR",
                    "DEF|0",
                    "SEG",
                    "USR",
                    "DELETE",
                    "DIM",
                    "DRAW",
                    "EDIT",
                    "END",
                    "ENVIRON",
                    "ENVIRON$",
                    "EOF",
                    "EQV",
                    "ERASE",
                    "ERDEV",
                    "ERDEV$",
                    "ERL",
                    "ERR",
                    "ERROR",
                    "EXP",
                    "FIELD",
                    "FILES",
                    "FIX",
                    "FOR|0",
                    "FRE",
                    "GET",
                    "GOSUB|10",
                    "GOTO",
                    "HEX$",
                    "IF",
                    "THEN",
                    "ELSE|0",
                    "INKEY$",
                    "INP",
                    "INPUT",
                    "INPUT#",
                    "INPUT$",
                    "INSTR",
                    "IMP",
                    "INT",
                    "IOCTL",
                    "IOCTL$",
                    "KEY",
                    "ON",
                    "OFF",
                    "LIST",
                    "KILL",
                    "LEFT$",
                    "LEN",
                    "LET",
                    "LINE",
                    "LLIST",
                    "LOAD",
                    "LOC",
                    "LOCATE",
                    "LOF",
                    "LOG",
                    "LPRINT",
                    "USING",
                    "LSET",
                    "MERGE",
                    "MID$",
                    "MKDIR",
                    "MKD$",
                    "MKI$",
                    "MKS$",
                    "MOD",
                    "NAME",
                    "NEW",
                    "NEXT",
                    "NOISE",
                    "NOT",
                    "OCT$",
                    "ON",
                    "OR",
                    "PEN",
                    "PLAY",
                    "STRIG",
                    "OPEN",
                    "OPTION",
                    "BASE",
                    "OUT",
                    "PAINT",
                    "PALETTE",
                    "PCOPY",
                    "PEEK",
                    "PMAP",
                    "POINT",
                    "POKE",
                    "POS",
                    "PRINT",
                    "PRINT]",
                    "PSET",
                    "PRESET",
                    "PUT",
                    "RANDOMIZE",
                    "READ",
                    "REM",
                    "RENUM",
                    "RESET|0",
                    "RESTORE",
                    "RESUME",
                    "RETURN|0",
                    "RIGHT$",
                    "RMDIR",
                    "RND",
                    "RSET",
                    "RUN",
                    "SAVE",
                    "SCREEN",
                    "SGN",
                    "SHELL",
                    "SIN",
                    "SOUND",
                    "SPACE$",
                    "SPC",
                    "SQR",
                    "STEP",
                    "STICK",
                    "STOP",
                    "STR$",
                    "STRING$",
                    "SWAP",
                    "SYSTEM",
                    "TAB",
                    "TAN",
                    "TIME$",
                    "TIMER",
                    "TROFF",
                    "TRON",
                    "TO",
                    "USR",
                    "VAL",
                    "VARPTR",
                    "VARPTR$",
                    "VIEW",
                    "WAIT",
                    "WHILE",
                    "WEND",
                    "WIDTH",
                    "WINDOW",
                    "WRITE",
                    "XOR"
                ]
            },
            contains: [
                e.QUOTE_STRING_MODE,
                e.COMMENT("REM", "$", {
                    relevance: 10
                }),
                e.COMMENT("'", "$", {
                    relevance: 0
                }),
                {
                    className: "symbol",
                    begin: "^[0-9]+ ",
                    relevance: 10
                },
                {
                    className: "number",
                    begin: "\\b\\d+(\\.\\d+)?([edED]\\d+)?[#!]?",
                    relevance: 0
                },
                {
                    className: "number",
                    begin: "(&[hH][0-9a-fA-F]{1,4})"
                },
                {
                    className: "number",
                    begin: "(&[oO][0-7]{1,6})"
                }
            ]
        };
    }), Xe)), Cs.registerLanguage("bnf", (et || (et = 1, Je = function(e) {
        return {
            name: "Backus\u2013Naur Form",
            contains: [
                {
                    className: "attribute",
                    begin: /</,
                    end: />/
                },
                {
                    begin: /::=/,
                    end: /$/,
                    contains: [
                        {
                            begin: /</,
                            end: />/
                        },
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE,
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE
                    ]
                }
            ]
        };
    }), Je)), Cs.registerLanguage("brainfuck", (at || (at = 1, tt = function(e) {
        const t = {
            className: "literal",
            begin: /[+-]+/,
            relevance: 0
        };
        return {
            name: "Brainfuck",
            aliases: [
                "bf"
            ],
            contains: [
                e.COMMENT(/[^\[\]\.,\+\-<> \r\n]/, /[\[\]\.,\+\-<> \r\n]/, {
                    contains: [
                        {
                            match: /[ ]+[^\[\]\.,\+\-<> \r\n]/,
                            relevance: 0
                        }
                    ],
                    returnEnd: !0,
                    relevance: 0
                }),
                {
                    className: "title",
                    begin: "[\\[\\]]",
                    relevance: 0
                },
                {
                    className: "string",
                    begin: "[\\.,]",
                    relevance: 0
                },
                {
                    begin: /(?=\+\+|--)/,
                    contains: [
                        t
                    ]
                },
                t
            ]
        };
    }), tt)), Cs.registerLanguage("c", (it || (it = 1, nt = function(e) {
        const t = e.regex, a = e.COMMENT("//", "$", {
            contains: [
                {
                    begin: /\\\n/
                }
            ]
        }), n = "decltype\\(auto\\)", i = "[a-zA-Z_]\\w*::", r = "(" + n + "|" + t.optional(i) + "[a-zA-Z_]\\w*" + t.optional("<[^<>]+>") + ")", o = {
            className: "type",
            variants: [
                {
                    begin: "\\b[a-z\\d_]*_t\\b"
                },
                {
                    match: /\batomic_[a-z]{3,6}\b/
                }
            ]
        }, s = {
            className: "string",
            variants: [
                {
                    begin: '(u8?|U|L)?"',
                    end: '"',
                    illegal: "\\n",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: "(u8?|U|L)?'(\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)|.)",
                    end: "'",
                    illegal: "."
                },
                e.END_SAME_AS_BEGIN({
                    begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                    end: /\)([^()\\ ]{0,16})"/
                })
            ]
        }, l = {
            className: "number",
            variants: [
                {
                    begin: "\\b(0b[01']+)"
                },
                {
                    begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)"
                },
                {
                    begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
                }
            ],
            relevance: 0
        }, c = {
            className: "meta",
            begin: /#\s*[a-z]+\b/,
            end: /$/,
            keywords: {
                keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
            },
            contains: [
                {
                    begin: /\\\n/,
                    relevance: 0
                },
                e.inherit(s, {
                    className: "string"
                }),
                {
                    className: "string",
                    begin: /<.*?>/
                },
                a,
                e.C_BLOCK_COMMENT_MODE
            ]
        }, _ = {
            className: "title",
            begin: t.optional(i) + e.IDENT_RE,
            relevance: 0
        }, d = t.optional(i) + e.IDENT_RE + "\\s*\\(", m = {
            keyword: [
                "asm",
                "auto",
                "break",
                "case",
                "continue",
                "default",
                "do",
                "else",
                "enum",
                "extern",
                "for",
                "fortran",
                "goto",
                "if",
                "inline",
                "register",
                "restrict",
                "return",
                "sizeof",
                "struct",
                "switch",
                "typedef",
                "union",
                "volatile",
                "while",
                "_Alignas",
                "_Alignof",
                "_Atomic",
                "_Generic",
                "_Noreturn",
                "_Static_assert",
                "_Thread_local",
                "alignas",
                "alignof",
                "noreturn",
                "static_assert",
                "thread_local",
                "_Pragma"
            ],
            type: [
                "float",
                "double",
                "signed",
                "unsigned",
                "int",
                "short",
                "long",
                "char",
                "void",
                "_Bool",
                "_Complex",
                "_Imaginary",
                "_Decimal32",
                "_Decimal64",
                "_Decimal128",
                "const",
                "static",
                "complex",
                "bool",
                "imaginary"
            ],
            literal: "true false NULL",
            built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr"
        }, p = [
            c,
            o,
            a,
            e.C_BLOCK_COMMENT_MODE,
            l,
            s
        ], u = {
            variants: [
                {
                    begin: /=/,
                    end: /;/
                },
                {
                    begin: /\(/,
                    end: /\)/
                },
                {
                    beginKeywords: "new throw return else",
                    end: /;/
                }
            ],
            keywords: m,
            contains: p.concat([
                {
                    begin: /\(/,
                    end: /\)/,
                    keywords: m,
                    contains: p.concat([
                        "self"
                    ]),
                    relevance: 0
                }
            ]),
            relevance: 0
        }, g = {
            begin: "(" + r + "[\\*&\\s]+)+" + d,
            returnBegin: !0,
            end: /[{;=]/,
            excludeEnd: !0,
            keywords: m,
            illegal: /[^\w\s\*&:<>.]/,
            contains: [
                {
                    begin: n,
                    keywords: m,
                    relevance: 0
                },
                {
                    begin: d,
                    returnBegin: !0,
                    contains: [
                        e.inherit(_, {
                            className: "title.function"
                        })
                    ],
                    relevance: 0
                },
                {
                    relevance: 0,
                    match: /,/
                },
                {
                    className: "params",
                    begin: /\(/,
                    end: /\)/,
                    keywords: m,
                    relevance: 0,
                    contains: [
                        a,
                        e.C_BLOCK_COMMENT_MODE,
                        s,
                        l,
                        o,
                        {
                            begin: /\(/,
                            end: /\)/,
                            keywords: m,
                            relevance: 0,
                            contains: [
                                "self",
                                a,
                                e.C_BLOCK_COMMENT_MODE,
                                s,
                                l,
                                o
                            ]
                        }
                    ]
                },
                o,
                a,
                e.C_BLOCK_COMMENT_MODE,
                c
            ]
        };
        return {
            name: "C",
            aliases: [
                "h"
            ],
            keywords: m,
            disableAutodetect: !0,
            illegal: "</",
            contains: [].concat(u, g, p, [
                c,
                {
                    begin: e.IDENT_RE + "::",
                    keywords: m
                },
                {
                    className: "class",
                    beginKeywords: "enum class struct union",
                    end: /[{;:<>=]/,
                    contains: [
                        {
                            beginKeywords: "final class struct"
                        },
                        e.TITLE_MODE
                    ]
                }
            ]),
            exports: {
                preprocessor: c,
                strings: s,
                keywords: m
            }
        };
    }), nt)), Cs.registerLanguage("cal", (ot || (ot = 1, rt = function(e) {
        const t = e.regex, a = [
            "div",
            "mod",
            "in",
            "and",
            "or",
            "not",
            "xor",
            "asserterror",
            "begin",
            "case",
            "do",
            "downto",
            "else",
            "end",
            "exit",
            "for",
            "local",
            "if",
            "of",
            "repeat",
            "then",
            "to",
            "until",
            "while",
            "with",
            "var"
        ], n = [
            e.C_LINE_COMMENT_MODE,
            e.COMMENT(/\{/, /\}/, {
                relevance: 0
            }),
            e.COMMENT(/\(\*/, /\*\)/, {
                relevance: 10
            })
        ], i = {
            className: "string",
            begin: /'/,
            end: /'/,
            contains: [
                {
                    begin: /''/
                }
            ]
        }, r = {
            className: "string",
            begin: /(#\d+)+/
        }, o = {
            match: [
                /procedure/,
                /\s+/,
                /[a-zA-Z_][\w@]*/,
                /\s*/
            ],
            scope: {
                1: "keyword",
                3: "title.function"
            },
            contains: [
                {
                    className: "params",
                    begin: /\(/,
                    end: /\)/,
                    keywords: a,
                    contains: [
                        i,
                        r,
                        e.NUMBER_MODE
                    ]
                },
                ...n
            ]
        }, s = {
            match: [
                /OBJECT/,
                /\s+/,
                t.either("Table", "Form", "Report", "Dataport", "Codeunit", "XMLport", "MenuSuite", "Page", "Query"),
                /\s+/,
                /\d+/,
                /\s+(?=[^\s])/,
                /.*/,
                /$/
            ],
            relevance: 3,
            scope: {
                1: "keyword",
                3: "type",
                5: "number",
                7: "title"
            }
        };
        return {
            name: "C/AL",
            case_insensitive: !0,
            keywords: {
                keyword: a,
                literal: "false true"
            },
            illegal: /\/\*/,
            contains: [
                {
                    match: /[\w]+(?=\=)/,
                    scope: "attribute",
                    relevance: 0
                },
                i,
                r,
                {
                    className: "number",
                    begin: "\\b\\d+(\\.\\d+)?(DT|D|T)",
                    relevance: 0
                },
                {
                    className: "string",
                    begin: '"',
                    end: '"'
                },
                e.NUMBER_MODE,
                s,
                o
            ]
        };
    }), rt)), Cs.registerLanguage("capnproto", (lt || (lt = 1, st = function(e) {
        const t = {
            variants: [
                {
                    match: [
                        /(struct|enum|interface)/,
                        /\s+/,
                        e.IDENT_RE
                    ]
                },
                {
                    match: [
                        /extends/,
                        /\s*\(/,
                        e.IDENT_RE,
                        /\s*\)/
                    ]
                }
            ],
            scope: {
                1: "keyword",
                3: "title.class"
            }
        };
        return {
            name: "Cap\u2019n Proto",
            aliases: [
                "capnp"
            ],
            keywords: {
                keyword: [
                    "struct",
                    "enum",
                    "interface",
                    "union",
                    "group",
                    "import",
                    "using",
                    "const",
                    "annotation",
                    "extends",
                    "in",
                    "of",
                    "on",
                    "as",
                    "with",
                    "from",
                    "fixed"
                ],
                type: [
                    "Void",
                    "Bool",
                    "Int8",
                    "Int16",
                    "Int32",
                    "Int64",
                    "UInt8",
                    "UInt16",
                    "UInt32",
                    "UInt64",
                    "Float32",
                    "Float64",
                    "Text",
                    "Data",
                    "AnyPointer",
                    "AnyStruct",
                    "Capability",
                    "List"
                ],
                literal: [
                    "true",
                    "false"
                ]
            },
            contains: [
                e.QUOTE_STRING_MODE,
                e.NUMBER_MODE,
                e.HASH_COMMENT_MODE,
                {
                    className: "meta",
                    begin: /@0x[\w\d]{16};/,
                    illegal: /\n/
                },
                {
                    className: "symbol",
                    begin: /@\d+\b/
                },
                t
            ]
        };
    }), st)), Cs.registerLanguage("ceylon", (_t || (_t = 1, ct = function(e) {
        const t = [
            "assembly",
            "module",
            "package",
            "import",
            "alias",
            "class",
            "interface",
            "object",
            "given",
            "value",
            "assign",
            "void",
            "function",
            "new",
            "of",
            "extends",
            "satisfies",
            "abstracts",
            "in",
            "out",
            "return",
            "break",
            "continue",
            "throw",
            "assert",
            "dynamic",
            "if",
            "else",
            "switch",
            "case",
            "for",
            "while",
            "try",
            "catch",
            "finally",
            "then",
            "let",
            "this",
            "outer",
            "super",
            "is",
            "exists",
            "nonempty"
        ], a = {
            className: "subst",
            excludeBegin: !0,
            excludeEnd: !0,
            begin: /``/,
            end: /``/,
            keywords: t,
            relevance: 10
        }, n = [
            {
                className: "string",
                begin: '"""',
                end: '"""',
                relevance: 10
            },
            {
                className: "string",
                begin: '"',
                end: '"',
                contains: [
                    a
                ]
            },
            {
                className: "string",
                begin: "'",
                end: "'"
            },
            {
                className: "number",
                begin: "#[0-9a-fA-F_]+|\\$[01_]+|[0-9_]+(?:\\.[0-9_](?:[eE][+-]?\\d+)?)?[kMGTPmunpf]?",
                relevance: 0
            }
        ];
        return a.contains = n, {
            name: "Ceylon",
            keywords: {
                keyword: t.concat([
                    "shared",
                    "abstract",
                    "formal",
                    "default",
                    "actual",
                    "variable",
                    "late",
                    "native",
                    "deprecated",
                    "final",
                    "sealed",
                    "annotation",
                    "suppressWarnings",
                    "small"
                ]),
                meta: [
                    "doc",
                    "by",
                    "license",
                    "see",
                    "throws",
                    "tagged"
                ]
            },
            illegal: "\\$[^01]|#[^0-9a-fA-F]",
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.COMMENT("/\\*", "\\*/", {
                    contains: [
                        "self"
                    ]
                }),
                {
                    className: "meta",
                    begin: '@[a-z]\\w*(?::"[^"]*")?'
                }
            ].concat(n)
        };
    }), ct)), Cs.registerLanguage("clean", (mt || (mt = 1, dt = function(e) {
        return {
            name: "Clean",
            aliases: [
                "icl",
                "dcl"
            ],
            keywords: {
                keyword: [
                    "if",
                    "let",
                    "in",
                    "with",
                    "where",
                    "case",
                    "of",
                    "class",
                    "instance",
                    "otherwise",
                    "implementation",
                    "definition",
                    "system",
                    "module",
                    "from",
                    "import",
                    "qualified",
                    "as",
                    "special",
                    "code",
                    "inline",
                    "foreign",
                    "export",
                    "ccall",
                    "stdcall",
                    "generic",
                    "derive",
                    "infix",
                    "infixl",
                    "infixr"
                ],
                built_in: "Int Real Char Bool",
                literal: "True False"
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE,
                {
                    begin: "->|<-[|:]?|#!?|>>=|\\{\\||\\|\\}|:==|=:|<>"
                }
            ]
        };
    }), dt)), Cs.registerLanguage("clojure", (ut || (ut = 1, pt = function(e) {
        const t = "a-zA-Z_\\-!.?+*=<>&'", a = "[#]?[" + t + "][" + t + "0-9/;:$#]*", n = "def defonce defprotocol defstruct defmulti defmethod defn- defn defmacro deftype defrecord", i = {
            $pattern: a,
            built_in: n + " cond apply if-not if-let if not not= =|0 <|0 >|0 <=|0 >=|0 ==|0 +|0 /|0 *|0 -|0 rem quot neg? pos? delay? symbol? keyword? true? false? integer? empty? coll? list? set? ifn? fn? associative? sequential? sorted? counted? reversible? number? decimal? class? distinct? isa? float? rational? reduced? ratio? odd? even? char? seq? vector? string? map? nil? contains? zero? instance? not-every? not-any? libspec? -> ->> .. . inc compare do dotimes mapcat take remove take-while drop letfn drop-last take-last drop-while while intern condp case reduced cycle split-at split-with repeat replicate iterate range merge zipmap declare line-seq sort comparator sort-by dorun doall nthnext nthrest partition eval doseq await await-for let agent atom send send-off release-pending-sends add-watch mapv filterv remove-watch agent-error restart-agent set-error-handler error-handler set-error-mode! error-mode shutdown-agents quote var fn loop recur throw try monitor-enter monitor-exit macroexpand macroexpand-1 for dosync and or when when-not when-let comp juxt partial sequence memoize constantly complement identity assert peek pop doto proxy first rest cons cast coll last butlast sigs reify second ffirst fnext nfirst nnext meta with-meta ns in-ns create-ns import refer keys select-keys vals key val rseq name namespace promise into transient persistent! conj! assoc! dissoc! pop! disj! use class type num float double short byte boolean bigint biginteger bigdec print-method print-dup throw-if printf format load compile get-in update-in pr pr-on newline flush read slurp read-line subvec with-open memfn time re-find re-groups rand-int rand mod locking assert-valid-fdecl alias resolve ref deref refset swap! reset! set-validator! compare-and-set! alter-meta! reset-meta! commute get-validator alter ref-set ref-history-count ref-min-history ref-max-history ensure sync io! new next conj set! to-array future future-call into-array aset gen-class reduce map filter find empty hash-map hash-set sorted-map sorted-map-by sorted-set sorted-set-by vec vector seq flatten reverse assoc dissoc list disj get union difference intersection extend extend-type extend-protocol int nth delay count concat chunk chunk-buffer chunk-append chunk-first chunk-rest max min dec unchecked-inc-int unchecked-inc unchecked-dec-inc unchecked-dec unchecked-negate unchecked-add-int unchecked-add unchecked-subtract-int unchecked-subtract chunk-next chunk-cons chunked-seq? prn vary-meta lazy-seq spread list* str find-keyword keyword symbol gensym force rationalize"
        }, r = {
            begin: a,
            relevance: 0
        }, o = {
            scope: "number",
            relevance: 0,
            variants: [
                {
                    match: /[-+]?0[xX][0-9a-fA-F]+N?/
                },
                {
                    match: /[-+]?0[0-7]+N?/
                },
                {
                    match: /[-+]?[1-9][0-9]?[rR][0-9a-zA-Z]+N?/
                },
                {
                    match: /[-+]?[0-9]+\/[0-9]+N?/
                },
                {
                    match: /[-+]?[0-9]+((\.[0-9]*([eE][+-]?[0-9]+)?M?)|([eE][+-]?[0-9]+M?|M))/
                },
                {
                    match: /[-+]?([1-9][0-9]*|0)N?/
                }
            ]
        }, s = {
            scope: "character",
            variants: [
                {
                    match: /\\o[0-3]?[0-7]{1,2}/
                },
                {
                    match: /\\u[0-9a-fA-F]{4}/
                },
                {
                    match: /\\(newline|space|tab|formfeed|backspace|return)/
                },
                {
                    match: /\\\S/,
                    relevance: 0
                }
            ]
        }, l = {
            scope: "regex",
            begin: /#"/,
            end: /"/,
            contains: [
                e.BACKSLASH_ESCAPE
            ]
        }, c = e.inherit(e.QUOTE_STRING_MODE, {
            illegal: null
        }), _ = {
            scope: "punctuation",
            match: /,/,
            relevance: 0
        }, d = e.COMMENT(";", "$", {
            relevance: 0
        }), m = {
            className: "literal",
            begin: /\b(true|false|nil)\b/
        }, p = {
            begin: "\\[|(#::?" + a + ")?\\{",
            end: "[\\]\\}]",
            relevance: 0
        }, u = {
            className: "symbol",
            begin: "[:]{1,2}" + a
        }, g = {
            begin: "\\(",
            end: "\\)"
        }, E = {
            endsWithParent: !0,
            relevance: 0
        }, S = {
            keywords: i,
            className: "name",
            begin: a,
            relevance: 0,
            starts: E
        }, b = [
            _,
            g,
            s,
            l,
            c,
            d,
            u,
            p,
            o,
            m,
            r
        ], T = {
            beginKeywords: n,
            keywords: {
                $pattern: a,
                keyword: n
            },
            end: '(\\[|#|\\d|"|:|\\{|\\)|\\(|$)',
            contains: [
                {
                    className: "title",
                    begin: a,
                    relevance: 0,
                    excludeEnd: !0,
                    endsParent: !0
                }
            ].concat(b)
        };
        return g.contains = [
            T,
            S,
            E
        ], E.contains = b, p.contains = b, {
            name: "Clojure",
            aliases: [
                "clj",
                "edn"
            ],
            illegal: /\S/,
            contains: [
                _,
                g,
                s,
                l,
                c,
                d,
                u,
                p,
                o,
                m
            ]
        };
    }), pt)), Cs.registerLanguage("clojure-repl", Et ? gt : (Et = 1, gt = function(e) {
        return {
            name: "Clojure REPL",
            contains: [
                {
                    className: "meta.prompt",
                    begin: /^([\w.-]+|\s*#_)?=>/,
                    starts: {
                        end: /$/,
                        subLanguage: "clojure"
                    }
                }
            ]
        };
    })), Cs.registerLanguage("cmake", (bt || (bt = 1, St = function(e) {
        return {
            name: "CMake",
            aliases: [
                "cmake.in"
            ],
            case_insensitive: !0,
            keywords: {
                keyword: "break cmake_host_system_information cmake_minimum_required cmake_parse_arguments cmake_policy configure_file continue elseif else endforeach endfunction endif endmacro endwhile execute_process file find_file find_library find_package find_path find_program foreach function get_cmake_property get_directory_property get_filename_component get_property if include include_guard list macro mark_as_advanced math message option return separate_arguments set_directory_properties set_property set site_name string unset variable_watch while add_compile_definitions add_compile_options add_custom_command add_custom_target add_definitions add_dependencies add_executable add_library add_link_options add_subdirectory add_test aux_source_directory build_command create_test_sourcelist define_property enable_language enable_testing export fltk_wrap_ui get_source_file_property get_target_property get_test_property include_directories include_external_msproject include_regular_expression install link_directories link_libraries load_cache project qt_wrap_cpp qt_wrap_ui remove_definitions set_source_files_properties set_target_properties set_tests_properties source_group target_compile_definitions target_compile_features target_compile_options target_include_directories target_link_directories target_link_libraries target_link_options target_sources try_compile try_run ctest_build ctest_configure ctest_coverage ctest_empty_binary_directory ctest_memcheck ctest_read_custom_files ctest_run_script ctest_sleep ctest_start ctest_submit ctest_test ctest_update ctest_upload build_name exec_program export_library_dependencies install_files install_programs install_targets load_command make_directory output_required_files remove subdir_depends subdirs use_mangled_mesa utility_source variable_requires write_file qt5_use_modules qt5_use_package qt5_wrap_cpp on off true false and or not command policy target test exists is_newer_than is_directory is_symlink is_absolute matches less greater equal less_equal greater_equal strless strgreater strequal strless_equal strgreater_equal version_less version_greater version_equal version_less_equal version_greater_equal in_list defined"
            },
            contains: [
                {
                    className: "variable",
                    begin: /\$\{/,
                    end: /\}/
                },
                e.COMMENT(/#\[\[/, /]]/),
                e.HASH_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.NUMBER_MODE
            ]
        };
    }), St)), Cs.registerLanguage("coffeescript", function() {
        if (Ct) return Tt;
        Ct = 1;
        const e = [
            "as",
            "in",
            "of",
            "if",
            "for",
            "while",
            "finally",
            "var",
            "new",
            "function",
            "do",
            "return",
            "void",
            "else",
            "break",
            "catch",
            "instanceof",
            "with",
            "throw",
            "case",
            "default",
            "try",
            "switch",
            "continue",
            "typeof",
            "delete",
            "let",
            "yield",
            "const",
            "class",
            "debugger",
            "async",
            "await",
            "static",
            "import",
            "from",
            "export",
            "extends"
        ], t = [
            "true",
            "false",
            "null",
            "undefined",
            "NaN",
            "Infinity"
        ], a = [].concat([
            "setInterval",
            "setTimeout",
            "clearInterval",
            "clearTimeout",
            "require",
            "exports",
            "eval",
            "isFinite",
            "isNaN",
            "parseFloat",
            "parseInt",
            "decodeURI",
            "decodeURIComponent",
            "encodeURI",
            "encodeURIComponent",
            "escape",
            "unescape"
        ], [
            "Object",
            "Function",
            "Boolean",
            "Symbol",
            "Math",
            "Date",
            "Number",
            "BigInt",
            "String",
            "RegExp",
            "Array",
            "Float32Array",
            "Float64Array",
            "Int8Array",
            "Uint8Array",
            "Uint8ClampedArray",
            "Int16Array",
            "Int32Array",
            "Uint16Array",
            "Uint32Array",
            "BigInt64Array",
            "BigUint64Array",
            "Set",
            "Map",
            "WeakSet",
            "WeakMap",
            "ArrayBuffer",
            "SharedArrayBuffer",
            "Atomics",
            "DataView",
            "JSON",
            "Promise",
            "Generator",
            "GeneratorFunction",
            "AsyncFunction",
            "Reflect",
            "Proxy",
            "Intl",
            "WebAssembly"
        ], [
            "Error",
            "EvalError",
            "InternalError",
            "RangeError",
            "ReferenceError",
            "SyntaxError",
            "TypeError",
            "URIError"
        ]);
        return Tt = function(n) {
            const i = {
                keyword: e.concat([
                    "then",
                    "unless",
                    "until",
                    "loop",
                    "by",
                    "when",
                    "and",
                    "or",
                    "is",
                    "isnt",
                    "not"
                ]).filter((r = [
                    "var",
                    "const",
                    "let",
                    "function",
                    "static"
                ], (e)=>!r.includes(e))),
                literal: t.concat([
                    "yes",
                    "no",
                    "on",
                    "off"
                ]),
                built_in: a.concat([
                    "npm",
                    "print"
                ])
            };
            var r;
            const o = "[A-Za-z$_][0-9A-Za-z$_]*", s = {
                className: "subst",
                begin: /#\{/,
                end: /\}/,
                keywords: i
            }, l = [
                n.BINARY_NUMBER_MODE,
                n.inherit(n.C_NUMBER_MODE, {
                    starts: {
                        end: "(\\s*/)?",
                        relevance: 0
                    }
                }),
                {
                    className: "string",
                    variants: [
                        {
                            begin: /'''/,
                            end: /'''/,
                            contains: [
                                n.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /'/,
                            end: /'/,
                            contains: [
                                n.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /"""/,
                            end: /"""/,
                            contains: [
                                n.BACKSLASH_ESCAPE,
                                s
                            ]
                        },
                        {
                            begin: /"/,
                            end: /"/,
                            contains: [
                                n.BACKSLASH_ESCAPE,
                                s
                            ]
                        }
                    ]
                },
                {
                    className: "regexp",
                    variants: [
                        {
                            begin: "///",
                            end: "///",
                            contains: [
                                s,
                                n.HASH_COMMENT_MODE
                            ]
                        },
                        {
                            begin: "//[gim]{0,3}(?=\\W)",
                            relevance: 0
                        },
                        {
                            begin: /\/(?![ *]).*?(?![\\]).\/[gim]{0,3}(?=\W)/
                        }
                    ]
                },
                {
                    begin: "@" + o
                },
                {
                    subLanguage: "javascript",
                    excludeBegin: !0,
                    excludeEnd: !0,
                    variants: [
                        {
                            begin: "```",
                            end: "```"
                        },
                        {
                            begin: "`",
                            end: "`"
                        }
                    ]
                }
            ];
            s.contains = l;
            const c = n.inherit(n.TITLE_MODE, {
                begin: o
            }), _ = "(\\(.*\\)\\s*)?\\B[-=]>", d = {
                className: "params",
                begin: "\\([^\\(]",
                returnBegin: !0,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: i,
                        contains: [
                            "self"
                        ].concat(l)
                    }
                ]
            }, m = {
                variants: [
                    {
                        match: [
                            /class\s+/,
                            o,
                            /\s+extends\s+/,
                            o
                        ]
                    },
                    {
                        match: [
                            /class\s+/,
                            o
                        ]
                    }
                ],
                scope: {
                    2: "title.class",
                    4: "title.class.inherited"
                },
                keywords: i
            };
            return {
                name: "CoffeeScript",
                aliases: [
                    "coffee",
                    "cson",
                    "iced"
                ],
                keywords: i,
                illegal: /\/\*/,
                contains: [
                    ...l,
                    n.COMMENT("###", "###"),
                    n.HASH_COMMENT_MODE,
                    {
                        className: "function",
                        begin: "^\\s*" + o + "\\s*=\\s*" + _,
                        end: "[-=]>",
                        returnBegin: !0,
                        contains: [
                            c,
                            d
                        ]
                    },
                    {
                        begin: /[:\(,=]\s*/,
                        relevance: 0,
                        contains: [
                            {
                                className: "function",
                                begin: _,
                                end: "[-=]>",
                                returnBegin: !0,
                                contains: [
                                    d
                                ]
                            }
                        ]
                    },
                    m,
                    {
                        begin: o + ":",
                        end: ":",
                        returnBegin: !0,
                        returnEnd: !0,
                        relevance: 0
                    }
                ]
            };
        }, Tt;
    }()), Cs.registerLanguage("coq", (Rt || (Rt = 1, ft = function(e) {
        return {
            name: "Coq",
            keywords: {
                keyword: [
                    "_|0",
                    "as",
                    "at",
                    "cofix",
                    "else",
                    "end",
                    "exists",
                    "exists2",
                    "fix",
                    "for",
                    "forall",
                    "fun",
                    "if",
                    "IF",
                    "in",
                    "let",
                    "match",
                    "mod",
                    "Prop",
                    "return",
                    "Set",
                    "then",
                    "Type",
                    "using",
                    "where",
                    "with",
                    "Abort",
                    "About",
                    "Add",
                    "Admit",
                    "Admitted",
                    "All",
                    "Arguments",
                    "Assumptions",
                    "Axiom",
                    "Back",
                    "BackTo",
                    "Backtrack",
                    "Bind",
                    "Blacklist",
                    "Canonical",
                    "Cd",
                    "Check",
                    "Class",
                    "Classes",
                    "Close",
                    "Coercion",
                    "Coercions",
                    "CoFixpoint",
                    "CoInductive",
                    "Collection",
                    "Combined",
                    "Compute",
                    "Conjecture",
                    "Conjectures",
                    "Constant",
                    "constr",
                    "Constraint",
                    "Constructors",
                    "Context",
                    "Corollary",
                    "CreateHintDb",
                    "Cut",
                    "Declare",
                    "Defined",
                    "Definition",
                    "Delimit",
                    "Dependencies",
                    "Dependent",
                    "Derive",
                    "Drop",
                    "eauto",
                    "End",
                    "Equality",
                    "Eval",
                    "Example",
                    "Existential",
                    "Existentials",
                    "Existing",
                    "Export",
                    "exporting",
                    "Extern",
                    "Extract",
                    "Extraction",
                    "Fact",
                    "Field",
                    "Fields",
                    "File",
                    "Fixpoint",
                    "Focus",
                    "for",
                    "From",
                    "Function",
                    "Functional",
                    "Generalizable",
                    "Global",
                    "Goal",
                    "Grab",
                    "Grammar",
                    "Graph",
                    "Guarded",
                    "Heap",
                    "Hint",
                    "HintDb",
                    "Hints",
                    "Hypotheses",
                    "Hypothesis",
                    "ident",
                    "Identity",
                    "If",
                    "Immediate",
                    "Implicit",
                    "Import",
                    "Include",
                    "Inductive",
                    "Infix",
                    "Info",
                    "Initial",
                    "Inline",
                    "Inspect",
                    "Instance",
                    "Instances",
                    "Intro",
                    "Intros",
                    "Inversion",
                    "Inversion_clear",
                    "Language",
                    "Left",
                    "Lemma",
                    "Let",
                    "Libraries",
                    "Library",
                    "Load",
                    "LoadPath",
                    "Local",
                    "Locate",
                    "Ltac",
                    "ML",
                    "Mode",
                    "Module",
                    "Modules",
                    "Monomorphic",
                    "Morphism",
                    "Next",
                    "NoInline",
                    "Notation",
                    "Obligation",
                    "Obligations",
                    "Opaque",
                    "Open",
                    "Optimize",
                    "Options",
                    "Parameter",
                    "Parameters",
                    "Parametric",
                    "Path",
                    "Paths",
                    "pattern",
                    "Polymorphic",
                    "Preterm",
                    "Print",
                    "Printing",
                    "Program",
                    "Projections",
                    "Proof",
                    "Proposition",
                    "Pwd",
                    "Qed",
                    "Quit",
                    "Rec",
                    "Record",
                    "Recursive",
                    "Redirect",
                    "Relation",
                    "Remark",
                    "Remove",
                    "Require",
                    "Reserved",
                    "Reset",
                    "Resolve",
                    "Restart",
                    "Rewrite",
                    "Right",
                    "Ring",
                    "Rings",
                    "Save",
                    "Scheme",
                    "Scope",
                    "Scopes",
                    "Script",
                    "Search",
                    "SearchAbout",
                    "SearchHead",
                    "SearchPattern",
                    "SearchRewrite",
                    "Section",
                    "Separate",
                    "Set",
                    "Setoid",
                    "Show",
                    "Solve",
                    "Sorted",
                    "Step",
                    "Strategies",
                    "Strategy",
                    "Structure",
                    "SubClass",
                    "Table",
                    "Tables",
                    "Tactic",
                    "Term",
                    "Test",
                    "Theorem",
                    "Time",
                    "Timeout",
                    "Transparent",
                    "Type",
                    "Typeclasses",
                    "Types",
                    "Undelimit",
                    "Undo",
                    "Unfocus",
                    "Unfocused",
                    "Unfold",
                    "Universe",
                    "Universes",
                    "Unset",
                    "Unshelve",
                    "using",
                    "Variable",
                    "Variables",
                    "Variant",
                    "Verbose",
                    "Visibility",
                    "where",
                    "with"
                ],
                built_in: [
                    "abstract",
                    "absurd",
                    "admit",
                    "after",
                    "apply",
                    "as",
                    "assert",
                    "assumption",
                    "at",
                    "auto",
                    "autorewrite",
                    "autounfold",
                    "before",
                    "bottom",
                    "btauto",
                    "by",
                    "case",
                    "case_eq",
                    "cbn",
                    "cbv",
                    "change",
                    "classical_left",
                    "classical_right",
                    "clear",
                    "clearbody",
                    "cofix",
                    "compare",
                    "compute",
                    "congruence",
                    "constr_eq",
                    "constructor",
                    "contradict",
                    "contradiction",
                    "cut",
                    "cutrewrite",
                    "cycle",
                    "decide",
                    "decompose",
                    "dependent",
                    "destruct",
                    "destruction",
                    "dintuition",
                    "discriminate",
                    "discrR",
                    "do",
                    "double",
                    "dtauto",
                    "eapply",
                    "eassumption",
                    "eauto",
                    "ecase",
                    "econstructor",
                    "edestruct",
                    "ediscriminate",
                    "eelim",
                    "eexact",
                    "eexists",
                    "einduction",
                    "einjection",
                    "eleft",
                    "elim",
                    "elimtype",
                    "enough",
                    "equality",
                    "erewrite",
                    "eright",
                    "esimplify_eq",
                    "esplit",
                    "evar",
                    "exact",
                    "exactly_once",
                    "exfalso",
                    "exists",
                    "f_equal",
                    "fail",
                    "field",
                    "field_simplify",
                    "field_simplify_eq",
                    "first",
                    "firstorder",
                    "fix",
                    "fold",
                    "fourier",
                    "functional",
                    "generalize",
                    "generalizing",
                    "gfail",
                    "give_up",
                    "has_evar",
                    "hnf",
                    "idtac",
                    "in",
                    "induction",
                    "injection",
                    "instantiate",
                    "intro",
                    "intro_pattern",
                    "intros",
                    "intuition",
                    "inversion",
                    "inversion_clear",
                    "is_evar",
                    "is_var",
                    "lapply",
                    "lazy",
                    "left",
                    "lia",
                    "lra",
                    "move",
                    "native_compute",
                    "nia",
                    "nsatz",
                    "omega",
                    "once",
                    "pattern",
                    "pose",
                    "progress",
                    "proof",
                    "psatz",
                    "quote",
                    "record",
                    "red",
                    "refine",
                    "reflexivity",
                    "remember",
                    "rename",
                    "repeat",
                    "replace",
                    "revert",
                    "revgoals",
                    "rewrite",
                    "rewrite_strat",
                    "right",
                    "ring",
                    "ring_simplify",
                    "rtauto",
                    "set",
                    "setoid_reflexivity",
                    "setoid_replace",
                    "setoid_rewrite",
                    "setoid_symmetry",
                    "setoid_transitivity",
                    "shelve",
                    "shelve_unifiable",
                    "simpl",
                    "simple",
                    "simplify_eq",
                    "solve",
                    "specialize",
                    "split",
                    "split_Rabs",
                    "split_Rmult",
                    "stepl",
                    "stepr",
                    "subst",
                    "sum",
                    "swap",
                    "symmetry",
                    "tactic",
                    "tauto",
                    "time",
                    "timeout",
                    "top",
                    "transitivity",
                    "trivial",
                    "try",
                    "tryif",
                    "unfold",
                    "unify",
                    "until",
                    "using",
                    "vm_compute",
                    "with"
                ]
            },
            contains: [
                e.QUOTE_STRING_MODE,
                e.COMMENT("\\(\\*", "\\*\\)"),
                e.C_NUMBER_MODE,
                {
                    className: "type",
                    excludeBegin: !0,
                    begin: "\\|\\s*",
                    end: "\\w+"
                },
                {
                    begin: /[-=]>/
                }
            ]
        };
    }), ft)), Cs.registerLanguage("cos", (Ot || (Ot = 1, Nt = function(e) {
        return {
            name: "Cach\xe9 Object Script",
            case_insensitive: !0,
            aliases: [
                "cls"
            ],
            keywords: "property parameter class classmethod clientmethod extends as break catch close continue do d|0 else elseif for goto halt hang h|0 if job j|0 kill k|0 lock l|0 merge new open quit q|0 read r|0 return set s|0 tcommit throw trollback try tstart use view while write w|0 xecute x|0 zkill znspace zn ztrap zwrite zw zzdump zzwrite print zbreak zinsert zload zprint zremove zsave zzprint mv mvcall mvcrt mvdim mvprint zquit zsync ascii",
            contains: [
                {
                    className: "number",
                    begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)",
                    relevance: 0
                },
                {
                    className: "string",
                    variants: [
                        {
                            begin: '"',
                            end: '"',
                            contains: [
                                {
                                    begin: '""',
                                    relevance: 0
                                }
                            ]
                        }
                    ]
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "comment",
                    begin: /;/,
                    end: "$",
                    relevance: 0
                },
                {
                    className: "built_in",
                    begin: /(?:\$\$?|\.\.)\^?[a-zA-Z]+/
                },
                {
                    className: "built_in",
                    begin: /\$\$\$[a-zA-Z]+/
                },
                {
                    className: "built_in",
                    begin: /%[a-z]+(?:\.[a-z]+)*/
                },
                {
                    className: "symbol",
                    begin: /\^%?[a-zA-Z][\w]*/
                },
                {
                    className: "keyword",
                    begin: /##class|##super|#define|#dim/
                },
                {
                    begin: /&sql\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    subLanguage: "sql"
                },
                {
                    begin: /&(js|jscript|javascript)</,
                    end: />/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    subLanguage: "javascript"
                },
                {
                    begin: /&html<\s*</,
                    end: />\s*>/,
                    subLanguage: "xml"
                }
            ]
        };
    }), Nt)), Cs.registerLanguage("cpp", (vt || (vt = 1, ht = function(e) {
        const t = e.regex, a = e.COMMENT("//", "$", {
            contains: [
                {
                    begin: /\\\n/
                }
            ]
        }), n = "decltype\\(auto\\)", i = "[a-zA-Z_]\\w*::", r = "(?!struct)(" + n + "|" + t.optional(i) + "[a-zA-Z_]\\w*" + t.optional("<[^<>]+>") + ")", o = {
            className: "type",
            begin: "\\b[a-z\\d_]*_t\\b"
        }, s = {
            className: "string",
            variants: [
                {
                    begin: '(u8?|U|L)?"',
                    end: '"',
                    illegal: "\\n",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: "(u8?|U|L)?'(\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)|.)",
                    end: "'",
                    illegal: "."
                },
                e.END_SAME_AS_BEGIN({
                    begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
                    end: /\)([^()\\ ]{0,16})"/
                })
            ]
        }, l = {
            className: "number",
            variants: [
                {
                    begin: "\\b(0b[01']+)"
                },
                {
                    begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)"
                },
                {
                    begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
                }
            ],
            relevance: 0
        }, c = {
            className: "meta",
            begin: /#\s*[a-z]+\b/,
            end: /$/,
            keywords: {
                keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include"
            },
            contains: [
                {
                    begin: /\\\n/,
                    relevance: 0
                },
                e.inherit(s, {
                    className: "string"
                }),
                {
                    className: "string",
                    begin: /<.*?>/
                },
                a,
                e.C_BLOCK_COMMENT_MODE
            ]
        }, _ = {
            className: "title",
            begin: t.optional(i) + e.IDENT_RE,
            relevance: 0
        }, d = t.optional(i) + e.IDENT_RE + "\\s*\\(", m = {
            type: [
                "bool",
                "char",
                "char16_t",
                "char32_t",
                "char8_t",
                "double",
                "float",
                "int",
                "long",
                "short",
                "void",
                "wchar_t",
                "unsigned",
                "signed",
                "const",
                "static"
            ],
            keyword: [
                "alignas",
                "alignof",
                "and",
                "and_eq",
                "asm",
                "atomic_cancel",
                "atomic_commit",
                "atomic_noexcept",
                "auto",
                "bitand",
                "bitor",
                "break",
                "case",
                "catch",
                "class",
                "co_await",
                "co_return",
                "co_yield",
                "compl",
                "concept",
                "const_cast|10",
                "consteval",
                "constexpr",
                "constinit",
                "continue",
                "decltype",
                "default",
                "delete",
                "do",
                "dynamic_cast|10",
                "else",
                "enum",
                "explicit",
                "export",
                "extern",
                "false",
                "final",
                "for",
                "friend",
                "goto",
                "if",
                "import",
                "inline",
                "module",
                "mutable",
                "namespace",
                "new",
                "noexcept",
                "not",
                "not_eq",
                "nullptr",
                "operator",
                "or",
                "or_eq",
                "override",
                "private",
                "protected",
                "public",
                "reflexpr",
                "register",
                "reinterpret_cast|10",
                "requires",
                "return",
                "sizeof",
                "static_assert",
                "static_cast|10",
                "struct",
                "switch",
                "synchronized",
                "template",
                "this",
                "thread_local",
                "throw",
                "transaction_safe",
                "transaction_safe_dynamic",
                "true",
                "try",
                "typedef",
                "typeid",
                "typename",
                "union",
                "using",
                "virtual",
                "volatile",
                "while",
                "xor",
                "xor_eq"
            ],
            literal: [
                "NULL",
                "false",
                "nullopt",
                "nullptr",
                "true"
            ],
            built_in: [
                "_Pragma"
            ],
            _type_hints: [
                "any",
                "auto_ptr",
                "barrier",
                "binary_semaphore",
                "bitset",
                "complex",
                "condition_variable",
                "condition_variable_any",
                "counting_semaphore",
                "deque",
                "false_type",
                "future",
                "imaginary",
                "initializer_list",
                "istringstream",
                "jthread",
                "latch",
                "lock_guard",
                "multimap",
                "multiset",
                "mutex",
                "optional",
                "ostringstream",
                "packaged_task",
                "pair",
                "promise",
                "priority_queue",
                "queue",
                "recursive_mutex",
                "recursive_timed_mutex",
                "scoped_lock",
                "set",
                "shared_future",
                "shared_lock",
                "shared_mutex",
                "shared_timed_mutex",
                "shared_ptr",
                "stack",
                "string_view",
                "stringstream",
                "timed_mutex",
                "thread",
                "true_type",
                "tuple",
                "unique_lock",
                "unique_ptr",
                "unordered_map",
                "unordered_multimap",
                "unordered_multiset",
                "unordered_set",
                "variant",
                "vector",
                "weak_ptr",
                "wstring",
                "wstring_view"
            ]
        }, p = {
            className: "function.dispatch",
            relevance: 0,
            keywords: {
                _hint: [
                    "abort",
                    "abs",
                    "acos",
                    "apply",
                    "as_const",
                    "asin",
                    "atan",
                    "atan2",
                    "calloc",
                    "ceil",
                    "cerr",
                    "cin",
                    "clog",
                    "cos",
                    "cosh",
                    "cout",
                    "declval",
                    "endl",
                    "exchange",
                    "exit",
                    "exp",
                    "fabs",
                    "floor",
                    "fmod",
                    "forward",
                    "fprintf",
                    "fputs",
                    "free",
                    "frexp",
                    "fscanf",
                    "future",
                    "invoke",
                    "isalnum",
                    "isalpha",
                    "iscntrl",
                    "isdigit",
                    "isgraph",
                    "islower",
                    "isprint",
                    "ispunct",
                    "isspace",
                    "isupper",
                    "isxdigit",
                    "labs",
                    "launder",
                    "ldexp",
                    "log",
                    "log10",
                    "make_pair",
                    "make_shared",
                    "make_shared_for_overwrite",
                    "make_tuple",
                    "make_unique",
                    "malloc",
                    "memchr",
                    "memcmp",
                    "memcpy",
                    "memset",
                    "modf",
                    "move",
                    "pow",
                    "printf",
                    "putchar",
                    "puts",
                    "realloc",
                    "scanf",
                    "sin",
                    "sinh",
                    "snprintf",
                    "sprintf",
                    "sqrt",
                    "sscanf",
                    "std",
                    "stderr",
                    "stdin",
                    "stdout",
                    "strcat",
                    "strchr",
                    "strcmp",
                    "strcpy",
                    "strcspn",
                    "strlen",
                    "strncat",
                    "strncmp",
                    "strncpy",
                    "strpbrk",
                    "strrchr",
                    "strspn",
                    "strstr",
                    "swap",
                    "tan",
                    "tanh",
                    "terminate",
                    "to_underlying",
                    "tolower",
                    "toupper",
                    "vfprintf",
                    "visit",
                    "vprintf",
                    "vsprintf"
                ]
            },
            begin: t.concat(/\b/, /(?!decltype)/, /(?!if)/, /(?!for)/, /(?!switch)/, /(?!while)/, e.IDENT_RE, t.lookahead(/(<[^<>]+>|)\s*\(/))
        }, u = [
            p,
            c,
            o,
            a,
            e.C_BLOCK_COMMENT_MODE,
            l,
            s
        ], g = {
            variants: [
                {
                    begin: /=/,
                    end: /;/
                },
                {
                    begin: /\(/,
                    end: /\)/
                },
                {
                    beginKeywords: "new throw return else",
                    end: /;/
                }
            ],
            keywords: m,
            contains: u.concat([
                {
                    begin: /\(/,
                    end: /\)/,
                    keywords: m,
                    contains: u.concat([
                        "self"
                    ]),
                    relevance: 0
                }
            ]),
            relevance: 0
        }, E = {
            className: "function",
            begin: "(" + r + "[\\*&\\s]+)+" + d,
            returnBegin: !0,
            end: /[{;=]/,
            excludeEnd: !0,
            keywords: m,
            illegal: /[^\w\s\*&:<>.]/,
            contains: [
                {
                    begin: n,
                    keywords: m,
                    relevance: 0
                },
                {
                    begin: d,
                    returnBegin: !0,
                    contains: [
                        _
                    ],
                    relevance: 0
                },
                {
                    begin: /::/,
                    relevance: 0
                },
                {
                    begin: /:/,
                    endsWithParent: !0,
                    contains: [
                        s,
                        l
                    ]
                },
                {
                    relevance: 0,
                    match: /,/
                },
                {
                    className: "params",
                    begin: /\(/,
                    end: /\)/,
                    keywords: m,
                    relevance: 0,
                    contains: [
                        a,
                        e.C_BLOCK_COMMENT_MODE,
                        s,
                        l,
                        o,
                        {
                            begin: /\(/,
                            end: /\)/,
                            keywords: m,
                            relevance: 0,
                            contains: [
                                "self",
                                a,
                                e.C_BLOCK_COMMENT_MODE,
                                s,
                                l,
                                o
                            ]
                        }
                    ]
                },
                o,
                a,
                e.C_BLOCK_COMMENT_MODE,
                c
            ]
        };
        return {
            name: "C++",
            aliases: [
                "cc",
                "c++",
                "h++",
                "hpp",
                "hh",
                "hxx",
                "cxx"
            ],
            keywords: m,
            illegal: "</",
            classNameAliases: {
                "function.dispatch": "built_in"
            },
            contains: [].concat(g, E, p, u, [
                c,
                {
                    begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function)\\s*<(?!<)",
                    end: ">",
                    keywords: m,
                    contains: [
                        "self",
                        o
                    ]
                },
                {
                    begin: e.IDENT_RE + "::",
                    keywords: m
                },
                {
                    match: [
                        /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
                        /\s+/,
                        /\w+/
                    ],
                    className: {
                        1: "keyword",
                        3: "title.class"
                    }
                }
            ])
        };
    }), ht)), Cs.registerLanguage("crmsh", (At || (At = 1, It = function(e) {
        const t = "group clone ms master location colocation order fencing_topology rsc_ticket acl_target acl_group user role tag xml";
        return {
            name: "crmsh",
            aliases: [
                "crm",
                "pcmk"
            ],
            case_insensitive: !0,
            keywords: {
                keyword: "params meta operations op rule attributes utilization read write deny defined not_defined in_range date spec in ref reference attribute type xpath version and or lt gt tag lte gte eq ne \\ number string",
                literal: "Master Started Slave Stopped start promote demote stop monitor true false"
            },
            contains: [
                e.HASH_COMMENT_MODE,
                {
                    beginKeywords: "node",
                    starts: {
                        end: "\\s*([\\w_-]+:)?",
                        starts: {
                            className: "title",
                            end: "\\s*[\\$\\w_][\\w_-]*"
                        }
                    }
                },
                {
                    beginKeywords: "primitive rsc_template",
                    starts: {
                        className: "title",
                        end: "\\s*[\\$\\w_][\\w_-]*",
                        starts: {
                            end: "\\s*@?[\\w_][\\w_\\.:-]*"
                        }
                    }
                },
                {
                    begin: "\\b(" + t.split(" ").join("|") + ")\\s+",
                    keywords: t,
                    starts: {
                        className: "title",
                        end: "[\\$\\w_][\\w_-]*"
                    }
                },
                {
                    beginKeywords: "property rsc_defaults op_defaults",
                    starts: {
                        className: "title",
                        end: "\\s*([\\w_-]+:)?"
                    }
                },
                e.QUOTE_STRING_MODE,
                {
                    className: "meta",
                    begin: "(ocf|systemd|service|lsb):[\\w_:-]+",
                    relevance: 0
                },
                {
                    className: "number",
                    begin: "\\b\\d+(\\.\\d+)?(ms|s|h|m)?",
                    relevance: 0
                },
                {
                    className: "literal",
                    begin: "[-]?(infinity|inf)",
                    relevance: 0
                },
                {
                    className: "attr",
                    begin: /([A-Za-z$_#][\w_-]+)=/,
                    relevance: 0
                },
                {
                    className: "tag",
                    begin: "</?",
                    end: "/?>",
                    relevance: 0
                }
            ]
        };
    }), It)), Cs.registerLanguage("crystal", (Dt || (Dt = 1, yt = function(e) {
        const t = "(_?[ui](8|16|32|64|128))?", a = "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|[=!]~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~|]|//|//=|&[-+*]=?|&\\*\\*|\\[\\][=?]?", n = "[A-Za-z_]\\w*(::\\w+)*(\\?|!)?", i = {
            $pattern: "[a-zA-Z_]\\w*[!?=]?",
            keyword: "abstract alias annotation as as? asm begin break case class def do else elsif end ensure enum extend for fun if include instance_sizeof is_a? lib macro module next nil? of out pointerof private protected rescue responds_to? return require select self sizeof struct super then type typeof union uninitialized unless until verbatim when while with yield __DIR__ __END_LINE__ __FILE__ __LINE__",
            literal: "false nil true"
        }, r = {
            className: "subst",
            begin: /#\{/,
            end: /\}/,
            keywords: i
        }, o = {
            className: "variable",
            begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"
        }, s = {
            className: "template-variable",
            variants: [
                {
                    begin: "\\{\\{",
                    end: "\\}\\}"
                },
                {
                    begin: "\\{%",
                    end: "%\\}"
                }
            ],
            keywords: i
        };
        function l(e, t) {
            const a = [
                {
                    begin: e,
                    end: t
                }
            ];
            return a[0].contains = a, a;
        }
        const c = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE,
                r
            ],
            variants: [
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /"/,
                    end: /"/
                },
                {
                    begin: /`/,
                    end: /`/
                },
                {
                    begin: "%[Qwi]?\\(",
                    end: "\\)",
                    contains: l("\\(", "\\)")
                },
                {
                    begin: "%[Qwi]?\\[",
                    end: "\\]",
                    contains: l("\\[", "\\]")
                },
                {
                    begin: "%[Qwi]?\\{",
                    end: /\}/,
                    contains: l(/\{/, /\}/)
                },
                {
                    begin: "%[Qwi]?<",
                    end: ">",
                    contains: l("<", ">")
                },
                {
                    begin: "%[Qwi]?\\|",
                    end: "\\|"
                },
                {
                    begin: /<<-\w+$/,
                    end: /^\s*\w+$/
                }
            ],
            relevance: 0
        }, _ = {
            className: "string",
            variants: [
                {
                    begin: "%q\\(",
                    end: "\\)",
                    contains: l("\\(", "\\)")
                },
                {
                    begin: "%q\\[",
                    end: "\\]",
                    contains: l("\\[", "\\]")
                },
                {
                    begin: "%q\\{",
                    end: /\}/,
                    contains: l(/\{/, /\}/)
                },
                {
                    begin: "%q<",
                    end: ">",
                    contains: l("<", ">")
                },
                {
                    begin: "%q\\|",
                    end: "\\|"
                },
                {
                    begin: /<<-'\w+'$/,
                    end: /^\s*\w+$/
                }
            ],
            relevance: 0
        }, d = {
            begin: "(?!%\\})(" + e.RE_STARTERS_RE + "|\\n|\\b(case|if|select|unless|until|when|while)\\b)\\s*",
            keywords: "case if select unless until when while",
            contains: [
                {
                    className: "regexp",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        r
                    ],
                    variants: [
                        {
                            begin: "//[a-z]*",
                            relevance: 0
                        },
                        {
                            begin: "/(?!\\/)",
                            end: "/[a-z]*"
                        }
                    ]
                }
            ],
            relevance: 0
        }, m = [
            s,
            c,
            _,
            {
                className: "regexp",
                contains: [
                    e.BACKSLASH_ESCAPE,
                    r
                ],
                variants: [
                    {
                        begin: "%r\\(",
                        end: "\\)",
                        contains: l("\\(", "\\)")
                    },
                    {
                        begin: "%r\\[",
                        end: "\\]",
                        contains: l("\\[", "\\]")
                    },
                    {
                        begin: "%r\\{",
                        end: /\}/,
                        contains: l(/\{/, /\}/)
                    },
                    {
                        begin: "%r<",
                        end: ">",
                        contains: l("<", ">")
                    },
                    {
                        begin: "%r\\|",
                        end: "\\|"
                    }
                ],
                relevance: 0
            },
            d,
            {
                className: "meta",
                begin: "@\\[",
                end: "\\]",
                contains: [
                    e.inherit(e.QUOTE_STRING_MODE, {
                        className: "string"
                    })
                ]
            },
            o,
            e.HASH_COMMENT_MODE,
            {
                className: "class",
                beginKeywords: "class module struct",
                end: "$|;",
                illegal: /=/,
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.inherit(e.TITLE_MODE, {
                        begin: n
                    }),
                    {
                        begin: "<"
                    }
                ]
            },
            {
                className: "class",
                beginKeywords: "lib enum union",
                end: "$|;",
                illegal: /=/,
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.inherit(e.TITLE_MODE, {
                        begin: n
                    })
                ]
            },
            {
                beginKeywords: "annotation",
                end: "$|;",
                illegal: /=/,
                contains: [
                    e.HASH_COMMENT_MODE,
                    e.inherit(e.TITLE_MODE, {
                        begin: n
                    })
                ],
                relevance: 2
            },
            {
                className: "function",
                beginKeywords: "def",
                end: /\B\b/,
                contains: [
                    e.inherit(e.TITLE_MODE, {
                        begin: a,
                        endsParent: !0
                    })
                ]
            },
            {
                className: "function",
                beginKeywords: "fun macro",
                end: /\B\b/,
                contains: [
                    e.inherit(e.TITLE_MODE, {
                        begin: a,
                        endsParent: !0
                    })
                ],
                relevance: 2
            },
            {
                className: "symbol",
                begin: e.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
                relevance: 0
            },
            {
                className: "symbol",
                begin: ":",
                contains: [
                    c,
                    {
                        begin: a
                    }
                ],
                relevance: 0
            },
            {
                className: "number",
                variants: [
                    {
                        begin: "\\b0b([01_]+)" + t
                    },
                    {
                        begin: "\\b0o([0-7_]+)" + t
                    },
                    {
                        begin: "\\b0x([A-Fa-f0-9_]+)" + t
                    },
                    {
                        begin: "\\b([1-9][0-9_]*[0-9]|[0-9])(\\.[0-9][0-9_]*)?([eE]_?[-+]?[0-9_]*)?(_?f(32|64))?(?!_)"
                    },
                    {
                        begin: "\\b([1-9][0-9_]*|0)" + t
                    }
                ],
                relevance: 0
            }
        ];
        return r.contains = m, s.contains = m.slice(1), {
            name: "Crystal",
            aliases: [
                "cr"
            ],
            keywords: i,
            contains: m
        };
    }), yt)), Cs.registerLanguage("csharp", (Lt || (Lt = 1, Mt = function(e) {
        const t = {
            keyword: [
                "abstract",
                "as",
                "base",
                "break",
                "case",
                "catch",
                "class",
                "const",
                "continue",
                "do",
                "else",
                "event",
                "explicit",
                "extern",
                "finally",
                "fixed",
                "for",
                "foreach",
                "goto",
                "if",
                "implicit",
                "in",
                "interface",
                "internal",
                "is",
                "lock",
                "namespace",
                "new",
                "operator",
                "out",
                "override",
                "params",
                "private",
                "protected",
                "public",
                "readonly",
                "record",
                "ref",
                "return",
                "scoped",
                "sealed",
                "sizeof",
                "stackalloc",
                "static",
                "struct",
                "switch",
                "this",
                "throw",
                "try",
                "typeof",
                "unchecked",
                "unsafe",
                "using",
                "virtual",
                "void",
                "volatile",
                "while"
            ].concat([
                "add",
                "alias",
                "and",
                "ascending",
                "async",
                "await",
                "by",
                "descending",
                "equals",
                "from",
                "get",
                "global",
                "group",
                "init",
                "into",
                "join",
                "let",
                "nameof",
                "not",
                "notnull",
                "on",
                "or",
                "orderby",
                "partial",
                "remove",
                "select",
                "set",
                "unmanaged",
                "value|0",
                "var",
                "when",
                "where",
                "with",
                "yield"
            ]),
            built_in: [
                "bool",
                "byte",
                "char",
                "decimal",
                "delegate",
                "double",
                "dynamic",
                "enum",
                "float",
                "int",
                "long",
                "nint",
                "nuint",
                "object",
                "sbyte",
                "short",
                "string",
                "ulong",
                "uint",
                "ushort"
            ],
            literal: [
                "default",
                "false",
                "null",
                "true"
            ]
        }, a = e.inherit(e.TITLE_MODE, {
            begin: "[a-zA-Z](\\.?\\w)*"
        }), n = {
            className: "number",
            variants: [
                {
                    begin: "\\b(0b[01']+)"
                },
                {
                    begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)"
                },
                {
                    begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)"
                }
            ],
            relevance: 0
        }, i = {
            className: "string",
            begin: '@"',
            end: '"',
            contains: [
                {
                    begin: '""'
                }
            ]
        }, r = e.inherit(i, {
            illegal: /\n/
        }), o = {
            className: "subst",
            begin: /\{/,
            end: /\}/,
            keywords: t
        }, s = e.inherit(o, {
            illegal: /\n/
        }), l = {
            className: "string",
            begin: /\$"/,
            end: '"',
            illegal: /\n/,
            contains: [
                {
                    begin: /\{\{/
                },
                {
                    begin: /\}\}/
                },
                e.BACKSLASH_ESCAPE,
                s
            ]
        }, c = {
            className: "string",
            begin: /\$@"/,
            end: '"',
            contains: [
                {
                    begin: /\{\{/
                },
                {
                    begin: /\}\}/
                },
                {
                    begin: '""'
                },
                o
            ]
        }, _ = e.inherit(c, {
            illegal: /\n/,
            contains: [
                {
                    begin: /\{\{/
                },
                {
                    begin: /\}\}/
                },
                {
                    begin: '""'
                },
                s
            ]
        });
        o.contains = [
            c,
            l,
            i,
            e.APOS_STRING_MODE,
            e.QUOTE_STRING_MODE,
            n,
            e.C_BLOCK_COMMENT_MODE
        ], s.contains = [
            _,
            l,
            r,
            e.APOS_STRING_MODE,
            e.QUOTE_STRING_MODE,
            n,
            e.inherit(e.C_BLOCK_COMMENT_MODE, {
                illegal: /\n/
            })
        ];
        const d = {
            variants: [
                c,
                l,
                i,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE
            ]
        }, m = {
            begin: "<",
            end: ">",
            contains: [
                {
                    beginKeywords: "in out"
                },
                a
            ]
        }, p = e.IDENT_RE + "(<" + e.IDENT_RE + "(\\s*,\\s*" + e.IDENT_RE + ")*>)?(\\[\\])?", u = {
            begin: "@" + e.IDENT_RE,
            relevance: 0
        };
        return {
            name: "C#",
            aliases: [
                "cs",
                "c#"
            ],
            keywords: t,
            illegal: /::/,
            contains: [
                e.COMMENT("///", "$", {
                    returnBegin: !0,
                    contains: [
                        {
                            className: "doctag",
                            variants: [
                                {
                                    begin: "///",
                                    relevance: 0
                                },
                                {
                                    begin: "\x3c!--|--\x3e"
                                },
                                {
                                    begin: "</?",
                                    end: ">"
                                }
                            ]
                        }
                    ]
                }),
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "meta",
                    begin: "#",
                    end: "$",
                    keywords: {
                        keyword: "if else elif endif define undef warning error line region endregion pragma checksum"
                    }
                },
                d,
                n,
                {
                    beginKeywords: "class interface",
                    relevance: 0,
                    end: /[{;=]/,
                    illegal: /[^\s:,]/,
                    contains: [
                        {
                            beginKeywords: "where class"
                        },
                        a,
                        m,
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                {
                    beginKeywords: "namespace",
                    relevance: 0,
                    end: /[{;=]/,
                    illegal: /[^\s:]/,
                    contains: [
                        a,
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                {
                    beginKeywords: "record",
                    relevance: 0,
                    end: /[{;=]/,
                    illegal: /[^\s:]/,
                    contains: [
                        a,
                        m,
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                {
                    className: "meta",
                    begin: "^\\s*\\[(?=[\\w])",
                    excludeBegin: !0,
                    end: "\\]",
                    excludeEnd: !0,
                    contains: [
                        {
                            className: "string",
                            begin: /"/,
                            end: /"/
                        }
                    ]
                },
                {
                    beginKeywords: "new return throw await else",
                    relevance: 0
                },
                {
                    className: "function",
                    begin: "(" + p + "\\s+)+" + e.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
                    returnBegin: !0,
                    end: /\s*[{;=]/,
                    excludeEnd: !0,
                    keywords: t,
                    contains: [
                        {
                            beginKeywords: [
                                "public",
                                "private",
                                "protected",
                                "static",
                                "internal",
                                "protected",
                                "abstract",
                                "async",
                                "extern",
                                "override",
                                "unsafe",
                                "virtual",
                                "new",
                                "sealed",
                                "partial"
                            ].join(" "),
                            relevance: 0
                        },
                        {
                            begin: e.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
                            returnBegin: !0,
                            contains: [
                                e.TITLE_MODE,
                                m
                            ],
                            relevance: 0
                        },
                        {
                            match: /\(\)/
                        },
                        {
                            className: "params",
                            begin: /\(/,
                            end: /\)/,
                            excludeBegin: !0,
                            excludeEnd: !0,
                            keywords: t,
                            relevance: 0,
                            contains: [
                                d,
                                n,
                                e.C_BLOCK_COMMENT_MODE
                            ]
                        },
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                u
            ]
        };
    }), Mt)), Cs.registerLanguage("csp", wt ? xt : (wt = 1, xt = function(e) {
        return {
            name: "CSP",
            case_insensitive: !1,
            keywords: {
                $pattern: "[a-zA-Z][a-zA-Z0-9_-]*",
                keyword: [
                    "base-uri",
                    "child-src",
                    "connect-src",
                    "default-src",
                    "font-src",
                    "form-action",
                    "frame-ancestors",
                    "frame-src",
                    "img-src",
                    "manifest-src",
                    "media-src",
                    "object-src",
                    "plugin-types",
                    "report-uri",
                    "sandbox",
                    "script-src",
                    "style-src",
                    "trusted-types",
                    "unsafe-hashes",
                    "worker-src"
                ]
            },
            contains: [
                {
                    className: "string",
                    begin: "'",
                    end: "'"
                },
                {
                    className: "attribute",
                    begin: "^Content",
                    end: ":",
                    excludeEnd: !0
                }
            ]
        };
    })), Cs.registerLanguage("css", function() {
        if (kt) return Pt;
        kt = 1;
        const e = [
            "a",
            "abbr",
            "address",
            "article",
            "aside",
            "audio",
            "b",
            "blockquote",
            "body",
            "button",
            "canvas",
            "caption",
            "cite",
            "code",
            "dd",
            "del",
            "details",
            "dfn",
            "div",
            "dl",
            "dt",
            "em",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "html",
            "i",
            "iframe",
            "img",
            "input",
            "ins",
            "kbd",
            "label",
            "legend",
            "li",
            "main",
            "mark",
            "menu",
            "nav",
            "object",
            "ol",
            "p",
            "q",
            "quote",
            "samp",
            "section",
            "span",
            "strong",
            "summary",
            "sup",
            "table",
            "tbody",
            "td",
            "textarea",
            "tfoot",
            "th",
            "thead",
            "time",
            "tr",
            "ul",
            "var",
            "video"
        ], t = [
            "any-hover",
            "any-pointer",
            "aspect-ratio",
            "color",
            "color-gamut",
            "color-index",
            "device-aspect-ratio",
            "device-height",
            "device-width",
            "display-mode",
            "forced-colors",
            "grid",
            "height",
            "hover",
            "inverted-colors",
            "monochrome",
            "orientation",
            "overflow-block",
            "overflow-inline",
            "pointer",
            "prefers-color-scheme",
            "prefers-contrast",
            "prefers-reduced-motion",
            "prefers-reduced-transparency",
            "resolution",
            "scan",
            "scripting",
            "update",
            "width",
            "min-width",
            "max-width",
            "min-height",
            "max-height"
        ], a = [
            "active",
            "any-link",
            "blank",
            "checked",
            "current",
            "default",
            "defined",
            "dir",
            "disabled",
            "drop",
            "empty",
            "enabled",
            "first",
            "first-child",
            "first-of-type",
            "fullscreen",
            "future",
            "focus",
            "focus-visible",
            "focus-within",
            "has",
            "host",
            "host-context",
            "hover",
            "indeterminate",
            "in-range",
            "invalid",
            "is",
            "lang",
            "last-child",
            "last-of-type",
            "left",
            "link",
            "local-link",
            "not",
            "nth-child",
            "nth-col",
            "nth-last-child",
            "nth-last-col",
            "nth-last-of-type",
            "nth-of-type",
            "only-child",
            "only-of-type",
            "optional",
            "out-of-range",
            "past",
            "placeholder-shown",
            "read-only",
            "read-write",
            "required",
            "right",
            "root",
            "scope",
            "target",
            "target-within",
            "user-invalid",
            "valid",
            "visited",
            "where"
        ], n = [
            "after",
            "backdrop",
            "before",
            "cue",
            "cue-region",
            "first-letter",
            "first-line",
            "grammar-error",
            "marker",
            "part",
            "placeholder",
            "selection",
            "slotted",
            "spelling-error"
        ], i = [
            "align-content",
            "align-items",
            "align-self",
            "all",
            "animation",
            "animation-delay",
            "animation-direction",
            "animation-duration",
            "animation-fill-mode",
            "animation-iteration-count",
            "animation-name",
            "animation-play-state",
            "animation-timing-function",
            "backface-visibility",
            "background",
            "background-attachment",
            "background-blend-mode",
            "background-clip",
            "background-color",
            "background-image",
            "background-origin",
            "background-position",
            "background-repeat",
            "background-size",
            "block-size",
            "border",
            "border-block",
            "border-block-color",
            "border-block-end",
            "border-block-end-color",
            "border-block-end-style",
            "border-block-end-width",
            "border-block-start",
            "border-block-start-color",
            "border-block-start-style",
            "border-block-start-width",
            "border-block-style",
            "border-block-width",
            "border-bottom",
            "border-bottom-color",
            "border-bottom-left-radius",
            "border-bottom-right-radius",
            "border-bottom-style",
            "border-bottom-width",
            "border-collapse",
            "border-color",
            "border-image",
            "border-image-outset",
            "border-image-repeat",
            "border-image-slice",
            "border-image-source",
            "border-image-width",
            "border-inline",
            "border-inline-color",
            "border-inline-end",
            "border-inline-end-color",
            "border-inline-end-style",
            "border-inline-end-width",
            "border-inline-start",
            "border-inline-start-color",
            "border-inline-start-style",
            "border-inline-start-width",
            "border-inline-style",
            "border-inline-width",
            "border-left",
            "border-left-color",
            "border-left-style",
            "border-left-width",
            "border-radius",
            "border-right",
            "border-right-color",
            "border-right-style",
            "border-right-width",
            "border-spacing",
            "border-style",
            "border-top",
            "border-top-color",
            "border-top-left-radius",
            "border-top-right-radius",
            "border-top-style",
            "border-top-width",
            "border-width",
            "bottom",
            "box-decoration-break",
            "box-shadow",
            "box-sizing",
            "break-after",
            "break-before",
            "break-inside",
            "caption-side",
            "caret-color",
            "clear",
            "clip",
            "clip-path",
            "clip-rule",
            "color",
            "column-count",
            "column-fill",
            "column-gap",
            "column-rule",
            "column-rule-color",
            "column-rule-style",
            "column-rule-width",
            "column-span",
            "column-width",
            "columns",
            "contain",
            "content",
            "content-visibility",
            "counter-increment",
            "counter-reset",
            "cue",
            "cue-after",
            "cue-before",
            "cursor",
            "direction",
            "display",
            "empty-cells",
            "filter",
            "flex",
            "flex-basis",
            "flex-direction",
            "flex-flow",
            "flex-grow",
            "flex-shrink",
            "flex-wrap",
            "float",
            "flow",
            "font",
            "font-display",
            "font-family",
            "font-feature-settings",
            "font-kerning",
            "font-language-override",
            "font-size",
            "font-size-adjust",
            "font-smoothing",
            "font-stretch",
            "font-style",
            "font-synthesis",
            "font-variant",
            "font-variant-caps",
            "font-variant-east-asian",
            "font-variant-ligatures",
            "font-variant-numeric",
            "font-variant-position",
            "font-variation-settings",
            "font-weight",
            "gap",
            "glyph-orientation-vertical",
            "grid",
            "grid-area",
            "grid-auto-columns",
            "grid-auto-flow",
            "grid-auto-rows",
            "grid-column",
            "grid-column-end",
            "grid-column-start",
            "grid-gap",
            "grid-row",
            "grid-row-end",
            "grid-row-start",
            "grid-template",
            "grid-template-areas",
            "grid-template-columns",
            "grid-template-rows",
            "hanging-punctuation",
            "height",
            "hyphens",
            "icon",
            "image-orientation",
            "image-rendering",
            "image-resolution",
            "ime-mode",
            "inline-size",
            "isolation",
            "justify-content",
            "left",
            "letter-spacing",
            "line-break",
            "line-height",
            "list-style",
            "list-style-image",
            "list-style-position",
            "list-style-type",
            "margin",
            "margin-block",
            "margin-block-end",
            "margin-block-start",
            "margin-bottom",
            "margin-inline",
            "margin-inline-end",
            "margin-inline-start",
            "margin-left",
            "margin-right",
            "margin-top",
            "marks",
            "mask",
            "mask-border",
            "mask-border-mode",
            "mask-border-outset",
            "mask-border-repeat",
            "mask-border-slice",
            "mask-border-source",
            "mask-border-width",
            "mask-clip",
            "mask-composite",
            "mask-image",
            "mask-mode",
            "mask-origin",
            "mask-position",
            "mask-repeat",
            "mask-size",
            "mask-type",
            "max-block-size",
            "max-height",
            "max-inline-size",
            "max-width",
            "min-block-size",
            "min-height",
            "min-inline-size",
            "min-width",
            "mix-blend-mode",
            "nav-down",
            "nav-index",
            "nav-left",
            "nav-right",
            "nav-up",
            "none",
            "normal",
            "object-fit",
            "object-position",
            "opacity",
            "order",
            "orphans",
            "outline",
            "outline-color",
            "outline-offset",
            "outline-style",
            "outline-width",
            "overflow",
            "overflow-wrap",
            "overflow-x",
            "overflow-y",
            "padding",
            "padding-block",
            "padding-block-end",
            "padding-block-start",
            "padding-bottom",
            "padding-inline",
            "padding-inline-end",
            "padding-inline-start",
            "padding-left",
            "padding-right",
            "padding-top",
            "page-break-after",
            "page-break-before",
            "page-break-inside",
            "pause",
            "pause-after",
            "pause-before",
            "perspective",
            "perspective-origin",
            "pointer-events",
            "position",
            "quotes",
            "resize",
            "rest",
            "rest-after",
            "rest-before",
            "right",
            "row-gap",
            "scroll-margin",
            "scroll-margin-block",
            "scroll-margin-block-end",
            "scroll-margin-block-start",
            "scroll-margin-bottom",
            "scroll-margin-inline",
            "scroll-margin-inline-end",
            "scroll-margin-inline-start",
            "scroll-margin-left",
            "scroll-margin-right",
            "scroll-margin-top",
            "scroll-padding",
            "scroll-padding-block",
            "scroll-padding-block-end",
            "scroll-padding-block-start",
            "scroll-padding-bottom",
            "scroll-padding-inline",
            "scroll-padding-inline-end",
            "scroll-padding-inline-start",
            "scroll-padding-left",
            "scroll-padding-right",
            "scroll-padding-top",
            "scroll-snap-align",
            "scroll-snap-stop",
            "scroll-snap-type",
            "scrollbar-color",
            "scrollbar-gutter",
            "scrollbar-width",
            "shape-image-threshold",
            "shape-margin",
            "shape-outside",
            "speak",
            "speak-as",
            "src",
            "tab-size",
            "table-layout",
            "text-align",
            "text-align-all",
            "text-align-last",
            "text-combine-upright",
            "text-decoration",
            "text-decoration-color",
            "text-decoration-line",
            "text-decoration-style",
            "text-emphasis",
            "text-emphasis-color",
            "text-emphasis-position",
            "text-emphasis-style",
            "text-indent",
            "text-justify",
            "text-orientation",
            "text-overflow",
            "text-rendering",
            "text-shadow",
            "text-transform",
            "text-underline-position",
            "top",
            "transform",
            "transform-box",
            "transform-origin",
            "transform-style",
            "transition",
            "transition-delay",
            "transition-duration",
            "transition-property",
            "transition-timing-function",
            "unicode-bidi",
            "vertical-align",
            "visibility",
            "voice-balance",
            "voice-duration",
            "voice-family",
            "voice-pitch",
            "voice-range",
            "voice-rate",
            "voice-stress",
            "voice-volume",
            "white-space",
            "widows",
            "width",
            "will-change",
            "word-break",
            "word-spacing",
            "word-wrap",
            "writing-mode",
            "z-index"
        ].reverse();
        return Pt = function(r) {
            const o = r.regex, s = ((e)=>({
                    IMPORTANT: {
                        scope: "meta",
                        begin: "!important"
                    },
                    BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
                    HEXCOLOR: {
                        scope: "number",
                        begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
                    },
                    FUNCTION_DISPATCH: {
                        className: "built_in",
                        begin: /[\w-]+(?=\()/
                    },
                    ATTRIBUTE_SELECTOR_MODE: {
                        scope: "selector-attr",
                        begin: /\[/,
                        end: /\]/,
                        illegal: "$",
                        contains: [
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    CSS_NUMBER_MODE: {
                        scope: "number",
                        begin: e.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
                        relevance: 0
                    },
                    CSS_VARIABLE: {
                        className: "attr",
                        begin: /--[A-Za-z_][A-Za-z0-9_-]*/
                    }
                }))(r), l = [
                r.APOS_STRING_MODE,
                r.QUOTE_STRING_MODE
            ];
            return {
                name: "CSS",
                case_insensitive: !0,
                illegal: /[=|'\$]/,
                keywords: {
                    keyframePosition: "from to"
                },
                classNameAliases: {
                    keyframePosition: "selector-tag"
                },
                contains: [
                    s.BLOCK_COMMENT,
                    {
                        begin: /-(webkit|moz|ms|o)-(?=[a-z])/
                    },
                    s.CSS_NUMBER_MODE,
                    {
                        className: "selector-id",
                        begin: /#[A-Za-z0-9_-]+/,
                        relevance: 0
                    },
                    {
                        className: "selector-class",
                        begin: "\\.[a-zA-Z-][a-zA-Z0-9_-]*",
                        relevance: 0
                    },
                    s.ATTRIBUTE_SELECTOR_MODE,
                    {
                        className: "selector-pseudo",
                        variants: [
                            {
                                begin: ":(" + a.join("|") + ")"
                            },
                            {
                                begin: ":(:)?(" + n.join("|") + ")"
                            }
                        ]
                    },
                    s.CSS_VARIABLE,
                    {
                        className: "attribute",
                        begin: "\\b(" + i.join("|") + ")\\b"
                    },
                    {
                        begin: /:/,
                        end: /[;}{]/,
                        contains: [
                            s.BLOCK_COMMENT,
                            s.HEXCOLOR,
                            s.IMPORTANT,
                            s.CSS_NUMBER_MODE,
                            ...l,
                            {
                                begin: /(url|data-uri)\(/,
                                end: /\)/,
                                relevance: 0,
                                keywords: {
                                    built_in: "url data-uri"
                                },
                                contains: [
                                    ...l,
                                    {
                                        className: "string",
                                        begin: /[^)]/,
                                        endsWithParent: !0,
                                        excludeEnd: !0
                                    }
                                ]
                            },
                            s.FUNCTION_DISPATCH
                        ]
                    },
                    {
                        begin: o.lookahead(/@/),
                        end: "[{;]",
                        relevance: 0,
                        illegal: /:/,
                        contains: [
                            {
                                className: "keyword",
                                begin: /@-?\w[\w]*(-\w+)*/
                            },
                            {
                                begin: /\s/,
                                endsWithParent: !0,
                                excludeEnd: !0,
                                relevance: 0,
                                keywords: {
                                    $pattern: /[a-z-]+/,
                                    keyword: "and or not only",
                                    attribute: t.join(" ")
                                },
                                contains: [
                                    {
                                        begin: /[a-z-]+(?=:)/,
                                        className: "attribute"
                                    },
                                    ...l,
                                    s.CSS_NUMBER_MODE
                                ]
                            }
                        ]
                    },
                    {
                        className: "selector-tag",
                        begin: "\\b(" + e.join("|") + ")\\b"
                    }
                ]
            };
        }, Pt;
    }()), Cs.registerLanguage("d", (Ft || (Ft = 1, Ut = function(e) {
        const t = {
            $pattern: e.UNDERSCORE_IDENT_RE,
            keyword: "abstract alias align asm assert auto body break byte case cast catch class const continue debug default delete deprecated do else enum export extern final finally for foreach foreach_reverse|10 goto if immutable import in inout int interface invariant is lazy macro mixin module new nothrow out override package pragma private protected public pure ref return scope shared static struct super switch synchronized template this throw try typedef typeid typeof union unittest version void volatile while with __FILE__ __LINE__ __gshared|10 __thread __traits __DATE__ __EOF__ __TIME__ __TIMESTAMP__ __VENDOR__ __VERSION__",
            built_in: "bool cdouble cent cfloat char creal dchar delegate double dstring float function idouble ifloat ireal long real short string ubyte ucent uint ulong ushort wchar wstring",
            literal: "false null true"
        }, a = "(0|[1-9][\\d_]*)", n = "(0|[1-9][\\d_]*|\\d[\\d_]*|[\\d_]+?\\d)", i = "([\\da-fA-F][\\da-fA-F_]*|_[\\da-fA-F][\\da-fA-F_]*)", r = "([eE][+-]?" + n + ")", o = "(" + a + "|0[bB][01_]+|0[xX]" + i + ")", s = "\\\\(['\"\\?\\\\abfnrtv]|u[\\dA-Fa-f]{4}|[0-7]{1,3}|x[\\dA-Fa-f]{2}|U[\\dA-Fa-f]{8})|&[a-zA-Z\\d]{2,};", l = {
            className: "number",
            begin: "\\b" + o + "(L|u|U|Lu|LU|uL|UL)?",
            relevance: 0
        }, c = {
            className: "number",
            begin: "\\b(((0[xX](" + i + "\\." + i + "|\\.?" + i + ")[pP][+-]?" + n + ")|(" + n + "(\\.\\d*|" + r + ")|\\d+\\." + n + "|\\." + a + r + "?))([fF]|L|i|[fF]i|Li)?|" + o + "(i|[fF]i|Li))",
            relevance: 0
        }, _ = {
            className: "string",
            begin: "'(" + s + "|.)",
            end: "'",
            illegal: "."
        }, d = {
            className: "string",
            begin: '"',
            contains: [
                {
                    begin: s,
                    relevance: 0
                }
            ],
            end: '"[cwd]?'
        }, m = e.COMMENT("\\/\\+", "\\+\\/", {
            contains: [
                "self"
            ],
            relevance: 10
        });
        return {
            name: "D",
            keywords: t,
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                m,
                {
                    className: "string",
                    begin: 'x"[\\da-fA-F\\s\\n\\r]*"[cwd]?',
                    relevance: 10
                },
                d,
                {
                    className: "string",
                    begin: '[rq]"',
                    end: '"[cwd]?',
                    relevance: 5
                },
                {
                    className: "string",
                    begin: "`",
                    end: "`[cwd]?"
                },
                {
                    className: "string",
                    begin: 'q"\\{',
                    end: '\\}"'
                },
                c,
                l,
                _,
                {
                    className: "meta",
                    begin: "^#!",
                    end: "$",
                    relevance: 5
                },
                {
                    className: "meta",
                    begin: "#(line)",
                    end: "$",
                    relevance: 5
                },
                {
                    className: "keyword",
                    begin: "@[a-zA-Z_][a-zA-Z_\\d]*"
                }
            ]
        };
    }), Ut)), Cs.registerLanguage("markdown", (Gt || (Gt = 1, Bt = function(e) {
        const t = {
            begin: /<\/?[A-Za-z_]/,
            end: ">",
            subLanguage: "xml",
            relevance: 0
        }, a = {
            variants: [
                {
                    begin: /\[.+?\]\[.*?\]/,
                    relevance: 0
                },
                {
                    begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
                    relevance: 2
                },
                {
                    begin: e.regex.concat(/\[.+?\]\(/, /[A-Za-z][A-Za-z0-9+.-]*/, /:\/\/.*?\)/),
                    relevance: 2
                },
                {
                    begin: /\[.+?\]\([./?&#].*?\)/,
                    relevance: 1
                },
                {
                    begin: /\[.*?\]\(.*?\)/,
                    relevance: 0
                }
            ],
            returnBegin: !0,
            contains: [
                {
                    match: /\[(?=\])/
                },
                {
                    className: "string",
                    relevance: 0,
                    begin: "\\[",
                    end: "\\]",
                    excludeBegin: !0,
                    returnEnd: !0
                },
                {
                    className: "link",
                    relevance: 0,
                    begin: "\\]\\(",
                    end: "\\)",
                    excludeBegin: !0,
                    excludeEnd: !0
                },
                {
                    className: "symbol",
                    relevance: 0,
                    begin: "\\]\\[",
                    end: "\\]",
                    excludeBegin: !0,
                    excludeEnd: !0
                }
            ]
        }, n = {
            className: "strong",
            contains: [],
            variants: [
                {
                    begin: /_{2}(?!\s)/,
                    end: /_{2}/
                },
                {
                    begin: /\*{2}(?!\s)/,
                    end: /\*{2}/
                }
            ]
        }, i = {
            className: "emphasis",
            contains: [],
            variants: [
                {
                    begin: /\*(?![*\s])/,
                    end: /\*/
                },
                {
                    begin: /_(?![_\s])/,
                    end: /_/,
                    relevance: 0
                }
            ]
        }, r = e.inherit(n, {
            contains: []
        }), o = e.inherit(i, {
            contains: []
        });
        n.contains.push(o), i.contains.push(r);
        let s = [
            t,
            a
        ];
        return [
            n,
            i,
            r,
            o
        ].forEach((e)=>{
            e.contains = e.contains.concat(s);
        }), s = s.concat(n, i), {
            name: "Markdown",
            aliases: [
                "md",
                "mkdown",
                "mkd"
            ],
            contains: [
                {
                    className: "section",
                    variants: [
                        {
                            begin: "^#{1,6}",
                            end: "$",
                            contains: s
                        },
                        {
                            begin: "(?=^.+?\\n[=-]{2,}$)",
                            contains: [
                                {
                                    begin: "^[=-]*$"
                                },
                                {
                                    begin: "^",
                                    end: "\\n",
                                    contains: s
                                }
                            ]
                        }
                    ]
                },
                t,
                {
                    className: "bullet",
                    begin: "^[ \t]*([*+-]|(\\d+\\.))(?=\\s+)",
                    end: "\\s+",
                    excludeEnd: !0
                },
                n,
                i,
                {
                    className: "quote",
                    begin: "^>\\s+",
                    contains: s,
                    end: "$"
                },
                {
                    className: "code",
                    variants: [
                        {
                            begin: "(`{3,})[^`](.|\\n)*?\\1`*[ ]*"
                        },
                        {
                            begin: "(~{3,})[^~](.|\\n)*?\\1~*[ ]*"
                        },
                        {
                            begin: "```",
                            end: "```+[ ]*$"
                        },
                        {
                            begin: "~~~",
                            end: "~~~+[ ]*$"
                        },
                        {
                            begin: "`.+?`"
                        },
                        {
                            begin: "(?=^( {4}|\\t))",
                            contains: [
                                {
                                    begin: "^( {4}|\\t)",
                                    end: "(\\n)$"
                                }
                            ],
                            relevance: 0
                        }
                    ]
                },
                {
                    begin: "^[-\\*]{3,}",
                    end: "$"
                },
                a,
                {
                    begin: /^\[[^\n]+\]:/,
                    returnBegin: !0,
                    contains: [
                        {
                            className: "symbol",
                            begin: /\[/,
                            end: /\]/,
                            excludeBegin: !0,
                            excludeEnd: !0
                        },
                        {
                            className: "link",
                            begin: /:\s*/,
                            end: /$/,
                            excludeBegin: !0
                        }
                    ]
                }
            ]
        };
    }), Bt)), Cs.registerLanguage("dart", (Ht || (Ht = 1, Yt = function(e) {
        const t = {
            className: "subst",
            variants: [
                {
                    begin: "\\$[A-Za-z0-9_]+"
                }
            ]
        }, a = {
            className: "subst",
            variants: [
                {
                    begin: /\$\{/,
                    end: /\}/
                }
            ],
            keywords: "true false null this is new super"
        }, n = {
            className: "string",
            variants: [
                {
                    begin: "r'''",
                    end: "'''"
                },
                {
                    begin: 'r"""',
                    end: '"""'
                },
                {
                    begin: "r'",
                    end: "'",
                    illegal: "\\n"
                },
                {
                    begin: 'r"',
                    end: '"',
                    illegal: "\\n"
                },
                {
                    begin: "'''",
                    end: "'''",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        t,
                        a
                    ]
                },
                {
                    begin: '"""',
                    end: '"""',
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        t,
                        a
                    ]
                },
                {
                    begin: "'",
                    end: "'",
                    illegal: "\\n",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        t,
                        a
                    ]
                },
                {
                    begin: '"',
                    end: '"',
                    illegal: "\\n",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        t,
                        a
                    ]
                }
            ]
        };
        a.contains = [
            e.C_NUMBER_MODE,
            n
        ];
        const i = [
            "Comparable",
            "DateTime",
            "Duration",
            "Function",
            "Iterable",
            "Iterator",
            "List",
            "Map",
            "Match",
            "Object",
            "Pattern",
            "RegExp",
            "Set",
            "Stopwatch",
            "String",
            "StringBuffer",
            "StringSink",
            "Symbol",
            "Type",
            "Uri",
            "bool",
            "double",
            "int",
            "num",
            "Element",
            "ElementList"
        ], r = i.map((e)=>`${e}?`);
        return {
            name: "Dart",
            keywords: {
                keyword: [
                    "abstract",
                    "as",
                    "assert",
                    "async",
                    "await",
                    "base",
                    "break",
                    "case",
                    "catch",
                    "class",
                    "const",
                    "continue",
                    "covariant",
                    "default",
                    "deferred",
                    "do",
                    "dynamic",
                    "else",
                    "enum",
                    "export",
                    "extends",
                    "extension",
                    "external",
                    "factory",
                    "false",
                    "final",
                    "finally",
                    "for",
                    "Function",
                    "get",
                    "hide",
                    "if",
                    "implements",
                    "import",
                    "in",
                    "interface",
                    "is",
                    "late",
                    "library",
                    "mixin",
                    "new",
                    "null",
                    "on",
                    "operator",
                    "part",
                    "required",
                    "rethrow",
                    "return",
                    "sealed",
                    "set",
                    "show",
                    "static",
                    "super",
                    "switch",
                    "sync",
                    "this",
                    "throw",
                    "true",
                    "try",
                    "typedef",
                    "var",
                    "void",
                    "when",
                    "while",
                    "with",
                    "yield"
                ],
                built_in: i.concat(r).concat([
                    "Never",
                    "Null",
                    "dynamic",
                    "print",
                    "document",
                    "querySelector",
                    "querySelectorAll",
                    "window"
                ]),
                $pattern: /[A-Za-z][A-Za-z0-9_]*\??/
            },
            contains: [
                n,
                e.COMMENT(/\/\*\*(?!\/)/, /\*\//, {
                    subLanguage: "markdown",
                    relevance: 0
                }),
                e.COMMENT(/\/{3,} ?/, /$/, {
                    contains: [
                        {
                            subLanguage: "markdown",
                            begin: ".",
                            end: "$",
                            relevance: 0
                        }
                    ]
                }),
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "class",
                    beginKeywords: "class interface",
                    end: /\{/,
                    excludeEnd: !0,
                    contains: [
                        {
                            beginKeywords: "extends implements"
                        },
                        e.UNDERSCORE_TITLE_MODE
                    ]
                },
                e.C_NUMBER_MODE,
                {
                    className: "meta",
                    begin: "@[A-Za-z]+"
                },
                {
                    begin: "=>"
                }
            ]
        };
    }), Yt)), Cs.registerLanguage("delphi", (qt || (qt = 1, Vt = function(e) {
        const t = [
            "exports",
            "register",
            "file",
            "shl",
            "array",
            "record",
            "property",
            "for",
            "mod",
            "while",
            "set",
            "ally",
            "label",
            "uses",
            "raise",
            "not",
            "stored",
            "class",
            "safecall",
            "var",
            "interface",
            "or",
            "private",
            "static",
            "exit",
            "index",
            "inherited",
            "to",
            "else",
            "stdcall",
            "override",
            "shr",
            "asm",
            "far",
            "resourcestring",
            "finalization",
            "packed",
            "virtual",
            "out",
            "and",
            "protected",
            "library",
            "do",
            "xorwrite",
            "goto",
            "near",
            "function",
            "end",
            "div",
            "overload",
            "object",
            "unit",
            "begin",
            "string",
            "on",
            "inline",
            "repeat",
            "until",
            "destructor",
            "write",
            "message",
            "program",
            "with",
            "read",
            "initialization",
            "except",
            "default",
            "nil",
            "if",
            "case",
            "cdecl",
            "in",
            "downto",
            "threadvar",
            "of",
            "try",
            "pascal",
            "const",
            "external",
            "constructor",
            "type",
            "public",
            "then",
            "implementation",
            "finally",
            "published",
            "procedure",
            "absolute",
            "reintroduce",
            "operator",
            "as",
            "is",
            "abstract",
            "alias",
            "assembler",
            "bitpacked",
            "break",
            "continue",
            "cppdecl",
            "cvar",
            "enumerator",
            "experimental",
            "platform",
            "deprecated",
            "unimplemented",
            "dynamic",
            "export",
            "far16",
            "forward",
            "generic",
            "helper",
            "implements",
            "interrupt",
            "iochecks",
            "local",
            "name",
            "nodefault",
            "noreturn",
            "nostackframe",
            "oldfpccall",
            "otherwise",
            "saveregisters",
            "softfloat",
            "specialize",
            "strict",
            "unaligned",
            "varargs"
        ], a = [
            e.C_LINE_COMMENT_MODE,
            e.COMMENT(/\{/, /\}/, {
                relevance: 0
            }),
            e.COMMENT(/\(\*/, /\*\)/, {
                relevance: 10
            })
        ], n = {
            className: "meta",
            variants: [
                {
                    begin: /\{\$/,
                    end: /\}/
                },
                {
                    begin: /\(\*\$/,
                    end: /\*\)/
                }
            ]
        }, i = {
            className: "string",
            begin: /'/,
            end: /'/,
            contains: [
                {
                    begin: /''/
                }
            ]
        }, r = {
            className: "string",
            begin: /(#\d+)+/
        }, o = {
            begin: e.IDENT_RE + "\\s*=\\s*class\\s*\\(",
            returnBegin: !0,
            contains: [
                e.TITLE_MODE
            ]
        }, s = {
            className: "function",
            beginKeywords: "function constructor destructor procedure",
            end: /[:;]/,
            keywords: "function constructor|10 destructor|10 procedure|10",
            contains: [
                e.TITLE_MODE,
                {
                    className: "params",
                    begin: /\(/,
                    end: /\)/,
                    keywords: t,
                    contains: [
                        i,
                        r,
                        n
                    ].concat(a)
                },
                n
            ].concat(a)
        };
        return {
            name: "Delphi",
            aliases: [
                "dpr",
                "dfm",
                "pas",
                "pascal"
            ],
            case_insensitive: !0,
            keywords: t,
            illegal: /"|\$[G-Zg-z]|\/\*|<\/|\|/,
            contains: [
                i,
                r,
                e.NUMBER_MODE,
                {
                    className: "number",
                    relevance: 0,
                    variants: [
                        {
                            begin: "\\$[0-9A-Fa-f]+"
                        },
                        {
                            begin: "&[0-7]+"
                        },
                        {
                            begin: "%[01]+"
                        }
                    ]
                },
                o,
                s,
                n
            ].concat(a)
        };
    }), Vt)), Cs.registerLanguage("diff", ($t || ($t = 1, zt = function(e) {
        const t = e.regex;
        return {
            name: "Diff",
            aliases: [
                "patch"
            ],
            contains: [
                {
                    className: "meta",
                    relevance: 10,
                    match: t.either(/^@@ +-\d+,\d+ +\+\d+,\d+ +@@/, /^\*\*\* +\d+,\d+ +\*\*\*\*$/, /^--- +\d+,\d+ +----$/)
                },
                {
                    className: "comment",
                    variants: [
                        {
                            begin: t.either(/Index: /, /^index/, /={3,}/, /^-{3}/, /^\*{3} /, /^\+{3}/, /^diff --git/),
                            end: /$/
                        },
                        {
                            match: /^\*{15}$/
                        }
                    ]
                },
                {
                    className: "addition",
                    begin: /^\+/,
                    end: /$/
                },
                {
                    className: "deletion",
                    begin: /^-/,
                    end: /$/
                },
                {
                    className: "addition",
                    begin: /^!/,
                    end: /$/
                }
            ]
        };
    }), zt)), Cs.registerLanguage("django", (Qt || (Qt = 1, Wt = function(e) {
        const t = {
            begin: /\|[A-Za-z]+:?/,
            keywords: {
                name: "truncatewords removetags linebreaksbr yesno get_digit timesince random striptags filesizeformat escape linebreaks length_is ljust rjust cut urlize fix_ampersands title floatformat capfirst pprint divisibleby add make_list unordered_list urlencode timeuntil urlizetrunc wordcount stringformat linenumbers slice date dictsort dictsortreversed default_if_none pluralize lower join center default truncatewords_html upper length phone2numeric wordwrap time addslashes slugify first escapejs force_escape iriencode last safe safeseq truncatechars localize unlocalize localtime utc timezone"
            },
            contains: [
                e.QUOTE_STRING_MODE,
                e.APOS_STRING_MODE
            ]
        };
        return {
            name: "Django",
            aliases: [
                "jinja"
            ],
            case_insensitive: !0,
            subLanguage: "xml",
            contains: [
                e.COMMENT(/\{%\s*comment\s*%\}/, /\{%\s*endcomment\s*%\}/),
                e.COMMENT(/\{#/, /#\}/),
                {
                    className: "template-tag",
                    begin: /\{%/,
                    end: /%\}/,
                    contains: [
                        {
                            className: "name",
                            begin: /\w+/,
                            keywords: {
                                name: "comment endcomment load templatetag ifchanged endifchanged if endif firstof for endfor ifnotequal endifnotequal widthratio extends include spaceless endspaceless regroup ifequal endifequal ssi now with cycle url filter endfilter debug block endblock else autoescape endautoescape csrf_token empty elif endwith static trans blocktrans endblocktrans get_static_prefix get_media_prefix plural get_current_language language get_available_languages get_current_language_bidi get_language_info get_language_info_list localize endlocalize localtime endlocaltime timezone endtimezone get_current_timezone verbatim"
                            },
                            starts: {
                                endsWithParent: !0,
                                keywords: "in by as",
                                contains: [
                                    t
                                ],
                                relevance: 0
                            }
                        }
                    ]
                },
                {
                    className: "template-variable",
                    begin: /\{\{/,
                    end: /\}\}/,
                    contains: [
                        t
                    ]
                }
            ]
        };
    }), Wt)), Cs.registerLanguage("dns", (jt || (jt = 1, Kt = function(e) {
        return {
            name: "DNS Zone",
            aliases: [
                "bind",
                "zone"
            ],
            keywords: [
                "IN",
                "A",
                "AAAA",
                "AFSDB",
                "APL",
                "CAA",
                "CDNSKEY",
                "CDS",
                "CERT",
                "CNAME",
                "DHCID",
                "DLV",
                "DNAME",
                "DNSKEY",
                "DS",
                "HIP",
                "IPSECKEY",
                "KEY",
                "KX",
                "LOC",
                "MX",
                "NAPTR",
                "NS",
                "NSEC",
                "NSEC3",
                "NSEC3PARAM",
                "PTR",
                "RRSIG",
                "RP",
                "SIG",
                "SOA",
                "SRV",
                "SSHFP",
                "TA",
                "TKEY",
                "TLSA",
                "TSIG",
                "TXT"
            ],
            contains: [
                e.COMMENT(";", "$", {
                    relevance: 0
                }),
                {
                    className: "meta",
                    begin: /^\$(TTL|GENERATE|INCLUDE|ORIGIN)\b/
                },
                {
                    className: "number",
                    begin: "((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)){3}))|:)))\\b"
                },
                {
                    className: "number",
                    begin: "((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]).){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\b"
                },
                e.inherit(e.NUMBER_MODE, {
                    begin: /\b\d+[dhwm]?/
                })
            ]
        };
    }), Kt)), Cs.registerLanguage("dockerfile", (Zt || (Zt = 1, Xt = function(e) {
        return {
            name: "Dockerfile",
            aliases: [
                "docker"
            ],
            case_insensitive: !0,
            keywords: [
                "from",
                "maintainer",
                "expose",
                "env",
                "arg",
                "user",
                "onbuild",
                "stopsignal"
            ],
            contains: [
                e.HASH_COMMENT_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.NUMBER_MODE,
                {
                    beginKeywords: "run cmd entrypoint volume add copy workdir label healthcheck shell",
                    starts: {
                        end: /[^\\]$/,
                        subLanguage: "bash"
                    }
                }
            ],
            illegal: "</"
        };
    }), Xt)), Cs.registerLanguage("dos", (ea || (ea = 1, Jt = function(e) {
        const t = e.COMMENT(/^\s*@?rem\b/, /$/, {
            relevance: 10
        });
        return {
            name: "Batch file (DOS)",
            aliases: [
                "bat",
                "cmd"
            ],
            case_insensitive: !0,
            illegal: /\/\*/,
            keywords: {
                keyword: [
                    "if",
                    "else",
                    "goto",
                    "for",
                    "in",
                    "do",
                    "call",
                    "exit",
                    "not",
                    "exist",
                    "errorlevel",
                    "defined",
                    "equ",
                    "neq",
                    "lss",
                    "leq",
                    "gtr",
                    "geq"
                ],
                built_in: [
                    "prn",
                    "nul",
                    "lpt3",
                    "lpt2",
                    "lpt1",
                    "con",
                    "com4",
                    "com3",
                    "com2",
                    "com1",
                    "aux",
                    "shift",
                    "cd",
                    "dir",
                    "echo",
                    "setlocal",
                    "endlocal",
                    "set",
                    "pause",
                    "copy",
                    "append",
                    "assoc",
                    "at",
                    "attrib",
                    "break",
                    "cacls",
                    "cd",
                    "chcp",
                    "chdir",
                    "chkdsk",
                    "chkntfs",
                    "cls",
                    "cmd",
                    "color",
                    "comp",
                    "compact",
                    "convert",
                    "date",
                    "dir",
                    "diskcomp",
                    "diskcopy",
                    "doskey",
                    "erase",
                    "fs",
                    "find",
                    "findstr",
                    "format",
                    "ftype",
                    "graftabl",
                    "help",
                    "keyb",
                    "label",
                    "md",
                    "mkdir",
                    "mode",
                    "more",
                    "move",
                    "path",
                    "pause",
                    "print",
                    "popd",
                    "pushd",
                    "promt",
                    "rd",
                    "recover",
                    "rem",
                    "rename",
                    "replace",
                    "restore",
                    "rmdir",
                    "shift",
                    "sort",
                    "start",
                    "subst",
                    "time",
                    "title",
                    "tree",
                    "type",
                    "ver",
                    "verify",
                    "vol",
                    "ping",
                    "net",
                    "ipconfig",
                    "taskkill",
                    "xcopy",
                    "ren",
                    "del"
                ]
            },
            contains: [
                {
                    className: "variable",
                    begin: /%%[^ ]|%[^ ]+?%|![^ ]+?!/
                },
                {
                    className: "function",
                    begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)",
                    end: "goto:eof",
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*"
                        }),
                        t
                    ]
                },
                {
                    className: "number",
                    begin: "\\b\\d+",
                    relevance: 0
                },
                t
            ]
        };
    }), Jt)), Cs.registerLanguage("dsconfig", (aa || (aa = 1, ta = function(e) {
        return {
            keywords: "dsconfig",
            contains: [
                {
                    className: "keyword",
                    begin: "^dsconfig",
                    end: /\s/,
                    excludeEnd: !0,
                    relevance: 10
                },
                {
                    className: "built_in",
                    begin: /(list|create|get|set|delete)-(\w+)/,
                    end: /\s/,
                    excludeEnd: !0,
                    illegal: "!@#$%^&*()",
                    relevance: 10
                },
                {
                    className: "built_in",
                    begin: /--(\w+)/,
                    end: /\s/,
                    excludeEnd: !0
                },
                {
                    className: "string",
                    begin: /"/,
                    end: /"/
                },
                {
                    className: "string",
                    begin: /'/,
                    end: /'/
                },
                {
                    className: "string",
                    begin: /[\w\-?]+:\w+/,
                    end: /\W/,
                    relevance: 0
                },
                {
                    className: "string",
                    begin: /\w+(\-\w+)*/,
                    end: /(?=\W)/,
                    relevance: 0
                },
                e.HASH_COMMENT_MODE
            ]
        };
    }), ta)), Cs.registerLanguage("dts", (ia || (ia = 1, na = function(e) {
        const t = {
            className: "string",
            variants: [
                e.inherit(e.QUOTE_STRING_MODE, {
                    begin: '((u8?|U)|L)?"'
                }),
                {
                    begin: '(u8?|U)?R"',
                    end: '"',
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: "'\\\\?.",
                    end: "'",
                    illegal: "."
                }
            ]
        }, a = {
            className: "number",
            variants: [
                {
                    begin: "\\b(\\d+(\\.\\d*)?|\\.\\d+)(u|U|l|L|ul|UL|f|F)"
                },
                {
                    begin: e.C_NUMBER_RE
                }
            ],
            relevance: 0
        }, n = {
            className: "meta",
            begin: "#",
            end: "$",
            keywords: {
                keyword: "if else elif endif define undef ifdef ifndef"
            },
            contains: [
                {
                    begin: /\\\n/,
                    relevance: 0
                },
                {
                    beginKeywords: "include",
                    end: "$",
                    keywords: {
                        keyword: "include"
                    },
                    contains: [
                        e.inherit(t, {
                            className: "string"
                        }),
                        {
                            className: "string",
                            begin: "<",
                            end: ">",
                            illegal: "\\n"
                        }
                    ]
                },
                t,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE
            ]
        }, i = {
            className: "variable",
            begin: /&[a-z\d_]*\b/
        };
        return {
            name: "Device Tree",
            contains: [
                {
                    className: "title.class",
                    begin: /^\/(?=\s*\{)/,
                    relevance: 10
                },
                i,
                {
                    className: "keyword",
                    begin: "/[a-z][a-z\\d-]*/"
                },
                {
                    className: "symbol",
                    begin: "^\\s*[a-zA-Z_][a-zA-Z\\d_]*:"
                },
                {
                    className: "title.class",
                    begin: /[a-zA-Z_][a-zA-Z\d_@-]*(?=\s\{)/,
                    relevance: .2
                },
                {
                    relevance: 0,
                    match: [
                        /[a-z][a-z-,]+/,
                        /\s*/,
                        /=/
                    ],
                    scope: {
                        1: "attr",
                        3: "operator"
                    }
                },
                {
                    match: /[a-z][a-z-,]+(?=;)/,
                    relevance: 0,
                    scope: "attr"
                },
                {
                    className: "params",
                    relevance: 0,
                    begin: "<",
                    end: ">",
                    contains: [
                        a,
                        i
                    ]
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                a,
                t,
                n,
                {
                    scope: "punctuation",
                    relevance: 0,
                    match: /\};|[;{}]/
                },
                {
                    begin: e.IDENT_RE + "::",
                    keywords: ""
                }
            ]
        };
    }), na)), Cs.registerLanguage("dust", (oa || (oa = 1, ra = function(e) {
        return {
            name: "Dust",
            aliases: [
                "dst"
            ],
            case_insensitive: !0,
            subLanguage: "xml",
            contains: [
                {
                    className: "template-tag",
                    begin: /\{[#\/]/,
                    end: /\}/,
                    illegal: /;/,
                    contains: [
                        {
                            className: "name",
                            begin: /[a-zA-Z\.-]+/,
                            starts: {
                                endsWithParent: !0,
                                relevance: 0,
                                contains: [
                                    e.QUOTE_STRING_MODE
                                ]
                            }
                        }
                    ]
                },
                {
                    className: "template-variable",
                    begin: /\{/,
                    end: /\}/,
                    illegal: /;/,
                    keywords: "if eq ne lt lte gt gte select default math sep"
                }
            ]
        };
    }), ra)), Cs.registerLanguage("ebnf", (la || (la = 1, sa = function(e) {
        const t = e.COMMENT(/\(\*/, /\*\)/);
        return {
            name: "Extended Backus-Naur Form",
            illegal: /\S/,
            contains: [
                t,
                {
                    className: "attribute",
                    begin: /^[ ]*[a-zA-Z]+([\s_-]+[a-zA-Z]+)*/
                },
                {
                    begin: /=/,
                    end: /[.;]/,
                    contains: [
                        t,
                        {
                            className: "meta",
                            begin: /\?.*\?/
                        },
                        {
                            className: "string",
                            variants: [
                                e.APOS_STRING_MODE,
                                e.QUOTE_STRING_MODE,
                                {
                                    begin: "`",
                                    end: "`"
                                }
                            ]
                        }
                    ]
                }
            ]
        };
    }), sa)), Cs.registerLanguage("elixir", (_a || (_a = 1, ca = function(e) {
        const t = e.regex, a = "[a-zA-Z_][a-zA-Z0-9_.]*(!|\\?)?", n = {
            $pattern: a,
            keyword: [
                "after",
                "alias",
                "and",
                "case",
                "catch",
                "cond",
                "defstruct",
                "defguard",
                "do",
                "else",
                "end",
                "fn",
                "for",
                "if",
                "import",
                "in",
                "not",
                "or",
                "quote",
                "raise",
                "receive",
                "require",
                "reraise",
                "rescue",
                "try",
                "unless",
                "unquote",
                "unquote_splicing",
                "use",
                "when",
                "with|0"
            ],
            literal: [
                "false",
                "nil",
                "true"
            ]
        }, i = {
            className: "subst",
            begin: /#\{/,
            end: /\}/,
            keywords: n
        }, r = {
            match: /\\[\s\S]/,
            scope: "char.escape",
            relevance: 0
        }, o = "[/|([{<\"']", s = [
            {
                begin: /"/,
                end: /"/
            },
            {
                begin: /'/,
                end: /'/
            },
            {
                begin: /\//,
                end: /\//
            },
            {
                begin: /\|/,
                end: /\|/
            },
            {
                begin: /\(/,
                end: /\)/
            },
            {
                begin: /\[/,
                end: /\]/
            },
            {
                begin: /\{/,
                end: /\}/
            },
            {
                begin: /</,
                end: />/
            }
        ], l = (e)=>({
                scope: "char.escape",
                begin: t.concat(/\\/, e),
                relevance: 0
            }), c = {
            className: "string",
            begin: "~[a-z](?=" + o + ")",
            contains: s.map((t)=>e.inherit(t, {
                    contains: [
                        l(t.end),
                        r,
                        i
                    ]
                }))
        }, _ = {
            className: "string",
            begin: "~[A-Z](?=" + o + ")",
            contains: s.map((t)=>e.inherit(t, {
                    contains: [
                        l(t.end)
                    ]
                }))
        }, d = {
            className: "regex",
            variants: [
                {
                    begin: "~r(?=" + o + ")",
                    contains: s.map((a)=>e.inherit(a, {
                            end: t.concat(a.end, /[uismxfU]{0,7}/),
                            contains: [
                                l(a.end),
                                r,
                                i
                            ]
                        }))
                },
                {
                    begin: "~R(?=" + o + ")",
                    contains: s.map((a)=>e.inherit(a, {
                            end: t.concat(a.end, /[uismxfU]{0,7}/),
                            contains: [
                                l(a.end)
                            ]
                        }))
                }
            ]
        }, m = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE,
                i
            ],
            variants: [
                {
                    begin: /"""/,
                    end: /"""/
                },
                {
                    begin: /'''/,
                    end: /'''/
                },
                {
                    begin: /~S"""/,
                    end: /"""/,
                    contains: []
                },
                {
                    begin: /~S"/,
                    end: /"/,
                    contains: []
                },
                {
                    begin: /~S'''/,
                    end: /'''/,
                    contains: []
                },
                {
                    begin: /~S'/,
                    end: /'/,
                    contains: []
                },
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /"/,
                    end: /"/
                }
            ]
        }, p = {
            className: "function",
            beginKeywords: "def defp defmacro defmacrop",
            end: /\B\b/,
            contains: [
                e.inherit(e.TITLE_MODE, {
                    begin: a,
                    endsParent: !0
                })
            ]
        }, u = e.inherit(p, {
            className: "class",
            beginKeywords: "defimpl defmodule defprotocol defrecord",
            end: /\bdo\b|$|;/
        }), g = [
            m,
            d,
            _,
            c,
            e.HASH_COMMENT_MODE,
            u,
            p,
            {
                begin: "::"
            },
            {
                className: "symbol",
                begin: ":(?![\\s:])",
                contains: [
                    m,
                    {
                        begin: "[a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?"
                    }
                ],
                relevance: 0
            },
            {
                className: "symbol",
                begin: a + ":(?!:)",
                relevance: 0
            },
            {
                className: "title.class",
                begin: /(\b[A-Z][a-zA-Z0-9_]+)/,
                relevance: 0
            },
            {
                className: "number",
                begin: "(\\b0o[0-7_]+)|(\\b0b[01_]+)|(\\b0x[0-9a-fA-F_]+)|(-?\\b[0-9][0-9_]*(\\.[0-9_]+([eE][-+]?[0-9]+)?)?)",
                relevance: 0
            },
            {
                className: "variable",
                begin: "(\\$\\W)|((\\$|@@?)(\\w+))"
            }
        ];
        return i.contains = g, {
            name: "Elixir",
            aliases: [
                "ex",
                "exs"
            ],
            keywords: n,
            contains: g
        };
    }), ca)), Cs.registerLanguage("elm", (ma || (ma = 1, da = function(e) {
        const t = {
            variants: [
                e.COMMENT("--", "$"),
                e.COMMENT(/\{-/, /-\}/, {
                    contains: [
                        "self"
                    ]
                })
            ]
        }, a = {
            className: "type",
            begin: "\\b[A-Z][\\w']*",
            relevance: 0
        }, n = {
            begin: "\\(",
            end: "\\)",
            illegal: '"',
            contains: [
                {
                    className: "type",
                    begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
                },
                t
            ]
        };
        return {
            name: "Elm",
            keywords: [
                "let",
                "in",
                "if",
                "then",
                "else",
                "case",
                "of",
                "where",
                "module",
                "import",
                "exposing",
                "type",
                "alias",
                "as",
                "infix",
                "infixl",
                "infixr",
                "port",
                "effect",
                "command",
                "subscription"
            ],
            contains: [
                {
                    beginKeywords: "port effect module",
                    end: "exposing",
                    keywords: "port effect module where command subscription exposing",
                    contains: [
                        n,
                        t
                    ],
                    illegal: "\\W\\.|;"
                },
                {
                    begin: "import",
                    end: "$",
                    keywords: "import as exposing",
                    contains: [
                        n,
                        t
                    ],
                    illegal: "\\W\\.|;"
                },
                {
                    begin: "type",
                    end: "$",
                    keywords: "type alias",
                    contains: [
                        a,
                        n,
                        {
                            begin: /\{/,
                            end: /\}/,
                            contains: n.contains
                        },
                        t
                    ]
                },
                {
                    beginKeywords: "infix infixl infixr",
                    end: "$",
                    contains: [
                        e.C_NUMBER_MODE,
                        t
                    ]
                },
                {
                    begin: "port",
                    end: "$",
                    keywords: "port",
                    contains: [
                        t
                    ]
                },
                {
                    className: "string",
                    begin: "'\\\\?.",
                    end: "'",
                    illegal: "."
                },
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE,
                a,
                e.inherit(e.TITLE_MODE, {
                    begin: "^[_a-z][\\w']*"
                }),
                t,
                {
                    begin: "->|<-"
                }
            ],
            illegal: /;/
        };
    }), da)), Cs.registerLanguage("ruby", (ua || (ua = 1, pa = function(e) {
        const t = e.regex, a = "([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)", n = t.either(/\b([A-Z]+[a-z0-9]+)+/, /\b([A-Z]+[a-z0-9]+)+[A-Z]+/), i = t.concat(n, /(::\w+)*/), r = {
            "variable.constant": [
                "__FILE__",
                "__LINE__",
                "__ENCODING__"
            ],
            "variable.language": [
                "self",
                "super"
            ],
            keyword: [
                "alias",
                "and",
                "begin",
                "BEGIN",
                "break",
                "case",
                "class",
                "defined",
                "do",
                "else",
                "elsif",
                "end",
                "END",
                "ensure",
                "for",
                "if",
                "in",
                "module",
                "next",
                "not",
                "or",
                "redo",
                "require",
                "rescue",
                "retry",
                "return",
                "then",
                "undef",
                "unless",
                "until",
                "when",
                "while",
                "yield",
                "include",
                "extend",
                "prepend",
                "public",
                "private",
                "protected",
                "raise",
                "throw"
            ],
            built_in: [
                "proc",
                "lambda",
                "attr_accessor",
                "attr_reader",
                "attr_writer",
                "define_method",
                "private_constant",
                "module_function"
            ],
            literal: [
                "true",
                "false",
                "nil"
            ]
        }, o = {
            className: "doctag",
            begin: "@[A-Za-z]+"
        }, s = {
            begin: "#<",
            end: ">"
        }, l = [
            e.COMMENT("#", "$", {
                contains: [
                    o
                ]
            }),
            e.COMMENT("^=begin", "^=end", {
                contains: [
                    o
                ],
                relevance: 10
            }),
            e.COMMENT("^__END__", e.MATCH_NOTHING_RE)
        ], c = {
            className: "subst",
            begin: /#\{/,
            end: /\}/,
            keywords: r
        }, _ = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE,
                c
            ],
            variants: [
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /"/,
                    end: /"/
                },
                {
                    begin: /`/,
                    end: /`/
                },
                {
                    begin: /%[qQwWx]?\(/,
                    end: /\)/
                },
                {
                    begin: /%[qQwWx]?\[/,
                    end: /\]/
                },
                {
                    begin: /%[qQwWx]?\{/,
                    end: /\}/
                },
                {
                    begin: /%[qQwWx]?</,
                    end: />/
                },
                {
                    begin: /%[qQwWx]?\//,
                    end: /\//
                },
                {
                    begin: /%[qQwWx]?%/,
                    end: /%/
                },
                {
                    begin: /%[qQwWx]?-/,
                    end: /-/
                },
                {
                    begin: /%[qQwWx]?\|/,
                    end: /\|/
                },
                {
                    begin: /\B\?(\\\d{1,3})/
                },
                {
                    begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/
                },
                {
                    begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/
                },
                {
                    begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/
                },
                {
                    begin: /\B\?\\(c|C-)[\x20-\x7e]/
                },
                {
                    begin: /\B\?\\?\S/
                },
                {
                    begin: t.concat(/<<[-~]?'?/, t.lookahead(/(\w+)(?=\W)[^\n]*\n(?:[^\n]*\n)*?\s*\1\b/)),
                    contains: [
                        e.END_SAME_AS_BEGIN({
                            begin: /(\w+)/,
                            end: /(\w+)/,
                            contains: [
                                e.BACKSLASH_ESCAPE,
                                c
                            ]
                        })
                    ]
                }
            ]
        }, d = "[0-9](_?[0-9])*", m = {
            className: "number",
            relevance: 0,
            variants: [
                {
                    begin: `\\b([1-9](_?[0-9])*|0)(\\.(${d}))?([eE][+-]?(${d})|r)?i?\\b`
                },
                {
                    begin: "\\b0[dD][0-9](_?[0-9])*r?i?\\b"
                },
                {
                    begin: "\\b0[bB][0-1](_?[0-1])*r?i?\\b"
                },
                {
                    begin: "\\b0[oO][0-7](_?[0-7])*r?i?\\b"
                },
                {
                    begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b"
                },
                {
                    begin: "\\b0(_?[0-7])+r?i?\\b"
                }
            ]
        }, p = {
            variants: [
                {
                    match: /\(\)/
                },
                {
                    className: "params",
                    begin: /\(/,
                    end: /(?=\))/,
                    excludeBegin: !0,
                    endsParent: !0,
                    keywords: r
                }
            ]
        }, u = [
            _,
            {
                variants: [
                    {
                        match: [
                            /class\s+/,
                            i,
                            /\s+<\s+/,
                            i
                        ]
                    },
                    {
                        match: [
                            /\b(class|module)\s+/,
                            i
                        ]
                    }
                ],
                scope: {
                    2: "title.class",
                    4: "title.class.inherited"
                },
                keywords: r
            },
            {
                match: [
                    /(include|extend)\s+/,
                    i
                ],
                scope: {
                    2: "title.class"
                },
                keywords: r
            },
            {
                relevance: 0,
                match: [
                    i,
                    /\.new[. (]/
                ],
                scope: {
                    1: "title.class"
                }
            },
            {
                relevance: 0,
                match: /\b[A-Z][A-Z_0-9]+\b/,
                className: "variable.constant"
            },
            {
                relevance: 0,
                match: n,
                scope: "title.class"
            },
            {
                match: [
                    /def/,
                    /\s+/,
                    a
                ],
                scope: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    p
                ]
            },
            {
                begin: e.IDENT_RE + "::"
            },
            {
                className: "symbol",
                begin: e.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
                relevance: 0
            },
            {
                className: "symbol",
                begin: ":(?!\\s)",
                contains: [
                    _,
                    {
                        begin: a
                    }
                ],
                relevance: 0
            },
            m,
            {
                className: "variable",
                begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"
            },
            {
                className: "params",
                begin: /\|/,
                end: /\|/,
                excludeBegin: !0,
                excludeEnd: !0,
                relevance: 0,
                keywords: r
            },
            {
                begin: "(" + e.RE_STARTERS_RE + "|unless)\\s*",
                keywords: "unless",
                contains: [
                    {
                        className: "regexp",
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            c
                        ],
                        illegal: /\n/,
                        variants: [
                            {
                                begin: "/",
                                end: "/[a-z]*"
                            },
                            {
                                begin: /%r\{/,
                                end: /\}[a-z]*/
                            },
                            {
                                begin: "%r\\(",
                                end: "\\)[a-z]*"
                            },
                            {
                                begin: "%r!",
                                end: "![a-z]*"
                            },
                            {
                                begin: "%r\\[",
                                end: "\\][a-z]*"
                            }
                        ]
                    }
                ].concat(s, l),
                relevance: 0
            }
        ].concat(s, l);
        c.contains = u, p.contains = u;
        const g = [
            {
                begin: /^\s*=>/,
                starts: {
                    end: "$",
                    contains: u
                }
            },
            {
                className: "meta.prompt",
                begin: "^([>?]>|[\\w#]+\\(\\w+\\):\\d+:\\d+[>*]|(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>)(?=[ ])",
                starts: {
                    end: "$",
                    keywords: r,
                    contains: u
                }
            }
        ];
        return l.unshift(s), {
            name: "Ruby",
            aliases: [
                "rb",
                "gemspec",
                "podspec",
                "thor",
                "irb"
            ],
            keywords: r,
            illegal: /\/\*/,
            contains: [
                e.SHEBANG({
                    binary: "ruby"
                })
            ].concat(g).concat(l).concat(u)
        };
    }), pa)), Cs.registerLanguage("erb", (Ea || (Ea = 1, ga = function(e) {
        return {
            name: "ERB",
            subLanguage: "xml",
            contains: [
                e.COMMENT("<%#", "%>"),
                {
                    begin: "<%[%=-]?",
                    end: "[%-]?%>",
                    subLanguage: "ruby",
                    excludeBegin: !0,
                    excludeEnd: !0
                }
            ]
        };
    }), ga)), Cs.registerLanguage("erlang-repl", (ba || (ba = 1, Sa = function(e) {
        const t = e.regex;
        return {
            name: "Erlang REPL",
            keywords: {
                built_in: "spawn spawn_link self",
                keyword: "after and andalso|10 band begin bnot bor bsl bsr bxor case catch cond div end fun if let not of or orelse|10 query receive rem try when xor"
            },
            contains: [
                {
                    className: "meta.prompt",
                    begin: "^[0-9]+> ",
                    relevance: 10
                },
                e.COMMENT("%", "$"),
                {
                    className: "number",
                    begin: "\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)",
                    relevance: 0
                },
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                {
                    begin: t.concat(/\?(::)?/, /([A-Z]\w*)/, /((::)[A-Z]\w*)*/)
                },
                {
                    begin: "->"
                },
                {
                    begin: "ok"
                },
                {
                    begin: "!"
                },
                {
                    begin: "(\\b[a-z'][a-zA-Z0-9_']*:[a-z'][a-zA-Z0-9_']*)|(\\b[a-z'][a-zA-Z0-9_']*)",
                    relevance: 0
                },
                {
                    begin: "[A-Z][a-zA-Z0-9_']*",
                    relevance: 0
                }
            ]
        };
    }), Sa)), Cs.registerLanguage("erlang", (Ca || (Ca = 1, Ta = function(e) {
        const t = "[a-z'][a-zA-Z0-9_']*", a = "(" + t + ":" + t + "|" + t + ")", n = {
            keyword: "after and andalso|10 band begin bnot bor bsl bzr bxor case catch cond div end fun if let not of orelse|10 query receive rem try when xor",
            literal: "false true"
        }, i = e.COMMENT("%", "$"), r = {
            className: "number",
            begin: "\\b(\\d+(_\\d+)*#[a-fA-F0-9]+(_[a-fA-F0-9]+)*|\\d+(_\\d+)*(\\.\\d+(_\\d+)*)?([eE][-+]?\\d+)?)",
            relevance: 0
        }, o = {
            begin: "fun\\s+" + t + "/\\d+"
        }, s = {
            begin: a + "\\(",
            end: "\\)",
            returnBegin: !0,
            relevance: 0,
            contains: [
                {
                    begin: a,
                    relevance: 0
                },
                {
                    begin: "\\(",
                    end: "\\)",
                    endsWithParent: !0,
                    returnEnd: !0,
                    relevance: 0
                }
            ]
        }, l = {
            begin: /\{/,
            end: /\}/,
            relevance: 0
        }, c = {
            begin: "\\b_([A-Z][A-Za-z0-9_]*)?",
            relevance: 0
        }, _ = {
            begin: "[A-Z][a-zA-Z0-9_]*",
            relevance: 0
        }, d = {
            begin: "#" + e.UNDERSCORE_IDENT_RE,
            relevance: 0,
            returnBegin: !0,
            contains: [
                {
                    begin: "#" + e.UNDERSCORE_IDENT_RE,
                    relevance: 0
                },
                {
                    begin: /\{/,
                    end: /\}/,
                    relevance: 0
                }
            ]
        }, m = {
            beginKeywords: "fun receive if try case",
            end: "end",
            keywords: n
        };
        m.contains = [
            i,
            o,
            e.inherit(e.APOS_STRING_MODE, {
                className: ""
            }),
            m,
            s,
            e.QUOTE_STRING_MODE,
            r,
            l,
            c,
            _,
            d
        ];
        const p = [
            i,
            o,
            m,
            s,
            e.QUOTE_STRING_MODE,
            r,
            l,
            c,
            _,
            d
        ];
        s.contains[1].contains = p, l.contains = p, d.contains[1].contains = p;
        const u = {
            className: "params",
            begin: "\\(",
            end: "\\)",
            contains: p
        };
        return {
            name: "Erlang",
            aliases: [
                "erl"
            ],
            keywords: n,
            illegal: "(</|\\*=|\\+=|-=|/\\*|\\*/|\\(\\*|\\*\\))",
            contains: [
                {
                    className: "function",
                    begin: "^" + t + "\\s*\\(",
                    end: "->",
                    returnBegin: !0,
                    illegal: "\\(|#|//|/\\*|\\\\|:|;",
                    contains: [
                        u,
                        e.inherit(e.TITLE_MODE, {
                            begin: t
                        })
                    ],
                    starts: {
                        end: ";|\\.",
                        keywords: n,
                        contains: p
                    }
                },
                i,
                {
                    begin: "^-",
                    end: "\\.",
                    relevance: 0,
                    excludeEnd: !0,
                    returnBegin: !0,
                    keywords: {
                        $pattern: "-" + e.IDENT_RE,
                        keyword: [
                            "-module",
                            "-record",
                            "-undef",
                            "-export",
                            "-ifdef",
                            "-ifndef",
                            "-author",
                            "-copyright",
                            "-doc",
                            "-vsn",
                            "-import",
                            "-include",
                            "-include_lib",
                            "-compile",
                            "-define",
                            "-else",
                            "-endif",
                            "-file",
                            "-behaviour",
                            "-behavior",
                            "-spec"
                        ].map((e)=>`${e}|1.5`).join(" ")
                    },
                    contains: [
                        u
                    ]
                },
                r,
                e.QUOTE_STRING_MODE,
                d,
                c,
                _,
                l,
                {
                    begin: /\.$/
                }
            ]
        };
    }), Ta)), Cs.registerLanguage("excel", (Ra || (Ra = 1, fa = function(e) {
        return {
            name: "Excel formulae",
            aliases: [
                "xlsx",
                "xls"
            ],
            case_insensitive: !0,
            keywords: {
                $pattern: /[a-zA-Z][\w\.]*/,
                built_in: [
                    "ABS",
                    "ACCRINT",
                    "ACCRINTM",
                    "ACOS",
                    "ACOSH",
                    "ACOT",
                    "ACOTH",
                    "AGGREGATE",
                    "ADDRESS",
                    "AMORDEGRC",
                    "AMORLINC",
                    "AND",
                    "ARABIC",
                    "AREAS",
                    "ASC",
                    "ASIN",
                    "ASINH",
                    "ATAN",
                    "ATAN2",
                    "ATANH",
                    "AVEDEV",
                    "AVERAGE",
                    "AVERAGEA",
                    "AVERAGEIF",
                    "AVERAGEIFS",
                    "BAHTTEXT",
                    "BASE",
                    "BESSELI",
                    "BESSELJ",
                    "BESSELK",
                    "BESSELY",
                    "BETADIST",
                    "BETA.DIST",
                    "BETAINV",
                    "BETA.INV",
                    "BIN2DEC",
                    "BIN2HEX",
                    "BIN2OCT",
                    "BINOMDIST",
                    "BINOM.DIST",
                    "BINOM.DIST.RANGE",
                    "BINOM.INV",
                    "BITAND",
                    "BITLSHIFT",
                    "BITOR",
                    "BITRSHIFT",
                    "BITXOR",
                    "CALL",
                    "CEILING",
                    "CEILING.MATH",
                    "CEILING.PRECISE",
                    "CELL",
                    "CHAR",
                    "CHIDIST",
                    "CHIINV",
                    "CHITEST",
                    "CHISQ.DIST",
                    "CHISQ.DIST.RT",
                    "CHISQ.INV",
                    "CHISQ.INV.RT",
                    "CHISQ.TEST",
                    "CHOOSE",
                    "CLEAN",
                    "CODE",
                    "COLUMN",
                    "COLUMNS",
                    "COMBIN",
                    "COMBINA",
                    "COMPLEX",
                    "CONCAT",
                    "CONCATENATE",
                    "CONFIDENCE",
                    "CONFIDENCE.NORM",
                    "CONFIDENCE.T",
                    "CONVERT",
                    "CORREL",
                    "COS",
                    "COSH",
                    "COT",
                    "COTH",
                    "COUNT",
                    "COUNTA",
                    "COUNTBLANK",
                    "COUNTIF",
                    "COUNTIFS",
                    "COUPDAYBS",
                    "COUPDAYS",
                    "COUPDAYSNC",
                    "COUPNCD",
                    "COUPNUM",
                    "COUPPCD",
                    "COVAR",
                    "COVARIANCE.P",
                    "COVARIANCE.S",
                    "CRITBINOM",
                    "CSC",
                    "CSCH",
                    "CUBEKPIMEMBER",
                    "CUBEMEMBER",
                    "CUBEMEMBERPROPERTY",
                    "CUBERANKEDMEMBER",
                    "CUBESET",
                    "CUBESETCOUNT",
                    "CUBEVALUE",
                    "CUMIPMT",
                    "CUMPRINC",
                    "DATE",
                    "DATEDIF",
                    "DATEVALUE",
                    "DAVERAGE",
                    "DAY",
                    "DAYS",
                    "DAYS360",
                    "DB",
                    "DBCS",
                    "DCOUNT",
                    "DCOUNTA",
                    "DDB",
                    "DEC2BIN",
                    "DEC2HEX",
                    "DEC2OCT",
                    "DECIMAL",
                    "DEGREES",
                    "DELTA",
                    "DEVSQ",
                    "DGET",
                    "DISC",
                    "DMAX",
                    "DMIN",
                    "DOLLAR",
                    "DOLLARDE",
                    "DOLLARFR",
                    "DPRODUCT",
                    "DSTDEV",
                    "DSTDEVP",
                    "DSUM",
                    "DURATION",
                    "DVAR",
                    "DVARP",
                    "EDATE",
                    "EFFECT",
                    "ENCODEURL",
                    "EOMONTH",
                    "ERF",
                    "ERF.PRECISE",
                    "ERFC",
                    "ERFC.PRECISE",
                    "ERROR.TYPE",
                    "EUROCONVERT",
                    "EVEN",
                    "EXACT",
                    "EXP",
                    "EXPON.DIST",
                    "EXPONDIST",
                    "FACT",
                    "FACTDOUBLE",
                    "FALSE|0",
                    "F.DIST",
                    "FDIST",
                    "F.DIST.RT",
                    "FILTERXML",
                    "FIND",
                    "FINDB",
                    "F.INV",
                    "F.INV.RT",
                    "FINV",
                    "FISHER",
                    "FISHERINV",
                    "FIXED",
                    "FLOOR",
                    "FLOOR.MATH",
                    "FLOOR.PRECISE",
                    "FORECAST",
                    "FORECAST.ETS",
                    "FORECAST.ETS.CONFINT",
                    "FORECAST.ETS.SEASONALITY",
                    "FORECAST.ETS.STAT",
                    "FORECAST.LINEAR",
                    "FORMULATEXT",
                    "FREQUENCY",
                    "F.TEST",
                    "FTEST",
                    "FV",
                    "FVSCHEDULE",
                    "GAMMA",
                    "GAMMA.DIST",
                    "GAMMADIST",
                    "GAMMA.INV",
                    "GAMMAINV",
                    "GAMMALN",
                    "GAMMALN.PRECISE",
                    "GAUSS",
                    "GCD",
                    "GEOMEAN",
                    "GESTEP",
                    "GETPIVOTDATA",
                    "GROWTH",
                    "HARMEAN",
                    "HEX2BIN",
                    "HEX2DEC",
                    "HEX2OCT",
                    "HLOOKUP",
                    "HOUR",
                    "HYPERLINK",
                    "HYPGEOM.DIST",
                    "HYPGEOMDIST",
                    "IF",
                    "IFERROR",
                    "IFNA",
                    "IFS",
                    "IMABS",
                    "IMAGINARY",
                    "IMARGUMENT",
                    "IMCONJUGATE",
                    "IMCOS",
                    "IMCOSH",
                    "IMCOT",
                    "IMCSC",
                    "IMCSCH",
                    "IMDIV",
                    "IMEXP",
                    "IMLN",
                    "IMLOG10",
                    "IMLOG2",
                    "IMPOWER",
                    "IMPRODUCT",
                    "IMREAL",
                    "IMSEC",
                    "IMSECH",
                    "IMSIN",
                    "IMSINH",
                    "IMSQRT",
                    "IMSUB",
                    "IMSUM",
                    "IMTAN",
                    "INDEX",
                    "INDIRECT",
                    "INFO",
                    "INT",
                    "INTERCEPT",
                    "INTRATE",
                    "IPMT",
                    "IRR",
                    "ISBLANK",
                    "ISERR",
                    "ISERROR",
                    "ISEVEN",
                    "ISFORMULA",
                    "ISLOGICAL",
                    "ISNA",
                    "ISNONTEXT",
                    "ISNUMBER",
                    "ISODD",
                    "ISREF",
                    "ISTEXT",
                    "ISO.CEILING",
                    "ISOWEEKNUM",
                    "ISPMT",
                    "JIS",
                    "KURT",
                    "LARGE",
                    "LCM",
                    "LEFT",
                    "LEFTB",
                    "LEN",
                    "LENB",
                    "LINEST",
                    "LN",
                    "LOG",
                    "LOG10",
                    "LOGEST",
                    "LOGINV",
                    "LOGNORM.DIST",
                    "LOGNORMDIST",
                    "LOGNORM.INV",
                    "LOOKUP",
                    "LOWER",
                    "MATCH",
                    "MAX",
                    "MAXA",
                    "MAXIFS",
                    "MDETERM",
                    "MDURATION",
                    "MEDIAN",
                    "MID",
                    "MIDBs",
                    "MIN",
                    "MINIFS",
                    "MINA",
                    "MINUTE",
                    "MINVERSE",
                    "MIRR",
                    "MMULT",
                    "MOD",
                    "MODE",
                    "MODE.MULT",
                    "MODE.SNGL",
                    "MONTH",
                    "MROUND",
                    "MULTINOMIAL",
                    "MUNIT",
                    "N",
                    "NA",
                    "NEGBINOM.DIST",
                    "NEGBINOMDIST",
                    "NETWORKDAYS",
                    "NETWORKDAYS.INTL",
                    "NOMINAL",
                    "NORM.DIST",
                    "NORMDIST",
                    "NORMINV",
                    "NORM.INV",
                    "NORM.S.DIST",
                    "NORMSDIST",
                    "NORM.S.INV",
                    "NORMSINV",
                    "NOT",
                    "NOW",
                    "NPER",
                    "NPV",
                    "NUMBERVALUE",
                    "OCT2BIN",
                    "OCT2DEC",
                    "OCT2HEX",
                    "ODD",
                    "ODDFPRICE",
                    "ODDFYIELD",
                    "ODDLPRICE",
                    "ODDLYIELD",
                    "OFFSET",
                    "OR",
                    "PDURATION",
                    "PEARSON",
                    "PERCENTILE.EXC",
                    "PERCENTILE.INC",
                    "PERCENTILE",
                    "PERCENTRANK.EXC",
                    "PERCENTRANK.INC",
                    "PERCENTRANK",
                    "PERMUT",
                    "PERMUTATIONA",
                    "PHI",
                    "PHONETIC",
                    "PI",
                    "PMT",
                    "POISSON.DIST",
                    "POISSON",
                    "POWER",
                    "PPMT",
                    "PRICE",
                    "PRICEDISC",
                    "PRICEMAT",
                    "PROB",
                    "PRODUCT",
                    "PROPER",
                    "PV",
                    "QUARTILE",
                    "QUARTILE.EXC",
                    "QUARTILE.INC",
                    "QUOTIENT",
                    "RADIANS",
                    "RAND",
                    "RANDBETWEEN",
                    "RANK.AVG",
                    "RANK.EQ",
                    "RANK",
                    "RATE",
                    "RECEIVED",
                    "REGISTER.ID",
                    "REPLACE",
                    "REPLACEB",
                    "REPT",
                    "RIGHT",
                    "RIGHTB",
                    "ROMAN",
                    "ROUND",
                    "ROUNDDOWN",
                    "ROUNDUP",
                    "ROW",
                    "ROWS",
                    "RRI",
                    "RSQ",
                    "RTD",
                    "SEARCH",
                    "SEARCHB",
                    "SEC",
                    "SECH",
                    "SECOND",
                    "SERIESSUM",
                    "SHEET",
                    "SHEETS",
                    "SIGN",
                    "SIN",
                    "SINH",
                    "SKEW",
                    "SKEW.P",
                    "SLN",
                    "SLOPE",
                    "SMALL",
                    "SQL.REQUEST",
                    "SQRT",
                    "SQRTPI",
                    "STANDARDIZE",
                    "STDEV",
                    "STDEV.P",
                    "STDEV.S",
                    "STDEVA",
                    "STDEVP",
                    "STDEVPA",
                    "STEYX",
                    "SUBSTITUTE",
                    "SUBTOTAL",
                    "SUM",
                    "SUMIF",
                    "SUMIFS",
                    "SUMPRODUCT",
                    "SUMSQ",
                    "SUMX2MY2",
                    "SUMX2PY2",
                    "SUMXMY2",
                    "SWITCH",
                    "SYD",
                    "T",
                    "TAN",
                    "TANH",
                    "TBILLEQ",
                    "TBILLPRICE",
                    "TBILLYIELD",
                    "T.DIST",
                    "T.DIST.2T",
                    "T.DIST.RT",
                    "TDIST",
                    "TEXT",
                    "TEXTJOIN",
                    "TIME",
                    "TIMEVALUE",
                    "T.INV",
                    "T.INV.2T",
                    "TINV",
                    "TODAY",
                    "TRANSPOSE",
                    "TREND",
                    "TRIM",
                    "TRIMMEAN",
                    "TRUE|0",
                    "TRUNC",
                    "T.TEST",
                    "TTEST",
                    "TYPE",
                    "UNICHAR",
                    "UNICODE",
                    "UPPER",
                    "VALUE",
                    "VAR",
                    "VAR.P",
                    "VAR.S",
                    "VARA",
                    "VARP",
                    "VARPA",
                    "VDB",
                    "VLOOKUP",
                    "WEBSERVICE",
                    "WEEKDAY",
                    "WEEKNUM",
                    "WEIBULL",
                    "WEIBULL.DIST",
                    "WORKDAY",
                    "WORKDAY.INTL",
                    "XIRR",
                    "XNPV",
                    "XOR",
                    "YEAR",
                    "YEARFRAC",
                    "YIELD",
                    "YIELDDISC",
                    "YIELDMAT",
                    "Z.TEST",
                    "ZTEST"
                ]
            },
            contains: [
                {
                    begin: /^=/,
                    end: /[^=]/,
                    returnEnd: !0,
                    illegal: /=/,
                    relevance: 10
                },
                {
                    className: "symbol",
                    begin: /\b[A-Z]{1,2}\d+\b/,
                    end: /[^\d]/,
                    excludeEnd: !0,
                    relevance: 0
                },
                {
                    className: "symbol",
                    begin: /[A-Z]{0,2}\d*:[A-Z]{0,2}\d*/,
                    relevance: 0
                },
                e.BACKSLASH_ESCAPE,
                e.QUOTE_STRING_MODE,
                {
                    className: "number",
                    begin: e.NUMBER_RE + "(%)?",
                    relevance: 0
                },
                e.COMMENT(/\bN\(/, /\)/, {
                    excludeBegin: !0,
                    excludeEnd: !0,
                    illegal: /\n/
                })
            ]
        };
    }), fa)), Cs.registerLanguage("fix", Oa ? Na : (Oa = 1, Na = function(e) {
        return {
            name: "FIX",
            contains: [
                {
                    begin: /[^\u2401\u0001]+/,
                    end: /[\u2401\u0001]/,
                    excludeEnd: !0,
                    returnBegin: !0,
                    returnEnd: !1,
                    contains: [
                        {
                            begin: /([^\u2401\u0001=]+)/,
                            end: /=([^\u2401\u0001=]+)/,
                            returnEnd: !0,
                            returnBegin: !1,
                            className: "attr"
                        },
                        {
                            begin: /=/,
                            end: /([\u2401\u0001])/,
                            excludeEnd: !0,
                            excludeBegin: !0,
                            className: "string"
                        }
                    ]
                }
            ],
            case_insensitive: !0
        };
    })), Cs.registerLanguage("flix", (va || (va = 1, ha = function(e) {
        const t = {
            className: "function",
            beginKeywords: "def",
            end: /[:={\[(\n;]/,
            excludeEnd: !0,
            contains: [
                {
                    className: "title",
                    relevance: 0,
                    begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/
                }
            ]
        };
        return {
            name: "Flix",
            keywords: {
                keyword: [
                    "case",
                    "class",
                    "def",
                    "else",
                    "enum",
                    "if",
                    "impl",
                    "import",
                    "in",
                    "lat",
                    "rel",
                    "index",
                    "let",
                    "match",
                    "namespace",
                    "switch",
                    "type",
                    "yield",
                    "with"
                ],
                literal: [
                    "true",
                    "false"
                ]
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "string",
                    begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
                },
                {
                    className: "string",
                    variants: [
                        {
                            begin: '"',
                            end: '"'
                        }
                    ]
                },
                t,
                e.C_NUMBER_MODE
            ]
        };
    }), ha)), Cs.registerLanguage("fortran", (Aa || (Aa = 1, Ia = function(e) {
        const t = e.regex, a = {
            variants: [
                e.COMMENT("!", "$", {
                    relevance: 0
                }),
                e.COMMENT("^C[ ]", "$", {
                    relevance: 0
                }),
                e.COMMENT("^C$", "$", {
                    relevance: 0
                })
            ]
        }, n = /(_[a-z_\d]+)?/, i = /([de][+-]?\d+)?/, r = {
            className: "number",
            variants: [
                {
                    begin: t.concat(/\b\d+/, /\.(\d*)/, i, n)
                },
                {
                    begin: t.concat(/\b\d+/, i, n)
                },
                {
                    begin: t.concat(/\.\d+/, i, n)
                }
            ],
            relevance: 0
        }, o = {
            className: "function",
            beginKeywords: "subroutine function program",
            illegal: "[${=\\n]",
            contains: [
                e.UNDERSCORE_TITLE_MODE,
                {
                    className: "params",
                    begin: "\\(",
                    end: "\\)"
                }
            ]
        };
        return {
            name: "Fortran",
            case_insensitive: !0,
            aliases: [
                "f90",
                "f95"
            ],
            keywords: {
                keyword: [
                    "kind",
                    "do",
                    "concurrent",
                    "local",
                    "shared",
                    "while",
                    "private",
                    "call",
                    "intrinsic",
                    "where",
                    "elsewhere",
                    "type",
                    "endtype",
                    "endmodule",
                    "endselect",
                    "endinterface",
                    "end",
                    "enddo",
                    "endif",
                    "if",
                    "forall",
                    "endforall",
                    "only",
                    "contains",
                    "default",
                    "return",
                    "stop",
                    "then",
                    "block",
                    "endblock",
                    "endassociate",
                    "public",
                    "subroutine|10",
                    "function",
                    "program",
                    ".and.",
                    ".or.",
                    ".not.",
                    ".le.",
                    ".eq.",
                    ".ge.",
                    ".gt.",
                    ".lt.",
                    "goto",
                    "save",
                    "else",
                    "use",
                    "module",
                    "select",
                    "case",
                    "access",
                    "blank",
                    "direct",
                    "exist",
                    "file",
                    "fmt",
                    "form",
                    "formatted",
                    "iostat",
                    "name",
                    "named",
                    "nextrec",
                    "number",
                    "opened",
                    "rec",
                    "recl",
                    "sequential",
                    "status",
                    "unformatted",
                    "unit",
                    "continue",
                    "format",
                    "pause",
                    "cycle",
                    "exit",
                    "c_null_char",
                    "c_alert",
                    "c_backspace",
                    "c_form_feed",
                    "flush",
                    "wait",
                    "decimal",
                    "round",
                    "iomsg",
                    "synchronous",
                    "nopass",
                    "non_overridable",
                    "pass",
                    "protected",
                    "volatile",
                    "abstract",
                    "extends",
                    "import",
                    "non_intrinsic",
                    "value",
                    "deferred",
                    "generic",
                    "final",
                    "enumerator",
                    "class",
                    "associate",
                    "bind",
                    "enum",
                    "c_int",
                    "c_short",
                    "c_long",
                    "c_long_long",
                    "c_signed_char",
                    "c_size_t",
                    "c_int8_t",
                    "c_int16_t",
                    "c_int32_t",
                    "c_int64_t",
                    "c_int_least8_t",
                    "c_int_least16_t",
                    "c_int_least32_t",
                    "c_int_least64_t",
                    "c_int_fast8_t",
                    "c_int_fast16_t",
                    "c_int_fast32_t",
                    "c_int_fast64_t",
                    "c_intmax_t",
                    "C_intptr_t",
                    "c_float",
                    "c_double",
                    "c_long_double",
                    "c_float_complex",
                    "c_double_complex",
                    "c_long_double_complex",
                    "c_bool",
                    "c_char",
                    "c_null_ptr",
                    "c_null_funptr",
                    "c_new_line",
                    "c_carriage_return",
                    "c_horizontal_tab",
                    "c_vertical_tab",
                    "iso_c_binding",
                    "c_loc",
                    "c_funloc",
                    "c_associated",
                    "c_f_pointer",
                    "c_ptr",
                    "c_funptr",
                    "iso_fortran_env",
                    "character_storage_size",
                    "error_unit",
                    "file_storage_size",
                    "input_unit",
                    "iostat_end",
                    "iostat_eor",
                    "numeric_storage_size",
                    "output_unit",
                    "c_f_procpointer",
                    "ieee_arithmetic",
                    "ieee_support_underflow_control",
                    "ieee_get_underflow_mode",
                    "ieee_set_underflow_mode",
                    "newunit",
                    "contiguous",
                    "recursive",
                    "pad",
                    "position",
                    "action",
                    "delim",
                    "readwrite",
                    "eor",
                    "advance",
                    "nml",
                    "interface",
                    "procedure",
                    "namelist",
                    "include",
                    "sequence",
                    "elemental",
                    "pure",
                    "impure",
                    "integer",
                    "real",
                    "character",
                    "complex",
                    "logical",
                    "codimension",
                    "dimension",
                    "allocatable|10",
                    "parameter",
                    "external",
                    "implicit|10",
                    "none",
                    "double",
                    "precision",
                    "assign",
                    "intent",
                    "optional",
                    "pointer",
                    "target",
                    "in",
                    "out",
                    "common",
                    "equivalence",
                    "data"
                ],
                literal: [
                    ".False.",
                    ".True."
                ],
                built_in: [
                    "alog",
                    "alog10",
                    "amax0",
                    "amax1",
                    "amin0",
                    "amin1",
                    "amod",
                    "cabs",
                    "ccos",
                    "cexp",
                    "clog",
                    "csin",
                    "csqrt",
                    "dabs",
                    "dacos",
                    "dasin",
                    "datan",
                    "datan2",
                    "dcos",
                    "dcosh",
                    "ddim",
                    "dexp",
                    "dint",
                    "dlog",
                    "dlog10",
                    "dmax1",
                    "dmin1",
                    "dmod",
                    "dnint",
                    "dsign",
                    "dsin",
                    "dsinh",
                    "dsqrt",
                    "dtan",
                    "dtanh",
                    "float",
                    "iabs",
                    "idim",
                    "idint",
                    "idnint",
                    "ifix",
                    "isign",
                    "max0",
                    "max1",
                    "min0",
                    "min1",
                    "sngl",
                    "algama",
                    "cdabs",
                    "cdcos",
                    "cdexp",
                    "cdlog",
                    "cdsin",
                    "cdsqrt",
                    "cqabs",
                    "cqcos",
                    "cqexp",
                    "cqlog",
                    "cqsin",
                    "cqsqrt",
                    "dcmplx",
                    "dconjg",
                    "derf",
                    "derfc",
                    "dfloat",
                    "dgamma",
                    "dimag",
                    "dlgama",
                    "iqint",
                    "qabs",
                    "qacos",
                    "qasin",
                    "qatan",
                    "qatan2",
                    "qcmplx",
                    "qconjg",
                    "qcos",
                    "qcosh",
                    "qdim",
                    "qerf",
                    "qerfc",
                    "qexp",
                    "qgamma",
                    "qimag",
                    "qlgama",
                    "qlog",
                    "qlog10",
                    "qmax1",
                    "qmin1",
                    "qmod",
                    "qnint",
                    "qsign",
                    "qsin",
                    "qsinh",
                    "qsqrt",
                    "qtan",
                    "qtanh",
                    "abs",
                    "acos",
                    "aimag",
                    "aint",
                    "anint",
                    "asin",
                    "atan",
                    "atan2",
                    "char",
                    "cmplx",
                    "conjg",
                    "cos",
                    "cosh",
                    "exp",
                    "ichar",
                    "index",
                    "int",
                    "log",
                    "log10",
                    "max",
                    "min",
                    "nint",
                    "sign",
                    "sin",
                    "sinh",
                    "sqrt",
                    "tan",
                    "tanh",
                    "print",
                    "write",
                    "dim",
                    "lge",
                    "lgt",
                    "lle",
                    "llt",
                    "mod",
                    "nullify",
                    "allocate",
                    "deallocate",
                    "adjustl",
                    "adjustr",
                    "all",
                    "allocated",
                    "any",
                    "associated",
                    "bit_size",
                    "btest",
                    "ceiling",
                    "count",
                    "cshift",
                    "date_and_time",
                    "digits",
                    "dot_product",
                    "eoshift",
                    "epsilon",
                    "exponent",
                    "floor",
                    "fraction",
                    "huge",
                    "iand",
                    "ibclr",
                    "ibits",
                    "ibset",
                    "ieor",
                    "ior",
                    "ishft",
                    "ishftc",
                    "lbound",
                    "len_trim",
                    "matmul",
                    "maxexponent",
                    "maxloc",
                    "maxval",
                    "merge",
                    "minexponent",
                    "minloc",
                    "minval",
                    "modulo",
                    "mvbits",
                    "nearest",
                    "pack",
                    "present",
                    "product",
                    "radix",
                    "random_number",
                    "random_seed",
                    "range",
                    "repeat",
                    "reshape",
                    "rrspacing",
                    "scale",
                    "scan",
                    "selected_int_kind",
                    "selected_real_kind",
                    "set_exponent",
                    "shape",
                    "size",
                    "spacing",
                    "spread",
                    "sum",
                    "system_clock",
                    "tiny",
                    "transpose",
                    "trim",
                    "ubound",
                    "unpack",
                    "verify",
                    "achar",
                    "iachar",
                    "transfer",
                    "dble",
                    "entry",
                    "dprod",
                    "cpu_time",
                    "command_argument_count",
                    "get_command",
                    "get_command_argument",
                    "get_environment_variable",
                    "is_iostat_end",
                    "ieee_arithmetic",
                    "ieee_support_underflow_control",
                    "ieee_get_underflow_mode",
                    "ieee_set_underflow_mode",
                    "is_iostat_eor",
                    "move_alloc",
                    "new_line",
                    "selected_char_kind",
                    "same_type_as",
                    "extends_type_of",
                    "acosh",
                    "asinh",
                    "atanh",
                    "bessel_j0",
                    "bessel_j1",
                    "bessel_jn",
                    "bessel_y0",
                    "bessel_y1",
                    "bessel_yn",
                    "erf",
                    "erfc",
                    "erfc_scaled",
                    "gamma",
                    "log_gamma",
                    "hypot",
                    "norm2",
                    "atomic_define",
                    "atomic_ref",
                    "execute_command_line",
                    "leadz",
                    "trailz",
                    "storage_size",
                    "merge_bits",
                    "bge",
                    "bgt",
                    "ble",
                    "blt",
                    "dshiftl",
                    "dshiftr",
                    "findloc",
                    "iall",
                    "iany",
                    "iparity",
                    "image_index",
                    "lcobound",
                    "ucobound",
                    "maskl",
                    "maskr",
                    "num_images",
                    "parity",
                    "popcnt",
                    "poppar",
                    "shifta",
                    "shiftl",
                    "shiftr",
                    "this_image",
                    "sync",
                    "change",
                    "team",
                    "co_broadcast",
                    "co_max",
                    "co_min",
                    "co_sum",
                    "co_reduce"
                ]
            },
            illegal: /\/\*/,
            contains: [
                {
                    className: "string",
                    relevance: 0,
                    variants: [
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE
                    ]
                },
                o,
                {
                    begin: /^C\s*=(?!=)/,
                    relevance: 0
                },
                a,
                r
            ]
        };
    }), Ia)), Cs.registerLanguage("fsharp", function() {
        if (Da) return ya;
        function e(e) {
            return new RegExp(e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
        }
        function t(e) {
            return e ? "string" == typeof e ? e : e.source : null;
        }
        function a(e) {
            return n("(?=", e, ")");
        }
        function n(...e) {
            return e.map((e)=>t(e)).join("");
        }
        function i(...e) {
            const a = function(e) {
                const t = e[e.length - 1];
                return "object" == typeof t && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
            }(e);
            return "(" + (a.capture ? "" : "?:") + e.map((e)=>t(e)).join("|") + ")";
        }
        return Da = 1, ya = function(t) {
            const r = {
                scope: "keyword",
                match: /\b(yield|return|let|do|match|use)!/
            }, o = [
                "bool",
                "byte",
                "sbyte",
                "int8",
                "int16",
                "int32",
                "uint8",
                "uint16",
                "uint32",
                "int",
                "uint",
                "int64",
                "uint64",
                "nativeint",
                "unativeint",
                "decimal",
                "float",
                "double",
                "float32",
                "single",
                "char",
                "string",
                "unit",
                "bigint",
                "option",
                "voption",
                "list",
                "array",
                "seq",
                "byref",
                "exn",
                "inref",
                "nativeptr",
                "obj",
                "outref",
                "voidptr",
                "Result"
            ], s = {
                keyword: [
                    "abstract",
                    "and",
                    "as",
                    "assert",
                    "base",
                    "begin",
                    "class",
                    "default",
                    "delegate",
                    "do",
                    "done",
                    "downcast",
                    "downto",
                    "elif",
                    "else",
                    "end",
                    "exception",
                    "extern",
                    "finally",
                    "fixed",
                    "for",
                    "fun",
                    "function",
                    "global",
                    "if",
                    "in",
                    "inherit",
                    "inline",
                    "interface",
                    "internal",
                    "lazy",
                    "let",
                    "match",
                    "member",
                    "module",
                    "mutable",
                    "namespace",
                    "new",
                    "of",
                    "open",
                    "or",
                    "override",
                    "private",
                    "public",
                    "rec",
                    "return",
                    "static",
                    "struct",
                    "then",
                    "to",
                    "try",
                    "type",
                    "upcast",
                    "use",
                    "val",
                    "void",
                    "when",
                    "while",
                    "with",
                    "yield"
                ],
                literal: [
                    "true",
                    "false",
                    "null",
                    "Some",
                    "None",
                    "Ok",
                    "Error",
                    "infinity",
                    "infinityf",
                    "nan",
                    "nanf"
                ],
                built_in: [
                    "not",
                    "ref",
                    "raise",
                    "reraise",
                    "dict",
                    "readOnlyDict",
                    "set",
                    "get",
                    "enum",
                    "sizeof",
                    "typeof",
                    "typedefof",
                    "nameof",
                    "nullArg",
                    "invalidArg",
                    "invalidOp",
                    "id",
                    "fst",
                    "snd",
                    "ignore",
                    "lock",
                    "using",
                    "box",
                    "unbox",
                    "tryUnbox",
                    "printf",
                    "printfn",
                    "sprintf",
                    "eprintf",
                    "eprintfn",
                    "fprintf",
                    "fprintfn",
                    "failwith",
                    "failwithf"
                ],
                "variable.constant": [
                    "__LINE__",
                    "__SOURCE_DIRECTORY__",
                    "__SOURCE_FILE__"
                ]
            }, l = {
                variants: [
                    t.COMMENT(/\(\*(?!\))/, /\*\)/, {
                        contains: [
                            "self"
                        ]
                    }),
                    t.C_LINE_COMMENT_MODE
                ]
            }, c = {
                scope: "variable",
                begin: /``/,
                end: /``/
            }, _ = /\B('|\^)/, d = {
                scope: "symbol",
                variants: [
                    {
                        match: n(_, /``.*?``/)
                    },
                    {
                        match: n(_, t.UNDERSCORE_IDENT_RE)
                    }
                ],
                relevance: 0
            }, m = function({ includeEqual: t }) {
                let r;
                r = t ? "!%&*+-/<=>@^|~?" : "!%&*+-/<>@^|~?";
                const o = n("[", ...Array.from(r).map(e), "]"), s = i(o, /\./), l = n(s, a(s)), c = i(n(l, s, "*"), n(o, "+"));
                return {
                    scope: "operator",
                    match: i(c, /:\?>/, /:\?/, /:>/, /:=/, /::?/, /\$/),
                    relevance: 0
                };
            }, p = m({
                includeEqual: !0
            }), u = m({
                includeEqual: !1
            }), g = function(e, r) {
                return {
                    begin: n(e, a(n(/\s*/, i(/\w/, /'/, /\^/, /#/, /``/, /\(/, /{\|/)))),
                    beginScope: r,
                    end: a(i(/\n/, /=/)),
                    relevance: 0,
                    keywords: t.inherit(s, {
                        type: o
                    }),
                    contains: [
                        l,
                        d,
                        t.inherit(c, {
                            scope: null
                        }),
                        u
                    ]
                };
            }, E = g(/:/, "operator"), S = g(/\bof\b/, "keyword"), b = {
                begin: [
                    /(^|\s+)/,
                    /type/,
                    /\s+/,
                    /[a-zA-Z_](\w|')*/
                ],
                beginScope: {
                    2: "keyword",
                    4: "title.class"
                },
                end: a(/\(|=|$/),
                keywords: s,
                contains: [
                    l,
                    t.inherit(c, {
                        scope: null
                    }),
                    d,
                    {
                        scope: "operator",
                        match: /<|>/
                    },
                    E
                ]
            }, T = {
                scope: "computation-expression",
                match: /\b[_a-z]\w*(?=\s*\{)/
            }, C = {
                begin: [
                    /^\s*/,
                    n(/#/, i("if", "else", "endif", "line", "nowarn", "light", "r", "i", "I", "load", "time", "help", "quit")),
                    /\b/
                ],
                beginScope: {
                    2: "meta"
                },
                end: a(/\s|$/)
            }, f = {
                variants: [
                    t.BINARY_NUMBER_MODE,
                    t.C_NUMBER_MODE
                ]
            }, R = {
                scope: "string",
                begin: /"/,
                end: /"/,
                contains: [
                    t.BACKSLASH_ESCAPE
                ]
            }, N = {
                scope: "string",
                begin: /@"/,
                end: /"/,
                contains: [
                    {
                        match: /""/
                    },
                    t.BACKSLASH_ESCAPE
                ]
            }, O = {
                scope: "string",
                begin: /"""/,
                end: /"""/,
                relevance: 2
            }, h = {
                scope: "subst",
                begin: /\{/,
                end: /\}/,
                keywords: s
            }, v = {
                scope: "string",
                begin: /\$"/,
                end: /"/,
                contains: [
                    {
                        match: /\{\{/
                    },
                    {
                        match: /\}\}/
                    },
                    t.BACKSLASH_ESCAPE,
                    h
                ]
            }, I = {
                scope: "string",
                begin: /(\$@|@\$)"/,
                end: /"/,
                contains: [
                    {
                        match: /\{\{/
                    },
                    {
                        match: /\}\}/
                    },
                    {
                        match: /""/
                    },
                    t.BACKSLASH_ESCAPE,
                    h
                ]
            }, A = {
                scope: "string",
                begin: /\$"""/,
                end: /"""/,
                contains: [
                    {
                        match: /\{\{/
                    },
                    {
                        match: /\}\}/
                    },
                    h
                ],
                relevance: 2
            }, y = {
                scope: "string",
                match: n(/'/, i(/[^\\']/, /\\(?:.|\d{3}|x[a-fA-F\d]{2}|u[a-fA-F\d]{4}|U[a-fA-F\d]{8})/), /'/)
            };
            return h.contains = [
                I,
                v,
                N,
                R,
                y,
                r,
                l,
                c,
                E,
                T,
                C,
                f,
                d,
                p
            ], {
                name: "F#",
                aliases: [
                    "fs",
                    "f#"
                ],
                keywords: s,
                illegal: /\/\*/,
                classNameAliases: {
                    "computation-expression": "keyword"
                },
                contains: [
                    r,
                    {
                        variants: [
                            A,
                            I,
                            v,
                            O,
                            N,
                            R,
                            y
                        ]
                    },
                    l,
                    c,
                    b,
                    {
                        scope: "meta",
                        begin: /\[</,
                        end: />\]/,
                        relevance: 2,
                        contains: [
                            c,
                            O,
                            N,
                            R,
                            y,
                            f
                        ]
                    },
                    S,
                    E,
                    T,
                    C,
                    f,
                    d,
                    p
                ]
            };
        }, ya;
    }()), Cs.registerLanguage("gams", (La || (La = 1, Ma = function(e) {
        const t = e.regex, a = {
            keyword: "abort acronym acronyms alias all and assign binary card diag display else eq file files for free ge gt if integer le loop lt maximizing minimizing model models ne negative no not option options or ord positive prod put putpage puttl repeat sameas semicont semiint smax smin solve sos1 sos2 sum system table then until using while xor yes",
            literal: "eps inf na",
            built_in: "abs arccos arcsin arctan arctan2 Beta betaReg binomial ceil centropy cos cosh cvPower div div0 eDist entropy errorf execSeed exp fact floor frac gamma gammaReg log logBeta logGamma log10 log2 mapVal max min mod ncpCM ncpF ncpVUpow ncpVUsin normal pi poly power randBinomial randLinear randTriangle round rPower sigmoid sign signPower sin sinh slexp sllog10 slrec sqexp sqlog10 sqr sqrec sqrt tan tanh trunc uniform uniformInt vcPower bool_and bool_eqv bool_imp bool_not bool_or bool_xor ifThen rel_eq rel_ge rel_gt rel_le rel_lt rel_ne gday gdow ghour gleap gmillisec gminute gmonth gsecond gyear jdate jnow jstart jtime errorLevel execError gamsRelease gamsVersion handleCollect handleDelete handleStatus handleSubmit heapFree heapLimit heapSize jobHandle jobKill jobStatus jobTerminate licenseLevel licenseStatus maxExecError sleep timeClose timeComp timeElapsed timeExec timeStart"
        }, n = {
            className: "symbol",
            variants: [
                {
                    begin: /=[lgenxc]=/
                },
                {
                    begin: /\$/
                }
            ]
        }, i = {
            className: "comment",
            variants: [
                {
                    begin: "'",
                    end: "'"
                },
                {
                    begin: '"',
                    end: '"'
                }
            ],
            illegal: "\\n",
            contains: [
                e.BACKSLASH_ESCAPE
            ]
        }, r = {
            begin: "/",
            end: "/",
            keywords: a,
            contains: [
                i,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.APOS_STRING_MODE,
                e.C_NUMBER_MODE
            ]
        }, o = /[a-z0-9&#*=?@\\><:,()$[\]_.{}!+%^-]+/, s = {
            begin: /[a-z][a-z0-9_]*(\([a-z0-9_, ]*\))?[ \t]+/,
            excludeBegin: !0,
            end: "$",
            endsWithParent: !0,
            contains: [
                i,
                r,
                {
                    className: "comment",
                    begin: t.concat(o, t.anyNumberOfTimes(t.concat(/[ ]+/, o))),
                    relevance: 0
                }
            ]
        };
        return {
            name: "GAMS",
            aliases: [
                "gms"
            ],
            case_insensitive: !0,
            keywords: a,
            contains: [
                e.COMMENT(/^\$ontext/, /^\$offtext/),
                {
                    className: "meta",
                    begin: "^\\$[a-z0-9]+",
                    end: "$",
                    returnBegin: !0,
                    contains: [
                        {
                            className: "keyword",
                            begin: "^\\$[a-z0-9]+"
                        }
                    ]
                },
                e.COMMENT("^\\*", "$"),
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.APOS_STRING_MODE,
                {
                    beginKeywords: "set sets parameter parameters variable variables scalar scalars equation equations",
                    end: ";",
                    contains: [
                        e.COMMENT("^\\*", "$"),
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE,
                        e.QUOTE_STRING_MODE,
                        e.APOS_STRING_MODE,
                        r,
                        s
                    ]
                },
                {
                    beginKeywords: "table",
                    end: ";",
                    returnBegin: !0,
                    contains: [
                        {
                            beginKeywords: "table",
                            end: "$",
                            contains: [
                                s
                            ]
                        },
                        e.COMMENT("^\\*", "$"),
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE,
                        e.QUOTE_STRING_MODE,
                        e.APOS_STRING_MODE,
                        e.C_NUMBER_MODE
                    ]
                },
                {
                    className: "function",
                    begin: /^[a-z][a-z0-9_,\-+' ()$]+\.{2}/,
                    returnBegin: !0,
                    contains: [
                        {
                            className: "title",
                            begin: /^[a-z0-9_]+/
                        },
                        {
                            className: "params",
                            begin: /\(/,
                            end: /\)/,
                            excludeBegin: !0,
                            excludeEnd: !0
                        },
                        n
                    ]
                },
                e.C_NUMBER_MODE,
                n
            ]
        };
    }), Ma)), Cs.registerLanguage("gauss", (wa || (wa = 1, xa = function(e) {
        const t = {
            keyword: "bool break call callexe checkinterrupt clear clearg closeall cls comlog compile continue create debug declare delete disable dlibrary dllcall do dos ed edit else elseif enable end endfor endif endp endo errorlog errorlogat expr external fn for format goto gosub graph if keyword let lib library line load loadarray loadexe loadf loadk loadm loadp loads loadx local locate loopnextindex lprint lpwidth lshow matrix msym ndpclex new open output outwidth plot plotsym pop prcsn print printdos proc push retp return rndcon rndmod rndmult rndseed run save saveall screen scroll setarray show sparse stop string struct system trace trap threadfor threadendfor threadbegin threadjoin threadstat threadend until use while winprint ne ge le gt lt and xor or not eq eqv",
            built_in: "abs acf aconcat aeye amax amean AmericanBinomCall AmericanBinomCall_Greeks AmericanBinomCall_ImpVol AmericanBinomPut AmericanBinomPut_Greeks AmericanBinomPut_ImpVol AmericanBSCall AmericanBSCall_Greeks AmericanBSCall_ImpVol AmericanBSPut AmericanBSPut_Greeks AmericanBSPut_ImpVol amin amult annotationGetDefaults annotationSetBkd annotationSetFont annotationSetLineColor annotationSetLineStyle annotationSetLineThickness annualTradingDays arccos arcsin areshape arrayalloc arrayindex arrayinit arraytomat asciiload asclabel astd astds asum atan atan2 atranspose axmargin balance band bandchol bandcholsol bandltsol bandrv bandsolpd bar base10 begwind besselj bessely beta box boxcox cdfBeta cdfBetaInv cdfBinomial cdfBinomialInv cdfBvn cdfBvn2 cdfBvn2e cdfCauchy cdfCauchyInv cdfChic cdfChii cdfChinc cdfChincInv cdfExp cdfExpInv cdfFc cdfFnc cdfFncInv cdfGam cdfGenPareto cdfHyperGeo cdfLaplace cdfLaplaceInv cdfLogistic cdfLogisticInv cdfmControlCreate cdfMvn cdfMvn2e cdfMvnce cdfMvne cdfMvt2e cdfMvtce cdfMvte cdfN cdfN2 cdfNc cdfNegBinomial cdfNegBinomialInv cdfNi cdfPoisson cdfPoissonInv cdfRayleigh cdfRayleighInv cdfTc cdfTci cdfTnc cdfTvn cdfWeibull cdfWeibullInv cdir ceil ChangeDir chdir chiBarSquare chol choldn cholsol cholup chrs close code cols colsf combinate combinated complex con cond conj cons ConScore contour conv convertsatostr convertstrtosa corrm corrms corrvc corrx corrxs cos cosh counts countwts crossprd crout croutp csrcol csrlin csvReadM csvReadSA cumprodc cumsumc curve cvtos datacreate datacreatecomplex datalist dataload dataloop dataopen datasave date datestr datestring datestrymd dayinyr dayofweek dbAddDatabase dbClose dbCommit dbCreateQuery dbExecQuery dbGetConnectOptions dbGetDatabaseName dbGetDriverName dbGetDrivers dbGetHostName dbGetLastErrorNum dbGetLastErrorText dbGetNumericalPrecPolicy dbGetPassword dbGetPort dbGetTableHeaders dbGetTables dbGetUserName dbHasFeature dbIsDriverAvailable dbIsOpen dbIsOpenError dbOpen dbQueryBindValue dbQueryClear dbQueryCols dbQueryExecPrepared dbQueryFetchAllM dbQueryFetchAllSA dbQueryFetchOneM dbQueryFetchOneSA dbQueryFinish dbQueryGetBoundValue dbQueryGetBoundValues dbQueryGetField dbQueryGetLastErrorNum dbQueryGetLastErrorText dbQueryGetLastInsertID dbQueryGetLastQuery dbQueryGetPosition dbQueryIsActive dbQueryIsForwardOnly dbQueryIsNull dbQueryIsSelect dbQueryIsValid dbQueryPrepare dbQueryRows dbQuerySeek dbQuerySeekFirst dbQuerySeekLast dbQuerySeekNext dbQuerySeekPrevious dbQuerySetForwardOnly dbRemoveDatabase dbRollback dbSetConnectOptions dbSetDatabaseName dbSetHostName dbSetNumericalPrecPolicy dbSetPort dbSetUserName dbTransaction DeleteFile delif delrows denseToSp denseToSpRE denToZero design det detl dfft dffti diag diagrv digamma doswin DOSWinCloseall DOSWinOpen dotfeq dotfeqmt dotfge dotfgemt dotfgt dotfgtmt dotfle dotflemt dotflt dotfltmt dotfne dotfnemt draw drop dsCreate dstat dstatmt dstatmtControlCreate dtdate dtday dttime dttodtv dttostr dttoutc dtvnormal dtvtodt dtvtoutc dummy dummybr dummydn eig eigh eighv eigv elapsedTradingDays endwind envget eof eqSolve eqSolvemt eqSolvemtControlCreate eqSolvemtOutCreate eqSolveset erf erfc erfccplx erfcplx error etdays ethsec etstr EuropeanBinomCall EuropeanBinomCall_Greeks EuropeanBinomCall_ImpVol EuropeanBinomPut EuropeanBinomPut_Greeks EuropeanBinomPut_ImpVol EuropeanBSCall EuropeanBSCall_Greeks EuropeanBSCall_ImpVol EuropeanBSPut EuropeanBSPut_Greeks EuropeanBSPut_ImpVol exctsmpl exec execbg exp extern eye fcheckerr fclearerr feq feqmt fflush fft ffti fftm fftmi fftn fge fgemt fgets fgetsa fgetsat fgetst fgt fgtmt fileinfo filesa fle flemt floor flt fltmt fmod fne fnemt fonts fopen formatcv formatnv fputs fputst fseek fstrerror ftell ftocv ftos ftostrC gamma gammacplx gammaii gausset gdaAppend gdaCreate gdaDStat gdaDStatMat gdaGetIndex gdaGetName gdaGetNames gdaGetOrders gdaGetType gdaGetTypes gdaGetVarInfo gdaIsCplx gdaLoad gdaPack gdaRead gdaReadByIndex gdaReadSome gdaReadSparse gdaReadStruct gdaReportVarInfo gdaSave gdaUpdate gdaUpdateAndPack gdaVars gdaWrite gdaWrite32 gdaWriteSome getarray getdims getf getGAUSShome getmatrix getmatrix4D getname getnamef getNextTradingDay getNextWeekDay getnr getorders getpath getPreviousTradingDay getPreviousWeekDay getRow getscalar3D getscalar4D getTrRow getwind glm gradcplx gradMT gradMTm gradMTT gradMTTm gradp graphprt graphset hasimag header headermt hess hessMT hessMTg hessMTgw hessMTm hessMTmw hessMTT hessMTTg hessMTTgw hessMTTm hessMTw hessp hist histf histp hsec imag indcv indexcat indices indices2 indicesf indicesfn indnv indsav integrate1d integrateControlCreate intgrat2 intgrat3 inthp1 inthp2 inthp3 inthp4 inthpControlCreate intquad1 intquad2 intquad3 intrleav intrleavsa intrsect intsimp inv invpd invswp iscplx iscplxf isden isinfnanmiss ismiss key keyav keyw lag lag1 lagn lapEighb lapEighi lapEighvb lapEighvi lapgEig lapgEigh lapgEighv lapgEigv lapgSchur lapgSvdcst lapgSvds lapgSvdst lapSvdcusv lapSvds lapSvdusv ldlp ldlsol linSolve listwise ln lncdfbvn lncdfbvn2 lncdfmvn lncdfn lncdfn2 lncdfnc lnfact lngammacplx lnpdfmvn lnpdfmvt lnpdfn lnpdft loadd loadstruct loadwind loess loessmt loessmtControlCreate log loglog logx logy lower lowmat lowmat1 ltrisol lu lusol machEpsilon make makevars makewind margin matalloc matinit mattoarray maxbytes maxc maxindc maxv maxvec mbesselei mbesselei0 mbesselei1 mbesseli mbesseli0 mbesseli1 meanc median mergeby mergevar minc minindc minv miss missex missrv moment momentd movingave movingaveExpwgt movingaveWgt nextindex nextn nextnevn nextwind ntos null null1 numCombinations ols olsmt olsmtControlCreate olsqr olsqr2 olsqrmt ones optn optnevn orth outtyp pacf packedToSp packr parse pause pdfCauchy pdfChi pdfExp pdfGenPareto pdfHyperGeo pdfLaplace pdfLogistic pdfn pdfPoisson pdfRayleigh pdfWeibull pi pinv pinvmt plotAddArrow plotAddBar plotAddBox plotAddHist plotAddHistF plotAddHistP plotAddPolar plotAddScatter plotAddShape plotAddTextbox plotAddTS plotAddXY plotArea plotBar plotBox plotClearLayout plotContour plotCustomLayout plotGetDefaults plotHist plotHistF plotHistP plotLayout plotLogLog plotLogX plotLogY plotOpenWindow plotPolar plotSave plotScatter plotSetAxesPen plotSetBar plotSetBarFill plotSetBarStacked plotSetBkdColor plotSetFill plotSetGrid plotSetLegend plotSetLineColor plotSetLineStyle plotSetLineSymbol plotSetLineThickness plotSetNewWindow plotSetTitle plotSetWhichYAxis plotSetXAxisShow plotSetXLabel plotSetXRange plotSetXTicInterval plotSetXTicLabel plotSetYAxisShow plotSetYLabel plotSetYRange plotSetZAxisShow plotSetZLabel plotSurface plotTS plotXY polar polychar polyeval polygamma polyint polymake polymat polymroot polymult polyroot pqgwin previousindex princomp printfm printfmt prodc psi putarray putf putvals pvCreate pvGetIndex pvGetParNames pvGetParVector pvLength pvList pvPack pvPacki pvPackm pvPackmi pvPacks pvPacksi pvPacksm pvPacksmi pvPutParVector pvTest pvUnpack QNewton QNewtonmt QNewtonmtControlCreate QNewtonmtOutCreate QNewtonSet QProg QProgmt QProgmtInCreate qqr qqre qqrep qr qre qrep qrsol qrtsol qtyr qtyre qtyrep quantile quantiled qyr qyre qyrep qz rank rankindx readr real reclassify reclassifyCuts recode recserar recsercp recserrc rerun rescale reshape rets rev rfft rffti rfftip rfftn rfftnp rfftp rndBernoulli rndBeta rndBinomial rndCauchy rndChiSquare rndCon rndCreateState rndExp rndGamma rndGeo rndGumbel rndHyperGeo rndi rndKMbeta rndKMgam rndKMi rndKMn rndKMnb rndKMp rndKMu rndKMvm rndLaplace rndLCbeta rndLCgam rndLCi rndLCn rndLCnb rndLCp rndLCu rndLCvm rndLogNorm rndMTu rndMVn rndMVt rndn rndnb rndNegBinomial rndp rndPoisson rndRayleigh rndStateSkip rndu rndvm rndWeibull rndWishart rotater round rows rowsf rref sampleData satostrC saved saveStruct savewind scale scale3d scalerr scalinfnanmiss scalmiss schtoc schur searchsourcepath seekr select selif seqa seqm setdif setdifsa setvars setvwrmode setwind shell shiftr sin singleindex sinh sleep solpd sortc sortcc sortd sorthc sorthcc sortind sortindc sortmc sortr sortrc spBiconjGradSol spChol spConjGradSol spCreate spDenseSubmat spDiagRvMat spEigv spEye spLDL spline spLU spNumNZE spOnes spreadSheetReadM spreadSheetReadSA spreadSheetWrite spScale spSubmat spToDense spTrTDense spTScalar spZeros sqpSolve sqpSolveMT sqpSolveMTControlCreate sqpSolveMTlagrangeCreate sqpSolveMToutCreate sqpSolveSet sqrt statements stdc stdsc stocv stof strcombine strindx strlen strput strrindx strsect strsplit strsplitPad strtodt strtof strtofcplx strtriml strtrimr strtrunc strtruncl strtruncpad strtruncr submat subscat substute subvec sumc sumr surface svd svd1 svd2 svdcusv svds svdusv sysstate tab tan tanh tempname time timedt timestr timeutc title tkf2eps tkf2ps tocart todaydt toeplitz token topolar trapchk trigamma trimr trunc type typecv typef union unionsa uniqindx uniqindxsa unique uniquesa upmat upmat1 upper utctodt utctodtv utrisol vals varCovMS varCovXS varget vargetl varmall varmares varput varputl vartypef vcm vcms vcx vcxs vec vech vecr vector vget view viewxyz vlist vnamecv volume vput vread vtypecv wait waitc walkindex where window writer xlabel xlsGetSheetCount xlsGetSheetSize xlsGetSheetTypes xlsMakeRange xlsReadM xlsReadSA xlsWrite xlsWriteM xlsWriteSA xpnd xtics xy xyz ylabel ytics zeros zeta zlabel ztics cdfEmpirical dot h5create h5open h5read h5readAttribute h5write h5writeAttribute ldl plotAddErrorBar plotAddSurface plotCDFEmpirical plotSetColormap plotSetContourLabels plotSetLegendFont plotSetTextInterpreter plotSetXTicCount plotSetYTicCount plotSetZLevels powerm strjoin sylvester strtrim",
            literal: "DB_AFTER_LAST_ROW DB_ALL_TABLES DB_BATCH_OPERATIONS DB_BEFORE_FIRST_ROW DB_BLOB DB_EVENT_NOTIFICATIONS DB_FINISH_QUERY DB_HIGH_PRECISION DB_LAST_INSERT_ID DB_LOW_PRECISION_DOUBLE DB_LOW_PRECISION_INT32 DB_LOW_PRECISION_INT64 DB_LOW_PRECISION_NUMBERS DB_MULTIPLE_RESULT_SETS DB_NAMED_PLACEHOLDERS DB_POSITIONAL_PLACEHOLDERS DB_PREPARED_QUERIES DB_QUERY_SIZE DB_SIMPLE_LOCKING DB_SYSTEM_TABLES DB_TABLES DB_TRANSACTIONS DB_UNICODE DB_VIEWS __STDIN __STDOUT __STDERR __FILE_DIR"
        }, a = e.COMMENT("@", "@"), n = {
            className: "meta",
            begin: "#",
            end: "$",
            keywords: {
                keyword: "define definecs|10 undef ifdef ifndef iflight ifdllcall ifmac ifos2win ifunix else endif lineson linesoff srcfile srcline"
            },
            contains: [
                {
                    begin: /\\\n/,
                    relevance: 0
                },
                {
                    beginKeywords: "include",
                    end: "$",
                    keywords: {
                        keyword: "include"
                    },
                    contains: [
                        {
                            className: "string",
                            begin: '"',
                            end: '"',
                            illegal: "\\n"
                        }
                    ]
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                a
            ]
        }, i = {
            begin: /\bstruct\s+/,
            end: /\s/,
            keywords: "struct",
            contains: [
                {
                    className: "type",
                    begin: e.UNDERSCORE_IDENT_RE,
                    relevance: 0
                }
            ]
        }, r = [
            {
                className: "params",
                begin: /\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0,
                endsWithParent: !0,
                relevance: 0,
                contains: [
                    {
                        className: "literal",
                        begin: /\.\.\./
                    },
                    e.C_NUMBER_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    a,
                    i
                ]
            }
        ], o = {
            className: "title",
            begin: e.UNDERSCORE_IDENT_RE,
            relevance: 0
        }, s = function(t, n, i) {
            const s = e.inherit({
                className: "function",
                beginKeywords: t,
                end: n,
                excludeEnd: !0,
                contains: [].concat(r)
            }, i || {});
            return s.contains.push(o), s.contains.push(e.C_NUMBER_MODE), s.contains.push(e.C_BLOCK_COMMENT_MODE), s.contains.push(a), s;
        }, l = {
            className: "built_in",
            begin: "\\b(" + t.built_in.split(" ").join("|") + ")\\b"
        }, c = {
            className: "string",
            begin: '"',
            end: '"',
            contains: [
                e.BACKSLASH_ESCAPE
            ],
            relevance: 0
        }, _ = {
            begin: e.UNDERSCORE_IDENT_RE + "\\s*\\(",
            returnBegin: !0,
            keywords: t,
            relevance: 0,
            contains: [
                {
                    beginKeywords: t.keyword
                },
                l,
                {
                    className: "built_in",
                    begin: e.UNDERSCORE_IDENT_RE,
                    relevance: 0
                }
            ]
        }, d = {
            begin: /\(/,
            end: /\)/,
            relevance: 0,
            keywords: {
                built_in: t.built_in,
                literal: t.literal
            },
            contains: [
                e.C_NUMBER_MODE,
                e.C_BLOCK_COMMENT_MODE,
                a,
                l,
                _,
                c,
                "self"
            ]
        };
        return _.contains.push(d), {
            name: "GAUSS",
            aliases: [
                "gss"
            ],
            case_insensitive: !0,
            keywords: t,
            illegal: /(\{[%#]|[%#]\}| <- )/,
            contains: [
                e.C_NUMBER_MODE,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                a,
                c,
                n,
                {
                    className: "keyword",
                    begin: /\bexternal (matrix|string|array|sparse matrix|struct|proc|keyword|fn)/
                },
                s("proc keyword", ";"),
                s("fn", "="),
                {
                    beginKeywords: "for threadfor",
                    end: /;/,
                    relevance: 0,
                    contains: [
                        e.C_BLOCK_COMMENT_MODE,
                        a,
                        d
                    ]
                },
                {
                    variants: [
                        {
                            begin: e.UNDERSCORE_IDENT_RE + "\\." + e.UNDERSCORE_IDENT_RE
                        },
                        {
                            begin: e.UNDERSCORE_IDENT_RE + "\\s*="
                        }
                    ],
                    relevance: 0
                },
                _,
                i
            ]
        };
    }), xa)), Cs.registerLanguage("gcode", (ka || (ka = 1, Pa = function(e) {
        const t = {
            $pattern: "[A-Z_][A-Z0-9_.]*",
            keyword: "IF DO WHILE ENDWHILE CALL ENDIF SUB ENDSUB GOTO REPEAT ENDREPEAT EQ LT GT NE GE LE OR XOR"
        }, a = e.inherit(e.C_NUMBER_MODE, {
            begin: "([-+]?((\\.\\d+)|(\\d+)(\\.\\d*)?))|" + e.C_NUMBER_RE
        }), n = [
            e.C_LINE_COMMENT_MODE,
            e.C_BLOCK_COMMENT_MODE,
            e.COMMENT(/\(/, /\)/),
            a,
            e.inherit(e.APOS_STRING_MODE, {
                illegal: null
            }),
            e.inherit(e.QUOTE_STRING_MODE, {
                illegal: null
            }),
            {
                className: "name",
                begin: "([G])([0-9]+\\.?[0-9]?)"
            },
            {
                className: "name",
                begin: "([M])([0-9]+\\.?[0-9]?)"
            },
            {
                className: "attr",
                begin: "(VC|VS|#)",
                end: "(\\d+)"
            },
            {
                className: "attr",
                begin: "(VZOFX|VZOFY|VZOFZ)"
            },
            {
                className: "built_in",
                begin: "(ATAN|ABS|ACOS|ASIN|SIN|COS|EXP|FIX|FUP|ROUND|LN|TAN)(\\[)",
                contains: [
                    a
                ],
                end: "\\]"
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: "N",
                        end: "\\d+",
                        illegal: "\\W"
                    }
                ]
            }
        ];
        return {
            name: "G-code (ISO 6983)",
            aliases: [
                "nc"
            ],
            case_insensitive: !0,
            keywords: t,
            contains: [
                {
                    className: "meta",
                    begin: "%"
                },
                {
                    className: "meta",
                    begin: "([O])([0-9]+)"
                }
            ].concat(n)
        };
    }), Pa)), Cs.registerLanguage("gherkin", (Fa || (Fa = 1, Ua = function(e) {
        return {
            name: "Gherkin",
            aliases: [
                "feature"
            ],
            keywords: "Feature Background Ability Business Need Scenario Scenarios Scenario Outline Scenario Template Examples Given And Then But When",
            contains: [
                {
                    className: "symbol",
                    begin: "\\*",
                    relevance: 0
                },
                {
                    className: "meta",
                    begin: "@[^@\\s]+"
                },
                {
                    begin: "\\|",
                    end: "\\|\\w*$",
                    contains: [
                        {
                            className: "string",
                            begin: "[^|]+"
                        }
                    ]
                },
                {
                    className: "variable",
                    begin: "<",
                    end: ">"
                },
                e.HASH_COMMENT_MODE,
                {
                    className: "string",
                    begin: '"""',
                    end: '"""'
                },
                e.QUOTE_STRING_MODE
            ]
        };
    }), Ua)), Cs.registerLanguage("glsl", (Ga || (Ga = 1, Ba = function(e) {
        return {
            name: "GLSL",
            keywords: {
                keyword: "break continue discard do else for if return while switch case default attribute binding buffer ccw centroid centroid varying coherent column_major const cw depth_any depth_greater depth_less depth_unchanged early_fragment_tests equal_spacing flat fractional_even_spacing fractional_odd_spacing highp in index inout invariant invocations isolines layout line_strip lines lines_adjacency local_size_x local_size_y local_size_z location lowp max_vertices mediump noperspective offset origin_upper_left out packed patch pixel_center_integer point_mode points precise precision quads r11f_g11f_b10f r16 r16_snorm r16f r16i r16ui r32f r32i r32ui r8 r8_snorm r8i r8ui readonly restrict rg16 rg16_snorm rg16f rg16i rg16ui rg32f rg32i rg32ui rg8 rg8_snorm rg8i rg8ui rgb10_a2 rgb10_a2ui rgba16 rgba16_snorm rgba16f rgba16i rgba16ui rgba32f rgba32i rgba32ui rgba8 rgba8_snorm rgba8i rgba8ui row_major sample shared smooth std140 std430 stream triangle_strip triangles triangles_adjacency uniform varying vertices volatile writeonly",
                type: "atomic_uint bool bvec2 bvec3 bvec4 dmat2 dmat2x2 dmat2x3 dmat2x4 dmat3 dmat3x2 dmat3x3 dmat3x4 dmat4 dmat4x2 dmat4x3 dmat4x4 double dvec2 dvec3 dvec4 float iimage1D iimage1DArray iimage2D iimage2DArray iimage2DMS iimage2DMSArray iimage2DRect iimage3D iimageBuffer iimageCube iimageCubeArray image1D image1DArray image2D image2DArray image2DMS image2DMSArray image2DRect image3D imageBuffer imageCube imageCubeArray int isampler1D isampler1DArray isampler2D isampler2DArray isampler2DMS isampler2DMSArray isampler2DRect isampler3D isamplerBuffer isamplerCube isamplerCubeArray ivec2 ivec3 ivec4 mat2 mat2x2 mat2x3 mat2x4 mat3 mat3x2 mat3x3 mat3x4 mat4 mat4x2 mat4x3 mat4x4 sampler1D sampler1DArray sampler1DArrayShadow sampler1DShadow sampler2D sampler2DArray sampler2DArrayShadow sampler2DMS sampler2DMSArray sampler2DRect sampler2DRectShadow sampler2DShadow sampler3D samplerBuffer samplerCube samplerCubeArray samplerCubeArrayShadow samplerCubeShadow image1D uimage1DArray uimage2D uimage2DArray uimage2DMS uimage2DMSArray uimage2DRect uimage3D uimageBuffer uimageCube uimageCubeArray uint usampler1D usampler1DArray usampler2D usampler2DArray usampler2DMS usampler2DMSArray usampler2DRect usampler3D samplerBuffer usamplerCube usamplerCubeArray uvec2 uvec3 uvec4 vec2 vec3 vec4 void",
                built_in: "gl_MaxAtomicCounterBindings gl_MaxAtomicCounterBufferSize gl_MaxClipDistances gl_MaxClipPlanes gl_MaxCombinedAtomicCounterBuffers gl_MaxCombinedAtomicCounters gl_MaxCombinedImageUniforms gl_MaxCombinedImageUnitsAndFragmentOutputs gl_MaxCombinedTextureImageUnits gl_MaxComputeAtomicCounterBuffers gl_MaxComputeAtomicCounters gl_MaxComputeImageUniforms gl_MaxComputeTextureImageUnits gl_MaxComputeUniformComponents gl_MaxComputeWorkGroupCount gl_MaxComputeWorkGroupSize gl_MaxDrawBuffers gl_MaxFragmentAtomicCounterBuffers gl_MaxFragmentAtomicCounters gl_MaxFragmentImageUniforms gl_MaxFragmentInputComponents gl_MaxFragmentInputVectors gl_MaxFragmentUniformComponents gl_MaxFragmentUniformVectors gl_MaxGeometryAtomicCounterBuffers gl_MaxGeometryAtomicCounters gl_MaxGeometryImageUniforms gl_MaxGeometryInputComponents gl_MaxGeometryOutputComponents gl_MaxGeometryOutputVertices gl_MaxGeometryTextureImageUnits gl_MaxGeometryTotalOutputComponents gl_MaxGeometryUniformComponents gl_MaxGeometryVaryingComponents gl_MaxImageSamples gl_MaxImageUnits gl_MaxLights gl_MaxPatchVertices gl_MaxProgramTexelOffset gl_MaxTessControlAtomicCounterBuffers gl_MaxTessControlAtomicCounters gl_MaxTessControlImageUniforms gl_MaxTessControlInputComponents gl_MaxTessControlOutputComponents gl_MaxTessControlTextureImageUnits gl_MaxTessControlTotalOutputComponents gl_MaxTessControlUniformComponents gl_MaxTessEvaluationAtomicCounterBuffers gl_MaxTessEvaluationAtomicCounters gl_MaxTessEvaluationImageUniforms gl_MaxTessEvaluationInputComponents gl_MaxTessEvaluationOutputComponents gl_MaxTessEvaluationTextureImageUnits gl_MaxTessEvaluationUniformComponents gl_MaxTessGenLevel gl_MaxTessPatchComponents gl_MaxTextureCoords gl_MaxTextureImageUnits gl_MaxTextureUnits gl_MaxVaryingComponents gl_MaxVaryingFloats gl_MaxVaryingVectors gl_MaxVertexAtomicCounterBuffers gl_MaxVertexAtomicCounters gl_MaxVertexAttribs gl_MaxVertexImageUniforms gl_MaxVertexOutputComponents gl_MaxVertexOutputVectors gl_MaxVertexTextureImageUnits gl_MaxVertexUniformComponents gl_MaxVertexUniformVectors gl_MaxViewports gl_MinProgramTexelOffset gl_BackColor gl_BackLightModelProduct gl_BackLightProduct gl_BackMaterial gl_BackSecondaryColor gl_ClipDistance gl_ClipPlane gl_ClipVertex gl_Color gl_DepthRange gl_EyePlaneQ gl_EyePlaneR gl_EyePlaneS gl_EyePlaneT gl_Fog gl_FogCoord gl_FogFragCoord gl_FragColor gl_FragCoord gl_FragData gl_FragDepth gl_FrontColor gl_FrontFacing gl_FrontLightModelProduct gl_FrontLightProduct gl_FrontMaterial gl_FrontSecondaryColor gl_GlobalInvocationID gl_InstanceID gl_InvocationID gl_Layer gl_LightModel gl_LightSource gl_LocalInvocationID gl_LocalInvocationIndex gl_ModelViewMatrix gl_ModelViewMatrixInverse gl_ModelViewMatrixInverseTranspose gl_ModelViewMatrixTranspose gl_ModelViewProjectionMatrix gl_ModelViewProjectionMatrixInverse gl_ModelViewProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixTranspose gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_Normal gl_NormalMatrix gl_NormalScale gl_NumSamples gl_NumWorkGroups gl_ObjectPlaneQ gl_ObjectPlaneR gl_ObjectPlaneS gl_ObjectPlaneT gl_PatchVerticesIn gl_Point gl_PointCoord gl_PointSize gl_Position gl_PrimitiveID gl_PrimitiveIDIn gl_ProjectionMatrix gl_ProjectionMatrixInverse gl_ProjectionMatrixInverseTranspose gl_ProjectionMatrixTranspose gl_SampleID gl_SampleMask gl_SampleMaskIn gl_SamplePosition gl_SecondaryColor gl_TessCoord gl_TessLevelInner gl_TessLevelOuter gl_TexCoord gl_TextureEnvColor gl_TextureMatrix gl_TextureMatrixInverse gl_TextureMatrixInverseTranspose gl_TextureMatrixTranspose gl_Vertex gl_VertexID gl_ViewportIndex gl_WorkGroupID gl_WorkGroupSize gl_in gl_out EmitStreamVertex EmitVertex EndPrimitive EndStreamPrimitive abs acos acosh all any asin asinh atan atanh atomicAdd atomicAnd atomicCompSwap atomicCounter atomicCounterDecrement atomicCounterIncrement atomicExchange atomicMax atomicMin atomicOr atomicXor barrier bitCount bitfieldExtract bitfieldInsert bitfieldReverse ceil clamp cos cosh cross dFdx dFdy degrees determinant distance dot equal exp exp2 faceforward findLSB findMSB floatBitsToInt floatBitsToUint floor fma fract frexp ftransform fwidth greaterThan greaterThanEqual groupMemoryBarrier imageAtomicAdd imageAtomicAnd imageAtomicCompSwap imageAtomicExchange imageAtomicMax imageAtomicMin imageAtomicOr imageAtomicXor imageLoad imageSize imageStore imulExtended intBitsToFloat interpolateAtCentroid interpolateAtOffset interpolateAtSample inverse inversesqrt isinf isnan ldexp length lessThan lessThanEqual log log2 matrixCompMult max memoryBarrier memoryBarrierAtomicCounter memoryBarrierBuffer memoryBarrierImage memoryBarrierShared min mix mod modf noise1 noise2 noise3 noise4 normalize not notEqual outerProduct packDouble2x32 packHalf2x16 packSnorm2x16 packSnorm4x8 packUnorm2x16 packUnorm4x8 pow radians reflect refract round roundEven shadow1D shadow1DLod shadow1DProj shadow1DProjLod shadow2D shadow2DLod shadow2DProj shadow2DProjLod sign sin sinh smoothstep sqrt step tan tanh texelFetch texelFetchOffset texture texture1D texture1DLod texture1DProj texture1DProjLod texture2D texture2DLod texture2DProj texture2DProjLod texture3D texture3DLod texture3DProj texture3DProjLod textureCube textureCubeLod textureGather textureGatherOffset textureGatherOffsets textureGrad textureGradOffset textureLod textureLodOffset textureOffset textureProj textureProjGrad textureProjGradOffset textureProjLod textureProjLodOffset textureProjOffset textureQueryLevels textureQueryLod textureSize transpose trunc uaddCarry uintBitsToFloat umulExtended unpackDouble2x32 unpackHalf2x16 unpackSnorm2x16 unpackSnorm4x8 unpackUnorm2x16 unpackUnorm4x8 usubBorrow",
                literal: "true false"
            },
            illegal: '"',
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.C_NUMBER_MODE,
                {
                    className: "meta",
                    begin: "#",
                    end: "$"
                }
            ]
        };
    }), Ba)), Cs.registerLanguage("gml", (Ha || (Ha = 1, Ya = function(e) {
        return {
            name: "GML",
            case_insensitive: !1,
            keywords: {
                keyword: [
                    "#endregion",
                    "#macro",
                    "#region",
                    "and",
                    "begin",
                    "break",
                    "case",
                    "constructor",
                    "continue",
                    "default",
                    "delete",
                    "div",
                    "do",
                    "else",
                    "end",
                    "enum",
                    "exit",
                    "for",
                    "function",
                    "globalvar",
                    "if",
                    "mod",
                    "not",
                    "or",
                    "repeat",
                    "return",
                    "switch",
                    "then",
                    "until",
                    "var",
                    "while",
                    "with",
                    "xor"
                ],
                built_in: [
                    "abs",
                    "achievement_available",
                    "achievement_event",
                    "achievement_get_challenges",
                    "achievement_get_info",
                    "achievement_get_pic",
                    "achievement_increment",
                    "achievement_load_friends",
                    "achievement_load_leaderboard",
                    "achievement_load_progress",
                    "achievement_login",
                    "achievement_login_status",
                    "achievement_logout",
                    "achievement_post",
                    "achievement_post_score",
                    "achievement_reset",
                    "achievement_send_challenge",
                    "achievement_show",
                    "achievement_show_achievements",
                    "achievement_show_challenge_notifications",
                    "achievement_show_leaderboards",
                    "action_inherited",
                    "action_kill_object",
                    "ads_disable",
                    "ads_enable",
                    "ads_engagement_active",
                    "ads_engagement_available",
                    "ads_engagement_launch",
                    "ads_event",
                    "ads_event_preload",
                    "ads_get_display_height",
                    "ads_get_display_width",
                    "ads_interstitial_available",
                    "ads_interstitial_display",
                    "ads_move",
                    "ads_set_reward_callback",
                    "ads_setup",
                    "alarm_get",
                    "alarm_set",
                    "analytics_event",
                    "analytics_event_ext",
                    "angle_difference",
                    "ansi_char",
                    "application_get_position",
                    "application_surface_draw_enable",
                    "application_surface_enable",
                    "application_surface_is_enabled",
                    "arccos",
                    "arcsin",
                    "arctan",
                    "arctan2",
                    "array_copy",
                    "array_create",
                    "array_delete",
                    "array_equals",
                    "array_height_2d",
                    "array_insert",
                    "array_length",
                    "array_length_1d",
                    "array_length_2d",
                    "array_pop",
                    "array_push",
                    "array_resize",
                    "array_sort",
                    "asset_get_index",
                    "asset_get_type",
                    "audio_channel_num",
                    "audio_create_buffer_sound",
                    "audio_create_play_queue",
                    "audio_create_stream",
                    "audio_create_sync_group",
                    "audio_debug",
                    "audio_destroy_stream",
                    "audio_destroy_sync_group",
                    "audio_emitter_create",
                    "audio_emitter_exists",
                    "audio_emitter_falloff",
                    "audio_emitter_free",
                    "audio_emitter_gain",
                    "audio_emitter_get_gain",
                    "audio_emitter_get_listener_mask",
                    "audio_emitter_get_pitch",
                    "audio_emitter_get_vx",
                    "audio_emitter_get_vy",
                    "audio_emitter_get_vz",
                    "audio_emitter_get_x",
                    "audio_emitter_get_y",
                    "audio_emitter_get_z",
                    "audio_emitter_pitch",
                    "audio_emitter_position",
                    "audio_emitter_set_listener_mask",
                    "audio_emitter_velocity",
                    "audio_exists",
                    "audio_falloff_set_model",
                    "audio_free_buffer_sound",
                    "audio_free_play_queue",
                    "audio_get_listener_count",
                    "audio_get_listener_info",
                    "audio_get_listener_mask",
                    "audio_get_master_gain",
                    "audio_get_name",
                    "audio_get_recorder_count",
                    "audio_get_recorder_info",
                    "audio_get_type",
                    "audio_group_is_loaded",
                    "audio_group_load",
                    "audio_group_load_progress",
                    "audio_group_name",
                    "audio_group_set_gain",
                    "audio_group_stop_all",
                    "audio_group_unload",
                    "audio_is_paused",
                    "audio_is_playing",
                    "audio_listener_get_data",
                    "audio_listener_orientation",
                    "audio_listener_position",
                    "audio_listener_set_orientation",
                    "audio_listener_set_position",
                    "audio_listener_set_velocity",
                    "audio_listener_velocity",
                    "audio_master_gain",
                    "audio_music_gain",
                    "audio_music_is_playing",
                    "audio_pause_all",
                    "audio_pause_music",
                    "audio_pause_sound",
                    "audio_pause_sync_group",
                    "audio_play_in_sync_group",
                    "audio_play_music",
                    "audio_play_sound",
                    "audio_play_sound_at",
                    "audio_play_sound_on",
                    "audio_queue_sound",
                    "audio_resume_all",
                    "audio_resume_music",
                    "audio_resume_sound",
                    "audio_resume_sync_group",
                    "audio_set_listener_mask",
                    "audio_set_master_gain",
                    "audio_sound_gain",
                    "audio_sound_get_gain",
                    "audio_sound_get_listener_mask",
                    "audio_sound_get_pitch",
                    "audio_sound_get_track_position",
                    "audio_sound_length",
                    "audio_sound_pitch",
                    "audio_sound_set_listener_mask",
                    "audio_sound_set_track_position",
                    "audio_start_recording",
                    "audio_start_sync_group",
                    "audio_stop_all",
                    "audio_stop_music",
                    "audio_stop_recording",
                    "audio_stop_sound",
                    "audio_stop_sync_group",
                    "audio_sync_group_debug",
                    "audio_sync_group_get_track_pos",
                    "audio_sync_group_is_playing",
                    "audio_system",
                    "background_get_height",
                    "background_get_width",
                    "base64_decode",
                    "base64_encode",
                    "browser_input_capture",
                    "buffer_async_group_begin",
                    "buffer_async_group_end",
                    "buffer_async_group_option",
                    "buffer_base64_decode",
                    "buffer_base64_decode_ext",
                    "buffer_base64_encode",
                    "buffer_copy",
                    "buffer_copy_from_vertex_buffer",
                    "buffer_create",
                    "buffer_create_from_vertex_buffer",
                    "buffer_create_from_vertex_buffer_ext",
                    "buffer_delete",
                    "buffer_exists",
                    "buffer_fill",
                    "buffer_get_address",
                    "buffer_get_alignment",
                    "buffer_get_size",
                    "buffer_get_surface",
                    "buffer_get_type",
                    "buffer_load",
                    "buffer_load_async",
                    "buffer_load_ext",
                    "buffer_load_partial",
                    "buffer_md5",
                    "buffer_peek",
                    "buffer_poke",
                    "buffer_read",
                    "buffer_resize",
                    "buffer_save",
                    "buffer_save_async",
                    "buffer_save_ext",
                    "buffer_seek",
                    "buffer_set_surface",
                    "buffer_sha1",
                    "buffer_sizeof",
                    "buffer_tell",
                    "buffer_write",
                    "camera_apply",
                    "camera_create",
                    "camera_create_view",
                    "camera_destroy",
                    "camera_get_active",
                    "camera_get_begin_script",
                    "camera_get_default",
                    "camera_get_end_script",
                    "camera_get_proj_mat",
                    "camera_get_update_script",
                    "camera_get_view_angle",
                    "camera_get_view_border_x",
                    "camera_get_view_border_y",
                    "camera_get_view_height",
                    "camera_get_view_mat",
                    "camera_get_view_speed_x",
                    "camera_get_view_speed_y",
                    "camera_get_view_target",
                    "camera_get_view_width",
                    "camera_get_view_x",
                    "camera_get_view_y",
                    "camera_set_begin_script",
                    "camera_set_default",
                    "camera_set_end_script",
                    "camera_set_proj_mat",
                    "camera_set_update_script",
                    "camera_set_view_angle",
                    "camera_set_view_border",
                    "camera_set_view_mat",
                    "camera_set_view_pos",
                    "camera_set_view_size",
                    "camera_set_view_speed",
                    "camera_set_view_target",
                    "ceil",
                    "choose",
                    "chr",
                    "clamp",
                    "clickable_add",
                    "clickable_add_ext",
                    "clickable_change",
                    "clickable_change_ext",
                    "clickable_delete",
                    "clickable_exists",
                    "clickable_set_style",
                    "clipboard_get_text",
                    "clipboard_has_text",
                    "clipboard_set_text",
                    "cloud_file_save",
                    "cloud_string_save",
                    "cloud_synchronise",
                    "code_is_compiled",
                    "collision_circle",
                    "collision_circle_list",
                    "collision_ellipse",
                    "collision_ellipse_list",
                    "collision_line",
                    "collision_line_list",
                    "collision_point",
                    "collision_point_list",
                    "collision_rectangle",
                    "collision_rectangle_list",
                    "color_get_blue",
                    "color_get_green",
                    "color_get_hue",
                    "color_get_red",
                    "color_get_saturation",
                    "color_get_value",
                    "colour_get_blue",
                    "colour_get_green",
                    "colour_get_hue",
                    "colour_get_red",
                    "colour_get_saturation",
                    "colour_get_value",
                    "cos",
                    "darccos",
                    "darcsin",
                    "darctan",
                    "darctan2",
                    "date_compare_date",
                    "date_compare_datetime",
                    "date_compare_time",
                    "date_create_datetime",
                    "date_current_datetime",
                    "date_date_of",
                    "date_date_string",
                    "date_datetime_string",
                    "date_day_span",
                    "date_days_in_month",
                    "date_days_in_year",
                    "date_get_day",
                    "date_get_day_of_year",
                    "date_get_hour",
                    "date_get_hour_of_year",
                    "date_get_minute",
                    "date_get_minute_of_year",
                    "date_get_month",
                    "date_get_second",
                    "date_get_second_of_year",
                    "date_get_timezone",
                    "date_get_week",
                    "date_get_weekday",
                    "date_get_year",
                    "date_hour_span",
                    "date_inc_day",
                    "date_inc_hour",
                    "date_inc_minute",
                    "date_inc_month",
                    "date_inc_second",
                    "date_inc_week",
                    "date_inc_year",
                    "date_is_today",
                    "date_leap_year",
                    "date_minute_span",
                    "date_month_span",
                    "date_second_span",
                    "date_set_timezone",
                    "date_time_of",
                    "date_time_string",
                    "date_valid_datetime",
                    "date_week_span",
                    "date_year_span",
                    "dcos",
                    "debug_event",
                    "debug_get_callstack",
                    "degtorad",
                    "device_get_tilt_x",
                    "device_get_tilt_y",
                    "device_get_tilt_z",
                    "device_is_keypad_open",
                    "device_mouse_check_button",
                    "device_mouse_check_button_pressed",
                    "device_mouse_check_button_released",
                    "device_mouse_dbclick_enable",
                    "device_mouse_raw_x",
                    "device_mouse_raw_y",
                    "device_mouse_x",
                    "device_mouse_x_to_gui",
                    "device_mouse_y",
                    "device_mouse_y_to_gui",
                    "directory_create",
                    "directory_destroy",
                    "directory_exists",
                    "display_get_dpi_x",
                    "display_get_dpi_y",
                    "display_get_gui_height",
                    "display_get_gui_width",
                    "display_get_height",
                    "display_get_orientation",
                    "display_get_sleep_margin",
                    "display_get_timing_method",
                    "display_get_width",
                    "display_mouse_get_x",
                    "display_mouse_get_y",
                    "display_mouse_set",
                    "display_reset",
                    "display_set_gui_maximise",
                    "display_set_gui_maximize",
                    "display_set_gui_size",
                    "display_set_sleep_margin",
                    "display_set_timing_method",
                    "display_set_ui_visibility",
                    "distance_to_object",
                    "distance_to_point",
                    "dot_product",
                    "dot_product_3d",
                    "dot_product_3d_normalised",
                    "dot_product_3d_normalized",
                    "dot_product_normalised",
                    "dot_product_normalized",
                    "draw_arrow",
                    "draw_background",
                    "draw_background_ext",
                    "draw_background_part_ext",
                    "draw_background_tiled",
                    "draw_button",
                    "draw_circle",
                    "draw_circle_color",
                    "draw_circle_colour",
                    "draw_clear",
                    "draw_clear_alpha",
                    "draw_ellipse",
                    "draw_ellipse_color",
                    "draw_ellipse_colour",
                    "draw_enable_alphablend",
                    "draw_enable_drawevent",
                    "draw_enable_swf_aa",
                    "draw_flush",
                    "draw_get_alpha",
                    "draw_get_color",
                    "draw_get_colour",
                    "draw_get_lighting",
                    "draw_get_swf_aa_level",
                    "draw_getpixel",
                    "draw_getpixel_ext",
                    "draw_healthbar",
                    "draw_highscore",
                    "draw_light_define_ambient",
                    "draw_light_define_direction",
                    "draw_light_define_point",
                    "draw_light_enable",
                    "draw_light_get",
                    "draw_light_get_ambient",
                    "draw_line",
                    "draw_line_color",
                    "draw_line_colour",
                    "draw_line_width",
                    "draw_line_width_color",
                    "draw_line_width_colour",
                    "draw_path",
                    "draw_point",
                    "draw_point_color",
                    "draw_point_colour",
                    "draw_primitive_begin",
                    "draw_primitive_begin_texture",
                    "draw_primitive_end",
                    "draw_rectangle",
                    "draw_rectangle_color",
                    "draw_rectangle_colour",
                    "draw_roundrect",
                    "draw_roundrect_color",
                    "draw_roundrect_color_ext",
                    "draw_roundrect_colour",
                    "draw_roundrect_colour_ext",
                    "draw_roundrect_ext",
                    "draw_self",
                    "draw_set_alpha",
                    "draw_set_alpha_test",
                    "draw_set_alpha_test_ref_value",
                    "draw_set_blend_mode",
                    "draw_set_blend_mode_ext",
                    "draw_set_circle_precision",
                    "draw_set_color",
                    "draw_set_color_write_enable",
                    "draw_set_colour",
                    "draw_set_font",
                    "draw_set_halign",
                    "draw_set_lighting",
                    "draw_set_swf_aa_level",
                    "draw_set_valign",
                    "draw_skeleton",
                    "draw_skeleton_collision",
                    "draw_skeleton_instance",
                    "draw_skeleton_time",
                    "draw_sprite",
                    "draw_sprite_ext",
                    "draw_sprite_general",
                    "draw_sprite_part",
                    "draw_sprite_part_ext",
                    "draw_sprite_pos",
                    "draw_sprite_stretched",
                    "draw_sprite_stretched_ext",
                    "draw_sprite_tiled",
                    "draw_sprite_tiled_ext",
                    "draw_surface",
                    "draw_surface_ext",
                    "draw_surface_general",
                    "draw_surface_part",
                    "draw_surface_part_ext",
                    "draw_surface_stretched",
                    "draw_surface_stretched_ext",
                    "draw_surface_tiled",
                    "draw_surface_tiled_ext",
                    "draw_text",
                    "draw_text_color",
                    "draw_text_colour",
                    "draw_text_ext",
                    "draw_text_ext_color",
                    "draw_text_ext_colour",
                    "draw_text_ext_transformed",
                    "draw_text_ext_transformed_color",
                    "draw_text_ext_transformed_colour",
                    "draw_text_transformed",
                    "draw_text_transformed_color",
                    "draw_text_transformed_colour",
                    "draw_texture_flush",
                    "draw_tile",
                    "draw_tilemap",
                    "draw_triangle",
                    "draw_triangle_color",
                    "draw_triangle_colour",
                    "draw_vertex",
                    "draw_vertex_color",
                    "draw_vertex_colour",
                    "draw_vertex_texture",
                    "draw_vertex_texture_color",
                    "draw_vertex_texture_colour",
                    "ds_exists",
                    "ds_grid_add",
                    "ds_grid_add_disk",
                    "ds_grid_add_grid_region",
                    "ds_grid_add_region",
                    "ds_grid_clear",
                    "ds_grid_copy",
                    "ds_grid_create",
                    "ds_grid_destroy",
                    "ds_grid_get",
                    "ds_grid_get_disk_max",
                    "ds_grid_get_disk_mean",
                    "ds_grid_get_disk_min",
                    "ds_grid_get_disk_sum",
                    "ds_grid_get_max",
                    "ds_grid_get_mean",
                    "ds_grid_get_min",
                    "ds_grid_get_sum",
                    "ds_grid_height",
                    "ds_grid_multiply",
                    "ds_grid_multiply_disk",
                    "ds_grid_multiply_grid_region",
                    "ds_grid_multiply_region",
                    "ds_grid_read",
                    "ds_grid_resize",
                    "ds_grid_set",
                    "ds_grid_set_disk",
                    "ds_grid_set_grid_region",
                    "ds_grid_set_region",
                    "ds_grid_shuffle",
                    "ds_grid_sort",
                    "ds_grid_value_disk_exists",
                    "ds_grid_value_disk_x",
                    "ds_grid_value_disk_y",
                    "ds_grid_value_exists",
                    "ds_grid_value_x",
                    "ds_grid_value_y",
                    "ds_grid_width",
                    "ds_grid_write",
                    "ds_list_add",
                    "ds_list_clear",
                    "ds_list_copy",
                    "ds_list_create",
                    "ds_list_delete",
                    "ds_list_destroy",
                    "ds_list_empty",
                    "ds_list_find_index",
                    "ds_list_find_value",
                    "ds_list_insert",
                    "ds_list_mark_as_list",
                    "ds_list_mark_as_map",
                    "ds_list_read",
                    "ds_list_replace",
                    "ds_list_set",
                    "ds_list_shuffle",
                    "ds_list_size",
                    "ds_list_sort",
                    "ds_list_write",
                    "ds_map_add",
                    "ds_map_add_list",
                    "ds_map_add_map",
                    "ds_map_clear",
                    "ds_map_copy",
                    "ds_map_create",
                    "ds_map_delete",
                    "ds_map_destroy",
                    "ds_map_empty",
                    "ds_map_exists",
                    "ds_map_find_first",
                    "ds_map_find_last",
                    "ds_map_find_next",
                    "ds_map_find_previous",
                    "ds_map_find_value",
                    "ds_map_read",
                    "ds_map_replace",
                    "ds_map_replace_list",
                    "ds_map_replace_map",
                    "ds_map_secure_load",
                    "ds_map_secure_load_buffer",
                    "ds_map_secure_save",
                    "ds_map_secure_save_buffer",
                    "ds_map_set",
                    "ds_map_size",
                    "ds_map_write",
                    "ds_priority_add",
                    "ds_priority_change_priority",
                    "ds_priority_clear",
                    "ds_priority_copy",
                    "ds_priority_create",
                    "ds_priority_delete_max",
                    "ds_priority_delete_min",
                    "ds_priority_delete_value",
                    "ds_priority_destroy",
                    "ds_priority_empty",
                    "ds_priority_find_max",
                    "ds_priority_find_min",
                    "ds_priority_find_priority",
                    "ds_priority_read",
                    "ds_priority_size",
                    "ds_priority_write",
                    "ds_queue_clear",
                    "ds_queue_copy",
                    "ds_queue_create",
                    "ds_queue_dequeue",
                    "ds_queue_destroy",
                    "ds_queue_empty",
                    "ds_queue_enqueue",
                    "ds_queue_head",
                    "ds_queue_read",
                    "ds_queue_size",
                    "ds_queue_tail",
                    "ds_queue_write",
                    "ds_set_precision",
                    "ds_stack_clear",
                    "ds_stack_copy",
                    "ds_stack_create",
                    "ds_stack_destroy",
                    "ds_stack_empty",
                    "ds_stack_pop",
                    "ds_stack_push",
                    "ds_stack_read",
                    "ds_stack_size",
                    "ds_stack_top",
                    "ds_stack_write",
                    "dsin",
                    "dtan",
                    "effect_clear",
                    "effect_create_above",
                    "effect_create_below",
                    "environment_get_variable",
                    "event_inherited",
                    "event_perform",
                    "event_perform_object",
                    "event_user",
                    "exp",
                    "external_call",
                    "external_define",
                    "external_free",
                    "facebook_accesstoken",
                    "facebook_check_permission",
                    "facebook_dialog",
                    "facebook_graph_request",
                    "facebook_init",
                    "facebook_launch_offerwall",
                    "facebook_login",
                    "facebook_logout",
                    "facebook_post_message",
                    "facebook_request_publish_permissions",
                    "facebook_request_read_permissions",
                    "facebook_send_invite",
                    "facebook_status",
                    "facebook_user_id",
                    "file_attributes",
                    "file_bin_close",
                    "file_bin_open",
                    "file_bin_position",
                    "file_bin_read_byte",
                    "file_bin_rewrite",
                    "file_bin_seek",
                    "file_bin_size",
                    "file_bin_write_byte",
                    "file_copy",
                    "file_delete",
                    "file_exists",
                    "file_find_close",
                    "file_find_first",
                    "file_find_next",
                    "file_rename",
                    "file_text_close",
                    "file_text_eof",
                    "file_text_eoln",
                    "file_text_open_append",
                    "file_text_open_from_string",
                    "file_text_open_read",
                    "file_text_open_write",
                    "file_text_read_real",
                    "file_text_read_string",
                    "file_text_readln",
                    "file_text_write_real",
                    "file_text_write_string",
                    "file_text_writeln",
                    "filename_change_ext",
                    "filename_dir",
                    "filename_drive",
                    "filename_ext",
                    "filename_name",
                    "filename_path",
                    "floor",
                    "font_add",
                    "font_add_enable_aa",
                    "font_add_get_enable_aa",
                    "font_add_sprite",
                    "font_add_sprite_ext",
                    "font_delete",
                    "font_exists",
                    "font_get_bold",
                    "font_get_first",
                    "font_get_fontname",
                    "font_get_italic",
                    "font_get_last",
                    "font_get_name",
                    "font_get_size",
                    "font_get_texture",
                    "font_get_uvs",
                    "font_replace",
                    "font_replace_sprite",
                    "font_replace_sprite_ext",
                    "font_set_cache_size",
                    "font_texture_page_size",
                    "frac",
                    "game_end",
                    "game_get_speed",
                    "game_load",
                    "game_load_buffer",
                    "game_restart",
                    "game_save",
                    "game_save_buffer",
                    "game_set_speed",
                    "gamepad_axis_count",
                    "gamepad_axis_value",
                    "gamepad_button_check",
                    "gamepad_button_check_pressed",
                    "gamepad_button_check_released",
                    "gamepad_button_count",
                    "gamepad_button_value",
                    "gamepad_get_axis_deadzone",
                    "gamepad_get_button_threshold",
                    "gamepad_get_description",
                    "gamepad_get_device_count",
                    "gamepad_is_connected",
                    "gamepad_is_supported",
                    "gamepad_set_axis_deadzone",
                    "gamepad_set_button_threshold",
                    "gamepad_set_color",
                    "gamepad_set_colour",
                    "gamepad_set_vibration",
                    "gesture_double_tap_distance",
                    "gesture_double_tap_time",
                    "gesture_drag_distance",
                    "gesture_drag_time",
                    "gesture_flick_speed",
                    "gesture_get_double_tap_distance",
                    "gesture_get_double_tap_time",
                    "gesture_get_drag_distance",
                    "gesture_get_drag_time",
                    "gesture_get_flick_speed",
                    "gesture_get_pinch_angle_away",
                    "gesture_get_pinch_angle_towards",
                    "gesture_get_pinch_distance",
                    "gesture_get_rotate_angle",
                    "gesture_get_rotate_time",
                    "gesture_get_tap_count",
                    "gesture_pinch_angle_away",
                    "gesture_pinch_angle_towards",
                    "gesture_pinch_distance",
                    "gesture_rotate_angle",
                    "gesture_rotate_time",
                    "gesture_tap_count",
                    "get_integer",
                    "get_integer_async",
                    "get_login_async",
                    "get_open_filename",
                    "get_open_filename_ext",
                    "get_save_filename",
                    "get_save_filename_ext",
                    "get_string",
                    "get_string_async",
                    "get_timer",
                    "gml_pragma",
                    "gml_release_mode",
                    "gpu_get_alphatestenable",
                    "gpu_get_alphatestfunc",
                    "gpu_get_alphatestref",
                    "gpu_get_blendenable",
                    "gpu_get_blendmode",
                    "gpu_get_blendmode_dest",
                    "gpu_get_blendmode_destalpha",
                    "gpu_get_blendmode_ext",
                    "gpu_get_blendmode_ext_sepalpha",
                    "gpu_get_blendmode_src",
                    "gpu_get_blendmode_srcalpha",
                    "gpu_get_colorwriteenable",
                    "gpu_get_colourwriteenable",
                    "gpu_get_cullmode",
                    "gpu_get_fog",
                    "gpu_get_lightingenable",
                    "gpu_get_state",
                    "gpu_get_tex_filter",
                    "gpu_get_tex_filter_ext",
                    "gpu_get_tex_max_aniso",
                    "gpu_get_tex_max_aniso_ext",
                    "gpu_get_tex_max_mip",
                    "gpu_get_tex_max_mip_ext",
                    "gpu_get_tex_min_mip",
                    "gpu_get_tex_min_mip_ext",
                    "gpu_get_tex_mip_bias",
                    "gpu_get_tex_mip_bias_ext",
                    "gpu_get_tex_mip_enable",
                    "gpu_get_tex_mip_enable_ext",
                    "gpu_get_tex_mip_filter",
                    "gpu_get_tex_mip_filter_ext",
                    "gpu_get_tex_repeat",
                    "gpu_get_tex_repeat_ext",
                    "gpu_get_texfilter",
                    "gpu_get_texfilter_ext",
                    "gpu_get_texrepeat",
                    "gpu_get_texrepeat_ext",
                    "gpu_get_zfunc",
                    "gpu_get_ztestenable",
                    "gpu_get_zwriteenable",
                    "gpu_pop_state",
                    "gpu_push_state",
                    "gpu_set_alphatestenable",
                    "gpu_set_alphatestfunc",
                    "gpu_set_alphatestref",
                    "gpu_set_blendenable",
                    "gpu_set_blendmode",
                    "gpu_set_blendmode_ext",
                    "gpu_set_blendmode_ext_sepalpha",
                    "gpu_set_colorwriteenable",
                    "gpu_set_colourwriteenable",
                    "gpu_set_cullmode",
                    "gpu_set_fog",
                    "gpu_set_lightingenable",
                    "gpu_set_state",
                    "gpu_set_tex_filter",
                    "gpu_set_tex_filter_ext",
                    "gpu_set_tex_max_aniso",
                    "gpu_set_tex_max_aniso_ext",
                    "gpu_set_tex_max_mip",
                    "gpu_set_tex_max_mip_ext",
                    "gpu_set_tex_min_mip",
                    "gpu_set_tex_min_mip_ext",
                    "gpu_set_tex_mip_bias",
                    "gpu_set_tex_mip_bias_ext",
                    "gpu_set_tex_mip_enable",
                    "gpu_set_tex_mip_enable_ext",
                    "gpu_set_tex_mip_filter",
                    "gpu_set_tex_mip_filter_ext",
                    "gpu_set_tex_repeat",
                    "gpu_set_tex_repeat_ext",
                    "gpu_set_texfilter",
                    "gpu_set_texfilter_ext",
                    "gpu_set_texrepeat",
                    "gpu_set_texrepeat_ext",
                    "gpu_set_zfunc",
                    "gpu_set_ztestenable",
                    "gpu_set_zwriteenable",
                    "highscore_add",
                    "highscore_clear",
                    "highscore_name",
                    "highscore_value",
                    "http_get",
                    "http_get_file",
                    "http_post_string",
                    "http_request",
                    "iap_acquire",
                    "iap_activate",
                    "iap_consume",
                    "iap_enumerate_products",
                    "iap_product_details",
                    "iap_purchase_details",
                    "iap_restore_all",
                    "iap_status",
                    "ini_close",
                    "ini_key_delete",
                    "ini_key_exists",
                    "ini_open",
                    "ini_open_from_string",
                    "ini_read_real",
                    "ini_read_string",
                    "ini_section_delete",
                    "ini_section_exists",
                    "ini_write_real",
                    "ini_write_string",
                    "instance_activate_all",
                    "instance_activate_layer",
                    "instance_activate_object",
                    "instance_activate_region",
                    "instance_change",
                    "instance_copy",
                    "instance_create",
                    "instance_create_depth",
                    "instance_create_layer",
                    "instance_deactivate_all",
                    "instance_deactivate_layer",
                    "instance_deactivate_object",
                    "instance_deactivate_region",
                    "instance_destroy",
                    "instance_exists",
                    "instance_find",
                    "instance_furthest",
                    "instance_id_get",
                    "instance_nearest",
                    "instance_number",
                    "instance_place",
                    "instance_place_list",
                    "instance_position",
                    "instance_position_list",
                    "int64",
                    "io_clear",
                    "irandom",
                    "irandom_range",
                    "is_array",
                    "is_bool",
                    "is_infinity",
                    "is_int32",
                    "is_int64",
                    "is_matrix",
                    "is_method",
                    "is_nan",
                    "is_numeric",
                    "is_ptr",
                    "is_real",
                    "is_string",
                    "is_struct",
                    "is_undefined",
                    "is_vec3",
                    "is_vec4",
                    "json_decode",
                    "json_encode",
                    "keyboard_check",
                    "keyboard_check_direct",
                    "keyboard_check_pressed",
                    "keyboard_check_released",
                    "keyboard_clear",
                    "keyboard_get_map",
                    "keyboard_get_numlock",
                    "keyboard_key_press",
                    "keyboard_key_release",
                    "keyboard_set_map",
                    "keyboard_set_numlock",
                    "keyboard_unset_map",
                    "keyboard_virtual_height",
                    "keyboard_virtual_hide",
                    "keyboard_virtual_show",
                    "keyboard_virtual_status",
                    "layer_add_instance",
                    "layer_background_alpha",
                    "layer_background_blend",
                    "layer_background_change",
                    "layer_background_create",
                    "layer_background_destroy",
                    "layer_background_exists",
                    "layer_background_get_alpha",
                    "layer_background_get_blend",
                    "layer_background_get_htiled",
                    "layer_background_get_id",
                    "layer_background_get_index",
                    "layer_background_get_speed",
                    "layer_background_get_sprite",
                    "layer_background_get_stretch",
                    "layer_background_get_visible",
                    "layer_background_get_vtiled",
                    "layer_background_get_xscale",
                    "layer_background_get_yscale",
                    "layer_background_htiled",
                    "layer_background_index",
                    "layer_background_speed",
                    "layer_background_sprite",
                    "layer_background_stretch",
                    "layer_background_visible",
                    "layer_background_vtiled",
                    "layer_background_xscale",
                    "layer_background_yscale",
                    "layer_create",
                    "layer_depth",
                    "layer_destroy",
                    "layer_destroy_instances",
                    "layer_element_move",
                    "layer_exists",
                    "layer_force_draw_depth",
                    "layer_get_all",
                    "layer_get_all_elements",
                    "layer_get_depth",
                    "layer_get_element_layer",
                    "layer_get_element_type",
                    "layer_get_forced_depth",
                    "layer_get_hspeed",
                    "layer_get_id",
                    "layer_get_id_at_depth",
                    "layer_get_name",
                    "layer_get_script_begin",
                    "layer_get_script_end",
                    "layer_get_shader",
                    "layer_get_target_room",
                    "layer_get_visible",
                    "layer_get_vspeed",
                    "layer_get_x",
                    "layer_get_y",
                    "layer_has_instance",
                    "layer_hspeed",
                    "layer_instance_get_instance",
                    "layer_is_draw_depth_forced",
                    "layer_reset_target_room",
                    "layer_script_begin",
                    "layer_script_end",
                    "layer_set_target_room",
                    "layer_set_visible",
                    "layer_shader",
                    "layer_sprite_alpha",
                    "layer_sprite_angle",
                    "layer_sprite_blend",
                    "layer_sprite_change",
                    "layer_sprite_create",
                    "layer_sprite_destroy",
                    "layer_sprite_exists",
                    "layer_sprite_get_alpha",
                    "layer_sprite_get_angle",
                    "layer_sprite_get_blend",
                    "layer_sprite_get_id",
                    "layer_sprite_get_index",
                    "layer_sprite_get_speed",
                    "layer_sprite_get_sprite",
                    "layer_sprite_get_x",
                    "layer_sprite_get_xscale",
                    "layer_sprite_get_y",
                    "layer_sprite_get_yscale",
                    "layer_sprite_index",
                    "layer_sprite_speed",
                    "layer_sprite_x",
                    "layer_sprite_xscale",
                    "layer_sprite_y",
                    "layer_sprite_yscale",
                    "layer_tile_alpha",
                    "layer_tile_blend",
                    "layer_tile_change",
                    "layer_tile_create",
                    "layer_tile_destroy",
                    "layer_tile_exists",
                    "layer_tile_get_alpha",
                    "layer_tile_get_blend",
                    "layer_tile_get_region",
                    "layer_tile_get_sprite",
                    "layer_tile_get_visible",
                    "layer_tile_get_x",
                    "layer_tile_get_xscale",
                    "layer_tile_get_y",
                    "layer_tile_get_yscale",
                    "layer_tile_region",
                    "layer_tile_visible",
                    "layer_tile_x",
                    "layer_tile_xscale",
                    "layer_tile_y",
                    "layer_tile_yscale",
                    "layer_tilemap_create",
                    "layer_tilemap_destroy",
                    "layer_tilemap_exists",
                    "layer_tilemap_get_id",
                    "layer_vspeed",
                    "layer_x",
                    "layer_y",
                    "lengthdir_x",
                    "lengthdir_y",
                    "lerp",
                    "ln",
                    "load_csv",
                    "log10",
                    "log2",
                    "logn",
                    "make_color_hsv",
                    "make_color_rgb",
                    "make_colour_hsv",
                    "make_colour_rgb",
                    "math_get_epsilon",
                    "math_set_epsilon",
                    "matrix_build",
                    "matrix_build_identity",
                    "matrix_build_lookat",
                    "matrix_build_projection_ortho",
                    "matrix_build_projection_perspective",
                    "matrix_build_projection_perspective_fov",
                    "matrix_get",
                    "matrix_multiply",
                    "matrix_set",
                    "matrix_stack_clear",
                    "matrix_stack_is_empty",
                    "matrix_stack_multiply",
                    "matrix_stack_pop",
                    "matrix_stack_push",
                    "matrix_stack_set",
                    "matrix_stack_top",
                    "matrix_transform_vertex",
                    "max",
                    "md5_file",
                    "md5_string_unicode",
                    "md5_string_utf8",
                    "mean",
                    "median",
                    "merge_color",
                    "merge_colour",
                    "min",
                    "motion_add",
                    "motion_set",
                    "mouse_check_button",
                    "mouse_check_button_pressed",
                    "mouse_check_button_released",
                    "mouse_clear",
                    "mouse_wheel_down",
                    "mouse_wheel_up",
                    "move_bounce_all",
                    "move_bounce_solid",
                    "move_contact_all",
                    "move_contact_solid",
                    "move_outside_all",
                    "move_outside_solid",
                    "move_random",
                    "move_snap",
                    "move_towards_point",
                    "move_wrap",
                    "mp_grid_add_cell",
                    "mp_grid_add_instances",
                    "mp_grid_add_rectangle",
                    "mp_grid_clear_all",
                    "mp_grid_clear_cell",
                    "mp_grid_clear_rectangle",
                    "mp_grid_create",
                    "mp_grid_destroy",
                    "mp_grid_draw",
                    "mp_grid_get_cell",
                    "mp_grid_path",
                    "mp_grid_to_ds_grid",
                    "mp_linear_path",
                    "mp_linear_path_object",
                    "mp_linear_step",
                    "mp_linear_step_object",
                    "mp_potential_path",
                    "mp_potential_path_object",
                    "mp_potential_settings",
                    "mp_potential_step",
                    "mp_potential_step_object",
                    "network_connect",
                    "network_connect_raw",
                    "network_create_server",
                    "network_create_server_raw",
                    "network_create_socket",
                    "network_create_socket_ext",
                    "network_destroy",
                    "network_resolve",
                    "network_send_broadcast",
                    "network_send_packet",
                    "network_send_raw",
                    "network_send_udp",
                    "network_send_udp_raw",
                    "network_set_config",
                    "network_set_timeout",
                    "object_exists",
                    "object_get_depth",
                    "object_get_mask",
                    "object_get_name",
                    "object_get_parent",
                    "object_get_persistent",
                    "object_get_physics",
                    "object_get_solid",
                    "object_get_sprite",
                    "object_get_visible",
                    "object_is_ancestor",
                    "object_set_mask",
                    "object_set_persistent",
                    "object_set_solid",
                    "object_set_sprite",
                    "object_set_visible",
                    "ord",
                    "os_get_config",
                    "os_get_info",
                    "os_get_language",
                    "os_get_region",
                    "os_is_network_connected",
                    "os_is_paused",
                    "os_lock_orientation",
                    "os_powersave_enable",
                    "parameter_count",
                    "parameter_string",
                    "part_emitter_burst",
                    "part_emitter_clear",
                    "part_emitter_create",
                    "part_emitter_destroy",
                    "part_emitter_destroy_all",
                    "part_emitter_exists",
                    "part_emitter_region",
                    "part_emitter_stream",
                    "part_particles_clear",
                    "part_particles_count",
                    "part_particles_create",
                    "part_particles_create_color",
                    "part_particles_create_colour",
                    "part_system_automatic_draw",
                    "part_system_automatic_update",
                    "part_system_clear",
                    "part_system_create",
                    "part_system_create_layer",
                    "part_system_depth",
                    "part_system_destroy",
                    "part_system_draw_order",
                    "part_system_drawit",
                    "part_system_exists",
                    "part_system_get_layer",
                    "part_system_layer",
                    "part_system_position",
                    "part_system_update",
                    "part_type_alpha1",
                    "part_type_alpha2",
                    "part_type_alpha3",
                    "part_type_blend",
                    "part_type_clear",
                    "part_type_color1",
                    "part_type_color2",
                    "part_type_color3",
                    "part_type_color_hsv",
                    "part_type_color_mix",
                    "part_type_color_rgb",
                    "part_type_colour1",
                    "part_type_colour2",
                    "part_type_colour3",
                    "part_type_colour_hsv",
                    "part_type_colour_mix",
                    "part_type_colour_rgb",
                    "part_type_create",
                    "part_type_death",
                    "part_type_destroy",
                    "part_type_direction",
                    "part_type_exists",
                    "part_type_gravity",
                    "part_type_life",
                    "part_type_orientation",
                    "part_type_scale",
                    "part_type_shape",
                    "part_type_size",
                    "part_type_speed",
                    "part_type_sprite",
                    "part_type_step",
                    "path_add",
                    "path_add_point",
                    "path_append",
                    "path_assign",
                    "path_change_point",
                    "path_clear_points",
                    "path_delete",
                    "path_delete_point",
                    "path_duplicate",
                    "path_end",
                    "path_exists",
                    "path_flip",
                    "path_get_closed",
                    "path_get_kind",
                    "path_get_length",
                    "path_get_name",
                    "path_get_number",
                    "path_get_point_speed",
                    "path_get_point_x",
                    "path_get_point_y",
                    "path_get_precision",
                    "path_get_speed",
                    "path_get_time",
                    "path_get_x",
                    "path_get_y",
                    "path_insert_point",
                    "path_mirror",
                    "path_rescale",
                    "path_reverse",
                    "path_rotate",
                    "path_set_closed",
                    "path_set_kind",
                    "path_set_precision",
                    "path_shift",
                    "path_start",
                    "physics_apply_angular_impulse",
                    "physics_apply_force",
                    "physics_apply_impulse",
                    "physics_apply_local_force",
                    "physics_apply_local_impulse",
                    "physics_apply_torque",
                    "physics_draw_debug",
                    "physics_fixture_add_point",
                    "physics_fixture_bind",
                    "physics_fixture_bind_ext",
                    "physics_fixture_create",
                    "physics_fixture_delete",
                    "physics_fixture_set_angular_damping",
                    "physics_fixture_set_awake",
                    "physics_fixture_set_box_shape",
                    "physics_fixture_set_chain_shape",
                    "physics_fixture_set_circle_shape",
                    "physics_fixture_set_collision_group",
                    "physics_fixture_set_density",
                    "physics_fixture_set_edge_shape",
                    "physics_fixture_set_friction",
                    "physics_fixture_set_kinematic",
                    "physics_fixture_set_linear_damping",
                    "physics_fixture_set_polygon_shape",
                    "physics_fixture_set_restitution",
                    "physics_fixture_set_sensor",
                    "physics_get_density",
                    "physics_get_friction",
                    "physics_get_restitution",
                    "physics_joint_delete",
                    "physics_joint_distance_create",
                    "physics_joint_enable_motor",
                    "physics_joint_friction_create",
                    "physics_joint_gear_create",
                    "physics_joint_get_value",
                    "physics_joint_prismatic_create",
                    "physics_joint_pulley_create",
                    "physics_joint_revolute_create",
                    "physics_joint_rope_create",
                    "physics_joint_set_value",
                    "physics_joint_weld_create",
                    "physics_joint_wheel_create",
                    "physics_mass_properties",
                    "physics_particle_count",
                    "physics_particle_create",
                    "physics_particle_delete",
                    "physics_particle_delete_region_box",
                    "physics_particle_delete_region_circle",
                    "physics_particle_delete_region_poly",
                    "physics_particle_draw",
                    "physics_particle_draw_ext",
                    "physics_particle_get_damping",
                    "physics_particle_get_data",
                    "physics_particle_get_data_particle",
                    "physics_particle_get_density",
                    "physics_particle_get_gravity_scale",
                    "physics_particle_get_group_flags",
                    "physics_particle_get_max_count",
                    "physics_particle_get_radius",
                    "physics_particle_group_add_point",
                    "physics_particle_group_begin",
                    "physics_particle_group_box",
                    "physics_particle_group_circle",
                    "physics_particle_group_count",
                    "physics_particle_group_delete",
                    "physics_particle_group_end",
                    "physics_particle_group_get_ang_vel",
                    "physics_particle_group_get_angle",
                    "physics_particle_group_get_centre_x",
                    "physics_particle_group_get_centre_y",
                    "physics_particle_group_get_data",
                    "physics_particle_group_get_inertia",
                    "physics_particle_group_get_mass",
                    "physics_particle_group_get_vel_x",
                    "physics_particle_group_get_vel_y",
                    "physics_particle_group_get_x",
                    "physics_particle_group_get_y",
                    "physics_particle_group_join",
                    "physics_particle_group_polygon",
                    "physics_particle_set_category_flags",
                    "physics_particle_set_damping",
                    "physics_particle_set_density",
                    "physics_particle_set_flags",
                    "physics_particle_set_gravity_scale",
                    "physics_particle_set_group_flags",
                    "physics_particle_set_max_count",
                    "physics_particle_set_radius",
                    "physics_pause_enable",
                    "physics_remove_fixture",
                    "physics_set_density",
                    "physics_set_friction",
                    "physics_set_restitution",
                    "physics_test_overlap",
                    "physics_world_create",
                    "physics_world_draw_debug",
                    "physics_world_gravity",
                    "physics_world_update_iterations",
                    "physics_world_update_speed",
                    "place_empty",
                    "place_free",
                    "place_meeting",
                    "place_snapped",
                    "point_direction",
                    "point_distance",
                    "point_distance_3d",
                    "point_in_circle",
                    "point_in_rectangle",
                    "point_in_triangle",
                    "position_change",
                    "position_destroy",
                    "position_empty",
                    "position_meeting",
                    "power",
                    "ptr",
                    "push_cancel_local_notification",
                    "push_get_first_local_notification",
                    "push_get_next_local_notification",
                    "push_local_notification",
                    "radtodeg",
                    "random",
                    "random_get_seed",
                    "random_range",
                    "random_set_seed",
                    "randomise",
                    "randomize",
                    "real",
                    "rectangle_in_circle",
                    "rectangle_in_rectangle",
                    "rectangle_in_triangle",
                    "room_add",
                    "room_assign",
                    "room_duplicate",
                    "room_exists",
                    "room_get_camera",
                    "room_get_name",
                    "room_get_viewport",
                    "room_goto",
                    "room_goto_next",
                    "room_goto_previous",
                    "room_instance_add",
                    "room_instance_clear",
                    "room_next",
                    "room_previous",
                    "room_restart",
                    "room_set_background_color",
                    "room_set_background_colour",
                    "room_set_camera",
                    "room_set_height",
                    "room_set_persistent",
                    "room_set_view",
                    "room_set_view_enabled",
                    "room_set_viewport",
                    "room_set_width",
                    "round",
                    "screen_save",
                    "screen_save_part",
                    "script_execute",
                    "script_exists",
                    "script_get_name",
                    "sha1_file",
                    "sha1_string_unicode",
                    "sha1_string_utf8",
                    "shader_current",
                    "shader_enable_corner_id",
                    "shader_get_name",
                    "shader_get_sampler_index",
                    "shader_get_uniform",
                    "shader_is_compiled",
                    "shader_reset",
                    "shader_set",
                    "shader_set_uniform_f",
                    "shader_set_uniform_f_array",
                    "shader_set_uniform_i",
                    "shader_set_uniform_i_array",
                    "shader_set_uniform_matrix",
                    "shader_set_uniform_matrix_array",
                    "shaders_are_supported",
                    "shop_leave_rating",
                    "show_debug_message",
                    "show_debug_overlay",
                    "show_error",
                    "show_message",
                    "show_message_async",
                    "show_question",
                    "show_question_async",
                    "sign",
                    "sin",
                    "skeleton_animation_clear",
                    "skeleton_animation_get",
                    "skeleton_animation_get_duration",
                    "skeleton_animation_get_ext",
                    "skeleton_animation_get_frame",
                    "skeleton_animation_get_frames",
                    "skeleton_animation_list",
                    "skeleton_animation_mix",
                    "skeleton_animation_set",
                    "skeleton_animation_set_ext",
                    "skeleton_animation_set_frame",
                    "skeleton_attachment_create",
                    "skeleton_attachment_get",
                    "skeleton_attachment_set",
                    "skeleton_bone_data_get",
                    "skeleton_bone_data_set",
                    "skeleton_bone_state_get",
                    "skeleton_bone_state_set",
                    "skeleton_collision_draw_set",
                    "skeleton_get_bounds",
                    "skeleton_get_minmax",
                    "skeleton_get_num_bounds",
                    "skeleton_skin_get",
                    "skeleton_skin_list",
                    "skeleton_skin_set",
                    "skeleton_slot_data",
                    "sprite_add",
                    "sprite_add_from_surface",
                    "sprite_assign",
                    "sprite_collision_mask",
                    "sprite_create_from_surface",
                    "sprite_delete",
                    "sprite_duplicate",
                    "sprite_exists",
                    "sprite_flush",
                    "sprite_flush_multi",
                    "sprite_get_bbox_bottom",
                    "sprite_get_bbox_left",
                    "sprite_get_bbox_right",
                    "sprite_get_bbox_top",
                    "sprite_get_height",
                    "sprite_get_name",
                    "sprite_get_number",
                    "sprite_get_speed",
                    "sprite_get_speed_type",
                    "sprite_get_texture",
                    "sprite_get_tpe",
                    "sprite_get_uvs",
                    "sprite_get_width",
                    "sprite_get_xoffset",
                    "sprite_get_yoffset",
                    "sprite_merge",
                    "sprite_prefetch",
                    "sprite_prefetch_multi",
                    "sprite_replace",
                    "sprite_save",
                    "sprite_save_strip",
                    "sprite_set_alpha_from_sprite",
                    "sprite_set_cache_size",
                    "sprite_set_cache_size_ext",
                    "sprite_set_offset",
                    "sprite_set_speed",
                    "sqr",
                    "sqrt",
                    "steam_activate_overlay",
                    "steam_activate_overlay_browser",
                    "steam_activate_overlay_store",
                    "steam_activate_overlay_user",
                    "steam_available_languages",
                    "steam_clear_achievement",
                    "steam_create_leaderboard",
                    "steam_current_game_language",
                    "steam_download_friends_scores",
                    "steam_download_scores",
                    "steam_download_scores_around_user",
                    "steam_file_delete",
                    "steam_file_exists",
                    "steam_file_persisted",
                    "steam_file_read",
                    "steam_file_share",
                    "steam_file_size",
                    "steam_file_write",
                    "steam_file_write_file",
                    "steam_get_achievement",
                    "steam_get_app_id",
                    "steam_get_persona_name",
                    "steam_get_quota_free",
                    "steam_get_quota_total",
                    "steam_get_stat_avg_rate",
                    "steam_get_stat_float",
                    "steam_get_stat_int",
                    "steam_get_user_account_id",
                    "steam_get_user_persona_name",
                    "steam_get_user_steam_id",
                    "steam_initialised",
                    "steam_is_cloud_enabled_for_account",
                    "steam_is_cloud_enabled_for_app",
                    "steam_is_overlay_activated",
                    "steam_is_overlay_enabled",
                    "steam_is_screenshot_requested",
                    "steam_is_user_logged_on",
                    "steam_reset_all_stats",
                    "steam_reset_all_stats_achievements",
                    "steam_send_screenshot",
                    "steam_set_achievement",
                    "steam_set_stat_avg_rate",
                    "steam_set_stat_float",
                    "steam_set_stat_int",
                    "steam_stats_ready",
                    "steam_ugc_create_item",
                    "steam_ugc_create_query_all",
                    "steam_ugc_create_query_all_ex",
                    "steam_ugc_create_query_user",
                    "steam_ugc_create_query_user_ex",
                    "steam_ugc_download",
                    "steam_ugc_get_item_install_info",
                    "steam_ugc_get_item_update_info",
                    "steam_ugc_get_item_update_progress",
                    "steam_ugc_get_subscribed_items",
                    "steam_ugc_num_subscribed_items",
                    "steam_ugc_query_add_excluded_tag",
                    "steam_ugc_query_add_required_tag",
                    "steam_ugc_query_set_allow_cached_response",
                    "steam_ugc_query_set_cloud_filename_filter",
                    "steam_ugc_query_set_match_any_tag",
                    "steam_ugc_query_set_ranked_by_trend_days",
                    "steam_ugc_query_set_return_long_description",
                    "steam_ugc_query_set_return_total_only",
                    "steam_ugc_query_set_search_text",
                    "steam_ugc_request_item_details",
                    "steam_ugc_send_query",
                    "steam_ugc_set_item_content",
                    "steam_ugc_set_item_description",
                    "steam_ugc_set_item_preview",
                    "steam_ugc_set_item_tags",
                    "steam_ugc_set_item_title",
                    "steam_ugc_set_item_visibility",
                    "steam_ugc_start_item_update",
                    "steam_ugc_submit_item_update",
                    "steam_ugc_subscribe_item",
                    "steam_ugc_unsubscribe_item",
                    "steam_upload_score",
                    "steam_upload_score_buffer",
                    "steam_upload_score_buffer_ext",
                    "steam_upload_score_ext",
                    "steam_user_installed_dlc",
                    "steam_user_owns_dlc",
                    "string",
                    "string_byte_at",
                    "string_byte_length",
                    "string_char_at",
                    "string_copy",
                    "string_count",
                    "string_delete",
                    "string_digits",
                    "string_format",
                    "string_hash_to_newline",
                    "string_height",
                    "string_height_ext",
                    "string_insert",
                    "string_length",
                    "string_letters",
                    "string_lettersdigits",
                    "string_lower",
                    "string_ord_at",
                    "string_pos",
                    "string_repeat",
                    "string_replace",
                    "string_replace_all",
                    "string_set_byte_at",
                    "string_upper",
                    "string_width",
                    "string_width_ext",
                    "surface_copy",
                    "surface_copy_part",
                    "surface_create",
                    "surface_create_ext",
                    "surface_depth_disable",
                    "surface_exists",
                    "surface_free",
                    "surface_get_depth_disable",
                    "surface_get_height",
                    "surface_get_texture",
                    "surface_get_width",
                    "surface_getpixel",
                    "surface_getpixel_ext",
                    "surface_reset_target",
                    "surface_resize",
                    "surface_save",
                    "surface_save_part",
                    "surface_set_target",
                    "surface_set_target_ext",
                    "tan",
                    "texture_get_height",
                    "texture_get_texel_height",
                    "texture_get_texel_width",
                    "texture_get_uvs",
                    "texture_get_width",
                    "texture_global_scale",
                    "texture_set_stage",
                    "tile_get_empty",
                    "tile_get_flip",
                    "tile_get_index",
                    "tile_get_mirror",
                    "tile_get_rotate",
                    "tile_set_empty",
                    "tile_set_flip",
                    "tile_set_index",
                    "tile_set_mirror",
                    "tile_set_rotate",
                    "tilemap_clear",
                    "tilemap_get",
                    "tilemap_get_at_pixel",
                    "tilemap_get_cell_x_at_pixel",
                    "tilemap_get_cell_y_at_pixel",
                    "tilemap_get_frame",
                    "tilemap_get_global_mask",
                    "tilemap_get_height",
                    "tilemap_get_mask",
                    "tilemap_get_tile_height",
                    "tilemap_get_tile_width",
                    "tilemap_get_tileset",
                    "tilemap_get_width",
                    "tilemap_get_x",
                    "tilemap_get_y",
                    "tilemap_set",
                    "tilemap_set_at_pixel",
                    "tilemap_set_global_mask",
                    "tilemap_set_mask",
                    "tilemap_tileset",
                    "tilemap_x",
                    "tilemap_y",
                    "timeline_add",
                    "timeline_clear",
                    "timeline_delete",
                    "timeline_exists",
                    "timeline_get_name",
                    "timeline_max_moment",
                    "timeline_moment_add_script",
                    "timeline_moment_clear",
                    "timeline_size",
                    "typeof",
                    "url_get_domain",
                    "url_open",
                    "url_open_ext",
                    "url_open_full",
                    "variable_global_exists",
                    "variable_global_get",
                    "variable_global_set",
                    "variable_instance_exists",
                    "variable_instance_get",
                    "variable_instance_get_names",
                    "variable_instance_set",
                    "variable_struct_exists",
                    "variable_struct_get",
                    "variable_struct_get_names",
                    "variable_struct_names_count",
                    "variable_struct_remove",
                    "variable_struct_set",
                    "vertex_argb",
                    "vertex_begin",
                    "vertex_color",
                    "vertex_colour",
                    "vertex_create_buffer",
                    "vertex_create_buffer_ext",
                    "vertex_create_buffer_from_buffer",
                    "vertex_create_buffer_from_buffer_ext",
                    "vertex_delete_buffer",
                    "vertex_end",
                    "vertex_float1",
                    "vertex_float2",
                    "vertex_float3",
                    "vertex_float4",
                    "vertex_format_add_color",
                    "vertex_format_add_colour",
                    "vertex_format_add_custom",
                    "vertex_format_add_normal",
                    "vertex_format_add_position",
                    "vertex_format_add_position_3d",
                    "vertex_format_add_texcoord",
                    "vertex_format_add_textcoord",
                    "vertex_format_begin",
                    "vertex_format_delete",
                    "vertex_format_end",
                    "vertex_freeze",
                    "vertex_get_buffer_size",
                    "vertex_get_number",
                    "vertex_normal",
                    "vertex_position",
                    "vertex_position_3d",
                    "vertex_submit",
                    "vertex_texcoord",
                    "vertex_ubyte4",
                    "view_get_camera",
                    "view_get_hport",
                    "view_get_surface_id",
                    "view_get_visible",
                    "view_get_wport",
                    "view_get_xport",
                    "view_get_yport",
                    "view_set_camera",
                    "view_set_hport",
                    "view_set_surface_id",
                    "view_set_visible",
                    "view_set_wport",
                    "view_set_xport",
                    "view_set_yport",
                    "virtual_key_add",
                    "virtual_key_delete",
                    "virtual_key_hide",
                    "virtual_key_show",
                    "win8_appbar_add_element",
                    "win8_appbar_enable",
                    "win8_appbar_remove_element",
                    "win8_device_touchscreen_available",
                    "win8_license_initialize_sandbox",
                    "win8_license_trial_version",
                    "win8_livetile_badge_clear",
                    "win8_livetile_badge_notification",
                    "win8_livetile_notification_begin",
                    "win8_livetile_notification_end",
                    "win8_livetile_notification_expiry",
                    "win8_livetile_notification_image_add",
                    "win8_livetile_notification_secondary_begin",
                    "win8_livetile_notification_tag",
                    "win8_livetile_notification_text_add",
                    "win8_livetile_queue_enable",
                    "win8_livetile_tile_clear",
                    "win8_livetile_tile_notification",
                    "win8_search_add_suggestions",
                    "win8_search_disable",
                    "win8_search_enable",
                    "win8_secondarytile_badge_notification",
                    "win8_secondarytile_delete",
                    "win8_secondarytile_pin",
                    "win8_settingscharm_add_entry",
                    "win8_settingscharm_add_html_entry",
                    "win8_settingscharm_add_xaml_entry",
                    "win8_settingscharm_get_xaml_property",
                    "win8_settingscharm_remove_entry",
                    "win8_settingscharm_set_xaml_property",
                    "win8_share_file",
                    "win8_share_image",
                    "win8_share_screenshot",
                    "win8_share_text",
                    "win8_share_url",
                    "window_center",
                    "window_device",
                    "window_get_caption",
                    "window_get_color",
                    "window_get_colour",
                    "window_get_cursor",
                    "window_get_fullscreen",
                    "window_get_height",
                    "window_get_visible_rects",
                    "window_get_width",
                    "window_get_x",
                    "window_get_y",
                    "window_handle",
                    "window_has_focus",
                    "window_mouse_get_x",
                    "window_mouse_get_y",
                    "window_mouse_set",
                    "window_set_caption",
                    "window_set_color",
                    "window_set_colour",
                    "window_set_cursor",
                    "window_set_fullscreen",
                    "window_set_max_height",
                    "window_set_max_width",
                    "window_set_min_height",
                    "window_set_min_width",
                    "window_set_position",
                    "window_set_rectangle",
                    "window_set_size",
                    "window_view_mouse_get_x",
                    "window_view_mouse_get_y",
                    "window_views_mouse_get_x",
                    "window_views_mouse_get_y",
                    "winphone_license_trial_version",
                    "winphone_tile_back_content",
                    "winphone_tile_back_content_wide",
                    "winphone_tile_back_image",
                    "winphone_tile_back_image_wide",
                    "winphone_tile_back_title",
                    "winphone_tile_background_color",
                    "winphone_tile_background_colour",
                    "winphone_tile_count",
                    "winphone_tile_cycle_images",
                    "winphone_tile_front_image",
                    "winphone_tile_front_image_small",
                    "winphone_tile_front_image_wide",
                    "winphone_tile_icon_image",
                    "winphone_tile_small_background_image",
                    "winphone_tile_small_icon_image",
                    "winphone_tile_title",
                    "winphone_tile_wide_content",
                    "zip_unzip"
                ],
                literal: [
                    "all",
                    "false",
                    "noone",
                    "pointer_invalid",
                    "pointer_null",
                    "true",
                    "undefined"
                ],
                symbol: [
                    "ANSI_CHARSET",
                    "ARABIC_CHARSET",
                    "BALTIC_CHARSET",
                    "CHINESEBIG5_CHARSET",
                    "DEFAULT_CHARSET",
                    "EASTEUROPE_CHARSET",
                    "GB2312_CHARSET",
                    "GM_build_date",
                    "GM_runtime_version",
                    "GM_version",
                    "GREEK_CHARSET",
                    "HANGEUL_CHARSET",
                    "HEBREW_CHARSET",
                    "JOHAB_CHARSET",
                    "MAC_CHARSET",
                    "OEM_CHARSET",
                    "RUSSIAN_CHARSET",
                    "SHIFTJIS_CHARSET",
                    "SYMBOL_CHARSET",
                    "THAI_CHARSET",
                    "TURKISH_CHARSET",
                    "VIETNAMESE_CHARSET",
                    "achievement_achievement_info",
                    "achievement_filter_all_players",
                    "achievement_filter_favorites_only",
                    "achievement_filter_friends_only",
                    "achievement_friends_info",
                    "achievement_leaderboard_info",
                    "achievement_our_info",
                    "achievement_pic_loaded",
                    "achievement_show_achievement",
                    "achievement_show_bank",
                    "achievement_show_friend_picker",
                    "achievement_show_leaderboard",
                    "achievement_show_profile",
                    "achievement_show_purchase_prompt",
                    "achievement_show_ui",
                    "achievement_type_achievement_challenge",
                    "achievement_type_score_challenge",
                    "asset_font",
                    "asset_object",
                    "asset_path",
                    "asset_room",
                    "asset_script",
                    "asset_shader",
                    "asset_sound",
                    "asset_sprite",
                    "asset_tiles",
                    "asset_timeline",
                    "asset_unknown",
                    "audio_3d",
                    "audio_falloff_exponent_distance",
                    "audio_falloff_exponent_distance_clamped",
                    "audio_falloff_inverse_distance",
                    "audio_falloff_inverse_distance_clamped",
                    "audio_falloff_linear_distance",
                    "audio_falloff_linear_distance_clamped",
                    "audio_falloff_none",
                    "audio_mono",
                    "audio_new_system",
                    "audio_old_system",
                    "audio_stereo",
                    "bm_add",
                    "bm_complex",
                    "bm_dest_alpha",
                    "bm_dest_color",
                    "bm_dest_colour",
                    "bm_inv_dest_alpha",
                    "bm_inv_dest_color",
                    "bm_inv_dest_colour",
                    "bm_inv_src_alpha",
                    "bm_inv_src_color",
                    "bm_inv_src_colour",
                    "bm_max",
                    "bm_normal",
                    "bm_one",
                    "bm_src_alpha",
                    "bm_src_alpha_sat",
                    "bm_src_color",
                    "bm_src_colour",
                    "bm_subtract",
                    "bm_zero",
                    "browser_chrome",
                    "browser_edge",
                    "browser_firefox",
                    "browser_ie",
                    "browser_ie_mobile",
                    "browser_not_a_browser",
                    "browser_opera",
                    "browser_safari",
                    "browser_safari_mobile",
                    "browser_tizen",
                    "browser_unknown",
                    "browser_windows_store",
                    "buffer_bool",
                    "buffer_f16",
                    "buffer_f32",
                    "buffer_f64",
                    "buffer_fast",
                    "buffer_fixed",
                    "buffer_generalerror",
                    "buffer_grow",
                    "buffer_invalidtype",
                    "buffer_network",
                    "buffer_outofbounds",
                    "buffer_outofspace",
                    "buffer_s16",
                    "buffer_s32",
                    "buffer_s8",
                    "buffer_seek_end",
                    "buffer_seek_relative",
                    "buffer_seek_start",
                    "buffer_string",
                    "buffer_surface_copy",
                    "buffer_text",
                    "buffer_u16",
                    "buffer_u32",
                    "buffer_u64",
                    "buffer_u8",
                    "buffer_vbuffer",
                    "buffer_wrap",
                    "button_type",
                    "c_aqua",
                    "c_black",
                    "c_blue",
                    "c_dkgray",
                    "c_fuchsia",
                    "c_gray",
                    "c_green",
                    "c_lime",
                    "c_ltgray",
                    "c_maroon",
                    "c_navy",
                    "c_olive",
                    "c_orange",
                    "c_purple",
                    "c_red",
                    "c_silver",
                    "c_teal",
                    "c_white",
                    "c_yellow",
                    "cmpfunc_always",
                    "cmpfunc_equal",
                    "cmpfunc_greater",
                    "cmpfunc_greaterequal",
                    "cmpfunc_less",
                    "cmpfunc_lessequal",
                    "cmpfunc_never",
                    "cmpfunc_notequal",
                    "cr_appstart",
                    "cr_arrow",
                    "cr_beam",
                    "cr_cross",
                    "cr_default",
                    "cr_drag",
                    "cr_handpoint",
                    "cr_hourglass",
                    "cr_none",
                    "cr_size_all",
                    "cr_size_nesw",
                    "cr_size_ns",
                    "cr_size_nwse",
                    "cr_size_we",
                    "cr_uparrow",
                    "cull_clockwise",
                    "cull_counterclockwise",
                    "cull_noculling",
                    "device_emulator",
                    "device_ios_ipad",
                    "device_ios_ipad_retina",
                    "device_ios_iphone",
                    "device_ios_iphone5",
                    "device_ios_iphone6",
                    "device_ios_iphone6plus",
                    "device_ios_iphone_retina",
                    "device_ios_unknown",
                    "device_tablet",
                    "display_landscape",
                    "display_landscape_flipped",
                    "display_portrait",
                    "display_portrait_flipped",
                    "dll_cdecl",
                    "dll_stdcall",
                    "ds_type_grid",
                    "ds_type_list",
                    "ds_type_map",
                    "ds_type_priority",
                    "ds_type_queue",
                    "ds_type_stack",
                    "ef_cloud",
                    "ef_ellipse",
                    "ef_explosion",
                    "ef_firework",
                    "ef_flare",
                    "ef_rain",
                    "ef_ring",
                    "ef_smoke",
                    "ef_smokeup",
                    "ef_snow",
                    "ef_spark",
                    "ef_star",
                    "ev_alarm",
                    "ev_animation_end",
                    "ev_boundary",
                    "ev_cleanup",
                    "ev_close_button",
                    "ev_collision",
                    "ev_create",
                    "ev_destroy",
                    "ev_draw",
                    "ev_draw_begin",
                    "ev_draw_end",
                    "ev_draw_post",
                    "ev_draw_pre",
                    "ev_end_of_path",
                    "ev_game_end",
                    "ev_game_start",
                    "ev_gesture",
                    "ev_gesture_double_tap",
                    "ev_gesture_drag_end",
                    "ev_gesture_drag_start",
                    "ev_gesture_dragging",
                    "ev_gesture_flick",
                    "ev_gesture_pinch_end",
                    "ev_gesture_pinch_in",
                    "ev_gesture_pinch_out",
                    "ev_gesture_pinch_start",
                    "ev_gesture_rotate_end",
                    "ev_gesture_rotate_start",
                    "ev_gesture_rotating",
                    "ev_gesture_tap",
                    "ev_global_gesture_double_tap",
                    "ev_global_gesture_drag_end",
                    "ev_global_gesture_drag_start",
                    "ev_global_gesture_dragging",
                    "ev_global_gesture_flick",
                    "ev_global_gesture_pinch_end",
                    "ev_global_gesture_pinch_in",
                    "ev_global_gesture_pinch_out",
                    "ev_global_gesture_pinch_start",
                    "ev_global_gesture_rotate_end",
                    "ev_global_gesture_rotate_start",
                    "ev_global_gesture_rotating",
                    "ev_global_gesture_tap",
                    "ev_global_left_button",
                    "ev_global_left_press",
                    "ev_global_left_release",
                    "ev_global_middle_button",
                    "ev_global_middle_press",
                    "ev_global_middle_release",
                    "ev_global_right_button",
                    "ev_global_right_press",
                    "ev_global_right_release",
                    "ev_gui",
                    "ev_gui_begin",
                    "ev_gui_end",
                    "ev_joystick1_button1",
                    "ev_joystick1_button2",
                    "ev_joystick1_button3",
                    "ev_joystick1_button4",
                    "ev_joystick1_button5",
                    "ev_joystick1_button6",
                    "ev_joystick1_button7",
                    "ev_joystick1_button8",
                    "ev_joystick1_down",
                    "ev_joystick1_left",
                    "ev_joystick1_right",
                    "ev_joystick1_up",
                    "ev_joystick2_button1",
                    "ev_joystick2_button2",
                    "ev_joystick2_button3",
                    "ev_joystick2_button4",
                    "ev_joystick2_button5",
                    "ev_joystick2_button6",
                    "ev_joystick2_button7",
                    "ev_joystick2_button8",
                    "ev_joystick2_down",
                    "ev_joystick2_left",
                    "ev_joystick2_right",
                    "ev_joystick2_up",
                    "ev_keyboard",
                    "ev_keypress",
                    "ev_keyrelease",
                    "ev_left_button",
                    "ev_left_press",
                    "ev_left_release",
                    "ev_middle_button",
                    "ev_middle_press",
                    "ev_middle_release",
                    "ev_mouse",
                    "ev_mouse_enter",
                    "ev_mouse_leave",
                    "ev_mouse_wheel_down",
                    "ev_mouse_wheel_up",
                    "ev_no_button",
                    "ev_no_more_health",
                    "ev_no_more_lives",
                    "ev_other",
                    "ev_outside",
                    "ev_right_button",
                    "ev_right_press",
                    "ev_right_release",
                    "ev_room_end",
                    "ev_room_start",
                    "ev_step",
                    "ev_step_begin",
                    "ev_step_end",
                    "ev_step_normal",
                    "ev_trigger",
                    "ev_user0",
                    "ev_user1",
                    "ev_user2",
                    "ev_user3",
                    "ev_user4",
                    "ev_user5",
                    "ev_user6",
                    "ev_user7",
                    "ev_user8",
                    "ev_user9",
                    "ev_user10",
                    "ev_user11",
                    "ev_user12",
                    "ev_user13",
                    "ev_user14",
                    "ev_user15",
                    "fa_archive",
                    "fa_bottom",
                    "fa_center",
                    "fa_directory",
                    "fa_hidden",
                    "fa_left",
                    "fa_middle",
                    "fa_readonly",
                    "fa_right",
                    "fa_sysfile",
                    "fa_top",
                    "fa_volumeid",
                    "fb_login_default",
                    "fb_login_fallback_to_webview",
                    "fb_login_forcing_safari",
                    "fb_login_forcing_webview",
                    "fb_login_no_fallback_to_webview",
                    "fb_login_use_system_account",
                    "gamespeed_fps",
                    "gamespeed_microseconds",
                    "ge_lose",
                    "global",
                    "gp_axislh",
                    "gp_axislv",
                    "gp_axisrh",
                    "gp_axisrv",
                    "gp_face1",
                    "gp_face2",
                    "gp_face3",
                    "gp_face4",
                    "gp_padd",
                    "gp_padl",
                    "gp_padr",
                    "gp_padu",
                    "gp_select",
                    "gp_shoulderl",
                    "gp_shoulderlb",
                    "gp_shoulderr",
                    "gp_shoulderrb",
                    "gp_start",
                    "gp_stickl",
                    "gp_stickr",
                    "iap_available",
                    "iap_canceled",
                    "iap_ev_consume",
                    "iap_ev_product",
                    "iap_ev_purchase",
                    "iap_ev_restore",
                    "iap_ev_storeload",
                    "iap_failed",
                    "iap_purchased",
                    "iap_refunded",
                    "iap_status_available",
                    "iap_status_loading",
                    "iap_status_processing",
                    "iap_status_restoring",
                    "iap_status_unavailable",
                    "iap_status_uninitialised",
                    "iap_storeload_failed",
                    "iap_storeload_ok",
                    "iap_unavailable",
                    "input_type",
                    "kbv_autocapitalize_characters",
                    "kbv_autocapitalize_none",
                    "kbv_autocapitalize_sentences",
                    "kbv_autocapitalize_words",
                    "kbv_returnkey_continue",
                    "kbv_returnkey_default",
                    "kbv_returnkey_done",
                    "kbv_returnkey_emergency",
                    "kbv_returnkey_go",
                    "kbv_returnkey_google",
                    "kbv_returnkey_join",
                    "kbv_returnkey_next",
                    "kbv_returnkey_route",
                    "kbv_returnkey_search",
                    "kbv_returnkey_send",
                    "kbv_returnkey_yahoo",
                    "kbv_type_ascii",
                    "kbv_type_default",
                    "kbv_type_email",
                    "kbv_type_numbers",
                    "kbv_type_phone",
                    "kbv_type_phone_name",
                    "kbv_type_url",
                    "layerelementtype_background",
                    "layerelementtype_instance",
                    "layerelementtype_oldtilemap",
                    "layerelementtype_particlesystem",
                    "layerelementtype_sprite",
                    "layerelementtype_tile",
                    "layerelementtype_tilemap",
                    "layerelementtype_undefined",
                    "lb_disp_none",
                    "lb_disp_numeric",
                    "lb_disp_time_ms",
                    "lb_disp_time_sec",
                    "lb_sort_ascending",
                    "lb_sort_descending",
                    "lb_sort_none",
                    "leaderboard_type_number",
                    "leaderboard_type_time_mins_secs",
                    "lighttype_dir",
                    "lighttype_point",
                    "local",
                    "matrix_projection",
                    "matrix_view",
                    "matrix_world",
                    "mb_any",
                    "mb_left",
                    "mb_middle",
                    "mb_none",
                    "mb_right",
                    "mip_markedonly",
                    "mip_off",
                    "mip_on",
                    "network_config_connect_timeout",
                    "network_config_disable_reliable_udp",
                    "network_config_enable_reliable_udp",
                    "network_config_use_non_blocking_socket",
                    "network_socket_bluetooth",
                    "network_socket_tcp",
                    "network_socket_udp",
                    "network_type_connect",
                    "network_type_data",
                    "network_type_disconnect",
                    "network_type_non_blocking_connect",
                    "of_challen",
                    "of_challenge_tie",
                    "of_challenge_win",
                    "os_3ds",
                    "os_android",
                    "os_bb10",
                    "os_ios",
                    "os_linux",
                    "os_macosx",
                    "os_ps3",
                    "os_ps4",
                    "os_psvita",
                    "os_switch",
                    "os_symbian",
                    "os_tizen",
                    "os_tvos",
                    "os_unknown",
                    "os_uwp",
                    "os_wiiu",
                    "os_win32",
                    "os_win8native",
                    "os_windows",
                    "os_winphone",
                    "os_xbox360",
                    "os_xboxone",
                    "other",
                    "ov_achievements",
                    "ov_community",
                    "ov_friends",
                    "ov_gamegroup",
                    "ov_players",
                    "ov_settings",
                    "path_action_continue",
                    "path_action_restart",
                    "path_action_reverse",
                    "path_action_stop",
                    "phy_debug_render_aabb",
                    "phy_debug_render_collision_pairs",
                    "phy_debug_render_coms",
                    "phy_debug_render_core_shapes",
                    "phy_debug_render_joints",
                    "phy_debug_render_obb",
                    "phy_debug_render_shapes",
                    "phy_joint_anchor_1_x",
                    "phy_joint_anchor_1_y",
                    "phy_joint_anchor_2_x",
                    "phy_joint_anchor_2_y",
                    "phy_joint_angle",
                    "phy_joint_angle_limits",
                    "phy_joint_damping_ratio",
                    "phy_joint_frequency",
                    "phy_joint_length_1",
                    "phy_joint_length_2",
                    "phy_joint_lower_angle_limit",
                    "phy_joint_max_force",
                    "phy_joint_max_length",
                    "phy_joint_max_motor_force",
                    "phy_joint_max_motor_torque",
                    "phy_joint_max_torque",
                    "phy_joint_motor_force",
                    "phy_joint_motor_speed",
                    "phy_joint_motor_torque",
                    "phy_joint_reaction_force_x",
                    "phy_joint_reaction_force_y",
                    "phy_joint_reaction_torque",
                    "phy_joint_speed",
                    "phy_joint_translation",
                    "phy_joint_upper_angle_limit",
                    "phy_particle_data_flag_category",
                    "phy_particle_data_flag_color",
                    "phy_particle_data_flag_colour",
                    "phy_particle_data_flag_position",
                    "phy_particle_data_flag_typeflags",
                    "phy_particle_data_flag_velocity",
                    "phy_particle_flag_colormixing",
                    "phy_particle_flag_colourmixing",
                    "phy_particle_flag_elastic",
                    "phy_particle_flag_powder",
                    "phy_particle_flag_spring",
                    "phy_particle_flag_tensile",
                    "phy_particle_flag_viscous",
                    "phy_particle_flag_wall",
                    "phy_particle_flag_water",
                    "phy_particle_flag_zombie",
                    "phy_particle_group_flag_rigid",
                    "phy_particle_group_flag_solid",
                    "pi",
                    "pr_linelist",
                    "pr_linestrip",
                    "pr_pointlist",
                    "pr_trianglefan",
                    "pr_trianglelist",
                    "pr_trianglestrip",
                    "ps_distr_gaussian",
                    "ps_distr_invgaussian",
                    "ps_distr_linear",
                    "ps_shape_diamond",
                    "ps_shape_ellipse",
                    "ps_shape_line",
                    "ps_shape_rectangle",
                    "pt_shape_circle",
                    "pt_shape_cloud",
                    "pt_shape_disk",
                    "pt_shape_explosion",
                    "pt_shape_flare",
                    "pt_shape_line",
                    "pt_shape_pixel",
                    "pt_shape_ring",
                    "pt_shape_smoke",
                    "pt_shape_snow",
                    "pt_shape_spark",
                    "pt_shape_sphere",
                    "pt_shape_square",
                    "pt_shape_star",
                    "spritespeed_framespergameframe",
                    "spritespeed_framespersecond",
                    "text_type",
                    "tf_anisotropic",
                    "tf_linear",
                    "tf_point",
                    "tile_flip",
                    "tile_index_mask",
                    "tile_mirror",
                    "tile_rotate",
                    "timezone_local",
                    "timezone_utc",
                    "tm_countvsyncs",
                    "tm_sleep",
                    "ty_real",
                    "ty_string",
                    "ugc_filetype_community",
                    "ugc_filetype_microtrans",
                    "ugc_list_Favorited",
                    "ugc_list_Followed",
                    "ugc_list_Published",
                    "ugc_list_Subscribed",
                    "ugc_list_UsedOrPlayed",
                    "ugc_list_VotedDown",
                    "ugc_list_VotedOn",
                    "ugc_list_VotedUp",
                    "ugc_list_WillVoteLater",
                    "ugc_match_AllGuides",
                    "ugc_match_Artwork",
                    "ugc_match_Collections",
                    "ugc_match_ControllerBindings",
                    "ugc_match_IntegratedGuides",
                    "ugc_match_Items",
                    "ugc_match_Items_Mtx",
                    "ugc_match_Items_ReadyToUse",
                    "ugc_match_Screenshots",
                    "ugc_match_UsableInGame",
                    "ugc_match_Videos",
                    "ugc_match_WebGuides",
                    "ugc_query_AcceptedForGameRankedByAcceptanceDate",
                    "ugc_query_CreatedByFollowedUsersRankedByPublicationDate",
                    "ugc_query_CreatedByFriendsRankedByPublicationDate",
                    "ugc_query_FavoritedByFriendsRankedByPublicationDate",
                    "ugc_query_NotYetRated",
                    "ugc_query_RankedByNumTimesReported",
                    "ugc_query_RankedByPublicationDate",
                    "ugc_query_RankedByTextSearch",
                    "ugc_query_RankedByTotalVotesAsc",
                    "ugc_query_RankedByTrend",
                    "ugc_query_RankedByVote",
                    "ugc_query_RankedByVotesUp",
                    "ugc_result_success",
                    "ugc_sortorder_CreationOrderAsc",
                    "ugc_sortorder_CreationOrderDesc",
                    "ugc_sortorder_ForModeration",
                    "ugc_sortorder_LastUpdatedDesc",
                    "ugc_sortorder_SubscriptionDateDesc",
                    "ugc_sortorder_TitleAsc",
                    "ugc_sortorder_VoteScoreDesc",
                    "ugc_visibility_friends_only",
                    "ugc_visibility_private",
                    "ugc_visibility_public",
                    "vertex_type_color",
                    "vertex_type_colour",
                    "vertex_type_float1",
                    "vertex_type_float2",
                    "vertex_type_float3",
                    "vertex_type_float4",
                    "vertex_type_ubyte4",
                    "vertex_usage_binormal",
                    "vertex_usage_blendindices",
                    "vertex_usage_blendweight",
                    "vertex_usage_color",
                    "vertex_usage_colour",
                    "vertex_usage_depth",
                    "vertex_usage_fog",
                    "vertex_usage_normal",
                    "vertex_usage_position",
                    "vertex_usage_psize",
                    "vertex_usage_sample",
                    "vertex_usage_tangent",
                    "vertex_usage_texcoord",
                    "vertex_usage_textcoord",
                    "vk_add",
                    "vk_alt",
                    "vk_anykey",
                    "vk_backspace",
                    "vk_control",
                    "vk_decimal",
                    "vk_delete",
                    "vk_divide",
                    "vk_down",
                    "vk_end",
                    "vk_enter",
                    "vk_escape",
                    "vk_f1",
                    "vk_f2",
                    "vk_f3",
                    "vk_f4",
                    "vk_f5",
                    "vk_f6",
                    "vk_f7",
                    "vk_f8",
                    "vk_f9",
                    "vk_f10",
                    "vk_f11",
                    "vk_f12",
                    "vk_home",
                    "vk_insert",
                    "vk_lalt",
                    "vk_lcontrol",
                    "vk_left",
                    "vk_lshift",
                    "vk_multiply",
                    "vk_nokey",
                    "vk_numpad0",
                    "vk_numpad1",
                    "vk_numpad2",
                    "vk_numpad3",
                    "vk_numpad4",
                    "vk_numpad5",
                    "vk_numpad6",
                    "vk_numpad7",
                    "vk_numpad8",
                    "vk_numpad9",
                    "vk_pagedown",
                    "vk_pageup",
                    "vk_pause",
                    "vk_printscreen",
                    "vk_ralt",
                    "vk_rcontrol",
                    "vk_return",
                    "vk_right",
                    "vk_rshift",
                    "vk_shift",
                    "vk_space",
                    "vk_subtract",
                    "vk_tab",
                    "vk_up"
                ],
                "variable.language": [
                    "alarm",
                    "application_surface",
                    "argument",
                    "argument0",
                    "argument1",
                    "argument2",
                    "argument3",
                    "argument4",
                    "argument5",
                    "argument6",
                    "argument7",
                    "argument8",
                    "argument9",
                    "argument10",
                    "argument11",
                    "argument12",
                    "argument13",
                    "argument14",
                    "argument15",
                    "argument_count",
                    "argument_relative",
                    "async_load",
                    "background_color",
                    "background_colour",
                    "background_showcolor",
                    "background_showcolour",
                    "bbox_bottom",
                    "bbox_left",
                    "bbox_right",
                    "bbox_top",
                    "browser_height",
                    "browser_width",
                    "caption_health",
                    "caption_lives",
                    "caption_score",
                    "current_day",
                    "current_hour",
                    "current_minute",
                    "current_month",
                    "current_second",
                    "current_time",
                    "current_weekday",
                    "current_year",
                    "cursor_sprite",
                    "debug_mode",
                    "delta_time",
                    "depth",
                    "direction",
                    "display_aa",
                    "error_last",
                    "error_occurred",
                    "event_action",
                    "event_data",
                    "event_number",
                    "event_object",
                    "event_type",
                    "fps",
                    "fps_real",
                    "friction",
                    "game_display_name",
                    "game_id",
                    "game_project_name",
                    "game_save_id",
                    "gamemaker_pro",
                    "gamemaker_registered",
                    "gamemaker_version",
                    "gravity",
                    "gravity_direction",
                    "health",
                    "hspeed",
                    "iap_data",
                    "id|0",
                    "image_alpha",
                    "image_angle",
                    "image_blend",
                    "image_index",
                    "image_number",
                    "image_speed",
                    "image_xscale",
                    "image_yscale",
                    "instance_count",
                    "instance_id",
                    "keyboard_key",
                    "keyboard_lastchar",
                    "keyboard_lastkey",
                    "keyboard_string",
                    "layer",
                    "lives",
                    "mask_index",
                    "mouse_button",
                    "mouse_lastbutton",
                    "mouse_x",
                    "mouse_y",
                    "object_index",
                    "os_browser",
                    "os_device",
                    "os_type",
                    "os_version",
                    "path_endaction",
                    "path_index",
                    "path_orientation",
                    "path_position",
                    "path_positionprevious",
                    "path_scale",
                    "path_speed",
                    "persistent",
                    "phy_active",
                    "phy_angular_damping",
                    "phy_angular_velocity",
                    "phy_bullet",
                    "phy_col_normal_x",
                    "phy_col_normal_y",
                    "phy_collision_points",
                    "phy_collision_x",
                    "phy_collision_y",
                    "phy_com_x",
                    "phy_com_y",
                    "phy_dynamic",
                    "phy_fixed_rotation",
                    "phy_inertia",
                    "phy_kinematic",
                    "phy_linear_damping",
                    "phy_linear_velocity_x",
                    "phy_linear_velocity_y",
                    "phy_mass",
                    "phy_position_x",
                    "phy_position_xprevious",
                    "phy_position_y",
                    "phy_position_yprevious",
                    "phy_rotation",
                    "phy_sleeping",
                    "phy_speed",
                    "phy_speed_x",
                    "phy_speed_y",
                    "program_directory",
                    "room",
                    "room_caption",
                    "room_first",
                    "room_height",
                    "room_last",
                    "room_persistent",
                    "room_speed",
                    "room_width",
                    "score",
                    "self",
                    "show_health",
                    "show_lives",
                    "show_score",
                    "solid",
                    "speed",
                    "sprite_height",
                    "sprite_index",
                    "sprite_width",
                    "sprite_xoffset",
                    "sprite_yoffset",
                    "temp_directory",
                    "timeline_index",
                    "timeline_loop",
                    "timeline_position",
                    "timeline_running",
                    "timeline_speed",
                    "view_angle",
                    "view_camera",
                    "view_current",
                    "view_enabled",
                    "view_hborder",
                    "view_hport",
                    "view_hspeed",
                    "view_hview",
                    "view_object",
                    "view_surface_id",
                    "view_vborder",
                    "view_visible",
                    "view_vspeed",
                    "view_wport",
                    "view_wview",
                    "view_xport",
                    "view_xview",
                    "view_yport",
                    "view_yview",
                    "visible",
                    "vspeed",
                    "webgl_enabled",
                    "working_directory",
                    "xprevious",
                    "xstart",
                    "x|0",
                    "yprevious",
                    "ystart",
                    "y|0"
                ]
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE
            ]
        };
    }), Ya)), Cs.registerLanguage("go", (qa || (qa = 1, Va = function(e) {
        const t = {
            keyword: [
                "break",
                "case",
                "chan",
                "const",
                "continue",
                "default",
                "defer",
                "else",
                "fallthrough",
                "for",
                "func",
                "go",
                "goto",
                "if",
                "import",
                "interface",
                "map",
                "package",
                "range",
                "return",
                "select",
                "struct",
                "switch",
                "type",
                "var"
            ],
            type: [
                "bool",
                "byte",
                "complex64",
                "complex128",
                "error",
                "float32",
                "float64",
                "int8",
                "int16",
                "int32",
                "int64",
                "string",
                "uint8",
                "uint16",
                "uint32",
                "uint64",
                "int",
                "uint",
                "uintptr",
                "rune"
            ],
            literal: [
                "true",
                "false",
                "iota",
                "nil"
            ],
            built_in: [
                "append",
                "cap",
                "close",
                "complex",
                "copy",
                "imag",
                "len",
                "make",
                "new",
                "panic",
                "print",
                "println",
                "real",
                "recover",
                "delete"
            ]
        };
        return {
            name: "Go",
            aliases: [
                "golang"
            ],
            keywords: t,
            illegal: "</",
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "string",
                    variants: [
                        e.QUOTE_STRING_MODE,
                        e.APOS_STRING_MODE,
                        {
                            begin: "`",
                            end: "`"
                        }
                    ]
                },
                {
                    className: "number",
                    variants: [
                        {
                            begin: e.C_NUMBER_RE + "[i]",
                            relevance: 1
                        },
                        e.C_NUMBER_MODE
                    ]
                },
                {
                    begin: /:=/
                },
                {
                    className: "function",
                    beginKeywords: "func",
                    end: "\\s*(\\{|$)",
                    excludeEnd: !0,
                    contains: [
                        e.TITLE_MODE,
                        {
                            className: "params",
                            begin: /\(/,
                            end: /\)/,
                            endsParent: !0,
                            keywords: t,
                            illegal: /["']/
                        }
                    ]
                }
            ]
        };
    }), Va)), Cs.registerLanguage("golo", ($a || ($a = 1, za = function(e) {
        return {
            name: "Golo",
            keywords: {
                keyword: [
                    "println",
                    "readln",
                    "print",
                    "import",
                    "module",
                    "function",
                    "local",
                    "return",
                    "let",
                    "var",
                    "while",
                    "for",
                    "foreach",
                    "times",
                    "in",
                    "case",
                    "when",
                    "match",
                    "with",
                    "break",
                    "continue",
                    "augment",
                    "augmentation",
                    "each",
                    "find",
                    "filter",
                    "reduce",
                    "if",
                    "then",
                    "else",
                    "otherwise",
                    "try",
                    "catch",
                    "finally",
                    "raise",
                    "throw",
                    "orIfNull",
                    "DynamicObject|10",
                    "DynamicVariable",
                    "struct",
                    "Observable",
                    "map",
                    "set",
                    "vector",
                    "list",
                    "array"
                ],
                literal: [
                    "true",
                    "false",
                    "null"
                ]
            },
            contains: [
                e.HASH_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE,
                {
                    className: "meta",
                    begin: "@[A-Za-z]+"
                }
            ]
        };
    }), za)), Cs.registerLanguage("gradle", (Qa || (Qa = 1, Wa = function(e) {
        return {
            name: "Gradle",
            case_insensitive: !0,
            keywords: [
                "task",
                "project",
                "allprojects",
                "subprojects",
                "artifacts",
                "buildscript",
                "configurations",
                "dependencies",
                "repositories",
                "sourceSets",
                "description",
                "delete",
                "from",
                "into",
                "include",
                "exclude",
                "source",
                "classpath",
                "destinationDir",
                "includes",
                "options",
                "sourceCompatibility",
                "targetCompatibility",
                "group",
                "flatDir",
                "doLast",
                "doFirst",
                "flatten",
                "todir",
                "fromdir",
                "ant",
                "def",
                "abstract",
                "break",
                "case",
                "catch",
                "continue",
                "default",
                "do",
                "else",
                "extends",
                "final",
                "finally",
                "for",
                "if",
                "implements",
                "instanceof",
                "native",
                "new",
                "private",
                "protected",
                "public",
                "return",
                "static",
                "switch",
                "synchronized",
                "throw",
                "throws",
                "transient",
                "try",
                "volatile",
                "while",
                "strictfp",
                "package",
                "import",
                "false",
                "null",
                "super",
                "this",
                "true",
                "antlrtask",
                "checkstyle",
                "codenarc",
                "copy",
                "boolean",
                "byte",
                "char",
                "class",
                "double",
                "float",
                "int",
                "interface",
                "long",
                "short",
                "void",
                "compile",
                "runTime",
                "file",
                "fileTree",
                "abs",
                "any",
                "append",
                "asList",
                "asWritable",
                "call",
                "collect",
                "compareTo",
                "count",
                "div",
                "dump",
                "each",
                "eachByte",
                "eachFile",
                "eachLine",
                "every",
                "find",
                "findAll",
                "flatten",
                "getAt",
                "getErr",
                "getIn",
                "getOut",
                "getText",
                "grep",
                "immutable",
                "inject",
                "inspect",
                "intersect",
                "invokeMethods",
                "isCase",
                "join",
                "leftShift",
                "minus",
                "multiply",
                "newInputStream",
                "newOutputStream",
                "newPrintWriter",
                "newReader",
                "newWriter",
                "next",
                "plus",
                "pop",
                "power",
                "previous",
                "print",
                "println",
                "push",
                "putAt",
                "read",
                "readBytes",
                "readLines",
                "reverse",
                "reverseEach",
                "round",
                "size",
                "sort",
                "splitEachLine",
                "step",
                "subMap",
                "times",
                "toInteger",
                "toList",
                "tokenize",
                "upto",
                "waitForOrKill",
                "withPrintWriter",
                "withReader",
                "withStream",
                "withWriter",
                "withWriterAppend",
                "write",
                "writeLine"
            ],
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.NUMBER_MODE,
                e.REGEXP_MODE
            ]
        };
    }), Wa)), Cs.registerLanguage("graphql", (ja || (ja = 1, Ka = function(e) {
        const t = e.regex;
        return {
            name: "GraphQL",
            aliases: [
                "gql"
            ],
            case_insensitive: !0,
            disableAutodetect: !1,
            keywords: {
                keyword: [
                    "query",
                    "mutation",
                    "subscription",
                    "type",
                    "input",
                    "schema",
                    "directive",
                    "interface",
                    "union",
                    "scalar",
                    "fragment",
                    "enum",
                    "on"
                ],
                literal: [
                    "true",
                    "false",
                    "null"
                ]
            },
            contains: [
                e.HASH_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.NUMBER_MODE,
                {
                    scope: "punctuation",
                    match: /[.]{3}/,
                    relevance: 0
                },
                {
                    scope: "punctuation",
                    begin: /[\!\(\)\:\=\[\]\{\|\}]{1}/,
                    relevance: 0
                },
                {
                    scope: "variable",
                    begin: /\$/,
                    end: /\W/,
                    excludeEnd: !0,
                    relevance: 0
                },
                {
                    scope: "meta",
                    match: /@\w+/,
                    excludeEnd: !0
                },
                {
                    scope: "symbol",
                    begin: t.concat(/[_A-Za-z][_0-9A-Za-z]*/, t.lookahead(/\s*:/)),
                    relevance: 0
                }
            ],
            illegal: [
                /[;<']/,
                /BEGIN/
            ]
        };
    }), Ka)), Cs.registerLanguage("groovy", function() {
        if (Za) return Xa;
        function e(e1, t = {}) {
            return t.variants = e1, t;
        }
        return Za = 1, Xa = function(t) {
            const a = t.regex, n = "[A-Za-z0-9_$]+", i = e([
                t.C_LINE_COMMENT_MODE,
                t.C_BLOCK_COMMENT_MODE,
                t.COMMENT("/\\*\\*", "\\*/", {
                    relevance: 0,
                    contains: [
                        {
                            begin: /\w+@/,
                            relevance: 0
                        },
                        {
                            className: "doctag",
                            begin: "@[A-Za-z]+"
                        }
                    ]
                })
            ]), r = {
                className: "regexp",
                begin: /~?\/[^\/\n]+\//,
                contains: [
                    t.BACKSLASH_ESCAPE
                ]
            }, o = e([
                t.BINARY_NUMBER_MODE,
                t.C_NUMBER_MODE
            ]), s = e([
                {
                    begin: /"""/,
                    end: /"""/
                },
                {
                    begin: /'''/,
                    end: /'''/
                },
                {
                    begin: "\\$/",
                    end: "/\\$",
                    relevance: 10
                },
                t.APOS_STRING_MODE,
                t.QUOTE_STRING_MODE
            ], {
                className: "string"
            }), l = {
                match: [
                    /(class|interface|trait|enum|record|extends|implements)/,
                    /\s+/,
                    t.UNDERSCORE_IDENT_RE
                ],
                scope: {
                    1: "keyword",
                    3: "title.class"
                }
            };
            return {
                name: "Groovy",
                keywords: {
                    "variable.language": "this super",
                    literal: "true false null",
                    type: [
                        "byte",
                        "short",
                        "char",
                        "int",
                        "long",
                        "boolean",
                        "float",
                        "double",
                        "void"
                    ],
                    keyword: [
                        "def",
                        "as",
                        "in",
                        "assert",
                        "trait",
                        "abstract",
                        "static",
                        "volatile",
                        "transient",
                        "public",
                        "private",
                        "protected",
                        "synchronized",
                        "final",
                        "class",
                        "interface",
                        "enum",
                        "if",
                        "else",
                        "for",
                        "while",
                        "switch",
                        "case",
                        "break",
                        "default",
                        "continue",
                        "throw",
                        "throws",
                        "try",
                        "catch",
                        "finally",
                        "implements",
                        "extends",
                        "new",
                        "import",
                        "package",
                        "return",
                        "instanceof",
                        "var"
                    ]
                },
                contains: [
                    t.SHEBANG({
                        binary: "groovy",
                        relevance: 10
                    }),
                    i,
                    s,
                    r,
                    o,
                    l,
                    {
                        className: "meta",
                        begin: "@[A-Za-z]+",
                        relevance: 0
                    },
                    {
                        className: "attr",
                        begin: n + "[ \t]*:",
                        relevance: 0
                    },
                    {
                        begin: /\?/,
                        end: /:/,
                        relevance: 0,
                        contains: [
                            i,
                            s,
                            r,
                            o,
                            "self"
                        ]
                    },
                    {
                        className: "symbol",
                        begin: "^[ \t]*" + a.lookahead(n + ":"),
                        excludeBegin: !0,
                        end: n + ":",
                        relevance: 0
                    }
                ],
                illegal: /#|<\//
            };
        }, Xa;
    }()), Cs.registerLanguage("haml", (en || (en = 1, Ja = function(e) {
        return {
            name: "HAML",
            case_insensitive: !0,
            contains: [
                {
                    className: "meta",
                    begin: "^!!!( (5|1\\.1|Strict|Frameset|Basic|Mobile|RDFa|XML\\b.*))?$",
                    relevance: 10
                },
                e.COMMENT("^\\s*(!=#|=#|-#|/).*$", null, {
                    relevance: 0
                }),
                {
                    begin: "^\\s*(-|=|!=)(?!#)",
                    end: /$/,
                    subLanguage: "ruby",
                    excludeBegin: !0,
                    excludeEnd: !0
                },
                {
                    className: "tag",
                    begin: "^\\s*%",
                    contains: [
                        {
                            className: "selector-tag",
                            begin: "\\w+"
                        },
                        {
                            className: "selector-id",
                            begin: "#[\\w-]+"
                        },
                        {
                            className: "selector-class",
                            begin: "\\.[\\w-]+"
                        },
                        {
                            begin: /\{\s*/,
                            end: /\s*\}/,
                            contains: [
                                {
                                    begin: ":\\w+\\s*=>",
                                    end: ",\\s+",
                                    returnBegin: !0,
                                    endsWithParent: !0,
                                    contains: [
                                        {
                                            className: "attr",
                                            begin: ":\\w+"
                                        },
                                        e.APOS_STRING_MODE,
                                        e.QUOTE_STRING_MODE,
                                        {
                                            begin: "\\w+",
                                            relevance: 0
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            begin: "\\(\\s*",
                            end: "\\s*\\)",
                            excludeEnd: !0,
                            contains: [
                                {
                                    begin: "\\w+\\s*=",
                                    end: "\\s+",
                                    returnBegin: !0,
                                    endsWithParent: !0,
                                    contains: [
                                        {
                                            className: "attr",
                                            begin: "\\w+",
                                            relevance: 0
                                        },
                                        e.APOS_STRING_MODE,
                                        e.QUOTE_STRING_MODE,
                                        {
                                            begin: "\\w+",
                                            relevance: 0
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    begin: "^\\s*[=~]\\s*"
                },
                {
                    begin: /#\{/,
                    end: /\}/,
                    subLanguage: "ruby",
                    excludeBegin: !0,
                    excludeEnd: !0
                }
            ]
        };
    }), Ja)), Cs.registerLanguage("handlebars", (an || (an = 1, tn = function(e) {
        const t = e.regex, a = {
            $pattern: /[\w.\/]+/,
            built_in: [
                "action",
                "bindattr",
                "collection",
                "component",
                "concat",
                "debugger",
                "each",
                "each-in",
                "get",
                "hash",
                "if",
                "in",
                "input",
                "link-to",
                "loc",
                "log",
                "lookup",
                "mut",
                "outlet",
                "partial",
                "query-params",
                "render",
                "template",
                "textarea",
                "unbound",
                "unless",
                "view",
                "with",
                "yield"
            ]
        }, n = /\[\]|\[[^\]]+\]/, i = /[^\s!"#%&'()*+,.\/;<=>@\[\\\]^`{|}~]+/, r = t.either(/""|"[^"]+"/, /''|'[^']+'/, n, i), o = t.concat(t.optional(/\.|\.\/|\//), r, t.anyNumberOfTimes(t.concat(/(\.|\/)/, r))), s = t.concat("(", n, "|", i, ")(?==)"), l = {
            begin: o
        }, c = e.inherit(l, {
            keywords: {
                $pattern: /[\w.\/]+/,
                literal: [
                    "true",
                    "false",
                    "undefined",
                    "null"
                ]
            }
        }), _ = {
            begin: /\(/,
            end: /\)/
        }, d = {
            className: "attr",
            begin: s,
            relevance: 0,
            starts: {
                begin: /=/,
                end: /=/,
                starts: {
                    contains: [
                        e.NUMBER_MODE,
                        e.QUOTE_STRING_MODE,
                        e.APOS_STRING_MODE,
                        c,
                        _
                    ]
                }
            }
        }, m = {
            contains: [
                e.NUMBER_MODE,
                e.QUOTE_STRING_MODE,
                e.APOS_STRING_MODE,
                {
                    begin: /as\s+\|/,
                    keywords: {
                        keyword: "as"
                    },
                    end: /\|/,
                    contains: [
                        {
                            begin: /\w+/
                        }
                    ]
                },
                d,
                c,
                _
            ],
            returnEnd: !0
        }, p = e.inherit(l, {
            className: "name",
            keywords: a,
            starts: e.inherit(m, {
                end: /\)/
            })
        });
        _.contains = [
            p
        ];
        const u = e.inherit(l, {
            keywords: a,
            className: "name",
            starts: e.inherit(m, {
                end: /\}\}/
            })
        }), g = e.inherit(l, {
            keywords: a,
            className: "name"
        }), E = e.inherit(l, {
            className: "name",
            keywords: a,
            starts: e.inherit(m, {
                end: /\}\}/
            })
        });
        return {
            name: "Handlebars",
            aliases: [
                "hbs",
                "html.hbs",
                "html.handlebars",
                "htmlbars"
            ],
            case_insensitive: !0,
            subLanguage: "xml",
            contains: [
                {
                    begin: /\\\{\{/,
                    skip: !0
                },
                {
                    begin: /\\\\(?=\{\{)/,
                    skip: !0
                },
                e.COMMENT(/\{\{!--/, /--\}\}/),
                e.COMMENT(/\{\{!/, /\}\}/),
                {
                    className: "template-tag",
                    begin: /\{\{\{\{(?!\/)/,
                    end: /\}\}\}\}/,
                    contains: [
                        u
                    ],
                    starts: {
                        end: /\{\{\{\{\//,
                        returnEnd: !0,
                        subLanguage: "xml"
                    }
                },
                {
                    className: "template-tag",
                    begin: /\{\{\{\{\//,
                    end: /\}\}\}\}/,
                    contains: [
                        g
                    ]
                },
                {
                    className: "template-tag",
                    begin: /\{\{#/,
                    end: /\}\}/,
                    contains: [
                        u
                    ]
                },
                {
                    className: "template-tag",
                    begin: /\{\{(?=else\}\})/,
                    end: /\}\}/,
                    keywords: "else"
                },
                {
                    className: "template-tag",
                    begin: /\{\{(?=else if)/,
                    end: /\}\}/,
                    keywords: "else if"
                },
                {
                    className: "template-tag",
                    begin: /\{\{\//,
                    end: /\}\}/,
                    contains: [
                        g
                    ]
                },
                {
                    className: "template-variable",
                    begin: /\{\{\{/,
                    end: /\}\}\}/,
                    contains: [
                        E
                    ]
                },
                {
                    className: "template-variable",
                    begin: /\{\{/,
                    end: /\}\}/,
                    contains: [
                        E
                    ]
                }
            ]
        };
    }), tn)), Cs.registerLanguage("haskell", (rn || (rn = 1, nn = function(e) {
        const t = "([0-9]_*)+", a = "([0-9a-fA-F]_*)+", n = "([!#$%&*+.\\/<=>?@\\\\^~-]|(?!([(),;\\[\\]`|{}]|[_:\"']))(\\p{S}|\\p{P}))", i = {
            variants: [
                e.COMMENT("--+", "$"),
                e.COMMENT(/\{-/, /-\}/, {
                    contains: [
                        "self"
                    ]
                })
            ]
        }, r = {
            className: "meta",
            begin: /\{-#/,
            end: /#-\}/
        }, o = {
            className: "meta",
            begin: "^#",
            end: "$"
        }, s = {
            className: "type",
            begin: "\\b[A-Z][\\w']*",
            relevance: 0
        }, l = {
            begin: "\\(",
            end: "\\)",
            illegal: '"',
            contains: [
                r,
                o,
                {
                    className: "type",
                    begin: "\\b[A-Z][\\w]*(\\((\\.\\.|,|\\w+)\\))?"
                },
                e.inherit(e.TITLE_MODE, {
                    begin: "[_a-z][\\w']*"
                }),
                i
            ]
        }, c = {
            className: "number",
            relevance: 0,
            variants: [
                {
                    match: `\\b(${t})(\\.(${t}))?([eE][+-]?(${t}))?\\b`
                },
                {
                    match: `\\b0[xX]_*(${a})(\\.(${a}))?([pP][+-]?(${t}))?\\b`
                },
                {
                    match: "\\b0[oO](([0-7]_*)+)\\b"
                },
                {
                    match: "\\b0[bB](([01]_*)+)\\b"
                }
            ]
        };
        return {
            name: "Haskell",
            aliases: [
                "hs"
            ],
            keywords: "let in if then else case of where do module import hiding qualified type data newtype deriving class instance as default infix infixl infixr foreign export ccall stdcall cplusplus jvm dotnet safe unsafe family forall mdo proc rec",
            unicodeRegex: !0,
            contains: [
                {
                    beginKeywords: "module",
                    end: "where",
                    keywords: "module where",
                    contains: [
                        l,
                        i
                    ],
                    illegal: "\\W\\.|;"
                },
                {
                    begin: "\\bimport\\b",
                    end: "$",
                    keywords: "import qualified as hiding",
                    contains: [
                        l,
                        i
                    ],
                    illegal: "\\W\\.|;"
                },
                {
                    className: "class",
                    begin: "^(\\s*)?(class|instance)\\b",
                    end: "where",
                    keywords: "class family instance where",
                    contains: [
                        s,
                        l,
                        i
                    ]
                },
                {
                    className: "class",
                    begin: "\\b(data|(new)?type)\\b",
                    end: "$",
                    keywords: "data family type newtype deriving",
                    contains: [
                        r,
                        s,
                        l,
                        {
                            begin: /\{/,
                            end: /\}/,
                            contains: l.contains
                        },
                        i
                    ]
                },
                {
                    beginKeywords: "default",
                    end: "$",
                    contains: [
                        s,
                        l,
                        i
                    ]
                },
                {
                    beginKeywords: "infix infixl infixr",
                    end: "$",
                    contains: [
                        e.C_NUMBER_MODE,
                        i
                    ]
                },
                {
                    begin: "\\bforeign\\b",
                    end: "$",
                    keywords: "foreign import export ccall stdcall cplusplus jvm dotnet safe unsafe",
                    contains: [
                        s,
                        e.QUOTE_STRING_MODE,
                        i
                    ]
                },
                {
                    className: "meta",
                    begin: "#!\\/usr\\/bin\\/env runhaskell",
                    end: "$"
                },
                r,
                o,
                {
                    scope: "string",
                    begin: /'(?=\\?.')/,
                    end: /'/,
                    contains: [
                        {
                            scope: "char.escape",
                            match: /\\./
                        }
                    ]
                },
                e.QUOTE_STRING_MODE,
                c,
                s,
                e.inherit(e.TITLE_MODE, {
                    begin: "^[_a-z][\\w']*"
                }),
                {
                    begin: `(?!-)${n}--+|--+(?!-)${n}`
                },
                i,
                {
                    begin: "->|<-"
                }
            ]
        };
    }), nn)), Cs.registerLanguage("haxe", (sn || (sn = 1, on = function(e) {
        return {
            name: "Haxe",
            aliases: [
                "hx"
            ],
            keywords: {
                keyword: "abstract break case cast catch continue default do dynamic else enum extern final for function here if import in inline is macro never new override package private get set public return static super switch this throw trace try typedef untyped using var while Int Float String Bool Dynamic Void Array ",
                built_in: "trace this",
                literal: "true false null _"
            },
            contains: [
                {
                    className: "string",
                    begin: "'",
                    end: "'",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        {
                            className: "subst",
                            begin: /\$\{/,
                            end: /\}/
                        },
                        {
                            className: "subst",
                            begin: /\$/,
                            end: /\W\}/
                        }
                    ]
                },
                e.QUOTE_STRING_MODE,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "number",
                    begin: /(-?)(\b0[xX][a-fA-F0-9_]+|(\b\d+(\.[\d_]*)?|\.[\d_]+)(([eE][-+]?\d+)|i32|u32|i64|f64)?)/,
                    relevance: 0
                },
                {
                    className: "variable",
                    begin: "\\$[a-zA-Z_$][a-zA-Z0-9_$]*"
                },
                {
                    className: "meta",
                    begin: /@:?/,
                    end: /\(|$/,
                    excludeEnd: !0
                },
                {
                    className: "meta",
                    begin: "#",
                    end: "$",
                    keywords: {
                        keyword: "if else elseif end error"
                    }
                },
                {
                    className: "type",
                    begin: /:[ \t]*/,
                    end: /[^A-Za-z0-9_ \t\->]/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    relevance: 0
                },
                {
                    className: "type",
                    begin: /:[ \t]*/,
                    end: /\W/,
                    excludeBegin: !0,
                    excludeEnd: !0
                },
                {
                    className: "type",
                    begin: /new */,
                    end: /\W/,
                    excludeBegin: !0,
                    excludeEnd: !0
                },
                {
                    className: "title.class",
                    beginKeywords: "enum",
                    end: /\{/,
                    contains: [
                        e.TITLE_MODE
                    ]
                },
                {
                    className: "title.class",
                    begin: "\\babstract\\b(?=\\s*" + e.IDENT_RE + "\\s*\\()",
                    end: /[\{$]/,
                    contains: [
                        {
                            className: "type",
                            begin: /\(/,
                            end: /\)/,
                            excludeBegin: !0,
                            excludeEnd: !0
                        },
                        {
                            className: "type",
                            begin: /from +/,
                            end: /\W/,
                            excludeBegin: !0,
                            excludeEnd: !0
                        },
                        {
                            className: "type",
                            begin: /to +/,
                            end: /\W/,
                            excludeBegin: !0,
                            excludeEnd: !0
                        },
                        e.TITLE_MODE
                    ],
                    keywords: {
                        keyword: "abstract from to"
                    }
                },
                {
                    className: "title.class",
                    begin: /\b(class|interface) +/,
                    end: /[\{$]/,
                    excludeEnd: !0,
                    keywords: "class interface",
                    contains: [
                        {
                            className: "keyword",
                            begin: /\b(extends|implements) +/,
                            keywords: "extends implements",
                            contains: [
                                {
                                    className: "type",
                                    begin: e.IDENT_RE,
                                    relevance: 0
                                }
                            ]
                        },
                        e.TITLE_MODE
                    ]
                },
                {
                    className: "title.function",
                    beginKeywords: "function",
                    end: /\(/,
                    excludeEnd: !0,
                    illegal: /\S/,
                    contains: [
                        e.TITLE_MODE
                    ]
                }
            ],
            illegal: /<\//
        };
    }), on)), Cs.registerLanguage("hsp", (cn || (cn = 1, ln = function(e) {
        return {
            name: "HSP",
            case_insensitive: !0,
            keywords: {
                $pattern: /[\w._]+/,
                keyword: "goto gosub return break repeat loop continue wait await dim sdim foreach dimtype dup dupptr end stop newmod delmod mref run exgoto on mcall assert logmes newlab resume yield onexit onerror onkey onclick oncmd exist delete mkdir chdir dirlist bload bsave bcopy memfile if else poke wpoke lpoke getstr chdpm memexpand memcpy memset notesel noteadd notedel noteload notesave randomize noteunsel noteget split strrep setease button chgdisp exec dialog mmload mmplay mmstop mci pset pget syscolor mes print title pos circle cls font sysfont objsize picload color palcolor palette redraw width gsel gcopy gzoom gmode bmpsave hsvcolor getkey listbox chkbox combox input mesbox buffer screen bgscr mouse objsel groll line clrobj boxf objprm objmode stick grect grotate gsquare gradf objimage objskip objenable celload celdiv celput newcom querycom delcom cnvstow comres axobj winobj sendmsg comevent comevarg sarrayconv callfunc cnvwtos comevdisp libptr system hspstat hspver stat cnt err strsize looplev sublev iparam wparam lparam refstr refdval int rnd strlen length length2 length3 length4 vartype gettime peek wpeek lpeek varptr varuse noteinfo instr abs limit getease str strmid strf getpath strtrim sin cos tan atan sqrt double absf expf logf limitf powf geteasef mousex mousey mousew hwnd hinstance hdc ginfo objinfo dirinfo sysinfo thismod __hspver__ __hsp30__ __date__ __time__ __line__ __file__ _debug __hspdef__ and or xor not screen_normal screen_palette screen_hide screen_fixedsize screen_tool screen_frame gmode_gdi gmode_mem gmode_rgb0 gmode_alpha gmode_rgb0alpha gmode_add gmode_sub gmode_pixela ginfo_mx ginfo_my ginfo_act ginfo_sel ginfo_wx1 ginfo_wy1 ginfo_wx2 ginfo_wy2 ginfo_vx ginfo_vy ginfo_sizex ginfo_sizey ginfo_winx ginfo_winy ginfo_mesx ginfo_mesy ginfo_r ginfo_g ginfo_b ginfo_paluse ginfo_dispx ginfo_dispy ginfo_cx ginfo_cy ginfo_intid ginfo_newid ginfo_sx ginfo_sy objinfo_mode objinfo_bmscr objinfo_hwnd notemax notesize dir_cur dir_exe dir_win dir_sys dir_cmdline dir_desktop dir_mydoc dir_tv font_normal font_bold font_italic font_underline font_strikeout font_antialias objmode_normal objmode_guifont objmode_usefont gsquare_grad msgothic msmincho do until while wend for next _break _continue switch case default swbreak swend ddim ldim alloc m_pi rad2deg deg2rad ease_linear ease_quad_in ease_quad_out ease_quad_inout ease_cubic_in ease_cubic_out ease_cubic_inout ease_quartic_in ease_quartic_out ease_quartic_inout ease_bounce_in ease_bounce_out ease_bounce_inout ease_shake_in ease_shake_out ease_shake_inout ease_loop"
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.APOS_STRING_MODE,
                {
                    className: "string",
                    begin: /\{"/,
                    end: /"\}/,
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                e.COMMENT(";", "$", {
                    relevance: 0
                }),
                {
                    className: "meta",
                    begin: "#",
                    end: "$",
                    keywords: {
                        keyword: "addion cfunc cmd cmpopt comfunc const defcfunc deffunc define else endif enum epack func global if ifdef ifndef include modcfunc modfunc modinit modterm module pack packopt regcmd runtime undef usecom uselib"
                    },
                    contains: [
                        e.inherit(e.QUOTE_STRING_MODE, {
                            className: "string"
                        }),
                        e.NUMBER_MODE,
                        e.C_NUMBER_MODE,
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                {
                    className: "symbol",
                    begin: "^\\*(\\w+|@)"
                },
                e.NUMBER_MODE,
                e.C_NUMBER_MODE
            ]
        };
    }), ln)), Cs.registerLanguage("http", (dn || (dn = 1, _n = function(e) {
        const t = "HTTP/([32]|1\\.[01])", a = {
            className: "attribute",
            begin: e.regex.concat("^", /[A-Za-z][A-Za-z0-9-]*/, "(?=\\:\\s)"),
            starts: {
                contains: [
                    {
                        className: "punctuation",
                        begin: /: /,
                        relevance: 0,
                        starts: {
                            end: "$",
                            relevance: 0
                        }
                    }
                ]
            }
        }, n = [
            a,
            {
                begin: "\\n\\n",
                starts: {
                    subLanguage: [],
                    endsWithParent: !0
                }
            }
        ];
        return {
            name: "HTTP",
            aliases: [
                "https"
            ],
            illegal: /\S/,
            contains: [
                {
                    begin: "^(?=" + t + " \\d{3})",
                    end: /$/,
                    contains: [
                        {
                            className: "meta",
                            begin: t
                        },
                        {
                            className: "number",
                            begin: "\\b\\d{3}\\b"
                        }
                    ],
                    starts: {
                        end: /\b\B/,
                        illegal: /\S/,
                        contains: n
                    }
                },
                {
                    begin: "(?=^[A-Z]+ (.*?) " + t + "$)",
                    end: /$/,
                    contains: [
                        {
                            className: "string",
                            begin: " ",
                            end: " ",
                            excludeBegin: !0,
                            excludeEnd: !0
                        },
                        {
                            className: "meta",
                            begin: t
                        },
                        {
                            className: "keyword",
                            begin: "[A-Z]+"
                        }
                    ],
                    starts: {
                        end: /\b\B/,
                        illegal: /\S/,
                        contains: n
                    }
                },
                e.inherit(a, {
                    relevance: 0
                })
            ]
        };
    }), _n)), Cs.registerLanguage("hy", (pn || (pn = 1, mn = function(e) {
        const t = "a-zA-Z_\\-!.?+*=<>&#'", a = "[" + t + "][" + t + "0-9/;:]*", n = {
            $pattern: a,
            built_in: "!= % %= & &= * ** **= *= *map + += , --build-class-- --import-- -= . / // //= /= < << <<= <= = > >= >> >>= @ @= ^ ^= abs accumulate all and any ap-compose ap-dotimes ap-each ap-each-while ap-filter ap-first ap-if ap-last ap-map ap-map-when ap-pipe ap-reduce ap-reject apply as-> ascii assert assoc bin break butlast callable calling-module-name car case cdr chain chr coll? combinations compile compress cond cons cons? continue count curry cut cycle dec def default-method defclass defmacro defmacro-alias defmacro/g! defmain defmethod defmulti defn defn-alias defnc defnr defreader defseq del delattr delete-route dict-comp dir disassemble dispatch-reader-macro distinct divmod do doto drop drop-last drop-while empty? end-sequence eval eval-and-compile eval-when-compile even? every? except exec filter first flatten float? fn fnc fnr for for* format fraction genexpr gensym get getattr global globals group-by hasattr hash hex id identity if if* if-not if-python2 import in inc input instance? integer integer-char? integer? interleave interpose is is-coll is-cons is-empty is-even is-every is-float is-instance is-integer is-integer-char is-iterable is-iterator is-keyword is-neg is-none is-not is-numeric is-odd is-pos is-string is-symbol is-zero isinstance islice issubclass iter iterable? iterate iterator? keyword keyword? lambda last len let lif lif-not list* list-comp locals loop macro-error macroexpand macroexpand-1 macroexpand-all map max merge-with method-decorator min multi-decorator multicombinations name neg? next none? nonlocal not not-in not? nth numeric? oct odd? open or ord partition permutations pos? post-route postwalk pow prewalk print product profile/calls profile/cpu put-route quasiquote quote raise range read read-str recursive-replace reduce remove repeat repeatedly repr require rest round route route-with-methods rwm second seq set-comp setattr setv some sorted string string? sum switch symbol? take take-nth take-while tee try unless unquote unquote-splicing vars walk when while with with* with-decorator with-gensyms xi xor yield yield-from zero? zip zip-longest | |= ~"
        }, i = {
            begin: a,
            relevance: 0
        }, r = {
            className: "number",
            begin: "[-+]?\\d+(\\.\\d+)?",
            relevance: 0
        }, o = e.inherit(e.QUOTE_STRING_MODE, {
            illegal: null
        }), s = e.COMMENT(";", "$", {
            relevance: 0
        }), l = {
            className: "literal",
            begin: /\b([Tt]rue|[Ff]alse|nil|None)\b/
        }, c = {
            begin: "[\\[\\{]",
            end: "[\\]\\}]",
            relevance: 0
        }, _ = {
            className: "comment",
            begin: "\\^" + a
        }, d = e.COMMENT("\\^\\{", "\\}"), m = {
            className: "symbol",
            begin: "[:]{1,2}" + a
        }, p = {
            begin: "\\(",
            end: "\\)"
        }, u = {
            endsWithParent: !0,
            relevance: 0
        }, g = {
            className: "name",
            relevance: 0,
            keywords: n,
            begin: a,
            starts: u
        }, E = [
            p,
            o,
            _,
            d,
            s,
            m,
            c,
            r,
            l,
            i
        ];
        return p.contains = [
            e.COMMENT("comment", ""),
            g,
            u
        ], u.contains = E, c.contains = E, {
            name: "Hy",
            aliases: [
                "hylang"
            ],
            illegal: /\S/,
            contains: [
                e.SHEBANG(),
                p,
                o,
                _,
                d,
                s,
                m,
                c,
                r,
                l
            ]
        };
    }), mn)), Cs.registerLanguage("inform7", gn ? un : (gn = 1, un = function(e) {
        return {
            name: "Inform 7",
            aliases: [
                "i7"
            ],
            case_insensitive: !0,
            keywords: {
                keyword: "thing room person man woman animal container supporter backdrop door scenery open closed locked inside gender is are say understand kind of rule"
            },
            contains: [
                {
                    className: "string",
                    begin: '"',
                    end: '"',
                    relevance: 0,
                    contains: [
                        {
                            className: "subst",
                            begin: "\\[",
                            end: "\\]"
                        }
                    ]
                },
                {
                    className: "section",
                    begin: /^(Volume|Book|Part|Chapter|Section|Table)\b/,
                    end: "$"
                },
                {
                    begin: /^(Check|Carry out|Report|Instead of|To|Rule|When|Before|After)\b/,
                    end: ":",
                    contains: [
                        {
                            begin: "\\(This",
                            end: "\\)"
                        }
                    ]
                },
                {
                    className: "comment",
                    begin: "\\[",
                    end: "\\]",
                    contains: [
                        "self"
                    ]
                }
            ]
        };
    })), Cs.registerLanguage("ini", (Sn || (Sn = 1, En = function(e) {
        const t = e.regex, a = {
            className: "number",
            relevance: 0,
            variants: [
                {
                    begin: /([+-]+)?[\d]+_[\d_]+/
                },
                {
                    begin: e.NUMBER_RE
                }
            ]
        }, n = e.COMMENT();
        n.variants = [
            {
                begin: /;/,
                end: /$/
            },
            {
                begin: /#/,
                end: /$/
            }
        ];
        const i = {
            className: "variable",
            variants: [
                {
                    begin: /\$[\w\d"][\w\d_]*/
                },
                {
                    begin: /\$\{(.*?)\}/
                }
            ]
        }, r = {
            className: "literal",
            begin: /\bon|off|true|false|yes|no\b/
        }, o = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE
            ],
            variants: [
                {
                    begin: "'''",
                    end: "'''",
                    relevance: 10
                },
                {
                    begin: '"""',
                    end: '"""',
                    relevance: 10
                },
                {
                    begin: '"',
                    end: '"'
                },
                {
                    begin: "'",
                    end: "'"
                }
            ]
        }, s = {
            begin: /\[/,
            end: /\]/,
            contains: [
                n,
                r,
                i,
                o,
                a,
                "self"
            ],
            relevance: 0
        }, l = t.either(/[A-Za-z0-9_-]+/, /"(\\"|[^"])*"/, /'[^']*'/);
        return {
            name: "TOML, also INI",
            aliases: [
                "toml"
            ],
            case_insensitive: !0,
            illegal: /\S/,
            contains: [
                n,
                {
                    className: "section",
                    begin: /\[+/,
                    end: /\]+/
                },
                {
                    begin: t.concat(l, "(\\s*\\.\\s*", l, ")*", t.lookahead(/\s*=\s*[^#\s]/)),
                    className: "attr",
                    starts: {
                        end: /$/,
                        contains: [
                            n,
                            s,
                            r,
                            i,
                            o,
                            a
                        ]
                    }
                }
            ]
        };
    }), En)), Cs.registerLanguage("irpf90", (Tn || (Tn = 1, bn = function(e) {
        const t = e.regex, a = /(_[a-z_\d]+)?/, n = /([de][+-]?\d+)?/, i = {
            className: "number",
            variants: [
                {
                    begin: t.concat(/\b\d+/, /\.(\d*)/, n, a)
                },
                {
                    begin: t.concat(/\b\d+/, n, a)
                },
                {
                    begin: t.concat(/\.\d+/, n, a)
                }
            ],
            relevance: 0
        };
        return {
            name: "IRPF90",
            case_insensitive: !0,
            keywords: {
                literal: ".False. .True.",
                keyword: "kind do while private call intrinsic where elsewhere type endtype endmodule endselect endinterface end enddo endif if forall endforall only contains default return stop then public subroutine|10 function program .and. .or. .not. .le. .eq. .ge. .gt. .lt. goto save else use module select case access blank direct exist file fmt form formatted iostat name named nextrec number opened rec recl sequential status unformatted unit continue format pause cycle exit c_null_char c_alert c_backspace c_form_feed flush wait decimal round iomsg synchronous nopass non_overridable pass protected volatile abstract extends import non_intrinsic value deferred generic final enumerator class associate bind enum c_int c_short c_long c_long_long c_signed_char c_size_t c_int8_t c_int16_t c_int32_t c_int64_t c_int_least8_t c_int_least16_t c_int_least32_t c_int_least64_t c_int_fast8_t c_int_fast16_t c_int_fast32_t c_int_fast64_t c_intmax_t C_intptr_t c_float c_double c_long_double c_float_complex c_double_complex c_long_double_complex c_bool c_char c_null_ptr c_null_funptr c_new_line c_carriage_return c_horizontal_tab c_vertical_tab iso_c_binding c_loc c_funloc c_associated  c_f_pointer c_ptr c_funptr iso_fortran_env character_storage_size error_unit file_storage_size input_unit iostat_end iostat_eor numeric_storage_size output_unit c_f_procpointer ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode newunit contiguous recursive pad position action delim readwrite eor advance nml interface procedure namelist include sequence elemental pure integer real character complex logical dimension allocatable|10 parameter external implicit|10 none double precision assign intent optional pointer target in out common equivalence data begin_provider &begin_provider end_provider begin_shell end_shell begin_template end_template subst assert touch soft_touch provide no_dep free irp_if irp_else irp_endif irp_write irp_read",
                built_in: "alog alog10 amax0 amax1 amin0 amin1 amod cabs ccos cexp clog csin csqrt dabs dacos dasin datan datan2 dcos dcosh ddim dexp dint dlog dlog10 dmax1 dmin1 dmod dnint dsign dsin dsinh dsqrt dtan dtanh float iabs idim idint idnint ifix isign max0 max1 min0 min1 sngl algama cdabs cdcos cdexp cdlog cdsin cdsqrt cqabs cqcos cqexp cqlog cqsin cqsqrt dcmplx dconjg derf derfc dfloat dgamma dimag dlgama iqint qabs qacos qasin qatan qatan2 qcmplx qconjg qcos qcosh qdim qerf qerfc qexp qgamma qimag qlgama qlog qlog10 qmax1 qmin1 qmod qnint qsign qsin qsinh qsqrt qtan qtanh abs acos aimag aint anint asin atan atan2 char cmplx conjg cos cosh exp ichar index int log log10 max min nint sign sin sinh sqrt tan tanh print write dim lge lgt lle llt mod nullify allocate deallocate adjustl adjustr all allocated any associated bit_size btest ceiling count cshift date_and_time digits dot_product eoshift epsilon exponent floor fraction huge iand ibclr ibits ibset ieor ior ishft ishftc lbound len_trim matmul maxexponent maxloc maxval merge minexponent minloc minval modulo mvbits nearest pack present product radix random_number random_seed range repeat reshape rrspacing scale scan selected_int_kind selected_real_kind set_exponent shape size spacing spread sum system_clock tiny transpose trim ubound unpack verify achar iachar transfer dble entry dprod cpu_time command_argument_count get_command get_command_argument get_environment_variable is_iostat_end ieee_arithmetic ieee_support_underflow_control ieee_get_underflow_mode ieee_set_underflow_mode is_iostat_eor move_alloc new_line selected_char_kind same_type_as extends_type_of acosh asinh atanh bessel_j0 bessel_j1 bessel_jn bessel_y0 bessel_y1 bessel_yn erf erfc erfc_scaled gamma log_gamma hypot norm2 atomic_define atomic_ref execute_command_line leadz trailz storage_size merge_bits bge bgt ble blt dshiftl dshiftr findloc iall iany iparity image_index lcobound ucobound maskl maskr num_images parity popcnt poppar shifta shiftl shiftr this_image IRP_ALIGN irp_here"
            },
            illegal: /\/\*/,
            contains: [
                e.inherit(e.APOS_STRING_MODE, {
                    className: "string",
                    relevance: 0
                }),
                e.inherit(e.QUOTE_STRING_MODE, {
                    className: "string",
                    relevance: 0
                }),
                {
                    className: "function",
                    beginKeywords: "subroutine function program",
                    illegal: "[${=\\n]",
                    contains: [
                        e.UNDERSCORE_TITLE_MODE,
                        {
                            className: "params",
                            begin: "\\(",
                            end: "\\)"
                        }
                    ]
                },
                e.COMMENT("!", "$", {
                    relevance: 0
                }),
                e.COMMENT("begin_doc", "end_doc", {
                    relevance: 10
                }),
                i
            ]
        };
    }), bn)), Cs.registerLanguage("isbl", (fn || (fn = 1, Cn = function(e) {
        const t = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_!][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]*", a = {
            className: "number",
            begin: e.NUMBER_RE,
            relevance: 0
        }, n = {
            className: "string",
            variants: [
                {
                    begin: '"',
                    end: '"'
                },
                {
                    begin: "'",
                    end: "'"
                }
            ]
        }, i = {
            className: "doctag",
            begin: "\\b(?:TODO|DONE|BEGIN|END|STUB|CHG|FIXME|NOTE|BUG|XXX)\\b",
            relevance: 0
        }, r = {
            variants: [
                {
                    className: "comment",
                    begin: "//",
                    end: "$",
                    relevance: 0,
                    contains: [
                        e.PHRASAL_WORDS_MODE,
                        i
                    ]
                },
                {
                    className: "comment",
                    begin: "/\\*",
                    end: "\\*/",
                    relevance: 0,
                    contains: [
                        e.PHRASAL_WORDS_MODE,
                        i
                    ]
                }
            ]
        }, o = {
            $pattern: t,
            keyword: "and \u0438 else \u0438\u043D\u0430\u0447\u0435 endexcept endfinally endforeach \u043A\u043E\u043D\u0435\u0446\u0432\u0441\u0435 endif \u043A\u043E\u043D\u0435\u0446\u0435\u0441\u043B\u0438 endwhile \u043A\u043E\u043D\u0435\u0446\u043F\u043E\u043A\u0430 except exitfor finally foreach \u0432\u0441\u0435 if \u0435\u0441\u043B\u0438 in \u0432 not \u043D\u0435 or \u0438\u043B\u0438 try while \u043F\u043E\u043A\u0430 ",
            built_in: "SYSRES_CONST_ACCES_RIGHT_TYPE_EDIT SYSRES_CONST_ACCES_RIGHT_TYPE_FULL SYSRES_CONST_ACCES_RIGHT_TYPE_VIEW SYSRES_CONST_ACCESS_MODE_REQUISITE_CODE SYSRES_CONST_ACCESS_NO_ACCESS_VIEW SYSRES_CONST_ACCESS_NO_ACCESS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_ADD_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_CHANGE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_DELETE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_EXECUTE_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_NO_ACCESS_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_RATIFY_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW SYSRES_CONST_ACCESS_RIGHTS_VIEW_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_CODE SYSRES_CONST_ACCESS_RIGHTS_VIEW_REQUISITE_YES_CODE SYSRES_CONST_ACCESS_TYPE_CHANGE SYSRES_CONST_ACCESS_TYPE_CHANGE_CODE SYSRES_CONST_ACCESS_TYPE_EXISTS SYSRES_CONST_ACCESS_TYPE_EXISTS_CODE SYSRES_CONST_ACCESS_TYPE_FULL SYSRES_CONST_ACCESS_TYPE_FULL_CODE SYSRES_CONST_ACCESS_TYPE_VIEW SYSRES_CONST_ACCESS_TYPE_VIEW_CODE SYSRES_CONST_ACTION_TYPE_ABORT SYSRES_CONST_ACTION_TYPE_ACCEPT SYSRES_CONST_ACTION_TYPE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ADD_ATTACHMENT SYSRES_CONST_ACTION_TYPE_CHANGE_CARD SYSRES_CONST_ACTION_TYPE_CHANGE_KIND SYSRES_CONST_ACTION_TYPE_CHANGE_STORAGE SYSRES_CONST_ACTION_TYPE_CONTINUE SYSRES_CONST_ACTION_TYPE_COPY SYSRES_CONST_ACTION_TYPE_CREATE SYSRES_CONST_ACTION_TYPE_CREATE_VERSION SYSRES_CONST_ACTION_TYPE_DELETE SYSRES_CONST_ACTION_TYPE_DELETE_ATTACHMENT SYSRES_CONST_ACTION_TYPE_DELETE_VERSION SYSRES_CONST_ACTION_TYPE_DISABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENABLE_DELEGATE_ACCESS_RIGHTS SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_CERTIFICATE_AND_PASSWORD SYSRES_CONST_ACTION_TYPE_ENCRYPTION_BY_PASSWORD SYSRES_CONST_ACTION_TYPE_EXPORT_WITH_LOCK SYSRES_CONST_ACTION_TYPE_EXPORT_WITHOUT_LOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITH_UNLOCK SYSRES_CONST_ACTION_TYPE_IMPORT_WITHOUT_UNLOCK SYSRES_CONST_ACTION_TYPE_LIFE_CYCLE_STAGE SYSRES_CONST_ACTION_TYPE_LOCK SYSRES_CONST_ACTION_TYPE_LOCK_FOR_SERVER SYSRES_CONST_ACTION_TYPE_LOCK_MODIFY SYSRES_CONST_ACTION_TYPE_MARK_AS_READED SYSRES_CONST_ACTION_TYPE_MARK_AS_UNREADED SYSRES_CONST_ACTION_TYPE_MODIFY SYSRES_CONST_ACTION_TYPE_MODIFY_CARD SYSRES_CONST_ACTION_TYPE_MOVE_TO_ARCHIVE SYSRES_CONST_ACTION_TYPE_OFF_ENCRYPTION SYSRES_CONST_ACTION_TYPE_PASSWORD_CHANGE SYSRES_CONST_ACTION_TYPE_PERFORM SYSRES_CONST_ACTION_TYPE_RECOVER_FROM_LOCAL_COPY SYSRES_CONST_ACTION_TYPE_RESTART SYSRES_CONST_ACTION_TYPE_RESTORE_FROM_ARCHIVE SYSRES_CONST_ACTION_TYPE_REVISION SYSRES_CONST_ACTION_TYPE_SEND_BY_MAIL SYSRES_CONST_ACTION_TYPE_SIGN SYSRES_CONST_ACTION_TYPE_START SYSRES_CONST_ACTION_TYPE_UNLOCK SYSRES_CONST_ACTION_TYPE_UNLOCK_FROM_SERVER SYSRES_CONST_ACTION_TYPE_VERSION_STATE SYSRES_CONST_ACTION_TYPE_VERSION_VISIBILITY SYSRES_CONST_ACTION_TYPE_VIEW SYSRES_CONST_ACTION_TYPE_VIEW_SHADOW_COPY SYSRES_CONST_ACTION_TYPE_WORKFLOW_DESCRIPTION_MODIFY SYSRES_CONST_ACTION_TYPE_WRITE_HISTORY SYSRES_CONST_ACTIVE_VERSION_STATE_PICK_VALUE SYSRES_CONST_ADD_REFERENCE_MODE_NAME SYSRES_CONST_ADDITION_REQUISITE_CODE SYSRES_CONST_ADDITIONAL_PARAMS_REQUISITE_CODE SYSRES_CONST_ADITIONAL_JOB_END_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_READ_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_START_DATE_REQUISITE_NAME SYSRES_CONST_ADITIONAL_JOB_STATE_REQUISITE_NAME SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_ADDING_USER_TO_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_CREATION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_DATABASE_USER_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_COMP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_DELETION_USER_FROM_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_GRANTING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_MAIN_SERVER_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_IS_PUBLIC_CHANGED_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_FILTERER_RESTRICTION_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_PRIVILEGE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_REMOVING_RIGHTS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_CREATION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION SYSRES_CONST_ADMINISTRATION_HISTORY_SERVER_LOGIN_DELETION_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_CATEGORY_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_COMP_TITLE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_FULL_NAME_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_PARENT_GROUP_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_AUTH_TYPE_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_LOGIN_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION SYSRES_CONST_ADMINISTRATION_HISTORY_UPDATING_USER_STATUS_ACTION_CODE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE SYSRES_CONST_ADMINISTRATION_HISTORY_USER_PASSWORD_CHANGE_ACTION SYSRES_CONST_ALL_ACCEPT_CONDITION_RUS SYSRES_CONST_ALL_USERS_GROUP SYSRES_CONST_ALL_USERS_GROUP_NAME SYSRES_CONST_ALL_USERS_SERVER_GROUP_NAME SYSRES_CONST_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_APP_VIEWER_TYPE_REQUISITE_CODE SYSRES_CONST_APPROVING_SIGNATURE_NAME SYSRES_CONST_APPROVING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE SYSRES_CONST_ASSISTANT_SUBSTITUE_TYPE_CODE SYSRES_CONST_ATTACH_TYPE_COMPONENT_TOKEN SYSRES_CONST_ATTACH_TYPE_DOC SYSRES_CONST_ATTACH_TYPE_EDOC SYSRES_CONST_ATTACH_TYPE_FOLDER SYSRES_CONST_ATTACH_TYPE_JOB SYSRES_CONST_ATTACH_TYPE_REFERENCE SYSRES_CONST_ATTACH_TYPE_TASK SYSRES_CONST_AUTH_ENCODED_PASSWORD SYSRES_CONST_AUTH_ENCODED_PASSWORD_CODE SYSRES_CONST_AUTH_NOVELL SYSRES_CONST_AUTH_PASSWORD SYSRES_CONST_AUTH_PASSWORD_CODE SYSRES_CONST_AUTH_WINDOWS SYSRES_CONST_AUTHENTICATING_SIGNATURE_NAME SYSRES_CONST_AUTHENTICATING_SIGNATURE_REQUISITE_CODE SYSRES_CONST_AUTO_ENUM_METHOD_FLAG SYSRES_CONST_AUTO_NUMERATION_CODE SYSRES_CONST_AUTO_STRONG_ENUM_METHOD_FLAG SYSRES_CONST_AUTOTEXT_NAME_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_TEXT_REQUISITE_CODE SYSRES_CONST_AUTOTEXT_USAGE_ALL SYSRES_CONST_AUTOTEXT_USAGE_ALL_CODE SYSRES_CONST_AUTOTEXT_USAGE_SIGN SYSRES_CONST_AUTOTEXT_USAGE_SIGN_CODE SYSRES_CONST_AUTOTEXT_USAGE_WORK SYSRES_CONST_AUTOTEXT_USAGE_WORK_CODE SYSRES_CONST_AUTOTEXT_USE_ANYWHERE_CODE SYSRES_CONST_AUTOTEXT_USE_ON_SIGNING_CODE SYSRES_CONST_AUTOTEXT_USE_ON_WORK_CODE SYSRES_CONST_BEGIN_DATE_REQUISITE_CODE SYSRES_CONST_BLACK_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BLUE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_BTN_PART SYSRES_CONST_CALCULATED_ROLE_TYPE_CODE SYSRES_CONST_CALL_TYPE_VARIABLE_BUTTON_VALUE SYSRES_CONST_CALL_TYPE_VARIABLE_PROGRAM_VALUE SYSRES_CONST_CANCEL_MESSAGE_FUNCTION_RESULT SYSRES_CONST_CARD_PART SYSRES_CONST_CARD_REFERENCE_MODE_NAME SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_AND_ENCRYPT_VALUE SYSRES_CONST_CERTIFICATE_TYPE_REQUISITE_SIGN_VALUE SYSRES_CONST_CHECK_PARAM_VALUE_DATE_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_FLOAT_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_INTEGER_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_PICK_PARAM_TYPE SYSRES_CONST_CHECK_PARAM_VALUE_REEFRENCE_PARAM_TYPE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_CLOSED_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_CODE_COMPONENT_TYPE_ADMIN SYSRES_CONST_CODE_COMPONENT_TYPE_DEVELOPER SYSRES_CONST_CODE_COMPONENT_TYPE_DOCS SYSRES_CONST_CODE_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_CODE_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_CODE_COMPONENT_TYPE_OTHER SYSRES_CONST_CODE_COMPONENT_TYPE_REFERENCE SYSRES_CONST_CODE_COMPONENT_TYPE_REPORT SYSRES_CONST_CODE_COMPONENT_TYPE_SCRIPT SYSRES_CONST_CODE_COMPONENT_TYPE_URL SYSRES_CONST_CODE_REQUISITE_ACCESS SYSRES_CONST_CODE_REQUISITE_CODE SYSRES_CONST_CODE_REQUISITE_COMPONENT SYSRES_CONST_CODE_REQUISITE_DESCRIPTION SYSRES_CONST_CODE_REQUISITE_EXCLUDE_COMPONENT SYSRES_CONST_CODE_REQUISITE_RECORD SYSRES_CONST_COMMENT_REQ_CODE SYSRES_CONST_COMMON_SETTINGS_REQUISITE_CODE SYSRES_CONST_COMP_CODE_GRD SYSRES_CONST_COMPONENT_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_COMPONENT_TYPE_ADMIN_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DEVELOPER_COMPONENTS SYSRES_CONST_COMPONENT_TYPE_DOCS SYSRES_CONST_COMPONENT_TYPE_EDOC_CARDS SYSRES_CONST_COMPONENT_TYPE_EDOCS SYSRES_CONST_COMPONENT_TYPE_EXTERNAL_EXECUTABLE SYSRES_CONST_COMPONENT_TYPE_OTHER SYSRES_CONST_COMPONENT_TYPE_REFERENCE_TYPES SYSRES_CONST_COMPONENT_TYPE_REFERENCES SYSRES_CONST_COMPONENT_TYPE_REPORTS SYSRES_CONST_COMPONENT_TYPE_SCRIPTS SYSRES_CONST_COMPONENT_TYPE_URL SYSRES_CONST_COMPONENTS_REMOTE_SERVERS_VIEW_CODE SYSRES_CONST_CONDITION_BLOCK_DESCRIPTION SYSRES_CONST_CONST_FIRM_STATUS_COMMON SYSRES_CONST_CONST_FIRM_STATUS_INDIVIDUAL SYSRES_CONST_CONST_NEGATIVE_VALUE SYSRES_CONST_CONST_POSITIVE_VALUE SYSRES_CONST_CONST_SERVER_STATUS_DONT_REPLICATE SYSRES_CONST_CONST_SERVER_STATUS_REPLICATE SYSRES_CONST_CONTENTS_REQUISITE_CODE SYSRES_CONST_DATA_TYPE_BOOLEAN SYSRES_CONST_DATA_TYPE_DATE SYSRES_CONST_DATA_TYPE_FLOAT SYSRES_CONST_DATA_TYPE_INTEGER SYSRES_CONST_DATA_TYPE_PICK SYSRES_CONST_DATA_TYPE_REFERENCE SYSRES_CONST_DATA_TYPE_STRING SYSRES_CONST_DATA_TYPE_TEXT SYSRES_CONST_DATA_TYPE_VARIANT SYSRES_CONST_DATE_CLOSE_REQ_CODE SYSRES_CONST_DATE_FORMAT_DATE_ONLY_CHAR SYSRES_CONST_DATE_OPEN_REQ_CODE SYSRES_CONST_DATE_REQUISITE SYSRES_CONST_DATE_REQUISITE_CODE SYSRES_CONST_DATE_REQUISITE_NAME SYSRES_CONST_DATE_REQUISITE_TYPE SYSRES_CONST_DATE_TYPE_CHAR SYSRES_CONST_DATETIME_FORMAT_VALUE SYSRES_CONST_DEA_ACCESS_RIGHTS_ACTION_CODE SYSRES_CONST_DESCRIPTION_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_DET1_PART SYSRES_CONST_DET2_PART SYSRES_CONST_DET3_PART SYSRES_CONST_DET4_PART SYSRES_CONST_DET5_PART SYSRES_CONST_DET6_PART SYSRES_CONST_DETAIL_DATASET_KEY_REQUISITE_CODE SYSRES_CONST_DETAIL_PICK_REQUISITE_CODE SYSRES_CONST_DETAIL_REQ_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ACCESS_TYPE_NAME SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_CODE SYSRES_CONST_DO_NOT_USE_ON_VIEW_ACCESS_TYPE_NAME SYSRES_CONST_DOCUMENT_STORAGES_CODE SYSRES_CONST_DOCUMENT_TEMPLATES_TYPE_NAME SYSRES_CONST_DOUBLE_REQUISITE_CODE SYSRES_CONST_EDITOR_CLOSE_FILE_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_CLOSE_PROCESS_OBSERV_TYPE_CODE SYSRES_CONST_EDITOR_TYPE_REQUISITE_CODE SYSRES_CONST_EDITORS_APPLICATION_NAME_REQUISITE_CODE SYSRES_CONST_EDITORS_CREATE_SEVERAL_PROCESSES_REQUISITE_CODE SYSRES_CONST_EDITORS_EXTENSION_REQUISITE_CODE SYSRES_CONST_EDITORS_OBSERVER_BY_PROCESS_TYPE SYSRES_CONST_EDITORS_REFERENCE_CODE SYSRES_CONST_EDITORS_REPLACE_SPEC_CHARS_REQUISITE_CODE SYSRES_CONST_EDITORS_USE_PLUGINS_REQUISITE_CODE SYSRES_CONST_EDITORS_VIEW_DOCUMENT_OPENED_TO_EDIT_CODE SYSRES_CONST_EDOC_CARD_TYPE_REQUISITE_CODE SYSRES_CONST_EDOC_CARD_TYPES_LINK_REQUISITE_CODE SYSRES_CONST_EDOC_CERTIFICATE_AND_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_CERTIFICATE_ENCODE_CODE SYSRES_CONST_EDOC_DATE_REQUISITE_CODE SYSRES_CONST_EDOC_KIND_REFERENCE_CODE SYSRES_CONST_EDOC_KINDS_BY_TEMPLATE_ACTION_CODE SYSRES_CONST_EDOC_MANAGE_ACCESS_CODE SYSRES_CONST_EDOC_NONE_ENCODE_CODE SYSRES_CONST_EDOC_NUMBER_REQUISITE_CODE SYSRES_CONST_EDOC_PASSWORD_ENCODE_CODE SYSRES_CONST_EDOC_READONLY_ACCESS_CODE SYSRES_CONST_EDOC_SHELL_LIFE_TYPE_VIEW_VALUE SYSRES_CONST_EDOC_SIZE_RESTRICTION_PRIORITY_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_CHECK_ACCESS_RIGHTS_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_COMPUTER_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_DATABASE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_EDIT_IN_STORAGE_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_LOCAL_PATH_REQUISITE_CODE SYSRES_CONST_EDOC_STORAGE_SHARED_SOURCE_NAME_REQUISITE_CODE SYSRES_CONST_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_EDOC_TYPES_REFERENCE_CODE SYSRES_CONST_EDOC_VERSION_ACTIVE_STAGE_CODE SYSRES_CONST_EDOC_VERSION_DESIGN_STAGE_CODE SYSRES_CONST_EDOC_VERSION_OBSOLETE_STAGE_CODE SYSRES_CONST_EDOC_WRITE_ACCES_CODE SYSRES_CONST_EDOCUMENT_CARD_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_END_DATE_REQUISITE_CODE SYSRES_CONST_ENUMERATION_TYPE_REQUISITE_CODE SYSRES_CONST_EXECUTE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_EXECUTIVE_FILE_STORAGE_TYPE SYSRES_CONST_EXIST_CONST SYSRES_CONST_EXIST_VALUE SYSRES_CONST_EXPORT_LOCK_TYPE_ASK SYSRES_CONST_EXPORT_LOCK_TYPE_WITH_LOCK SYSRES_CONST_EXPORT_LOCK_TYPE_WITHOUT_LOCK SYSRES_CONST_EXPORT_VERSION_TYPE_ASK SYSRES_CONST_EXPORT_VERSION_TYPE_LAST SYSRES_CONST_EXPORT_VERSION_TYPE_LAST_ACTIVE SYSRES_CONST_EXTENSION_REQUISITE_CODE SYSRES_CONST_FILTER_NAME_REQUISITE_CODE SYSRES_CONST_FILTER_REQUISITE_CODE SYSRES_CONST_FILTER_TYPE_COMMON_CODE SYSRES_CONST_FILTER_TYPE_COMMON_NAME SYSRES_CONST_FILTER_TYPE_USER_CODE SYSRES_CONST_FILTER_TYPE_USER_NAME SYSRES_CONST_FILTER_VALUE_REQUISITE_NAME SYSRES_CONST_FLOAT_NUMBER_FORMAT_CHAR SYSRES_CONST_FLOAT_REQUISITE_TYPE SYSRES_CONST_FOLDER_AUTHOR_VALUE SYSRES_CONST_FOLDER_KIND_ANY_OBJECTS SYSRES_CONST_FOLDER_KIND_COMPONENTS SYSRES_CONST_FOLDER_KIND_EDOCS SYSRES_CONST_FOLDER_KIND_JOBS SYSRES_CONST_FOLDER_KIND_TASKS SYSRES_CONST_FOLDER_TYPE_COMMON SYSRES_CONST_FOLDER_TYPE_COMPONENT SYSRES_CONST_FOLDER_TYPE_FAVORITES SYSRES_CONST_FOLDER_TYPE_INBOX SYSRES_CONST_FOLDER_TYPE_OUTBOX SYSRES_CONST_FOLDER_TYPE_QUICK_LAUNCH SYSRES_CONST_FOLDER_TYPE_SEARCH SYSRES_CONST_FOLDER_TYPE_SHORTCUTS SYSRES_CONST_FOLDER_TYPE_USER SYSRES_CONST_FROM_DICTIONARY_ENUM_METHOD_FLAG SYSRES_CONST_FULL_SUBSTITUTE_TYPE SYSRES_CONST_FULL_SUBSTITUTE_TYPE_CODE SYSRES_CONST_FUNCTION_CANCEL_RESULT SYSRES_CONST_FUNCTION_CATEGORY_SYSTEM SYSRES_CONST_FUNCTION_CATEGORY_USER SYSRES_CONST_FUNCTION_FAILURE_RESULT SYSRES_CONST_FUNCTION_SAVE_RESULT SYSRES_CONST_GENERATED_REQUISITE SYSRES_CONST_GREEN_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_GROUP_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_CODE SYSRES_CONST_GROUP_CATEGORY_NORMAL_NAME SYSRES_CONST_GROUP_CATEGORY_SERVICE_CODE SYSRES_CONST_GROUP_CATEGORY_SERVICE_NAME SYSRES_CONST_GROUP_COMMON_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_FULL_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_CODES_REQUISITE_CODE SYSRES_CONST_GROUP_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_GROUP_SERVICE_CATEGORY_FIELD_VALUE SYSRES_CONST_GROUP_USER_REQUISITE_CODE SYSRES_CONST_GROUPS_REFERENCE_CODE SYSRES_CONST_GROUPS_REQUISITE_CODE SYSRES_CONST_HIDDEN_MODE_NAME SYSRES_CONST_HIGH_LVL_REQUISITE_CODE SYSRES_CONST_HISTORY_ACTION_CREATE_CODE SYSRES_CONST_HISTORY_ACTION_DELETE_CODE SYSRES_CONST_HISTORY_ACTION_EDIT_CODE SYSRES_CONST_HOUR_CHAR SYSRES_CONST_ID_REQUISITE_CODE SYSRES_CONST_IDSPS_REQUISITE_CODE SYSRES_CONST_IMAGE_MODE_COLOR SYSRES_CONST_IMAGE_MODE_GREYSCALE SYSRES_CONST_IMAGE_MODE_MONOCHROME SYSRES_CONST_IMPORTANCE_HIGH SYSRES_CONST_IMPORTANCE_LOW SYSRES_CONST_IMPORTANCE_NORMAL SYSRES_CONST_IN_DESIGN_VERSION_STATE_PICK_VALUE SYSRES_CONST_INCOMING_WORK_RULE_TYPE_CODE SYSRES_CONST_INT_REQUISITE SYSRES_CONST_INT_REQUISITE_TYPE SYSRES_CONST_INTEGER_NUMBER_FORMAT_CHAR SYSRES_CONST_INTEGER_TYPE_CHAR SYSRES_CONST_IS_GENERATED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_PUBLIC_ROLE_REQUISITE_CODE SYSRES_CONST_IS_REMOTE_USER_NEGATIVE_VALUE SYSRES_CONST_IS_REMOTE_USER_POSITIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_NEGATIVE_VALUE SYSRES_CONST_IS_STORED_REQUISITE_STORED_VALUE SYSRES_CONST_ITALIC_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_JOB_BLOCK_DESCRIPTION SYSRES_CONST_JOB_KIND_CONTROL_JOB SYSRES_CONST_JOB_KIND_JOB SYSRES_CONST_JOB_KIND_NOTICE SYSRES_CONST_JOB_STATE_ABORTED SYSRES_CONST_JOB_STATE_COMPLETE SYSRES_CONST_JOB_STATE_WORKING SYSRES_CONST_KIND_REQUISITE_CODE SYSRES_CONST_KIND_REQUISITE_NAME SYSRES_CONST_KINDS_CREATE_SHADOW_COPIES_REQUISITE_CODE SYSRES_CONST_KINDS_DEFAULT_EDOC_LIFE_STAGE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALL_TEPLATES_ALLOWED_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_LIFE_CYCLE_STAGE_CHANGING_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_ALLOW_MULTIPLE_ACTIVE_VERSIONS_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_SHARE_ACCES_RIGHTS_BY_DEFAULT_CODE SYSRES_CONST_KINDS_EDOC_TEMPLATE_REQUISITE_CODE SYSRES_CONST_KINDS_EDOC_TYPE_REQUISITE_CODE SYSRES_CONST_KINDS_SIGNERS_REQUISITES_CODE SYSRES_CONST_KOD_INPUT_TYPE SYSRES_CONST_LAST_UPDATE_DATE_REQUISITE_CODE SYSRES_CONST_LIFE_CYCLE_START_STAGE_REQUISITE_CODE SYSRES_CONST_LILAC_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_LINK_OBJECT_KIND_COMPONENT SYSRES_CONST_LINK_OBJECT_KIND_DOCUMENT SYSRES_CONST_LINK_OBJECT_KIND_EDOC SYSRES_CONST_LINK_OBJECT_KIND_FOLDER SYSRES_CONST_LINK_OBJECT_KIND_JOB SYSRES_CONST_LINK_OBJECT_KIND_REFERENCE SYSRES_CONST_LINK_OBJECT_KIND_TASK SYSRES_CONST_LINK_REF_TYPE_REQUISITE_CODE SYSRES_CONST_LIST_REFERENCE_MODE_NAME SYSRES_CONST_LOCALIZATION_DICTIONARY_MAIN_VIEW_CODE SYSRES_CONST_MAIN_VIEW_CODE SYSRES_CONST_MANUAL_ENUM_METHOD_FLAG SYSRES_CONST_MASTER_COMP_TYPE_REQUISITE_CODE SYSRES_CONST_MASTER_TABLE_REC_ID_REQUISITE_CODE SYSRES_CONST_MAXIMIZED_MODE_NAME SYSRES_CONST_ME_VALUE SYSRES_CONST_MESSAGE_ATTENTION_CAPTION SYSRES_CONST_MESSAGE_CONFIRMATION_CAPTION SYSRES_CONST_MESSAGE_ERROR_CAPTION SYSRES_CONST_MESSAGE_INFORMATION_CAPTION SYSRES_CONST_MINIMIZED_MODE_NAME SYSRES_CONST_MINUTE_CHAR SYSRES_CONST_MODULE_REQUISITE_CODE SYSRES_CONST_MONITORING_BLOCK_DESCRIPTION SYSRES_CONST_MONTH_FORMAT_VALUE SYSRES_CONST_NAME_LOCALIZE_ID_REQUISITE_CODE SYSRES_CONST_NAME_REQUISITE_CODE SYSRES_CONST_NAME_SINGULAR_REQUISITE_CODE SYSRES_CONST_NAMEAN_INPUT_TYPE SYSRES_CONST_NEGATIVE_PICK_VALUE SYSRES_CONST_NEGATIVE_VALUE SYSRES_CONST_NO SYSRES_CONST_NO_PICK_VALUE SYSRES_CONST_NO_SIGNATURE_REQUISITE_CODE SYSRES_CONST_NO_VALUE SYSRES_CONST_NONE_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE SYSRES_CONST_NONOPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_NORMAL_ACCESS_RIGHTS_TYPE_CODE SYSRES_CONST_NORMAL_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_NORMAL_MODE_NAME SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_CODE SYSRES_CONST_NOT_ALLOWED_ACCESS_TYPE_NAME SYSRES_CONST_NOTE_REQUISITE_CODE SYSRES_CONST_NOTICE_BLOCK_DESCRIPTION SYSRES_CONST_NUM_REQUISITE SYSRES_CONST_NUM_STR_REQUISITE_CODE SYSRES_CONST_NUMERATION_AUTO_NOT_STRONG SYSRES_CONST_NUMERATION_AUTO_STRONG SYSRES_CONST_NUMERATION_FROM_DICTONARY SYSRES_CONST_NUMERATION_MANUAL SYSRES_CONST_NUMERIC_TYPE_CHAR SYSRES_CONST_NUMREQ_REQUISITE_CODE SYSRES_CONST_OBSOLETE_VERSION_STATE_PICK_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_FEMININE SYSRES_CONST_OPERATING_RECORD_FLAG_VALUE_MASCULINE SYSRES_CONST_OPTIONAL_FORM_COMP_REQCODE_PREFIX SYSRES_CONST_ORANGE_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_ORIGINALREF_REQUISITE_CODE SYSRES_CONST_OURFIRM_REF_CODE SYSRES_CONST_OURFIRM_REQUISITE_CODE SYSRES_CONST_OURFIRM_VAR SYSRES_CONST_OUTGOING_WORK_RULE_TYPE_CODE SYSRES_CONST_PICK_NEGATIVE_RESULT SYSRES_CONST_PICK_POSITIVE_RESULT SYSRES_CONST_PICK_REQUISITE SYSRES_CONST_PICK_REQUISITE_TYPE SYSRES_CONST_PICK_TYPE_CHAR SYSRES_CONST_PLAN_STATUS_REQUISITE_CODE SYSRES_CONST_PLATFORM_VERSION_COMMENT SYSRES_CONST_PLUGINS_SETTINGS_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_POSITIVE_PICK_VALUE SYSRES_CONST_POWER_TO_CREATE_ACTION_CODE SYSRES_CONST_POWER_TO_SIGN_ACTION_CODE SYSRES_CONST_PRIORITY_REQUISITE_CODE SYSRES_CONST_QUALIFIED_TASK_TYPE SYSRES_CONST_QUALIFIED_TASK_TYPE_CODE SYSRES_CONST_RECSTAT_REQUISITE_CODE SYSRES_CONST_RED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_REF_ID_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_REF_REQUISITE SYSRES_CONST_REF_REQUISITE_TYPE SYSRES_CONST_REF_REQUISITES_REFERENCE_CODE_SELECTED_REQUISITE SYSRES_CONST_REFERENCE_RECORD_HISTORY_CREATE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_DELETE_ACTION_CODE SYSRES_CONST_REFERENCE_RECORD_HISTORY_MODIFY_ACTION_CODE SYSRES_CONST_REFERENCE_TYPE_CHAR SYSRES_CONST_REFERENCE_TYPE_REQUISITE_NAME SYSRES_CONST_REFERENCES_ADD_PARAMS_REQUISITE_CODE SYSRES_CONST_REFERENCES_DISPLAY_REQUISITE_REQUISITE_CODE SYSRES_CONST_REMOTE_SERVER_STATUS_WORKING SYSRES_CONST_REMOTE_SERVER_TYPE_MAIN SYSRES_CONST_REMOTE_SERVER_TYPE_SECONDARY SYSRES_CONST_REMOTE_USER_FLAG_VALUE_CODE SYSRES_CONST_REPORT_APP_EDITOR_INTERNAL SYSRES_CONST_REPORT_BASE_REPORT_ID_REQUISITE_CODE SYSRES_CONST_REPORT_BASE_REPORT_REQUISITE_CODE SYSRES_CONST_REPORT_SCRIPT_REQUISITE_CODE SYSRES_CONST_REPORT_TEMPLATE_REQUISITE_CODE SYSRES_CONST_REPORT_VIEWER_CODE_REQUISITE_CODE SYSRES_CONST_REQ_ALLOW_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_RECORD_DEFAULT_VALUE SYSRES_CONST_REQ_ALLOW_SERVER_COMPONENT_DEFAULT_VALUE SYSRES_CONST_REQ_MODE_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_EDIT_CODE SYSRES_CONST_REQ_MODE_HIDDEN_CODE SYSRES_CONST_REQ_MODE_NOT_AVAILABLE_CODE SYSRES_CONST_REQ_MODE_VIEW_CODE SYSRES_CONST_REQ_NUMBER_REQUISITE_CODE SYSRES_CONST_REQ_SECTION_VALUE SYSRES_CONST_REQ_TYPE_VALUE SYSRES_CONST_REQUISITE_FORMAT_BY_UNIT SYSRES_CONST_REQUISITE_FORMAT_DATE_FULL SYSRES_CONST_REQUISITE_FORMAT_DATE_TIME SYSRES_CONST_REQUISITE_FORMAT_LEFT SYSRES_CONST_REQUISITE_FORMAT_RIGHT SYSRES_CONST_REQUISITE_FORMAT_WITHOUT_UNIT SYSRES_CONST_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_REQUISITE_SECTION_ACTIONS SYSRES_CONST_REQUISITE_SECTION_BUTTON SYSRES_CONST_REQUISITE_SECTION_BUTTONS SYSRES_CONST_REQUISITE_SECTION_CARD SYSRES_CONST_REQUISITE_SECTION_TABLE SYSRES_CONST_REQUISITE_SECTION_TABLE10 SYSRES_CONST_REQUISITE_SECTION_TABLE11 SYSRES_CONST_REQUISITE_SECTION_TABLE12 SYSRES_CONST_REQUISITE_SECTION_TABLE13 SYSRES_CONST_REQUISITE_SECTION_TABLE14 SYSRES_CONST_REQUISITE_SECTION_TABLE15 SYSRES_CONST_REQUISITE_SECTION_TABLE16 SYSRES_CONST_REQUISITE_SECTION_TABLE17 SYSRES_CONST_REQUISITE_SECTION_TABLE18 SYSRES_CONST_REQUISITE_SECTION_TABLE19 SYSRES_CONST_REQUISITE_SECTION_TABLE2 SYSRES_CONST_REQUISITE_SECTION_TABLE20 SYSRES_CONST_REQUISITE_SECTION_TABLE21 SYSRES_CONST_REQUISITE_SECTION_TABLE22 SYSRES_CONST_REQUISITE_SECTION_TABLE23 SYSRES_CONST_REQUISITE_SECTION_TABLE24 SYSRES_CONST_REQUISITE_SECTION_TABLE3 SYSRES_CONST_REQUISITE_SECTION_TABLE4 SYSRES_CONST_REQUISITE_SECTION_TABLE5 SYSRES_CONST_REQUISITE_SECTION_TABLE6 SYSRES_CONST_REQUISITE_SECTION_TABLE7 SYSRES_CONST_REQUISITE_SECTION_TABLE8 SYSRES_CONST_REQUISITE_SECTION_TABLE9 SYSRES_CONST_REQUISITES_PSEUDOREFERENCE_REQUISITE_NUMBER_REQUISITE_CODE SYSRES_CONST_RIGHT_ALIGNMENT_CODE SYSRES_CONST_ROLES_REFERENCE_CODE SYSRES_CONST_ROUTE_STEP_AFTER_RUS SYSRES_CONST_ROUTE_STEP_AND_CONDITION_RUS SYSRES_CONST_ROUTE_STEP_OR_CONDITION_RUS SYSRES_CONST_ROUTE_TYPE_COMPLEX SYSRES_CONST_ROUTE_TYPE_PARALLEL SYSRES_CONST_ROUTE_TYPE_SERIAL SYSRES_CONST_SBDATASETDESC_NEGATIVE_VALUE SYSRES_CONST_SBDATASETDESC_POSITIVE_VALUE SYSRES_CONST_SBVIEWSDESC_POSITIVE_VALUE SYSRES_CONST_SCRIPT_BLOCK_DESCRIPTION SYSRES_CONST_SEARCH_BY_TEXT_REQUISITE_CODE SYSRES_CONST_SEARCHES_COMPONENT_CONTENT SYSRES_CONST_SEARCHES_CRITERIA_ACTION_NAME SYSRES_CONST_SEARCHES_EDOC_CONTENT SYSRES_CONST_SEARCHES_FOLDER_CONTENT SYSRES_CONST_SEARCHES_JOB_CONTENT SYSRES_CONST_SEARCHES_REFERENCE_CODE SYSRES_CONST_SEARCHES_TASK_CONTENT SYSRES_CONST_SECOND_CHAR SYSRES_CONST_SECTION_REQUISITE_ACTIONS_VALUE SYSRES_CONST_SECTION_REQUISITE_CARD_VALUE SYSRES_CONST_SECTION_REQUISITE_CODE SYSRES_CONST_SECTION_REQUISITE_DETAIL_1_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_2_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_3_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_4_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_5_VALUE SYSRES_CONST_SECTION_REQUISITE_DETAIL_6_VALUE SYSRES_CONST_SELECT_REFERENCE_MODE_NAME SYSRES_CONST_SELECT_TYPE_SELECTABLE SYSRES_CONST_SELECT_TYPE_SELECTABLE_ONLY_CHILD SYSRES_CONST_SELECT_TYPE_SELECTABLE_WITH_CHILD SYSRES_CONST_SELECT_TYPE_UNSLECTABLE SYSRES_CONST_SERVER_TYPE_MAIN SYSRES_CONST_SERVICE_USER_CATEGORY_FIELD_VALUE SYSRES_CONST_SETTINGS_USER_REQUISITE_CODE SYSRES_CONST_SIGNATURE_AND_ENCODE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SIGNATURE_CERTIFICATE_TYPE_CODE SYSRES_CONST_SINGULAR_TITLE_REQUISITE_CODE SYSRES_CONST_SQL_SERVER_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_SQL_SERVER_ENCODE_AUTHENTIFICATION_FLAG_VALUE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_CODE SYSRES_CONST_STANDART_ROUTE_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_STANDART_ROUTES_GROUPS_REFERENCE_CODE SYSRES_CONST_STATE_REQ_NAME SYSRES_CONST_STATE_REQUISITE_ACTIVE_VALUE SYSRES_CONST_STATE_REQUISITE_CLOSED_VALUE SYSRES_CONST_STATE_REQUISITE_CODE SYSRES_CONST_STATIC_ROLE_TYPE_CODE SYSRES_CONST_STATUS_PLAN_DEFAULT_VALUE SYSRES_CONST_STATUS_VALUE_AUTOCLEANING SYSRES_CONST_STATUS_VALUE_BLUE_SQUARE SYSRES_CONST_STATUS_VALUE_COMPLETE SYSRES_CONST_STATUS_VALUE_GREEN_SQUARE SYSRES_CONST_STATUS_VALUE_ORANGE_SQUARE SYSRES_CONST_STATUS_VALUE_PURPLE_SQUARE SYSRES_CONST_STATUS_VALUE_RED_SQUARE SYSRES_CONST_STATUS_VALUE_SUSPEND SYSRES_CONST_STATUS_VALUE_YELLOW_SQUARE SYSRES_CONST_STDROUTE_SHOW_TO_USERS_REQUISITE_CODE SYSRES_CONST_STORAGE_TYPE_FILE SYSRES_CONST_STORAGE_TYPE_SQL_SERVER SYSRES_CONST_STR_REQUISITE SYSRES_CONST_STRIKEOUT_LIFE_CYCLE_STAGE_DRAW_STYLE SYSRES_CONST_STRING_FORMAT_LEFT_ALIGN_CHAR SYSRES_CONST_STRING_FORMAT_RIGHT_ALIGN_CHAR SYSRES_CONST_STRING_REQUISITE_CODE SYSRES_CONST_STRING_REQUISITE_TYPE SYSRES_CONST_STRING_TYPE_CHAR SYSRES_CONST_SUBSTITUTES_PSEUDOREFERENCE_CODE SYSRES_CONST_SUBTASK_BLOCK_DESCRIPTION SYSRES_CONST_SYSTEM_SETTING_CURRENT_USER_PARAM_VALUE SYSRES_CONST_SYSTEM_SETTING_EMPTY_VALUE_PARAM_VALUE SYSRES_CONST_SYSTEM_VERSION_COMMENT SYSRES_CONST_TASK_ACCESS_TYPE_ALL SYSRES_CONST_TASK_ACCESS_TYPE_ALL_MEMBERS SYSRES_CONST_TASK_ACCESS_TYPE_MANUAL SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION SYSRES_CONST_TASK_ENCODE_TYPE_CERTIFICATION_AND_PASSWORD SYSRES_CONST_TASK_ENCODE_TYPE_NONE SYSRES_CONST_TASK_ENCODE_TYPE_PASSWORD SYSRES_CONST_TASK_ROUTE_ALL_CONDITION SYSRES_CONST_TASK_ROUTE_AND_CONDITION SYSRES_CONST_TASK_ROUTE_OR_CONDITION SYSRES_CONST_TASK_STATE_ABORTED SYSRES_CONST_TASK_STATE_COMPLETE SYSRES_CONST_TASK_STATE_CONTINUED SYSRES_CONST_TASK_STATE_CONTROL SYSRES_CONST_TASK_STATE_INIT SYSRES_CONST_TASK_STATE_WORKING SYSRES_CONST_TASK_TITLE SYSRES_CONST_TASK_TYPES_GROUPS_REFERENCE_CODE SYSRES_CONST_TASK_TYPES_REFERENCE_CODE SYSRES_CONST_TEMPLATES_REFERENCE_CODE SYSRES_CONST_TEST_DATE_REQUISITE_NAME SYSRES_CONST_TEST_DEV_DATABASE_NAME SYSRES_CONST_TEST_DEV_SYSTEM_CODE SYSRES_CONST_TEST_EDMS_DATABASE_NAME SYSRES_CONST_TEST_EDMS_MAIN_CODE SYSRES_CONST_TEST_EDMS_MAIN_DB_NAME SYSRES_CONST_TEST_EDMS_SECOND_CODE SYSRES_CONST_TEST_EDMS_SECOND_DB_NAME SYSRES_CONST_TEST_EDMS_SYSTEM_CODE SYSRES_CONST_TEST_NUMERIC_REQUISITE_NAME SYSRES_CONST_TEXT_REQUISITE SYSRES_CONST_TEXT_REQUISITE_CODE SYSRES_CONST_TEXT_REQUISITE_TYPE SYSRES_CONST_TEXT_TYPE_CHAR SYSRES_CONST_TYPE_CODE_REQUISITE_CODE SYSRES_CONST_TYPE_REQUISITE_CODE SYSRES_CONST_UNDEFINED_LIFE_CYCLE_STAGE_FONT_COLOR SYSRES_CONST_UNITS_SECTION_ID_REQUISITE_CODE SYSRES_CONST_UNITS_SECTION_REQUISITE_CODE SYSRES_CONST_UNOPERATING_RECORD_FLAG_VALUE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_CODE SYSRES_CONST_UNSTORED_DATA_REQUISITE_NAME SYSRES_CONST_USE_ACCESS_TYPE_CODE SYSRES_CONST_USE_ACCESS_TYPE_NAME SYSRES_CONST_USER_ACCOUNT_TYPE_VALUE_CODE SYSRES_CONST_USER_ADDITIONAL_INFORMATION_REQUISITE_CODE SYSRES_CONST_USER_AND_GROUP_ID_FROM_PSEUDOREFERENCE_REQUISITE_CODE SYSRES_CONST_USER_CATEGORY_NORMAL SYSRES_CONST_USER_CERTIFICATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_STATE_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_SUBJECT_NAME_REQUISITE_CODE SYSRES_CONST_USER_CERTIFICATE_THUMBPRINT_REQUISITE_CODE SYSRES_CONST_USER_COMMON_CATEGORY SYSRES_CONST_USER_COMMON_CATEGORY_CODE SYSRES_CONST_USER_FULL_NAME_REQUISITE_CODE SYSRES_CONST_USER_GROUP_TYPE_REQUISITE_CODE SYSRES_CONST_USER_LOGIN_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USER_REMOTE_SYSTEM_REQUISITE_CODE SYSRES_CONST_USER_RIGHTS_T_REQUISITE_CODE SYSRES_CONST_USER_SERVER_NAME_REQUISITE_CODE SYSRES_CONST_USER_SERVICE_CATEGORY SYSRES_CONST_USER_SERVICE_CATEGORY_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_CODE SYSRES_CONST_USER_STATUS_ADMINISTRATOR_NAME SYSRES_CONST_USER_STATUS_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_DEVELOPER_NAME SYSRES_CONST_USER_STATUS_DISABLED_CODE SYSRES_CONST_USER_STATUS_DISABLED_NAME SYSRES_CONST_USER_STATUS_SYSTEM_DEVELOPER_CODE SYSRES_CONST_USER_STATUS_USER_CODE SYSRES_CONST_USER_STATUS_USER_NAME SYSRES_CONST_USER_STATUS_USER_NAME_DEPRECATED SYSRES_CONST_USER_TYPE_FIELD_VALUE_USER SYSRES_CONST_USER_TYPE_REQUISITE_CODE SYSRES_CONST_USERS_CONTROLLER_REQUISITE_CODE SYSRES_CONST_USERS_IS_MAIN_SERVER_REQUISITE_CODE SYSRES_CONST_USERS_REFERENCE_CODE SYSRES_CONST_USERS_REGISTRATION_CERTIFICATES_ACTION_NAME SYSRES_CONST_USERS_REQUISITE_CODE SYSRES_CONST_USERS_SYSTEM_REQUISITE_CODE SYSRES_CONST_USERS_USER_ACCESS_RIGHTS_TYPR_REQUISITE_CODE SYSRES_CONST_USERS_USER_AUTHENTICATION_REQUISITE_CODE SYSRES_CONST_USERS_USER_COMPONENT_REQUISITE_CODE SYSRES_CONST_USERS_USER_GROUP_REQUISITE_CODE SYSRES_CONST_USERS_VIEW_CERTIFICATES_ACTION_NAME SYSRES_CONST_VIEW_DEFAULT_CODE SYSRES_CONST_VIEW_DEFAULT_NAME SYSRES_CONST_VIEWER_REQUISITE_CODE SYSRES_CONST_WAITING_BLOCK_DESCRIPTION SYSRES_CONST_WIZARD_FORM_LABEL_TEST_STRING  SYSRES_CONST_WIZARD_QUERY_PARAM_HEIGHT_ETALON_STRING SYSRES_CONST_WIZARD_REFERENCE_COMMENT_REQUISITE_CODE SYSRES_CONST_WORK_RULES_DESCRIPTION_REQUISITE_CODE SYSRES_CONST_WORK_TIME_CALENDAR_REFERENCE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE SYSRES_CONST_WORK_WORKFLOW_HARD_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORK_WORKFLOW_SOFT_ROUTE_TYPE_VALUE_CODE_RUS SYSRES_CONST_WORKFLOW_ROUTE_TYPR_HARD SYSRES_CONST_WORKFLOW_ROUTE_TYPR_SOFT SYSRES_CONST_XML_ENCODING SYSRES_CONST_XREC_STAT_REQUISITE_CODE SYSRES_CONST_XRECID_FIELD_NAME SYSRES_CONST_YES SYSRES_CONST_YES_NO_2_REQUISITE_CODE SYSRES_CONST_YES_NO_REQUISITE_CODE SYSRES_CONST_YES_NO_T_REF_TYPE_REQUISITE_CODE SYSRES_CONST_YES_PICK_VALUE SYSRES_CONST_YES_VALUE CR FALSE nil NO_VALUE NULL TAB TRUE YES_VALUE ADMINISTRATORS_GROUP_NAME CUSTOMIZERS_GROUP_NAME DEVELOPERS_GROUP_NAME SERVICE_USERS_GROUP_NAME DECISION_BLOCK_FIRST_OPERAND_PROPERTY DECISION_BLOCK_NAME_PROPERTY DECISION_BLOCK_OPERATION_PROPERTY DECISION_BLOCK_RESULT_TYPE_PROPERTY DECISION_BLOCK_SECOND_OPERAND_PROPERTY ANY_FILE_EXTENTION COMPRESSED_DOCUMENT_EXTENSION EXTENDED_DOCUMENT_EXTENSION SHORT_COMPRESSED_DOCUMENT_EXTENSION SHORT_EXTENDED_DOCUMENT_EXTENSION JOB_BLOCK_ABORT_DEADLINE_PROPERTY JOB_BLOCK_AFTER_FINISH_EVENT JOB_BLOCK_AFTER_QUERY_PARAMETERS_EVENT JOB_BLOCK_ATTACHMENT_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY JOB_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY JOB_BLOCK_BEFORE_QUERY_PARAMETERS_EVENT JOB_BLOCK_BEFORE_START_EVENT JOB_BLOCK_CREATED_JOBS_PROPERTY JOB_BLOCK_DEADLINE_PROPERTY JOB_BLOCK_EXECUTION_RESULTS_PROPERTY JOB_BLOCK_IS_PARALLEL_PROPERTY JOB_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY JOB_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY JOB_BLOCK_JOB_TEXT_PROPERTY JOB_BLOCK_NAME_PROPERTY JOB_BLOCK_NEED_SIGN_ON_PERFORM_PROPERTY JOB_BLOCK_PERFORMER_PROPERTY JOB_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY JOB_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY JOB_BLOCK_SUBJECT_PROPERTY ENGLISH_LANGUAGE_CODE RUSSIAN_LANGUAGE_CODE smHidden smMaximized smMinimized smNormal wmNo wmYes COMPONENT_TOKEN_LINK_KIND DOCUMENT_LINK_KIND EDOCUMENT_LINK_KIND FOLDER_LINK_KIND JOB_LINK_KIND REFERENCE_LINK_KIND TASK_LINK_KIND COMPONENT_TOKEN_LOCK_TYPE EDOCUMENT_VERSION_LOCK_TYPE MONITOR_BLOCK_AFTER_FINISH_EVENT MONITOR_BLOCK_BEFORE_START_EVENT MONITOR_BLOCK_DEADLINE_PROPERTY MONITOR_BLOCK_INTERVAL_PROPERTY MONITOR_BLOCK_INTERVAL_TYPE_PROPERTY MONITOR_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY MONITOR_BLOCK_NAME_PROPERTY MONITOR_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY MONITOR_BLOCK_SEARCH_SCRIPT_PROPERTY NOTICE_BLOCK_AFTER_FINISH_EVENT NOTICE_BLOCK_ATTACHMENT_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY NOTICE_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY NOTICE_BLOCK_BEFORE_START_EVENT NOTICE_BLOCK_CREATED_NOTICES_PROPERTY NOTICE_BLOCK_DEADLINE_PROPERTY NOTICE_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY NOTICE_BLOCK_NAME_PROPERTY NOTICE_BLOCK_NOTICE_TEXT_PROPERTY NOTICE_BLOCK_PERFORMER_PROPERTY NOTICE_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY NOTICE_BLOCK_SUBJECT_PROPERTY dseAfterCancel dseAfterClose dseAfterDelete dseAfterDeleteOutOfTransaction dseAfterInsert dseAfterOpen dseAfterScroll dseAfterUpdate dseAfterUpdateOutOfTransaction dseBeforeCancel dseBeforeClose dseBeforeDelete dseBeforeDetailUpdate dseBeforeInsert dseBeforeOpen dseBeforeUpdate dseOnAnyRequisiteChange dseOnCloseRecord dseOnDeleteError dseOnOpenRecord dseOnPrepareUpdate dseOnUpdateError dseOnUpdateRatifiedRecord dseOnValidDelete dseOnValidUpdate reOnChange reOnChangeValues SELECTION_BEGIN_ROUTE_EVENT SELECTION_END_ROUTE_EVENT CURRENT_PERIOD_IS_REQUIRED PREVIOUS_CARD_TYPE_NAME SHOW_RECORD_PROPERTIES_FORM ACCESS_RIGHTS_SETTING_DIALOG_CODE ADMINISTRATOR_USER_CODE ANALYTIC_REPORT_TYPE asrtHideLocal asrtHideRemote CALCULATED_ROLE_TYPE_CODE COMPONENTS_REFERENCE_DEVELOPER_VIEW_CODE DCTS_TEST_PROTOCOLS_FOLDER_PATH E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED E_EDOC_VERSION_ALREADY_APPROVINGLY_SIGNED_BY_USER E_EDOC_VERSION_ALREDY_SIGNED E_EDOC_VERSION_ALREDY_SIGNED_BY_USER EDOC_TYPES_CODE_REQUISITE_FIELD_NAME EDOCUMENTS_ALIAS_NAME FILES_FOLDER_PATH FILTER_OPERANDS_DELIMITER FILTER_OPERATIONS_DELIMITER FORMCARD_NAME FORMLIST_NAME GET_EXTENDED_DOCUMENT_EXTENSION_CREATION_MODE GET_EXTENDED_DOCUMENT_EXTENSION_IMPORT_MODE INTEGRATED_REPORT_TYPE IS_BUILDER_APPLICATION_ROLE IS_BUILDER_APPLICATION_ROLE2 IS_BUILDER_USERS ISBSYSDEV LOG_FOLDER_PATH mbCancel mbNo mbNoToAll mbOK mbYes mbYesToAll MEMORY_DATASET_DESRIPTIONS_FILENAME mrNo mrNoToAll mrYes mrYesToAll MULTIPLE_SELECT_DIALOG_CODE NONOPERATING_RECORD_FLAG_FEMININE NONOPERATING_RECORD_FLAG_MASCULINE OPERATING_RECORD_FLAG_FEMININE OPERATING_RECORD_FLAG_MASCULINE PROFILING_SETTINGS_COMMON_SETTINGS_CODE_VALUE PROGRAM_INITIATED_LOOKUP_ACTION ratDelete ratEdit ratInsert REPORT_TYPE REQUIRED_PICK_VALUES_VARIABLE rmCard rmList SBRTE_PROGID_DEV SBRTE_PROGID_RELEASE STATIC_ROLE_TYPE_CODE SUPPRESS_EMPTY_TEMPLATE_CREATION SYSTEM_USER_CODE UPDATE_DIALOG_DATASET USED_IN_OBJECT_HINT_PARAM USER_INITIATED_LOOKUP_ACTION USER_NAME_FORMAT USER_SELECTION_RESTRICTIONS WORKFLOW_TEST_PROTOCOLS_FOLDER_PATH ELS_SUBTYPE_CONTROL_NAME ELS_FOLDER_KIND_CONTROL_NAME REPEAT_PROCESS_CURRENT_OBJECT_EXCEPTION_NAME PRIVILEGE_COMPONENT_FULL_ACCESS PRIVILEGE_DEVELOPMENT_EXPORT PRIVILEGE_DEVELOPMENT_IMPORT PRIVILEGE_DOCUMENT_DELETE PRIVILEGE_ESD PRIVILEGE_FOLDER_DELETE PRIVILEGE_MANAGE_ACCESS_RIGHTS PRIVILEGE_MANAGE_REPLICATION PRIVILEGE_MANAGE_SESSION_SERVER PRIVILEGE_OBJECT_FULL_ACCESS PRIVILEGE_OBJECT_VIEW PRIVILEGE_RESERVE_LICENSE PRIVILEGE_SYSTEM_CUSTOMIZE PRIVILEGE_SYSTEM_DEVELOP PRIVILEGE_SYSTEM_INSTALL PRIVILEGE_TASK_DELETE PRIVILEGE_USER_PLUGIN_SETTINGS_CUSTOMIZE PRIVILEGES_PSEUDOREFERENCE_CODE ACCESS_TYPES_PSEUDOREFERENCE_CODE ALL_AVAILABLE_COMPONENTS_PSEUDOREFERENCE_CODE ALL_AVAILABLE_PRIVILEGES_PSEUDOREFERENCE_CODE ALL_REPLICATE_COMPONENTS_PSEUDOREFERENCE_CODE AVAILABLE_DEVELOPERS_COMPONENTS_PSEUDOREFERENCE_CODE COMPONENTS_PSEUDOREFERENCE_CODE FILTRATER_SETTINGS_CONFLICTS_PSEUDOREFERENCE_CODE GROUPS_PSEUDOREFERENCE_CODE RECEIVE_PROTOCOL_PSEUDOREFERENCE_CODE REFERENCE_REQUISITE_PSEUDOREFERENCE_CODE REFERENCE_REQUISITES_PSEUDOREFERENCE_CODE REFTYPES_PSEUDOREFERENCE_CODE REPLICATION_SEANCES_DIARY_PSEUDOREFERENCE_CODE SEND_PROTOCOL_PSEUDOREFERENCE_CODE SUBSTITUTES_PSEUDOREFERENCE_CODE SYSTEM_SETTINGS_PSEUDOREFERENCE_CODE UNITS_PSEUDOREFERENCE_CODE USERS_PSEUDOREFERENCE_CODE VIEWERS_PSEUDOREFERENCE_CODE CERTIFICATE_TYPE_ENCRYPT CERTIFICATE_TYPE_SIGN CERTIFICATE_TYPE_SIGN_AND_ENCRYPT STORAGE_TYPE_FILE STORAGE_TYPE_NAS_CIFS STORAGE_TYPE_SAPERION STORAGE_TYPE_SQL_SERVER COMPTYPE2_REQUISITE_DOCUMENTS_VALUE COMPTYPE2_REQUISITE_TASKS_VALUE COMPTYPE2_REQUISITE_FOLDERS_VALUE COMPTYPE2_REQUISITE_REFERENCES_VALUE SYSREQ_CODE SYSREQ_COMPTYPE2 SYSREQ_CONST_AVAILABLE_FOR_WEB SYSREQ_CONST_COMMON_CODE SYSREQ_CONST_COMMON_VALUE SYSREQ_CONST_FIRM_CODE SYSREQ_CONST_FIRM_STATUS SYSREQ_CONST_FIRM_VALUE SYSREQ_CONST_SERVER_STATUS SYSREQ_CONTENTS SYSREQ_DATE_OPEN SYSREQ_DATE_CLOSE SYSREQ_DESCRIPTION SYSREQ_DESCRIPTION_LOCALIZE_ID SYSREQ_DOUBLE SYSREQ_EDOC_ACCESS_TYPE SYSREQ_EDOC_AUTHOR SYSREQ_EDOC_CREATED SYSREQ_EDOC_DELEGATE_RIGHTS_REQUISITE_CODE SYSREQ_EDOC_EDITOR SYSREQ_EDOC_ENCODE_TYPE SYSREQ_EDOC_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_EXPORT_DATE SYSREQ_EDOC_EXPORTER SYSREQ_EDOC_KIND SYSREQ_EDOC_LIFE_STAGE_NAME SYSREQ_EDOC_LOCKED_FOR_SERVER_CODE SYSREQ_EDOC_MODIFIED SYSREQ_EDOC_NAME SYSREQ_EDOC_NOTE SYSREQ_EDOC_QUALIFIED_ID SYSREQ_EDOC_SESSION_KEY SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_NAME SYSREQ_EDOC_SESSION_KEY_ENCRYPTION_PLUGIN_VERSION SYSREQ_EDOC_SIGNATURE_TYPE SYSREQ_EDOC_SIGNED SYSREQ_EDOC_STORAGE SYSREQ_EDOC_STORAGES_ARCHIVE_STORAGE SYSREQ_EDOC_STORAGES_CHECK_RIGHTS SYSREQ_EDOC_STORAGES_COMPUTER_NAME SYSREQ_EDOC_STORAGES_EDIT_IN_STORAGE SYSREQ_EDOC_STORAGES_EXECUTIVE_STORAGE SYSREQ_EDOC_STORAGES_FUNCTION SYSREQ_EDOC_STORAGES_INITIALIZED SYSREQ_EDOC_STORAGES_LOCAL_PATH SYSREQ_EDOC_STORAGES_SAPERION_DATABASE_NAME SYSREQ_EDOC_STORAGES_SEARCH_BY_TEXT SYSREQ_EDOC_STORAGES_SERVER_NAME SYSREQ_EDOC_STORAGES_SHARED_SOURCE_NAME SYSREQ_EDOC_STORAGES_TYPE SYSREQ_EDOC_TEXT_MODIFIED SYSREQ_EDOC_TYPE_ACT_CODE SYSREQ_EDOC_TYPE_ACT_DESCRIPTION SYSREQ_EDOC_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE SYSREQ_EDOC_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_EDOC_TYPE_ACT_SECTION SYSREQ_EDOC_TYPE_ADD_PARAMS SYSREQ_EDOC_TYPE_COMMENT SYSREQ_EDOC_TYPE_EVENT_TEXT SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR SYSREQ_EDOC_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_EDOC_TYPE_NAME_LOCALIZE_ID SYSREQ_EDOC_TYPE_NUMERATION_METHOD SYSREQ_EDOC_TYPE_PSEUDO_REQUISITE_CODE SYSREQ_EDOC_TYPE_REQ_CODE SYSREQ_EDOC_TYPE_REQ_DESCRIPTION SYSREQ_EDOC_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_EDOC_TYPE_REQ_IS_LEADING SYSREQ_EDOC_TYPE_REQ_IS_REQUIRED SYSREQ_EDOC_TYPE_REQ_NUMBER SYSREQ_EDOC_TYPE_REQ_ON_CHANGE SYSREQ_EDOC_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_EDOC_TYPE_REQ_ON_SELECT SYSREQ_EDOC_TYPE_REQ_ON_SELECT_KIND SYSREQ_EDOC_TYPE_REQ_SECTION SYSREQ_EDOC_TYPE_VIEW_CARD SYSREQ_EDOC_TYPE_VIEW_CODE SYSREQ_EDOC_TYPE_VIEW_COMMENT SYSREQ_EDOC_TYPE_VIEW_IS_MAIN SYSREQ_EDOC_TYPE_VIEW_NAME SYSREQ_EDOC_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_EDOC_VERSION_AUTHOR SYSREQ_EDOC_VERSION_CRC SYSREQ_EDOC_VERSION_DATA SYSREQ_EDOC_VERSION_EDITOR SYSREQ_EDOC_VERSION_EXPORT_DATE SYSREQ_EDOC_VERSION_EXPORTER SYSREQ_EDOC_VERSION_HIDDEN SYSREQ_EDOC_VERSION_LIFE_STAGE SYSREQ_EDOC_VERSION_MODIFIED SYSREQ_EDOC_VERSION_NOTE SYSREQ_EDOC_VERSION_SIGNATURE_TYPE SYSREQ_EDOC_VERSION_SIGNED SYSREQ_EDOC_VERSION_SIZE SYSREQ_EDOC_VERSION_SOURCE SYSREQ_EDOC_VERSION_TEXT_MODIFIED SYSREQ_EDOCKIND_DEFAULT_VERSION_STATE_CODE SYSREQ_FOLDER_KIND SYSREQ_FUNC_CATEGORY SYSREQ_FUNC_COMMENT SYSREQ_FUNC_GROUP SYSREQ_FUNC_GROUP_COMMENT SYSREQ_FUNC_GROUP_NUMBER SYSREQ_FUNC_HELP SYSREQ_FUNC_PARAM_DEF_VALUE SYSREQ_FUNC_PARAM_IDENT SYSREQ_FUNC_PARAM_NUMBER SYSREQ_FUNC_PARAM_TYPE SYSREQ_FUNC_TEXT SYSREQ_GROUP_CATEGORY SYSREQ_ID SYSREQ_LAST_UPDATE SYSREQ_LEADER_REFERENCE SYSREQ_LINE_NUMBER SYSREQ_MAIN_RECORD_ID SYSREQ_NAME SYSREQ_NAME_LOCALIZE_ID SYSREQ_NOTE SYSREQ_ORIGINAL_RECORD SYSREQ_OUR_FIRM SYSREQ_PROFILING_SETTINGS_BATCH_LOGING SYSREQ_PROFILING_SETTINGS_BATCH_SIZE SYSREQ_PROFILING_SETTINGS_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_SQL_PROFILING_ENABLED SYSREQ_PROFILING_SETTINGS_START_LOGGED SYSREQ_RECORD_STATUS SYSREQ_REF_REQ_FIELD_NAME SYSREQ_REF_REQ_FORMAT SYSREQ_REF_REQ_GENERATED SYSREQ_REF_REQ_LENGTH SYSREQ_REF_REQ_PRECISION SYSREQ_REF_REQ_REFERENCE SYSREQ_REF_REQ_SECTION SYSREQ_REF_REQ_STORED SYSREQ_REF_REQ_TOKENS SYSREQ_REF_REQ_TYPE SYSREQ_REF_REQ_VIEW SYSREQ_REF_TYPE_ACT_CODE SYSREQ_REF_TYPE_ACT_DESCRIPTION SYSREQ_REF_TYPE_ACT_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_ACT_ON_EXECUTE SYSREQ_REF_TYPE_ACT_ON_EXECUTE_EXISTS SYSREQ_REF_TYPE_ACT_SECTION SYSREQ_REF_TYPE_ADD_PARAMS SYSREQ_REF_TYPE_COMMENT SYSREQ_REF_TYPE_COMMON_SETTINGS SYSREQ_REF_TYPE_DISPLAY_REQUISITE_NAME SYSREQ_REF_TYPE_EVENT_TEXT SYSREQ_REF_TYPE_MAIN_LEADING_REF SYSREQ_REF_TYPE_NAME_IN_SINGULAR SYSREQ_REF_TYPE_NAME_IN_SINGULAR_LOCALIZE_ID SYSREQ_REF_TYPE_NAME_LOCALIZE_ID SYSREQ_REF_TYPE_NUMERATION_METHOD SYSREQ_REF_TYPE_REQ_CODE SYSREQ_REF_TYPE_REQ_DESCRIPTION SYSREQ_REF_TYPE_REQ_DESCRIPTION_LOCALIZE_ID SYSREQ_REF_TYPE_REQ_IS_CONTROL SYSREQ_REF_TYPE_REQ_IS_FILTER SYSREQ_REF_TYPE_REQ_IS_LEADING SYSREQ_REF_TYPE_REQ_IS_REQUIRED SYSREQ_REF_TYPE_REQ_NUMBER SYSREQ_REF_TYPE_REQ_ON_CHANGE SYSREQ_REF_TYPE_REQ_ON_CHANGE_EXISTS SYSREQ_REF_TYPE_REQ_ON_SELECT SYSREQ_REF_TYPE_REQ_ON_SELECT_KIND SYSREQ_REF_TYPE_REQ_SECTION SYSREQ_REF_TYPE_VIEW_CARD SYSREQ_REF_TYPE_VIEW_CODE SYSREQ_REF_TYPE_VIEW_COMMENT SYSREQ_REF_TYPE_VIEW_IS_MAIN SYSREQ_REF_TYPE_VIEW_NAME SYSREQ_REF_TYPE_VIEW_NAME_LOCALIZE_ID SYSREQ_REFERENCE_TYPE_ID SYSREQ_STATE SYSREQ_STAT\u0415 SYSREQ_SYSTEM_SETTINGS_VALUE SYSREQ_TYPE SYSREQ_UNIT SYSREQ_UNIT_ID SYSREQ_USER_GROUPS_GROUP_FULL_NAME SYSREQ_USER_GROUPS_GROUP_NAME SYSREQ_USER_GROUPS_GROUP_SERVER_NAME SYSREQ_USERS_ACCESS_RIGHTS SYSREQ_USERS_AUTHENTICATION SYSREQ_USERS_CATEGORY SYSREQ_USERS_COMPONENT SYSREQ_USERS_COMPONENT_USER_IS_PUBLIC SYSREQ_USERS_DOMAIN SYSREQ_USERS_FULL_USER_NAME SYSREQ_USERS_GROUP SYSREQ_USERS_IS_MAIN_SERVER SYSREQ_USERS_LOGIN SYSREQ_USERS_REFERENCE_USER_IS_PUBLIC SYSREQ_USERS_STATUS SYSREQ_USERS_USER_CERTIFICATE SYSREQ_USERS_USER_CERTIFICATE_INFO SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_NAME SYSREQ_USERS_USER_CERTIFICATE_PLUGIN_VERSION SYSREQ_USERS_USER_CERTIFICATE_STATE SYSREQ_USERS_USER_CERTIFICATE_SUBJECT_NAME SYSREQ_USERS_USER_CERTIFICATE_THUMBPRINT SYSREQ_USERS_USER_DEFAULT_CERTIFICATE SYSREQ_USERS_USER_DESCRIPTION SYSREQ_USERS_USER_GLOBAL_NAME SYSREQ_USERS_USER_LOGIN SYSREQ_USERS_USER_MAIN_SERVER SYSREQ_USERS_USER_TYPE SYSREQ_WORK_RULES_FOLDER_ID RESULT_VAR_NAME RESULT_VAR_NAME_ENG AUTO_NUMERATION_RULE_ID CANT_CHANGE_ID_REQUISITE_RULE_ID CANT_CHANGE_OURFIRM_REQUISITE_RULE_ID CHECK_CHANGING_REFERENCE_RECORD_USE_RULE_ID CHECK_CODE_REQUISITE_RULE_ID CHECK_DELETING_REFERENCE_RECORD_USE_RULE_ID CHECK_FILTRATER_CHANGES_RULE_ID CHECK_RECORD_INTERVAL_RULE_ID CHECK_REFERENCE_INTERVAL_RULE_ID CHECK_REQUIRED_DATA_FULLNESS_RULE_ID CHECK_REQUIRED_REQUISITES_FULLNESS_RULE_ID MAKE_RECORD_UNRATIFIED_RULE_ID RESTORE_AUTO_NUMERATION_RULE_ID SET_FIRM_CONTEXT_FROM_RECORD_RULE_ID SET_FIRST_RECORD_IN_LIST_FORM_RULE_ID SET_IDSPS_VALUE_RULE_ID SET_NEXT_CODE_VALUE_RULE_ID SET_OURFIRM_BOUNDS_RULE_ID SET_OURFIRM_REQUISITE_RULE_ID SCRIPT_BLOCK_AFTER_FINISH_EVENT SCRIPT_BLOCK_BEFORE_START_EVENT SCRIPT_BLOCK_EXECUTION_RESULTS_PROPERTY SCRIPT_BLOCK_NAME_PROPERTY SCRIPT_BLOCK_SCRIPT_PROPERTY SUBTASK_BLOCK_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_AFTER_FINISH_EVENT SUBTASK_BLOCK_ASSIGN_PARAMS_EVENT SUBTASK_BLOCK_ATTACHMENTS_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_GROUP_PROPERTY SUBTASK_BLOCK_ATTACHMENTS_RIGHTS_TYPE_PROPERTY SUBTASK_BLOCK_BEFORE_START_EVENT SUBTASK_BLOCK_CREATED_TASK_PROPERTY SUBTASK_BLOCK_CREATION_EVENT SUBTASK_BLOCK_DEADLINE_PROPERTY SUBTASK_BLOCK_IMPORTANCE_PROPERTY SUBTASK_BLOCK_INITIATOR_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_ABORT_DEADLINE_PROPERTY SUBTASK_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY SUBTASK_BLOCK_JOBS_TYPE_PROPERTY SUBTASK_BLOCK_NAME_PROPERTY SUBTASK_BLOCK_PARALLEL_ROUTE_PROPERTY SUBTASK_BLOCK_PERFORMERS_PROPERTY SUBTASK_BLOCK_RELATIVE_ABORT_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SUBTASK_BLOCK_REQUIRE_SIGN_PROPERTY SUBTASK_BLOCK_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_START_EVENT SUBTASK_BLOCK_STEP_CONTROL_PROPERTY SUBTASK_BLOCK_SUBJECT_PROPERTY SUBTASK_BLOCK_TASK_CONTROL_PROPERTY SUBTASK_BLOCK_TEXT_PROPERTY SUBTASK_BLOCK_UNLOCK_ATTACHMENTS_ON_STOP_PROPERTY SUBTASK_BLOCK_USE_STANDARD_ROUTE_PROPERTY SUBTASK_BLOCK_WAIT_FOR_TASK_COMPLETE_PROPERTY SYSCOMP_CONTROL_JOBS SYSCOMP_FOLDERS SYSCOMP_JOBS SYSCOMP_NOTICES SYSCOMP_TASKS SYSDLG_CREATE_EDOCUMENT SYSDLG_CREATE_EDOCUMENT_VERSION SYSDLG_CURRENT_PERIOD SYSDLG_EDIT_FUNCTION_HELP SYSDLG_EDOCUMENT_KINDS_FOR_TEMPLATE SYSDLG_EXPORT_MULTIPLE_EDOCUMENTS SYSDLG_EXPORT_SINGLE_EDOCUMENT SYSDLG_IMPORT_EDOCUMENT SYSDLG_MULTIPLE_SELECT SYSDLG_SETUP_ACCESS_RIGHTS SYSDLG_SETUP_DEFAULT_RIGHTS SYSDLG_SETUP_FILTER_CONDITION SYSDLG_SETUP_SIGN_RIGHTS SYSDLG_SETUP_TASK_OBSERVERS SYSDLG_SETUP_TASK_ROUTE SYSDLG_SETUP_USERS_LIST SYSDLG_SIGN_EDOCUMENT SYSDLG_SIGN_MULTIPLE_EDOCUMENTS SYSREF_ACCESS_RIGHTS_TYPES SYSREF_ADMINISTRATION_HISTORY SYSREF_ALL_AVAILABLE_COMPONENTS SYSREF_ALL_AVAILABLE_PRIVILEGES SYSREF_ALL_REPLICATING_COMPONENTS SYSREF_AVAILABLE_DEVELOPERS_COMPONENTS SYSREF_CALENDAR_EVENTS SYSREF_COMPONENT_TOKEN_HISTORY SYSREF_COMPONENT_TOKENS SYSREF_COMPONENTS SYSREF_CONSTANTS SYSREF_DATA_RECEIVE_PROTOCOL SYSREF_DATA_SEND_PROTOCOL SYSREF_DIALOGS SYSREF_DIALOGS_REQUISITES SYSREF_EDITORS SYSREF_EDOC_CARDS SYSREF_EDOC_TYPES SYSREF_EDOCUMENT_CARD_REQUISITES SYSREF_EDOCUMENT_CARD_TYPES SYSREF_EDOCUMENT_CARD_TYPES_REFERENCE SYSREF_EDOCUMENT_CARDS SYSREF_EDOCUMENT_HISTORY SYSREF_EDOCUMENT_KINDS SYSREF_EDOCUMENT_REQUISITES SYSREF_EDOCUMENT_SIGNATURES SYSREF_EDOCUMENT_TEMPLATES SYSREF_EDOCUMENT_TEXT_STORAGES SYSREF_EDOCUMENT_VIEWS SYSREF_FILTERER_SETUP_CONFLICTS SYSREF_FILTRATER_SETTING_CONFLICTS SYSREF_FOLDER_HISTORY SYSREF_FOLDERS SYSREF_FUNCTION_GROUPS SYSREF_FUNCTION_PARAMS SYSREF_FUNCTIONS SYSREF_JOB_HISTORY SYSREF_LINKS SYSREF_LOCALIZATION_DICTIONARY SYSREF_LOCALIZATION_LANGUAGES SYSREF_MODULES SYSREF_PRIVILEGES SYSREF_RECORD_HISTORY SYSREF_REFERENCE_REQUISITES SYSREF_REFERENCE_TYPE_VIEWS SYSREF_REFERENCE_TYPES SYSREF_REFERENCES SYSREF_REFERENCES_REQUISITES SYSREF_REMOTE_SERVERS SYSREF_REPLICATION_SESSIONS_LOG SYSREF_REPLICATION_SESSIONS_PROTOCOL SYSREF_REPORTS SYSREF_ROLES SYSREF_ROUTE_BLOCK_GROUPS SYSREF_ROUTE_BLOCKS SYSREF_SCRIPTS SYSREF_SEARCHES SYSREF_SERVER_EVENTS SYSREF_SERVER_EVENTS_HISTORY SYSREF_STANDARD_ROUTE_GROUPS SYSREF_STANDARD_ROUTES SYSREF_STATUSES SYSREF_SYSTEM_SETTINGS SYSREF_TASK_HISTORY SYSREF_TASK_KIND_GROUPS SYSREF_TASK_KINDS SYSREF_TASK_RIGHTS SYSREF_TASK_SIGNATURES SYSREF_TASKS SYSREF_UNITS SYSREF_USER_GROUPS SYSREF_USER_GROUPS_REFERENCE SYSREF_USER_SUBSTITUTION SYSREF_USERS SYSREF_USERS_REFERENCE SYSREF_VIEWERS SYSREF_WORKING_TIME_CALENDARS ACCESS_RIGHTS_TABLE_NAME EDMS_ACCESS_TABLE_NAME EDOC_TYPES_TABLE_NAME TEST_DEV_DB_NAME TEST_DEV_SYSTEM_CODE TEST_EDMS_DB_NAME TEST_EDMS_MAIN_CODE TEST_EDMS_MAIN_DB_NAME TEST_EDMS_SECOND_CODE TEST_EDMS_SECOND_DB_NAME TEST_EDMS_SYSTEM_CODE TEST_ISB5_MAIN_CODE TEST_ISB5_SECOND_CODE TEST_SQL_SERVER_2005_NAME TEST_SQL_SERVER_NAME ATTENTION_CAPTION cbsCommandLinks cbsDefault CONFIRMATION_CAPTION ERROR_CAPTION INFORMATION_CAPTION mrCancel mrOk EDOC_VERSION_ACTIVE_STAGE_CODE EDOC_VERSION_DESIGN_STAGE_CODE EDOC_VERSION_OBSOLETE_STAGE_CODE cpDataEnciphermentEnabled cpDigitalSignatureEnabled cpID cpIssuer cpPluginVersion cpSerial cpSubjectName cpSubjSimpleName cpValidFromDate cpValidToDate ISBL_SYNTAX NO_SYNTAX XML_SYNTAX WAIT_BLOCK_AFTER_FINISH_EVENT WAIT_BLOCK_BEFORE_START_EVENT WAIT_BLOCK_DEADLINE_PROPERTY WAIT_BLOCK_IS_RELATIVE_DEADLINE_PROPERTY WAIT_BLOCK_NAME_PROPERTY WAIT_BLOCK_RELATIVE_DEADLINE_TYPE_PROPERTY SYSRES_COMMON SYSRES_CONST SYSRES_MBFUNC SYSRES_SBDATA SYSRES_SBGUI SYSRES_SBINTF SYSRES_SBREFDSC SYSRES_SQLERRORS SYSRES_SYSCOMP atUser atGroup atRole aemEnabledAlways aemDisabledAlways aemEnabledOnBrowse aemEnabledOnEdit aemDisabledOnBrowseEmpty apBegin apEnd alLeft alRight asmNever asmNoButCustomize asmAsLastTime asmYesButCustomize asmAlways cirCommon cirRevoked ctSignature ctEncode ctSignatureEncode clbUnchecked clbChecked clbGrayed ceISB ceAlways ceNever ctDocument ctReference ctScript ctUnknown ctReport ctDialog ctFunction ctFolder ctEDocument ctTask ctJob ctNotice ctControlJob cfInternal cfDisplay ciUnspecified ciWrite ciRead ckFolder ckEDocument ckTask ckJob ckComponentToken ckAny ckReference ckScript ckReport ckDialog ctISBLEditor ctBevel ctButton ctCheckListBox ctComboBox ctComboEdit ctGrid ctDBCheckBox ctDBComboBox ctDBEdit ctDBEllipsis ctDBMemo ctDBNavigator ctDBRadioGroup ctDBStatusLabel ctEdit ctGroupBox ctInplaceHint ctMemo ctPanel ctListBox ctRadioButton ctRichEdit ctTabSheet ctWebBrowser ctImage ctHyperLink ctLabel ctDBMultiEllipsis ctRibbon ctRichView ctInnerPanel ctPanelGroup ctBitButton cctDate cctInteger cctNumeric cctPick cctReference cctString cctText cltInternal cltPrimary cltGUI dseBeforeOpen dseAfterOpen dseBeforeClose dseAfterClose dseOnValidDelete dseBeforeDelete dseAfterDelete dseAfterDeleteOutOfTransaction dseOnDeleteError dseBeforeInsert dseAfterInsert dseOnValidUpdate dseBeforeUpdate dseOnUpdateRatifiedRecord dseAfterUpdate dseAfterUpdateOutOfTransaction dseOnUpdateError dseAfterScroll dseOnOpenRecord dseOnCloseRecord dseBeforeCancel dseAfterCancel dseOnUpdateDeadlockError dseBeforeDetailUpdate dseOnPrepareUpdate dseOnAnyRequisiteChange dssEdit dssInsert dssBrowse dssInActive dftDate dftShortDate dftDateTime dftTimeStamp dotDays dotHours dotMinutes dotSeconds dtkndLocal dtkndUTC arNone arView arEdit arFull ddaView ddaEdit emLock emEdit emSign emExportWithLock emImportWithUnlock emChangeVersionNote emOpenForModify emChangeLifeStage emDelete emCreateVersion emImport emUnlockExportedWithLock emStart emAbort emReInit emMarkAsReaded emMarkAsUnreaded emPerform emAccept emResume emChangeRights emEditRoute emEditObserver emRecoveryFromLocalCopy emChangeWorkAccessType emChangeEncodeTypeToCertificate emChangeEncodeTypeToPassword emChangeEncodeTypeToNone emChangeEncodeTypeToCertificatePassword emChangeStandardRoute emGetText emOpenForView emMoveToStorage emCreateObject emChangeVersionHidden emDeleteVersion emChangeLifeCycleStage emApprovingSign emExport emContinue emLockFromEdit emUnLockForEdit emLockForServer emUnlockFromServer emDelegateAccessRights emReEncode ecotFile ecotProcess eaGet eaCopy eaCreate eaCreateStandardRoute edltAll edltNothing edltQuery essmText essmCard esvtLast esvtLastActive esvtSpecified edsfExecutive edsfArchive edstSQLServer edstFile edvstNone edvstEDocumentVersionCopy edvstFile edvstTemplate edvstScannedFile vsDefault vsDesign vsActive vsObsolete etNone etCertificate etPassword etCertificatePassword ecException ecWarning ecInformation estAll estApprovingOnly evtLast evtLastActive evtQuery fdtString fdtNumeric fdtInteger fdtDate fdtText fdtUnknown fdtWideString fdtLargeInteger ftInbox ftOutbox ftFavorites ftCommonFolder ftUserFolder ftComponents ftQuickLaunch ftShortcuts ftSearch grhAuto grhX1 grhX2 grhX3 hltText hltRTF hltHTML iffBMP iffJPEG iffMultiPageTIFF iffSinglePageTIFF iffTIFF iffPNG im8bGrayscale im24bRGB im1bMonochrome itBMP itJPEG itWMF itPNG ikhInformation ikhWarning ikhError ikhNoIcon icUnknown icScript icFunction icIntegratedReport icAnalyticReport icDataSetEventHandler icActionHandler icFormEventHandler icLookUpEventHandler icRequisiteChangeEventHandler icBeforeSearchEventHandler icRoleCalculation icSelectRouteEventHandler icBlockPropertyCalculation icBlockQueryParamsEventHandler icChangeSearchResultEventHandler icBlockEventHandler icSubTaskInitEventHandler icEDocDataSetEventHandler icEDocLookUpEventHandler icEDocActionHandler icEDocFormEventHandler icEDocRequisiteChangeEventHandler icStructuredConversionRule icStructuredConversionEventBefore icStructuredConversionEventAfter icWizardEventHandler icWizardFinishEventHandler icWizardStepEventHandler icWizardStepFinishEventHandler icWizardActionEnableEventHandler icWizardActionExecuteEventHandler icCreateJobsHandler icCreateNoticesHandler icBeforeLookUpEventHandler icAfterLookUpEventHandler icTaskAbortEventHandler icWorkflowBlockActionHandler icDialogDataSetEventHandler icDialogActionHandler icDialogLookUpEventHandler icDialogRequisiteChangeEventHandler icDialogFormEventHandler icDialogValidCloseEventHandler icBlockFormEventHandler icTaskFormEventHandler icReferenceMethod icEDocMethod icDialogMethod icProcessMessageHandler isShow isHide isByUserSettings jkJob jkNotice jkControlJob jtInner jtLeft jtRight jtFull jtCross lbpAbove lbpBelow lbpLeft lbpRight eltPerConnection eltPerUser sfcUndefined sfcBlack sfcGreen sfcRed sfcBlue sfcOrange sfcLilac sfsItalic sfsStrikeout sfsNormal ldctStandardRoute ldctWizard ldctScript ldctFunction ldctRouteBlock ldctIntegratedReport ldctAnalyticReport ldctReferenceType ldctEDocumentType ldctDialog ldctServerEvents mrcrtNone mrcrtUser mrcrtMaximal mrcrtCustom vtEqual vtGreaterOrEqual vtLessOrEqual vtRange rdYesterday rdToday rdTomorrow rdThisWeek rdThisMonth rdThisYear rdNextMonth rdNextWeek rdLastWeek rdLastMonth rdWindow rdFile rdPrinter rdtString rdtNumeric rdtInteger rdtDate rdtReference rdtAccount rdtText rdtPick rdtUnknown rdtLargeInteger rdtDocument reOnChange reOnChangeValues ttGlobal ttLocal ttUser ttSystem ssmBrowse ssmSelect ssmMultiSelect ssmBrowseModal smSelect smLike smCard stNone stAuthenticating stApproving sctString sctStream sstAnsiSort sstNaturalSort svtEqual svtContain soatString soatNumeric soatInteger soatDatetime soatReferenceRecord soatText soatPick soatBoolean soatEDocument soatAccount soatIntegerCollection soatNumericCollection soatStringCollection soatPickCollection soatDatetimeCollection soatBooleanCollection soatReferenceRecordCollection soatEDocumentCollection soatAccountCollection soatContents soatUnknown tarAbortByUser tarAbortByWorkflowException tvtAllWords tvtExactPhrase tvtAnyWord usNone usCompleted usRedSquare usBlueSquare usYellowSquare usGreenSquare usOrangeSquare usPurpleSquare usFollowUp utUnknown utUser utDeveloper utAdministrator utSystemDeveloper utDisconnected btAnd btDetailAnd btOr btNotOr btOnly vmView vmSelect vmNavigation vsmSingle vsmMultiple vsmMultipleCheck vsmNoSelection wfatPrevious wfatNext wfatCancel wfatFinish wfepUndefined wfepText3 wfepText6 wfepText9 wfepSpinEdit wfepDropDown wfepRadioGroup wfepFlag wfepText12 wfepText15 wfepText18 wfepText21 wfepText24 wfepText27 wfepText30 wfepRadioGroupColumn1 wfepRadioGroupColumn2 wfepRadioGroupColumn3 wfetQueryParameter wfetText wfetDelimiter wfetLabel wptString wptInteger wptNumeric wptBoolean wptDateTime wptPick wptText wptUser wptUserList wptEDocumentInfo wptEDocumentInfoList wptReferenceRecordInfo wptReferenceRecordInfoList wptFolderInfo wptTaskInfo wptContents wptFileName wptDate wsrComplete wsrGoNext wsrGoPrevious wsrCustom wsrCancel wsrGoFinal wstForm wstEDocument wstTaskCard wstReferenceRecordCard wstFinal waAll waPerformers waManual wsbStart wsbFinish wsbNotice wsbStep wsbDecision wsbWait wsbMonitor wsbScript wsbConnector wsbSubTask wsbLifeCycleStage wsbPause wdtInteger wdtFloat wdtString wdtPick wdtDateTime wdtBoolean wdtTask wdtJob wdtFolder wdtEDocument wdtReferenceRecord wdtUser wdtGroup wdtRole wdtIntegerCollection wdtFloatCollection wdtStringCollection wdtPickCollection wdtDateTimeCollection wdtBooleanCollection wdtTaskCollection wdtJobCollection wdtFolderCollection wdtEDocumentCollection wdtReferenceRecordCollection wdtUserCollection wdtGroupCollection wdtRoleCollection wdtContents wdtUserList wdtSearchDescription wdtDeadLine wdtPickSet wdtAccountCollection wiLow wiNormal wiHigh wrtSoft wrtHard wsInit wsRunning wsDone wsControlled wsAborted wsContinued wtmFull wtmFromCurrent wtmOnlyCurrent ",
            class: "AltState Application CallType ComponentTokens CreatedJobs CreatedNotices ControlState DialogResult Dialogs EDocuments EDocumentVersionSource Folders GlobalIDs Job Jobs InputValue LookUpReference LookUpRequisiteNames LookUpSearch Object ParentComponent Processes References Requisite ReportName Reports Result Scripts Searches SelectedAttachments SelectedItems SelectMode Sender ServerEvents ServiceFactory ShiftState SubTask SystemDialogs Tasks Wizard Wizards Work \u0412\u044B\u0437\u043E\u0432\u0421\u043F\u043E\u0441\u043E\u0431 \u0418\u043C\u044F\u041E\u0442\u0447\u0435\u0442\u0430 \u0420\u0435\u043A\u0432\u0417\u043D\u0430\u0447 ",
            literal: "null true false nil "
        }, s = {
            begin: "\\.\\s*" + e.UNDERSCORE_IDENT_RE,
            keywords: o,
            relevance: 0
        }, l = {
            className: "type",
            begin: ":[ \\t]*(" + "IApplication IAccessRights IAccountRepository IAccountSelectionRestrictions IAction IActionList IAdministrationHistoryDescription IAnchors IApplication IArchiveInfo IAttachment IAttachmentList ICheckListBox ICheckPointedList IColumn IComponent IComponentDescription IComponentToken IComponentTokenFactory IComponentTokenInfo ICompRecordInfo IConnection IContents IControl IControlJob IControlJobInfo IControlList ICrypto ICrypto2 ICustomJob ICustomJobInfo ICustomListBox ICustomObjectWizardStep ICustomWork ICustomWorkInfo IDataSet IDataSetAccessInfo IDataSigner IDateCriterion IDateRequisite IDateRequisiteDescription IDateValue IDeaAccessRights IDeaObjectInfo IDevelopmentComponentLock IDialog IDialogFactory IDialogPickRequisiteItems IDialogsFactory IDICSFactory IDocRequisite IDocumentInfo IDualListDialog IECertificate IECertificateInfo IECertificates IEditControl IEditorForm IEdmsExplorer IEdmsObject IEdmsObjectDescription IEdmsObjectFactory IEdmsObjectInfo IEDocument IEDocumentAccessRights IEDocumentDescription IEDocumentEditor IEDocumentFactory IEDocumentInfo IEDocumentStorage IEDocumentVersion IEDocumentVersionListDialog IEDocumentVersionSource IEDocumentWizardStep IEDocVerSignature IEDocVersionState IEnabledMode IEncodeProvider IEncrypter IEvent IEventList IException IExternalEvents IExternalHandler IFactory IField IFileDialog IFolder IFolderDescription IFolderDialog IFolderFactory IFolderInfo IForEach IForm IFormTitle IFormWizardStep IGlobalIDFactory IGlobalIDInfo IGrid IHasher IHistoryDescription IHyperLinkControl IImageButton IImageControl IInnerPanel IInplaceHint IIntegerCriterion IIntegerList IIntegerRequisite IIntegerValue IISBLEditorForm IJob IJobDescription IJobFactory IJobForm IJobInfo ILabelControl ILargeIntegerCriterion ILargeIntegerRequisite ILargeIntegerValue ILicenseInfo ILifeCycleStage IList IListBox ILocalIDInfo ILocalization ILock IMemoryDataSet IMessagingFactory IMetadataRepository INotice INoticeInfo INumericCriterion INumericRequisite INumericValue IObject IObjectDescription IObjectImporter IObjectInfo IObserver IPanelGroup IPickCriterion IPickProperty IPickRequisite IPickRequisiteDescription IPickRequisiteItem IPickRequisiteItems IPickValue IPrivilege IPrivilegeList IProcess IProcessFactory IProcessMessage IProgress IProperty IPropertyChangeEvent IQuery IReference IReferenceCriterion IReferenceEnabledMode IReferenceFactory IReferenceHistoryDescription IReferenceInfo IReferenceRecordCardWizardStep IReferenceRequisiteDescription IReferencesFactory IReferenceValue IRefRequisite IReport IReportFactory IRequisite IRequisiteDescription IRequisiteDescriptionList IRequisiteFactory IRichEdit IRouteStep IRule IRuleList ISchemeBlock IScript IScriptFactory ISearchCriteria ISearchCriterion ISearchDescription ISearchFactory ISearchFolderInfo ISearchForObjectDescription ISearchResultRestrictions ISecuredContext ISelectDialog IServerEvent IServerEventFactory IServiceDialog IServiceFactory ISignature ISignProvider ISignProvider2 ISignProvider3 ISimpleCriterion IStringCriterion IStringList IStringRequisite IStringRequisiteDescription IStringValue ISystemDialogsFactory ISystemInfo ITabSheet ITask ITaskAbortReasonInfo ITaskCardWizardStep ITaskDescription ITaskFactory ITaskInfo ITaskRoute ITextCriterion ITextRequisite ITextValue ITreeListSelectDialog IUser IUserList IValue IView IWebBrowserControl IWizard IWizardAction IWizardFactory IWizardFormElement IWizardParam IWizardPickParam IWizardReferenceParam IWizardStep IWorkAccessRights IWorkDescription IWorkflowAskableParam IWorkflowAskableParams IWorkflowBlock IWorkflowBlockResult IWorkflowEnabledMode IWorkflowParam IWorkflowPickParam IWorkflowReferenceParam IWorkState IWorkTreeCustomNode IWorkTreeJobNode IWorkTreeTaskNode IXMLEditorForm SBCrypto ".trim().replace(/\s/g, "|") + ")",
            end: "[ \\t]*=",
            excludeEnd: !0
        }, c = {
            className: "variable",
            keywords: o,
            begin: t,
            relevance: 0,
            contains: [
                l,
                s
            ]
        }, _ = "[A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_][A-Za-z\u0410-\u042F\u0430-\u044F\u0451\u0401_0-9]*\\(";
        return {
            name: "ISBL",
            case_insensitive: !0,
            keywords: o,
            illegal: "\\$|\\?|%|,|;$|~|#|@|</",
            contains: [
                {
                    className: "function",
                    begin: _,
                    end: "\\)$",
                    returnBegin: !0,
                    keywords: o,
                    illegal: "[\\[\\]\\|\\$\\?%,~#@]",
                    contains: [
                        {
                            className: "title",
                            keywords: {
                                $pattern: t,
                                built_in: "AddSubString AdjustLineBreaks AmountInWords Analysis ArrayDimCount ArrayHighBound ArrayLowBound ArrayOf ArrayReDim Assert Assigned BeginOfMonth BeginOfPeriod BuildProfilingOperationAnalysis CallProcedure CanReadFile CArrayElement CDataSetRequisite ChangeDate ChangeReferenceDataset Char CharPos CheckParam CheckParamValue CompareStrings ConstantExists ControlState ConvertDateStr Copy CopyFile CreateArray CreateCachedReference CreateConnection CreateDialog CreateDualListDialog CreateEditor CreateException CreateFile CreateFolderDialog CreateInputDialog CreateLinkFile CreateList CreateLock CreateMemoryDataSet CreateObject CreateOpenDialog CreateProgress CreateQuery CreateReference CreateReport CreateSaveDialog CreateScript CreateSQLPivotFunction CreateStringList CreateTreeListSelectDialog CSelectSQL CSQL CSubString CurrentUserID CurrentUserName CurrentVersion DataSetLocateEx DateDiff DateTimeDiff DateToStr DayOfWeek DeleteFile DirectoryExists DisableCheckAccessRights DisableCheckFullShowingRestriction DisableMassTaskSendingRestrictions DropTable DupeString EditText EnableCheckAccessRights EnableCheckFullShowingRestriction EnableMassTaskSendingRestrictions EndOfMonth EndOfPeriod ExceptionExists ExceptionsOff ExceptionsOn Execute ExecuteProcess Exit ExpandEnvironmentVariables ExtractFileDrive ExtractFileExt ExtractFileName ExtractFilePath ExtractParams FileExists FileSize FindFile FindSubString FirmContext ForceDirectories Format FormatDate FormatNumeric FormatSQLDate FormatString FreeException GetComponent GetComponentLaunchParam GetConstant GetLastException GetReferenceRecord GetRefTypeByRefID GetTableID GetTempFolder IfThen In IndexOf InputDialog InputDialogEx InteractiveMode IsFileLocked IsGraphicFile IsNumeric Length LoadString LoadStringFmt LocalTimeToUTC LowerCase Max MessageBox MessageBoxEx MimeDecodeBinary MimeDecodeString MimeEncodeBinary MimeEncodeString Min MoneyInWords MoveFile NewID Now OpenFile Ord Precision Raise ReadCertificateFromFile ReadFile ReferenceCodeByID ReferenceNumber ReferenceRequisiteMode ReferenceRequisiteValue RegionDateSettings RegionNumberSettings RegionTimeSettings RegRead RegWrite RenameFile Replace Round SelectServerCode SelectSQL ServerDateTime SetConstant SetManagedFolderFieldsState ShowConstantsInputDialog ShowMessage Sleep Split SQL SQL2XLSTAB SQLProfilingSendReport StrToDate SubString SubStringCount SystemSetting Time TimeDiff Today Transliterate Trim UpperCase UserStatus UTCToLocalTime ValidateXML VarIsClear VarIsEmpty VarIsNull WorkTimeDiff WriteFile WriteFileEx WriteObjectHistory \u0410\u043D\u0430\u043B\u0438\u0437 \u0411\u0430\u0437\u0430\u0414\u0430\u043D\u043D\u044B\u0445 \u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C \u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C\u0420\u0430\u0441\u0448 \u0411\u043B\u043E\u043A\u0418\u043D\u0444\u043E \u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C \u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C\u0420\u0430\u0441\u0448 \u0411\u043B\u043E\u043A\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0412\u0432\u043E\u0434 \u0412\u0432\u043E\u0434\u041C\u0435\u043D\u044E \u0412\u0435\u0434\u0421 \u0412\u0435\u0434\u0421\u043F\u0440 \u0412\u0435\u0440\u0445\u043D\u044F\u044F\u0413\u0440\u0430\u043D\u0438\u0446\u0430\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0412\u043D\u0435\u0448\u041F\u0440\u043E\u0433\u0440 \u0412\u043E\u0441\u0441\u0442 \u0412\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F\u041F\u0430\u043F\u043A\u0430 \u0412\u0440\u0435\u043C\u044F \u0412\u044B\u0431\u043E\u0440SQL \u0412\u044B\u0431\u0440\u0430\u0442\u044C\u0417\u0430\u043F\u0438\u0441\u044C \u0412\u044B\u0434\u0435\u043B\u0438\u0442\u044C\u0421\u0442\u0440 \u0412\u044B\u0437\u0432\u0430\u0442\u044C \u0412\u044B\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0412\u044B\u043F\u041F\u0440\u043E\u0433\u0440 \u0413\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u0438\u0439\u0424\u0430\u0439\u043B \u0413\u0440\u0443\u043F\u043F\u0430\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0414\u0430\u0442\u0430\u0412\u0440\u0435\u043C\u044F\u0421\u0435\u0440\u0432 \u0414\u0435\u043D\u044C\u041D\u0435\u0434\u0435\u043B\u0438 \u0414\u0438\u0430\u043B\u043E\u0433\u0414\u0430\u041D\u0435\u0442 \u0414\u043B\u0438\u043D\u0430\u0421\u0442\u0440 \u0414\u043E\u0431\u041F\u043E\u0434\u0441\u0442\u0440 \u0415\u041F\u0443\u0441\u0442\u043E \u0415\u0441\u043B\u0438\u0422\u043E \u0415\u0427\u0438\u0441\u043B\u043E \u0417\u0430\u043C\u041F\u043E\u0434\u0441\u0442\u0440 \u0417\u0430\u043F\u0438\u0441\u044C\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0417\u043D\u0430\u0447\u041F\u043E\u043B\u044F\u0421\u043F\u0440 \u0418\u0414\u0422\u0438\u043F\u0421\u043F\u0440 \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0414\u0438\u0441\u043A \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0418\u043C\u044F\u0424\u0430\u0439\u043B\u0430 \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u041F\u0443\u0442\u044C \u0418\u0437\u0432\u043B\u0435\u0447\u044C\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0418\u0437\u043C\u0414\u0430\u0442 \u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C\u0420\u0430\u0437\u043C\u0435\u0440\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0418\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u0418\u043C\u044F\u041E\u0440\u0433 \u0418\u043C\u044F\u041F\u043E\u043B\u044F\u0421\u043F\u0440 \u0418\u043D\u0434\u0435\u043A\u0441 \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440\u0428\u0430\u0433 \u0418\u043D\u0442\u0435\u0440\u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439\u0420\u0435\u0436\u0438\u043C \u0418\u0442\u043E\u0433\u0422\u0431\u043B\u0421\u043F\u0440 \u041A\u043E\u0434\u0412\u0438\u0434\u0412\u0435\u0434\u0421\u043F\u0440 \u041A\u043E\u0434\u0412\u0438\u0434\u0421\u043F\u0440\u041F\u043E\u0418\u0414 \u041A\u043E\u0434\u041F\u043EAnalit \u041A\u043E\u0434\u0421\u0438\u043C\u0432\u043E\u043B\u0430 \u041A\u043E\u0434\u0421\u043F\u0440 \u041A\u043E\u043B\u041F\u043E\u0434\u0441\u0442\u0440 \u041A\u043E\u043B\u041F\u0440\u043E\u043F \u041A\u043E\u043D\u041C\u0435\u0441 \u041A\u043E\u043D\u0441\u0442 \u041A\u043E\u043D\u0441\u0442\u0415\u0441\u0442\u044C \u041A\u043E\u043D\u0441\u0442\u0417\u043D\u0430\u0447 \u041A\u043E\u043D\u0422\u0440\u0430\u043D \u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0424\u0430\u0439\u043B \u041A\u043E\u043F\u0438\u044F\u0421\u0442\u0440 \u041A\u041F\u0435\u0440\u0438\u043E\u0434 \u041A\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u041C\u0430\u043A\u0441 \u041C\u0430\u043A\u0441\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u041C\u0430\u0441\u0441\u0438\u0432 \u041C\u0435\u043D\u044E \u041C\u0435\u043D\u044E\u0420\u0430\u0441\u0448 \u041C\u0438\u043D \u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445\u041D\u0430\u0439\u0442\u0438\u0420\u0430\u0441\u0448 \u041D\u0430\u0438\u043C\u0412\u0438\u0434\u0421\u043F\u0440 \u041D\u0430\u0438\u043C\u041F\u043EAnalit \u041D\u0430\u0438\u043C\u0421\u043F\u0440 \u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C\u041F\u0435\u0440\u0435\u0432\u043E\u0434\u044B\u0421\u0442\u0440\u043E\u043A \u041D\u0430\u0447\u041C\u0435\u0441 \u041D\u0430\u0447\u0422\u0440\u0430\u043D \u041D\u0438\u0436\u043D\u044F\u044F\u0413\u0440\u0430\u043D\u0438\u0446\u0430\u041C\u0430\u0441\u0441\u0438\u0432\u0430 \u041D\u043E\u043C\u0435\u0440\u0421\u043F\u0440 \u041D\u041F\u0435\u0440\u0438\u043E\u0434 \u041E\u043A\u043D\u043E \u041E\u043A\u0440 \u041E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u0435 \u041E\u0442\u043B\u0418\u043D\u0444\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u041E\u0442\u043B\u0418\u043D\u0444\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u041E\u0442\u0447\u0435\u0442 \u041E\u0442\u0447\u0435\u0442\u0410\u043D\u0430\u043B \u041E\u0442\u0447\u0435\u0442\u0418\u043D\u0442 \u041F\u0430\u043F\u043A\u0430\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u041F\u0430\u0443\u0437\u0430 \u041F\u0412\u044B\u0431\u043E\u0440SQL \u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C\u0424\u0430\u0439\u043B \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435 \u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C\u0424\u0430\u0439\u043B \u041F\u043E\u0434\u0441\u0442\u0440 \u041F\u043E\u0438\u0441\u043A\u041F\u043E\u0434\u0441\u0442\u0440 \u041F\u043E\u0438\u0441\u043A\u0421\u0442\u0440 \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C\u0418\u0414\u0422\u0430\u0431\u043B\u0438\u0446\u044B \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0418\u0414 \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0418\u043C\u044F \u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0421\u0442\u0430\u0442\u0443\u0441 \u041F\u0440\u0435\u0440\u0432\u0430\u0442\u044C \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440 \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0417\u043D\u0430\u0447 \u041F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C\u0423\u0441\u043B\u043E\u0432\u0438\u0435 \u0420\u0430\u0437\u0431\u0421\u0442\u0440 \u0420\u0430\u0437\u043D\u0412\u0440\u0435\u043C\u044F \u0420\u0430\u0437\u043D\u0414\u0430\u0442 \u0420\u0430\u0437\u043D\u0414\u0430\u0442\u0430\u0412\u0440\u0435\u043C\u044F \u0420\u0430\u0437\u043D\u0420\u0430\u0431\u0412\u0440\u0435\u043C\u044F \u0420\u0435\u0433\u0423\u0441\u0442\u0412\u0440\u0435\u043C \u0420\u0435\u0433\u0423\u0441\u0442\u0414\u0430\u0442 \u0420\u0435\u0433\u0423\u0441\u0442\u0427\u0441\u043B \u0420\u0435\u0434\u0422\u0435\u043A\u0441\u0442 \u0420\u0435\u0435\u0441\u0442\u0440\u0417\u0430\u043F\u0438\u0441\u044C \u0420\u0435\u0435\u0441\u0442\u0440\u0421\u043F\u0438\u0441\u043E\u043A\u0418\u043C\u0435\u043D\u041F\u0430\u0440\u0430\u043C \u0420\u0435\u0435\u0441\u0442\u0440\u0427\u0442\u0435\u043D\u0438\u0435 \u0420\u0435\u043A\u0432\u0421\u043F\u0440 \u0420\u0435\u043A\u0432\u0421\u043F\u0440\u041F\u0440 \u0421\u0435\u0433\u043E\u0434\u043D\u044F \u0421\u0435\u0439\u0447\u0430\u0441 \u0421\u0435\u0440\u0432\u0435\u0440 \u0421\u0435\u0440\u0432\u0435\u0440\u041F\u0440\u043E\u0446\u0435\u0441\u0441\u0418\u0414 \u0421\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0424\u0430\u0439\u043B\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0421\u0436\u041F\u0440\u043E\u0431 \u0421\u0438\u043C\u0432\u043E\u043B \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u0414\u0438\u0440\u0435\u043A\u0442\u0443\u043C\u041A\u043E\u0434 \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0421\u0438\u0441\u0442\u0435\u043C\u0430\u041A\u043E\u0434 \u0421\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0412\u044B\u0431\u043E\u0440\u0430\u0418\u0437\u0414\u0432\u0443\u0445\u0421\u043F\u0438\u0441\u043A\u043E\u0432 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0412\u044B\u0431\u043E\u0440\u0430\u041F\u0430\u043F\u043A\u0438 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u041E\u0442\u043A\u0440\u044B\u0442\u0438\u044F\u0424\u0430\u0439\u043B\u0430 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0414\u0438\u0430\u043B\u043E\u0433\u0421\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F\u0424\u0430\u0439\u043B\u0430 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0417\u0430\u043F\u0440\u043E\u0441 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0418\u043D\u0434\u0438\u043A\u0430\u0442\u043E\u0440 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0418\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041A\u044D\u0448\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041C\u0430\u0441\u0441\u0438\u0432 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041E\u0431\u044A\u0435\u043A\u0442 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041E\u0442\u0447\u0435\u0442 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u041F\u0430\u043F\u043A\u0443 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0438\u0441\u043E\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0438\u0441\u043E\u043A\u0421\u0442\u0440\u043E\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043E\u0437\u0434\u0430\u0442\u044C\u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439 \u0421\u043E\u0437\u0434\u0421\u043F\u0440 \u0421\u043E\u0441\u0442\u0421\u043F\u0440 \u0421\u043E\u0445\u0440 \u0421\u043E\u0445\u0440\u0421\u043F\u0440 \u0421\u043F\u0438\u0441\u043E\u043A\u0421\u0438\u0441\u0442\u0435\u043C \u0421\u043F\u0440 \u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0415\u0441\u0442\u044C \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0421\u043D\u044F\u0442\u044C\u0420\u0430\u0441\u0448 \u0421\u043F\u0440\u0411\u043B\u043E\u043A\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0421\u043F\u0440\u0418\u0437\u043C\u041D\u0430\u0431\u0414\u0430\u043D \u0421\u043F\u0440\u041A\u043E\u0434 \u0421\u043F\u0440\u041D\u043E\u043C\u0435\u0440 \u0421\u043F\u0440\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0421\u043F\u0440\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0421\u043F\u0440\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0421\u043F\u0440\u041F\u0430\u0440\u0430\u043C \u0421\u043F\u0440\u041F\u043E\u043B\u0435\u0417\u043D\u0430\u0447 \u0421\u043F\u0440\u041F\u043E\u043B\u0435\u0418\u043C\u044F \u0421\u043F\u0440\u0420\u0435\u043A\u0432 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0412\u0432\u0435\u0434\u0417\u043D \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041D\u043E\u0432\u044B\u0435 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041F\u0440 \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u041F\u0440\u0435\u0434\u0417\u043D \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0420\u0435\u0436\u0438\u043C \u0421\u043F\u0440\u0420\u0435\u043A\u0432\u0422\u0438\u043F\u0422\u0435\u043A\u0441\u0442 \u0421\u043F\u0440\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0421\u043F\u0440\u0421\u043E\u0441\u0442 \u0421\u043F\u0440\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0421\u043F\u0440\u0422\u0431\u043B\u0418\u0442\u043E\u0433 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041A\u043E\u043B \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041C\u0430\u043A\u0441 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041C\u0438\u043D \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u041F\u0440\u0435\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0421\u043B\u0435\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0421\u043E\u0437\u0434 \u0421\u043F\u0440\u0422\u0431\u043B\u0421\u0442\u0440\u0423\u0434 \u0421\u043F\u0440\u0422\u0435\u043A\u041F\u0440\u0435\u0434\u0441\u0442 \u0421\u043F\u0440\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0421\u0440\u0430\u0432\u043D\u0438\u0442\u044C\u0421\u0442\u0440 \u0421\u0442\u0440\u0412\u0435\u0440\u0445\u0420\u0435\u0433\u0438\u0441\u0442\u0440 \u0421\u0442\u0440\u041D\u0438\u0436\u043D\u0420\u0435\u0433\u0438\u0441\u0442\u0440 \u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u0421\u0443\u043C\u041F\u0440\u043E\u043F \u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439 \u0421\u0446\u0435\u043D\u0430\u0440\u0438\u0439\u041F\u0430\u0440\u0430\u043C \u0422\u0435\u043A\u0412\u0435\u0440\u0441\u0438\u044F \u0422\u0435\u043A\u041E\u0440\u0433 \u0422\u043E\u0447\u043D \u0422\u0440\u0430\u043D \u0422\u0440\u0430\u043D\u0441\u043B\u0438\u0442\u0435\u0440\u0430\u0446\u0438\u044F \u0423\u0434\u0430\u043B\u0438\u0442\u044C\u0422\u0430\u0431\u043B\u0438\u0446\u0443 \u0423\u0434\u0430\u043B\u0438\u0442\u044C\u0424\u0430\u0439\u043B \u0423\u0434\u0421\u043F\u0440 \u0423\u0434\u0421\u0442\u0440\u0422\u0431\u043B\u0421\u043F\u0440 \u0423\u0441\u0442 \u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438\u041A\u043E\u043D\u0441\u0442\u0430\u043D\u0442 \u0424\u0430\u0439\u043B\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u0412\u0440\u0435\u043C\u044F \u0424\u0430\u0439\u043B\u0412\u0440\u0435\u043C\u044F\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0417\u0430\u043D\u044F\u0442 \u0424\u0430\u0439\u043B\u0417\u0430\u043F\u0438\u0441\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0418\u0441\u043A\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041C\u043E\u0436\u043D\u043E\u0427\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u0438\u043C\u0435\u043D\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u043A\u043E\u0434\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0424\u0430\u0439\u043B\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0424\u0430\u0439\u043B\u0420\u0430\u0437\u043C\u0435\u0440 \u0424\u0430\u0439\u043B\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0421\u0441\u044B\u043B\u043A\u0430\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442 \u0424\u0430\u0439\u043B\u0421\u0447\u0438\u0442\u0430\u0442\u044C \u0424\u0430\u0439\u043B\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0424\u043C\u0442SQL\u0414\u0430\u0442 \u0424\u043C\u0442\u0414\u0430\u0442 \u0424\u043C\u0442\u0421\u0442\u0440 \u0424\u043C\u0442\u0427\u0441\u043B \u0424\u043E\u0440\u043C\u0430\u0442 \u0426\u041C\u0430\u0441\u0441\u0438\u0432\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u0426\u041D\u0430\u0431\u043E\u0440\u0414\u0430\u043D\u043D\u044B\u0445\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0442 \u0426\u041F\u043E\u0434\u0441\u0442\u0440 "
                            },
                            begin: _,
                            end: "\\(",
                            returnBegin: !0,
                            excludeEnd: !0
                        },
                        s,
                        c,
                        n,
                        a,
                        r
                    ]
                },
                l,
                s,
                c,
                n,
                a,
                r
            ]
        };
    }), Cn)), Cs.registerLanguage("java", function() {
        if (Nn) return Rn;
        Nn = 1;
        var e = "[0-9](_*[0-9])*", t = `\\.(${e})`, a = "[0-9a-fA-F](_*[0-9a-fA-F])*", n = {
            className: "number",
            variants: [
                {
                    begin: `(\\b(${e})((${t})|\\.)?|(${t}))[eE][+-]?(${e})[fFdD]?\\b`
                },
                {
                    begin: `\\b(${e})((${t})[fFdD]?\\b|\\.([fFdD]\\b)?)`
                },
                {
                    begin: `(${t})[fFdD]?\\b`
                },
                {
                    begin: `\\b(${e})[fFdD]\\b`
                },
                {
                    begin: `\\b0[xX]((${a})\\.?|(${a})?\\.(${a}))[pP][+-]?(${e})[fFdD]?\\b`
                },
                {
                    begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b"
                },
                {
                    begin: `\\b0[xX](${a})[lL]?\\b`
                },
                {
                    begin: "\\b0(_*[0-7])*[lL]?\\b"
                },
                {
                    begin: "\\b0[bB][01](_*[01])*[lL]?\\b"
                }
            ],
            relevance: 0
        };
        function i(e, t, a) {
            return -1 === a ? "" : e.replace(t, (n)=>i(e, t, a - 1));
        }
        return Rn = function(e) {
            const t = e.regex, a = "[\xc0-\u02B8a-zA-Z_$][\xc0-\u02B8a-zA-Z_$0-9]*", r = a + i("(?:<" + a + "~~~(?:\\s*,\\s*" + a + "~~~)*>)?", /~~~/g, 2), o = {
                keyword: [
                    "synchronized",
                    "abstract",
                    "private",
                    "var",
                    "static",
                    "if",
                    "const ",
                    "for",
                    "while",
                    "strictfp",
                    "finally",
                    "protected",
                    "import",
                    "native",
                    "final",
                    "void",
                    "enum",
                    "else",
                    "break",
                    "transient",
                    "catch",
                    "instanceof",
                    "volatile",
                    "case",
                    "assert",
                    "package",
                    "default",
                    "public",
                    "try",
                    "switch",
                    "continue",
                    "throws",
                    "protected",
                    "public",
                    "private",
                    "module",
                    "requires",
                    "exports",
                    "do",
                    "sealed",
                    "yield",
                    "permits"
                ],
                literal: [
                    "false",
                    "true",
                    "null"
                ],
                type: [
                    "char",
                    "boolean",
                    "long",
                    "float",
                    "int",
                    "byte",
                    "short",
                    "double"
                ],
                built_in: [
                    "super",
                    "this"
                ]
            }, s = {
                className: "meta",
                begin: "@" + a,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            "self"
                        ]
                    }
                ]
            }, l = {
                className: "params",
                begin: /\(/,
                end: /\)/,
                keywords: o,
                relevance: 0,
                contains: [
                    e.C_BLOCK_COMMENT_MODE
                ],
                endsParent: !0
            };
            return {
                name: "Java",
                aliases: [
                    "jsp"
                ],
                keywords: o,
                illegal: /<\/|#/,
                contains: [
                    e.COMMENT("/\\*\\*", "\\*/", {
                        relevance: 0,
                        contains: [
                            {
                                begin: /\w+@/,
                                relevance: 0
                            },
                            {
                                className: "doctag",
                                begin: "@[A-Za-z]+"
                            }
                        ]
                    }),
                    {
                        begin: /import java\.[a-z]+\./,
                        keywords: "import",
                        relevance: 2
                    },
                    e.C_LINE_COMMENT_MODE,
                    e.C_BLOCK_COMMENT_MODE,
                    {
                        begin: /"""/,
                        end: /"""/,
                        className: "string",
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    e.APOS_STRING_MODE,
                    e.QUOTE_STRING_MODE,
                    {
                        match: [
                            /\b(?:class|interface|enum|extends|implements|new)/,
                            /\s+/,
                            a
                        ],
                        className: {
                            1: "keyword",
                            3: "title.class"
                        }
                    },
                    {
                        match: /non-sealed/,
                        scope: "keyword"
                    },
                    {
                        begin: [
                            t.concat(/(?!else)/, a),
                            /\s+/,
                            a,
                            /\s+/,
                            /=(?!=)/
                        ],
                        className: {
                            1: "type",
                            3: "variable",
                            5: "operator"
                        }
                    },
                    {
                        begin: [
                            /record/,
                            /\s+/,
                            a
                        ],
                        className: {
                            1: "keyword",
                            3: "title.class"
                        },
                        contains: [
                            l,
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    {
                        beginKeywords: "new throw return else",
                        relevance: 0
                    },
                    {
                        begin: [
                            "(?:" + r + "\\s+)",
                            e.UNDERSCORE_IDENT_RE,
                            /\s*(?=\()/
                        ],
                        className: {
                            2: "title.function"
                        },
                        keywords: o,
                        contains: [
                            {
                                className: "params",
                                begin: /\(/,
                                end: /\)/,
                                keywords: o,
                                relevance: 0,
                                contains: [
                                    s,
                                    e.APOS_STRING_MODE,
                                    e.QUOTE_STRING_MODE,
                                    n,
                                    e.C_BLOCK_COMMENT_MODE
                                ]
                            },
                            e.C_LINE_COMMENT_MODE,
                            e.C_BLOCK_COMMENT_MODE
                        ]
                    },
                    n,
                    s
                ]
            };
        }, Rn;
    }()), Cs.registerLanguage("javascript", function() {
        if (hn) return On;
        hn = 1;
        const e = "[A-Za-z$_][0-9A-Za-z$_]*", t = [
            "as",
            "in",
            "of",
            "if",
            "for",
            "while",
            "finally",
            "var",
            "new",
            "function",
            "do",
            "return",
            "void",
            "else",
            "break",
            "catch",
            "instanceof",
            "with",
            "throw",
            "case",
            "default",
            "try",
            "switch",
            "continue",
            "typeof",
            "delete",
            "let",
            "yield",
            "const",
            "class",
            "debugger",
            "async",
            "await",
            "static",
            "import",
            "from",
            "export",
            "extends"
        ], a = [
            "true",
            "false",
            "null",
            "undefined",
            "NaN",
            "Infinity"
        ], n = [
            "Object",
            "Function",
            "Boolean",
            "Symbol",
            "Math",
            "Date",
            "Number",
            "BigInt",
            "String",
            "RegExp",
            "Array",
            "Float32Array",
            "Float64Array",
            "Int8Array",
            "Uint8Array",
            "Uint8ClampedArray",
            "Int16Array",
            "Int32Array",
            "Uint16Array",
            "Uint32Array",
            "BigInt64Array",
            "BigUint64Array",
            "Set",
            "Map",
            "WeakSet",
            "WeakMap",
            "ArrayBuffer",
            "SharedArrayBuffer",
            "Atomics",
            "DataView",
            "JSON",
            "Promise",
            "Generator",
            "GeneratorFunction",
            "AsyncFunction",
            "Reflect",
            "Proxy",
            "Intl",
            "WebAssembly"
        ], i = [
            "Error",
            "EvalError",
            "InternalError",
            "RangeError",
            "ReferenceError",
            "SyntaxError",
            "TypeError",
            "URIError"
        ], r = [
            "setInterval",
            "setTimeout",
            "clearInterval",
            "clearTimeout",
            "require",
            "exports",
            "eval",
            "isFinite",
            "isNaN",
            "parseFloat",
            "parseInt",
            "decodeURI",
            "decodeURIComponent",
            "encodeURI",
            "encodeURIComponent",
            "escape",
            "unescape"
        ], o = [
            "arguments",
            "this",
            "super",
            "console",
            "window",
            "document",
            "localStorage",
            "sessionStorage",
            "module",
            "global"
        ], s = [].concat(r, n, i);
        return On = function(l) {
            const c = l.regex, _ = e, d = "<>", m = "</>", p = {
                begin: /<[A-Za-z0-9\\._:-]+/,
                end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
                isTrulyOpeningTag: (e, t)=>{
                    const a = e[0].length + e.index, n = e.input[a];
                    if ("<" === n || "," === n) return void t.ignoreMatch();
                    let i;
                    ">" === n && (((e, { after: t })=>{
                        const a = "</" + e[0].slice(1);
                        return -1 !== e.input.indexOf(a, t);
                    })(e, {
                        after: a
                    }) || t.ignoreMatch());
                    const r = e.input.substring(a);
                    ((i = r.match(/^\s*=/)) || (i = r.match(/^\s+extends\s+/)) && 0 === i.index) && t.ignoreMatch();
                }
            }, u = {
                $pattern: e,
                keyword: t,
                literal: a,
                built_in: s,
                "variable.language": o
            }, g = "[0-9](_?[0-9])*", E = `\\.(${g})`, S = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", b = {
                className: "number",
                variants: [
                    {
                        begin: `(\\b(${S})((${E})|\\.)?|(${E}))[eE][+-]?(${g})\\b`
                    },
                    {
                        begin: `\\b(${S})\\b((${E})\\b|\\.)?|(${E})\\b`
                    },
                    {
                        begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
                    },
                    {
                        begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
                    },
                    {
                        begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
                    },
                    {
                        begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
                    },
                    {
                        begin: "\\b0[0-7]+n?\\b"
                    }
                ],
                relevance: 0
            }, T = {
                className: "subst",
                begin: "\\$\\{",
                end: "\\}",
                keywords: u,
                contains: []
            }, C = {
                begin: "html`",
                end: "",
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        l.BACKSLASH_ESCAPE,
                        T
                    ],
                    subLanguage: "xml"
                }
            }, f = {
                begin: "css`",
                end: "",
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        l.BACKSLASH_ESCAPE,
                        T
                    ],
                    subLanguage: "css"
                }
            }, R = {
                begin: "gql`",
                end: "",
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        l.BACKSLASH_ESCAPE,
                        T
                    ],
                    subLanguage: "graphql"
                }
            }, N = {
                className: "string",
                begin: "`",
                end: "`",
                contains: [
                    l.BACKSLASH_ESCAPE,
                    T
                ]
            }, O = {
                className: "comment",
                variants: [
                    l.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
                        relevance: 0,
                        contains: [
                            {
                                begin: "(?=@[A-Za-z]+)",
                                relevance: 0,
                                contains: [
                                    {
                                        className: "doctag",
                                        begin: "@[A-Za-z]+"
                                    },
                                    {
                                        className: "type",
                                        begin: "\\{",
                                        end: "\\}",
                                        excludeEnd: !0,
                                        excludeBegin: !0,
                                        relevance: 0
                                    },
                                    {
                                        className: "variable",
                                        begin: _ + "(?=\\s*(-)|$)",
                                        endsParent: !0,
                                        relevance: 0
                                    },
                                    {
                                        begin: /(?=[^\n])\s/,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    }),
                    l.C_BLOCK_COMMENT_MODE,
                    l.C_LINE_COMMENT_MODE
                ]
            }, h = [
                l.APOS_STRING_MODE,
                l.QUOTE_STRING_MODE,
                C,
                f,
                R,
                N,
                {
                    match: /\$\d+/
                },
                b
            ];
            T.contains = h.concat({
                begin: /\{/,
                end: /\}/,
                keywords: u,
                contains: [
                    "self"
                ].concat(h)
            });
            const v = [].concat(O, T.contains), I = v.concat([
                {
                    begin: /\(/,
                    end: /\)/,
                    keywords: u,
                    contains: [
                        "self"
                    ].concat(v)
                }
            ]), A = {
                className: "params",
                begin: /\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0,
                keywords: u,
                contains: I
            }, y = {
                variants: [
                    {
                        match: [
                            /class/,
                            /\s+/,
                            _,
                            /\s+/,
                            /extends/,
                            /\s+/,
                            c.concat(_, "(", c.concat(/\./, _), ")*")
                        ],
                        scope: {
                            1: "keyword",
                            3: "title.class",
                            5: "keyword",
                            7: "title.class.inherited"
                        }
                    },
                    {
                        match: [
                            /class/,
                            /\s+/,
                            _
                        ],
                        scope: {
                            1: "keyword",
                            3: "title.class"
                        }
                    }
                ]
            }, D = {
                relevance: 0,
                match: c.either(/\bJSON/, /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
                className: "title.class",
                keywords: {
                    _: [
                        ...n,
                        ...i
                    ]
                }
            }, M = {
                variants: [
                    {
                        match: [
                            /function/,
                            /\s+/,
                            _,
                            /(?=\s*\()/
                        ]
                    },
                    {
                        match: [
                            /function/,
                            /\s*(?=\()/
                        ]
                    }
                ],
                className: {
                    1: "keyword",
                    3: "title.function"
                },
                label: "func.def",
                contains: [
                    A
                ],
                illegal: /%/
            }, L = {
                match: c.concat(/\b/, (x = [
                    ...r,
                    "super",
                    "import"
                ], c.concat("(?!", x.join("|"), ")")), _, c.lookahead(/\(/)),
                className: "title.function",
                relevance: 0
            };
            var x;
            const w = {
                begin: c.concat(/\./, c.lookahead(c.concat(_, /(?![0-9A-Za-z$_(])/))),
                end: _,
                excludeBegin: !0,
                keywords: "prototype",
                className: "property",
                relevance: 0
            }, P = {
                match: [
                    /get|set/,
                    /\s+/,
                    _,
                    /(?=\()/
                ],
                className: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    {
                        begin: /\(\)/
                    },
                    A
                ]
            }, k = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + l.UNDERSCORE_IDENT_RE + ")\\s*=>", U = {
                match: [
                    /const|var|let/,
                    /\s+/,
                    _,
                    /\s*/,
                    /=\s*/,
                    /(async\s*)?/,
                    c.lookahead(k)
                ],
                keywords: "async",
                className: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    A
                ]
            };
            return {
                name: "JavaScript",
                aliases: [
                    "js",
                    "jsx",
                    "mjs",
                    "cjs"
                ],
                keywords: u,
                exports: {
                    PARAMS_CONTAINS: I,
                    CLASS_REFERENCE: D
                },
                illegal: /#(?![$_A-z])/,
                contains: [
                    l.SHEBANG({
                        label: "shebang",
                        binary: "node",
                        relevance: 5
                    }),
                    {
                        label: "use_strict",
                        className: "meta",
                        relevance: 10,
                        begin: /^\s*['"]use (strict|asm)['"]/
                    },
                    l.APOS_STRING_MODE,
                    l.QUOTE_STRING_MODE,
                    C,
                    f,
                    R,
                    N,
                    O,
                    {
                        match: /\$\d+/
                    },
                    b,
                    D,
                    {
                        className: "attr",
                        begin: _ + c.lookahead(":"),
                        relevance: 0
                    },
                    U,
                    {
                        begin: "(" + l.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                        keywords: "return throw case",
                        relevance: 0,
                        contains: [
                            O,
                            l.REGEXP_MODE,
                            {
                                className: "function",
                                begin: k,
                                returnBegin: !0,
                                end: "\\s*=>",
                                contains: [
                                    {
                                        className: "params",
                                        variants: [
                                            {
                                                begin: l.UNDERSCORE_IDENT_RE,
                                                relevance: 0
                                            },
                                            {
                                                className: null,
                                                begin: /\(\s*\)/,
                                                skip: !0
                                            },
                                            {
                                                begin: /\(/,
                                                end: /\)/,
                                                excludeBegin: !0,
                                                excludeEnd: !0,
                                                keywords: u,
                                                contains: I
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                begin: /,/,
                                relevance: 0
                            },
                            {
                                match: /\s+/,
                                relevance: 0
                            },
                            {
                                variants: [
                                    {
                                        begin: d,
                                        end: m
                                    },
                                    {
                                        match: /<[A-Za-z0-9\\._:-]+\s*\/>/
                                    },
                                    {
                                        begin: p.begin,
                                        "on:begin": p.isTrulyOpeningTag,
                                        end: p.end
                                    }
                                ],
                                subLanguage: "xml",
                                contains: [
                                    {
                                        begin: p.begin,
                                        end: p.end,
                                        skip: !0,
                                        contains: [
                                            "self"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    M,
                    {
                        beginKeywords: "while if switch catch for"
                    },
                    {
                        begin: "\\b(?!function)" + l.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
                        returnBegin: !0,
                        label: "func.def",
                        contains: [
                            A,
                            l.inherit(l.TITLE_MODE, {
                                begin: _,
                                className: "title.function"
                            })
                        ]
                    },
                    {
                        match: /\.\.\./,
                        relevance: 0
                    },
                    w,
                    {
                        match: "\\$" + _,
                        relevance: 0
                    },
                    {
                        match: [
                            /\bconstructor(?=\s*\()/
                        ],
                        className: {
                            1: "title.function"
                        },
                        contains: [
                            A
                        ]
                    },
                    L,
                    {
                        relevance: 0,
                        match: /\b[A-Z][A-Z_0-9]+\b/,
                        className: "variable.constant"
                    },
                    y,
                    P,
                    {
                        match: /\$[(.]/
                    }
                ]
            };
        }, On;
    }()), Cs.registerLanguage("jboss-cli", (In || (In = 1, vn = function(e) {
        const t = {
            className: "params",
            begin: /\(/,
            end: /\)/,
            contains: [
                {
                    begin: /[\w-]+ *=/,
                    returnBegin: !0,
                    relevance: 0,
                    contains: [
                        {
                            className: "attr",
                            begin: /[\w-]+/
                        }
                    ]
                }
            ],
            relevance: 0
        };
        return {
            name: "JBoss CLI",
            aliases: [
                "wildfly-cli"
            ],
            keywords: {
                $pattern: "[a-z-]+",
                keyword: "alias batch cd clear command connect connection-factory connection-info data-source deploy deployment-info deployment-overlay echo echo-dmr help history if jdbc-driver-info jms-queue|20 jms-topic|20 ls patch pwd quit read-attribute read-operation reload rollout-plan run-batch set shutdown try unalias undeploy unset version xa-data-source",
                literal: "true false"
            },
            contains: [
                e.HASH_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                {
                    className: "params",
                    begin: /--[\w\-=\/]+/
                },
                {
                    className: "function",
                    begin: /:[\w\-.]+/,
                    relevance: 0
                },
                {
                    className: "string",
                    begin: /\B([\/.])[\w\-.\/=]+/
                },
                t
            ]
        };
    }), vn)), Cs.registerLanguage("json", (yn || (yn = 1, An = function(e) {
        const t = [
            "true",
            "false",
            "null"
        ], a = {
            scope: "literal",
            beginKeywords: t.join(" ")
        };
        return {
            name: "JSON",
            keywords: {
                literal: t
            },
            contains: [
                {
                    className: "attr",
                    begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
                    relevance: 1.01
                },
                {
                    match: /[{}[\],:]/,
                    className: "punctuation",
                    relevance: 0
                },
                e.QUOTE_STRING_MODE,
                a,
                e.C_NUMBER_MODE,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE
            ],
            illegal: "\\S"
        };
    }), An)), Cs.registerLanguage("julia", (Mn || (Mn = 1, Dn = function(e) {
        const t = "[A-Za-z_\\u00A1-\\uFFFF][A-Za-z_0-9\\u00A1-\\uFFFF]*", a = {
            $pattern: t,
            keyword: [
                "baremodule",
                "begin",
                "break",
                "catch",
                "ccall",
                "const",
                "continue",
                "do",
                "else",
                "elseif",
                "end",
                "export",
                "false",
                "finally",
                "for",
                "function",
                "global",
                "if",
                "import",
                "in",
                "isa",
                "let",
                "local",
                "macro",
                "module",
                "quote",
                "return",
                "true",
                "try",
                "using",
                "where",
                "while"
            ],
            literal: [
                "ARGS",
                "C_NULL",
                "DEPOT_PATH",
                "ENDIAN_BOM",
                "ENV",
                "Inf",
                "Inf16",
                "Inf32",
                "Inf64",
                "InsertionSort",
                "LOAD_PATH",
                "MergeSort",
                "NaN",
                "NaN16",
                "NaN32",
                "NaN64",
                "PROGRAM_FILE",
                "QuickSort",
                "RoundDown",
                "RoundFromZero",
                "RoundNearest",
                "RoundNearestTiesAway",
                "RoundNearestTiesUp",
                "RoundToZero",
                "RoundUp",
                "VERSION|0",
                "devnull",
                "false",
                "im",
                "missing",
                "nothing",
                "pi",
                "stderr",
                "stdin",
                "stdout",
                "true",
                "undef",
                "\u03C0",
                "\u212F"
            ],
            built_in: [
                "AbstractArray",
                "AbstractChannel",
                "AbstractChar",
                "AbstractDict",
                "AbstractDisplay",
                "AbstractFloat",
                "AbstractIrrational",
                "AbstractMatrix",
                "AbstractRange",
                "AbstractSet",
                "AbstractString",
                "AbstractUnitRange",
                "AbstractVecOrMat",
                "AbstractVector",
                "Any",
                "ArgumentError",
                "Array",
                "AssertionError",
                "BigFloat",
                "BigInt",
                "BitArray",
                "BitMatrix",
                "BitSet",
                "BitVector",
                "Bool",
                "BoundsError",
                "CapturedException",
                "CartesianIndex",
                "CartesianIndices",
                "Cchar",
                "Cdouble",
                "Cfloat",
                "Channel",
                "Char",
                "Cint",
                "Cintmax_t",
                "Clong",
                "Clonglong",
                "Cmd",
                "Colon",
                "Complex",
                "ComplexF16",
                "ComplexF32",
                "ComplexF64",
                "CompositeException",
                "Condition",
                "Cptrdiff_t",
                "Cshort",
                "Csize_t",
                "Cssize_t",
                "Cstring",
                "Cuchar",
                "Cuint",
                "Cuintmax_t",
                "Culong",
                "Culonglong",
                "Cushort",
                "Cvoid",
                "Cwchar_t",
                "Cwstring",
                "DataType",
                "DenseArray",
                "DenseMatrix",
                "DenseVecOrMat",
                "DenseVector",
                "Dict",
                "DimensionMismatch",
                "Dims",
                "DivideError",
                "DomainError",
                "EOFError",
                "Enum",
                "ErrorException",
                "Exception",
                "ExponentialBackOff",
                "Expr",
                "Float16",
                "Float32",
                "Float64",
                "Function",
                "GlobalRef",
                "HTML",
                "IO",
                "IOBuffer",
                "IOContext",
                "IOStream",
                "IdDict",
                "IndexCartesian",
                "IndexLinear",
                "IndexStyle",
                "InexactError",
                "InitError",
                "Int",
                "Int128",
                "Int16",
                "Int32",
                "Int64",
                "Int8",
                "Integer",
                "InterruptException",
                "InvalidStateException",
                "Irrational",
                "KeyError",
                "LinRange",
                "LineNumberNode",
                "LinearIndices",
                "LoadError",
                "MIME",
                "Matrix",
                "Method",
                "MethodError",
                "Missing",
                "MissingException",
                "Module",
                "NTuple",
                "NamedTuple",
                "Nothing",
                "Number",
                "OrdinalRange",
                "OutOfMemoryError",
                "OverflowError",
                "Pair",
                "PartialQuickSort",
                "PermutedDimsArray",
                "Pipe",
                "ProcessFailedException",
                "Ptr",
                "QuoteNode",
                "Rational",
                "RawFD",
                "ReadOnlyMemoryError",
                "Real",
                "ReentrantLock",
                "Ref",
                "Regex",
                "RegexMatch",
                "RoundingMode",
                "SegmentationFault",
                "Set",
                "Signed",
                "Some",
                "StackOverflowError",
                "StepRange",
                "StepRangeLen",
                "StridedArray",
                "StridedMatrix",
                "StridedVecOrMat",
                "StridedVector",
                "String",
                "StringIndexError",
                "SubArray",
                "SubString",
                "SubstitutionString",
                "Symbol",
                "SystemError",
                "Task",
                "TaskFailedException",
                "Text",
                "TextDisplay",
                "Timer",
                "Tuple",
                "Type",
                "TypeError",
                "TypeVar",
                "UInt",
                "UInt128",
                "UInt16",
                "UInt32",
                "UInt64",
                "UInt8",
                "UndefInitializer",
                "UndefKeywordError",
                "UndefRefError",
                "UndefVarError",
                "Union",
                "UnionAll",
                "UnitRange",
                "Unsigned",
                "Val",
                "Vararg",
                "VecElement",
                "VecOrMat",
                "Vector",
                "VersionNumber",
                "WeakKeyDict",
                "WeakRef"
            ]
        }, n = {
            keywords: a,
            illegal: /<\//
        }, i = {
            className: "subst",
            begin: /\$\(/,
            end: /\)/,
            keywords: a
        }, r = {
            className: "variable",
            begin: "\\$" + t
        }, o = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE,
                i,
                r
            ],
            variants: [
                {
                    begin: /\w*"""/,
                    end: /"""\w*/,
                    relevance: 10
                },
                {
                    begin: /\w*"/,
                    end: /"\w*/
                }
            ]
        }, s = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE,
                i,
                r
            ],
            begin: "`",
            end: "`"
        }, l = {
            className: "meta",
            begin: "@" + t
        };
        return n.name = "Julia", n.contains = [
            {
                className: "number",
                begin: /(\b0x[\d_]*(\.[\d_]*)?|0x\.\d[\d_]*)p[-+]?\d+|\b0[box][a-fA-F0-9][a-fA-F0-9_]*|(\b\d[\d_]*(\.[\d_]*)?|\.\d[\d_]*)([eEfF][-+]?\d+)?/,
                relevance: 0
            },
            {
                className: "string",
                begin: /'(.|\\[xXuU][a-zA-Z0-9]+)'/
            },
            o,
            s,
            l,
            {
                className: "comment",
                variants: [
                    {
                        begin: "#=",
                        end: "=#",
                        relevance: 10
                    },
                    {
                        begin: "#",
                        end: "$"
                    }
                ]
            },
            e.HASH_COMMENT_MODE,
            {
                className: "keyword",
                begin: "\\b(((abstract|primitive)\\s+)type|(mutable\\s+)?struct)\\b"
            },
            {
                begin: /<:/
            }
        ], i.contains = n.contains, n;
    }), Dn)), Cs.registerLanguage("julia-repl", xn ? Ln : (xn = 1, Ln = function(e) {
        return {
            name: "Julia REPL",
            contains: [
                {
                    className: "meta.prompt",
                    begin: /^julia>/,
                    relevance: 10,
                    starts: {
                        end: /^(?![ ]{6})/,
                        subLanguage: "julia"
                    }
                }
            ],
            aliases: [
                "jldoctest"
            ]
        };
    })), Cs.registerLanguage("kotlin", function() {
        if (Pn) return wn;
        Pn = 1;
        var e = "[0-9](_*[0-9])*", t = `\\.(${e})`, a = "[0-9a-fA-F](_*[0-9a-fA-F])*", n = {
            className: "number",
            variants: [
                {
                    begin: `(\\b(${e})((${t})|\\.)?|(${t}))[eE][+-]?(${e})[fFdD]?\\b`
                },
                {
                    begin: `\\b(${e})((${t})[fFdD]?\\b|\\.([fFdD]\\b)?)`
                },
                {
                    begin: `(${t})[fFdD]?\\b`
                },
                {
                    begin: `\\b(${e})[fFdD]\\b`
                },
                {
                    begin: `\\b0[xX]((${a})\\.?|(${a})?\\.(${a}))[pP][+-]?(${e})[fFdD]?\\b`
                },
                {
                    begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b"
                },
                {
                    begin: `\\b0[xX](${a})[lL]?\\b`
                },
                {
                    begin: "\\b0(_*[0-7])*[lL]?\\b"
                },
                {
                    begin: "\\b0[bB][01](_*[01])*[lL]?\\b"
                }
            ],
            relevance: 0
        };
        return wn = function(e) {
            const t = {
                keyword: "abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual",
                built_in: "Byte Short Char Int Long Boolean Float Double Void Unit Nothing",
                literal: "true false null"
            }, a = {
                className: "symbol",
                begin: e.UNDERSCORE_IDENT_RE + "@"
            }, i = {
                className: "subst",
                begin: /\$\{/,
                end: /\}/,
                contains: [
                    e.C_NUMBER_MODE
                ]
            }, r = {
                className: "variable",
                begin: "\\$" + e.UNDERSCORE_IDENT_RE
            }, o = {
                className: "string",
                variants: [
                    {
                        begin: '"""',
                        end: '"""(?=[^"])',
                        contains: [
                            r,
                            i
                        ]
                    },
                    {
                        begin: "'",
                        end: "'",
                        illegal: /\n/,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: '"',
                        end: '"',
                        illegal: /\n/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            r,
                            i
                        ]
                    }
                ]
            };
            i.contains.push(o);
            const s = {
                className: "meta",
                begin: "@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*" + e.UNDERSCORE_IDENT_RE + ")?"
            }, l = {
                className: "meta",
                begin: "@" + e.UNDERSCORE_IDENT_RE,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            e.inherit(o, {
                                className: "string"
                            }),
                            "self"
                        ]
                    }
                ]
            }, c = n, _ = e.COMMENT("/\\*", "\\*/", {
                contains: [
                    e.C_BLOCK_COMMENT_MODE
                ]
            }), d = {
                variants: [
                    {
                        className: "type",
                        begin: e.UNDERSCORE_IDENT_RE
                    },
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: []
                    }
                ]
            }, m = d;
            return m.variants[1].contains = [
                d
            ], d.variants[1].contains = [
                m
            ], {
                name: "Kotlin",
                aliases: [
                    "kt",
                    "kts"
                ],
                keywords: t,
                contains: [
                    e.COMMENT("/\\*\\*", "\\*/", {
                        relevance: 0,
                        contains: [
                            {
                                className: "doctag",
                                begin: "@[A-Za-z]+"
                            }
                        ]
                    }),
                    e.C_LINE_COMMENT_MODE,
                    _,
                    {
                        className: "keyword",
                        begin: /\b(break|continue|return|this)\b/,
                        starts: {
                            contains: [
                                {
                                    className: "symbol",
                                    begin: /@\w+/
                                }
                            ]
                        }
                    },
                    a,
                    s,
                    l,
                    {
                        className: "function",
                        beginKeywords: "fun",
                        end: "[(]|$",
                        returnBegin: !0,
                        excludeEnd: !0,
                        keywords: t,
                        relevance: 5,
                        contains: [
                            {
                                begin: e.UNDERSCORE_IDENT_RE + "\\s*\\(",
                                returnBegin: !0,
                                relevance: 0,
                                contains: [
                                    e.UNDERSCORE_TITLE_MODE
                                ]
                            },
                            {
                                className: "type",
                                begin: /</,
                                end: />/,
                                keywords: "reified",
                                relevance: 0
                            },
                            {
                                className: "params",
                                begin: /\(/,
                                end: /\)/,
                                endsParent: !0,
                                keywords: t,
                                relevance: 0,
                                contains: [
                                    {
                                        begin: /:/,
                                        end: /[=,\/]/,
                                        endsWithParent: !0,
                                        contains: [
                                            d,
                                            e.C_LINE_COMMENT_MODE,
                                            _
                                        ],
                                        relevance: 0
                                    },
                                    e.C_LINE_COMMENT_MODE,
                                    _,
                                    s,
                                    l,
                                    o,
                                    e.C_NUMBER_MODE
                                ]
                            },
                            _
                        ]
                    },
                    {
                        begin: [
                            /class|interface|trait/,
                            /\s+/,
                            e.UNDERSCORE_IDENT_RE
                        ],
                        beginScope: {
                            3: "title.class"
                        },
                        keywords: "class interface trait",
                        end: /[:\{(]|$/,
                        excludeEnd: !0,
                        illegal: "extends implements",
                        contains: [
                            {
                                beginKeywords: "public protected internal private constructor"
                            },
                            e.UNDERSCORE_TITLE_MODE,
                            {
                                className: "type",
                                begin: /</,
                                end: />/,
                                excludeBegin: !0,
                                excludeEnd: !0,
                                relevance: 0
                            },
                            {
                                className: "type",
                                begin: /[,:]\s*/,
                                end: /[<\(,){\s]|$/,
                                excludeBegin: !0,
                                returnEnd: !0
                            },
                            s,
                            l
                        ]
                    },
                    o,
                    {
                        className: "meta",
                        begin: "^#!/usr/bin/env",
                        end: "$",
                        illegal: "\n"
                    },
                    c
                ]
            };
        }, wn;
    }()), Cs.registerLanguage("lasso", (Un || (Un = 1, kn = function(e) {
        const t = "[a-zA-Z_][\\w.]*", a = "<\\?(lasso(script)?|=)", n = "\\]|\\?>", i = {
            $pattern: t + "|&[lg]t;",
            literal: "true false none minimal full all void and or not bw nbw ew new cn ncn lt lte gt gte eq neq rx nrx ft",
            built_in: "array date decimal duration integer map pair string tag xml null boolean bytes keyword list locale queue set stack staticarray local var variable global data self inherited currentcapture givenblock",
            keyword: "cache database_names database_schemanames database_tablenames define_tag define_type email_batch encode_set html_comment handle handle_error header if inline iterate ljax_target link link_currentaction link_currentgroup link_currentrecord link_detail link_firstgroup link_firstrecord link_lastgroup link_lastrecord link_nextgroup link_nextrecord link_prevgroup link_prevrecord log loop namespace_using output_none portal private protect records referer referrer repeating resultset rows search_args search_arguments select sort_args sort_arguments thread_atomic value_list while abort case else fail_if fail_ifnot fail if_empty if_false if_null if_true loop_abort loop_continue loop_count params params_up return return_value run_children soap_definetag soap_lastrequest soap_lastresponse tag_name ascending average by define descending do equals frozen group handle_failure import in into join let match max min on order parent protected provide public require returnhome skip split_thread sum take thread to trait type where with yield yieldhome"
        }, r = e.COMMENT("\x3c!--", "--\x3e", {
            relevance: 0
        }), o = {
            className: "meta",
            begin: "\\[noprocess\\]",
            starts: {
                end: "\\[/noprocess\\]",
                returnEnd: !0,
                contains: [
                    r
                ]
            }
        }, s = {
            className: "meta",
            begin: "\\[/noprocess|" + a
        }, l = {
            className: "symbol",
            begin: "'" + t + "'"
        }, c = [
            e.C_LINE_COMMENT_MODE,
            e.C_BLOCK_COMMENT_MODE,
            e.inherit(e.C_NUMBER_MODE, {
                begin: e.C_NUMBER_RE + "|(-?infinity|NaN)\\b"
            }),
            e.inherit(e.APOS_STRING_MODE, {
                illegal: null
            }),
            e.inherit(e.QUOTE_STRING_MODE, {
                illegal: null
            }),
            {
                className: "string",
                begin: "`",
                end: "`"
            },
            {
                variants: [
                    {
                        begin: "[#$]" + t
                    },
                    {
                        begin: "#",
                        end: "\\d+",
                        illegal: "\\W"
                    }
                ]
            },
            {
                className: "type",
                begin: "::\\s*",
                end: t,
                illegal: "\\W"
            },
            {
                className: "params",
                variants: [
                    {
                        begin: "-(?!infinity)" + t,
                        relevance: 0
                    },
                    {
                        begin: "(\\.\\.\\.)"
                    }
                ]
            },
            {
                begin: /(->|\.)\s*/,
                relevance: 0,
                contains: [
                    l
                ]
            },
            {
                className: "class",
                beginKeywords: "define",
                returnEnd: !0,
                end: "\\(|=>",
                contains: [
                    e.inherit(e.TITLE_MODE, {
                        begin: t + "(=(?!>))?|[-+*/%](?!>)"
                    })
                ]
            }
        ];
        return {
            name: "Lasso",
            aliases: [
                "ls",
                "lassoscript"
            ],
            case_insensitive: !0,
            keywords: i,
            contains: [
                {
                    className: "meta",
                    begin: n,
                    relevance: 0,
                    starts: {
                        end: "\\[|" + a,
                        returnEnd: !0,
                        relevance: 0,
                        contains: [
                            r
                        ]
                    }
                },
                o,
                s,
                {
                    className: "meta",
                    begin: "\\[no_square_brackets",
                    starts: {
                        end: "\\[/no_square_brackets\\]",
                        keywords: i,
                        contains: [
                            {
                                className: "meta",
                                begin: n,
                                relevance: 0,
                                starts: {
                                    end: "\\[noprocess\\]|" + a,
                                    returnEnd: !0,
                                    contains: [
                                        r
                                    ]
                                }
                            },
                            o,
                            s
                        ].concat(c)
                    }
                },
                {
                    className: "meta",
                    begin: "\\[",
                    relevance: 0
                },
                {
                    className: "meta",
                    begin: "^#!",
                    end: "lasso9$",
                    relevance: 10
                }
            ].concat(c)
        };
    }), kn)), Cs.registerLanguage("latex", (Bn || (Bn = 1, Fn = function(e) {
        const t = [
            {
                begin: /\^{6}[0-9a-f]{6}/
            },
            {
                begin: /\^{5}[0-9a-f]{5}/
            },
            {
                begin: /\^{4}[0-9a-f]{4}/
            },
            {
                begin: /\^{3}[0-9a-f]{3}/
            },
            {
                begin: /\^{2}[0-9a-f]{2}/
            },
            {
                begin: /\^{2}[\u0000-\u007f]/
            }
        ], a = [
            {
                className: "keyword",
                begin: /\\/,
                relevance: 0,
                contains: [
                    {
                        endsParent: !0,
                        begin: e.regex.either(...[
                            "(?:NeedsTeXFormat|RequirePackage|GetIdInfo)",
                            "Provides(?:Expl)?(?:Package|Class|File)",
                            "(?:DeclareOption|ProcessOptions)",
                            "(?:documentclass|usepackage|input|include)",
                            "makeat(?:letter|other)",
                            "ExplSyntax(?:On|Off)",
                            "(?:new|renew|provide)?command",
                            "(?:re)newenvironment",
                            "(?:New|Renew|Provide|Declare)(?:Expandable)?DocumentCommand",
                            "(?:New|Renew|Provide|Declare)DocumentEnvironment",
                            "(?:(?:e|g|x)?def|let)",
                            "(?:begin|end)",
                            "(?:part|chapter|(?:sub){0,2}section|(?:sub)?paragraph)",
                            "caption",
                            "(?:label|(?:eq|page|name)?ref|(?:paren|foot|super)?cite)",
                            "(?:alpha|beta|[Gg]amma|[Dd]elta|(?:var)?epsilon|zeta|eta|[Tt]heta|vartheta)",
                            "(?:iota|(?:var)?kappa|[Ll]ambda|mu|nu|[Xx]i|[Pp]i|varpi|(?:var)rho)",
                            "(?:[Ss]igma|varsigma|tau|[Uu]psilon|[Pp]hi|varphi|chi|[Pp]si|[Oo]mega)",
                            "(?:frac|sum|prod|lim|infty|times|sqrt|leq|geq|left|right|middle|[bB]igg?)",
                            "(?:[lr]angle|q?quad|[lcvdi]?dots|d?dot|hat|tilde|bar)"
                        ].map((e)=>e + "(?![a-zA-Z@:_])"))
                    },
                    {
                        endsParent: !0,
                        begin: new RegExp([
                            "(?:__)?[a-zA-Z]{2,}_[a-zA-Z](?:_?[a-zA-Z])+:[a-zA-Z]*",
                            "[lgc]__?[a-zA-Z](?:_?[a-zA-Z])*_[a-zA-Z]{2,}",
                            "[qs]__?[a-zA-Z](?:_?[a-zA-Z])+",
                            "use(?:_i)?:[a-zA-Z]*",
                            "(?:else|fi|or):",
                            "(?:if|cs|exp):w",
                            "(?:hbox|vbox):n",
                            "::[a-zA-Z]_unbraced",
                            "::[a-zA-Z:]"
                        ].map((e)=>e + "(?![a-zA-Z:_])").join("|"))
                    },
                    {
                        endsParent: !0,
                        variants: t
                    },
                    {
                        endsParent: !0,
                        relevance: 0,
                        variants: [
                            {
                                begin: /[a-zA-Z@]+/
                            },
                            {
                                begin: /[^a-zA-Z@]?/
                            }
                        ]
                    }
                ]
            },
            {
                className: "params",
                relevance: 0,
                begin: /#+\d?/
            },
            {
                variants: t
            },
            {
                className: "built_in",
                relevance: 0,
                begin: /[$&^_]/
            },
            {
                className: "meta",
                begin: /% ?!(T[eE]X|tex|BIB|bib)/,
                end: "$",
                relevance: 10
            },
            e.COMMENT("%", "$", {
                relevance: 0
            })
        ], n = {
            begin: /\{/,
            end: /\}/,
            relevance: 0,
            contains: [
                "self",
                ...a
            ]
        }, i = e.inherit(n, {
            relevance: 0,
            endsParent: !0,
            contains: [
                n,
                ...a
            ]
        }), r = {
            begin: /\[/,
            end: /\]/,
            endsParent: !0,
            relevance: 0,
            contains: [
                n,
                ...a
            ]
        }, o = {
            begin: /\s+/,
            relevance: 0
        }, s = [
            i
        ], l = [
            r
        ], c = function(e, t) {
            return {
                contains: [
                    o
                ],
                starts: {
                    relevance: 0,
                    contains: e,
                    starts: t
                }
            };
        }, _ = function(e, t) {
            return {
                begin: "\\\\" + e + "(?![a-zA-Z@:_])",
                keywords: {
                    $pattern: /\\[a-zA-Z]+/,
                    keyword: "\\" + e
                },
                relevance: 0,
                contains: [
                    o
                ],
                starts: t
            };
        }, d = function(t, a) {
            return e.inherit({
                begin: "\\\\begin(?=[ \t]*(\\r?\\n[ \t]*)?\\{" + t + "\\})",
                keywords: {
                    $pattern: /\\[a-zA-Z]+/,
                    keyword: "\\begin"
                },
                relevance: 0
            }, c(s, a));
        }, m = (t = "string")=>e.END_SAME_AS_BEGIN({
                className: t,
                begin: /(.|\r?\n)/,
                end: /(.|\r?\n)/,
                excludeBegin: !0,
                excludeEnd: !0,
                endsParent: !0
            }), p = function(e) {
            return {
                className: "string",
                end: "(?=\\\\end\\{" + e + "\\})"
            };
        }, u = (e = "string")=>({
                relevance: 0,
                begin: /\{/,
                starts: {
                    endsParent: !0,
                    contains: [
                        {
                            className: e,
                            end: /(?=\})/,
                            endsParent: !0,
                            contains: [
                                {
                                    begin: /\{/,
                                    end: /\}/,
                                    relevance: 0,
                                    contains: [
                                        "self"
                                    ]
                                }
                            ]
                        }
                    ]
                }
            });
        return {
            name: "LaTeX",
            aliases: [
                "tex"
            ],
            contains: [
                ...[
                    "verb",
                    "lstinline"
                ].map((e)=>_(e, {
                        contains: [
                            m()
                        ]
                    })),
                _("mint", c(s, {
                    contains: [
                        m()
                    ]
                })),
                _("mintinline", c(s, {
                    contains: [
                        u(),
                        m()
                    ]
                })),
                _("url", {
                    contains: [
                        u("link"),
                        u("link")
                    ]
                }),
                _("hyperref", {
                    contains: [
                        u("link")
                    ]
                }),
                _("href", c(l, {
                    contains: [
                        u("link")
                    ]
                })),
                ...[].concat(...[
                    "",
                    "\\*"
                ].map((e)=>[
                        d("verbatim" + e, p("verbatim" + e)),
                        d("filecontents" + e, c(s, p("filecontents" + e))),
                        ...[
                            "",
                            "B",
                            "L"
                        ].map((t)=>d(t + "Verbatim" + e, c(l, p(t + "Verbatim" + e))))
                    ])),
                d("minted", c(l, c(s, p("minted")))),
                ...a
            ]
        };
    }), Fn)), Cs.registerLanguage("ldif", (Yn || (Yn = 1, Gn = function(e) {
        return {
            name: "LDIF",
            contains: [
                {
                    className: "attribute",
                    match: "^dn(?=:)",
                    relevance: 10
                },
                {
                    className: "attribute",
                    match: "^\\w+(?=:)"
                },
                {
                    className: "literal",
                    match: "^-"
                },
                e.HASH_COMMENT_MODE
            ]
        };
    }), Gn)), Cs.registerLanguage("leaf", Vn ? Hn : (Vn = 1, Hn = function(e) {
        const t = /([A-Za-z_][A-Za-z_0-9]*)?/, a = {
            scope: "params",
            begin: /\(/,
            end: /\)(?=\:?)/,
            endsParent: !0,
            relevance: 7,
            contains: [
                {
                    scope: "string",
                    begin: '"',
                    end: '"'
                },
                {
                    scope: "keyword",
                    match: [
                        "true",
                        "false",
                        "in"
                    ].join("|")
                },
                {
                    scope: "variable",
                    match: /[A-Za-z_][A-Za-z_0-9]*/
                },
                {
                    scope: "operator",
                    match: /\+|\-|\*|\/|\%|\=\=|\=|\!|\>|\<|\&\&|\|\|/
                }
            ]
        }, n = {
            match: [
                t,
                /(?=\()/
            ],
            scope: {
                1: "keyword"
            },
            contains: [
                a
            ]
        };
        return a.contains.unshift(n), {
            name: "Leaf",
            contains: [
                {
                    match: [
                        /#+/,
                        t,
                        /(?=\()/
                    ],
                    scope: {
                        1: "punctuation",
                        2: "keyword"
                    },
                    starts: {
                        contains: [
                            {
                                match: /\:/,
                                scope: "punctuation"
                            }
                        ]
                    },
                    contains: [
                        a
                    ]
                },
                {
                    match: [
                        /#+/,
                        t,
                        /:?/
                    ],
                    scope: {
                        1: "punctuation",
                        2: "keyword",
                        3: "punctuation"
                    }
                }
            ]
        };
    })), Cs.registerLanguage("less", function() {
        if (zn) return qn;
        zn = 1;
        const e = [
            "a",
            "abbr",
            "address",
            "article",
            "aside",
            "audio",
            "b",
            "blockquote",
            "body",
            "button",
            "canvas",
            "caption",
            "cite",
            "code",
            "dd",
            "del",
            "details",
            "dfn",
            "div",
            "dl",
            "dt",
            "em",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "html",
            "i",
            "iframe",
            "img",
            "input",
            "ins",
            "kbd",
            "label",
            "legend",
            "li",
            "main",
            "mark",
            "menu",
            "nav",
            "object",
            "ol",
            "p",
            "q",
            "quote",
            "samp",
            "section",
            "span",
            "strong",
            "summary",
            "sup",
            "table",
            "tbody",
            "td",
            "textarea",
            "tfoot",
            "th",
            "thead",
            "time",
            "tr",
            "ul",
            "var",
            "video"
        ], t = [
            "any-hover",
            "any-pointer",
            "aspect-ratio",
            "color",
            "color-gamut",
            "color-index",
            "device-aspect-ratio",
            "device-height",
            "device-width",
            "display-mode",
            "forced-colors",
            "grid",
            "height",
            "hover",
            "inverted-colors",
            "monochrome",
            "orientation",
            "overflow-block",
            "overflow-inline",
            "pointer",
            "prefers-color-scheme",
            "prefers-contrast",
            "prefers-reduced-motion",
            "prefers-reduced-transparency",
            "resolution",
            "scan",
            "scripting",
            "update",
            "width",
            "min-width",
            "max-width",
            "min-height",
            "max-height"
        ], a = [
            "active",
            "any-link",
            "blank",
            "checked",
            "current",
            "default",
            "defined",
            "dir",
            "disabled",
            "drop",
            "empty",
            "enabled",
            "first",
            "first-child",
            "first-of-type",
            "fullscreen",
            "future",
            "focus",
            "focus-visible",
            "focus-within",
            "has",
            "host",
            "host-context",
            "hover",
            "indeterminate",
            "in-range",
            "invalid",
            "is",
            "lang",
            "last-child",
            "last-of-type",
            "left",
            "link",
            "local-link",
            "not",
            "nth-child",
            "nth-col",
            "nth-last-child",
            "nth-last-col",
            "nth-last-of-type",
            "nth-of-type",
            "only-child",
            "only-of-type",
            "optional",
            "out-of-range",
            "past",
            "placeholder-shown",
            "read-only",
            "read-write",
            "required",
            "right",
            "root",
            "scope",
            "target",
            "target-within",
            "user-invalid",
            "valid",
            "visited",
            "where"
        ], n = [
            "after",
            "backdrop",
            "before",
            "cue",
            "cue-region",
            "first-letter",
            "first-line",
            "grammar-error",
            "marker",
            "part",
            "placeholder",
            "selection",
            "slotted",
            "spelling-error"
        ], i = [
            "align-content",
            "align-items",
            "align-self",
            "all",
            "animation",
            "animation-delay",
            "animation-direction",
            "animation-duration",
            "animation-fill-mode",
            "animation-iteration-count",
            "animation-name",
            "animation-play-state",
            "animation-timing-function",
            "backface-visibility",
            "background",
            "background-attachment",
            "background-blend-mode",
            "background-clip",
            "background-color",
            "background-image",
            "background-origin",
            "background-position",
            "background-repeat",
            "background-size",
            "block-size",
            "border",
            "border-block",
            "border-block-color",
            "border-block-end",
            "border-block-end-color",
            "border-block-end-style",
            "border-block-end-width",
            "border-block-start",
            "border-block-start-color",
            "border-block-start-style",
            "border-block-start-width",
            "border-block-style",
            "border-block-width",
            "border-bottom",
            "border-bottom-color",
            "border-bottom-left-radius",
            "border-bottom-right-radius",
            "border-bottom-style",
            "border-bottom-width",
            "border-collapse",
            "border-color",
            "border-image",
            "border-image-outset",
            "border-image-repeat",
            "border-image-slice",
            "border-image-source",
            "border-image-width",
            "border-inline",
            "border-inline-color",
            "border-inline-end",
            "border-inline-end-color",
            "border-inline-end-style",
            "border-inline-end-width",
            "border-inline-start",
            "border-inline-start-color",
            "border-inline-start-style",
            "border-inline-start-width",
            "border-inline-style",
            "border-inline-width",
            "border-left",
            "border-left-color",
            "border-left-style",
            "border-left-width",
            "border-radius",
            "border-right",
            "border-right-color",
            "border-right-style",
            "border-right-width",
            "border-spacing",
            "border-style",
            "border-top",
            "border-top-color",
            "border-top-left-radius",
            "border-top-right-radius",
            "border-top-style",
            "border-top-width",
            "border-width",
            "bottom",
            "box-decoration-break",
            "box-shadow",
            "box-sizing",
            "break-after",
            "break-before",
            "break-inside",
            "caption-side",
            "caret-color",
            "clear",
            "clip",
            "clip-path",
            "clip-rule",
            "color",
            "column-count",
            "column-fill",
            "column-gap",
            "column-rule",
            "column-rule-color",
            "column-rule-style",
            "column-rule-width",
            "column-span",
            "column-width",
            "columns",
            "contain",
            "content",
            "content-visibility",
            "counter-increment",
            "counter-reset",
            "cue",
            "cue-after",
            "cue-before",
            "cursor",
            "direction",
            "display",
            "empty-cells",
            "filter",
            "flex",
            "flex-basis",
            "flex-direction",
            "flex-flow",
            "flex-grow",
            "flex-shrink",
            "flex-wrap",
            "float",
            "flow",
            "font",
            "font-display",
            "font-family",
            "font-feature-settings",
            "font-kerning",
            "font-language-override",
            "font-size",
            "font-size-adjust",
            "font-smoothing",
            "font-stretch",
            "font-style",
            "font-synthesis",
            "font-variant",
            "font-variant-caps",
            "font-variant-east-asian",
            "font-variant-ligatures",
            "font-variant-numeric",
            "font-variant-position",
            "font-variation-settings",
            "font-weight",
            "gap",
            "glyph-orientation-vertical",
            "grid",
            "grid-area",
            "grid-auto-columns",
            "grid-auto-flow",
            "grid-auto-rows",
            "grid-column",
            "grid-column-end",
            "grid-column-start",
            "grid-gap",
            "grid-row",
            "grid-row-end",
            "grid-row-start",
            "grid-template",
            "grid-template-areas",
            "grid-template-columns",
            "grid-template-rows",
            "hanging-punctuation",
            "height",
            "hyphens",
            "icon",
            "image-orientation",
            "image-rendering",
            "image-resolution",
            "ime-mode",
            "inline-size",
            "isolation",
            "justify-content",
            "left",
            "letter-spacing",
            "line-break",
            "line-height",
            "list-style",
            "list-style-image",
            "list-style-position",
            "list-style-type",
            "margin",
            "margin-block",
            "margin-block-end",
            "margin-block-start",
            "margin-bottom",
            "margin-inline",
            "margin-inline-end",
            "margin-inline-start",
            "margin-left",
            "margin-right",
            "margin-top",
            "marks",
            "mask",
            "mask-border",
            "mask-border-mode",
            "mask-border-outset",
            "mask-border-repeat",
            "mask-border-slice",
            "mask-border-source",
            "mask-border-width",
            "mask-clip",
            "mask-composite",
            "mask-image",
            "mask-mode",
            "mask-origin",
            "mask-position",
            "mask-repeat",
            "mask-size",
            "mask-type",
            "max-block-size",
            "max-height",
            "max-inline-size",
            "max-width",
            "min-block-size",
            "min-height",
            "min-inline-size",
            "min-width",
            "mix-blend-mode",
            "nav-down",
            "nav-index",
            "nav-left",
            "nav-right",
            "nav-up",
            "none",
            "normal",
            "object-fit",
            "object-position",
            "opacity",
            "order",
            "orphans",
            "outline",
            "outline-color",
            "outline-offset",
            "outline-style",
            "outline-width",
            "overflow",
            "overflow-wrap",
            "overflow-x",
            "overflow-y",
            "padding",
            "padding-block",
            "padding-block-end",
            "padding-block-start",
            "padding-bottom",
            "padding-inline",
            "padding-inline-end",
            "padding-inline-start",
            "padding-left",
            "padding-right",
            "padding-top",
            "page-break-after",
            "page-break-before",
            "page-break-inside",
            "pause",
            "pause-after",
            "pause-before",
            "perspective",
            "perspective-origin",
            "pointer-events",
            "position",
            "quotes",
            "resize",
            "rest",
            "rest-after",
            "rest-before",
            "right",
            "row-gap",
            "scroll-margin",
            "scroll-margin-block",
            "scroll-margin-block-end",
            "scroll-margin-block-start",
            "scroll-margin-bottom",
            "scroll-margin-inline",
            "scroll-margin-inline-end",
            "scroll-margin-inline-start",
            "scroll-margin-left",
            "scroll-margin-right",
            "scroll-margin-top",
            "scroll-padding",
            "scroll-padding-block",
            "scroll-padding-block-end",
            "scroll-padding-block-start",
            "scroll-padding-bottom",
            "scroll-padding-inline",
            "scroll-padding-inline-end",
            "scroll-padding-inline-start",
            "scroll-padding-left",
            "scroll-padding-right",
            "scroll-padding-top",
            "scroll-snap-align",
            "scroll-snap-stop",
            "scroll-snap-type",
            "scrollbar-color",
            "scrollbar-gutter",
            "scrollbar-width",
            "shape-image-threshold",
            "shape-margin",
            "shape-outside",
            "speak",
            "speak-as",
            "src",
            "tab-size",
            "table-layout",
            "text-align",
            "text-align-all",
            "text-align-last",
            "text-combine-upright",
            "text-decoration",
            "text-decoration-color",
            "text-decoration-line",
            "text-decoration-style",
            "text-emphasis",
            "text-emphasis-color",
            "text-emphasis-position",
            "text-emphasis-style",
            "text-indent",
            "text-justify",
            "text-orientation",
            "text-overflow",
            "text-rendering",
            "text-shadow",
            "text-transform",
            "text-underline-position",
            "top",
            "transform",
            "transform-box",
            "transform-origin",
            "transform-style",
            "transition",
            "transition-delay",
            "transition-duration",
            "transition-property",
            "transition-timing-function",
            "unicode-bidi",
            "vertical-align",
            "visibility",
            "voice-balance",
            "voice-duration",
            "voice-family",
            "voice-pitch",
            "voice-range",
            "voice-rate",
            "voice-stress",
            "voice-volume",
            "white-space",
            "widows",
            "width",
            "will-change",
            "word-break",
            "word-spacing",
            "word-wrap",
            "writing-mode",
            "z-index"
        ].reverse(), r = a.concat(n);
        return qn = function(o) {
            const s = ((e)=>({
                    IMPORTANT: {
                        scope: "meta",
                        begin: "!important"
                    },
                    BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
                    HEXCOLOR: {
                        scope: "number",
                        begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
                    },
                    FUNCTION_DISPATCH: {
                        className: "built_in",
                        begin: /[\w-]+(?=\()/
                    },
                    ATTRIBUTE_SELECTOR_MODE: {
                        scope: "selector-attr",
                        begin: /\[/,
                        end: /\]/,
                        illegal: "$",
                        contains: [
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    CSS_NUMBER_MODE: {
                        scope: "number",
                        begin: e.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
                        relevance: 0
                    },
                    CSS_VARIABLE: {
                        className: "attr",
                        begin: /--[A-Za-z_][A-Za-z0-9_-]*/
                    }
                }))(o), l = r, c = "[\\w-]+", _ = "(" + c + "|@\\{" + c + "\\})", d = [], m = [], p = function(e) {
                return {
                    className: "string",
                    begin: "~?" + e + ".*?" + e
                };
            }, u = function(e, t, a) {
                return {
                    className: e,
                    begin: t,
                    relevance: a
                };
            }, g = {
                $pattern: /[a-z-]+/,
                keyword: "and or not only",
                attribute: t.join(" ")
            }, E = {
                begin: "\\(",
                end: "\\)",
                contains: m,
                keywords: g,
                relevance: 0
            };
            m.push(o.C_LINE_COMMENT_MODE, o.C_BLOCK_COMMENT_MODE, p("'"), p('"'), s.CSS_NUMBER_MODE, {
                begin: "(url|data-uri)\\(",
                starts: {
                    className: "string",
                    end: "[\\)\\n]",
                    excludeEnd: !0
                }
            }, s.HEXCOLOR, E, u("variable", "@@?" + c, 10), u("variable", "@\\{" + c + "\\}"), u("built_in", "~?`[^`]*?`"), {
                className: "attribute",
                begin: c + "\\s*:",
                end: ":",
                returnBegin: !0,
                excludeEnd: !0
            }, s.IMPORTANT, {
                beginKeywords: "and not"
            }, s.FUNCTION_DISPATCH);
            const S = m.concat({
                begin: /\{/,
                end: /\}/,
                contains: d
            }), b = {
                beginKeywords: "when",
                endsWithParent: !0,
                contains: [
                    {
                        beginKeywords: "and not"
                    }
                ].concat(m)
            }, T = {
                begin: _ + "\\s*:",
                returnBegin: !0,
                end: /[;}]/,
                relevance: 0,
                contains: [
                    {
                        begin: /-(webkit|moz|ms|o)-/
                    },
                    s.CSS_VARIABLE,
                    {
                        className: "attribute",
                        begin: "\\b(" + i.join("|") + ")\\b",
                        end: /(?=:)/,
                        starts: {
                            endsWithParent: !0,
                            illegal: "[<=$]",
                            relevance: 0,
                            contains: m
                        }
                    }
                ]
            }, C = {
                className: "keyword",
                begin: "@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b",
                starts: {
                    end: "[;{}]",
                    keywords: g,
                    returnEnd: !0,
                    contains: m,
                    relevance: 0
                }
            }, f = {
                className: "variable",
                variants: [
                    {
                        begin: "@" + c + "\\s*:",
                        relevance: 15
                    },
                    {
                        begin: "@" + c
                    }
                ],
                starts: {
                    end: "[;}]",
                    returnEnd: !0,
                    contains: S
                }
            }, R = {
                variants: [
                    {
                        begin: "[\\.#:&\\[>]",
                        end: "[;{}]"
                    },
                    {
                        begin: _,
                        end: /\{/
                    }
                ],
                returnBegin: !0,
                returnEnd: !0,
                illegal: "[<='$\"]",
                relevance: 0,
                contains: [
                    o.C_LINE_COMMENT_MODE,
                    o.C_BLOCK_COMMENT_MODE,
                    b,
                    u("keyword", "all\\b"),
                    u("variable", "@\\{" + c + "\\}"),
                    {
                        begin: "\\b(" + e.join("|") + ")\\b",
                        className: "selector-tag"
                    },
                    s.CSS_NUMBER_MODE,
                    u("selector-tag", _, 0),
                    u("selector-id", "#" + _),
                    u("selector-class", "\\." + _, 0),
                    u("selector-tag", "&", 0),
                    s.ATTRIBUTE_SELECTOR_MODE,
                    {
                        className: "selector-pseudo",
                        begin: ":(" + a.join("|") + ")"
                    },
                    {
                        className: "selector-pseudo",
                        begin: ":(:)?(" + n.join("|") + ")"
                    },
                    {
                        begin: /\(/,
                        end: /\)/,
                        relevance: 0,
                        contains: S
                    },
                    {
                        begin: "!important"
                    },
                    s.FUNCTION_DISPATCH
                ]
            }, N = {
                begin: c + ":(:)?" + `(${l.join("|")})`,
                returnBegin: !0,
                contains: [
                    R
                ]
            };
            return d.push(o.C_LINE_COMMENT_MODE, o.C_BLOCK_COMMENT_MODE, C, f, N, T, R, b, s.FUNCTION_DISPATCH), {
                name: "Less",
                case_insensitive: !0,
                illegal: "[=>'/<($\"]",
                contains: d
            };
        }, qn;
    }()), Cs.registerLanguage("lisp", (Wn || (Wn = 1, $n = function(e) {
        const t = "[a-zA-Z_\\-+\\*\\/<=>&#][a-zA-Z0-9_\\-+*\\/<=>&#!]*", a = "\\|[^]*?\\|", n = "(-|\\+)?\\d+(\\.\\d+|\\/\\d+)?((d|e|f|l|s|D|E|F|L|S)(\\+|-)?\\d+)?", i = {
            className: "literal",
            begin: "\\b(t{1}|nil)\\b"
        }, r = {
            className: "number",
            variants: [
                {
                    begin: n,
                    relevance: 0
                },
                {
                    begin: "#(b|B)[0-1]+(/[0-1]+)?"
                },
                {
                    begin: "#(o|O)[0-7]+(/[0-7]+)?"
                },
                {
                    begin: "#(x|X)[0-9a-fA-F]+(/[0-9a-fA-F]+)?"
                },
                {
                    begin: "#(c|C)\\(" + n + " +" + n,
                    end: "\\)"
                }
            ]
        }, o = e.inherit(e.QUOTE_STRING_MODE, {
            illegal: null
        }), s = e.COMMENT(";", "$", {
            relevance: 0
        }), l = {
            begin: "\\*",
            end: "\\*"
        }, c = {
            className: "symbol",
            begin: "[:&]" + t
        }, _ = {
            begin: t,
            relevance: 0
        }, d = {
            begin: a
        }, m = {
            contains: [
                r,
                o,
                l,
                c,
                {
                    begin: "\\(",
                    end: "\\)",
                    contains: [
                        "self",
                        i,
                        o,
                        r,
                        _
                    ]
                },
                _
            ],
            variants: [
                {
                    begin: "['`]\\(",
                    end: "\\)"
                },
                {
                    begin: "\\(quote ",
                    end: "\\)",
                    keywords: {
                        name: "quote"
                    }
                },
                {
                    begin: "'" + a
                }
            ]
        }, p = {
            variants: [
                {
                    begin: "'" + t
                },
                {
                    begin: "#'" + t + "(::" + t + ")*"
                }
            ]
        }, u = {
            begin: "\\(\\s*",
            end: "\\)"
        }, g = {
            endsWithParent: !0,
            relevance: 0
        };
        return u.contains = [
            {
                className: "name",
                variants: [
                    {
                        begin: t,
                        relevance: 0
                    },
                    {
                        begin: a
                    }
                ]
            },
            g
        ], g.contains = [
            m,
            p,
            u,
            i,
            r,
            o,
            s,
            l,
            c,
            d,
            _
        ], {
            name: "Lisp",
            illegal: /\S/,
            contains: [
                r,
                e.SHEBANG(),
                i,
                o,
                s,
                m,
                p,
                u,
                _
            ]
        };
    }), $n)), Cs.registerLanguage("livecodeserver", (Kn || (Kn = 1, Qn = function(e) {
        const t = {
            className: "variable",
            variants: [
                {
                    begin: "\\b([gtps][A-Z]{1}[a-zA-Z0-9]*)(\\[.+\\])?(?:\\s*?)"
                },
                {
                    begin: "\\$_[A-Z]+"
                }
            ],
            relevance: 0
        }, a = [
            e.C_BLOCK_COMMENT_MODE,
            e.HASH_COMMENT_MODE,
            e.COMMENT("--", "$"),
            e.COMMENT("[^:]//", "$")
        ], n = e.inherit(e.TITLE_MODE, {
            variants: [
                {
                    begin: "\\b_*rig[A-Z][A-Za-z0-9_\\-]*"
                },
                {
                    begin: "\\b_[a-z0-9\\-]+"
                }
            ]
        }), i = e.inherit(e.TITLE_MODE, {
            begin: "\\b([A-Za-z0-9_\\-]+)\\b"
        });
        return {
            name: "LiveCode",
            case_insensitive: !1,
            keywords: {
                keyword: "$_COOKIE $_FILES $_GET $_GET_BINARY $_GET_RAW $_POST $_POST_BINARY $_POST_RAW $_SESSION $_SERVER codepoint codepoints segment segments codeunit codeunits sentence sentences trueWord trueWords paragraph after byte bytes english the until http forever descending using line real8 with seventh for stdout finally element word words fourth before black ninth sixth characters chars stderr uInt1 uInt1s uInt2 uInt2s stdin string lines relative rel any fifth items from middle mid at else of catch then third it file milliseconds seconds second secs sec int1 int1s int4 int4s internet int2 int2s normal text item last long detailed effective uInt4 uInt4s repeat end repeat URL in try into switch to words https token binfile each tenth as ticks tick system real4 by dateItems without char character ascending eighth whole dateTime numeric short first ftp integer abbreviated abbr abbrev private case while if div mod wrap and or bitAnd bitNot bitOr bitXor among not in a an within contains ends with begins the keys of keys",
                literal: "SIX TEN FORMFEED NINE ZERO NONE SPACE FOUR FALSE COLON CRLF PI COMMA ENDOFFILE EOF EIGHT FIVE QUOTE EMPTY ONE TRUE RETURN CR LINEFEED RIGHT BACKSLASH NULL SEVEN TAB THREE TWO six ten formfeed nine zero none space four false colon crlf pi comma endoffile eof eight five quote empty one true return cr linefeed right backslash null seven tab three two RIVERSION RISTATE FILE_READ_MODE FILE_WRITE_MODE FILE_WRITE_MODE DIR_WRITE_MODE FILE_READ_UMASK FILE_WRITE_UMASK DIR_READ_UMASK DIR_WRITE_UMASK",
                built_in: "put abs acos aliasReference annuity arrayDecode arrayEncode asin atan atan2 average avg avgDev base64Decode base64Encode baseConvert binaryDecode binaryEncode byteOffset byteToNum cachedURL cachedURLs charToNum cipherNames codepointOffset codepointProperty codepointToNum codeunitOffset commandNames compound compress constantNames cos date dateFormat decompress difference directories diskSpace DNSServers exp exp1 exp2 exp10 extents files flushEvents folders format functionNames geometricMean global globals hasMemory harmonicMean hostAddress hostAddressToName hostName hostNameToAddress isNumber ISOToMac itemOffset keys len length libURLErrorData libUrlFormData libURLftpCommand libURLLastHTTPHeaders libURLLastRHHeaders libUrlMultipartFormAddPart libUrlMultipartFormData libURLVersion lineOffset ln ln1 localNames log log2 log10 longFilePath lower macToISO matchChunk matchText matrixMultiply max md5Digest median merge messageAuthenticationCode messageDigest millisec millisecs millisecond milliseconds min monthNames nativeCharToNum normalizeText num number numToByte numToChar numToCodepoint numToNativeChar offset open openfiles openProcesses openProcessIDs openSockets paragraphOffset paramCount param params peerAddress pendingMessages platform popStdDev populationStandardDeviation populationVariance popVariance processID random randomBytes replaceText result revCreateXMLTree revCreateXMLTreeFromFile revCurrentRecord revCurrentRecordIsFirst revCurrentRecordIsLast revDatabaseColumnCount revDatabaseColumnIsNull revDatabaseColumnLengths revDatabaseColumnNames revDatabaseColumnNamed revDatabaseColumnNumbered revDatabaseColumnTypes revDatabaseConnectResult revDatabaseCursors revDatabaseID revDatabaseTableNames revDatabaseType revDataFromQuery revdb_closeCursor revdb_columnbynumber revdb_columncount revdb_columnisnull revdb_columnlengths revdb_columnnames revdb_columntypes revdb_commit revdb_connect revdb_connections revdb_connectionerr revdb_currentrecord revdb_cursorconnection revdb_cursorerr revdb_cursors revdb_dbtype revdb_disconnect revdb_execute revdb_iseof revdb_isbof revdb_movefirst revdb_movelast revdb_movenext revdb_moveprev revdb_query revdb_querylist revdb_recordcount revdb_rollback revdb_tablenames revGetDatabaseDriverPath revNumberOfRecords revOpenDatabase revOpenDatabases revQueryDatabase revQueryDatabaseBlob revQueryResult revQueryIsAtStart revQueryIsAtEnd revUnixFromMacPath revXMLAttribute revXMLAttributes revXMLAttributeValues revXMLChildContents revXMLChildNames revXMLCreateTreeFromFileWithNamespaces revXMLCreateTreeWithNamespaces revXMLDataFromXPathQuery revXMLEvaluateXPath revXMLFirstChild revXMLMatchingNode revXMLNextSibling revXMLNodeContents revXMLNumberOfChildren revXMLParent revXMLPreviousSibling revXMLRootNode revXMLRPC_CreateRequest revXMLRPC_Documents revXMLRPC_Error revXMLRPC_GetHost revXMLRPC_GetMethod revXMLRPC_GetParam revXMLText revXMLRPC_Execute revXMLRPC_GetParamCount revXMLRPC_GetParamNode revXMLRPC_GetParamType revXMLRPC_GetPath revXMLRPC_GetPort revXMLRPC_GetProtocol revXMLRPC_GetRequest revXMLRPC_GetResponse revXMLRPC_GetSocket revXMLTree revXMLTrees revXMLValidateDTD revZipDescribeItem revZipEnumerateItems revZipOpenArchives round sampVariance sec secs seconds sentenceOffset sha1Digest shell shortFilePath sin specialFolderPath sqrt standardDeviation statRound stdDev sum sysError systemVersion tan tempName textDecode textEncode tick ticks time to tokenOffset toLower toUpper transpose truewordOffset trunc uniDecode uniEncode upper URLDecode URLEncode URLStatus uuid value variableNames variance version waitDepth weekdayNames wordOffset xsltApplyStylesheet xsltApplyStylesheetFromFile xsltLoadStylesheet xsltLoadStylesheetFromFile add breakpoint cancel clear local variable file word line folder directory URL close socket process combine constant convert create new alias folder directory decrypt delete variable word line folder directory URL dispatch divide do encrypt filter get include intersect kill libURLDownloadToFile libURLFollowHttpRedirects libURLftpUpload libURLftpUploadFile libURLresetAll libUrlSetAuthCallback libURLSetDriver libURLSetCustomHTTPHeaders libUrlSetExpect100 libURLSetFTPListCommand libURLSetFTPMode libURLSetFTPStopTime libURLSetStatusCallback load extension loadedExtensions multiply socket prepare process post seek rel relative read from process rename replace require resetAll resolve revAddXMLNode revAppendXML revCloseCursor revCloseDatabase revCommitDatabase revCopyFile revCopyFolder revCopyXMLNode revDeleteFolder revDeleteXMLNode revDeleteAllXMLTrees revDeleteXMLTree revExecuteSQL revGoURL revInsertXMLNode revMoveFolder revMoveToFirstRecord revMoveToLastRecord revMoveToNextRecord revMoveToPreviousRecord revMoveToRecord revMoveXMLNode revPutIntoXMLNode revRollBackDatabase revSetDatabaseDriverPath revSetXMLAttribute revXMLRPC_AddParam revXMLRPC_DeleteAllDocuments revXMLAddDTD revXMLRPC_Free revXMLRPC_FreeAll revXMLRPC_DeleteDocument revXMLRPC_DeleteParam revXMLRPC_SetHost revXMLRPC_SetMethod revXMLRPC_SetPort revXMLRPC_SetProtocol revXMLRPC_SetSocket revZipAddItemWithData revZipAddItemWithFile revZipAddUncompressedItemWithData revZipAddUncompressedItemWithFile revZipCancel revZipCloseArchive revZipDeleteItem revZipExtractItemToFile revZipExtractItemToVariable revZipSetProgressCallback revZipRenameItem revZipReplaceItemWithData revZipReplaceItemWithFile revZipOpenArchive send set sort split start stop subtract symmetric union unload vectorDotProduct wait write"
            },
            contains: [
                t,
                {
                    className: "keyword",
                    begin: "\\bend\\sif\\b"
                },
                {
                    className: "function",
                    beginKeywords: "function",
                    end: "$",
                    contains: [
                        t,
                        i,
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE,
                        e.BINARY_NUMBER_MODE,
                        e.C_NUMBER_MODE,
                        n
                    ]
                },
                {
                    className: "function",
                    begin: "\\bend\\s+",
                    end: "$",
                    keywords: "end",
                    contains: [
                        i,
                        n
                    ],
                    relevance: 0
                },
                {
                    beginKeywords: "command on",
                    end: "$",
                    contains: [
                        t,
                        i,
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE,
                        e.BINARY_NUMBER_MODE,
                        e.C_NUMBER_MODE,
                        n
                    ]
                },
                {
                    className: "meta",
                    variants: [
                        {
                            begin: "<\\?(rev|lc|livecode)",
                            relevance: 10
                        },
                        {
                            begin: "<\\?"
                        },
                        {
                            begin: "\\?>"
                        }
                    ]
                },
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.BINARY_NUMBER_MODE,
                e.C_NUMBER_MODE,
                n
            ].concat(a),
            illegal: ";$|^\\[|^=|&|\\{"
        };
    }), Qn)), Cs.registerLanguage("livescript", function() {
        if (Xn) return jn;
        Xn = 1;
        const e = [
            "as",
            "in",
            "of",
            "if",
            "for",
            "while",
            "finally",
            "var",
            "new",
            "function",
            "do",
            "return",
            "void",
            "else",
            "break",
            "catch",
            "instanceof",
            "with",
            "throw",
            "case",
            "default",
            "try",
            "switch",
            "continue",
            "typeof",
            "delete",
            "let",
            "yield",
            "const",
            "class",
            "debugger",
            "async",
            "await",
            "static",
            "import",
            "from",
            "export",
            "extends"
        ], t = [
            "true",
            "false",
            "null",
            "undefined",
            "NaN",
            "Infinity"
        ], a = [].concat([
            "setInterval",
            "setTimeout",
            "clearInterval",
            "clearTimeout",
            "require",
            "exports",
            "eval",
            "isFinite",
            "isNaN",
            "parseFloat",
            "parseInt",
            "decodeURI",
            "decodeURIComponent",
            "encodeURI",
            "encodeURIComponent",
            "escape",
            "unescape"
        ], [
            "Object",
            "Function",
            "Boolean",
            "Symbol",
            "Math",
            "Date",
            "Number",
            "BigInt",
            "String",
            "RegExp",
            "Array",
            "Float32Array",
            "Float64Array",
            "Int8Array",
            "Uint8Array",
            "Uint8ClampedArray",
            "Int16Array",
            "Int32Array",
            "Uint16Array",
            "Uint32Array",
            "BigInt64Array",
            "BigUint64Array",
            "Set",
            "Map",
            "WeakSet",
            "WeakMap",
            "ArrayBuffer",
            "SharedArrayBuffer",
            "Atomics",
            "DataView",
            "JSON",
            "Promise",
            "Generator",
            "GeneratorFunction",
            "AsyncFunction",
            "Reflect",
            "Proxy",
            "Intl",
            "WebAssembly"
        ], [
            "Error",
            "EvalError",
            "InternalError",
            "RangeError",
            "ReferenceError",
            "SyntaxError",
            "TypeError",
            "URIError"
        ]);
        return jn = function(n) {
            const i = {
                keyword: e.concat([
                    "then",
                    "unless",
                    "until",
                    "loop",
                    "of",
                    "by",
                    "when",
                    "and",
                    "or",
                    "is",
                    "isnt",
                    "not",
                    "it",
                    "that",
                    "otherwise",
                    "from",
                    "to",
                    "til",
                    "fallthrough",
                    "case",
                    "enum",
                    "native",
                    "list",
                    "map",
                    "__hasProp",
                    "__extends",
                    "__slice",
                    "__bind",
                    "__indexOf"
                ]),
                literal: t.concat([
                    "yes",
                    "no",
                    "on",
                    "off",
                    "it",
                    "that",
                    "void"
                ]),
                built_in: a.concat([
                    "npm",
                    "print"
                ])
            }, r = "[A-Za-z$_](?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*", o = n.inherit(n.TITLE_MODE, {
                begin: r
            }), s = {
                className: "subst",
                begin: /#\{/,
                end: /\}/,
                keywords: i
            }, l = {
                className: "subst",
                begin: /#[A-Za-z$_]/,
                end: /(?:-[0-9A-Za-z$_]|[0-9A-Za-z$_])*/,
                keywords: i
            }, c = [
                n.BINARY_NUMBER_MODE,
                {
                    className: "number",
                    begin: "(\\b0[xX][a-fA-F0-9_]+)|(\\b\\d(\\d|_\\d)*(\\.(\\d(\\d|_\\d)*)?)?(_*[eE]([-+]\\d(_\\d|\\d)*)?)?[_a-z]*)",
                    relevance: 0,
                    starts: {
                        end: "(\\s*/)?",
                        relevance: 0
                    }
                },
                {
                    className: "string",
                    variants: [
                        {
                            begin: /'''/,
                            end: /'''/,
                            contains: [
                                n.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /'/,
                            end: /'/,
                            contains: [
                                n.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            begin: /"""/,
                            end: /"""/,
                            contains: [
                                n.BACKSLASH_ESCAPE,
                                s,
                                l
                            ]
                        },
                        {
                            begin: /"/,
                            end: /"/,
                            contains: [
                                n.BACKSLASH_ESCAPE,
                                s,
                                l
                            ]
                        },
                        {
                            begin: /\\/,
                            end: /(\s|$)/,
                            excludeEnd: !0
                        }
                    ]
                },
                {
                    className: "regexp",
                    variants: [
                        {
                            begin: "//",
                            end: "//[gim]*",
                            contains: [
                                s,
                                n.HASH_COMMENT_MODE
                            ]
                        },
                        {
                            begin: /\/(?![ *])(\\.|[^\\\n])*?\/[gim]*(?=\W)/
                        }
                    ]
                },
                {
                    begin: "@" + r
                },
                {
                    begin: "``",
                    end: "``",
                    excludeBegin: !0,
                    excludeEnd: !0,
                    subLanguage: "javascript"
                }
            ];
            s.contains = c;
            const _ = {
                className: "params",
                begin: "\\(",
                returnBegin: !0,
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        keywords: i,
                        contains: [
                            "self"
                        ].concat(c)
                    }
                ]
            }, d = {
                variants: [
                    {
                        match: [
                            /class\s+/,
                            r,
                            /\s+extends\s+/,
                            r
                        ]
                    },
                    {
                        match: [
                            /class\s+/,
                            r
                        ]
                    }
                ],
                scope: {
                    2: "title.class",
                    4: "title.class.inherited"
                },
                keywords: i
            };
            return {
                name: "LiveScript",
                aliases: [
                    "ls"
                ],
                keywords: i,
                illegal: /\/\*/,
                contains: c.concat([
                    n.COMMENT("\\/\\*", "\\*\\/"),
                    n.HASH_COMMENT_MODE,
                    {
                        begin: "(#=>|=>|\\|>>|-?->|!->)"
                    },
                    {
                        className: "function",
                        contains: [
                            o,
                            _
                        ],
                        returnBegin: !0,
                        variants: [
                            {
                                begin: "(" + r + "\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B->\\*?",
                                end: "->\\*?"
                            },
                            {
                                begin: "(" + r + "\\s*(?:=|:=)\\s*)?!?(\\(.*\\)\\s*)?\\B[-~]{1,2}>\\*?",
                                end: "[-~]{1,2}>\\*?"
                            },
                            {
                                begin: "(" + r + "\\s*(?:=|:=)\\s*)?(\\(.*\\)\\s*)?\\B!?[-~]{1,2}>\\*?",
                                end: "!?[-~]{1,2}>\\*?"
                            }
                        ]
                    },
                    d,
                    {
                        begin: r + ":",
                        end: ":",
                        returnBegin: !0,
                        returnEnd: !0,
                        relevance: 0
                    }
                ])
            };
        }, jn;
    }()), Cs.registerLanguage("llvm", (Jn || (Jn = 1, Zn = function(e) {
        const t = e.regex, a = /([-a-zA-Z$._][\w$.-]*)/, n = {
            className: "variable",
            variants: [
                {
                    begin: t.concat(/%/, a)
                },
                {
                    begin: /%\d+/
                },
                {
                    begin: /#\d+/
                }
            ]
        }, i = {
            className: "title",
            variants: [
                {
                    begin: t.concat(/@/, a)
                },
                {
                    begin: /@\d+/
                },
                {
                    begin: t.concat(/!/, a)
                },
                {
                    begin: t.concat(/!\d+/, a)
                },
                {
                    begin: /!\d+/
                }
            ]
        };
        return {
            name: "LLVM IR",
            keywords: "begin end true false declare define global constant private linker_private internal available_externally linkonce linkonce_odr weak weak_odr appending dllimport dllexport common default hidden protected extern_weak external thread_local zeroinitializer undef null to tail target triple datalayout volatile nuw nsw nnan ninf nsz arcp fast exact inbounds align addrspace section alias module asm sideeffect gc dbg linker_private_weak attributes blockaddress initialexec localdynamic localexec prefix unnamed_addr ccc fastcc coldcc x86_stdcallcc x86_fastcallcc arm_apcscc arm_aapcscc arm_aapcs_vfpcc ptx_device ptx_kernel intel_ocl_bicc msp430_intrcc spir_func spir_kernel x86_64_sysvcc x86_64_win64cc x86_thiscallcc cc c signext zeroext inreg sret nounwind noreturn noalias nocapture byval nest readnone readonly inlinehint noinline alwaysinline optsize ssp sspreq noredzone noimplicitfloat naked builtin cold nobuiltin noduplicate nonlazybind optnone returns_twice sanitize_address sanitize_memory sanitize_thread sspstrong uwtable returned type opaque eq ne slt sgt sle sge ult ugt ule uge oeq one olt ogt ole oge ord uno ueq une x acq_rel acquire alignstack atomic catch cleanup filter inteldialect max min monotonic nand personality release seq_cst singlethread umax umin unordered xchg add fadd sub fsub mul fmul udiv sdiv fdiv urem srem frem shl lshr ashr and or xor icmp fcmp phi call trunc zext sext fptrunc fpext uitofp sitofp fptoui fptosi inttoptr ptrtoint bitcast addrspacecast select va_arg ret br switch invoke unwind unreachable indirectbr landingpad resume malloc alloca free load store getelementptr extractelement insertelement shufflevector getresult extractvalue insertvalue atomicrmw cmpxchg fence argmemonly double",
            contains: [
                {
                    className: "type",
                    begin: /\bi\d+(?=\s|\b)/
                },
                e.COMMENT(/;\s*$/, null, {
                    relevance: 0
                }),
                e.COMMENT(/;/, /$/),
                {
                    className: "string",
                    begin: /"/,
                    end: /"/,
                    contains: [
                        {
                            className: "char.escape",
                            match: /\\\d\d/
                        }
                    ]
                },
                i,
                {
                    className: "punctuation",
                    relevance: 0,
                    begin: /,/
                },
                {
                    className: "operator",
                    relevance: 0,
                    begin: /=/
                },
                n,
                {
                    className: "symbol",
                    variants: [
                        {
                            begin: /^\s*[a-z]+:/
                        }
                    ],
                    relevance: 0
                },
                {
                    className: "number",
                    variants: [
                        {
                            begin: /[su]?0[xX][KMLHR]?[a-fA-F0-9]+/
                        },
                        {
                            begin: /[-+]?\d+(?:[.]\d+)?(?:[eE][-+]?\d+(?:[.]\d+)?)?/
                        }
                    ],
                    relevance: 0
                }
            ]
        };
    }), Zn)), Cs.registerLanguage("lsl", (ti || (ti = 1, ei = function(e) {
        const t = {
            className: "string",
            begin: '"',
            end: '"',
            contains: [
                {
                    className: "subst",
                    begin: /\\[tn"\\]/
                }
            ]
        }, a = {
            className: "number",
            relevance: 0,
            begin: e.C_NUMBER_RE
        };
        return {
            name: "LSL (Linden Scripting Language)",
            illegal: ":",
            contains: [
                t,
                {
                    className: "comment",
                    variants: [
                        e.COMMENT("//", "$"),
                        e.COMMENT("/\\*", "\\*/")
                    ],
                    relevance: 0
                },
                a,
                {
                    className: "section",
                    variants: [
                        {
                            begin: "\\b(state|default)\\b"
                        },
                        {
                            begin: "\\b(state_(entry|exit)|touch(_(start|end))?|(land_)?collision(_(start|end))?|timer|listen|(no_)?sensor|control|(not_)?at_(rot_)?target|money|email|experience_permissions(_denied)?|run_time_permissions|changed|attach|dataserver|moving_(start|end)|link_message|(on|object)_rez|remote_data|http_re(sponse|quest)|path_update|transaction_result)\\b"
                        }
                    ]
                },
                {
                    className: "built_in",
                    begin: "\\b(ll(AgentInExperience|(Create|DataSize|Delete|KeyCount|Keys|Read|Update)KeyValue|GetExperience(Details|ErrorMessage)|ReturnObjectsBy(ID|Owner)|Json(2List|[GS]etValue|ValueType)|Sin|Cos|Tan|Atan2|Sqrt|Pow|Abs|Fabs|Frand|Floor|Ceil|Round|Vec(Mag|Norm|Dist)|Rot(Between|2(Euler|Fwd|Left|Up))|(Euler|Axes)2Rot|Whisper|(Region|Owner)?Say|Shout|Listen(Control|Remove)?|Sensor(Repeat|Remove)?|Detected(Name|Key|Owner|Type|Pos|Vel|Grab|Rot|Group|LinkNumber)|Die|Ground|Wind|([GS]et)(AnimationOverride|MemoryLimit|PrimMediaParams|ParcelMusicURL|Object(Desc|Name)|PhysicsMaterial|Status|Scale|Color|Alpha|Texture|Pos|Rot|Force|Torque)|ResetAnimationOverride|(Scale|Offset|Rotate)Texture|(Rot)?Target(Remove)?|(Stop)?MoveToTarget|Apply(Rotational)?Impulse|Set(KeyframedMotion|ContentType|RegionPos|(Angular)?Velocity|Buoyancy|HoverHeight|ForceAndTorque|TimerEvent|ScriptState|Damage|TextureAnim|Sound(Queueing|Radius)|Vehicle(Type|(Float|Vector|Rotation)Param)|(Touch|Sit)?Text|Camera(Eye|At)Offset|PrimitiveParams|ClickAction|Link(Alpha|Color|PrimitiveParams(Fast)?|Texture(Anim)?|Camera|Media)|RemoteScriptAccessPin|PayPrice|LocalRot)|ScaleByFactor|Get((Max|Min)ScaleFactor|ClosestNavPoint|StaticPath|SimStats|Env|PrimitiveParams|Link(PrimitiveParams|Number(OfSides)?|Key|Name|Media)|HTTPHeader|FreeURLs|Object(Details|PermMask|PrimCount)|Parcel(MaxPrims|Details|Prim(Count|Owners))|Attached(List)?|(SPMax|Free|Used)Memory|Region(Name|TimeDilation|FPS|Corner|AgentCount)|Root(Position|Rotation)|UnixTime|(Parcel|Region)Flags|(Wall|GMT)clock|SimulatorHostname|BoundingBox|GeometricCenter|Creator|NumberOf(Prims|NotecardLines|Sides)|Animation(List)?|(Camera|Local)(Pos|Rot)|Vel|Accel|Omega|Time(stamp|OfDay)|(Object|CenterOf)?Mass|MassMKS|Energy|Owner|(Owner)?Key|SunDirection|Texture(Offset|Scale|Rot)|Inventory(Number|Name|Key|Type|Creator|PermMask)|Permissions(Key)?|StartParameter|List(Length|EntryType)|Date|Agent(Size|Info|Language|List)|LandOwnerAt|NotecardLine|Script(Name|State))|(Get|Reset|GetAndReset)Time|PlaySound(Slave)?|LoopSound(Master|Slave)?|(Trigger|Stop|Preload)Sound|((Get|Delete)Sub|Insert)String|To(Upper|Lower)|Give(InventoryList|Money)|RezObject|(Stop)?LookAt|Sleep|CollisionFilter|(Take|Release)Controls|DetachFromAvatar|AttachToAvatar(Temp)?|InstantMessage|(GetNext)?Email|StopHover|MinEventDelay|RotLookAt|String(Length|Trim)|(Start|Stop)Animation|TargetOmega|Request(Experience)?Permissions|(Create|Break)Link|BreakAllLinks|(Give|Remove)Inventory|Water|PassTouches|Request(Agent|Inventory)Data|TeleportAgent(Home|GlobalCoords)?|ModifyLand|CollisionSound|ResetScript|MessageLinked|PushObject|PassCollisions|AxisAngle2Rot|Rot2(Axis|Angle)|A(cos|sin)|AngleBetween|AllowInventoryDrop|SubStringIndex|List2(CSV|Integer|Json|Float|String|Key|Vector|Rot|List(Strided)?)|DeleteSubList|List(Statistics|Sort|Randomize|(Insert|Find|Replace)List)|EdgeOfWorld|AdjustSoundVolume|Key2Name|TriggerSoundLimited|EjectFromLand|(CSV|ParseString)2List|OverMyLand|SameGroup|UnSit|Ground(Slope|Normal|Contour)|GroundRepel|(Set|Remove)VehicleFlags|SitOnLink|(AvatarOn)?(Link)?SitTarget|Script(Danger|Profiler)|Dialog|VolumeDetect|ResetOtherScript|RemoteLoadScriptPin|(Open|Close)RemoteDataChannel|SendRemoteData|RemoteDataReply|(Integer|String)ToBase64|XorBase64|Log(10)?|Base64To(String|Integer)|ParseStringKeepNulls|RezAtRoot|RequestSimulatorData|ForceMouselook|(Load|Release|(E|Une)scape)URL|ParcelMedia(CommandList|Query)|ModPow|MapDestination|(RemoveFrom|AddTo|Reset)Land(Pass|Ban)List|(Set|Clear)CameraParams|HTTP(Request|Response)|TextBox|DetectedTouch(UV|Face|Pos|(N|Bin)ormal|ST)|(MD5|SHA1|DumpList2)String|Request(Secure)?URL|Clear(Prim|Link)Media|(Link)?ParticleSystem|(Get|Request)(Username|DisplayName)|RegionSayTo|CastRay|GenerateKey|TransferLindenDollars|ManageEstateAccess|(Create|Delete)Character|ExecCharacterCmd|Evade|FleeFrom|NavigateTo|PatrolPoints|Pursue|UpdateCharacter|WanderWithin))\\b"
                },
                {
                    className: "literal",
                    variants: [
                        {
                            begin: "\\b(PI|TWO_PI|PI_BY_TWO|DEG_TO_RAD|RAD_TO_DEG|SQRT2)\\b"
                        },
                        {
                            begin: "\\b(XP_ERROR_(EXPERIENCES_DISABLED|EXPERIENCE_(DISABLED|SUSPENDED)|INVALID_(EXPERIENCE|PARAMETERS)|KEY_NOT_FOUND|MATURITY_EXCEEDED|NONE|NOT_(FOUND|PERMITTED(_LAND)?)|NO_EXPERIENCE|QUOTA_EXCEEDED|RETRY_UPDATE|STORAGE_EXCEPTION|STORE_DISABLED|THROTTLED|UNKNOWN_ERROR)|JSON_APPEND|STATUS_(PHYSICS|ROTATE_[XYZ]|PHANTOM|SANDBOX|BLOCK_GRAB(_OBJECT)?|(DIE|RETURN)_AT_EDGE|CAST_SHADOWS|OK|MALFORMED_PARAMS|TYPE_MISMATCH|BOUNDS_ERROR|NOT_(FOUND|SUPPORTED)|INTERNAL_ERROR|WHITELIST_FAILED)|AGENT(_(BY_(LEGACY_|USER)NAME|FLYING|ATTACHMENTS|SCRIPTED|MOUSELOOK|SITTING|ON_OBJECT|AWAY|WALKING|IN_AIR|TYPING|CROUCHING|BUSY|ALWAYS_RUN|AUTOPILOT|LIST_(PARCEL(_OWNER)?|REGION)))?|CAMERA_(PITCH|DISTANCE|BEHINDNESS_(ANGLE|LAG)|(FOCUS|POSITION)(_(THRESHOLD|LOCKED|LAG))?|FOCUS_OFFSET|ACTIVE)|ANIM_ON|LOOP|REVERSE|PING_PONG|SMOOTH|ROTATE|SCALE|ALL_SIDES|LINK_(ROOT|SET|ALL_(OTHERS|CHILDREN)|THIS)|ACTIVE|PASS(IVE|_(ALWAYS|IF_NOT_HANDLED|NEVER))|SCRIPTED|CONTROL_(FWD|BACK|(ROT_)?(LEFT|RIGHT)|UP|DOWN|(ML_)?LBUTTON)|PERMISSION_(RETURN_OBJECTS|DEBIT|OVERRIDE_ANIMATIONS|SILENT_ESTATE_MANAGEMENT|TAKE_CONTROLS|TRIGGER_ANIMATION|ATTACH|CHANGE_LINKS|(CONTROL|TRACK)_CAMERA|TELEPORT)|INVENTORY_(TEXTURE|SOUND|OBJECT|SCRIPT|LANDMARK|CLOTHING|NOTECARD|BODYPART|ANIMATION|GESTURE|ALL|NONE)|CHANGED_(INVENTORY|COLOR|SHAPE|SCALE|TEXTURE|LINK|ALLOWED_DROP|OWNER|REGION(_START)?|TELEPORT|MEDIA)|OBJECT_(CLICK_ACTION|HOVER_HEIGHT|LAST_OWNER_ID|(PHYSICS|SERVER|STREAMING)_COST|UNKNOWN_DETAIL|CHARACTER_TIME|PHANTOM|PHYSICS|TEMP_(ATTACHED|ON_REZ)|NAME|DESC|POS|PRIM_(COUNT|EQUIVALENCE)|RETURN_(PARCEL(_OWNER)?|REGION)|REZZER_KEY|ROO?T|VELOCITY|OMEGA|OWNER|GROUP(_TAG)?|CREATOR|ATTACHED_(POINT|SLOTS_AVAILABLE)|RENDER_WEIGHT|(BODY_SHAPE|PATHFINDING)_TYPE|(RUNNING|TOTAL)_SCRIPT_COUNT|TOTAL_INVENTORY_COUNT|SCRIPT_(MEMORY|TIME))|TYPE_(INTEGER|FLOAT|STRING|KEY|VECTOR|ROTATION|INVALID)|(DEBUG|PUBLIC)_CHANNEL|ATTACH_(AVATAR_CENTER|CHEST|HEAD|BACK|PELVIS|MOUTH|CHIN|NECK|NOSE|BELLY|[LR](SHOULDER|HAND|FOOT|EAR|EYE|[UL](ARM|LEG)|HIP)|(LEFT|RIGHT)_PEC|HUD_(CENTER_[12]|TOP_(RIGHT|CENTER|LEFT)|BOTTOM(_(RIGHT|LEFT))?)|[LR]HAND_RING1|TAIL_(BASE|TIP)|[LR]WING|FACE_(JAW|[LR]EAR|[LR]EYE|TOUNGE)|GROIN|HIND_[LR]FOOT)|LAND_(LEVEL|RAISE|LOWER|SMOOTH|NOISE|REVERT)|DATA_(ONLINE|NAME|BORN|SIM_(POS|STATUS|RATING)|PAYINFO)|PAYMENT_INFO_(ON_FILE|USED)|REMOTE_DATA_(CHANNEL|REQUEST|REPLY)|PSYS_(PART_(BF_(ZERO|ONE(_MINUS_(DEST_COLOR|SOURCE_(ALPHA|COLOR)))?|DEST_COLOR|SOURCE_(ALPHA|COLOR))|BLEND_FUNC_(DEST|SOURCE)|FLAGS|(START|END)_(COLOR|ALPHA|SCALE|GLOW)|MAX_AGE|(RIBBON|WIND|INTERP_(COLOR|SCALE)|BOUNCE|FOLLOW_(SRC|VELOCITY)|TARGET_(POS|LINEAR)|EMISSIVE)_MASK)|SRC_(MAX_AGE|PATTERN|ANGLE_(BEGIN|END)|BURST_(RATE|PART_COUNT|RADIUS|SPEED_(MIN|MAX))|ACCEL|TEXTURE|TARGET_KEY|OMEGA|PATTERN_(DROP|EXPLODE|ANGLE(_CONE(_EMPTY)?)?)))|VEHICLE_(REFERENCE_FRAME|TYPE_(NONE|SLED|CAR|BOAT|AIRPLANE|BALLOON)|(LINEAR|ANGULAR)_(FRICTION_TIMESCALE|MOTOR_DIRECTION)|LINEAR_MOTOR_OFFSET|HOVER_(HEIGHT|EFFICIENCY|TIMESCALE)|BUOYANCY|(LINEAR|ANGULAR)_(DEFLECTION_(EFFICIENCY|TIMESCALE)|MOTOR_(DECAY_)?TIMESCALE)|VERTICAL_ATTRACTION_(EFFICIENCY|TIMESCALE)|BANKING_(EFFICIENCY|MIX|TIMESCALE)|FLAG_(NO_DEFLECTION_UP|LIMIT_(ROLL_ONLY|MOTOR_UP)|HOVER_((WATER|TERRAIN|UP)_ONLY|GLOBAL_HEIGHT)|MOUSELOOK_(STEER|BANK)|CAMERA_DECOUPLED))|PRIM_(ALLOW_UNSIT|ALPHA_MODE(_(BLEND|EMISSIVE|MASK|NONE))?|NORMAL|SPECULAR|TYPE(_(BOX|CYLINDER|PRISM|SPHERE|TORUS|TUBE|RING|SCULPT))?|HOLE_(DEFAULT|CIRCLE|SQUARE|TRIANGLE)|MATERIAL(_(STONE|METAL|GLASS|WOOD|FLESH|PLASTIC|RUBBER))?|SHINY_(NONE|LOW|MEDIUM|HIGH)|BUMP_(NONE|BRIGHT|DARK|WOOD|BARK|BRICKS|CHECKER|CONCRETE|TILE|STONE|DISKS|GRAVEL|BLOBS|SIDING|LARGETILE|STUCCO|SUCTION|WEAVE)|TEXGEN_(DEFAULT|PLANAR)|SCRIPTED_SIT_ONLY|SCULPT_(TYPE_(SPHERE|TORUS|PLANE|CYLINDER|MASK)|FLAG_(MIRROR|INVERT))|PHYSICS(_(SHAPE_(CONVEX|NONE|PRIM|TYPE)))?|(POS|ROT)_LOCAL|SLICE|TEXT|FLEXIBLE|POINT_LIGHT|TEMP_ON_REZ|PHANTOM|POSITION|SIT_TARGET|SIZE|ROTATION|TEXTURE|NAME|OMEGA|DESC|LINK_TARGET|COLOR|BUMP_SHINY|FULLBRIGHT|TEXGEN|GLOW|MEDIA_(ALT_IMAGE_ENABLE|CONTROLS|(CURRENT|HOME)_URL|AUTO_(LOOP|PLAY|SCALE|ZOOM)|FIRST_CLICK_INTERACT|(WIDTH|HEIGHT)_PIXELS|WHITELIST(_ENABLE)?|PERMS_(INTERACT|CONTROL)|PARAM_MAX|CONTROLS_(STANDARD|MINI)|PERM_(NONE|OWNER|GROUP|ANYONE)|MAX_(URL_LENGTH|WHITELIST_(SIZE|COUNT)|(WIDTH|HEIGHT)_PIXELS)))|MASK_(BASE|OWNER|GROUP|EVERYONE|NEXT)|PERM_(TRANSFER|MODIFY|COPY|MOVE|ALL)|PARCEL_(MEDIA_COMMAND_(STOP|PAUSE|PLAY|LOOP|TEXTURE|URL|TIME|AGENT|UNLOAD|AUTO_ALIGN|TYPE|SIZE|DESC|LOOP_SET)|FLAG_(ALLOW_(FLY|(GROUP_)?SCRIPTS|LANDMARK|TERRAFORM|DAMAGE|CREATE_(GROUP_)?OBJECTS)|USE_(ACCESS_(GROUP|LIST)|BAN_LIST|LAND_PASS_LIST)|LOCAL_SOUND_ONLY|RESTRICT_PUSHOBJECT|ALLOW_(GROUP|ALL)_OBJECT_ENTRY)|COUNT_(TOTAL|OWNER|GROUP|OTHER|SELECTED|TEMP)|DETAILS_(NAME|DESC|OWNER|GROUP|AREA|ID|SEE_AVATARS))|LIST_STAT_(MAX|MIN|MEAN|MEDIAN|STD_DEV|SUM(_SQUARES)?|NUM_COUNT|GEOMETRIC_MEAN|RANGE)|PAY_(HIDE|DEFAULT)|REGION_FLAG_(ALLOW_DAMAGE|FIXED_SUN|BLOCK_TERRAFORM|SANDBOX|DISABLE_(COLLISIONS|PHYSICS)|BLOCK_FLY|ALLOW_DIRECT_TELEPORT|RESTRICT_PUSHOBJECT)|HTTP_(METHOD|MIMETYPE|BODY_(MAXLENGTH|TRUNCATED)|CUSTOM_HEADER|PRAGMA_NO_CACHE|VERBOSE_THROTTLE|VERIFY_CERT)|SIT_(INVALID_(AGENT|LINK_OBJECT)|NO(T_EXPERIENCE|_(ACCESS|EXPERIENCE_PERMISSION|SIT_TARGET)))|STRING_(TRIM(_(HEAD|TAIL))?)|CLICK_ACTION_(NONE|TOUCH|SIT|BUY|PAY|OPEN(_MEDIA)?|PLAY|ZOOM)|TOUCH_INVALID_FACE|PROFILE_(NONE|SCRIPT_MEMORY)|RC_(DATA_FLAGS|DETECT_PHANTOM|GET_(LINK_NUM|NORMAL|ROOT_KEY)|MAX_HITS|REJECT_(TYPES|AGENTS|(NON)?PHYSICAL|LAND))|RCERR_(CAST_TIME_EXCEEDED|SIM_PERF_LOW|UNKNOWN)|ESTATE_ACCESS_(ALLOWED_(AGENT|GROUP)_(ADD|REMOVE)|BANNED_AGENT_(ADD|REMOVE))|DENSITY|FRICTION|RESTITUTION|GRAVITY_MULTIPLIER|KFM_(COMMAND|CMD_(PLAY|STOP|PAUSE)|MODE|FORWARD|LOOP|PING_PONG|REVERSE|DATA|ROTATION|TRANSLATION)|ERR_(GENERIC|PARCEL_PERMISSIONS|MALFORMED_PARAMS|RUNTIME_PERMISSIONS|THROTTLED)|CHARACTER_(CMD_((SMOOTH_)?STOP|JUMP)|DESIRED_(TURN_)?SPEED|RADIUS|STAY_WITHIN_PARCEL|LENGTH|ORIENTATION|ACCOUNT_FOR_SKIPPED_FRAMES|AVOIDANCE_MODE|TYPE(_([ABCD]|NONE))?|MAX_(DECEL|TURN_RADIUS|(ACCEL|SPEED)))|PURSUIT_(OFFSET|FUZZ_FACTOR|GOAL_TOLERANCE|INTERCEPT)|REQUIRE_LINE_OF_SIGHT|FORCE_DIRECT_PATH|VERTICAL|HORIZONTAL|AVOID_(CHARACTERS|DYNAMIC_OBSTACLES|NONE)|PU_(EVADE_(HIDDEN|SPOTTED)|FAILURE_(DYNAMIC_PATHFINDING_DISABLED|INVALID_(GOAL|START)|NO_(NAVMESH|VALID_DESTINATION)|OTHER|TARGET_GONE|(PARCEL_)?UNREACHABLE)|(GOAL|SLOWDOWN_DISTANCE)_REACHED)|TRAVERSAL_TYPE(_(FAST|NONE|SLOW))?|CONTENT_TYPE_(ATOM|FORM|HTML|JSON|LLSD|RSS|TEXT|XHTML|XML)|GCNP_(RADIUS|STATIC)|(PATROL|WANDER)_PAUSE_AT_WAYPOINTS|OPT_(AVATAR|CHARACTER|EXCLUSION_VOLUME|LEGACY_LINKSET|MATERIAL_VOLUME|OTHER|STATIC_OBSTACLE|WALKABLE)|SIM_STAT_PCT_CHARS_STEPPED)\\b"
                        },
                        {
                            begin: "\\b(FALSE|TRUE)\\b"
                        },
                        {
                            begin: "\\b(ZERO_ROTATION)\\b"
                        },
                        {
                            begin: "\\b(EOF|JSON_(ARRAY|DELETE|FALSE|INVALID|NULL|NUMBER|OBJECT|STRING|TRUE)|NULL_KEY|TEXTURE_(BLANK|DEFAULT|MEDIA|PLYWOOD|TRANSPARENT)|URL_REQUEST_(GRANTED|DENIED))\\b"
                        },
                        {
                            begin: "\\b(ZERO_VECTOR|TOUCH_INVALID_(TEXCOORD|VECTOR))\\b"
                        }
                    ]
                },
                {
                    className: "type",
                    begin: "\\b(integer|float|string|key|vector|quaternion|rotation|list)\\b"
                }
            ]
        };
    }), ei)), Cs.registerLanguage("lua", (ni || (ni = 1, ai = function(e) {
        const t = "\\[=*\\[", a = "\\]=*\\]", n = {
            begin: t,
            end: a,
            contains: [
                "self"
            ]
        }, i = [
            e.COMMENT("--(?!" + t + ")", "$"),
            e.COMMENT("--" + t, a, {
                contains: [
                    n
                ],
                relevance: 10
            })
        ];
        return {
            name: "Lua",
            keywords: {
                $pattern: e.UNDERSCORE_IDENT_RE,
                literal: "true false nil",
                keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
                built_in: "_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len __gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall arg self coroutine resume yield status wrap create running debug getupvalue debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv io lines write close flush open output type read stderr stdin input stdout popen tmpfile math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower table setn insert getn foreachi maxn foreach concat sort remove"
            },
            contains: i.concat([
                {
                    className: "function",
                    beginKeywords: "function",
                    end: "\\)",
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*"
                        }),
                        {
                            className: "params",
                            begin: "\\(",
                            endsWithParent: !0,
                            contains: i
                        }
                    ].concat(i)
                },
                e.C_NUMBER_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    begin: t,
                    end: a,
                    contains: [
                        n
                    ],
                    relevance: 5
                }
            ])
        };
    }), ai)), Cs.registerLanguage("makefile", (ri || (ri = 1, ii = function(e) {
        const t = {
            className: "variable",
            variants: [
                {
                    begin: "\\$\\(" + e.UNDERSCORE_IDENT_RE + "\\)",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /\$[@%<?\^\+\*]/
                }
            ]
        }, a = {
            className: "string",
            begin: /"/,
            end: /"/,
            contains: [
                e.BACKSLASH_ESCAPE,
                t
            ]
        }, n = {
            className: "variable",
            begin: /\$\([\w-]+\s/,
            end: /\)/,
            keywords: {
                built_in: "subst patsubst strip findstring filter filter-out sort word wordlist firstword lastword dir notdir suffix basename addsuffix addprefix join wildcard realpath abspath error warning shell origin flavor foreach if or and call eval file value"
            },
            contains: [
                t
            ]
        }, i = {
            begin: "^" + e.UNDERSCORE_IDENT_RE + "\\s*(?=[:+?]?=)"
        }, r = {
            className: "section",
            begin: /^[^\s]+:/,
            end: /$/,
            contains: [
                t
            ]
        };
        return {
            name: "Makefile",
            aliases: [
                "mk",
                "mak",
                "make"
            ],
            keywords: {
                $pattern: /[\w-]+/,
                keyword: "define endef undefine ifdef ifndef ifeq ifneq else endif include -include sinclude override export unexport private vpath"
            },
            contains: [
                e.HASH_COMMENT_MODE,
                t,
                a,
                n,
                i,
                {
                    className: "meta",
                    begin: /^\.PHONY:/,
                    end: /$/,
                    keywords: {
                        $pattern: /[\.\w]+/,
                        keyword: ".PHONY"
                    }
                },
                r
            ]
        };
    }), ii)), Cs.registerLanguage("mathematica", function() {
        if (si) return oi;
        si = 1;
        const e = [
            "AASTriangle",
            "AbelianGroup",
            "Abort",
            "AbortKernels",
            "AbortProtect",
            "AbortScheduledTask",
            "Above",
            "Abs",
            "AbsArg",
            "AbsArgPlot",
            "Absolute",
            "AbsoluteCorrelation",
            "AbsoluteCorrelationFunction",
            "AbsoluteCurrentValue",
            "AbsoluteDashing",
            "AbsoluteFileName",
            "AbsoluteOptions",
            "AbsolutePointSize",
            "AbsoluteThickness",
            "AbsoluteTime",
            "AbsoluteTiming",
            "AcceptanceThreshold",
            "AccountingForm",
            "Accumulate",
            "Accuracy",
            "AccuracyGoal",
            "AcousticAbsorbingValue",
            "AcousticImpedanceValue",
            "AcousticNormalVelocityValue",
            "AcousticPDEComponent",
            "AcousticPressureCondition",
            "AcousticRadiationValue",
            "AcousticSoundHardValue",
            "AcousticSoundSoftCondition",
            "ActionDelay",
            "ActionMenu",
            "ActionMenuBox",
            "ActionMenuBoxOptions",
            "Activate",
            "Active",
            "ActiveClassification",
            "ActiveClassificationObject",
            "ActiveItem",
            "ActivePrediction",
            "ActivePredictionObject",
            "ActiveStyle",
            "AcyclicGraphQ",
            "AddOnHelpPath",
            "AddSides",
            "AddTo",
            "AddToSearchIndex",
            "AddUsers",
            "AdjacencyGraph",
            "AdjacencyList",
            "AdjacencyMatrix",
            "AdjacentMeshCells",
            "Adjugate",
            "AdjustmentBox",
            "AdjustmentBoxOptions",
            "AdjustTimeSeriesForecast",
            "AdministrativeDivisionData",
            "AffineHalfSpace",
            "AffineSpace",
            "AffineStateSpaceModel",
            "AffineTransform",
            "After",
            "AggregatedEntityClass",
            "AggregationLayer",
            "AircraftData",
            "AirportData",
            "AirPressureData",
            "AirSoundAttenuation",
            "AirTemperatureData",
            "AiryAi",
            "AiryAiPrime",
            "AiryAiZero",
            "AiryBi",
            "AiryBiPrime",
            "AiryBiZero",
            "AlgebraicIntegerQ",
            "AlgebraicNumber",
            "AlgebraicNumberDenominator",
            "AlgebraicNumberNorm",
            "AlgebraicNumberPolynomial",
            "AlgebraicNumberTrace",
            "AlgebraicRules",
            "AlgebraicRulesData",
            "Algebraics",
            "AlgebraicUnitQ",
            "Alignment",
            "AlignmentMarker",
            "AlignmentPoint",
            "All",
            "AllowAdultContent",
            "AllowChatServices",
            "AllowedCloudExtraParameters",
            "AllowedCloudParameterExtensions",
            "AllowedDimensions",
            "AllowedFrequencyRange",
            "AllowedHeads",
            "AllowGroupClose",
            "AllowIncomplete",
            "AllowInlineCells",
            "AllowKernelInitialization",
            "AllowLooseGrammar",
            "AllowReverseGroupClose",
            "AllowScriptLevelChange",
            "AllowVersionUpdate",
            "AllTrue",
            "Alphabet",
            "AlphabeticOrder",
            "AlphabeticSort",
            "AlphaChannel",
            "AlternateImage",
            "AlternatingFactorial",
            "AlternatingGroup",
            "AlternativeHypothesis",
            "Alternatives",
            "AltitudeMethod",
            "AmbientLight",
            "AmbiguityFunction",
            "AmbiguityList",
            "Analytic",
            "AnatomyData",
            "AnatomyForm",
            "AnatomyPlot3D",
            "AnatomySkinStyle",
            "AnatomyStyling",
            "AnchoredSearch",
            "And",
            "AndersonDarlingTest",
            "AngerJ",
            "AngleBisector",
            "AngleBracket",
            "AnglePath",
            "AnglePath3D",
            "AngleVector",
            "AngularGauge",
            "Animate",
            "AnimatedImage",
            "AnimationCycleOffset",
            "AnimationCycleRepetitions",
            "AnimationDirection",
            "AnimationDisplayTime",
            "AnimationRate",
            "AnimationRepetitions",
            "AnimationRunning",
            "AnimationRunTime",
            "AnimationTimeIndex",
            "AnimationVideo",
            "Animator",
            "AnimatorBox",
            "AnimatorBoxOptions",
            "AnimatorElements",
            "Annotate",
            "Annotation",
            "AnnotationDelete",
            "AnnotationKeys",
            "AnnotationRules",
            "AnnotationValue",
            "Annuity",
            "AnnuityDue",
            "Annulus",
            "AnomalyDetection",
            "AnomalyDetector",
            "AnomalyDetectorFunction",
            "Anonymous",
            "Antialiasing",
            "Antihermitian",
            "AntihermitianMatrixQ",
            "Antisymmetric",
            "AntisymmetricMatrixQ",
            "Antonyms",
            "AnyOrder",
            "AnySubset",
            "AnyTrue",
            "Apart",
            "ApartSquareFree",
            "APIFunction",
            "Appearance",
            "AppearanceElements",
            "AppearanceRules",
            "AppellF1",
            "Append",
            "AppendCheck",
            "AppendLayer",
            "AppendTo",
            "Application",
            "Apply",
            "ApplyReaction",
            "ApplySides",
            "ApplyTo",
            "ArcCos",
            "ArcCosh",
            "ArcCot",
            "ArcCoth",
            "ArcCsc",
            "ArcCsch",
            "ArcCurvature",
            "ARCHProcess",
            "ArcLength",
            "ArcSec",
            "ArcSech",
            "ArcSin",
            "ArcSinDistribution",
            "ArcSinh",
            "ArcTan",
            "ArcTanh",
            "Area",
            "Arg",
            "ArgMax",
            "ArgMin",
            "ArgumentCountQ",
            "ArgumentsOptions",
            "ARIMAProcess",
            "ArithmeticGeometricMean",
            "ARMAProcess",
            "Around",
            "AroundReplace",
            "ARProcess",
            "Array",
            "ArrayComponents",
            "ArrayDepth",
            "ArrayFilter",
            "ArrayFlatten",
            "ArrayMesh",
            "ArrayPad",
            "ArrayPlot",
            "ArrayPlot3D",
            "ArrayQ",
            "ArrayReduce",
            "ArrayResample",
            "ArrayReshape",
            "ArrayRules",
            "Arrays",
            "Arrow",
            "Arrow3DBox",
            "ArrowBox",
            "Arrowheads",
            "ASATriangle",
            "Ask",
            "AskAppend",
            "AskConfirm",
            "AskDisplay",
            "AskedQ",
            "AskedValue",
            "AskFunction",
            "AskState",
            "AskTemplateDisplay",
            "AspectRatio",
            "AspectRatioFixed",
            "Assert",
            "AssessmentFunction",
            "AssessmentResultObject",
            "AssociateTo",
            "Association",
            "AssociationFormat",
            "AssociationMap",
            "AssociationQ",
            "AssociationThread",
            "AssumeDeterministic",
            "Assuming",
            "Assumptions",
            "AstroAngularSeparation",
            "AstroBackground",
            "AstroCenter",
            "AstroDistance",
            "AstroGraphics",
            "AstroGridLines",
            "AstroGridLinesStyle",
            "AstronomicalData",
            "AstroPosition",
            "AstroProjection",
            "AstroRange",
            "AstroRangePadding",
            "AstroReferenceFrame",
            "AstroStyling",
            "AstroZoomLevel",
            "Asymptotic",
            "AsymptoticDSolveValue",
            "AsymptoticEqual",
            "AsymptoticEquivalent",
            "AsymptoticExpectation",
            "AsymptoticGreater",
            "AsymptoticGreaterEqual",
            "AsymptoticIntegrate",
            "AsymptoticLess",
            "AsymptoticLessEqual",
            "AsymptoticOutputTracker",
            "AsymptoticProbability",
            "AsymptoticProduct",
            "AsymptoticRSolveValue",
            "AsymptoticSolve",
            "AsymptoticSum",
            "Asynchronous",
            "AsynchronousTaskObject",
            "AsynchronousTasks",
            "Atom",
            "AtomCoordinates",
            "AtomCount",
            "AtomDiagramCoordinates",
            "AtomLabels",
            "AtomLabelStyle",
            "AtomList",
            "AtomQ",
            "AttachCell",
            "AttachedCell",
            "AttentionLayer",
            "Attributes",
            "Audio",
            "AudioAmplify",
            "AudioAnnotate",
            "AudioAnnotationLookup",
            "AudioBlockMap",
            "AudioCapture",
            "AudioChannelAssignment",
            "AudioChannelCombine",
            "AudioChannelMix",
            "AudioChannels",
            "AudioChannelSeparate",
            "AudioData",
            "AudioDelay",
            "AudioDelete",
            "AudioDevice",
            "AudioDistance",
            "AudioEncoding",
            "AudioFade",
            "AudioFrequencyShift",
            "AudioGenerator",
            "AudioIdentify",
            "AudioInputDevice",
            "AudioInsert",
            "AudioInstanceQ",
            "AudioIntervals",
            "AudioJoin",
            "AudioLabel",
            "AudioLength",
            "AudioLocalMeasurements",
            "AudioLooping",
            "AudioLoudness",
            "AudioMeasurements",
            "AudioNormalize",
            "AudioOutputDevice",
            "AudioOverlay",
            "AudioPad",
            "AudioPan",
            "AudioPartition",
            "AudioPause",
            "AudioPitchShift",
            "AudioPlay",
            "AudioPlot",
            "AudioQ",
            "AudioRecord",
            "AudioReplace",
            "AudioResample",
            "AudioReverb",
            "AudioReverse",
            "AudioSampleRate",
            "AudioSpectralMap",
            "AudioSpectralTransformation",
            "AudioSplit",
            "AudioStop",
            "AudioStream",
            "AudioStreams",
            "AudioTimeStretch",
            "AudioTrackApply",
            "AudioTrackSelection",
            "AudioTrim",
            "AudioType",
            "AugmentedPolyhedron",
            "AugmentedSymmetricPolynomial",
            "Authenticate",
            "Authentication",
            "AuthenticationDialog",
            "AutoAction",
            "Autocomplete",
            "AutocompletionFunction",
            "AutoCopy",
            "AutocorrelationTest",
            "AutoDelete",
            "AutoEvaluateEvents",
            "AutoGeneratedPackage",
            "AutoIndent",
            "AutoIndentSpacings",
            "AutoItalicWords",
            "AutoloadPath",
            "AutoMatch",
            "Automatic",
            "AutomaticImageSize",
            "AutoMultiplicationSymbol",
            "AutoNumberFormatting",
            "AutoOpenNotebooks",
            "AutoOpenPalettes",
            "AutoOperatorRenderings",
            "AutoQuoteCharacters",
            "AutoRefreshed",
            "AutoRemove",
            "AutorunSequencing",
            "AutoScaling",
            "AutoScroll",
            "AutoSpacing",
            "AutoStyleOptions",
            "AutoStyleWords",
            "AutoSubmitting",
            "Axes",
            "AxesEdge",
            "AxesLabel",
            "AxesOrigin",
            "AxesStyle",
            "AxiomaticTheory",
            "Axis",
            "Axis3DBox",
            "Axis3DBoxOptions",
            "AxisBox",
            "AxisBoxOptions",
            "AxisLabel",
            "AxisObject",
            "AxisStyle",
            "BabyMonsterGroupB",
            "Back",
            "BackFaceColor",
            "BackFaceGlowColor",
            "BackFaceOpacity",
            "BackFaceSpecularColor",
            "BackFaceSpecularExponent",
            "BackFaceSurfaceAppearance",
            "BackFaceTexture",
            "Background",
            "BackgroundAppearance",
            "BackgroundTasksSettings",
            "Backslash",
            "Backsubstitution",
            "Backward",
            "Ball",
            "Band",
            "BandpassFilter",
            "BandstopFilter",
            "BarabasiAlbertGraphDistribution",
            "BarChart",
            "BarChart3D",
            "BarcodeImage",
            "BarcodeRecognize",
            "BaringhausHenzeTest",
            "BarLegend",
            "BarlowProschanImportance",
            "BarnesG",
            "BarOrigin",
            "BarSpacing",
            "BartlettHannWindow",
            "BartlettWindow",
            "BaseDecode",
            "BaseEncode",
            "BaseForm",
            "Baseline",
            "BaselinePosition",
            "BaseStyle",
            "BasicRecurrentLayer",
            "BatchNormalizationLayer",
            "BatchSize",
            "BatesDistribution",
            "BattleLemarieWavelet",
            "BayesianMaximization",
            "BayesianMaximizationObject",
            "BayesianMinimization",
            "BayesianMinimizationObject",
            "Because",
            "BeckmannDistribution",
            "Beep",
            "Before",
            "Begin",
            "BeginDialogPacket",
            "BeginPackage",
            "BellB",
            "BellY",
            "Below",
            "BenfordDistribution",
            "BeniniDistribution",
            "BenktanderGibratDistribution",
            "BenktanderWeibullDistribution",
            "BernoulliB",
            "BernoulliDistribution",
            "BernoulliGraphDistribution",
            "BernoulliProcess",
            "BernsteinBasis",
            "BesagL",
            "BesselFilterModel",
            "BesselI",
            "BesselJ",
            "BesselJZero",
            "BesselK",
            "BesselY",
            "BesselYZero",
            "Beta",
            "BetaBinomialDistribution",
            "BetaDistribution",
            "BetaNegativeBinomialDistribution",
            "BetaPrimeDistribution",
            "BetaRegularized",
            "Between",
            "BetweennessCentrality",
            "Beveled",
            "BeveledPolyhedron",
            "BezierCurve",
            "BezierCurve3DBox",
            "BezierCurve3DBoxOptions",
            "BezierCurveBox",
            "BezierCurveBoxOptions",
            "BezierFunction",
            "BilateralFilter",
            "BilateralLaplaceTransform",
            "BilateralZTransform",
            "Binarize",
            "BinaryDeserialize",
            "BinaryDistance",
            "BinaryFormat",
            "BinaryImageQ",
            "BinaryRead",
            "BinaryReadList",
            "BinarySerialize",
            "BinaryWrite",
            "BinCounts",
            "BinLists",
            "BinnedVariogramList",
            "Binomial",
            "BinomialDistribution",
            "BinomialPointProcess",
            "BinomialProcess",
            "BinormalDistribution",
            "BiorthogonalSplineWavelet",
            "BioSequence",
            "BioSequenceBackTranslateList",
            "BioSequenceComplement",
            "BioSequenceInstances",
            "BioSequenceModify",
            "BioSequencePlot",
            "BioSequenceQ",
            "BioSequenceReverseComplement",
            "BioSequenceTranscribe",
            "BioSequenceTranslate",
            "BipartiteGraphQ",
            "BiquadraticFilterModel",
            "BirnbaumImportance",
            "BirnbaumSaundersDistribution",
            "BitAnd",
            "BitClear",
            "BitGet",
            "BitLength",
            "BitNot",
            "BitOr",
            "BitRate",
            "BitSet",
            "BitShiftLeft",
            "BitShiftRight",
            "BitXor",
            "BiweightLocation",
            "BiweightMidvariance",
            "Black",
            "BlackmanHarrisWindow",
            "BlackmanNuttallWindow",
            "BlackmanWindow",
            "Blank",
            "BlankForm",
            "BlankNullSequence",
            "BlankSequence",
            "Blend",
            "Block",
            "BlockchainAddressData",
            "BlockchainBase",
            "BlockchainBlockData",
            "BlockchainContractValue",
            "BlockchainData",
            "BlockchainGet",
            "BlockchainKeyEncode",
            "BlockchainPut",
            "BlockchainTokenData",
            "BlockchainTransaction",
            "BlockchainTransactionData",
            "BlockchainTransactionSign",
            "BlockchainTransactionSubmit",
            "BlockDiagonalMatrix",
            "BlockLowerTriangularMatrix",
            "BlockMap",
            "BlockRandom",
            "BlockUpperTriangularMatrix",
            "BlomqvistBeta",
            "BlomqvistBetaTest",
            "Blue",
            "Blur",
            "Blurring",
            "BodePlot",
            "BohmanWindow",
            "Bold",
            "Bond",
            "BondCount",
            "BondLabels",
            "BondLabelStyle",
            "BondList",
            "BondQ",
            "Bookmarks",
            "Boole",
            "BooleanConsecutiveFunction",
            "BooleanConvert",
            "BooleanCountingFunction",
            "BooleanFunction",
            "BooleanGraph",
            "BooleanMaxterms",
            "BooleanMinimize",
            "BooleanMinterms",
            "BooleanQ",
            "BooleanRegion",
            "Booleans",
            "BooleanStrings",
            "BooleanTable",
            "BooleanVariables",
            "BorderDimensions",
            "BorelTannerDistribution",
            "Bottom",
            "BottomHatTransform",
            "BoundaryDiscretizeGraphics",
            "BoundaryDiscretizeRegion",
            "BoundaryMesh",
            "BoundaryMeshRegion",
            "BoundaryMeshRegionQ",
            "BoundaryStyle",
            "BoundedRegionQ",
            "BoundingRegion",
            "Bounds",
            "Box",
            "BoxBaselineShift",
            "BoxData",
            "BoxDimensions",
            "Boxed",
            "Boxes",
            "BoxForm",
            "BoxFormFormatTypes",
            "BoxFrame",
            "BoxID",
            "BoxMargins",
            "BoxMatrix",
            "BoxObject",
            "BoxRatios",
            "BoxRotation",
            "BoxRotationPoint",
            "BoxStyle",
            "BoxWhiskerChart",
            "Bra",
            "BracketingBar",
            "BraKet",
            "BrayCurtisDistance",
            "BreadthFirstScan",
            "Break",
            "BridgeData",
            "BrightnessEqualize",
            "BroadcastStationData",
            "Brown",
            "BrownForsytheTest",
            "BrownianBridgeProcess",
            "BrowserCategory",
            "BSplineBasis",
            "BSplineCurve",
            "BSplineCurve3DBox",
            "BSplineCurve3DBoxOptions",
            "BSplineCurveBox",
            "BSplineCurveBoxOptions",
            "BSplineFunction",
            "BSplineSurface",
            "BSplineSurface3DBox",
            "BSplineSurface3DBoxOptions",
            "BubbleChart",
            "BubbleChart3D",
            "BubbleScale",
            "BubbleSizes",
            "BuckyballGraph",
            "BuildCompiledComponent",
            "BuildingData",
            "BulletGauge",
            "BusinessDayQ",
            "ButterflyGraph",
            "ButterworthFilterModel",
            "Button",
            "ButtonBar",
            "ButtonBox",
            "ButtonBoxOptions",
            "ButtonCell",
            "ButtonContents",
            "ButtonData",
            "ButtonEvaluator",
            "ButtonExpandable",
            "ButtonFrame",
            "ButtonFunction",
            "ButtonMargins",
            "ButtonMinHeight",
            "ButtonNote",
            "ButtonNotebook",
            "ButtonSource",
            "ButtonStyle",
            "ButtonStyleMenuListing",
            "Byte",
            "ByteArray",
            "ByteArrayFormat",
            "ByteArrayFormatQ",
            "ByteArrayQ",
            "ByteArrayToString",
            "ByteCount",
            "ByteOrdering",
            "C",
            "CachedValue",
            "CacheGraphics",
            "CachePersistence",
            "CalendarConvert",
            "CalendarData",
            "CalendarType",
            "Callout",
            "CalloutMarker",
            "CalloutStyle",
            "CallPacket",
            "CanberraDistance",
            "Cancel",
            "CancelButton",
            "CandlestickChart",
            "CanonicalGraph",
            "CanonicalizePolygon",
            "CanonicalizePolyhedron",
            "CanonicalizeRegion",
            "CanonicalName",
            "CanonicalWarpingCorrespondence",
            "CanonicalWarpingDistance",
            "CantorMesh",
            "CantorStaircase",
            "Canvas",
            "Cap",
            "CapForm",
            "CapitalDifferentialD",
            "Capitalize",
            "CapsuleShape",
            "CaptureRunning",
            "CaputoD",
            "CardinalBSplineBasis",
            "CarlemanLinearize",
            "CarlsonRC",
            "CarlsonRD",
            "CarlsonRE",
            "CarlsonRF",
            "CarlsonRG",
            "CarlsonRJ",
            "CarlsonRK",
            "CarlsonRM",
            "CarmichaelLambda",
            "CaseOrdering",
            "Cases",
            "CaseSensitive",
            "Cashflow",
            "Casoratian",
            "Cast",
            "Catalan",
            "CatalanNumber",
            "Catch",
            "CategoricalDistribution",
            "Catenate",
            "CatenateLayer",
            "CauchyDistribution",
            "CauchyMatrix",
            "CauchyPointProcess",
            "CauchyWindow",
            "CayleyGraph",
            "CDF",
            "CDFDeploy",
            "CDFInformation",
            "CDFWavelet",
            "Ceiling",
            "CelestialSystem",
            "Cell",
            "CellAutoOverwrite",
            "CellBaseline",
            "CellBoundingBox",
            "CellBracketOptions",
            "CellChangeTimes",
            "CellContents",
            "CellContext",
            "CellDingbat",
            "CellDingbatMargin",
            "CellDynamicExpression",
            "CellEditDuplicate",
            "CellElementsBoundingBox",
            "CellElementSpacings",
            "CellEpilog",
            "CellEvaluationDuplicate",
            "CellEvaluationFunction",
            "CellEvaluationLanguage",
            "CellEventActions",
            "CellFrame",
            "CellFrameColor",
            "CellFrameLabelMargins",
            "CellFrameLabels",
            "CellFrameMargins",
            "CellFrameStyle",
            "CellGroup",
            "CellGroupData",
            "CellGrouping",
            "CellGroupingRules",
            "CellHorizontalScrolling",
            "CellID",
            "CellInsertionPointCell",
            "CellLabel",
            "CellLabelAutoDelete",
            "CellLabelMargins",
            "CellLabelPositioning",
            "CellLabelStyle",
            "CellLabelTemplate",
            "CellMargins",
            "CellObject",
            "CellOpen",
            "CellPrint",
            "CellProlog",
            "Cells",
            "CellSize",
            "CellStyle",
            "CellTags",
            "CellTrayPosition",
            "CellTrayWidgets",
            "CellularAutomaton",
            "CensoredDistribution",
            "Censoring",
            "Center",
            "CenterArray",
            "CenterDot",
            "CenteredInterval",
            "CentralFeature",
            "CentralMoment",
            "CentralMomentGeneratingFunction",
            "Cepstrogram",
            "CepstrogramArray",
            "CepstrumArray",
            "CForm",
            "ChampernowneNumber",
            "ChangeOptions",
            "ChannelBase",
            "ChannelBrokerAction",
            "ChannelDatabin",
            "ChannelHistoryLength",
            "ChannelListen",
            "ChannelListener",
            "ChannelListeners",
            "ChannelListenerWait",
            "ChannelObject",
            "ChannelPreSendFunction",
            "ChannelReceiverFunction",
            "ChannelSend",
            "ChannelSubscribers",
            "ChanVeseBinarize",
            "Character",
            "CharacterCounts",
            "CharacterEncoding",
            "CharacterEncodingsPath",
            "CharacteristicFunction",
            "CharacteristicPolynomial",
            "CharacterName",
            "CharacterNormalize",
            "CharacterRange",
            "Characters",
            "ChartBaseStyle",
            "ChartElementData",
            "ChartElementDataFunction",
            "ChartElementFunction",
            "ChartElements",
            "ChartLabels",
            "ChartLayout",
            "ChartLegends",
            "ChartStyle",
            "Chebyshev1FilterModel",
            "Chebyshev2FilterModel",
            "ChebyshevDistance",
            "ChebyshevT",
            "ChebyshevU",
            "Check",
            "CheckAbort",
            "CheckAll",
            "CheckArguments",
            "Checkbox",
            "CheckboxBar",
            "CheckboxBox",
            "CheckboxBoxOptions",
            "ChemicalConvert",
            "ChemicalData",
            "ChemicalFormula",
            "ChemicalInstance",
            "ChemicalReaction",
            "ChessboardDistance",
            "ChiDistribution",
            "ChineseRemainder",
            "ChiSquareDistribution",
            "ChoiceButtons",
            "ChoiceDialog",
            "CholeskyDecomposition",
            "Chop",
            "ChromaticityPlot",
            "ChromaticityPlot3D",
            "ChromaticPolynomial",
            "Circle",
            "CircleBox",
            "CircleDot",
            "CircleMinus",
            "CirclePlus",
            "CirclePoints",
            "CircleThrough",
            "CircleTimes",
            "CirculantGraph",
            "CircularArcThrough",
            "CircularOrthogonalMatrixDistribution",
            "CircularQuaternionMatrixDistribution",
            "CircularRealMatrixDistribution",
            "CircularSymplecticMatrixDistribution",
            "CircularUnitaryMatrixDistribution",
            "Circumsphere",
            "CityData",
            "ClassifierFunction",
            "ClassifierInformation",
            "ClassifierMeasurements",
            "ClassifierMeasurementsObject",
            "Classify",
            "ClassPriors",
            "Clear",
            "ClearAll",
            "ClearAttributes",
            "ClearCookies",
            "ClearPermissions",
            "ClearSystemCache",
            "ClebschGordan",
            "ClickPane",
            "ClickToCopy",
            "ClickToCopyEnabled",
            "Clip",
            "ClipboardNotebook",
            "ClipFill",
            "ClippingStyle",
            "ClipPlanes",
            "ClipPlanesStyle",
            "ClipRange",
            "Clock",
            "ClockGauge",
            "ClockwiseContourIntegral",
            "Close",
            "Closed",
            "CloseKernels",
            "ClosenessCentrality",
            "Closing",
            "ClosingAutoSave",
            "ClosingEvent",
            "CloudAccountData",
            "CloudBase",
            "CloudConnect",
            "CloudConnections",
            "CloudDeploy",
            "CloudDirectory",
            "CloudDisconnect",
            "CloudEvaluate",
            "CloudExport",
            "CloudExpression",
            "CloudExpressions",
            "CloudFunction",
            "CloudGet",
            "CloudImport",
            "CloudLoggingData",
            "CloudObject",
            "CloudObjectInformation",
            "CloudObjectInformationData",
            "CloudObjectNameFormat",
            "CloudObjects",
            "CloudObjectURLType",
            "CloudPublish",
            "CloudPut",
            "CloudRenderingMethod",
            "CloudSave",
            "CloudShare",
            "CloudSubmit",
            "CloudSymbol",
            "CloudUnshare",
            "CloudUserID",
            "ClusterClassify",
            "ClusterDissimilarityFunction",
            "ClusteringComponents",
            "ClusteringMeasurements",
            "ClusteringTree",
            "CMYKColor",
            "Coarse",
            "CodeAssistOptions",
            "Coefficient",
            "CoefficientArrays",
            "CoefficientDomain",
            "CoefficientList",
            "CoefficientRules",
            "CoifletWavelet",
            "Collect",
            "CollinearPoints",
            "Colon",
            "ColonForm",
            "ColorBalance",
            "ColorCombine",
            "ColorConvert",
            "ColorCoverage",
            "ColorData",
            "ColorDataFunction",
            "ColorDetect",
            "ColorDistance",
            "ColorFunction",
            "ColorFunctionBinning",
            "ColorFunctionScaling",
            "Colorize",
            "ColorNegate",
            "ColorOutput",
            "ColorProfileData",
            "ColorQ",
            "ColorQuantize",
            "ColorReplace",
            "ColorRules",
            "ColorSelectorSettings",
            "ColorSeparate",
            "ColorSetter",
            "ColorSetterBox",
            "ColorSetterBoxOptions",
            "ColorSlider",
            "ColorsNear",
            "ColorSpace",
            "ColorToneMapping",
            "Column",
            "ColumnAlignments",
            "ColumnBackgrounds",
            "ColumnForm",
            "ColumnLines",
            "ColumnsEqual",
            "ColumnSpacings",
            "ColumnWidths",
            "CombinatorB",
            "CombinatorC",
            "CombinatorI",
            "CombinatorK",
            "CombinatorS",
            "CombinatorW",
            "CombinatorY",
            "CombinedEntityClass",
            "CombinerFunction",
            "CometData",
            "CommonDefaultFormatTypes",
            "Commonest",
            "CommonestFilter",
            "CommonName",
            "CommonUnits",
            "CommunityBoundaryStyle",
            "CommunityGraphPlot",
            "CommunityLabels",
            "CommunityRegionStyle",
            "CompanyData",
            "CompatibleUnitQ",
            "CompilationOptions",
            "CompilationTarget",
            "Compile",
            "Compiled",
            "CompiledCodeFunction",
            "CompiledComponent",
            "CompiledExpressionDeclaration",
            "CompiledFunction",
            "CompiledLayer",
            "CompilerCallback",
            "CompilerEnvironment",
            "CompilerEnvironmentAppend",
            "CompilerEnvironmentAppendTo",
            "CompilerEnvironmentObject",
            "CompilerOptions",
            "Complement",
            "ComplementedEntityClass",
            "CompleteGraph",
            "CompleteGraphQ",
            "CompleteIntegral",
            "CompleteKaryTree",
            "CompletionsListPacket",
            "Complex",
            "ComplexArrayPlot",
            "ComplexContourPlot",
            "Complexes",
            "ComplexExpand",
            "ComplexInfinity",
            "ComplexityFunction",
            "ComplexListPlot",
            "ComplexPlot",
            "ComplexPlot3D",
            "ComplexRegionPlot",
            "ComplexStreamPlot",
            "ComplexVectorPlot",
            "ComponentMeasurements",
            "ComponentwiseContextMenu",
            "Compose",
            "ComposeList",
            "ComposeSeries",
            "CompositeQ",
            "Composition",
            "CompoundElement",
            "CompoundExpression",
            "CompoundPoissonDistribution",
            "CompoundPoissonProcess",
            "CompoundRenewalProcess",
            "Compress",
            "CompressedData",
            "CompressionLevel",
            "ComputeUncertainty",
            "ConcaveHullMesh",
            "Condition",
            "ConditionalExpression",
            "Conditioned",
            "Cone",
            "ConeBox",
            "ConfidenceLevel",
            "ConfidenceRange",
            "ConfidenceTransform",
            "ConfigurationPath",
            "Confirm",
            "ConfirmAssert",
            "ConfirmBy",
            "ConfirmMatch",
            "ConfirmQuiet",
            "ConformationMethod",
            "ConformAudio",
            "ConformImages",
            "Congruent",
            "ConicGradientFilling",
            "ConicHullRegion",
            "ConicHullRegion3DBox",
            "ConicHullRegion3DBoxOptions",
            "ConicHullRegionBox",
            "ConicHullRegionBoxOptions",
            "ConicOptimization",
            "Conjugate",
            "ConjugateTranspose",
            "Conjunction",
            "Connect",
            "ConnectedComponents",
            "ConnectedGraphComponents",
            "ConnectedGraphQ",
            "ConnectedMeshComponents",
            "ConnectedMoleculeComponents",
            "ConnectedMoleculeQ",
            "ConnectionSettings",
            "ConnectLibraryCallbackFunction",
            "ConnectSystemModelComponents",
            "ConnectSystemModelController",
            "ConnesWindow",
            "ConoverTest",
            "ConservativeConvectionPDETerm",
            "ConsoleMessage",
            "Constant",
            "ConstantArray",
            "ConstantArrayLayer",
            "ConstantImage",
            "ConstantPlusLayer",
            "ConstantRegionQ",
            "Constants",
            "ConstantTimesLayer",
            "ConstellationData",
            "ConstrainedMax",
            "ConstrainedMin",
            "Construct",
            "Containing",
            "ContainsAll",
            "ContainsAny",
            "ContainsExactly",
            "ContainsNone",
            "ContainsOnly",
            "ContentDetectorFunction",
            "ContentFieldOptions",
            "ContentLocationFunction",
            "ContentObject",
            "ContentPadding",
            "ContentsBoundingBox",
            "ContentSelectable",
            "ContentSize",
            "Context",
            "ContextMenu",
            "Contexts",
            "ContextToFileName",
            "Continuation",
            "Continue",
            "ContinuedFraction",
            "ContinuedFractionK",
            "ContinuousAction",
            "ContinuousMarkovProcess",
            "ContinuousTask",
            "ContinuousTimeModelQ",
            "ContinuousWaveletData",
            "ContinuousWaveletTransform",
            "ContourDetect",
            "ContourGraphics",
            "ContourIntegral",
            "ContourLabels",
            "ContourLines",
            "ContourPlot",
            "ContourPlot3D",
            "Contours",
            "ContourShading",
            "ContourSmoothing",
            "ContourStyle",
            "ContraharmonicMean",
            "ContrastiveLossLayer",
            "Control",
            "ControlActive",
            "ControlAlignment",
            "ControlGroupContentsBox",
            "ControllabilityGramian",
            "ControllabilityMatrix",
            "ControllableDecomposition",
            "ControllableModelQ",
            "ControllerDuration",
            "ControllerInformation",
            "ControllerInformationData",
            "ControllerLinking",
            "ControllerManipulate",
            "ControllerMethod",
            "ControllerPath",
            "ControllerState",
            "ControlPlacement",
            "ControlsRendering",
            "ControlType",
            "ConvectionPDETerm",
            "Convergents",
            "ConversionOptions",
            "ConversionRules",
            "ConvertToPostScript",
            "ConvertToPostScriptPacket",
            "ConvexHullMesh",
            "ConvexHullRegion",
            "ConvexOptimization",
            "ConvexPolygonQ",
            "ConvexPolyhedronQ",
            "ConvexRegionQ",
            "ConvolutionLayer",
            "Convolve",
            "ConwayGroupCo1",
            "ConwayGroupCo2",
            "ConwayGroupCo3",
            "CookieFunction",
            "Cookies",
            "CoordinateBoundingBox",
            "CoordinateBoundingBoxArray",
            "CoordinateBounds",
            "CoordinateBoundsArray",
            "CoordinateChartData",
            "CoordinatesToolOptions",
            "CoordinateTransform",
            "CoordinateTransformData",
            "CoplanarPoints",
            "CoprimeQ",
            "Coproduct",
            "CopulaDistribution",
            "Copyable",
            "CopyDatabin",
            "CopyDirectory",
            "CopyFile",
            "CopyFunction",
            "CopyTag",
            "CopyToClipboard",
            "CoreNilpotentDecomposition",
            "CornerFilter",
            "CornerNeighbors",
            "Correlation",
            "CorrelationDistance",
            "CorrelationFunction",
            "CorrelationTest",
            "Cos",
            "Cosh",
            "CoshIntegral",
            "CosineDistance",
            "CosineWindow",
            "CosIntegral",
            "Cot",
            "Coth",
            "CoulombF",
            "CoulombG",
            "CoulombH1",
            "CoulombH2",
            "Count",
            "CountDistinct",
            "CountDistinctBy",
            "CounterAssignments",
            "CounterBox",
            "CounterBoxOptions",
            "CounterClockwiseContourIntegral",
            "CounterEvaluator",
            "CounterFunction",
            "CounterIncrements",
            "CounterStyle",
            "CounterStyleMenuListing",
            "CountRoots",
            "CountryData",
            "Counts",
            "CountsBy",
            "Covariance",
            "CovarianceEstimatorFunction",
            "CovarianceFunction",
            "CoxianDistribution",
            "CoxIngersollRossProcess",
            "CoxModel",
            "CoxModelFit",
            "CramerVonMisesTest",
            "CreateArchive",
            "CreateCellID",
            "CreateChannel",
            "CreateCloudExpression",
            "CreateCompilerEnvironment",
            "CreateDatabin",
            "CreateDataStructure",
            "CreateDataSystemModel",
            "CreateDialog",
            "CreateDirectory",
            "CreateDocument",
            "CreateFile",
            "CreateIntermediateDirectories",
            "CreateLicenseEntitlement",
            "CreateManagedLibraryExpression",
            "CreateNotebook",
            "CreatePacletArchive",
            "CreatePalette",
            "CreatePermissionsGroup",
            "CreateScheduledTask",
            "CreateSearchIndex",
            "CreateSystemModel",
            "CreateTemporary",
            "CreateTypeInstance",
            "CreateUUID",
            "CreateWindow",
            "CriterionFunction",
            "CriticalityFailureImportance",
            "CriticalitySuccessImportance",
            "CriticalSection",
            "Cross",
            "CrossEntropyLossLayer",
            "CrossingCount",
            "CrossingDetect",
            "CrossingPolygon",
            "CrossMatrix",
            "Csc",
            "Csch",
            "CSGRegion",
            "CSGRegionQ",
            "CSGRegionTree",
            "CTCLossLayer",
            "Cube",
            "CubeRoot",
            "Cubics",
            "Cuboid",
            "CuboidBox",
            "CuboidBoxOptions",
            "Cumulant",
            "CumulantGeneratingFunction",
            "CumulativeFeatureImpactPlot",
            "Cup",
            "CupCap",
            "Curl",
            "CurlyDoubleQuote",
            "CurlyQuote",
            "CurrencyConvert",
            "CurrentDate",
            "CurrentImage",
            "CurrentNotebookImage",
            "CurrentScreenImage",
            "CurrentValue",
            "Curry",
            "CurryApplied",
            "CurvatureFlowFilter",
            "CurveClosed",
            "Cyan",
            "CycleGraph",
            "CycleIndexPolynomial",
            "Cycles",
            "CyclicGroup",
            "Cyclotomic",
            "Cylinder",
            "CylinderBox",
            "CylinderBoxOptions",
            "CylindricalDecomposition",
            "CylindricalDecompositionFunction",
            "D",
            "DagumDistribution",
            "DamData",
            "DamerauLevenshteinDistance",
            "DampingFactor",
            "Darker",
            "Dashed",
            "Dashing",
            "DatabaseConnect",
            "DatabaseDisconnect",
            "DatabaseReference",
            "Databin",
            "DatabinAdd",
            "DatabinRemove",
            "Databins",
            "DatabinSubmit",
            "DatabinUpload",
            "DataCompression",
            "DataDistribution",
            "DataRange",
            "DataReversed",
            "Dataset",
            "DatasetDisplayPanel",
            "DatasetTheme",
            "DataStructure",
            "DataStructureQ",
            "Date",
            "DateBounds",
            "Dated",
            "DateDelimiters",
            "DateDifference",
            "DatedUnit",
            "DateFormat",
            "DateFunction",
            "DateGranularity",
            "DateHistogram",
            "DateInterval",
            "DateList",
            "DateListLogPlot",
            "DateListPlot",
            "DateListStepPlot",
            "DateObject",
            "DateObjectQ",
            "DateOverlapsQ",
            "DatePattern",
            "DatePlus",
            "DateRange",
            "DateReduction",
            "DateScale",
            "DateSelect",
            "DateString",
            "DateTicksFormat",
            "DateValue",
            "DateWithinQ",
            "DaubechiesWavelet",
            "DavisDistribution",
            "DawsonF",
            "DayCount",
            "DayCountConvention",
            "DayHemisphere",
            "DaylightQ",
            "DayMatchQ",
            "DayName",
            "DayNightTerminator",
            "DayPlus",
            "DayRange",
            "DayRound",
            "DeBruijnGraph",
            "DeBruijnSequence",
            "Debug",
            "DebugTag",
            "Decapitalize",
            "Decimal",
            "DecimalForm",
            "DeclareCompiledComponent",
            "DeclareKnownSymbols",
            "DeclarePackage",
            "Decompose",
            "DeconvolutionLayer",
            "Decrement",
            "Decrypt",
            "DecryptFile",
            "DedekindEta",
            "DeepSpaceProbeData",
            "Default",
            "Default2DTool",
            "Default3DTool",
            "DefaultAttachedCellStyle",
            "DefaultAxesStyle",
            "DefaultBaseStyle",
            "DefaultBoxStyle",
            "DefaultButton",
            "DefaultColor",
            "DefaultControlPlacement",
            "DefaultDockedCellStyle",
            "DefaultDuplicateCellStyle",
            "DefaultDuration",
            "DefaultElement",
            "DefaultFaceGridsStyle",
            "DefaultFieldHintStyle",
            "DefaultFont",
            "DefaultFontProperties",
            "DefaultFormatType",
            "DefaultFrameStyle",
            "DefaultFrameTicksStyle",
            "DefaultGridLinesStyle",
            "DefaultInlineFormatType",
            "DefaultInputFormatType",
            "DefaultLabelStyle",
            "DefaultMenuStyle",
            "DefaultNaturalLanguage",
            "DefaultNewCellStyle",
            "DefaultNewInlineCellStyle",
            "DefaultNotebook",
            "DefaultOptions",
            "DefaultOutputFormatType",
            "DefaultPrintPrecision",
            "DefaultStyle",
            "DefaultStyleDefinitions",
            "DefaultTextFormatType",
            "DefaultTextInlineFormatType",
            "DefaultTicksStyle",
            "DefaultTooltipStyle",
            "DefaultValue",
            "DefaultValues",
            "Defer",
            "DefineExternal",
            "DefineInputStreamMethod",
            "DefineOutputStreamMethod",
            "DefineResourceFunction",
            "Definition",
            "Degree",
            "DegreeCentrality",
            "DegreeGraphDistribution",
            "DegreeLexicographic",
            "DegreeReverseLexicographic",
            "DEigensystem",
            "DEigenvalues",
            "Deinitialization",
            "Del",
            "DelaunayMesh",
            "Delayed",
            "Deletable",
            "Delete",
            "DeleteAdjacentDuplicates",
            "DeleteAnomalies",
            "DeleteBorderComponents",
            "DeleteCases",
            "DeleteChannel",
            "DeleteCloudExpression",
            "DeleteContents",
            "DeleteDirectory",
            "DeleteDuplicates",
            "DeleteDuplicatesBy",
            "DeleteElements",
            "DeleteFile",
            "DeleteMissing",
            "DeleteObject",
            "DeletePermissionsKey",
            "DeleteSearchIndex",
            "DeleteSmallComponents",
            "DeleteStopwords",
            "DeleteWithContents",
            "DeletionWarning",
            "DelimitedArray",
            "DelimitedSequence",
            "Delimiter",
            "DelimiterAutoMatching",
            "DelimiterFlashTime",
            "DelimiterMatching",
            "Delimiters",
            "DeliveryFunction",
            "Dendrogram",
            "Denominator",
            "DensityGraphics",
            "DensityHistogram",
            "DensityPlot",
            "DensityPlot3D",
            "DependentVariables",
            "Deploy",
            "Deployed",
            "Depth",
            "DepthFirstScan",
            "Derivative",
            "DerivativeFilter",
            "DerivativePDETerm",
            "DerivedKey",
            "DescriptorStateSpace",
            "DesignMatrix",
            "DestroyAfterEvaluation",
            "Det",
            "DeviceClose",
            "DeviceConfigure",
            "DeviceExecute",
            "DeviceExecuteAsynchronous",
            "DeviceObject",
            "DeviceOpen",
            "DeviceOpenQ",
            "DeviceRead",
            "DeviceReadBuffer",
            "DeviceReadLatest",
            "DeviceReadList",
            "DeviceReadTimeSeries",
            "Devices",
            "DeviceStreams",
            "DeviceWrite",
            "DeviceWriteBuffer",
            "DGaussianWavelet",
            "DiacriticalPositioning",
            "Diagonal",
            "DiagonalizableMatrixQ",
            "DiagonalMatrix",
            "DiagonalMatrixQ",
            "Dialog",
            "DialogIndent",
            "DialogInput",
            "DialogLevel",
            "DialogNotebook",
            "DialogProlog",
            "DialogReturn",
            "DialogSymbols",
            "Diamond",
            "DiamondMatrix",
            "DiceDissimilarity",
            "DictionaryLookup",
            "DictionaryWordQ",
            "DifferenceDelta",
            "DifferenceOrder",
            "DifferenceQuotient",
            "DifferenceRoot",
            "DifferenceRootReduce",
            "Differences",
            "DifferentialD",
            "DifferentialRoot",
            "DifferentialRootReduce",
            "DifferentiatorFilter",
            "DiffusionPDETerm",
            "DiggleGatesPointProcess",
            "DiggleGrattonPointProcess",
            "DigitalSignature",
            "DigitBlock",
            "DigitBlockMinimum",
            "DigitCharacter",
            "DigitCount",
            "DigitQ",
            "DihedralAngle",
            "DihedralGroup",
            "Dilation",
            "DimensionalCombinations",
            "DimensionalMeshComponents",
            "DimensionReduce",
            "DimensionReducerFunction",
            "DimensionReduction",
            "Dimensions",
            "DiracComb",
            "DiracDelta",
            "DirectedEdge",
            "DirectedEdges",
            "DirectedGraph",
            "DirectedGraphQ",
            "DirectedInfinity",
            "Direction",
            "DirectionalLight",
            "Directive",
            "Directory",
            "DirectoryName",
            "DirectoryQ",
            "DirectoryStack",
            "DirichletBeta",
            "DirichletCharacter",
            "DirichletCondition",
            "DirichletConvolve",
            "DirichletDistribution",
            "DirichletEta",
            "DirichletL",
            "DirichletLambda",
            "DirichletTransform",
            "DirichletWindow",
            "DisableConsolePrintPacket",
            "DisableFormatting",
            "DiscreteAsymptotic",
            "DiscreteChirpZTransform",
            "DiscreteConvolve",
            "DiscreteDelta",
            "DiscreteHadamardTransform",
            "DiscreteIndicator",
            "DiscreteInputOutputModel",
            "DiscreteLimit",
            "DiscreteLQEstimatorGains",
            "DiscreteLQRegulatorGains",
            "DiscreteLyapunovSolve",
            "DiscreteMarkovProcess",
            "DiscreteMaxLimit",
            "DiscreteMinLimit",
            "DiscretePlot",
            "DiscretePlot3D",
            "DiscreteRatio",
            "DiscreteRiccatiSolve",
            "DiscreteShift",
            "DiscreteTimeModelQ",
            "DiscreteUniformDistribution",
            "DiscreteVariables",
            "DiscreteWaveletData",
            "DiscreteWaveletPacketTransform",
            "DiscreteWaveletTransform",
            "DiscretizeGraphics",
            "DiscretizeRegion",
            "Discriminant",
            "DisjointQ",
            "Disjunction",
            "Disk",
            "DiskBox",
            "DiskBoxOptions",
            "DiskMatrix",
            "DiskSegment",
            "Dispatch",
            "DispatchQ",
            "DispersionEstimatorFunction",
            "Display",
            "DisplayAllSteps",
            "DisplayEndPacket",
            "DisplayForm",
            "DisplayFunction",
            "DisplayPacket",
            "DisplayRules",
            "DisplayString",
            "DisplayTemporary",
            "DisplayWith",
            "DisplayWithRef",
            "DisplayWithVariable",
            "DistanceFunction",
            "DistanceMatrix",
            "DistanceTransform",
            "Distribute",
            "Distributed",
            "DistributedContexts",
            "DistributeDefinitions",
            "DistributionChart",
            "DistributionDomain",
            "DistributionFitTest",
            "DistributionParameterAssumptions",
            "DistributionParameterQ",
            "Dithering",
            "Div",
            "Divergence",
            "Divide",
            "DivideBy",
            "Dividers",
            "DivideSides",
            "Divisible",
            "Divisors",
            "DivisorSigma",
            "DivisorSum",
            "DMSList",
            "DMSString",
            "Do",
            "DockedCell",
            "DockedCells",
            "DocumentGenerator",
            "DocumentGeneratorInformation",
            "DocumentGeneratorInformationData",
            "DocumentGenerators",
            "DocumentNotebook",
            "DocumentWeightingRules",
            "Dodecahedron",
            "DomainRegistrationInformation",
            "DominantColors",
            "DominatorTreeGraph",
            "DominatorVertexList",
            "DOSTextFormat",
            "Dot",
            "DotDashed",
            "DotEqual",
            "DotLayer",
            "DotPlusLayer",
            "Dotted",
            "DoubleBracketingBar",
            "DoubleContourIntegral",
            "DoubleDownArrow",
            "DoubleLeftArrow",
            "DoubleLeftRightArrow",
            "DoubleLeftTee",
            "DoubleLongLeftArrow",
            "DoubleLongLeftRightArrow",
            "DoubleLongRightArrow",
            "DoubleRightArrow",
            "DoubleRightTee",
            "DoubleUpArrow",
            "DoubleUpDownArrow",
            "DoubleVerticalBar",
            "DoublyInfinite",
            "Down",
            "DownArrow",
            "DownArrowBar",
            "DownArrowUpArrow",
            "DownLeftRightVector",
            "DownLeftTeeVector",
            "DownLeftVector",
            "DownLeftVectorBar",
            "DownRightTeeVector",
            "DownRightVector",
            "DownRightVectorBar",
            "Downsample",
            "DownTee",
            "DownTeeArrow",
            "DownValues",
            "DownValuesFunction",
            "DragAndDrop",
            "DrawBackFaces",
            "DrawEdges",
            "DrawFrontFaces",
            "DrawHighlighted",
            "DrazinInverse",
            "Drop",
            "DropoutLayer",
            "DropShadowing",
            "DSolve",
            "DSolveChangeVariables",
            "DSolveValue",
            "Dt",
            "DualLinearProgramming",
            "DualPlanarGraph",
            "DualPolyhedron",
            "DualSystemsModel",
            "DumpGet",
            "DumpSave",
            "DuplicateFreeQ",
            "Duration",
            "Dynamic",
            "DynamicBox",
            "DynamicBoxOptions",
            "DynamicEvaluationTimeout",
            "DynamicGeoGraphics",
            "DynamicImage",
            "DynamicLocation",
            "DynamicModule",
            "DynamicModuleBox",
            "DynamicModuleBoxOptions",
            "DynamicModuleParent",
            "DynamicModuleValues",
            "DynamicName",
            "DynamicNamespace",
            "DynamicReference",
            "DynamicSetting",
            "DynamicUpdating",
            "DynamicWrapper",
            "DynamicWrapperBox",
            "DynamicWrapperBoxOptions",
            "E",
            "EarthImpactData",
            "EarthquakeData",
            "EccentricityCentrality",
            "Echo",
            "EchoEvaluation",
            "EchoFunction",
            "EchoLabel",
            "EchoTiming",
            "EclipseType",
            "EdgeAdd",
            "EdgeBetweennessCentrality",
            "EdgeCapacity",
            "EdgeCapForm",
            "EdgeChromaticNumber",
            "EdgeColor",
            "EdgeConnectivity",
            "EdgeContract",
            "EdgeCost",
            "EdgeCount",
            "EdgeCoverQ",
            "EdgeCycleMatrix",
            "EdgeDashing",
            "EdgeDelete",
            "EdgeDetect",
            "EdgeForm",
            "EdgeIndex",
            "EdgeJoinForm",
            "EdgeLabeling",
            "EdgeLabels",
            "EdgeLabelStyle",
            "EdgeList",
            "EdgeOpacity",
            "EdgeQ",
            "EdgeRenderingFunction",
            "EdgeRules",
            "EdgeShapeFunction",
            "EdgeStyle",
            "EdgeTaggedGraph",
            "EdgeTaggedGraphQ",
            "EdgeTags",
            "EdgeThickness",
            "EdgeTransitiveGraphQ",
            "EdgeValueRange",
            "EdgeValueSizes",
            "EdgeWeight",
            "EdgeWeightedGraphQ",
            "Editable",
            "EditButtonSettings",
            "EditCellTagsSettings",
            "EditDistance",
            "EffectiveInterest",
            "Eigensystem",
            "Eigenvalues",
            "EigenvectorCentrality",
            "Eigenvectors",
            "Element",
            "ElementData",
            "ElementwiseLayer",
            "ElidedForms",
            "Eliminate",
            "EliminationOrder",
            "Ellipsoid",
            "EllipticE",
            "EllipticExp",
            "EllipticExpPrime",
            "EllipticF",
            "EllipticFilterModel",
            "EllipticK",
            "EllipticLog",
            "EllipticNomeQ",
            "EllipticPi",
            "EllipticReducedHalfPeriods",
            "EllipticTheta",
            "EllipticThetaPrime",
            "EmbedCode",
            "EmbeddedHTML",
            "EmbeddedService",
            "EmbeddedSQLEntityClass",
            "EmbeddedSQLExpression",
            "EmbeddingLayer",
            "EmbeddingObject",
            "EmitSound",
            "EmphasizeSyntaxErrors",
            "EmpiricalDistribution",
            "Empty",
            "EmptyGraphQ",
            "EmptyRegion",
            "EmptySpaceF",
            "EnableConsolePrintPacket",
            "Enabled",
            "Enclose",
            "Encode",
            "Encrypt",
            "EncryptedObject",
            "EncryptFile",
            "End",
            "EndAdd",
            "EndDialogPacket",
            "EndOfBuffer",
            "EndOfFile",
            "EndOfLine",
            "EndOfString",
            "EndPackage",
            "EngineEnvironment",
            "EngineeringForm",
            "Enter",
            "EnterExpressionPacket",
            "EnterTextPacket",
            "Entity",
            "EntityClass",
            "EntityClassList",
            "EntityCopies",
            "EntityFunction",
            "EntityGroup",
            "EntityInstance",
            "EntityList",
            "EntityPrefetch",
            "EntityProperties",
            "EntityProperty",
            "EntityPropertyClass",
            "EntityRegister",
            "EntityStore",
            "EntityStores",
            "EntityTypeName",
            "EntityUnregister",
            "EntityValue",
            "Entropy",
            "EntropyFilter",
            "Environment",
            "Epilog",
            "EpilogFunction",
            "Equal",
            "EqualColumns",
            "EqualRows",
            "EqualTilde",
            "EqualTo",
            "EquatedTo",
            "Equilibrium",
            "EquirippleFilterKernel",
            "Equivalent",
            "Erf",
            "Erfc",
            "Erfi",
            "ErlangB",
            "ErlangC",
            "ErlangDistribution",
            "Erosion",
            "ErrorBox",
            "ErrorBoxOptions",
            "ErrorNorm",
            "ErrorPacket",
            "ErrorsDialogSettings",
            "EscapeRadius",
            "EstimatedBackground",
            "EstimatedDistribution",
            "EstimatedPointNormals",
            "EstimatedPointProcess",
            "EstimatedProcess",
            "EstimatedVariogramModel",
            "EstimatorGains",
            "EstimatorRegulator",
            "EuclideanDistance",
            "EulerAngles",
            "EulerCharacteristic",
            "EulerE",
            "EulerGamma",
            "EulerianGraphQ",
            "EulerMatrix",
            "EulerPhi",
            "Evaluatable",
            "Evaluate",
            "Evaluated",
            "EvaluatePacket",
            "EvaluateScheduledTask",
            "EvaluationBox",
            "EvaluationCell",
            "EvaluationCompletionAction",
            "EvaluationData",
            "EvaluationElements",
            "EvaluationEnvironment",
            "EvaluationMode",
            "EvaluationMonitor",
            "EvaluationNotebook",
            "EvaluationObject",
            "EvaluationOrder",
            "EvaluationPrivileges",
            "EvaluationRateLimit",
            "Evaluator",
            "EvaluatorNames",
            "EvenQ",
            "EventData",
            "EventEvaluator",
            "EventHandler",
            "EventHandlerTag",
            "EventLabels",
            "EventSeries",
            "ExactBlackmanWindow",
            "ExactNumberQ",
            "ExactRootIsolation",
            "ExampleData",
            "Except",
            "ExcludedContexts",
            "ExcludedForms",
            "ExcludedLines",
            "ExcludedPhysicalQuantities",
            "ExcludePods",
            "Exclusions",
            "ExclusionsStyle",
            "Exists",
            "Exit",
            "ExitDialog",
            "ExoplanetData",
            "Exp",
            "Expand",
            "ExpandAll",
            "ExpandDenominator",
            "ExpandFileName",
            "ExpandNumerator",
            "Expectation",
            "ExpectationE",
            "ExpectedValue",
            "ExpGammaDistribution",
            "ExpIntegralE",
            "ExpIntegralEi",
            "ExpirationDate",
            "Exponent",
            "ExponentFunction",
            "ExponentialDistribution",
            "ExponentialFamily",
            "ExponentialGeneratingFunction",
            "ExponentialMovingAverage",
            "ExponentialPowerDistribution",
            "ExponentPosition",
            "ExponentStep",
            "Export",
            "ExportAutoReplacements",
            "ExportByteArray",
            "ExportForm",
            "ExportPacket",
            "ExportString",
            "Expression",
            "ExpressionCell",
            "ExpressionGraph",
            "ExpressionPacket",
            "ExpressionTree",
            "ExpressionUUID",
            "ExpToTrig",
            "ExtendedEntityClass",
            "ExtendedGCD",
            "Extension",
            "ExtentElementFunction",
            "ExtentMarkers",
            "ExtentSize",
            "ExternalBundle",
            "ExternalCall",
            "ExternalDataCharacterEncoding",
            "ExternalEvaluate",
            "ExternalFunction",
            "ExternalFunctionName",
            "ExternalIdentifier",
            "ExternalObject",
            "ExternalOptions",
            "ExternalSessionObject",
            "ExternalSessions",
            "ExternalStorageBase",
            "ExternalStorageDownload",
            "ExternalStorageGet",
            "ExternalStorageObject",
            "ExternalStoragePut",
            "ExternalStorageUpload",
            "ExternalTypeSignature",
            "ExternalValue",
            "Extract",
            "ExtractArchive",
            "ExtractLayer",
            "ExtractPacletArchive",
            "ExtremeValueDistribution",
            "FaceAlign",
            "FaceForm",
            "FaceGrids",
            "FaceGridsStyle",
            "FaceRecognize",
            "FacialFeatures",
            "Factor",
            "FactorComplete",
            "Factorial",
            "Factorial2",
            "FactorialMoment",
            "FactorialMomentGeneratingFunction",
            "FactorialPower",
            "FactorInteger",
            "FactorList",
            "FactorSquareFree",
            "FactorSquareFreeList",
            "FactorTerms",
            "FactorTermsList",
            "Fail",
            "Failure",
            "FailureAction",
            "FailureDistribution",
            "FailureQ",
            "False",
            "FareySequence",
            "FARIMAProcess",
            "FeatureDistance",
            "FeatureExtract",
            "FeatureExtraction",
            "FeatureExtractor",
            "FeatureExtractorFunction",
            "FeatureImpactPlot",
            "FeatureNames",
            "FeatureNearest",
            "FeatureSpacePlot",
            "FeatureSpacePlot3D",
            "FeatureTypes",
            "FeatureValueDependencyPlot",
            "FeatureValueImpactPlot",
            "FEDisableConsolePrintPacket",
            "FeedbackLinearize",
            "FeedbackSector",
            "FeedbackSectorStyle",
            "FeedbackType",
            "FEEnableConsolePrintPacket",
            "FetalGrowthData",
            "Fibonacci",
            "Fibonorial",
            "FieldCompletionFunction",
            "FieldHint",
            "FieldHintStyle",
            "FieldMasked",
            "FieldSize",
            "File",
            "FileBaseName",
            "FileByteCount",
            "FileConvert",
            "FileDate",
            "FileExistsQ",
            "FileExtension",
            "FileFormat",
            "FileFormatProperties",
            "FileFormatQ",
            "FileHandler",
            "FileHash",
            "FileInformation",
            "FileName",
            "FileNameDepth",
            "FileNameDialogSettings",
            "FileNameDrop",
            "FileNameForms",
            "FileNameJoin",
            "FileNames",
            "FileNameSetter",
            "FileNameSplit",
            "FileNameTake",
            "FileNameToFormatList",
            "FilePrint",
            "FileSize",
            "FileSystemMap",
            "FileSystemScan",
            "FileSystemTree",
            "FileTemplate",
            "FileTemplateApply",
            "FileType",
            "FilledCurve",
            "FilledCurveBox",
            "FilledCurveBoxOptions",
            "FilledTorus",
            "FillForm",
            "Filling",
            "FillingStyle",
            "FillingTransform",
            "FilteredEntityClass",
            "FilterRules",
            "FinancialBond",
            "FinancialData",
            "FinancialDerivative",
            "FinancialIndicator",
            "Find",
            "FindAnomalies",
            "FindArgMax",
            "FindArgMin",
            "FindChannels",
            "FindClique",
            "FindClusters",
            "FindCookies",
            "FindCurvePath",
            "FindCycle",
            "FindDevices",
            "FindDistribution",
            "FindDistributionParameters",
            "FindDivisions",
            "FindEdgeColoring",
            "FindEdgeCover",
            "FindEdgeCut",
            "FindEdgeIndependentPaths",
            "FindEquationalProof",
            "FindEulerianCycle",
            "FindExternalEvaluators",
            "FindFaces",
            "FindFile",
            "FindFit",
            "FindFormula",
            "FindFundamentalCycles",
            "FindGeneratingFunction",
            "FindGeoLocation",
            "FindGeometricConjectures",
            "FindGeometricTransform",
            "FindGraphCommunities",
            "FindGraphIsomorphism",
            "FindGraphPartition",
            "FindHamiltonianCycle",
            "FindHamiltonianPath",
            "FindHiddenMarkovStates",
            "FindImageText",
            "FindIndependentEdgeSet",
            "FindIndependentVertexSet",
            "FindInstance",
            "FindIntegerNullVector",
            "FindIsomers",
            "FindIsomorphicSubgraph",
            "FindKClan",
            "FindKClique",
            "FindKClub",
            "FindKPlex",
            "FindLibrary",
            "FindLinearRecurrence",
            "FindList",
            "FindMatchingColor",
            "FindMaximum",
            "FindMaximumCut",
            "FindMaximumFlow",
            "FindMaxValue",
            "FindMeshDefects",
            "FindMinimum",
            "FindMinimumCostFlow",
            "FindMinimumCut",
            "FindMinValue",
            "FindMoleculeSubstructure",
            "FindPath",
            "FindPeaks",
            "FindPermutation",
            "FindPlanarColoring",
            "FindPointProcessParameters",
            "FindPostmanTour",
            "FindProcessParameters",
            "FindRegionTransform",
            "FindRepeat",
            "FindRoot",
            "FindSequenceFunction",
            "FindSettings",
            "FindShortestPath",
            "FindShortestTour",
            "FindSpanningTree",
            "FindSubgraphIsomorphism",
            "FindSystemModelEquilibrium",
            "FindTextualAnswer",
            "FindThreshold",
            "FindTransientRepeat",
            "FindVertexColoring",
            "FindVertexCover",
            "FindVertexCut",
            "FindVertexIndependentPaths",
            "Fine",
            "FinishDynamic",
            "FiniteAbelianGroupCount",
            "FiniteGroupCount",
            "FiniteGroupData",
            "First",
            "FirstCase",
            "FirstPassageTimeDistribution",
            "FirstPosition",
            "FischerGroupFi22",
            "FischerGroupFi23",
            "FischerGroupFi24Prime",
            "FisherHypergeometricDistribution",
            "FisherRatioTest",
            "FisherZDistribution",
            "Fit",
            "FitAll",
            "FitRegularization",
            "FittedModel",
            "FixedOrder",
            "FixedPoint",
            "FixedPointList",
            "FlashSelection",
            "Flat",
            "FlatShading",
            "Flatten",
            "FlattenAt",
            "FlattenLayer",
            "FlatTopWindow",
            "FlightData",
            "FlipView",
            "Floor",
            "FlowPolynomial",
            "Fold",
            "FoldList",
            "FoldPair",
            "FoldPairList",
            "FoldWhile",
            "FoldWhileList",
            "FollowRedirects",
            "Font",
            "FontColor",
            "FontFamily",
            "FontForm",
            "FontName",
            "FontOpacity",
            "FontPostScriptName",
            "FontProperties",
            "FontReencoding",
            "FontSize",
            "FontSlant",
            "FontSubstitutions",
            "FontTracking",
            "FontVariations",
            "FontWeight",
            "For",
            "ForAll",
            "ForAllType",
            "ForceVersionInstall",
            "Format",
            "FormatRules",
            "FormatType",
            "FormatTypeAutoConvert",
            "FormatValues",
            "FormBox",
            "FormBoxOptions",
            "FormControl",
            "FormFunction",
            "FormLayoutFunction",
            "FormObject",
            "FormPage",
            "FormProtectionMethod",
            "FormTheme",
            "FormulaData",
            "FormulaLookup",
            "FortranForm",
            "Forward",
            "ForwardBackward",
            "ForwardCloudCredentials",
            "Fourier",
            "FourierCoefficient",
            "FourierCosCoefficient",
            "FourierCosSeries",
            "FourierCosTransform",
            "FourierDCT",
            "FourierDCTFilter",
            "FourierDCTMatrix",
            "FourierDST",
            "FourierDSTMatrix",
            "FourierMatrix",
            "FourierParameters",
            "FourierSequenceTransform",
            "FourierSeries",
            "FourierSinCoefficient",
            "FourierSinSeries",
            "FourierSinTransform",
            "FourierTransform",
            "FourierTrigSeries",
            "FoxH",
            "FoxHReduce",
            "FractionalBrownianMotionProcess",
            "FractionalD",
            "FractionalGaussianNoiseProcess",
            "FractionalPart",
            "FractionBox",
            "FractionBoxOptions",
            "FractionLine",
            "Frame",
            "FrameBox",
            "FrameBoxOptions",
            "Framed",
            "FrameInset",
            "FrameLabel",
            "Frameless",
            "FrameListVideo",
            "FrameMargins",
            "FrameRate",
            "FrameStyle",
            "FrameTicks",
            "FrameTicksStyle",
            "FRatioDistribution",
            "FrechetDistribution",
            "FreeQ",
            "FrenetSerretSystem",
            "FrequencySamplingFilterKernel",
            "FresnelC",
            "FresnelF",
            "FresnelG",
            "FresnelS",
            "Friday",
            "FrobeniusNumber",
            "FrobeniusSolve",
            "FromAbsoluteTime",
            "FromCharacterCode",
            "FromCoefficientRules",
            "FromContinuedFraction",
            "FromDate",
            "FromDateString",
            "FromDigits",
            "FromDMS",
            "FromEntity",
            "FromJulianDate",
            "FromLetterNumber",
            "FromPolarCoordinates",
            "FromRawPointer",
            "FromRomanNumeral",
            "FromSphericalCoordinates",
            "FromUnixTime",
            "Front",
            "FrontEndDynamicExpression",
            "FrontEndEventActions",
            "FrontEndExecute",
            "FrontEndObject",
            "FrontEndResource",
            "FrontEndResourceString",
            "FrontEndStackSize",
            "FrontEndToken",
            "FrontEndTokenExecute",
            "FrontEndValueCache",
            "FrontEndVersion",
            "FrontFaceColor",
            "FrontFaceGlowColor",
            "FrontFaceOpacity",
            "FrontFaceSpecularColor",
            "FrontFaceSpecularExponent",
            "FrontFaceSurfaceAppearance",
            "FrontFaceTexture",
            "Full",
            "FullAxes",
            "FullDefinition",
            "FullForm",
            "FullGraphics",
            "FullInformationOutputRegulator",
            "FullOptions",
            "FullRegion",
            "FullSimplify",
            "Function",
            "FunctionAnalytic",
            "FunctionBijective",
            "FunctionCompile",
            "FunctionCompileExport",
            "FunctionCompileExportByteArray",
            "FunctionCompileExportLibrary",
            "FunctionCompileExportString",
            "FunctionContinuous",
            "FunctionConvexity",
            "FunctionDeclaration",
            "FunctionDiscontinuities",
            "FunctionDomain",
            "FunctionExpand",
            "FunctionInjective",
            "FunctionInterpolation",
            "FunctionLayer",
            "FunctionMeromorphic",
            "FunctionMonotonicity",
            "FunctionPeriod",
            "FunctionPoles",
            "FunctionRange",
            "FunctionSign",
            "FunctionSingularities",
            "FunctionSpace",
            "FunctionSurjective",
            "FussellVeselyImportance",
            "GaborFilter",
            "GaborMatrix",
            "GaborWavelet",
            "GainMargins",
            "GainPhaseMargins",
            "GalaxyData",
            "GalleryView",
            "Gamma",
            "GammaDistribution",
            "GammaRegularized",
            "GapPenalty",
            "GARCHProcess",
            "GatedRecurrentLayer",
            "Gather",
            "GatherBy",
            "GaugeFaceElementFunction",
            "GaugeFaceStyle",
            "GaugeFrameElementFunction",
            "GaugeFrameSize",
            "GaugeFrameStyle",
            "GaugeLabels",
            "GaugeMarkers",
            "GaugeStyle",
            "GaussianFilter",
            "GaussianIntegers",
            "GaussianMatrix",
            "GaussianOrthogonalMatrixDistribution",
            "GaussianSymplecticMatrixDistribution",
            "GaussianUnitaryMatrixDistribution",
            "GaussianWindow",
            "GCD",
            "GegenbauerC",
            "General",
            "GeneralizedLinearModelFit",
            "GenerateAsymmetricKeyPair",
            "GenerateConditions",
            "GeneratedAssetFormat",
            "GeneratedAssetLocation",
            "GeneratedCell",
            "GeneratedCellStyles",
            "GeneratedDocumentBinding",
            "GenerateDerivedKey",
            "GenerateDigitalSignature",
            "GenerateDocument",
            "GeneratedParameters",
            "GeneratedQuantityMagnitudes",
            "GenerateFileSignature",
            "GenerateHTTPResponse",
            "GenerateSecuredAuthenticationKey",
            "GenerateSymmetricKey",
            "GeneratingFunction",
            "GeneratorDescription",
            "GeneratorHistoryLength",
            "GeneratorOutputType",
            "Generic",
            "GenericCylindricalDecomposition",
            "GenomeData",
            "GenomeLookup",
            "GeoAntipode",
            "GeoArea",
            "GeoArraySize",
            "GeoBackground",
            "GeoBoundary",
            "GeoBoundingBox",
            "GeoBounds",
            "GeoBoundsRegion",
            "GeoBoundsRegionBoundary",
            "GeoBubbleChart",
            "GeoCenter",
            "GeoCircle",
            "GeoContourPlot",
            "GeoDensityPlot",
            "GeodesicClosing",
            "GeodesicDilation",
            "GeodesicErosion",
            "GeodesicOpening",
            "GeodesicPolyhedron",
            "GeoDestination",
            "GeodesyData",
            "GeoDirection",
            "GeoDisk",
            "GeoDisplacement",
            "GeoDistance",
            "GeoDistanceList",
            "GeoElevationData",
            "GeoEntities",
            "GeoGraphics",
            "GeoGraphPlot",
            "GeoGraphValuePlot",
            "GeogravityModelData",
            "GeoGridDirectionDifference",
            "GeoGridLines",
            "GeoGridLinesStyle",
            "GeoGridPosition",
            "GeoGridRange",
            "GeoGridRangePadding",
            "GeoGridUnitArea",
            "GeoGridUnitDistance",
            "GeoGridVector",
            "GeoGroup",
            "GeoHemisphere",
            "GeoHemisphereBoundary",
            "GeoHistogram",
            "GeoIdentify",
            "GeoImage",
            "GeoLabels",
            "GeoLength",
            "GeoListPlot",
            "GeoLocation",
            "GeologicalPeriodData",
            "GeomagneticModelData",
            "GeoMarker",
            "GeometricAssertion",
            "GeometricBrownianMotionProcess",
            "GeometricDistribution",
            "GeometricMean",
            "GeometricMeanFilter",
            "GeometricOptimization",
            "GeometricScene",
            "GeometricStep",
            "GeometricStylingRules",
            "GeometricTest",
            "GeometricTransformation",
            "GeometricTransformation3DBox",
            "GeometricTransformation3DBoxOptions",
            "GeometricTransformationBox",
            "GeometricTransformationBoxOptions",
            "GeoModel",
            "GeoNearest",
            "GeoOrientationData",
            "GeoPath",
            "GeoPolygon",
            "GeoPosition",
            "GeoPositionENU",
            "GeoPositionXYZ",
            "GeoProjection",
            "GeoProjectionData",
            "GeoRange",
            "GeoRangePadding",
            "GeoRegionValuePlot",
            "GeoResolution",
            "GeoScaleBar",
            "GeoServer",
            "GeoSmoothHistogram",
            "GeoStreamPlot",
            "GeoStyling",
            "GeoStylingImageFunction",
            "GeoVariant",
            "GeoVector",
            "GeoVectorENU",
            "GeoVectorPlot",
            "GeoVectorXYZ",
            "GeoVisibleRegion",
            "GeoVisibleRegionBoundary",
            "GeoWithinQ",
            "GeoZoomLevel",
            "GestureHandler",
            "GestureHandlerTag",
            "Get",
            "GetContext",
            "GetEnvironment",
            "GetFileName",
            "GetLinebreakInformationPacket",
            "GibbsPointProcess",
            "Glaisher",
            "GlobalClusteringCoefficient",
            "GlobalPreferences",
            "GlobalSession",
            "Glow",
            "GoldenAngle",
            "GoldenRatio",
            "GompertzMakehamDistribution",
            "GoochShading",
            "GoodmanKruskalGamma",
            "GoodmanKruskalGammaTest",
            "Goto",
            "GouraudShading",
            "Grad",
            "Gradient",
            "GradientFilter",
            "GradientFittedMesh",
            "GradientOrientationFilter",
            "GrammarApply",
            "GrammarRules",
            "GrammarToken",
            "Graph",
            "Graph3D",
            "GraphAssortativity",
            "GraphAutomorphismGroup",
            "GraphCenter",
            "GraphComplement",
            "GraphData",
            "GraphDensity",
            "GraphDiameter",
            "GraphDifference",
            "GraphDisjointUnion",
            "GraphDistance",
            "GraphDistanceMatrix",
            "GraphEmbedding",
            "GraphHighlight",
            "GraphHighlightStyle",
            "GraphHub",
            "Graphics",
            "Graphics3D",
            "Graphics3DBox",
            "Graphics3DBoxOptions",
            "GraphicsArray",
            "GraphicsBaseline",
            "GraphicsBox",
            "GraphicsBoxOptions",
            "GraphicsColor",
            "GraphicsColumn",
            "GraphicsComplex",
            "GraphicsComplex3DBox",
            "GraphicsComplex3DBoxOptions",
            "GraphicsComplexBox",
            "GraphicsComplexBoxOptions",
            "GraphicsContents",
            "GraphicsData",
            "GraphicsGrid",
            "GraphicsGridBox",
            "GraphicsGroup",
            "GraphicsGroup3DBox",
            "GraphicsGroup3DBoxOptions",
            "GraphicsGroupBox",
            "GraphicsGroupBoxOptions",
            "GraphicsGrouping",
            "GraphicsHighlightColor",
            "GraphicsRow",
            "GraphicsSpacing",
            "GraphicsStyle",
            "GraphIntersection",
            "GraphJoin",
            "GraphLayerLabels",
            "GraphLayers",
            "GraphLayerStyle",
            "GraphLayout",
            "GraphLinkEfficiency",
            "GraphPeriphery",
            "GraphPlot",
            "GraphPlot3D",
            "GraphPower",
            "GraphProduct",
            "GraphPropertyDistribution",
            "GraphQ",
            "GraphRadius",
            "GraphReciprocity",
            "GraphRoot",
            "GraphStyle",
            "GraphSum",
            "GraphTree",
            "GraphUnion",
            "Gray",
            "GrayLevel",
            "Greater",
            "GreaterEqual",
            "GreaterEqualLess",
            "GreaterEqualThan",
            "GreaterFullEqual",
            "GreaterGreater",
            "GreaterLess",
            "GreaterSlantEqual",
            "GreaterThan",
            "GreaterTilde",
            "GreekStyle",
            "Green",
            "GreenFunction",
            "Grid",
            "GridBaseline",
            "GridBox",
            "GridBoxAlignment",
            "GridBoxBackground",
            "GridBoxDividers",
            "GridBoxFrame",
            "GridBoxItemSize",
            "GridBoxItemStyle",
            "GridBoxOptions",
            "GridBoxSpacings",
            "GridCreationSettings",
            "GridDefaultElement",
            "GridElementStyleOptions",
            "GridFrame",
            "GridFrameMargins",
            "GridGraph",
            "GridLines",
            "GridLinesStyle",
            "GridVideo",
            "GroebnerBasis",
            "GroupActionBase",
            "GroupBy",
            "GroupCentralizer",
            "GroupElementFromWord",
            "GroupElementPosition",
            "GroupElementQ",
            "GroupElements",
            "GroupElementToWord",
            "GroupGenerators",
            "Groupings",
            "GroupMultiplicationTable",
            "GroupOpenerColor",
            "GroupOpenerInsideFrame",
            "GroupOrbits",
            "GroupOrder",
            "GroupPageBreakWithin",
            "GroupSetwiseStabilizer",
            "GroupStabilizer",
            "GroupStabilizerChain",
            "GroupTogetherGrouping",
            "GroupTogetherNestedGrouping",
            "GrowCutComponents",
            "Gudermannian",
            "GuidedFilter",
            "GumbelDistribution",
            "HaarWavelet",
            "HadamardMatrix",
            "HalfLine",
            "HalfNormalDistribution",
            "HalfPlane",
            "HalfSpace",
            "HalftoneShading",
            "HamiltonianGraphQ",
            "HammingDistance",
            "HammingWindow",
            "HandlerFunctions",
            "HandlerFunctionsKeys",
            "HankelH1",
            "HankelH2",
            "HankelMatrix",
            "HankelTransform",
            "HannPoissonWindow",
            "HannWindow",
            "HaradaNortonGroupHN",
            "HararyGraph",
            "HardcorePointProcess",
            "HarmonicMean",
            "HarmonicMeanFilter",
            "HarmonicNumber",
            "Hash",
            "HatchFilling",
            "HatchShading",
            "Haversine",
            "HazardFunction",
            "Head",
            "HeadCompose",
            "HeaderAlignment",
            "HeaderBackground",
            "HeaderDisplayFunction",
            "HeaderLines",
            "Headers",
            "HeaderSize",
            "HeaderStyle",
            "Heads",
            "HeatFluxValue",
            "HeatInsulationValue",
            "HeatOutflowValue",
            "HeatRadiationValue",
            "HeatSymmetryValue",
            "HeatTemperatureCondition",
            "HeatTransferPDEComponent",
            "HeatTransferValue",
            "HeavisideLambda",
            "HeavisidePi",
            "HeavisideTheta",
            "HeldGroupHe",
            "HeldPart",
            "HelmholtzPDEComponent",
            "HelpBrowserLookup",
            "HelpBrowserNotebook",
            "HelpBrowserSettings",
            "HelpViewerSettings",
            "Here",
            "HermiteDecomposition",
            "HermiteH",
            "Hermitian",
            "HermitianMatrixQ",
            "HessenbergDecomposition",
            "Hessian",
            "HeunB",
            "HeunBPrime",
            "HeunC",
            "HeunCPrime",
            "HeunD",
            "HeunDPrime",
            "HeunG",
            "HeunGPrime",
            "HeunT",
            "HeunTPrime",
            "HexadecimalCharacter",
            "Hexahedron",
            "HexahedronBox",
            "HexahedronBoxOptions",
            "HiddenItems",
            "HiddenMarkovProcess",
            "HiddenSurface",
            "Highlighted",
            "HighlightGraph",
            "HighlightImage",
            "HighlightMesh",
            "HighlightString",
            "HighpassFilter",
            "HigmanSimsGroupHS",
            "HilbertCurve",
            "HilbertFilter",
            "HilbertMatrix",
            "Histogram",
            "Histogram3D",
            "HistogramDistribution",
            "HistogramList",
            "HistogramPointDensity",
            "HistogramTransform",
            "HistogramTransformInterpolation",
            "HistoricalPeriodData",
            "HitMissTransform",
            "HITSCentrality",
            "HjorthDistribution",
            "HodgeDual",
            "HoeffdingD",
            "HoeffdingDTest",
            "Hold",
            "HoldAll",
            "HoldAllComplete",
            "HoldComplete",
            "HoldFirst",
            "HoldForm",
            "HoldPattern",
            "HoldRest",
            "HolidayCalendar",
            "HomeDirectory",
            "HomePage",
            "Horizontal",
            "HorizontalForm",
            "HorizontalGauge",
            "HorizontalScrollPosition",
            "HornerForm",
            "HostLookup",
            "HotellingTSquareDistribution",
            "HoytDistribution",
            "HTMLSave",
            "HTTPErrorResponse",
            "HTTPRedirect",
            "HTTPRequest",
            "HTTPRequestData",
            "HTTPResponse",
            "Hue",
            "HumanGrowthData",
            "HumpDownHump",
            "HumpEqual",
            "HurwitzLerchPhi",
            "HurwitzZeta",
            "HyperbolicDistribution",
            "HypercubeGraph",
            "HyperexponentialDistribution",
            "Hyperfactorial",
            "Hypergeometric0F1",
            "Hypergeometric0F1Regularized",
            "Hypergeometric1F1",
            "Hypergeometric1F1Regularized",
            "Hypergeometric2F1",
            "Hypergeometric2F1Regularized",
            "HypergeometricDistribution",
            "HypergeometricPFQ",
            "HypergeometricPFQRegularized",
            "HypergeometricU",
            "Hyperlink",
            "HyperlinkAction",
            "HyperlinkCreationSettings",
            "Hyperplane",
            "Hyphenation",
            "HyphenationOptions",
            "HypoexponentialDistribution",
            "HypothesisTestData",
            "I",
            "IconData",
            "Iconize",
            "IconizedObject",
            "IconRules",
            "Icosahedron",
            "Identity",
            "IdentityMatrix",
            "If",
            "IfCompiled",
            "IgnoreCase",
            "IgnoreDiacritics",
            "IgnoreIsotopes",
            "IgnorePunctuation",
            "IgnoreSpellCheck",
            "IgnoreStereochemistry",
            "IgnoringInactive",
            "Im",
            "Image",
            "Image3D",
            "Image3DProjection",
            "Image3DSlices",
            "ImageAccumulate",
            "ImageAdd",
            "ImageAdjust",
            "ImageAlign",
            "ImageApply",
            "ImageApplyIndexed",
            "ImageAspectRatio",
            "ImageAssemble",
            "ImageAugmentationLayer",
            "ImageBoundingBoxes",
            "ImageCache",
            "ImageCacheValid",
            "ImageCapture",
            "ImageCaptureFunction",
            "ImageCases",
            "ImageChannels",
            "ImageClip",
            "ImageCollage",
            "ImageColorSpace",
            "ImageCompose",
            "ImageContainsQ",
            "ImageContents",
            "ImageConvolve",
            "ImageCooccurrence",
            "ImageCorners",
            "ImageCorrelate",
            "ImageCorrespondingPoints",
            "ImageCrop",
            "ImageData",
            "ImageDeconvolve",
            "ImageDemosaic",
            "ImageDifference",
            "ImageDimensions",
            "ImageDisplacements",
            "ImageDistance",
            "ImageEditMode",
            "ImageEffect",
            "ImageExposureCombine",
            "ImageFeatureTrack",
            "ImageFileApply",
            "ImageFileFilter",
            "ImageFileScan",
            "ImageFilter",
            "ImageFocusCombine",
            "ImageForestingComponents",
            "ImageFormattingWidth",
            "ImageForwardTransformation",
            "ImageGraphics",
            "ImageHistogram",
            "ImageIdentify",
            "ImageInstanceQ",
            "ImageKeypoints",
            "ImageLabels",
            "ImageLegends",
            "ImageLevels",
            "ImageLines",
            "ImageMargins",
            "ImageMarker",
            "ImageMarkers",
            "ImageMeasurements",
            "ImageMesh",
            "ImageMultiply",
            "ImageOffset",
            "ImagePad",
            "ImagePadding",
            "ImagePartition",
            "ImagePeriodogram",
            "ImagePerspectiveTransformation",
            "ImagePosition",
            "ImagePreviewFunction",
            "ImagePyramid",
            "ImagePyramidApply",
            "ImageQ",
            "ImageRangeCache",
            "ImageRecolor",
            "ImageReflect",
            "ImageRegion",
            "ImageResize",
            "ImageResolution",
            "ImageRestyle",
            "ImageRotate",
            "ImageRotated",
            "ImageSaliencyFilter",
            "ImageScaled",
            "ImageScan",
            "ImageSize",
            "ImageSizeAction",
            "ImageSizeCache",
            "ImageSizeMultipliers",
            "ImageSizeRaw",
            "ImageStitch",
            "ImageSubtract",
            "ImageTake",
            "ImageTransformation",
            "ImageTrim",
            "ImageType",
            "ImageValue",
            "ImageValuePositions",
            "ImageVectorscopePlot",
            "ImageWaveformPlot",
            "ImagingDevice",
            "ImplicitD",
            "ImplicitRegion",
            "Implies",
            "Import",
            "ImportAutoReplacements",
            "ImportByteArray",
            "ImportedObject",
            "ImportOptions",
            "ImportString",
            "ImprovementImportance",
            "In",
            "Inactivate",
            "Inactive",
            "InactiveStyle",
            "IncidenceGraph",
            "IncidenceList",
            "IncidenceMatrix",
            "IncludeAromaticBonds",
            "IncludeConstantBasis",
            "IncludedContexts",
            "IncludeDefinitions",
            "IncludeDirectories",
            "IncludeFileExtension",
            "IncludeGeneratorTasks",
            "IncludeHydrogens",
            "IncludeInflections",
            "IncludeMetaInformation",
            "IncludePods",
            "IncludeQuantities",
            "IncludeRelatedTables",
            "IncludeSingularSolutions",
            "IncludeSingularTerm",
            "IncludeWindowTimes",
            "Increment",
            "IndefiniteMatrixQ",
            "Indent",
            "IndentingNewlineSpacings",
            "IndentMaxFraction",
            "IndependenceTest",
            "IndependentEdgeSetQ",
            "IndependentPhysicalQuantity",
            "IndependentUnit",
            "IndependentUnitDimension",
            "IndependentVertexSetQ",
            "Indeterminate",
            "IndeterminateThreshold",
            "IndexCreationOptions",
            "Indexed",
            "IndexEdgeTaggedGraph",
            "IndexGraph",
            "IndexTag",
            "Inequality",
            "InertEvaluate",
            "InertExpression",
            "InexactNumberQ",
            "InexactNumbers",
            "InfiniteFuture",
            "InfiniteLine",
            "InfiniteLineThrough",
            "InfinitePast",
            "InfinitePlane",
            "Infinity",
            "Infix",
            "InflationAdjust",
            "InflationMethod",
            "Information",
            "InformationData",
            "InformationDataGrid",
            "Inherited",
            "InheritScope",
            "InhomogeneousPoissonPointProcess",
            "InhomogeneousPoissonProcess",
            "InitialEvaluationHistory",
            "Initialization",
            "InitializationCell",
            "InitializationCellEvaluation",
            "InitializationCellWarning",
            "InitializationObject",
            "InitializationObjects",
            "InitializationValue",
            "Initialize",
            "InitialSeeding",
            "InlineCounterAssignments",
            "InlineCounterIncrements",
            "InlineRules",
            "Inner",
            "InnerPolygon",
            "InnerPolyhedron",
            "Inpaint",
            "Input",
            "InputAliases",
            "InputAssumptions",
            "InputAutoReplacements",
            "InputField",
            "InputFieldBox",
            "InputFieldBoxOptions",
            "InputForm",
            "InputGrouping",
            "InputNamePacket",
            "InputNotebook",
            "InputPacket",
            "InputPorts",
            "InputSettings",
            "InputStream",
            "InputString",
            "InputStringPacket",
            "InputToBoxFormPacket",
            "Insert",
            "InsertionFunction",
            "InsertionPointObject",
            "InsertLinebreaks",
            "InsertResults",
            "Inset",
            "Inset3DBox",
            "Inset3DBoxOptions",
            "InsetBox",
            "InsetBoxOptions",
            "Insphere",
            "Install",
            "InstallService",
            "InstanceNormalizationLayer",
            "InString",
            "Integer",
            "IntegerDigits",
            "IntegerExponent",
            "IntegerLength",
            "IntegerName",
            "IntegerPart",
            "IntegerPartitions",
            "IntegerQ",
            "IntegerReverse",
            "Integers",
            "IntegerString",
            "Integral",
            "Integrate",
            "IntegrateChangeVariables",
            "Interactive",
            "InteractiveTradingChart",
            "InterfaceSwitched",
            "Interlaced",
            "Interleaving",
            "InternallyBalancedDecomposition",
            "InterpolatingFunction",
            "InterpolatingPolynomial",
            "Interpolation",
            "InterpolationOrder",
            "InterpolationPoints",
            "InterpolationPrecision",
            "Interpretation",
            "InterpretationBox",
            "InterpretationBoxOptions",
            "InterpretationFunction",
            "Interpreter",
            "InterpretTemplate",
            "InterquartileRange",
            "Interrupt",
            "InterruptSettings",
            "IntersectedEntityClass",
            "IntersectingQ",
            "Intersection",
            "Interval",
            "IntervalIntersection",
            "IntervalMarkers",
            "IntervalMarkersStyle",
            "IntervalMemberQ",
            "IntervalSlider",
            "IntervalUnion",
            "Into",
            "Inverse",
            "InverseBetaRegularized",
            "InverseBilateralLaplaceTransform",
            "InverseBilateralZTransform",
            "InverseCDF",
            "InverseChiSquareDistribution",
            "InverseContinuousWaveletTransform",
            "InverseDistanceTransform",
            "InverseEllipticNomeQ",
            "InverseErf",
            "InverseErfc",
            "InverseFourier",
            "InverseFourierCosTransform",
            "InverseFourierSequenceTransform",
            "InverseFourierSinTransform",
            "InverseFourierTransform",
            "InverseFunction",
            "InverseFunctions",
            "InverseGammaDistribution",
            "InverseGammaRegularized",
            "InverseGaussianDistribution",
            "InverseGudermannian",
            "InverseHankelTransform",
            "InverseHaversine",
            "InverseImagePyramid",
            "InverseJacobiCD",
            "InverseJacobiCN",
            "InverseJacobiCS",
            "InverseJacobiDC",
            "InverseJacobiDN",
            "InverseJacobiDS",
            "InverseJacobiNC",
            "InverseJacobiND",
            "InverseJacobiNS",
            "InverseJacobiSC",
            "InverseJacobiSD",
            "InverseJacobiSN",
            "InverseLaplaceTransform",
            "InverseMellinTransform",
            "InversePermutation",
            "InverseRadon",
            "InverseRadonTransform",
            "InverseSeries",
            "InverseShortTimeFourier",
            "InverseSpectrogram",
            "InverseSurvivalFunction",
            "InverseTransformedRegion",
            "InverseWaveletTransform",
            "InverseWeierstrassP",
            "InverseWishartMatrixDistribution",
            "InverseZTransform",
            "Invisible",
            "InvisibleApplication",
            "InvisibleTimes",
            "IPAddress",
            "IrreduciblePolynomialQ",
            "IslandData",
            "IsolatingInterval",
            "IsomorphicGraphQ",
            "IsomorphicSubgraphQ",
            "IsotopeData",
            "Italic",
            "Item",
            "ItemAspectRatio",
            "ItemBox",
            "ItemBoxOptions",
            "ItemDisplayFunction",
            "ItemSize",
            "ItemStyle",
            "ItoProcess",
            "JaccardDissimilarity",
            "JacobiAmplitude",
            "Jacobian",
            "JacobiCD",
            "JacobiCN",
            "JacobiCS",
            "JacobiDC",
            "JacobiDN",
            "JacobiDS",
            "JacobiEpsilon",
            "JacobiNC",
            "JacobiND",
            "JacobiNS",
            "JacobiP",
            "JacobiSC",
            "JacobiSD",
            "JacobiSN",
            "JacobiSymbol",
            "JacobiZeta",
            "JacobiZN",
            "JankoGroupJ1",
            "JankoGroupJ2",
            "JankoGroupJ3",
            "JankoGroupJ4",
            "JarqueBeraALMTest",
            "JohnsonDistribution",
            "Join",
            "JoinAcross",
            "Joined",
            "JoinedCurve",
            "JoinedCurveBox",
            "JoinedCurveBoxOptions",
            "JoinForm",
            "JordanDecomposition",
            "JordanModelDecomposition",
            "JulianDate",
            "JuliaSetBoettcher",
            "JuliaSetIterationCount",
            "JuliaSetPlot",
            "JuliaSetPoints",
            "K",
            "KagiChart",
            "KaiserBesselWindow",
            "KaiserWindow",
            "KalmanEstimator",
            "KalmanFilter",
            "KarhunenLoeveDecomposition",
            "KaryTree",
            "KatzCentrality",
            "KCoreComponents",
            "KDistribution",
            "KEdgeConnectedComponents",
            "KEdgeConnectedGraphQ",
            "KeepExistingVersion",
            "KelvinBei",
            "KelvinBer",
            "KelvinKei",
            "KelvinKer",
            "KendallTau",
            "KendallTauTest",
            "KernelConfiguration",
            "KernelExecute",
            "KernelFunction",
            "KernelMixtureDistribution",
            "KernelObject",
            "Kernels",
            "Ket",
            "Key",
            "KeyCollisionFunction",
            "KeyComplement",
            "KeyDrop",
            "KeyDropFrom",
            "KeyExistsQ",
            "KeyFreeQ",
            "KeyIntersection",
            "KeyMap",
            "KeyMemberQ",
            "KeypointStrength",
            "Keys",
            "KeySelect",
            "KeySort",
            "KeySortBy",
            "KeyTake",
            "KeyUnion",
            "KeyValueMap",
            "KeyValuePattern",
            "Khinchin",
            "KillProcess",
            "KirchhoffGraph",
            "KirchhoffMatrix",
            "KleinInvariantJ",
            "KnapsackSolve",
            "KnightTourGraph",
            "KnotData",
            "KnownUnitQ",
            "KochCurve",
            "KolmogorovSmirnovTest",
            "KroneckerDelta",
            "KroneckerModelDecomposition",
            "KroneckerProduct",
            "KroneckerSymbol",
            "KuiperTest",
            "KumaraswamyDistribution",
            "Kurtosis",
            "KuwaharaFilter",
            "KVertexConnectedComponents",
            "KVertexConnectedGraphQ",
            "LABColor",
            "Label",
            "Labeled",
            "LabeledSlider",
            "LabelingFunction",
            "LabelingSize",
            "LabelStyle",
            "LabelVisibility",
            "LaguerreL",
            "LakeData",
            "LambdaComponents",
            "LambertW",
            "LameC",
            "LameCPrime",
            "LameEigenvalueA",
            "LameEigenvalueB",
            "LameS",
            "LameSPrime",
            "LaminaData",
            "LanczosWindow",
            "LandauDistribution",
            "Language",
            "LanguageCategory",
            "LanguageData",
            "LanguageIdentify",
            "LanguageOptions",
            "LaplaceDistribution",
            "LaplaceTransform",
            "Laplacian",
            "LaplacianFilter",
            "LaplacianGaussianFilter",
            "LaplacianPDETerm",
            "Large",
            "Larger",
            "Last",
            "Latitude",
            "LatitudeLongitude",
            "LatticeData",
            "LatticeReduce",
            "Launch",
            "LaunchKernels",
            "LayeredGraphPlot",
            "LayeredGraphPlot3D",
            "LayerSizeFunction",
            "LayoutInformation",
            "LCHColor",
            "LCM",
            "LeaderSize",
            "LeafCount",
            "LeapVariant",
            "LeapYearQ",
            "LearnDistribution",
            "LearnedDistribution",
            "LearningRate",
            "LearningRateMultipliers",
            "LeastSquares",
            "LeastSquaresFilterKernel",
            "Left",
            "LeftArrow",
            "LeftArrowBar",
            "LeftArrowRightArrow",
            "LeftDownTeeVector",
            "LeftDownVector",
            "LeftDownVectorBar",
            "LeftRightArrow",
            "LeftRightVector",
            "LeftTee",
            "LeftTeeArrow",
            "LeftTeeVector",
            "LeftTriangle",
            "LeftTriangleBar",
            "LeftTriangleEqual",
            "LeftUpDownVector",
            "LeftUpTeeVector",
            "LeftUpVector",
            "LeftUpVectorBar",
            "LeftVector",
            "LeftVectorBar",
            "LegendAppearance",
            "Legended",
            "LegendFunction",
            "LegendLabel",
            "LegendLayout",
            "LegendMargins",
            "LegendMarkers",
            "LegendMarkerSize",
            "LegendreP",
            "LegendreQ",
            "LegendreType",
            "Length",
            "LengthWhile",
            "LerchPhi",
            "Less",
            "LessEqual",
            "LessEqualGreater",
            "LessEqualThan",
            "LessFullEqual",
            "LessGreater",
            "LessLess",
            "LessSlantEqual",
            "LessThan",
            "LessTilde",
            "LetterCharacter",
            "LetterCounts",
            "LetterNumber",
            "LetterQ",
            "Level",
            "LeveneTest",
            "LeviCivitaTensor",
            "LevyDistribution",
            "Lexicographic",
            "LexicographicOrder",
            "LexicographicSort",
            "LibraryDataType",
            "LibraryFunction",
            "LibraryFunctionDeclaration",
            "LibraryFunctionError",
            "LibraryFunctionInformation",
            "LibraryFunctionLoad",
            "LibraryFunctionUnload",
            "LibraryLoad",
            "LibraryUnload",
            "LicenseEntitlementObject",
            "LicenseEntitlements",
            "LicenseID",
            "LicensingSettings",
            "LiftingFilterData",
            "LiftingWaveletTransform",
            "LightBlue",
            "LightBrown",
            "LightCyan",
            "Lighter",
            "LightGray",
            "LightGreen",
            "Lighting",
            "LightingAngle",
            "LightMagenta",
            "LightOrange",
            "LightPink",
            "LightPurple",
            "LightRed",
            "LightSources",
            "LightYellow",
            "Likelihood",
            "Limit",
            "LimitsPositioning",
            "LimitsPositioningTokens",
            "LindleyDistribution",
            "Line",
            "Line3DBox",
            "Line3DBoxOptions",
            "LinearFilter",
            "LinearFractionalOptimization",
            "LinearFractionalTransform",
            "LinearGradientFilling",
            "LinearGradientImage",
            "LinearizingTransformationData",
            "LinearLayer",
            "LinearModelFit",
            "LinearOffsetFunction",
            "LinearOptimization",
            "LinearProgramming",
            "LinearRecurrence",
            "LinearSolve",
            "LinearSolveFunction",
            "LineBox",
            "LineBoxOptions",
            "LineBreak",
            "LinebreakAdjustments",
            "LineBreakChart",
            "LinebreakSemicolonWeighting",
            "LineBreakWithin",
            "LineColor",
            "LineGraph",
            "LineIndent",
            "LineIndentMaxFraction",
            "LineIntegralConvolutionPlot",
            "LineIntegralConvolutionScale",
            "LineLegend",
            "LineOpacity",
            "LineSpacing",
            "LineWrapParts",
            "LinkActivate",
            "LinkClose",
            "LinkConnect",
            "LinkConnectedQ",
            "LinkCreate",
            "LinkError",
            "LinkFlush",
            "LinkFunction",
            "LinkHost",
            "LinkInterrupt",
            "LinkLaunch",
            "LinkMode",
            "LinkObject",
            "LinkOpen",
            "LinkOptions",
            "LinkPatterns",
            "LinkProtocol",
            "LinkRankCentrality",
            "LinkRead",
            "LinkReadHeld",
            "LinkReadyQ",
            "Links",
            "LinkService",
            "LinkWrite",
            "LinkWriteHeld",
            "LiouvilleLambda",
            "List",
            "Listable",
            "ListAnimate",
            "ListContourPlot",
            "ListContourPlot3D",
            "ListConvolve",
            "ListCorrelate",
            "ListCurvePathPlot",
            "ListDeconvolve",
            "ListDensityPlot",
            "ListDensityPlot3D",
            "Listen",
            "ListFormat",
            "ListFourierSequenceTransform",
            "ListInterpolation",
            "ListLineIntegralConvolutionPlot",
            "ListLinePlot",
            "ListLinePlot3D",
            "ListLogLinearPlot",
            "ListLogLogPlot",
            "ListLogPlot",
            "ListPicker",
            "ListPickerBox",
            "ListPickerBoxBackground",
            "ListPickerBoxOptions",
            "ListPlay",
            "ListPlot",
            "ListPlot3D",
            "ListPointPlot3D",
            "ListPolarPlot",
            "ListQ",
            "ListSliceContourPlot3D",
            "ListSliceDensityPlot3D",
            "ListSliceVectorPlot3D",
            "ListStepPlot",
            "ListStreamDensityPlot",
            "ListStreamPlot",
            "ListStreamPlot3D",
            "ListSurfacePlot3D",
            "ListVectorDensityPlot",
            "ListVectorDisplacementPlot",
            "ListVectorDisplacementPlot3D",
            "ListVectorPlot",
            "ListVectorPlot3D",
            "ListZTransform",
            "Literal",
            "LiteralSearch",
            "LiteralType",
            "LoadCompiledComponent",
            "LocalAdaptiveBinarize",
            "LocalCache",
            "LocalClusteringCoefficient",
            "LocalEvaluate",
            "LocalizeDefinitions",
            "LocalizeVariables",
            "LocalObject",
            "LocalObjects",
            "LocalResponseNormalizationLayer",
            "LocalSubmit",
            "LocalSymbol",
            "LocalTime",
            "LocalTimeZone",
            "LocationEquivalenceTest",
            "LocationTest",
            "Locator",
            "LocatorAutoCreate",
            "LocatorBox",
            "LocatorBoxOptions",
            "LocatorCentering",
            "LocatorPane",
            "LocatorPaneBox",
            "LocatorPaneBoxOptions",
            "LocatorRegion",
            "Locked",
            "Log",
            "Log10",
            "Log2",
            "LogBarnesG",
            "LogGamma",
            "LogGammaDistribution",
            "LogicalExpand",
            "LogIntegral",
            "LogisticDistribution",
            "LogisticSigmoid",
            "LogitModelFit",
            "LogLikelihood",
            "LogLinearPlot",
            "LogLogisticDistribution",
            "LogLogPlot",
            "LogMultinormalDistribution",
            "LogNormalDistribution",
            "LogPlot",
            "LogRankTest",
            "LogSeriesDistribution",
            "LongEqual",
            "Longest",
            "LongestCommonSequence",
            "LongestCommonSequencePositions",
            "LongestCommonSubsequence",
            "LongestCommonSubsequencePositions",
            "LongestMatch",
            "LongestOrderedSequence",
            "LongForm",
            "Longitude",
            "LongLeftArrow",
            "LongLeftRightArrow",
            "LongRightArrow",
            "LongShortTermMemoryLayer",
            "Lookup",
            "Loopback",
            "LoopFreeGraphQ",
            "Looping",
            "LossFunction",
            "LowerCaseQ",
            "LowerLeftArrow",
            "LowerRightArrow",
            "LowerTriangularize",
            "LowerTriangularMatrix",
            "LowerTriangularMatrixQ",
            "LowpassFilter",
            "LQEstimatorGains",
            "LQGRegulator",
            "LQOutputRegulatorGains",
            "LQRegulatorGains",
            "LUBackSubstitution",
            "LucasL",
            "LuccioSamiComponents",
            "LUDecomposition",
            "LunarEclipse",
            "LUVColor",
            "LyapunovSolve",
            "LyonsGroupLy",
            "MachineID",
            "MachineName",
            "MachineNumberQ",
            "MachinePrecision",
            "MacintoshSystemPageSetup",
            "Magenta",
            "Magnification",
            "Magnify",
            "MailAddressValidation",
            "MailExecute",
            "MailFolder",
            "MailItem",
            "MailReceiverFunction",
            "MailResponseFunction",
            "MailSearch",
            "MailServerConnect",
            "MailServerConnection",
            "MailSettings",
            "MainSolve",
            "MaintainDynamicCaches",
            "Majority",
            "MakeBoxes",
            "MakeExpression",
            "MakeRules",
            "ManagedLibraryExpressionID",
            "ManagedLibraryExpressionQ",
            "MandelbrotSetBoettcher",
            "MandelbrotSetDistance",
            "MandelbrotSetIterationCount",
            "MandelbrotSetMemberQ",
            "MandelbrotSetPlot",
            "MangoldtLambda",
            "ManhattanDistance",
            "Manipulate",
            "Manipulator",
            "MannedSpaceMissionData",
            "MannWhitneyTest",
            "MantissaExponent",
            "Manual",
            "Map",
            "MapAll",
            "MapApply",
            "MapAt",
            "MapIndexed",
            "MAProcess",
            "MapThread",
            "MarchenkoPasturDistribution",
            "MarcumQ",
            "MardiaCombinedTest",
            "MardiaKurtosisTest",
            "MardiaSkewnessTest",
            "MarginalDistribution",
            "MarkovProcessProperties",
            "Masking",
            "MassConcentrationCondition",
            "MassFluxValue",
            "MassImpermeableBoundaryValue",
            "MassOutflowValue",
            "MassSymmetryValue",
            "MassTransferValue",
            "MassTransportPDEComponent",
            "MatchingDissimilarity",
            "MatchLocalNameQ",
            "MatchLocalNames",
            "MatchQ",
            "Material",
            "MaterialShading",
            "MaternPointProcess",
            "MathematicalFunctionData",
            "MathematicaNotation",
            "MathieuC",
            "MathieuCharacteristicA",
            "MathieuCharacteristicB",
            "MathieuCharacteristicExponent",
            "MathieuCPrime",
            "MathieuGroupM11",
            "MathieuGroupM12",
            "MathieuGroupM22",
            "MathieuGroupM23",
            "MathieuGroupM24",
            "MathieuS",
            "MathieuSPrime",
            "MathMLForm",
            "MathMLText",
            "Matrices",
            "MatrixExp",
            "MatrixForm",
            "MatrixFunction",
            "MatrixLog",
            "MatrixNormalDistribution",
            "MatrixPlot",
            "MatrixPower",
            "MatrixPropertyDistribution",
            "MatrixQ",
            "MatrixRank",
            "MatrixTDistribution",
            "Max",
            "MaxBend",
            "MaxCellMeasure",
            "MaxColorDistance",
            "MaxDate",
            "MaxDetect",
            "MaxDisplayedChildren",
            "MaxDuration",
            "MaxExtraBandwidths",
            "MaxExtraConditions",
            "MaxFeatureDisplacement",
            "MaxFeatures",
            "MaxFilter",
            "MaximalBy",
            "Maximize",
            "MaxItems",
            "MaxIterations",
            "MaxLimit",
            "MaxMemoryUsed",
            "MaxMixtureKernels",
            "MaxOverlapFraction",
            "MaxPlotPoints",
            "MaxPoints",
            "MaxRecursion",
            "MaxStableDistribution",
            "MaxStepFraction",
            "MaxSteps",
            "MaxStepSize",
            "MaxTrainingRounds",
            "MaxValue",
            "MaxwellDistribution",
            "MaxWordGap",
            "McLaughlinGroupMcL",
            "Mean",
            "MeanAbsoluteLossLayer",
            "MeanAround",
            "MeanClusteringCoefficient",
            "MeanDegreeConnectivity",
            "MeanDeviation",
            "MeanFilter",
            "MeanGraphDistance",
            "MeanNeighborDegree",
            "MeanPointDensity",
            "MeanShift",
            "MeanShiftFilter",
            "MeanSquaredLossLayer",
            "Median",
            "MedianDeviation",
            "MedianFilter",
            "MedicalTestData",
            "Medium",
            "MeijerG",
            "MeijerGReduce",
            "MeixnerDistribution",
            "MellinConvolve",
            "MellinTransform",
            "MemberQ",
            "MemoryAvailable",
            "MemoryConstrained",
            "MemoryConstraint",
            "MemoryInUse",
            "MengerMesh",
            "Menu",
            "MenuAppearance",
            "MenuCommandKey",
            "MenuEvaluator",
            "MenuItem",
            "MenuList",
            "MenuPacket",
            "MenuSortingValue",
            "MenuStyle",
            "MenuView",
            "Merge",
            "MergeDifferences",
            "MergingFunction",
            "MersennePrimeExponent",
            "MersennePrimeExponentQ",
            "Mesh",
            "MeshCellCentroid",
            "MeshCellCount",
            "MeshCellHighlight",
            "MeshCellIndex",
            "MeshCellLabel",
            "MeshCellMarker",
            "MeshCellMeasure",
            "MeshCellQuality",
            "MeshCells",
            "MeshCellShapeFunction",
            "MeshCellStyle",
            "MeshConnectivityGraph",
            "MeshCoordinates",
            "MeshFunctions",
            "MeshPrimitives",
            "MeshQualityGoal",
            "MeshRange",
            "MeshRefinementFunction",
            "MeshRegion",
            "MeshRegionQ",
            "MeshShading",
            "MeshStyle",
            "Message",
            "MessageDialog",
            "MessageList",
            "MessageName",
            "MessageObject",
            "MessageOptions",
            "MessagePacket",
            "Messages",
            "MessagesNotebook",
            "MetaCharacters",
            "MetaInformation",
            "MeteorShowerData",
            "Method",
            "MethodOptions",
            "MexicanHatWavelet",
            "MeyerWavelet",
            "Midpoint",
            "MIMETypeToFormatList",
            "Min",
            "MinColorDistance",
            "MinDate",
            "MinDetect",
            "MineralData",
            "MinFilter",
            "MinimalBy",
            "MinimalPolynomial",
            "MinimalStateSpaceModel",
            "Minimize",
            "MinimumTimeIncrement",
            "MinIntervalSize",
            "MinkowskiQuestionMark",
            "MinLimit",
            "MinMax",
            "MinorPlanetData",
            "Minors",
            "MinPointSeparation",
            "MinRecursion",
            "MinSize",
            "MinStableDistribution",
            "Minus",
            "MinusPlus",
            "MinValue",
            "Missing",
            "MissingBehavior",
            "MissingDataMethod",
            "MissingDataRules",
            "MissingQ",
            "MissingString",
            "MissingStyle",
            "MissingValuePattern",
            "MissingValueSynthesis",
            "MittagLefflerE",
            "MixedFractionParts",
            "MixedGraphQ",
            "MixedMagnitude",
            "MixedRadix",
            "MixedRadixQuantity",
            "MixedUnit",
            "MixtureDistribution",
            "Mod",
            "Modal",
            "Mode",
            "ModelPredictiveController",
            "Modular",
            "ModularInverse",
            "ModularLambda",
            "Module",
            "Modulus",
            "MoebiusMu",
            "Molecule",
            "MoleculeAlign",
            "MoleculeContainsQ",
            "MoleculeDraw",
            "MoleculeEquivalentQ",
            "MoleculeFreeQ",
            "MoleculeGraph",
            "MoleculeMatchQ",
            "MoleculeMaximumCommonSubstructure",
            "MoleculeModify",
            "MoleculeName",
            "MoleculePattern",
            "MoleculePlot",
            "MoleculePlot3D",
            "MoleculeProperty",
            "MoleculeQ",
            "MoleculeRecognize",
            "MoleculeSubstructureCount",
            "MoleculeValue",
            "Moment",
            "MomentConvert",
            "MomentEvaluate",
            "MomentGeneratingFunction",
            "MomentOfInertia",
            "Monday",
            "Monitor",
            "MonomialList",
            "MonomialOrder",
            "MonsterGroupM",
            "MoonPhase",
            "MoonPosition",
            "MorletWavelet",
            "MorphologicalBinarize",
            "MorphologicalBranchPoints",
            "MorphologicalComponents",
            "MorphologicalEulerNumber",
            "MorphologicalGraph",
            "MorphologicalPerimeter",
            "MorphologicalTransform",
            "MortalityData",
            "Most",
            "MountainData",
            "MouseAnnotation",
            "MouseAppearance",
            "MouseAppearanceTag",
            "MouseButtons",
            "Mouseover",
            "MousePointerNote",
            "MousePosition",
            "MovieData",
            "MovingAverage",
            "MovingMap",
            "MovingMedian",
            "MoyalDistribution",
            "MultiaxisArrangement",
            "Multicolumn",
            "MultiedgeStyle",
            "MultigraphQ",
            "MultilaunchWarning",
            "MultiLetterItalics",
            "MultiLetterStyle",
            "MultilineFunction",
            "Multinomial",
            "MultinomialDistribution",
            "MultinormalDistribution",
            "MultiplicativeOrder",
            "Multiplicity",
            "MultiplySides",
            "MultiscriptBoxOptions",
            "Multiselection",
            "MultivariateHypergeometricDistribution",
            "MultivariatePoissonDistribution",
            "MultivariateTDistribution",
            "N",
            "NakagamiDistribution",
            "NameQ",
            "Names",
            "NamespaceBox",
            "NamespaceBoxOptions",
            "Nand",
            "NArgMax",
            "NArgMin",
            "NBernoulliB",
            "NBodySimulation",
            "NBodySimulationData",
            "NCache",
            "NCaputoD",
            "NDEigensystem",
            "NDEigenvalues",
            "NDSolve",
            "NDSolveValue",
            "Nearest",
            "NearestFunction",
            "NearestMeshCells",
            "NearestNeighborG",
            "NearestNeighborGraph",
            "NearestTo",
            "NebulaData",
            "NeedlemanWunschSimilarity",
            "Needs",
            "Negative",
            "NegativeBinomialDistribution",
            "NegativeDefiniteMatrixQ",
            "NegativeIntegers",
            "NegativelyOrientedPoints",
            "NegativeMultinomialDistribution",
            "NegativeRationals",
            "NegativeReals",
            "NegativeSemidefiniteMatrixQ",
            "NeighborhoodData",
            "NeighborhoodGraph",
            "Nest",
            "NestedGreaterGreater",
            "NestedLessLess",
            "NestedScriptRules",
            "NestGraph",
            "NestList",
            "NestTree",
            "NestWhile",
            "NestWhileList",
            "NetAppend",
            "NetArray",
            "NetArrayLayer",
            "NetBidirectionalOperator",
            "NetChain",
            "NetDecoder",
            "NetDelete",
            "NetDrop",
            "NetEncoder",
            "NetEvaluationMode",
            "NetExternalObject",
            "NetExtract",
            "NetFlatten",
            "NetFoldOperator",
            "NetGANOperator",
            "NetGraph",
            "NetInformation",
            "NetInitialize",
            "NetInsert",
            "NetInsertSharedArrays",
            "NetJoin",
            "NetMapOperator",
            "NetMapThreadOperator",
            "NetMeasurements",
            "NetModel",
            "NetNestOperator",
            "NetPairEmbeddingOperator",
            "NetPort",
            "NetPortGradient",
            "NetPrepend",
            "NetRename",
            "NetReplace",
            "NetReplacePart",
            "NetSharedArray",
            "NetStateObject",
            "NetTake",
            "NetTrain",
            "NetTrainResultsObject",
            "NetUnfold",
            "NetworkPacketCapture",
            "NetworkPacketRecording",
            "NetworkPacketRecordingDuring",
            "NetworkPacketTrace",
            "NeumannValue",
            "NevilleThetaC",
            "NevilleThetaD",
            "NevilleThetaN",
            "NevilleThetaS",
            "NewPrimitiveStyle",
            "NExpectation",
            "Next",
            "NextCell",
            "NextDate",
            "NextPrime",
            "NextScheduledTaskTime",
            "NeymanScottPointProcess",
            "NFractionalD",
            "NHoldAll",
            "NHoldFirst",
            "NHoldRest",
            "NicholsGridLines",
            "NicholsPlot",
            "NightHemisphere",
            "NIntegrate",
            "NMaximize",
            "NMaxValue",
            "NMinimize",
            "NMinValue",
            "NominalScale",
            "NominalVariables",
            "NonAssociative",
            "NoncentralBetaDistribution",
            "NoncentralChiSquareDistribution",
            "NoncentralFRatioDistribution",
            "NoncentralStudentTDistribution",
            "NonCommutativeMultiply",
            "NonConstants",
            "NondimensionalizationTransform",
            "None",
            "NoneTrue",
            "NonlinearModelFit",
            "NonlinearStateSpaceModel",
            "NonlocalMeansFilter",
            "NonNegative",
            "NonNegativeIntegers",
            "NonNegativeRationals",
            "NonNegativeReals",
            "NonPositive",
            "NonPositiveIntegers",
            "NonPositiveRationals",
            "NonPositiveReals",
            "Nor",
            "NorlundB",
            "Norm",
            "Normal",
            "NormalDistribution",
            "NormalGrouping",
            "NormalizationLayer",
            "Normalize",
            "Normalized",
            "NormalizedSquaredEuclideanDistance",
            "NormalMatrixQ",
            "NormalsFunction",
            "NormFunction",
            "Not",
            "NotCongruent",
            "NotCupCap",
            "NotDoubleVerticalBar",
            "Notebook",
            "NotebookApply",
            "NotebookAutoSave",
            "NotebookBrowseDirectory",
            "NotebookClose",
            "NotebookConvertSettings",
            "NotebookCreate",
            "NotebookDefault",
            "NotebookDelete",
            "NotebookDirectory",
            "NotebookDynamicExpression",
            "NotebookEvaluate",
            "NotebookEventActions",
            "NotebookFileName",
            "NotebookFind",
            "NotebookGet",
            "NotebookImport",
            "NotebookInformation",
            "NotebookInterfaceObject",
            "NotebookLocate",
            "NotebookObject",
            "NotebookOpen",
            "NotebookPath",
            "NotebookPrint",
            "NotebookPut",
            "NotebookRead",
            "Notebooks",
            "NotebookSave",
            "NotebookSelection",
            "NotebooksMenu",
            "NotebookTemplate",
            "NotebookWrite",
            "NotElement",
            "NotEqualTilde",
            "NotExists",
            "NotGreater",
            "NotGreaterEqual",
            "NotGreaterFullEqual",
            "NotGreaterGreater",
            "NotGreaterLess",
            "NotGreaterSlantEqual",
            "NotGreaterTilde",
            "Nothing",
            "NotHumpDownHump",
            "NotHumpEqual",
            "NotificationFunction",
            "NotLeftTriangle",
            "NotLeftTriangleBar",
            "NotLeftTriangleEqual",
            "NotLess",
            "NotLessEqual",
            "NotLessFullEqual",
            "NotLessGreater",
            "NotLessLess",
            "NotLessSlantEqual",
            "NotLessTilde",
            "NotNestedGreaterGreater",
            "NotNestedLessLess",
            "NotPrecedes",
            "NotPrecedesEqual",
            "NotPrecedesSlantEqual",
            "NotPrecedesTilde",
            "NotReverseElement",
            "NotRightTriangle",
            "NotRightTriangleBar",
            "NotRightTriangleEqual",
            "NotSquareSubset",
            "NotSquareSubsetEqual",
            "NotSquareSuperset",
            "NotSquareSupersetEqual",
            "NotSubset",
            "NotSubsetEqual",
            "NotSucceeds",
            "NotSucceedsEqual",
            "NotSucceedsSlantEqual",
            "NotSucceedsTilde",
            "NotSuperset",
            "NotSupersetEqual",
            "NotTilde",
            "NotTildeEqual",
            "NotTildeFullEqual",
            "NotTildeTilde",
            "NotVerticalBar",
            "Now",
            "NoWhitespace",
            "NProbability",
            "NProduct",
            "NProductFactors",
            "NRoots",
            "NSolve",
            "NSolveValues",
            "NSum",
            "NSumTerms",
            "NuclearExplosionData",
            "NuclearReactorData",
            "Null",
            "NullRecords",
            "NullSpace",
            "NullWords",
            "Number",
            "NumberCompose",
            "NumberDecompose",
            "NumberDigit",
            "NumberExpand",
            "NumberFieldClassNumber",
            "NumberFieldDiscriminant",
            "NumberFieldFundamentalUnits",
            "NumberFieldIntegralBasis",
            "NumberFieldNormRepresentatives",
            "NumberFieldRegulator",
            "NumberFieldRootsOfUnity",
            "NumberFieldSignature",
            "NumberForm",
            "NumberFormat",
            "NumberLinePlot",
            "NumberMarks",
            "NumberMultiplier",
            "NumberPadding",
            "NumberPoint",
            "NumberQ",
            "NumberSeparator",
            "NumberSigns",
            "NumberString",
            "Numerator",
            "NumeratorDenominator",
            "NumericalOrder",
            "NumericalSort",
            "NumericArray",
            "NumericArrayQ",
            "NumericArrayType",
            "NumericFunction",
            "NumericQ",
            "NuttallWindow",
            "NValues",
            "NyquistGridLines",
            "NyquistPlot",
            "O",
            "ObjectExistsQ",
            "ObservabilityGramian",
            "ObservabilityMatrix",
            "ObservableDecomposition",
            "ObservableModelQ",
            "OceanData",
            "Octahedron",
            "OddQ",
            "Off",
            "Offset",
            "OLEData",
            "On",
            "ONanGroupON",
            "Once",
            "OneIdentity",
            "Opacity",
            "OpacityFunction",
            "OpacityFunctionScaling",
            "Open",
            "OpenAppend",
            "Opener",
            "OpenerBox",
            "OpenerBoxOptions",
            "OpenerView",
            "OpenFunctionInspectorPacket",
            "Opening",
            "OpenRead",
            "OpenSpecialOptions",
            "OpenTemporary",
            "OpenWrite",
            "Operate",
            "OperatingSystem",
            "OperatorApplied",
            "OptimumFlowData",
            "Optional",
            "OptionalElement",
            "OptionInspectorSettings",
            "OptionQ",
            "Options",
            "OptionsPacket",
            "OptionsPattern",
            "OptionValue",
            "OptionValueBox",
            "OptionValueBoxOptions",
            "Or",
            "Orange",
            "Order",
            "OrderDistribution",
            "OrderedQ",
            "Ordering",
            "OrderingBy",
            "OrderingLayer",
            "Orderless",
            "OrderlessPatternSequence",
            "OrdinalScale",
            "OrnsteinUhlenbeckProcess",
            "Orthogonalize",
            "OrthogonalMatrixQ",
            "Out",
            "Outer",
            "OuterPolygon",
            "OuterPolyhedron",
            "OutputAutoOverwrite",
            "OutputControllabilityMatrix",
            "OutputControllableModelQ",
            "OutputForm",
            "OutputFormData",
            "OutputGrouping",
            "OutputMathEditExpression",
            "OutputNamePacket",
            "OutputPorts",
            "OutputResponse",
            "OutputSizeLimit",
            "OutputStream",
            "Over",
            "OverBar",
            "OverDot",
            "Overflow",
            "OverHat",
            "Overlaps",
            "Overlay",
            "OverlayBox",
            "OverlayBoxOptions",
            "OverlayVideo",
            "Overscript",
            "OverscriptBox",
            "OverscriptBoxOptions",
            "OverTilde",
            "OverVector",
            "OverwriteTarget",
            "OwenT",
            "OwnValues",
            "Package",
            "PackingMethod",
            "PackPaclet",
            "PacletDataRebuild",
            "PacletDirectoryAdd",
            "PacletDirectoryLoad",
            "PacletDirectoryRemove",
            "PacletDirectoryUnload",
            "PacletDisable",
            "PacletEnable",
            "PacletFind",
            "PacletFindRemote",
            "PacletInformation",
            "PacletInstall",
            "PacletInstallSubmit",
            "PacletNewerQ",
            "PacletObject",
            "PacletObjectQ",
            "PacletSite",
            "PacletSiteObject",
            "PacletSiteRegister",
            "PacletSites",
            "PacletSiteUnregister",
            "PacletSiteUpdate",
            "PacletSymbol",
            "PacletUninstall",
            "PacletUpdate",
            "PaddedForm",
            "Padding",
            "PaddingLayer",
            "PaddingSize",
            "PadeApproximant",
            "PadLeft",
            "PadRight",
            "PageBreakAbove",
            "PageBreakBelow",
            "PageBreakWithin",
            "PageFooterLines",
            "PageFooters",
            "PageHeaderLines",
            "PageHeaders",
            "PageHeight",
            "PageRankCentrality",
            "PageTheme",
            "PageWidth",
            "Pagination",
            "PairCorrelationG",
            "PairedBarChart",
            "PairedHistogram",
            "PairedSmoothHistogram",
            "PairedTTest",
            "PairedZTest",
            "PaletteNotebook",
            "PalettePath",
            "PalettesMenuSettings",
            "PalindromeQ",
            "Pane",
            "PaneBox",
            "PaneBoxOptions",
            "Panel",
            "PanelBox",
            "PanelBoxOptions",
            "Paneled",
            "PaneSelector",
            "PaneSelectorBox",
            "PaneSelectorBoxOptions",
            "PaperWidth",
            "ParabolicCylinderD",
            "ParagraphIndent",
            "ParagraphSpacing",
            "ParallelArray",
            "ParallelAxisPlot",
            "ParallelCombine",
            "ParallelDo",
            "Parallelepiped",
            "ParallelEvaluate",
            "Parallelization",
            "Parallelize",
            "ParallelKernels",
            "ParallelMap",
            "ParallelNeeds",
            "Parallelogram",
            "ParallelProduct",
            "ParallelSubmit",
            "ParallelSum",
            "ParallelTable",
            "ParallelTry",
            "Parameter",
            "ParameterEstimator",
            "ParameterMixtureDistribution",
            "ParameterVariables",
            "ParametricConvexOptimization",
            "ParametricFunction",
            "ParametricNDSolve",
            "ParametricNDSolveValue",
            "ParametricPlot",
            "ParametricPlot3D",
            "ParametricRampLayer",
            "ParametricRegion",
            "ParentBox",
            "ParentCell",
            "ParentConnect",
            "ParentDirectory",
            "ParentEdgeLabel",
            "ParentEdgeLabelFunction",
            "ParentEdgeLabelStyle",
            "ParentEdgeShapeFunction",
            "ParentEdgeStyle",
            "ParentEdgeStyleFunction",
            "ParentForm",
            "Parenthesize",
            "ParentList",
            "ParentNotebook",
            "ParetoDistribution",
            "ParetoPickandsDistribution",
            "ParkData",
            "Part",
            "PartBehavior",
            "PartialCorrelationFunction",
            "PartialD",
            "ParticleAcceleratorData",
            "ParticleData",
            "Partition",
            "PartitionGranularity",
            "PartitionsP",
            "PartitionsQ",
            "PartLayer",
            "PartOfSpeech",
            "PartProtection",
            "ParzenWindow",
            "PascalDistribution",
            "PassEventsDown",
            "PassEventsUp",
            "Paste",
            "PasteAutoQuoteCharacters",
            "PasteBoxFormInlineCells",
            "PasteButton",
            "Path",
            "PathGraph",
            "PathGraphQ",
            "Pattern",
            "PatternFilling",
            "PatternReaction",
            "PatternSequence",
            "PatternTest",
            "PauliMatrix",
            "PaulWavelet",
            "Pause",
            "PausedTime",
            "PDF",
            "PeakDetect",
            "PeanoCurve",
            "PearsonChiSquareTest",
            "PearsonCorrelationTest",
            "PearsonDistribution",
            "PenttinenPointProcess",
            "PercentForm",
            "PerfectNumber",
            "PerfectNumberQ",
            "PerformanceGoal",
            "Perimeter",
            "PeriodicBoundaryCondition",
            "PeriodicInterpolation",
            "Periodogram",
            "PeriodogramArray",
            "Permanent",
            "Permissions",
            "PermissionsGroup",
            "PermissionsGroupMemberQ",
            "PermissionsGroups",
            "PermissionsKey",
            "PermissionsKeys",
            "PermutationCycles",
            "PermutationCyclesQ",
            "PermutationGroup",
            "PermutationLength",
            "PermutationList",
            "PermutationListQ",
            "PermutationMatrix",
            "PermutationMax",
            "PermutationMin",
            "PermutationOrder",
            "PermutationPower",
            "PermutationProduct",
            "PermutationReplace",
            "Permutations",
            "PermutationSupport",
            "Permute",
            "PeronaMalikFilter",
            "Perpendicular",
            "PerpendicularBisector",
            "PersistenceLocation",
            "PersistenceTime",
            "PersistentObject",
            "PersistentObjects",
            "PersistentSymbol",
            "PersistentValue",
            "PersonData",
            "PERTDistribution",
            "PetersenGraph",
            "PhaseMargins",
            "PhaseRange",
            "PhongShading",
            "PhysicalSystemData",
            "Pi",
            "Pick",
            "PickedElements",
            "PickMode",
            "PIDData",
            "PIDDerivativeFilter",
            "PIDFeedforward",
            "PIDTune",
            "Piecewise",
            "PiecewiseExpand",
            "PieChart",
            "PieChart3D",
            "PillaiTrace",
            "PillaiTraceTest",
            "PingTime",
            "Pink",
            "PitchRecognize",
            "Pivoting",
            "PixelConstrained",
            "PixelValue",
            "PixelValuePositions",
            "Placed",
            "Placeholder",
            "PlaceholderLayer",
            "PlaceholderReplace",
            "Plain",
            "PlanarAngle",
            "PlanarFaceList",
            "PlanarGraph",
            "PlanarGraphQ",
            "PlanckRadiationLaw",
            "PlaneCurveData",
            "PlanetaryMoonData",
            "PlanetData",
            "PlantData",
            "Play",
            "PlaybackSettings",
            "PlayRange",
            "Plot",
            "Plot3D",
            "Plot3Matrix",
            "PlotDivision",
            "PlotJoined",
            "PlotLabel",
            "PlotLabels",
            "PlotLayout",
            "PlotLegends",
            "PlotMarkers",
            "PlotPoints",
            "PlotRange",
            "PlotRangeClipping",
            "PlotRangeClipPlanesStyle",
            "PlotRangePadding",
            "PlotRegion",
            "PlotStyle",
            "PlotTheme",
            "Pluralize",
            "Plus",
            "PlusMinus",
            "Pochhammer",
            "PodStates",
            "PodWidth",
            "Point",
            "Point3DBox",
            "Point3DBoxOptions",
            "PointBox",
            "PointBoxOptions",
            "PointCountDistribution",
            "PointDensity",
            "PointDensityFunction",
            "PointFigureChart",
            "PointLegend",
            "PointLight",
            "PointProcessEstimator",
            "PointProcessFitTest",
            "PointProcessParameterAssumptions",
            "PointProcessParameterQ",
            "PointSize",
            "PointStatisticFunction",
            "PointValuePlot",
            "PoissonConsulDistribution",
            "PoissonDistribution",
            "PoissonPDEComponent",
            "PoissonPointProcess",
            "PoissonProcess",
            "PoissonWindow",
            "PolarAxes",
            "PolarAxesOrigin",
            "PolarGridLines",
            "PolarPlot",
            "PolarTicks",
            "PoleZeroMarkers",
            "PolyaAeppliDistribution",
            "PolyGamma",
            "Polygon",
            "Polygon3DBox",
            "Polygon3DBoxOptions",
            "PolygonalNumber",
            "PolygonAngle",
            "PolygonBox",
            "PolygonBoxOptions",
            "PolygonCoordinates",
            "PolygonDecomposition",
            "PolygonHoleScale",
            "PolygonIntersections",
            "PolygonScale",
            "Polyhedron",
            "PolyhedronAngle",
            "PolyhedronBox",
            "PolyhedronBoxOptions",
            "PolyhedronCoordinates",
            "PolyhedronData",
            "PolyhedronDecomposition",
            "PolyhedronGenus",
            "PolyLog",
            "PolynomialExpressionQ",
            "PolynomialExtendedGCD",
            "PolynomialForm",
            "PolynomialGCD",
            "PolynomialLCM",
            "PolynomialMod",
            "PolynomialQ",
            "PolynomialQuotient",
            "PolynomialQuotientRemainder",
            "PolynomialReduce",
            "PolynomialRemainder",
            "Polynomials",
            "PolynomialSumOfSquaresList",
            "PoolingLayer",
            "PopupMenu",
            "PopupMenuBox",
            "PopupMenuBoxOptions",
            "PopupView",
            "PopupWindow",
            "Position",
            "PositionIndex",
            "PositionLargest",
            "PositionSmallest",
            "Positive",
            "PositiveDefiniteMatrixQ",
            "PositiveIntegers",
            "PositivelyOrientedPoints",
            "PositiveRationals",
            "PositiveReals",
            "PositiveSemidefiniteMatrixQ",
            "PossibleZeroQ",
            "Postfix",
            "PostScript",
            "Power",
            "PowerDistribution",
            "PowerExpand",
            "PowerMod",
            "PowerModList",
            "PowerRange",
            "PowerSpectralDensity",
            "PowersRepresentations",
            "PowerSymmetricPolynomial",
            "Precedence",
            "PrecedenceForm",
            "Precedes",
            "PrecedesEqual",
            "PrecedesSlantEqual",
            "PrecedesTilde",
            "Precision",
            "PrecisionGoal",
            "PreDecrement",
            "Predict",
            "PredictionRoot",
            "PredictorFunction",
            "PredictorInformation",
            "PredictorMeasurements",
            "PredictorMeasurementsObject",
            "PreemptProtect",
            "PreferencesPath",
            "PreferencesSettings",
            "Prefix",
            "PreIncrement",
            "Prepend",
            "PrependLayer",
            "PrependTo",
            "PreprocessingRules",
            "PreserveColor",
            "PreserveImageOptions",
            "Previous",
            "PreviousCell",
            "PreviousDate",
            "PriceGraphDistribution",
            "PrimaryPlaceholder",
            "Prime",
            "PrimeNu",
            "PrimeOmega",
            "PrimePi",
            "PrimePowerQ",
            "PrimeQ",
            "Primes",
            "PrimeZetaP",
            "PrimitivePolynomialQ",
            "PrimitiveRoot",
            "PrimitiveRootList",
            "PrincipalComponents",
            "PrincipalValue",
            "Print",
            "PrintableASCIIQ",
            "PrintAction",
            "PrintForm",
            "PrintingCopies",
            "PrintingOptions",
            "PrintingPageRange",
            "PrintingStartingPageNumber",
            "PrintingStyleEnvironment",
            "Printout3D",
            "Printout3DPreviewer",
            "PrintPrecision",
            "PrintTemporary",
            "Prism",
            "PrismBox",
            "PrismBoxOptions",
            "PrivateCellOptions",
            "PrivateEvaluationOptions",
            "PrivateFontOptions",
            "PrivateFrontEndOptions",
            "PrivateKey",
            "PrivateNotebookOptions",
            "PrivatePaths",
            "Probability",
            "ProbabilityDistribution",
            "ProbabilityPlot",
            "ProbabilityPr",
            "ProbabilityScalePlot",
            "ProbitModelFit",
            "ProcessConnection",
            "ProcessDirectory",
            "ProcessEnvironment",
            "Processes",
            "ProcessEstimator",
            "ProcessInformation",
            "ProcessObject",
            "ProcessParameterAssumptions",
            "ProcessParameterQ",
            "ProcessStateDomain",
            "ProcessStatus",
            "ProcessTimeDomain",
            "Product",
            "ProductDistribution",
            "ProductLog",
            "ProgressIndicator",
            "ProgressIndicatorBox",
            "ProgressIndicatorBoxOptions",
            "ProgressReporting",
            "Projection",
            "Prolog",
            "PromptForm",
            "ProofObject",
            "PropagateAborts",
            "Properties",
            "Property",
            "PropertyList",
            "PropertyValue",
            "Proportion",
            "Proportional",
            "Protect",
            "Protected",
            "ProteinData",
            "Pruning",
            "PseudoInverse",
            "PsychrometricPropertyData",
            "PublicKey",
            "PublisherID",
            "PulsarData",
            "PunctuationCharacter",
            "Purple",
            "Put",
            "PutAppend",
            "Pyramid",
            "PyramidBox",
            "PyramidBoxOptions",
            "QBinomial",
            "QFactorial",
            "QGamma",
            "QHypergeometricPFQ",
            "QnDispersion",
            "QPochhammer",
            "QPolyGamma",
            "QRDecomposition",
            "QuadraticIrrationalQ",
            "QuadraticOptimization",
            "Quantile",
            "QuantilePlot",
            "Quantity",
            "QuantityArray",
            "QuantityDistribution",
            "QuantityForm",
            "QuantityMagnitude",
            "QuantityQ",
            "QuantityUnit",
            "QuantityVariable",
            "QuantityVariableCanonicalUnit",
            "QuantityVariableDimensions",
            "QuantityVariableIdentifier",
            "QuantityVariablePhysicalQuantity",
            "Quartics",
            "QuartileDeviation",
            "Quartiles",
            "QuartileSkewness",
            "Query",
            "QuestionGenerator",
            "QuestionInterface",
            "QuestionObject",
            "QuestionSelector",
            "QueueingNetworkProcess",
            "QueueingProcess",
            "QueueProperties",
            "Quiet",
            "QuietEcho",
            "Quit",
            "Quotient",
            "QuotientRemainder",
            "RadialAxisPlot",
            "RadialGradientFilling",
            "RadialGradientImage",
            "RadialityCentrality",
            "RadicalBox",
            "RadicalBoxOptions",
            "RadioButton",
            "RadioButtonBar",
            "RadioButtonBox",
            "RadioButtonBoxOptions",
            "Radon",
            "RadonTransform",
            "RamanujanTau",
            "RamanujanTauL",
            "RamanujanTauTheta",
            "RamanujanTauZ",
            "Ramp",
            "Random",
            "RandomArrayLayer",
            "RandomChoice",
            "RandomColor",
            "RandomComplex",
            "RandomDate",
            "RandomEntity",
            "RandomFunction",
            "RandomGeneratorState",
            "RandomGeoPosition",
            "RandomGraph",
            "RandomImage",
            "RandomInstance",
            "RandomInteger",
            "RandomPermutation",
            "RandomPoint",
            "RandomPointConfiguration",
            "RandomPolygon",
            "RandomPolyhedron",
            "RandomPrime",
            "RandomReal",
            "RandomSample",
            "RandomSeed",
            "RandomSeeding",
            "RandomTime",
            "RandomTree",
            "RandomVariate",
            "RandomWalkProcess",
            "RandomWord",
            "Range",
            "RangeFilter",
            "RangeSpecification",
            "RankedMax",
            "RankedMin",
            "RarerProbability",
            "Raster",
            "Raster3D",
            "Raster3DBox",
            "Raster3DBoxOptions",
            "RasterArray",
            "RasterBox",
            "RasterBoxOptions",
            "Rasterize",
            "RasterSize",
            "Rational",
            "RationalExpressionQ",
            "RationalFunctions",
            "Rationalize",
            "Rationals",
            "Ratios",
            "RawArray",
            "RawBoxes",
            "RawData",
            "RawMedium",
            "RayleighDistribution",
            "Re",
            "ReactionBalance",
            "ReactionBalancedQ",
            "ReactionPDETerm",
            "Read",
            "ReadByteArray",
            "ReadLine",
            "ReadList",
            "ReadProtected",
            "ReadString",
            "Real",
            "RealAbs",
            "RealBlockDiagonalForm",
            "RealDigits",
            "RealExponent",
            "Reals",
            "RealSign",
            "Reap",
            "RebuildPacletData",
            "RecalibrationFunction",
            "RecognitionPrior",
            "RecognitionThreshold",
            "ReconstructionMesh",
            "Record",
            "RecordLists",
            "RecordSeparators",
            "Rectangle",
            "RectangleBox",
            "RectangleBoxOptions",
            "RectangleChart",
            "RectangleChart3D",
            "RectangularRepeatingElement",
            "RecurrenceFilter",
            "RecurrenceTable",
            "RecurringDigitsForm",
            "Red",
            "Reduce",
            "RefBox",
            "ReferenceLineStyle",
            "ReferenceMarkers",
            "ReferenceMarkerStyle",
            "Refine",
            "ReflectionMatrix",
            "ReflectionTransform",
            "Refresh",
            "RefreshRate",
            "Region",
            "RegionBinarize",
            "RegionBoundary",
            "RegionBoundaryStyle",
            "RegionBounds",
            "RegionCentroid",
            "RegionCongruent",
            "RegionConvert",
            "RegionDifference",
            "RegionDilation",
            "RegionDimension",
            "RegionDisjoint",
            "RegionDistance",
            "RegionDistanceFunction",
            "RegionEmbeddingDimension",
            "RegionEqual",
            "RegionErosion",
            "RegionFillingStyle",
            "RegionFit",
            "RegionFunction",
            "RegionImage",
            "RegionIntersection",
            "RegionMeasure",
            "RegionMember",
            "RegionMemberFunction",
            "RegionMoment",
            "RegionNearest",
            "RegionNearestFunction",
            "RegionPlot",
            "RegionPlot3D",
            "RegionProduct",
            "RegionQ",
            "RegionResize",
            "RegionSimilar",
            "RegionSize",
            "RegionSymmetricDifference",
            "RegionUnion",
            "RegionWithin",
            "RegisterExternalEvaluator",
            "RegularExpression",
            "Regularization",
            "RegularlySampledQ",
            "RegularPolygon",
            "ReIm",
            "ReImLabels",
            "ReImPlot",
            "ReImStyle",
            "Reinstall",
            "RelationalDatabase",
            "RelationGraph",
            "Release",
            "ReleaseHold",
            "ReliabilityDistribution",
            "ReliefImage",
            "ReliefPlot",
            "RemoteAuthorizationCaching",
            "RemoteBatchJobAbort",
            "RemoteBatchJobObject",
            "RemoteBatchJobs",
            "RemoteBatchMapSubmit",
            "RemoteBatchSubmissionEnvironment",
            "RemoteBatchSubmit",
            "RemoteConnect",
            "RemoteConnectionObject",
            "RemoteEvaluate",
            "RemoteFile",
            "RemoteInputFiles",
            "RemoteKernelObject",
            "RemoteProviderSettings",
            "RemoteRun",
            "RemoteRunProcess",
            "RemovalConditions",
            "Remove",
            "RemoveAlphaChannel",
            "RemoveAsynchronousTask",
            "RemoveAudioStream",
            "RemoveBackground",
            "RemoveChannelListener",
            "RemoveChannelSubscribers",
            "Removed",
            "RemoveDiacritics",
            "RemoveInputStreamMethod",
            "RemoveOutputStreamMethod",
            "RemoveProperty",
            "RemoveScheduledTask",
            "RemoveUsers",
            "RemoveVideoStream",
            "RenameDirectory",
            "RenameFile",
            "RenderAll",
            "RenderingOptions",
            "RenewalProcess",
            "RenkoChart",
            "RepairMesh",
            "Repeated",
            "RepeatedNull",
            "RepeatedString",
            "RepeatedTiming",
            "RepeatingElement",
            "Replace",
            "ReplaceAll",
            "ReplaceAt",
            "ReplaceHeldPart",
            "ReplaceImageValue",
            "ReplaceList",
            "ReplacePart",
            "ReplacePixelValue",
            "ReplaceRepeated",
            "ReplicateLayer",
            "RequiredPhysicalQuantities",
            "Resampling",
            "ResamplingAlgorithmData",
            "ResamplingMethod",
            "Rescale",
            "RescalingTransform",
            "ResetDirectory",
            "ResetScheduledTask",
            "ReshapeLayer",
            "Residue",
            "ResidueSum",
            "ResizeLayer",
            "Resolve",
            "ResolveContextAliases",
            "ResourceAcquire",
            "ResourceData",
            "ResourceFunction",
            "ResourceObject",
            "ResourceRegister",
            "ResourceRemove",
            "ResourceSearch",
            "ResourceSubmissionObject",
            "ResourceSubmit",
            "ResourceSystemBase",
            "ResourceSystemPath",
            "ResourceUpdate",
            "ResourceVersion",
            "ResponseForm",
            "Rest",
            "RestartInterval",
            "Restricted",
            "Resultant",
            "ResumePacket",
            "Return",
            "ReturnCreatesNewCell",
            "ReturnEntersInput",
            "ReturnExpressionPacket",
            "ReturnInputFormPacket",
            "ReturnPacket",
            "ReturnReceiptFunction",
            "ReturnTextPacket",
            "Reverse",
            "ReverseApplied",
            "ReverseBiorthogonalSplineWavelet",
            "ReverseElement",
            "ReverseEquilibrium",
            "ReverseGraph",
            "ReverseSort",
            "ReverseSortBy",
            "ReverseUpEquilibrium",
            "RevolutionAxis",
            "RevolutionPlot3D",
            "RGBColor",
            "RiccatiSolve",
            "RiceDistribution",
            "RidgeFilter",
            "RiemannR",
            "RiemannSiegelTheta",
            "RiemannSiegelZ",
            "RiemannXi",
            "Riffle",
            "Right",
            "RightArrow",
            "RightArrowBar",
            "RightArrowLeftArrow",
            "RightComposition",
            "RightCosetRepresentative",
            "RightDownTeeVector",
            "RightDownVector",
            "RightDownVectorBar",
            "RightTee",
            "RightTeeArrow",
            "RightTeeVector",
            "RightTriangle",
            "RightTriangleBar",
            "RightTriangleEqual",
            "RightUpDownVector",
            "RightUpTeeVector",
            "RightUpVector",
            "RightUpVectorBar",
            "RightVector",
            "RightVectorBar",
            "RipleyK",
            "RipleyRassonRegion",
            "RiskAchievementImportance",
            "RiskReductionImportance",
            "RobustConvexOptimization",
            "RogersTanimotoDissimilarity",
            "RollPitchYawAngles",
            "RollPitchYawMatrix",
            "RomanNumeral",
            "Root",
            "RootApproximant",
            "RootIntervals",
            "RootLocusPlot",
            "RootMeanSquare",
            "RootOfUnityQ",
            "RootReduce",
            "Roots",
            "RootSum",
            "RootTree",
            "Rotate",
            "RotateLabel",
            "RotateLeft",
            "RotateRight",
            "RotationAction",
            "RotationBox",
            "RotationBoxOptions",
            "RotationMatrix",
            "RotationTransform",
            "Round",
            "RoundImplies",
            "RoundingRadius",
            "Row",
            "RowAlignments",
            "RowBackgrounds",
            "RowBox",
            "RowHeights",
            "RowLines",
            "RowMinHeight",
            "RowReduce",
            "RowsEqual",
            "RowSpacings",
            "RSolve",
            "RSolveValue",
            "RudinShapiro",
            "RudvalisGroupRu",
            "Rule",
            "RuleCondition",
            "RuleDelayed",
            "RuleForm",
            "RulePlot",
            "RulerUnits",
            "RulesTree",
            "Run",
            "RunProcess",
            "RunScheduledTask",
            "RunThrough",
            "RuntimeAttributes",
            "RuntimeOptions",
            "RussellRaoDissimilarity",
            "SameAs",
            "SameQ",
            "SameTest",
            "SameTestProperties",
            "SampledEntityClass",
            "SampleDepth",
            "SampledSoundFunction",
            "SampledSoundList",
            "SampleRate",
            "SamplingPeriod",
            "SARIMAProcess",
            "SARMAProcess",
            "SASTriangle",
            "SatelliteData",
            "SatisfiabilityCount",
            "SatisfiabilityInstances",
            "SatisfiableQ",
            "Saturday",
            "Save",
            "Saveable",
            "SaveAutoDelete",
            "SaveConnection",
            "SaveDefinitions",
            "SavitzkyGolayMatrix",
            "SawtoothWave",
            "Scale",
            "Scaled",
            "ScaleDivisions",
            "ScaledMousePosition",
            "ScaleOrigin",
            "ScalePadding",
            "ScaleRanges",
            "ScaleRangeStyle",
            "ScalingFunctions",
            "ScalingMatrix",
            "ScalingTransform",
            "Scan",
            "ScheduledTask",
            "ScheduledTaskActiveQ",
            "ScheduledTaskInformation",
            "ScheduledTaskInformationData",
            "ScheduledTaskObject",
            "ScheduledTasks",
            "SchurDecomposition",
            "ScientificForm",
            "ScientificNotationThreshold",
            "ScorerGi",
            "ScorerGiPrime",
            "ScorerHi",
            "ScorerHiPrime",
            "ScreenRectangle",
            "ScreenStyleEnvironment",
            "ScriptBaselineShifts",
            "ScriptForm",
            "ScriptLevel",
            "ScriptMinSize",
            "ScriptRules",
            "ScriptSizeMultipliers",
            "Scrollbars",
            "ScrollingOptions",
            "ScrollPosition",
            "SearchAdjustment",
            "SearchIndexObject",
            "SearchIndices",
            "SearchQueryString",
            "SearchResultObject",
            "Sec",
            "Sech",
            "SechDistribution",
            "SecondOrderConeOptimization",
            "SectionGrouping",
            "SectorChart",
            "SectorChart3D",
            "SectorOrigin",
            "SectorSpacing",
            "SecuredAuthenticationKey",
            "SecuredAuthenticationKeys",
            "SecurityCertificate",
            "SeedRandom",
            "Select",
            "Selectable",
            "SelectComponents",
            "SelectedCells",
            "SelectedNotebook",
            "SelectFirst",
            "Selection",
            "SelectionAnimate",
            "SelectionCell",
            "SelectionCellCreateCell",
            "SelectionCellDefaultStyle",
            "SelectionCellParentStyle",
            "SelectionCreateCell",
            "SelectionDebuggerTag",
            "SelectionEvaluate",
            "SelectionEvaluateCreateCell",
            "SelectionMove",
            "SelectionPlaceholder",
            "SelectWithContents",
            "SelfLoops",
            "SelfLoopStyle",
            "SemanticImport",
            "SemanticImportString",
            "SemanticInterpretation",
            "SemialgebraicComponentInstances",
            "SemidefiniteOptimization",
            "SendMail",
            "SendMessage",
            "Sequence",
            "SequenceAlignment",
            "SequenceAttentionLayer",
            "SequenceCases",
            "SequenceCount",
            "SequenceFold",
            "SequenceFoldList",
            "SequenceForm",
            "SequenceHold",
            "SequenceIndicesLayer",
            "SequenceLastLayer",
            "SequenceMostLayer",
            "SequencePosition",
            "SequencePredict",
            "SequencePredictorFunction",
            "SequenceReplace",
            "SequenceRestLayer",
            "SequenceReverseLayer",
            "SequenceSplit",
            "Series",
            "SeriesCoefficient",
            "SeriesData",
            "SeriesTermGoal",
            "ServiceConnect",
            "ServiceDisconnect",
            "ServiceExecute",
            "ServiceObject",
            "ServiceRequest",
            "ServiceResponse",
            "ServiceSubmit",
            "SessionSubmit",
            "SessionTime",
            "Set",
            "SetAccuracy",
            "SetAlphaChannel",
            "SetAttributes",
            "Setbacks",
            "SetCloudDirectory",
            "SetCookies",
            "SetDelayed",
            "SetDirectory",
            "SetEnvironment",
            "SetFileDate",
            "SetFileFormatProperties",
            "SetOptions",
            "SetOptionsPacket",
            "SetPermissions",
            "SetPrecision",
            "SetProperty",
            "SetSecuredAuthenticationKey",
            "SetSelectedNotebook",
            "SetSharedFunction",
            "SetSharedVariable",
            "SetStreamPosition",
            "SetSystemModel",
            "SetSystemOptions",
            "Setter",
            "SetterBar",
            "SetterBox",
            "SetterBoxOptions",
            "Setting",
            "SetUsers",
            "Shading",
            "Shallow",
            "ShannonWavelet",
            "ShapiroWilkTest",
            "Share",
            "SharingList",
            "Sharpen",
            "ShearingMatrix",
            "ShearingTransform",
            "ShellRegion",
            "ShenCastanMatrix",
            "ShiftedGompertzDistribution",
            "ShiftRegisterSequence",
            "Short",
            "ShortDownArrow",
            "Shortest",
            "ShortestMatch",
            "ShortestPathFunction",
            "ShortLeftArrow",
            "ShortRightArrow",
            "ShortTimeFourier",
            "ShortTimeFourierData",
            "ShortUpArrow",
            "Show",
            "ShowAutoConvert",
            "ShowAutoSpellCheck",
            "ShowAutoStyles",
            "ShowCellBracket",
            "ShowCellLabel",
            "ShowCellTags",
            "ShowClosedCellArea",
            "ShowCodeAssist",
            "ShowContents",
            "ShowControls",
            "ShowCursorTracker",
            "ShowGroupOpenCloseIcon",
            "ShowGroupOpener",
            "ShowInvisibleCharacters",
            "ShowPageBreaks",
            "ShowPredictiveInterface",
            "ShowSelection",
            "ShowShortBoxForm",
            "ShowSpecialCharacters",
            "ShowStringCharacters",
            "ShowSyntaxStyles",
            "ShrinkingDelay",
            "ShrinkWrapBoundingBox",
            "SiderealTime",
            "SiegelTheta",
            "SiegelTukeyTest",
            "SierpinskiCurve",
            "SierpinskiMesh",
            "Sign",
            "Signature",
            "SignedRankTest",
            "SignedRegionDistance",
            "SignificanceLevel",
            "SignPadding",
            "SignTest",
            "SimilarityRules",
            "SimpleGraph",
            "SimpleGraphQ",
            "SimplePolygonQ",
            "SimplePolyhedronQ",
            "Simplex",
            "Simplify",
            "Sin",
            "Sinc",
            "SinghMaddalaDistribution",
            "SingleEvaluation",
            "SingleLetterItalics",
            "SingleLetterStyle",
            "SingularValueDecomposition",
            "SingularValueList",
            "SingularValuePlot",
            "SingularValues",
            "Sinh",
            "SinhIntegral",
            "SinIntegral",
            "SixJSymbol",
            "Skeleton",
            "SkeletonTransform",
            "SkellamDistribution",
            "Skewness",
            "SkewNormalDistribution",
            "SkinStyle",
            "Skip",
            "SliceContourPlot3D",
            "SliceDensityPlot3D",
            "SliceDistribution",
            "SliceVectorPlot3D",
            "Slider",
            "Slider2D",
            "Slider2DBox",
            "Slider2DBoxOptions",
            "SliderBox",
            "SliderBoxOptions",
            "SlideShowVideo",
            "SlideView",
            "Slot",
            "SlotSequence",
            "Small",
            "SmallCircle",
            "Smaller",
            "SmithDecomposition",
            "SmithDelayCompensator",
            "SmithWatermanSimilarity",
            "SmoothDensityHistogram",
            "SmoothHistogram",
            "SmoothHistogram3D",
            "SmoothKernelDistribution",
            "SmoothPointDensity",
            "SnDispersion",
            "Snippet",
            "SnippetsVideo",
            "SnubPolyhedron",
            "SocialMediaData",
            "Socket",
            "SocketConnect",
            "SocketListen",
            "SocketListener",
            "SocketObject",
            "SocketOpen",
            "SocketReadMessage",
            "SocketReadyQ",
            "Sockets",
            "SocketWaitAll",
            "SocketWaitNext",
            "SoftmaxLayer",
            "SokalSneathDissimilarity",
            "SolarEclipse",
            "SolarSystemFeatureData",
            "SolarTime",
            "SolidAngle",
            "SolidBoundaryLoadValue",
            "SolidData",
            "SolidDisplacementCondition",
            "SolidFixedCondition",
            "SolidMechanicsPDEComponent",
            "SolidMechanicsStrain",
            "SolidMechanicsStress",
            "SolidRegionQ",
            "Solve",
            "SolveAlways",
            "SolveDelayed",
            "SolveValues",
            "Sort",
            "SortBy",
            "SortedBy",
            "SortedEntityClass",
            "Sound",
            "SoundAndGraphics",
            "SoundNote",
            "SoundVolume",
            "SourceLink",
            "SourcePDETerm",
            "Sow",
            "Space",
            "SpaceCurveData",
            "SpaceForm",
            "Spacer",
            "Spacings",
            "Span",
            "SpanAdjustments",
            "SpanCharacterRounding",
            "SpanFromAbove",
            "SpanFromBoth",
            "SpanFromLeft",
            "SpanLineThickness",
            "SpanMaxSize",
            "SpanMinSize",
            "SpanningCharacters",
            "SpanSymmetric",
            "SparseArray",
            "SparseArrayQ",
            "SpatialBinnedPointData",
            "SpatialBoundaryCorrection",
            "SpatialEstimate",
            "SpatialEstimatorFunction",
            "SpatialGraphDistribution",
            "SpatialJ",
            "SpatialMedian",
            "SpatialNoiseLevel",
            "SpatialObservationRegionQ",
            "SpatialPointData",
            "SpatialPointSelect",
            "SpatialRandomnessTest",
            "SpatialTransformationLayer",
            "SpatialTrendFunction",
            "Speak",
            "SpeakerMatchQ",
            "SpearmanRankTest",
            "SpearmanRho",
            "SpeciesData",
            "SpecificityGoal",
            "SpectralLineData",
            "Spectrogram",
            "SpectrogramArray",
            "Specularity",
            "SpeechCases",
            "SpeechInterpreter",
            "SpeechRecognize",
            "SpeechSynthesize",
            "SpellingCorrection",
            "SpellingCorrectionList",
            "SpellingDictionaries",
            "SpellingDictionariesPath",
            "SpellingOptions",
            "Sphere",
            "SphereBox",
            "SphereBoxOptions",
            "SpherePoints",
            "SphericalBesselJ",
            "SphericalBesselY",
            "SphericalHankelH1",
            "SphericalHankelH2",
            "SphericalHarmonicY",
            "SphericalPlot3D",
            "SphericalRegion",
            "SphericalShell",
            "SpheroidalEigenvalue",
            "SpheroidalJoiningFactor",
            "SpheroidalPS",
            "SpheroidalPSPrime",
            "SpheroidalQS",
            "SpheroidalQSPrime",
            "SpheroidalRadialFactor",
            "SpheroidalS1",
            "SpheroidalS1Prime",
            "SpheroidalS2",
            "SpheroidalS2Prime",
            "Splice",
            "SplicedDistribution",
            "SplineClosed",
            "SplineDegree",
            "SplineKnots",
            "SplineWeights",
            "Split",
            "SplitBy",
            "SpokenString",
            "SpotLight",
            "Sqrt",
            "SqrtBox",
            "SqrtBoxOptions",
            "Square",
            "SquaredEuclideanDistance",
            "SquareFreeQ",
            "SquareIntersection",
            "SquareMatrixQ",
            "SquareRepeatingElement",
            "SquaresR",
            "SquareSubset",
            "SquareSubsetEqual",
            "SquareSuperset",
            "SquareSupersetEqual",
            "SquareUnion",
            "SquareWave",
            "SSSTriangle",
            "StabilityMargins",
            "StabilityMarginsStyle",
            "StableDistribution",
            "Stack",
            "StackBegin",
            "StackComplete",
            "StackedDateListPlot",
            "StackedListPlot",
            "StackInhibit",
            "StadiumShape",
            "StandardAtmosphereData",
            "StandardDeviation",
            "StandardDeviationFilter",
            "StandardForm",
            "Standardize",
            "Standardized",
            "StandardOceanData",
            "StandbyDistribution",
            "Star",
            "StarClusterData",
            "StarData",
            "StarGraph",
            "StartAsynchronousTask",
            "StartExternalSession",
            "StartingStepSize",
            "StartOfLine",
            "StartOfString",
            "StartProcess",
            "StartScheduledTask",
            "StartupSound",
            "StartWebSession",
            "StateDimensions",
            "StateFeedbackGains",
            "StateOutputEstimator",
            "StateResponse",
            "StateSpaceModel",
            "StateSpaceRealization",
            "StateSpaceTransform",
            "StateTransformationLinearize",
            "StationaryDistribution",
            "StationaryWaveletPacketTransform",
            "StationaryWaveletTransform",
            "StatusArea",
            "StatusCentrality",
            "StepMonitor",
            "StereochemistryElements",
            "StieltjesGamma",
            "StippleShading",
            "StirlingS1",
            "StirlingS2",
            "StopAsynchronousTask",
            "StoppingPowerData",
            "StopScheduledTask",
            "StrataVariables",
            "StratonovichProcess",
            "StraussHardcorePointProcess",
            "StraussPointProcess",
            "StreamColorFunction",
            "StreamColorFunctionScaling",
            "StreamDensityPlot",
            "StreamMarkers",
            "StreamPlot",
            "StreamPlot3D",
            "StreamPoints",
            "StreamPosition",
            "Streams",
            "StreamScale",
            "StreamStyle",
            "StrictInequalities",
            "String",
            "StringBreak",
            "StringByteCount",
            "StringCases",
            "StringContainsQ",
            "StringCount",
            "StringDelete",
            "StringDrop",
            "StringEndsQ",
            "StringExpression",
            "StringExtract",
            "StringForm",
            "StringFormat",
            "StringFormatQ",
            "StringFreeQ",
            "StringInsert",
            "StringJoin",
            "StringLength",
            "StringMatchQ",
            "StringPadLeft",
            "StringPadRight",
            "StringPart",
            "StringPartition",
            "StringPosition",
            "StringQ",
            "StringRepeat",
            "StringReplace",
            "StringReplaceList",
            "StringReplacePart",
            "StringReverse",
            "StringRiffle",
            "StringRotateLeft",
            "StringRotateRight",
            "StringSkeleton",
            "StringSplit",
            "StringStartsQ",
            "StringTake",
            "StringTakeDrop",
            "StringTemplate",
            "StringToByteArray",
            "StringToStream",
            "StringTrim",
            "StripBoxes",
            "StripOnInput",
            "StripStyleOnPaste",
            "StripWrapperBoxes",
            "StrokeForm",
            "Struckthrough",
            "StructuralImportance",
            "StructuredArray",
            "StructuredArrayHeadQ",
            "StructuredSelection",
            "StruveH",
            "StruveL",
            "Stub",
            "StudentTDistribution",
            "Style",
            "StyleBox",
            "StyleBoxAutoDelete",
            "StyleData",
            "StyleDefinitions",
            "StyleForm",
            "StyleHints",
            "StyleKeyMapping",
            "StyleMenuListing",
            "StyleNameDialogSettings",
            "StyleNames",
            "StylePrint",
            "StyleSheetPath",
            "Subdivide",
            "Subfactorial",
            "Subgraph",
            "SubMinus",
            "SubPlus",
            "SubresultantPolynomialRemainders",
            "SubresultantPolynomials",
            "Subresultants",
            "Subscript",
            "SubscriptBox",
            "SubscriptBoxOptions",
            "Subscripted",
            "Subsequences",
            "Subset",
            "SubsetCases",
            "SubsetCount",
            "SubsetEqual",
            "SubsetMap",
            "SubsetPosition",
            "SubsetQ",
            "SubsetReplace",
            "Subsets",
            "SubStar",
            "SubstitutionSystem",
            "Subsuperscript",
            "SubsuperscriptBox",
            "SubsuperscriptBoxOptions",
            "SubtitleEncoding",
            "SubtitleTrackSelection",
            "Subtract",
            "SubtractFrom",
            "SubtractSides",
            "SubValues",
            "Succeeds",
            "SucceedsEqual",
            "SucceedsSlantEqual",
            "SucceedsTilde",
            "Success",
            "SuchThat",
            "Sum",
            "SumConvergence",
            "SummationLayer",
            "Sunday",
            "SunPosition",
            "Sunrise",
            "Sunset",
            "SuperDagger",
            "SuperMinus",
            "SupernovaData",
            "SuperPlus",
            "Superscript",
            "SuperscriptBox",
            "SuperscriptBoxOptions",
            "Superset",
            "SupersetEqual",
            "SuperStar",
            "Surd",
            "SurdForm",
            "SurfaceAppearance",
            "SurfaceArea",
            "SurfaceColor",
            "SurfaceData",
            "SurfaceGraphics",
            "SurvivalDistribution",
            "SurvivalFunction",
            "SurvivalModel",
            "SurvivalModelFit",
            "SuspendPacket",
            "SuzukiDistribution",
            "SuzukiGroupSuz",
            "SwatchLegend",
            "Switch",
            "Symbol",
            "SymbolName",
            "SymletWavelet",
            "Symmetric",
            "SymmetricDifference",
            "SymmetricGroup",
            "SymmetricKey",
            "SymmetricMatrixQ",
            "SymmetricPolynomial",
            "SymmetricReduction",
            "Symmetrize",
            "SymmetrizedArray",
            "SymmetrizedArrayRules",
            "SymmetrizedDependentComponents",
            "SymmetrizedIndependentComponents",
            "SymmetrizedReplacePart",
            "SynchronousInitialization",
            "SynchronousUpdating",
            "Synonyms",
            "Syntax",
            "SyntaxForm",
            "SyntaxInformation",
            "SyntaxLength",
            "SyntaxPacket",
            "SyntaxQ",
            "SynthesizeMissingValues",
            "SystemCredential",
            "SystemCredentialData",
            "SystemCredentialKey",
            "SystemCredentialKeys",
            "SystemCredentialStoreObject",
            "SystemDialogInput",
            "SystemException",
            "SystemGet",
            "SystemHelpPath",
            "SystemInformation",
            "SystemInformationData",
            "SystemInstall",
            "SystemModel",
            "SystemModeler",
            "SystemModelExamples",
            "SystemModelLinearize",
            "SystemModelMeasurements",
            "SystemModelParametricSimulate",
            "SystemModelPlot",
            "SystemModelProgressReporting",
            "SystemModelReliability",
            "SystemModels",
            "SystemModelSimulate",
            "SystemModelSimulateSensitivity",
            "SystemModelSimulationData",
            "SystemOpen",
            "SystemOptions",
            "SystemProcessData",
            "SystemProcesses",
            "SystemsConnectionsModel",
            "SystemsModelControllerData",
            "SystemsModelDelay",
            "SystemsModelDelayApproximate",
            "SystemsModelDelete",
            "SystemsModelDimensions",
            "SystemsModelExtract",
            "SystemsModelFeedbackConnect",
            "SystemsModelLabels",
            "SystemsModelLinearity",
            "SystemsModelMerge",
            "SystemsModelOrder",
            "SystemsModelParallelConnect",
            "SystemsModelSeriesConnect",
            "SystemsModelStateFeedbackConnect",
            "SystemsModelVectorRelativeOrders",
            "SystemStub",
            "SystemTest",
            "Tab",
            "TabFilling",
            "Table",
            "TableAlignments",
            "TableDepth",
            "TableDirections",
            "TableForm",
            "TableHeadings",
            "TableSpacing",
            "TableView",
            "TableViewBox",
            "TableViewBoxAlignment",
            "TableViewBoxBackground",
            "TableViewBoxHeaders",
            "TableViewBoxItemSize",
            "TableViewBoxItemStyle",
            "TableViewBoxOptions",
            "TabSpacings",
            "TabView",
            "TabViewBox",
            "TabViewBoxOptions",
            "TagBox",
            "TagBoxNote",
            "TagBoxOptions",
            "TaggingRules",
            "TagSet",
            "TagSetDelayed",
            "TagStyle",
            "TagUnset",
            "Take",
            "TakeDrop",
            "TakeLargest",
            "TakeLargestBy",
            "TakeList",
            "TakeSmallest",
            "TakeSmallestBy",
            "TakeWhile",
            "Tally",
            "Tan",
            "Tanh",
            "TargetDevice",
            "TargetFunctions",
            "TargetSystem",
            "TargetUnits",
            "TaskAbort",
            "TaskExecute",
            "TaskObject",
            "TaskRemove",
            "TaskResume",
            "Tasks",
            "TaskSuspend",
            "TaskWait",
            "TautologyQ",
            "TelegraphProcess",
            "TemplateApply",
            "TemplateArgBox",
            "TemplateBox",
            "TemplateBoxOptions",
            "TemplateEvaluate",
            "TemplateExpression",
            "TemplateIf",
            "TemplateObject",
            "TemplateSequence",
            "TemplateSlot",
            "TemplateSlotSequence",
            "TemplateUnevaluated",
            "TemplateVerbatim",
            "TemplateWith",
            "TemporalData",
            "TemporalRegularity",
            "Temporary",
            "TemporaryVariable",
            "TensorContract",
            "TensorDimensions",
            "TensorExpand",
            "TensorProduct",
            "TensorQ",
            "TensorRank",
            "TensorReduce",
            "TensorSymmetry",
            "TensorTranspose",
            "TensorWedge",
            "TerminatedEvaluation",
            "TernaryListPlot",
            "TernaryPlotCorners",
            "TestID",
            "TestReport",
            "TestReportObject",
            "TestResultObject",
            "Tetrahedron",
            "TetrahedronBox",
            "TetrahedronBoxOptions",
            "TeXForm",
            "TeXSave",
            "Text",
            "Text3DBox",
            "Text3DBoxOptions",
            "TextAlignment",
            "TextBand",
            "TextBoundingBox",
            "TextBox",
            "TextCases",
            "TextCell",
            "TextClipboardType",
            "TextContents",
            "TextData",
            "TextElement",
            "TextForm",
            "TextGrid",
            "TextJustification",
            "TextLine",
            "TextPacket",
            "TextParagraph",
            "TextPosition",
            "TextRecognize",
            "TextSearch",
            "TextSearchReport",
            "TextSentences",
            "TextString",
            "TextStructure",
            "TextStyle",
            "TextTranslation",
            "Texture",
            "TextureCoordinateFunction",
            "TextureCoordinateScaling",
            "TextWords",
            "Therefore",
            "ThermodynamicData",
            "ThermometerGauge",
            "Thick",
            "Thickness",
            "Thin",
            "Thinning",
            "ThisLink",
            "ThomasPointProcess",
            "ThompsonGroupTh",
            "Thread",
            "Threaded",
            "ThreadingLayer",
            "ThreeJSymbol",
            "Threshold",
            "Through",
            "Throw",
            "ThueMorse",
            "Thumbnail",
            "Thursday",
            "TickDirection",
            "TickLabelOrientation",
            "TickLabelPositioning",
            "TickLabels",
            "TickLengths",
            "TickPositions",
            "Ticks",
            "TicksStyle",
            "TideData",
            "Tilde",
            "TildeEqual",
            "TildeFullEqual",
            "TildeTilde",
            "TimeConstrained",
            "TimeConstraint",
            "TimeDirection",
            "TimeFormat",
            "TimeGoal",
            "TimelinePlot",
            "TimeObject",
            "TimeObjectQ",
            "TimeRemaining",
            "Times",
            "TimesBy",
            "TimeSeries",
            "TimeSeriesAggregate",
            "TimeSeriesForecast",
            "TimeSeriesInsert",
            "TimeSeriesInvertibility",
            "TimeSeriesMap",
            "TimeSeriesMapThread",
            "TimeSeriesModel",
            "TimeSeriesModelFit",
            "TimeSeriesResample",
            "TimeSeriesRescale",
            "TimeSeriesShift",
            "TimeSeriesThread",
            "TimeSeriesWindow",
            "TimeSystem",
            "TimeSystemConvert",
            "TimeUsed",
            "TimeValue",
            "TimeWarpingCorrespondence",
            "TimeWarpingDistance",
            "TimeZone",
            "TimeZoneConvert",
            "TimeZoneOffset",
            "Timing",
            "Tiny",
            "TitleGrouping",
            "TitsGroupT",
            "ToBoxes",
            "ToCharacterCode",
            "ToColor",
            "ToContinuousTimeModel",
            "ToDate",
            "Today",
            "ToDiscreteTimeModel",
            "ToEntity",
            "ToeplitzMatrix",
            "ToExpression",
            "ToFileName",
            "Together",
            "Toggle",
            "ToggleFalse",
            "Toggler",
            "TogglerBar",
            "TogglerBox",
            "TogglerBoxOptions",
            "ToHeldExpression",
            "ToInvertibleTimeSeries",
            "TokenWords",
            "Tolerance",
            "ToLowerCase",
            "Tomorrow",
            "ToNumberField",
            "TooBig",
            "Tooltip",
            "TooltipBox",
            "TooltipBoxOptions",
            "TooltipDelay",
            "TooltipStyle",
            "ToonShading",
            "Top",
            "TopHatTransform",
            "ToPolarCoordinates",
            "TopologicalSort",
            "ToRadicals",
            "ToRawPointer",
            "ToRules",
            "Torus",
            "TorusGraph",
            "ToSphericalCoordinates",
            "ToString",
            "Total",
            "TotalHeight",
            "TotalLayer",
            "TotalVariationFilter",
            "TotalWidth",
            "TouchPosition",
            "TouchscreenAutoZoom",
            "TouchscreenControlPlacement",
            "ToUpperCase",
            "TourVideo",
            "Tr",
            "Trace",
            "TraceAbove",
            "TraceAction",
            "TraceBackward",
            "TraceDepth",
            "TraceDialog",
            "TraceForward",
            "TraceInternal",
            "TraceLevel",
            "TraceOff",
            "TraceOn",
            "TraceOriginal",
            "TracePrint",
            "TraceScan",
            "TrackCellChangeTimes",
            "TrackedSymbols",
            "TrackingFunction",
            "TracyWidomDistribution",
            "TradingChart",
            "TraditionalForm",
            "TraditionalFunctionNotation",
            "TraditionalNotation",
            "TraditionalOrder",
            "TrainImageContentDetector",
            "TrainingProgressCheckpointing",
            "TrainingProgressFunction",
            "TrainingProgressMeasurements",
            "TrainingProgressReporting",
            "TrainingStoppingCriterion",
            "TrainingUpdateSchedule",
            "TrainTextContentDetector",
            "TransferFunctionCancel",
            "TransferFunctionExpand",
            "TransferFunctionFactor",
            "TransferFunctionModel",
            "TransferFunctionPoles",
            "TransferFunctionTransform",
            "TransferFunctionZeros",
            "TransformationClass",
            "TransformationFunction",
            "TransformationFunctions",
            "TransformationMatrix",
            "TransformedDistribution",
            "TransformedField",
            "TransformedProcess",
            "TransformedRegion",
            "TransitionDirection",
            "TransitionDuration",
            "TransitionEffect",
            "TransitiveClosureGraph",
            "TransitiveReductionGraph",
            "Translate",
            "TranslationOptions",
            "TranslationTransform",
            "Transliterate",
            "Transparent",
            "TransparentColor",
            "Transpose",
            "TransposeLayer",
            "TrapEnterKey",
            "TrapSelection",
            "TravelDirections",
            "TravelDirectionsData",
            "TravelDistance",
            "TravelDistanceList",
            "TravelMethod",
            "TravelTime",
            "Tree",
            "TreeCases",
            "TreeChildren",
            "TreeCount",
            "TreeData",
            "TreeDelete",
            "TreeDepth",
            "TreeElementCoordinates",
            "TreeElementLabel",
            "TreeElementLabelFunction",
            "TreeElementLabelStyle",
            "TreeElementShape",
            "TreeElementShapeFunction",
            "TreeElementSize",
            "TreeElementSizeFunction",
            "TreeElementStyle",
            "TreeElementStyleFunction",
            "TreeExpression",
            "TreeExtract",
            "TreeFold",
            "TreeForm",
            "TreeGraph",
            "TreeGraphQ",
            "TreeInsert",
            "TreeLayout",
            "TreeLeafCount",
            "TreeLeafQ",
            "TreeLeaves",
            "TreeLevel",
            "TreeMap",
            "TreeMapAt",
            "TreeOutline",
            "TreePlot",
            "TreePosition",
            "TreeQ",
            "TreeReplacePart",
            "TreeRules",
            "TreeScan",
            "TreeSelect",
            "TreeSize",
            "TreeTraversalOrder",
            "TrendStyle",
            "Triangle",
            "TriangleCenter",
            "TriangleConstruct",
            "TriangleMeasurement",
            "TriangleWave",
            "TriangularDistribution",
            "TriangulateMesh",
            "Trig",
            "TrigExpand",
            "TrigFactor",
            "TrigFactorList",
            "Trigger",
            "TrigReduce",
            "TrigToExp",
            "TrimmedMean",
            "TrimmedVariance",
            "TropicalStormData",
            "True",
            "TrueQ",
            "TruncatedDistribution",
            "TruncatedPolyhedron",
            "TsallisQExponentialDistribution",
            "TsallisQGaussianDistribution",
            "TTest",
            "Tube",
            "TubeBezierCurveBox",
            "TubeBezierCurveBoxOptions",
            "TubeBox",
            "TubeBoxOptions",
            "TubeBSplineCurveBox",
            "TubeBSplineCurveBoxOptions",
            "Tuesday",
            "TukeyLambdaDistribution",
            "TukeyWindow",
            "TunnelData",
            "Tuples",
            "TuranGraph",
            "TuringMachine",
            "TuttePolynomial",
            "TwoWayRule",
            "Typed",
            "TypeDeclaration",
            "TypeEvaluate",
            "TypeHint",
            "TypeOf",
            "TypeSpecifier",
            "UnateQ",
            "Uncompress",
            "UnconstrainedParameters",
            "Undefined",
            "UnderBar",
            "Underflow",
            "Underlined",
            "Underoverscript",
            "UnderoverscriptBox",
            "UnderoverscriptBoxOptions",
            "Underscript",
            "UnderscriptBox",
            "UnderscriptBoxOptions",
            "UnderseaFeatureData",
            "UndirectedEdge",
            "UndirectedGraph",
            "UndirectedGraphQ",
            "UndoOptions",
            "UndoTrackedVariables",
            "Unequal",
            "UnequalTo",
            "Unevaluated",
            "UniformDistribution",
            "UniformGraphDistribution",
            "UniformPolyhedron",
            "UniformSumDistribution",
            "Uninstall",
            "Union",
            "UnionedEntityClass",
            "UnionPlus",
            "Unique",
            "UniqueElements",
            "UnitaryMatrixQ",
            "UnitBox",
            "UnitConvert",
            "UnitDimensions",
            "Unitize",
            "UnitRootTest",
            "UnitSimplify",
            "UnitStep",
            "UnitSystem",
            "UnitTriangle",
            "UnitVector",
            "UnitVectorLayer",
            "UnityDimensions",
            "UniverseModelData",
            "UniversityData",
            "UnixTime",
            "UnlabeledTree",
            "UnmanageObject",
            "Unprotect",
            "UnregisterExternalEvaluator",
            "UnsameQ",
            "UnsavedVariables",
            "Unset",
            "UnsetShared",
            "Until",
            "UntrackedVariables",
            "Up",
            "UpArrow",
            "UpArrowBar",
            "UpArrowDownArrow",
            "Update",
            "UpdateDynamicObjects",
            "UpdateDynamicObjectsSynchronous",
            "UpdateInterval",
            "UpdatePacletSites",
            "UpdateSearchIndex",
            "UpDownArrow",
            "UpEquilibrium",
            "UpperCaseQ",
            "UpperLeftArrow",
            "UpperRightArrow",
            "UpperTriangularize",
            "UpperTriangularMatrix",
            "UpperTriangularMatrixQ",
            "Upsample",
            "UpSet",
            "UpSetDelayed",
            "UpTee",
            "UpTeeArrow",
            "UpTo",
            "UpValues",
            "URL",
            "URLBuild",
            "URLDecode",
            "URLDispatcher",
            "URLDownload",
            "URLDownloadSubmit",
            "URLEncode",
            "URLExecute",
            "URLExpand",
            "URLFetch",
            "URLFetchAsynchronous",
            "URLParse",
            "URLQueryDecode",
            "URLQueryEncode",
            "URLRead",
            "URLResponseTime",
            "URLSave",
            "URLSaveAsynchronous",
            "URLShorten",
            "URLSubmit",
            "UseEmbeddedLibrary",
            "UseGraphicsRange",
            "UserDefinedWavelet",
            "Using",
            "UsingFrontEnd",
            "UtilityFunction",
            "V2Get",
            "ValenceErrorHandling",
            "ValenceFilling",
            "ValidationLength",
            "ValidationSet",
            "ValueBox",
            "ValueBoxOptions",
            "ValueDimensions",
            "ValueForm",
            "ValuePreprocessingFunction",
            "ValueQ",
            "Values",
            "ValuesData",
            "VandermondeMatrix",
            "Variables",
            "Variance",
            "VarianceEquivalenceTest",
            "VarianceEstimatorFunction",
            "VarianceGammaDistribution",
            "VarianceGammaPointProcess",
            "VarianceTest",
            "VariogramFunction",
            "VariogramModel",
            "VectorAngle",
            "VectorAround",
            "VectorAspectRatio",
            "VectorColorFunction",
            "VectorColorFunctionScaling",
            "VectorDensityPlot",
            "VectorDisplacementPlot",
            "VectorDisplacementPlot3D",
            "VectorGlyphData",
            "VectorGreater",
            "VectorGreaterEqual",
            "VectorLess",
            "VectorLessEqual",
            "VectorMarkers",
            "VectorPlot",
            "VectorPlot3D",
            "VectorPoints",
            "VectorQ",
            "VectorRange",
            "Vectors",
            "VectorScale",
            "VectorScaling",
            "VectorSizes",
            "VectorStyle",
            "Vee",
            "Verbatim",
            "Verbose",
            "VerificationTest",
            "VerifyConvergence",
            "VerifyDerivedKey",
            "VerifyDigitalSignature",
            "VerifyFileSignature",
            "VerifyInterpretation",
            "VerifySecurityCertificates",
            "VerifySolutions",
            "VerifyTestAssumptions",
            "VersionedPreferences",
            "VertexAdd",
            "VertexCapacity",
            "VertexChromaticNumber",
            "VertexColors",
            "VertexComponent",
            "VertexConnectivity",
            "VertexContract",
            "VertexCoordinateRules",
            "VertexCoordinates",
            "VertexCorrelationSimilarity",
            "VertexCosineSimilarity",
            "VertexCount",
            "VertexCoverQ",
            "VertexDataCoordinates",
            "VertexDegree",
            "VertexDelete",
            "VertexDiceSimilarity",
            "VertexEccentricity",
            "VertexInComponent",
            "VertexInComponentGraph",
            "VertexInDegree",
            "VertexIndex",
            "VertexJaccardSimilarity",
            "VertexLabeling",
            "VertexLabels",
            "VertexLabelStyle",
            "VertexList",
            "VertexNormals",
            "VertexOutComponent",
            "VertexOutComponentGraph",
            "VertexOutDegree",
            "VertexQ",
            "VertexRenderingFunction",
            "VertexReplace",
            "VertexShape",
            "VertexShapeFunction",
            "VertexSize",
            "VertexStyle",
            "VertexTextureCoordinates",
            "VertexTransitiveGraphQ",
            "VertexWeight",
            "VertexWeightedGraphQ",
            "Vertical",
            "VerticalBar",
            "VerticalForm",
            "VerticalGauge",
            "VerticalSeparator",
            "VerticalSlider",
            "VerticalTilde",
            "Video",
            "VideoCapture",
            "VideoCombine",
            "VideoDelete",
            "VideoEncoding",
            "VideoExtractFrames",
            "VideoFrameList",
            "VideoFrameMap",
            "VideoGenerator",
            "VideoInsert",
            "VideoIntervals",
            "VideoJoin",
            "VideoMap",
            "VideoMapList",
            "VideoMapTimeSeries",
            "VideoPadding",
            "VideoPause",
            "VideoPlay",
            "VideoQ",
            "VideoRecord",
            "VideoReplace",
            "VideoScreenCapture",
            "VideoSplit",
            "VideoStop",
            "VideoStream",
            "VideoStreams",
            "VideoTimeStretch",
            "VideoTrackSelection",
            "VideoTranscode",
            "VideoTransparency",
            "VideoTrim",
            "ViewAngle",
            "ViewCenter",
            "ViewMatrix",
            "ViewPoint",
            "ViewPointSelectorSettings",
            "ViewPort",
            "ViewProjection",
            "ViewRange",
            "ViewVector",
            "ViewVertical",
            "VirtualGroupData",
            "Visible",
            "VisibleCell",
            "VoiceStyleData",
            "VoigtDistribution",
            "VolcanoData",
            "Volume",
            "VonMisesDistribution",
            "VoronoiMesh",
            "WaitAll",
            "WaitAsynchronousTask",
            "WaitNext",
            "WaitUntil",
            "WakebyDistribution",
            "WalleniusHypergeometricDistribution",
            "WaringYuleDistribution",
            "WarpingCorrespondence",
            "WarpingDistance",
            "WatershedComponents",
            "WatsonUSquareTest",
            "WattsStrogatzGraphDistribution",
            "WaveletBestBasis",
            "WaveletFilterCoefficients",
            "WaveletImagePlot",
            "WaveletListPlot",
            "WaveletMapIndexed",
            "WaveletMatrixPlot",
            "WaveletPhi",
            "WaveletPsi",
            "WaveletScale",
            "WaveletScalogram",
            "WaveletThreshold",
            "WavePDEComponent",
            "WeaklyConnectedComponents",
            "WeaklyConnectedGraphComponents",
            "WeaklyConnectedGraphQ",
            "WeakStationarity",
            "WeatherData",
            "WeatherForecastData",
            "WebAudioSearch",
            "WebColumn",
            "WebElementObject",
            "WeberE",
            "WebExecute",
            "WebImage",
            "WebImageSearch",
            "WebItem",
            "WebPageMetaInformation",
            "WebRow",
            "WebSearch",
            "WebSessionObject",
            "WebSessions",
            "WebWindowObject",
            "Wedge",
            "Wednesday",
            "WeibullDistribution",
            "WeierstrassE1",
            "WeierstrassE2",
            "WeierstrassE3",
            "WeierstrassEta1",
            "WeierstrassEta2",
            "WeierstrassEta3",
            "WeierstrassHalfPeriods",
            "WeierstrassHalfPeriodW1",
            "WeierstrassHalfPeriodW2",
            "WeierstrassHalfPeriodW3",
            "WeierstrassInvariantG2",
            "WeierstrassInvariantG3",
            "WeierstrassInvariants",
            "WeierstrassP",
            "WeierstrassPPrime",
            "WeierstrassSigma",
            "WeierstrassZeta",
            "WeightedAdjacencyGraph",
            "WeightedAdjacencyMatrix",
            "WeightedData",
            "WeightedGraphQ",
            "Weights",
            "WelchWindow",
            "WheelGraph",
            "WhenEvent",
            "Which",
            "While",
            "White",
            "WhiteNoiseProcess",
            "WhitePoint",
            "Whitespace",
            "WhitespaceCharacter",
            "WhittakerM",
            "WhittakerW",
            "WholeCellGroupOpener",
            "WienerFilter",
            "WienerProcess",
            "WignerD",
            "WignerSemicircleDistribution",
            "WikidataData",
            "WikidataSearch",
            "WikipediaData",
            "WikipediaSearch",
            "WilksW",
            "WilksWTest",
            "WindDirectionData",
            "WindingCount",
            "WindingPolygon",
            "WindowClickSelect",
            "WindowElements",
            "WindowFloating",
            "WindowFrame",
            "WindowFrameElements",
            "WindowMargins",
            "WindowMovable",
            "WindowOpacity",
            "WindowPersistentStyles",
            "WindowSelected",
            "WindowSize",
            "WindowStatusArea",
            "WindowTitle",
            "WindowToolbars",
            "WindowWidth",
            "WindSpeedData",
            "WindVectorData",
            "WinsorizedMean",
            "WinsorizedVariance",
            "WishartMatrixDistribution",
            "With",
            "WithCleanup",
            "WithLock",
            "WolframAlpha",
            "WolframAlphaDate",
            "WolframAlphaQuantity",
            "WolframAlphaResult",
            "WolframCloudSettings",
            "WolframLanguageData",
            "Word",
            "WordBoundary",
            "WordCharacter",
            "WordCloud",
            "WordCount",
            "WordCounts",
            "WordData",
            "WordDefinition",
            "WordFrequency",
            "WordFrequencyData",
            "WordList",
            "WordOrientation",
            "WordSearch",
            "WordSelectionFunction",
            "WordSeparators",
            "WordSpacings",
            "WordStem",
            "WordTranslation",
            "WorkingPrecision",
            "WrapAround",
            "Write",
            "WriteLine",
            "WriteString",
            "Wronskian",
            "XMLElement",
            "XMLObject",
            "XMLTemplate",
            "Xnor",
            "Xor",
            "XYZColor",
            "Yellow",
            "Yesterday",
            "YuleDissimilarity",
            "ZernikeR",
            "ZeroSymmetric",
            "ZeroTest",
            "ZeroWidthTimes",
            "Zeta",
            "ZetaZero",
            "ZIPCodeData",
            "ZipfDistribution",
            "ZoomCenter",
            "ZoomFactor",
            "ZTest",
            "ZTransform",
            "$Aborted",
            "$ActivationGroupID",
            "$ActivationKey",
            "$ActivationUserRegistered",
            "$AddOnsDirectory",
            "$AllowDataUpdates",
            "$AllowExternalChannelFunctions",
            "$AllowInternet",
            "$AssertFunction",
            "$Assumptions",
            "$AsynchronousTask",
            "$AudioDecoders",
            "$AudioEncoders",
            "$AudioInputDevices",
            "$AudioOutputDevices",
            "$BaseDirectory",
            "$BasePacletsDirectory",
            "$BatchInput",
            "$BatchOutput",
            "$BlockchainBase",
            "$BoxForms",
            "$ByteOrdering",
            "$CacheBaseDirectory",
            "$Canceled",
            "$ChannelBase",
            "$CharacterEncoding",
            "$CharacterEncodings",
            "$CloudAccountName",
            "$CloudBase",
            "$CloudConnected",
            "$CloudConnection",
            "$CloudCreditsAvailable",
            "$CloudEvaluation",
            "$CloudExpressionBase",
            "$CloudObjectNameFormat",
            "$CloudObjectURLType",
            "$CloudRootDirectory",
            "$CloudSymbolBase",
            "$CloudUserID",
            "$CloudUserUUID",
            "$CloudVersion",
            "$CloudVersionNumber",
            "$CloudWolframEngineVersionNumber",
            "$CommandLine",
            "$CompilationTarget",
            "$CompilerEnvironment",
            "$ConditionHold",
            "$ConfiguredKernels",
            "$Context",
            "$ContextAliases",
            "$ContextPath",
            "$ControlActiveSetting",
            "$Cookies",
            "$CookieStore",
            "$CreationDate",
            "$CryptographicEllipticCurveNames",
            "$CurrentLink",
            "$CurrentTask",
            "$CurrentWebSession",
            "$DataStructures",
            "$DateStringFormat",
            "$DefaultAudioInputDevice",
            "$DefaultAudioOutputDevice",
            "$DefaultFont",
            "$DefaultFrontEnd",
            "$DefaultImagingDevice",
            "$DefaultKernels",
            "$DefaultLocalBase",
            "$DefaultLocalKernel",
            "$DefaultMailbox",
            "$DefaultNetworkInterface",
            "$DefaultPath",
            "$DefaultProxyRules",
            "$DefaultRemoteBatchSubmissionEnvironment",
            "$DefaultRemoteKernel",
            "$DefaultSystemCredentialStore",
            "$Display",
            "$DisplayFunction",
            "$DistributedContexts",
            "$DynamicEvaluation",
            "$Echo",
            "$EmbedCodeEnvironments",
            "$EmbeddableServices",
            "$EntityStores",
            "$Epilog",
            "$EvaluationCloudBase",
            "$EvaluationCloudObject",
            "$EvaluationEnvironment",
            "$ExportFormats",
            "$ExternalIdentifierTypes",
            "$ExternalStorageBase",
            "$Failed",
            "$FinancialDataSource",
            "$FontFamilies",
            "$FormatType",
            "$FrontEnd",
            "$FrontEndSession",
            "$GeneratedAssetLocation",
            "$GeoEntityTypes",
            "$GeoLocation",
            "$GeoLocationCity",
            "$GeoLocationCountry",
            "$GeoLocationPrecision",
            "$GeoLocationSource",
            "$HistoryLength",
            "$HomeDirectory",
            "$HTMLExportRules",
            "$HTTPCookies",
            "$HTTPRequest",
            "$IgnoreEOF",
            "$ImageFormattingWidth",
            "$ImageResolution",
            "$ImagingDevice",
            "$ImagingDevices",
            "$ImportFormats",
            "$IncomingMailSettings",
            "$InitialDirectory",
            "$Initialization",
            "$InitializationContexts",
            "$Input",
            "$InputFileName",
            "$InputStreamMethods",
            "$Inspector",
            "$InstallationDate",
            "$InstallationDirectory",
            "$InterfaceEnvironment",
            "$InterpreterTypes",
            "$IterationLimit",
            "$KernelCount",
            "$KernelID",
            "$Language",
            "$LaunchDirectory",
            "$LibraryPath",
            "$LicenseExpirationDate",
            "$LicenseID",
            "$LicenseProcesses",
            "$LicenseServer",
            "$LicenseSubprocesses",
            "$LicenseType",
            "$Line",
            "$Linked",
            "$LinkSupported",
            "$LoadedFiles",
            "$LocalBase",
            "$LocalSymbolBase",
            "$MachineAddresses",
            "$MachineDomain",
            "$MachineDomains",
            "$MachineEpsilon",
            "$MachineID",
            "$MachineName",
            "$MachinePrecision",
            "$MachineType",
            "$MaxDisplayedChildren",
            "$MaxExtraPrecision",
            "$MaxLicenseProcesses",
            "$MaxLicenseSubprocesses",
            "$MaxMachineNumber",
            "$MaxNumber",
            "$MaxPiecewiseCases",
            "$MaxPrecision",
            "$MaxRootDegree",
            "$MessageGroups",
            "$MessageList",
            "$MessagePrePrint",
            "$Messages",
            "$MinMachineNumber",
            "$MinNumber",
            "$MinorReleaseNumber",
            "$MinPrecision",
            "$MobilePhone",
            "$ModuleNumber",
            "$NetworkConnected",
            "$NetworkInterfaces",
            "$NetworkLicense",
            "$NewMessage",
            "$NewSymbol",
            "$NotebookInlineStorageLimit",
            "$Notebooks",
            "$NoValue",
            "$NumberMarks",
            "$Off",
            "$OperatingSystem",
            "$Output",
            "$OutputForms",
            "$OutputSizeLimit",
            "$OutputStreamMethods",
            "$Packages",
            "$ParentLink",
            "$ParentProcessID",
            "$PasswordFile",
            "$PatchLevelID",
            "$Path",
            "$PathnameSeparator",
            "$PerformanceGoal",
            "$Permissions",
            "$PermissionsGroupBase",
            "$PersistenceBase",
            "$PersistencePath",
            "$PipeSupported",
            "$PlotTheme",
            "$Post",
            "$Pre",
            "$PreferencesDirectory",
            "$PreInitialization",
            "$PrePrint",
            "$PreRead",
            "$PrintForms",
            "$PrintLiteral",
            "$Printout3DPreviewer",
            "$ProcessID",
            "$ProcessorCount",
            "$ProcessorType",
            "$ProductInformation",
            "$ProgramName",
            "$ProgressReporting",
            "$PublisherID",
            "$RandomGeneratorState",
            "$RandomState",
            "$RecursionLimit",
            "$RegisteredDeviceClasses",
            "$RegisteredUserName",
            "$ReleaseNumber",
            "$RequesterAddress",
            "$RequesterCloudUserID",
            "$RequesterCloudUserUUID",
            "$RequesterWolframID",
            "$RequesterWolframUUID",
            "$ResourceSystemBase",
            "$ResourceSystemPath",
            "$RootDirectory",
            "$ScheduledTask",
            "$ScriptCommandLine",
            "$ScriptInputString",
            "$SecuredAuthenticationKeyTokens",
            "$ServiceCreditsAvailable",
            "$Services",
            "$SessionID",
            "$SetParentLink",
            "$SharedFunctions",
            "$SharedVariables",
            "$SoundDisplay",
            "$SoundDisplayFunction",
            "$SourceLink",
            "$SSHAuthentication",
            "$SubtitleDecoders",
            "$SubtitleEncoders",
            "$SummaryBoxDataSizeLimit",
            "$SuppressInputFormHeads",
            "$SynchronousEvaluation",
            "$SyntaxHandler",
            "$System",
            "$SystemCharacterEncoding",
            "$SystemCredentialStore",
            "$SystemID",
            "$SystemMemory",
            "$SystemShell",
            "$SystemTimeZone",
            "$SystemWordLength",
            "$TargetSystems",
            "$TemplatePath",
            "$TemporaryDirectory",
            "$TemporaryPrefix",
            "$TestFileName",
            "$TextStyle",
            "$TimedOut",
            "$TimeUnit",
            "$TimeZone",
            "$TimeZoneEntity",
            "$TopDirectory",
            "$TraceOff",
            "$TraceOn",
            "$TracePattern",
            "$TracePostAction",
            "$TracePreAction",
            "$UnitSystem",
            "$Urgent",
            "$UserAddOnsDirectory",
            "$UserAgentLanguages",
            "$UserAgentMachine",
            "$UserAgentName",
            "$UserAgentOperatingSystem",
            "$UserAgentString",
            "$UserAgentVersion",
            "$UserBaseDirectory",
            "$UserBasePacletsDirectory",
            "$UserDocumentsDirectory",
            "$Username",
            "$UserName",
            "$UserURLBase",
            "$Version",
            "$VersionNumber",
            "$VideoDecoders",
            "$VideoEncoders",
            "$VoiceStyles",
            "$WolframDocumentsDirectory",
            "$WolframID",
            "$WolframUUID"
        ];
        return oi = function(t) {
            const a = t.regex, n = a.either(a.concat(/([2-9]|[1-2]\d|[3][0-5])\^\^/, /(\w*\.\w+|\w+\.\w*|\w+)/), /(\d*\.\d+|\d+\.\d*|\d+)/), i = a.either(/``[+-]?(\d*\.\d+|\d+\.\d*|\d+)/, /`([+-]?(\d*\.\d+|\d+\.\d*|\d+))?/), r = {
                className: "number",
                relevance: 0,
                begin: a.concat(n, a.optional(i), a.optional(/\*\^[+-]?\d+/))
            }, o = /[a-zA-Z$][a-zA-Z0-9$]*/, s = new Set(e), l = {
                variants: [
                    {
                        className: "builtin-symbol",
                        begin: o,
                        "on:begin": (e, t)=>{
                            s.has(e[0]) || t.ignoreMatch();
                        }
                    },
                    {
                        className: "symbol",
                        relevance: 0,
                        begin: o
                    }
                ]
            }, c = {
                className: "message-name",
                relevance: 0,
                begin: a.concat("::", o)
            };
            return {
                name: "Mathematica",
                aliases: [
                    "mma",
                    "wl"
                ],
                classNameAliases: {
                    brace: "punctuation",
                    pattern: "type",
                    slot: "type",
                    symbol: "variable",
                    "named-character": "variable",
                    "builtin-symbol": "built_in",
                    "message-name": "string"
                },
                contains: [
                    t.COMMENT(/\(\*/, /\*\)/, {
                        contains: [
                            "self"
                        ]
                    }),
                    {
                        className: "pattern",
                        relevance: 0,
                        begin: /([a-zA-Z$][a-zA-Z0-9$]*)?_+([a-zA-Z$][a-zA-Z0-9$]*)?/
                    },
                    {
                        className: "slot",
                        relevance: 0,
                        begin: /#[a-zA-Z$][a-zA-Z0-9$]*|#+[0-9]?/
                    },
                    c,
                    l,
                    {
                        className: "named-character",
                        begin: /\\\[[$a-zA-Z][$a-zA-Z0-9]+\]/
                    },
                    t.QUOTE_STRING_MODE,
                    r,
                    {
                        className: "operator",
                        relevance: 0,
                        begin: /[+\-*/,;.:@~=><&|_`'^?!%]+/
                    },
                    {
                        className: "brace",
                        relevance: 0,
                        begin: /[[\](){}]/
                    }
                ]
            };
        }, oi;
    }()), Cs.registerLanguage("matlab", (ci || (ci = 1, li = function(e) {
        const t = "('|\\.')+", a = {
            relevance: 0,
            contains: [
                {
                    begin: t
                }
            ]
        };
        return {
            name: "Matlab",
            keywords: {
                keyword: "arguments break case catch classdef continue else elseif end enumeration events for function global if methods otherwise parfor persistent properties return spmd switch try while",
                built_in: "sin sind sinh asin asind asinh cos cosd cosh acos acosd acosh tan tand tanh atan atand atan2 atanh sec secd sech asec asecd asech csc cscd csch acsc acscd acsch cot cotd coth acot acotd acoth hypot exp expm1 log log1p log10 log2 pow2 realpow reallog realsqrt sqrt nthroot nextpow2 abs angle complex conj imag real unwrap isreal cplxpair fix floor ceil round mod rem sign airy besselj bessely besselh besseli besselk beta betainc betaln ellipj ellipke erf erfc erfcx erfinv expint gamma gammainc gammaln psi legendre cross dot factor isprime primes gcd lcm rat rats perms nchoosek factorial cart2sph cart2pol pol2cart sph2cart hsv2rgb rgb2hsv zeros ones eye repmat rand randn linspace logspace freqspace meshgrid accumarray size length ndims numel disp isempty isequal isequalwithequalnans cat reshape diag blkdiag tril triu fliplr flipud flipdim rot90 find sub2ind ind2sub bsxfun ndgrid permute ipermute shiftdim circshift squeeze isscalar isvector ans eps realmax realmin pi i|0 inf nan isnan isinf isfinite j|0 why compan gallery hadamard hankel hilb invhilb magic pascal rosser toeplitz vander wilkinson max min nanmax nanmin mean nanmean type table readtable writetable sortrows sort figure plot plot3 scatter scatter3 cellfun legend intersect ismember procrustes hold num2cell "
            },
            illegal: '(//|"|#|/\\*|\\s+/\\w+)',
            contains: [
                {
                    className: "function",
                    beginKeywords: "function",
                    end: "$",
                    contains: [
                        e.UNDERSCORE_TITLE_MODE,
                        {
                            className: "params",
                            variants: [
                                {
                                    begin: "\\(",
                                    end: "\\)"
                                },
                                {
                                    begin: "\\[",
                                    end: "\\]"
                                }
                            ]
                        }
                    ]
                },
                {
                    className: "built_in",
                    begin: /true|false/,
                    relevance: 0,
                    starts: a
                },
                {
                    begin: "[a-zA-Z][a-zA-Z_0-9]*" + t,
                    relevance: 0
                },
                {
                    className: "number",
                    begin: e.C_NUMBER_RE,
                    relevance: 0,
                    starts: a
                },
                {
                    className: "string",
                    begin: "'",
                    end: "'",
                    contains: [
                        {
                            begin: "''"
                        }
                    ]
                },
                {
                    begin: /\]|\}|\)/,
                    relevance: 0,
                    starts: a
                },
                {
                    className: "string",
                    begin: '"',
                    end: '"',
                    contains: [
                        {
                            begin: '""'
                        }
                    ],
                    starts: a
                },
                e.COMMENT("^\\s*%\\{\\s*$", "^\\s*%\\}\\s*$"),
                e.COMMENT("%", "$")
            ]
        };
    }), li)), Cs.registerLanguage("maxima", (di || (di = 1, _i = function(e) {
        return {
            name: "Maxima",
            keywords: {
                $pattern: "[A-Za-z_%][0-9A-Za-z_%]*",
                keyword: "if then else elseif for thru do while unless step in and or not",
                literal: "true false unknown inf minf ind und %e %i %pi %phi %gamma",
                built_in: " abasep abs absint absolute_real_time acos acosh acot acoth acsc acsch activate addcol add_edge add_edges addmatrices addrow add_vertex add_vertices adjacency_matrix adjoin adjoint af agd airy airy_ai airy_bi airy_dai airy_dbi algsys alg_type alias allroots alphacharp alphanumericp amortization %and annuity_fv annuity_pv antid antidiff AntiDifference append appendfile apply apply1 apply2 applyb1 apropos args arit_amortization arithmetic arithsum array arrayapply arrayinfo arraymake arraysetapply ascii asec asech asin asinh askinteger asksign assoc assoc_legendre_p assoc_legendre_q assume assume_external_byte_order asympa at atan atan2 atanh atensimp atom atvalue augcoefmatrix augmented_lagrangian_method av average_degree backtrace bars barsplot barsplot_description base64 base64_decode bashindices batch batchload bc2 bdvac belln benefit_cost bern bernpoly bernstein_approx bernstein_expand bernstein_poly bessel bessel_i bessel_j bessel_k bessel_simplify bessel_y beta beta_incomplete beta_incomplete_generalized beta_incomplete_regularized bezout bfallroots bffac bf_find_root bf_fmin_cobyla bfhzeta bfloat bfloatp bfpsi bfpsi0 bfzeta biconnected_components bimetric binomial bipartition block blockmatrixp bode_gain bode_phase bothcoef box boxplot boxplot_description break bug_report build_info|10 buildq build_sample burn cabs canform canten cardinality carg cartan cartesian_product catch cauchy_matrix cbffac cdf_bernoulli cdf_beta cdf_binomial cdf_cauchy cdf_chi2 cdf_continuous_uniform cdf_discrete_uniform cdf_exp cdf_f cdf_gamma cdf_general_finite_discrete cdf_geometric cdf_gumbel cdf_hypergeometric cdf_laplace cdf_logistic cdf_lognormal cdf_negative_binomial cdf_noncentral_chi2 cdf_noncentral_student_t cdf_normal cdf_pareto cdf_poisson cdf_rank_sum cdf_rayleigh cdf_signed_rank cdf_student_t cdf_weibull cdisplay ceiling central_moment cequal cequalignore cf cfdisrep cfexpand cgeodesic cgreaterp cgreaterpignore changename changevar chaosgame charat charfun charfun2 charlist charp charpoly chdir chebyshev_t chebyshev_u checkdiv check_overlaps chinese cholesky christof chromatic_index chromatic_number cint circulant_graph clear_edge_weight clear_rules clear_vertex_label clebsch_gordan clebsch_graph clessp clesspignore close closefile cmetric coeff coefmatrix cograd col collapse collectterms columnop columnspace columnswap columnvector combination combine comp2pui compare compfile compile compile_file complement_graph complete_bipartite_graph complete_graph complex_number_p components compose_functions concan concat conjugate conmetderiv connected_components connect_vertices cons constant constantp constituent constvalue cont2part content continuous_freq contortion contour_plot contract contract_edge contragrad contrib_ode convert coord copy copy_file copy_graph copylist copymatrix cor cos cosh cot coth cov cov1 covdiff covect covers crc24sum create_graph create_list csc csch csetup cspline ctaylor ct_coordsys ctransform ctranspose cube_graph cuboctahedron_graph cunlisp cv cycle_digraph cycle_graph cylindrical days360 dblint deactivate declare declare_constvalue declare_dimensions declare_fundamental_dimensions declare_fundamental_units declare_qty declare_translated declare_unit_conversion declare_units declare_weights decsym defcon define define_alt_display define_variable defint defmatch defrule defstruct deftaylor degree_sequence del delete deleten delta demo demoivre denom depends derivdegree derivlist describe desolve determinant dfloat dgauss_a dgauss_b dgeev dgemm dgeqrf dgesv dgesvd diag diagmatrix diag_matrix diagmatrixp diameter diff digitcharp dimacs_export dimacs_import dimension dimensionless dimensions dimensions_as_list direct directory discrete_freq disjoin disjointp disolate disp dispcon dispform dispfun dispJordan display disprule dispterms distrib divide divisors divsum dkummer_m dkummer_u dlange dodecahedron_graph dotproduct dotsimp dpart draw draw2d draw3d drawdf draw_file draw_graph dscalar echelon edge_coloring edge_connectivity edges eigens_by_jacobi eigenvalues eigenvectors eighth einstein eivals eivects elapsed_real_time elapsed_run_time ele2comp ele2polynome ele2pui elem elementp elevation_grid elim elim_allbut eliminate eliminate_using ellipse elliptic_e elliptic_ec elliptic_eu elliptic_f elliptic_kc elliptic_pi ematrix empty_graph emptyp endcons entermatrix entertensor entier equal equalp equiv_classes erf erfc erf_generalized erfi errcatch error errormsg errors euler ev eval_string evenp every evolution evolution2d evundiff example exp expand expandwrt expandwrt_factored expint expintegral_chi expintegral_ci expintegral_e expintegral_e1 expintegral_ei expintegral_e_simplify expintegral_li expintegral_shi expintegral_si explicit explose exponentialize express expt exsec extdiff extract_linear_equations extremal_subset ezgcd %f f90 facsum factcomb factor factorfacsum factorial factorout factorsum facts fast_central_elements fast_linsolve fasttimes featurep fernfale fft fib fibtophi fifth filename_merge file_search file_type fillarray findde find_root find_root_abs find_root_error find_root_rel first fix flatten flength float floatnump floor flower_snark flush flush1deriv flushd flushnd flush_output fmin_cobyla forget fortran fourcos fourexpand fourier fourier_elim fourint fourintcos fourintsin foursimp foursin fourth fposition frame_bracket freeof freshline fresnel_c fresnel_s from_adjacency_matrix frucht_graph full_listify fullmap fullmapl fullratsimp fullratsubst fullsetify funcsolve fundamental_dimensions fundamental_units fundef funmake funp fv g0 g1 gamma gamma_greek gamma_incomplete gamma_incomplete_generalized gamma_incomplete_regularized gauss gauss_a gauss_b gaussprob gcd gcdex gcdivide gcfac gcfactor gd generalized_lambert_w genfact gen_laguerre genmatrix gensym geo_amortization geo_annuity_fv geo_annuity_pv geomap geometric geometric_mean geosum get getcurrentdirectory get_edge_weight getenv get_lu_factors get_output_stream_string get_pixel get_plot_option get_tex_environment get_tex_environment_default get_vertex_label gfactor gfactorsum ggf girth global_variances gn gnuplot_close gnuplot_replot gnuplot_reset gnuplot_restart gnuplot_start go Gosper GosperSum gr2d gr3d gradef gramschmidt graph6_decode graph6_encode graph6_export graph6_import graph_center graph_charpoly graph_eigenvalues graph_flow graph_order graph_periphery graph_product graph_size graph_union great_rhombicosidodecahedron_graph great_rhombicuboctahedron_graph grid_graph grind grobner_basis grotzch_graph hamilton_cycle hamilton_path hankel hankel_1 hankel_2 harmonic harmonic_mean hav heawood_graph hermite hessian hgfred hilbertmap hilbert_matrix hipow histogram histogram_description hodge horner hypergeometric i0 i1 %ibes ic1 ic2 ic_convert ichr1 ichr2 icosahedron_graph icosidodecahedron_graph icurvature ident identfor identity idiff idim idummy ieqn %if ifactors iframes ifs igcdex igeodesic_coords ilt image imagpart imetric implicit implicit_derivative implicit_plot indexed_tensor indices induced_subgraph inferencep inference_result infix info_display init_atensor init_ctensor in_neighbors innerproduct inpart inprod inrt integerp integer_partitions integrate intersect intersection intervalp intopois intosum invariant1 invariant2 inverse_fft inverse_jacobi_cd inverse_jacobi_cn inverse_jacobi_cs inverse_jacobi_dc inverse_jacobi_dn inverse_jacobi_ds inverse_jacobi_nc inverse_jacobi_nd inverse_jacobi_ns inverse_jacobi_sc inverse_jacobi_sd inverse_jacobi_sn invert invert_by_adjoint invert_by_lu inv_mod irr is is_biconnected is_bipartite is_connected is_digraph is_edge_in_graph is_graph is_graph_or_digraph ishow is_isomorphic isolate isomorphism is_planar isqrt isreal_p is_sconnected is_tree is_vertex_in_graph items_inference %j j0 j1 jacobi jacobian jacobi_cd jacobi_cn jacobi_cs jacobi_dc jacobi_dn jacobi_ds jacobi_nc jacobi_nd jacobi_ns jacobi_p jacobi_sc jacobi_sd jacobi_sn JF jn join jordan julia julia_set julia_sin %k kdels kdelta kill killcontext kostka kron_delta kronecker_product kummer_m kummer_u kurtosis kurtosis_bernoulli kurtosis_beta kurtosis_binomial kurtosis_chi2 kurtosis_continuous_uniform kurtosis_discrete_uniform kurtosis_exp kurtosis_f kurtosis_gamma kurtosis_general_finite_discrete kurtosis_geometric kurtosis_gumbel kurtosis_hypergeometric kurtosis_laplace kurtosis_logistic kurtosis_lognormal kurtosis_negative_binomial kurtosis_noncentral_chi2 kurtosis_noncentral_student_t kurtosis_normal kurtosis_pareto kurtosis_poisson kurtosis_rayleigh kurtosis_student_t kurtosis_weibull label labels lagrange laguerre lambda lambert_w laplace laplacian_matrix last lbfgs lc2kdt lcharp lc_l lcm lc_u ldefint ldisp ldisplay legendre_p legendre_q leinstein length let letrules letsimp levi_civita lfreeof lgtreillis lhs li liediff limit Lindstedt linear linearinterpol linear_program linear_regression line_graph linsolve listarray list_correlations listify list_matrix_entries list_nc_monomials listoftens listofvars listp lmax lmin load loadfile local locate_matrix_entry log logcontract log_gamma lopow lorentz_gauge lowercasep lpart lratsubst lreduce lriemann lsquares_estimates lsquares_estimates_approximate lsquares_estimates_exact lsquares_mse lsquares_residual_mse lsquares_residuals lsum ltreillis lu_backsub lucas lu_factor %m macroexpand macroexpand1 make_array makebox makefact makegamma make_graph make_level_picture makelist makeOrders make_poly_continent make_poly_country make_polygon make_random_state make_rgb_picture makeset make_string_input_stream make_string_output_stream make_transform mandelbrot mandelbrot_set map mapatom maplist matchdeclare matchfix mat_cond mat_fullunblocker mat_function mathml_display mat_norm matrix matrixmap matrixp matrix_size mattrace mat_trace mat_unblocker max max_clique max_degree max_flow maximize_lp max_independent_set max_matching maybe md5sum mean mean_bernoulli mean_beta mean_binomial mean_chi2 mean_continuous_uniform mean_deviation mean_discrete_uniform mean_exp mean_f mean_gamma mean_general_finite_discrete mean_geometric mean_gumbel mean_hypergeometric mean_laplace mean_logistic mean_lognormal mean_negative_binomial mean_noncentral_chi2 mean_noncentral_student_t mean_normal mean_pareto mean_poisson mean_rayleigh mean_student_t mean_weibull median median_deviation member mesh metricexpandall mgf1_sha1 min min_degree min_edge_cut minfactorial minimalPoly minimize_lp minimum_spanning_tree minor minpack_lsquares minpack_solve min_vertex_cover min_vertex_cut mkdir mnewton mod mode_declare mode_identity ModeMatrix moebius mon2schur mono monomial_dimensions multibernstein_poly multi_display_for_texinfo multi_elem multinomial multinomial_coeff multi_orbit multiplot_mode multi_pui multsym multthru mycielski_graph nary natural_unit nc_degree ncexpt ncharpoly negative_picture neighbors new newcontext newdet new_graph newline newton new_variable next_prime nicedummies niceindices ninth nofix nonarray noncentral_moment nonmetricity nonnegintegerp nonscalarp nonzeroandfreeof notequal nounify nptetrad npv nroots nterms ntermst nthroot nullity nullspace num numbered_boundaries numberp number_to_octets num_distinct_partitions numerval numfactor num_partitions nusum nzeta nzetai nzetar octets_to_number octets_to_oid odd_girth oddp ode2 ode_check odelin oid_to_octets op opena opena_binary openr openr_binary openw openw_binary operatorp opsubst optimize %or orbit orbits ordergreat ordergreatp orderless orderlessp orthogonal_complement orthopoly_recur orthopoly_weight outermap out_neighbors outofpois pade parabolic_cylinder_d parametric parametric_surface parg parGosper parse_string parse_timedate part part2cont partfrac partition partition_set partpol path_digraph path_graph pathname_directory pathname_name pathname_type pdf_bernoulli pdf_beta pdf_binomial pdf_cauchy pdf_chi2 pdf_continuous_uniform pdf_discrete_uniform pdf_exp pdf_f pdf_gamma pdf_general_finite_discrete pdf_geometric pdf_gumbel pdf_hypergeometric pdf_laplace pdf_logistic pdf_lognormal pdf_negative_binomial pdf_noncentral_chi2 pdf_noncentral_student_t pdf_normal pdf_pareto pdf_poisson pdf_rank_sum pdf_rayleigh pdf_signed_rank pdf_student_t pdf_weibull pearson_skewness permanent permut permutation permutations petersen_graph petrov pickapart picture_equalp picturep piechart piechart_description planar_embedding playback plog plot2d plot3d plotdf ploteq plsquares pochhammer points poisdiff poisexpt poisint poismap poisplus poissimp poissubst poistimes poistrim polar polarform polartorect polar_to_xy poly_add poly_buchberger poly_buchberger_criterion poly_colon_ideal poly_content polydecomp poly_depends_p poly_elimination_ideal poly_exact_divide poly_expand poly_expt poly_gcd polygon poly_grobner poly_grobner_equal poly_grobner_member poly_grobner_subsetp poly_ideal_intersection poly_ideal_polysaturation poly_ideal_polysaturation1 poly_ideal_saturation poly_ideal_saturation1 poly_lcm poly_minimization polymod poly_multiply polynome2ele polynomialp poly_normal_form poly_normalize poly_normalize_list poly_polysaturation_extension poly_primitive_part poly_pseudo_divide poly_reduced_grobner poly_reduction poly_saturation_extension poly_s_polynomial poly_subtract polytocompanion pop postfix potential power_mod powerseries powerset prefix prev_prime primep primes principal_components print printf printfile print_graph printpois printprops prodrac product properties propvars psi psubst ptriangularize pui pui2comp pui2ele pui2polynome pui_direct puireduc push put pv qput qrange qty quad_control quad_qag quad_qagi quad_qagp quad_qags quad_qawc quad_qawf quad_qawo quad_qaws quadrilateral quantile quantile_bernoulli quantile_beta quantile_binomial quantile_cauchy quantile_chi2 quantile_continuous_uniform quantile_discrete_uniform quantile_exp quantile_f quantile_gamma quantile_general_finite_discrete quantile_geometric quantile_gumbel quantile_hypergeometric quantile_laplace quantile_logistic quantile_lognormal quantile_negative_binomial quantile_noncentral_chi2 quantile_noncentral_student_t quantile_normal quantile_pareto quantile_poisson quantile_rayleigh quantile_student_t quantile_weibull quartile_skewness quit qunit quotient racah_v racah_w radcan radius random random_bernoulli random_beta random_binomial random_bipartite_graph random_cauchy random_chi2 random_continuous_uniform random_digraph random_discrete_uniform random_exp random_f random_gamma random_general_finite_discrete random_geometric random_graph random_graph1 random_gumbel random_hypergeometric random_laplace random_logistic random_lognormal random_negative_binomial random_network random_noncentral_chi2 random_noncentral_student_t random_normal random_pareto random_permutation random_poisson random_rayleigh random_regular_graph random_student_t random_tournament random_tree random_weibull range rank rat ratcoef ratdenom ratdiff ratdisrep ratexpand ratinterpol rational rationalize ratnumer ratnump ratp ratsimp ratsubst ratvars ratweight read read_array read_binary_array read_binary_list read_binary_matrix readbyte readchar read_hashed_array readline read_list read_matrix read_nested_list readonly read_xpm real_imagpart_to_conjugate realpart realroots rearray rectangle rectform rectform_log_if_constant recttopolar rediff reduce_consts reduce_order region region_boundaries region_boundaries_plus rem remainder remarray rembox remcomps remcon remcoord remfun remfunction remlet remove remove_constvalue remove_dimensions remove_edge remove_fundamental_dimensions remove_fundamental_units remove_plot_option remove_vertex rempart remrule remsym remvalue rename rename_file reset reset_displays residue resolvante resolvante_alternee1 resolvante_bipartite resolvante_diedrale resolvante_klein resolvante_klein3 resolvante_produit_sym resolvante_unitaire resolvante_vierer rest resultant return reveal reverse revert revert2 rgb2level rhs ricci riemann rinvariant risch rk rmdir rncombine romberg room rootscontract round row rowop rowswap rreduce run_testsuite %s save saving scalarp scaled_bessel_i scaled_bessel_i0 scaled_bessel_i1 scalefactors scanmap scatterplot scatterplot_description scene schur2comp sconcat scopy scsimp scurvature sdowncase sec sech second sequal sequalignore set_alt_display setdifference set_draw_defaults set_edge_weight setelmx setequalp setify setp set_partitions set_plot_option set_prompt set_random_state set_tex_environment set_tex_environment_default setunits setup_autoload set_up_dot_simplifications set_vertex_label seventh sexplode sf sha1sum sha256sum shortest_path shortest_weighted_path show showcomps showratvars sierpinskiale sierpinskimap sign signum similaritytransform simp_inequality simplify_sum simplode simpmetderiv simtran sin sinh sinsert sinvertcase sixth skewness skewness_bernoulli skewness_beta skewness_binomial skewness_chi2 skewness_continuous_uniform skewness_discrete_uniform skewness_exp skewness_f skewness_gamma skewness_general_finite_discrete skewness_geometric skewness_gumbel skewness_hypergeometric skewness_laplace skewness_logistic skewness_lognormal skewness_negative_binomial skewness_noncentral_chi2 skewness_noncentral_student_t skewness_normal skewness_pareto skewness_poisson skewness_rayleigh skewness_student_t skewness_weibull slength smake small_rhombicosidodecahedron_graph small_rhombicuboctahedron_graph smax smin smismatch snowmap snub_cube_graph snub_dodecahedron_graph solve solve_rec solve_rec_rat some somrac sort sparse6_decode sparse6_encode sparse6_export sparse6_import specint spherical spherical_bessel_j spherical_bessel_y spherical_hankel1 spherical_hankel2 spherical_harmonic spherical_to_xyz splice split sposition sprint sqfr sqrt sqrtdenest sremove sremovefirst sreverse ssearch ssort sstatus ssubst ssubstfirst staircase standardize standardize_inverse_trig starplot starplot_description status std std1 std_bernoulli std_beta std_binomial std_chi2 std_continuous_uniform std_discrete_uniform std_exp std_f std_gamma std_general_finite_discrete std_geometric std_gumbel std_hypergeometric std_laplace std_logistic std_lognormal std_negative_binomial std_noncentral_chi2 std_noncentral_student_t std_normal std_pareto std_poisson std_rayleigh std_student_t std_weibull stemplot stirling stirling1 stirling2 strim striml strimr string stringout stringp strong_components struve_h struve_l sublis sublist sublist_indices submatrix subsample subset subsetp subst substinpart subst_parallel substpart substring subvar subvarp sum sumcontract summand_to_rec supcase supcontext symbolp symmdifference symmetricp system take_channel take_inference tan tanh taylor taylorinfo taylorp taylor_simplifier taytorat tcl_output tcontract tellrat tellsimp tellsimpafter tentex tenth test_mean test_means_difference test_normality test_proportion test_proportions_difference test_rank_sum test_sign test_signed_rank test_variance test_variance_ratio tex tex1 tex_display texput %th third throw time timedate timer timer_info tldefint tlimit todd_coxeter toeplitz tokens to_lisp topological_sort to_poly to_poly_solve totaldisrep totalfourier totient tpartpol trace tracematrix trace_options transform_sample translate translate_file transpose treefale tree_reduce treillis treinat triangle triangularize trigexpand trigrat trigreduce trigsimp trunc truncate truncated_cube_graph truncated_dodecahedron_graph truncated_icosahedron_graph truncated_tetrahedron_graph tr_warnings_get tube tutte_graph ueivects uforget ultraspherical underlying_graph undiff union unique uniteigenvectors unitp units unit_step unitvector unorder unsum untellrat untimer untrace uppercasep uricci uriemann uvect vandermonde_matrix var var1 var_bernoulli var_beta var_binomial var_chi2 var_continuous_uniform var_discrete_uniform var_exp var_f var_gamma var_general_finite_discrete var_geometric var_gumbel var_hypergeometric var_laplace var_logistic var_lognormal var_negative_binomial var_noncentral_chi2 var_noncentral_student_t var_normal var_pareto var_poisson var_rayleigh var_student_t var_weibull vector vectorpotential vectorsimp verbify vers vertex_coloring vertex_connectivity vertex_degree vertex_distance vertex_eccentricity vertex_in_degree vertex_out_degree vertices vertices_to_cycle vertices_to_path %w weyl wheel_graph wiener_index wigner_3j wigner_6j wigner_9j with_stdout write_binary_data writebyte write_data writefile wronskian xreduce xthru %y Zeilberger zeroequiv zerofor zeromatrix zeromatrixp zeta zgeev zheev zlange zn_add_table zn_carmichael_lambda zn_characteristic_factors zn_determinant zn_factor_generators zn_invert_by_lu zn_log zn_mult_table absboxchar activecontexts adapt_depth additive adim aform algebraic algepsilon algexact aliases allbut all_dotsimp_denoms allocation allsym alphabetic animation antisymmetric arrays askexp assume_pos assume_pos_pred assumescalar asymbol atomgrad atrig1 axes axis_3d axis_bottom axis_left axis_right axis_top azimuth background background_color backsubst berlefact bernstein_explicit besselexpand beta_args_sum_to_integer beta_expand bftorat bftrunc bindtest border boundaries_array box boxchar breakup %c capping cauchysum cbrange cbtics center cflength cframe_flag cnonmet_flag color color_bar color_bar_tics colorbox columns commutative complex cone context contexts contour contour_levels cosnpiflag ctaypov ctaypt ctayswitch ctayvar ct_coords ctorsion_flag ctrgsimp cube current_let_rule_package cylinder data_file_name debugmode decreasing default_let_rule_package delay dependencies derivabbrev derivsubst detout diagmetric diff dim dimensions dispflag display2d|10 display_format_internal distribute_over doallmxops domain domxexpt domxmxops domxnctimes dontfactor doscmxops doscmxplus dot0nscsimp dot0simp dot1simp dotassoc dotconstrules dotdistrib dotexptsimp dotident dotscrules draw_graph_program draw_realpart edge_color edge_coloring edge_partition edge_type edge_width %edispflag elevation %emode endphi endtheta engineering_format_floats enhanced3d %enumer epsilon_lp erfflag erf_representation errormsg error_size error_syms error_type %e_to_numlog eval even evenfun evflag evfun ev_point expandwrt_denom expintexpand expintrep expon expop exptdispflag exptisolate exptsubst facexpand facsum_combine factlim factorflag factorial_expand factors_only fb feature features file_name file_output_append file_search_demo file_search_lisp file_search_maxima|10 file_search_tests file_search_usage file_type_lisp file_type_maxima|10 fill_color fill_density filled_func fixed_vertices flipflag float2bf font font_size fortindent fortspaces fpprec fpprintprec functions gamma_expand gammalim gdet genindex gensumnum GGFCFMAX GGFINFINITY globalsolve gnuplot_command gnuplot_curve_styles gnuplot_curve_titles gnuplot_default_term_command gnuplot_dumb_term_command gnuplot_file_args gnuplot_file_name gnuplot_out_file gnuplot_pdf_term_command gnuplot_pm3d gnuplot_png_term_command gnuplot_postamble gnuplot_preamble gnuplot_ps_term_command gnuplot_svg_term_command gnuplot_term gnuplot_view_args Gosper_in_Zeilberger gradefs grid grid2d grind halfangles head_angle head_both head_length head_type height hypergeometric_representation %iargs ibase icc1 icc2 icounter idummyx ieqnprint ifb ifc1 ifc2 ifg ifgi ifr iframe_bracket_form ifri igeowedge_flag ikt1 ikt2 imaginary inchar increasing infeval infinity inflag infolists inm inmc1 inmc2 intanalysis integer integervalued integrate_use_rootsof integration_constant integration_constant_counter interpolate_color intfaclim ip_grid ip_grid_in irrational isolate_wrt_times iterations itr julia_parameter %k1 %k2 keepfloat key key_pos kinvariant kt label label_alignment label_orientation labels lassociative lbfgs_ncorrections lbfgs_nfeval_max leftjust legend letrat let_rule_packages lfg lg lhospitallim limsubst linear linear_solver linechar linel|10 linenum line_type linewidth line_width linsolve_params linsolvewarn lispdisp listarith listconstvars listdummyvars lmxchar load_pathname loadprint logabs logarc logcb logconcoeffp logexpand lognegint logsimp logx logx_secondary logy logy_secondary logz lriem m1pbranch macroexpansion macros mainvar manual_demo maperror mapprint matrix_element_add matrix_element_mult matrix_element_transpose maxapplydepth maxapplyheight maxima_tempdir|10 maxima_userdir|10 maxnegex MAX_ORD maxposex maxpsifracdenom maxpsifracnum maxpsinegint maxpsiposint maxtayorder mesh_lines_color method mod_big_prime mode_check_errorp mode_checkp mode_check_warnp mod_test mod_threshold modular_linear_solver modulus multiplicative multiplicities myoptions nary negdistrib negsumdispflag newline newtonepsilon newtonmaxiter nextlayerfactor niceindicespref nm nmc noeval nolabels nonegative_lp noninteger nonscalar noun noundisp nouns np npi nticks ntrig numer numer_pbranch obase odd oddfun opacity opproperties opsubst optimprefix optionset orientation origin orthopoly_returns_intervals outative outchar packagefile palette partswitch pdf_file pfeformat phiresolution %piargs piece pivot_count_sx pivot_max_sx plot_format plot_options plot_realpart png_file pochhammer_max_index points pointsize point_size points_joined point_type poislim poisson poly_coefficient_ring poly_elimination_order polyfactor poly_grobner_algorithm poly_grobner_debug poly_monomial_order poly_primary_elimination_order poly_return_term_list poly_secondary_elimination_order poly_top_reduction_only posfun position powerdisp pred prederror primep_number_of_tests product_use_gamma program programmode promote_float_to_bigfloat prompt proportional_axes props psexpand ps_file radexpand radius radsubstflag rassociative ratalgdenom ratchristof ratdenomdivide rateinstein ratepsilon ratfac rational ratmx ratprint ratriemann ratsimpexpons ratvarswitch ratweights ratweyl ratwtlvl real realonly redraw refcheck resolution restart resultant ric riem rmxchar %rnum_list rombergabs rombergit rombergmin rombergtol rootsconmode rootsepsilon run_viewer same_xy same_xyz savedef savefactors scalar scalarmatrixp scale scale_lp setcheck setcheckbreak setval show_edge_color show_edges show_edge_type show_edge_width show_id show_label showtime show_vertex_color show_vertex_size show_vertex_type show_vertices show_weight simp simplified_output simplify_products simpproduct simpsum sinnpiflag solvedecomposes solveexplicit solvefactors solvenullwarn solveradcan solvetrigwarn space sparse sphere spring_embedding_depth sqrtdispflag stardisp startphi starttheta stats_numer stringdisp structures style sublis_apply_lambda subnumsimp sumexpand sumsplitfact surface surface_hide svg_file symmetric tab taylordepth taylor_logexpand taylor_order_coefficients taylor_truncate_polynomials tensorkill terminal testsuite_files thetaresolution timer_devalue title tlimswitch tr track transcompile transform transform_xy translate_fast_arrays transparent transrun tr_array_as_ref tr_bound_function_applyp tr_file_tty_messagesp tr_float_can_branch_complex tr_function_call_default trigexpandplus trigexpandtimes triginverses trigsign trivial_solutions tr_numer tr_optimize_max_loop tr_semicompile tr_state_vars tr_warn_bad_function_calls tr_warn_fexpr tr_warn_meval tr_warn_mode tr_warn_undeclared tr_warn_undefined_variable tstep ttyoff tube_extremes ufg ug %unitexpand unit_vectors uric uriem use_fast_arrays user_preamble usersetunits values vect_cross verbose vertex_color vertex_coloring vertex_partition vertex_size vertex_type view warnings weyl width windowname windowtitle wired_surface wireframe xaxis xaxis_color xaxis_secondary xaxis_type xaxis_width xlabel xlabel_secondary xlength xrange xrange_secondary xtics xtics_axis xtics_rotate xtics_rotate_secondary xtics_secondary xtics_secondary_axis xu_grid x_voxel xy_file xyplane xy_scale yaxis yaxis_color yaxis_secondary yaxis_type yaxis_width ylabel ylabel_secondary ylength yrange yrange_secondary ytics ytics_axis ytics_rotate ytics_rotate_secondary ytics_secondary ytics_secondary_axis yv_grid y_voxel yx_ratio zaxis zaxis_color zaxis_type zaxis_width zeroa zerob zerobern zeta%pi zlabel zlabel_rotate zlength zmin zn_primroot_limit zn_primroot_pretest",
                symbol: "_ __ %|0 %%|0"
            },
            contains: [
                {
                    className: "comment",
                    begin: "/\\*",
                    end: "\\*/",
                    contains: [
                        "self"
                    ]
                },
                e.QUOTE_STRING_MODE,
                {
                    className: "number",
                    relevance: 0,
                    variants: [
                        {
                            begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Ee][-+]?\\d+\\b"
                        },
                        {
                            begin: "\\b(\\d+|\\d+\\.|\\.\\d+|\\d+\\.\\d+)[Bb][-+]?\\d+\\b",
                            relevance: 10
                        },
                        {
                            begin: "\\b(\\.\\d+|\\d+\\.\\d+)\\b"
                        },
                        {
                            begin: "\\b(\\d+|0[0-9A-Za-z]+)\\.?\\b"
                        }
                    ]
                }
            ],
            illegal: /@/
        };
    }), _i)), Cs.registerLanguage("mel", (pi || (pi = 1, mi = function(e) {
        return {
            name: "MEL",
            keywords: "int float string vector matrix if else switch case default while do for in break continue global proc return about abs addAttr addAttributeEditorNodeHelp addDynamic addNewShelfTab addPP addPanelCategory addPrefixToName advanceToNextDrivenKey affectedNet affects aimConstraint air alias aliasAttr align alignCtx alignCurve alignSurface allViewFit ambientLight angle angleBetween animCone animCurveEditor animDisplay animView annotate appendStringArray applicationName applyAttrPreset applyTake arcLenDimContext arcLengthDimension arclen arrayMapper art3dPaintCtx artAttrCtx artAttrPaintVertexCtx artAttrSkinPaintCtx artAttrTool artBuildPaintMenu artFluidAttrCtx artPuttyCtx artSelectCtx artSetPaintCtx artUserPaintCtx assignCommand assignInputDevice assignViewportFactories attachCurve attachDeviceAttr attachSurface attrColorSliderGrp attrCompatibility attrControlGrp attrEnumOptionMenu attrEnumOptionMenuGrp attrFieldGrp attrFieldSliderGrp attrNavigationControlGrp attrPresetEditWin attributeExists attributeInfo attributeMenu attributeQuery autoKeyframe autoPlace bakeClip bakeFluidShading bakePartialHistory bakeResults bakeSimulation basename basenameEx batchRender bessel bevel bevelPlus binMembership bindSkin blend2 blendShape blendShapeEditor blendShapePanel blendTwoAttr blindDataType boneLattice boundary boxDollyCtx boxZoomCtx bufferCurve buildBookmarkMenu buildKeyframeMenu button buttonManip CBG cacheFile cacheFileCombine cacheFileMerge cacheFileTrack camera cameraView canCreateManip canvas capitalizeString catch catchQuiet ceil changeSubdivComponentDisplayLevel changeSubdivRegion channelBox character characterMap characterOutlineEditor characterize chdir checkBox checkBoxGrp checkDefaultRenderGlobals choice circle circularFillet clamp clear clearCache clip clipEditor clipEditorCurrentTimeCtx clipSchedule clipSchedulerOutliner clipTrimBefore closeCurve closeSurface cluster cmdFileOutput cmdScrollFieldExecuter cmdScrollFieldReporter cmdShell coarsenSubdivSelectionList collision color colorAtPoint colorEditor colorIndex colorIndexSliderGrp colorSliderButtonGrp colorSliderGrp columnLayout commandEcho commandLine commandPort compactHairSystem componentEditor compositingInterop computePolysetVolume condition cone confirmDialog connectAttr connectControl connectDynamic connectJoint connectionInfo constrain constrainValue constructionHistory container containsMultibyte contextInfo control convertFromOldLayers convertIffToPsd convertLightmap convertSolidTx convertTessellation convertUnit copyArray copyFlexor copyKey copySkinWeights cos cpButton cpCache cpClothSet cpCollision cpConstraint cpConvClothToMesh cpForces cpGetSolverAttr cpPanel cpProperty cpRigidCollisionFilter cpSeam cpSetEdit cpSetSolverAttr cpSolver cpSolverTypes cpTool cpUpdateClothUVs createDisplayLayer createDrawCtx createEditor createLayeredPsdFile createMotionField createNewShelf createNode createRenderLayer createSubdivRegion cross crossProduct ctxAbort ctxCompletion ctxEditMode ctxTraverse currentCtx currentTime currentTimeCtx currentUnit curve curveAddPtCtx curveCVCtx curveEPCtx curveEditorCtx curveIntersect curveMoveEPCtx curveOnSurface curveSketchCtx cutKey cycleCheck cylinder dagPose date defaultLightListCheckBox defaultNavigation defineDataServer defineVirtualDevice deformer deg_to_rad delete deleteAttr deleteShadingGroupsAndMaterials deleteShelfTab deleteUI deleteUnusedBrushes delrandstr detachCurve detachDeviceAttr detachSurface deviceEditor devicePanel dgInfo dgdirty dgeval dgtimer dimWhen directKeyCtx directionalLight dirmap dirname disable disconnectAttr disconnectJoint diskCache displacementToPoly displayAffected displayColor displayCull displayLevelOfDetail displayPref displayRGBColor displaySmoothness displayStats displayString displaySurface distanceDimContext distanceDimension doBlur dolly dollyCtx dopeSheetEditor dot dotProduct doubleProfileBirailSurface drag dragAttrContext draggerContext dropoffLocator duplicate duplicateCurve duplicateSurface dynCache dynControl dynExport dynExpression dynGlobals dynPaintEditor dynParticleCtx dynPref dynRelEdPanel dynRelEditor dynamicLoad editAttrLimits editDisplayLayerGlobals editDisplayLayerMembers editRenderLayerAdjustment editRenderLayerGlobals editRenderLayerMembers editor editorTemplate effector emit emitter enableDevice encodeString endString endsWith env equivalent equivalentTol erf error eval evalDeferred evalEcho event exactWorldBoundingBox exclusiveLightCheckBox exec executeForEachObject exists exp expression expressionEditorListen extendCurve extendSurface extrude fcheck fclose feof fflush fgetline fgetword file fileBrowserDialog fileDialog fileExtension fileInfo filetest filletCurve filter filterCurve filterExpand filterStudioImport findAllIntersections findAnimCurves findKeyframe findMenuItem findRelatedSkinCluster finder firstParentOf fitBspline flexor floatEq floatField floatFieldGrp floatScrollBar floatSlider floatSlider2 floatSliderButtonGrp floatSliderGrp floor flow fluidCacheInfo fluidEmitter fluidVoxelInfo flushUndo fmod fontDialog fopen formLayout format fprint frameLayout fread freeFormFillet frewind fromNativePath fwrite gamma gauss geometryConstraint getApplicationVersionAsFloat getAttr getClassification getDefaultBrush getFileList getFluidAttr getInputDeviceRange getMayaPanelTypes getModifiers getPanel getParticleAttr getPluginResource getenv getpid glRender glRenderEditor globalStitch gmatch goal gotoBindPose grabColor gradientControl gradientControlNoAttr graphDollyCtx graphSelectContext graphTrackCtx gravity grid gridLayout group groupObjectsByName HfAddAttractorToAS HfAssignAS HfBuildEqualMap HfBuildFurFiles HfBuildFurImages HfCancelAFR HfConnectASToHF HfCreateAttractor HfDeleteAS HfEditAS HfPerformCreateAS HfRemoveAttractorFromAS HfSelectAttached HfSelectAttractors HfUnAssignAS hardenPointCurve hardware hardwareRenderPanel headsUpDisplay headsUpMessage help helpLine hermite hide hilite hitTest hotBox hotkey hotkeyCheck hsv_to_rgb hudButton hudSlider hudSliderButton hwReflectionMap hwRender hwRenderLoad hyperGraph hyperPanel hyperShade hypot iconTextButton iconTextCheckBox iconTextRadioButton iconTextRadioCollection iconTextScrollList iconTextStaticLabel ikHandle ikHandleCtx ikHandleDisplayScale ikSolver ikSplineHandleCtx ikSystem ikSystemInfo ikfkDisplayMethod illustratorCurves image imfPlugins inheritTransform insertJoint insertJointCtx insertKeyCtx insertKnotCurve insertKnotSurface instance instanceable instancer intField intFieldGrp intScrollBar intSlider intSliderGrp interToUI internalVar intersect iprEngine isAnimCurve isConnected isDirty isParentOf isSameObject isTrue isValidObjectName isValidString isValidUiName isolateSelect itemFilter itemFilterAttr itemFilterRender itemFilterType joint jointCluster jointCtx jointDisplayScale jointLattice keyTangent keyframe keyframeOutliner keyframeRegionCurrentTimeCtx keyframeRegionDirectKeyCtx keyframeRegionDollyCtx keyframeRegionInsertKeyCtx keyframeRegionMoveKeyCtx keyframeRegionScaleKeyCtx keyframeRegionSelectKeyCtx keyframeRegionSetKeyCtx keyframeRegionTrackCtx keyframeStats lassoContext lattice latticeDeformKeyCtx launch launchImageEditor layerButton layeredShaderPort layeredTexturePort layout layoutDialog lightList lightListEditor lightListPanel lightlink lineIntersection linearPrecision linstep listAnimatable listAttr listCameras listConnections listDeviceAttachments listHistory listInputDeviceAxes listInputDeviceButtons listInputDevices listMenuAnnotation listNodeTypes listPanelCategories listRelatives listSets listTransforms listUnselected listerEditor loadFluid loadNewShelf loadPlugin loadPluginLanguageResources loadPrefObjects localizedPanelLabel lockNode loft log longNameOf lookThru ls lsThroughFilter lsType lsUI Mayatomr mag makeIdentity makeLive makePaintable makeRoll makeSingleSurface makeTubeOn makebot manipMoveContext manipMoveLimitsCtx manipOptions manipRotateContext manipRotateLimitsCtx manipScaleContext manipScaleLimitsCtx marker match max memory menu menuBarLayout menuEditor menuItem menuItemToShelf menuSet menuSetPref messageLine min minimizeApp mirrorJoint modelCurrentTimeCtx modelEditor modelPanel mouse movIn movOut move moveIKtoFK moveKeyCtx moveVertexAlongDirection multiProfileBirailSurface mute nParticle nameCommand nameField namespace namespaceInfo newPanelItems newton nodeCast nodeIconButton nodeOutliner nodePreset nodeType noise nonLinear normalConstraint normalize nurbsBoolean nurbsCopyUVSet nurbsCube nurbsEditUV nurbsPlane nurbsSelect nurbsSquare nurbsToPoly nurbsToPolygonsPref nurbsToSubdiv nurbsToSubdivPref nurbsUVSet nurbsViewDirectionVector objExists objectCenter objectLayer objectType objectTypeUI obsoleteProc oceanNurbsPreviewPlane offsetCurve offsetCurveOnSurface offsetSurface openGLExtension openMayaPref optionMenu optionMenuGrp optionVar orbit orbitCtx orientConstraint outlinerEditor outlinerPanel overrideModifier paintEffectsDisplay pairBlend palettePort paneLayout panel panelConfiguration panelHistory paramDimContext paramDimension paramLocator parent parentConstraint particle particleExists particleInstancer particleRenderInfo partition pasteKey pathAnimation pause pclose percent performanceOptions pfxstrokes pickWalk picture pixelMove planarSrf plane play playbackOptions playblast plugAttr plugNode pluginInfo pluginResourceUtil pointConstraint pointCurveConstraint pointLight pointMatrixMult pointOnCurve pointOnSurface pointPosition poleVectorConstraint polyAppend polyAppendFacetCtx polyAppendVertex polyAutoProjection polyAverageNormal polyAverageVertex polyBevel polyBlendColor polyBlindData polyBoolOp polyBridgeEdge polyCacheMonitor polyCheck polyChipOff polyClipboard polyCloseBorder polyCollapseEdge polyCollapseFacet polyColorBlindData polyColorDel polyColorPerVertex polyColorSet polyCompare polyCone polyCopyUV polyCrease polyCreaseCtx polyCreateFacet polyCreateFacetCtx polyCube polyCut polyCutCtx polyCylinder polyCylindricalProjection polyDelEdge polyDelFacet polyDelVertex polyDuplicateAndConnect polyDuplicateEdge polyEditUV polyEditUVShell polyEvaluate polyExtrudeEdge polyExtrudeFacet polyExtrudeVertex polyFlipEdge polyFlipUV polyForceUV polyGeoSampler polyHelix polyInfo polyInstallAction polyLayoutUV polyListComponentConversion polyMapCut polyMapDel polyMapSew polyMapSewMove polyMergeEdge polyMergeEdgeCtx polyMergeFacet polyMergeFacetCtx polyMergeUV polyMergeVertex polyMirrorFace polyMoveEdge polyMoveFacet polyMoveFacetUV polyMoveUV polyMoveVertex polyNormal polyNormalPerVertex polyNormalizeUV polyOptUvs polyOptions polyOutput polyPipe polyPlanarProjection polyPlane polyPlatonicSolid polyPoke polyPrimitive polyPrism polyProjection polyPyramid polyQuad polyQueryBlindData polyReduce polySelect polySelectConstraint polySelectConstraintMonitor polySelectCtx polySelectEditCtx polySeparate polySetToFaceNormal polySewEdge polyShortestPathCtx polySmooth polySoftEdge polySphere polySphericalProjection polySplit polySplitCtx polySplitEdge polySplitRing polySplitVertex polyStraightenUVBorder polySubdivideEdge polySubdivideFacet polyToSubdiv polyTorus polyTransfer polyTriangulate polyUVSet polyUnite polyWedgeFace popen popupMenu pose pow preloadRefEd print progressBar progressWindow projFileViewer projectCurve projectTangent projectionContext projectionManip promptDialog propModCtx propMove psdChannelOutliner psdEditTextureFile psdExport psdTextureFile putenv pwd python querySubdiv quit rad_to_deg radial radioButton radioButtonGrp radioCollection radioMenuItemCollection rampColorPort rand randomizeFollicles randstate rangeControl readTake rebuildCurve rebuildSurface recordAttr recordDevice redo reference referenceEdit referenceQuery refineSubdivSelectionList refresh refreshAE registerPluginResource rehash reloadImage removeJoint removeMultiInstance removePanelCategory rename renameAttr renameSelectionList renameUI render renderGlobalsNode renderInfo renderLayerButton renderLayerParent renderLayerPostProcess renderLayerUnparent renderManip renderPartition renderQualityNode renderSettings renderThumbnailUpdate renderWindowEditor renderWindowSelectContext renderer reorder reorderDeformers requires reroot resampleFluid resetAE resetPfxToPolyCamera resetTool resolutionNode retarget reverseCurve reverseSurface revolve rgb_to_hsv rigidBody rigidSolver roll rollCtx rootOf rot rotate rotationInterpolation roundConstantRadius rowColumnLayout rowLayout runTimeCommand runup sampleImage saveAllShelves saveAttrPreset saveFluid saveImage saveInitialState saveMenu savePrefObjects savePrefs saveShelf saveToolSettings scale scaleBrushBrightness scaleComponents scaleConstraint scaleKey scaleKeyCtx sceneEditor sceneUIReplacement scmh scriptCtx scriptEditorInfo scriptJob scriptNode scriptTable scriptToShelf scriptedPanel scriptedPanelType scrollField scrollLayout sculpt searchPathArray seed selLoadSettings select selectContext selectCurveCV selectKey selectKeyCtx selectKeyframeRegionCtx selectMode selectPref selectPriority selectType selectedNodes selectionConnection separator setAttr setAttrEnumResource setAttrMapping setAttrNiceNameResource setConstraintRestPosition setDefaultShadingGroup setDrivenKeyframe setDynamic setEditCtx setEditor setFluidAttr setFocus setInfinity setInputDeviceMapping setKeyCtx setKeyPath setKeyframe setKeyframeBlendshapeTargetWts setMenuMode setNodeNiceNameResource setNodeTypeFlag setParent setParticleAttr setPfxToPolyCamera setPluginResource setProject setStampDensity setStartupMessage setState setToolTo setUITemplate setXformManip sets shadingConnection shadingGeometryRelCtx shadingLightRelCtx shadingNetworkCompare shadingNode shapeCompare shelfButton shelfLayout shelfTabLayout shellField shortNameOf showHelp showHidden showManipCtx showSelectionInTitle showShadingGroupAttrEditor showWindow sign simplify sin singleProfileBirailSurface size sizeBytes skinCluster skinPercent smoothCurve smoothTangentSurface smoothstep snap2to2 snapKey snapMode snapTogetherCtx snapshot soft softMod softModCtx sort sound soundControl source spaceLocator sphere sphrand spotLight spotLightPreviewPort spreadSheetEditor spring sqrt squareSurface srtContext stackTrace startString startsWith stitchAndExplodeShell stitchSurface stitchSurfacePoints strcmp stringArrayCatenate stringArrayContains stringArrayCount stringArrayInsertAtIndex stringArrayIntersector stringArrayRemove stringArrayRemoveAtIndex stringArrayRemoveDuplicates stringArrayRemoveExact stringArrayToString stringToStringArray strip stripPrefixFromName stroke subdAutoProjection subdCleanTopology subdCollapse subdDuplicateAndConnect subdEditUV subdListComponentConversion subdMapCut subdMapSewMove subdMatchTopology subdMirror subdToBlind subdToPoly subdTransferUVsToCache subdiv subdivCrease subdivDisplaySmoothness substitute substituteAllString substituteGeometry substring surface surfaceSampler surfaceShaderList swatchDisplayPort switchTable symbolButton symbolCheckBox sysFile system tabLayout tan tangentConstraint texLatticeDeformContext texManipContext texMoveContext texMoveUVShellContext texRotateContext texScaleContext texSelectContext texSelectShortestPathCtx texSmudgeUVContext texWinToolCtx text textCurves textField textFieldButtonGrp textFieldGrp textManip textScrollList textToShelf textureDisplacePlane textureHairColor texturePlacementContext textureWindow threadCount threePointArcCtx timeControl timePort timerX toNativePath toggle toggleAxis toggleWindowVisibility tokenize tokenizeList tolerance tolower toolButton toolCollection toolDropped toolHasOptions toolPropertyWindow torus toupper trace track trackCtx transferAttributes transformCompare transformLimits translator trim trunc truncateFluidCache truncateHairCache tumble tumbleCtx turbulence twoPointArcCtx uiRes uiTemplate unassignInputDevice undo undoInfo ungroup uniform unit unloadPlugin untangleUV untitledFileName untrim upAxis updateAE userCtx uvLink uvSnapshot validateShelfName vectorize view2dToolCtx viewCamera viewClipPlane viewFit viewHeadOn viewLookAt viewManip viewPlace viewSet visor volumeAxis vortex waitCursor warning webBrowser webBrowserPrefs whatIs window windowPref wire wireContext workspace wrinkle wrinkleContext writeTake xbmLangPathList xform",
            illegal: "</",
            contains: [
                e.C_NUMBER_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    begin: "`",
                    end: "`",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /[$%@](\^\w\b|#\w+|[^\s\w{]|\{\w+\}|\w+)/
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE
            ]
        };
    }), mi)), Cs.registerLanguage("mercury", (gi || (gi = 1, ui = function(e) {
        const t = e.COMMENT("%", "$"), a = e.inherit(e.APOS_STRING_MODE, {
            relevance: 0
        }), n = e.inherit(e.QUOTE_STRING_MODE, {
            relevance: 0
        });
        return n.contains = n.contains.slice(), n.contains.push({
            className: "subst",
            begin: "\\\\[abfnrtv]\\|\\\\x[0-9a-fA-F]*\\\\\\|%[-+# *.0-9]*[dioxXucsfeEgGp]",
            relevance: 0
        }), {
            name: "Mercury",
            aliases: [
                "m",
                "moo"
            ],
            keywords: {
                keyword: "module use_module import_module include_module end_module initialise mutable initialize finalize finalise interface implementation pred mode func type inst solver any_pred any_func is semidet det nondet multi erroneous failure cc_nondet cc_multi typeclass instance where pragma promise external trace atomic or_else require_complete_switch require_det require_semidet require_multi require_nondet require_cc_multi require_cc_nondet require_erroneous require_failure",
                meta: "inline no_inline type_spec source_file fact_table obsolete memo loop_check minimal_model terminates does_not_terminate check_termination promise_equivalent_clauses foreign_proc foreign_decl foreign_code foreign_type foreign_import_module foreign_export_enum foreign_export foreign_enum may_call_mercury will_not_call_mercury thread_safe not_thread_safe maybe_thread_safe promise_pure promise_semipure tabled_for_io local untrailed trailed attach_to_io_state can_pass_as_mercury_type stable will_not_throw_exception may_modify_trail will_not_modify_trail may_duplicate may_not_duplicate affects_liveness does_not_affect_liveness doesnt_affect_liveness no_sharing unknown_sharing sharing",
                built_in: "some all not if then else true fail false try catch catch_any semidet_true semidet_false semidet_fail impure_true impure semipure"
            },
            contains: [
                {
                    className: "built_in",
                    variants: [
                        {
                            begin: "<=>"
                        },
                        {
                            begin: "<=",
                            relevance: 0
                        },
                        {
                            begin: "=>",
                            relevance: 0
                        },
                        {
                            begin: "/\\\\"
                        },
                        {
                            begin: "\\\\/"
                        }
                    ]
                },
                {
                    className: "built_in",
                    variants: [
                        {
                            begin: ":-\\|--\x3e"
                        },
                        {
                            begin: "=",
                            relevance: 0
                        }
                    ]
                },
                t,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "number",
                    begin: "0'.\\|0[box][0-9a-fA-F]*"
                },
                e.NUMBER_MODE,
                a,
                n,
                {
                    begin: /:-/
                },
                {
                    begin: /\.$/
                }
            ]
        };
    }), ui)), Cs.registerLanguage("mipsasm", (Si || (Si = 1, Ei = function(e) {
        return {
            name: "MIPS Assembly",
            case_insensitive: !0,
            aliases: [
                "mips"
            ],
            keywords: {
                $pattern: "\\.?" + e.IDENT_RE,
                meta: ".2byte .4byte .align .ascii .asciz .balign .byte .code .data .else .end .endif .endm .endr .equ .err .exitm .extern .global .hword .if .ifdef .ifndef .include .irp .long .macro .rept .req .section .set .skip .space .text .word .ltorg ",
                built_in: "$0 $1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11 $12 $13 $14 $15 $16 $17 $18 $19 $20 $21 $22 $23 $24 $25 $26 $27 $28 $29 $30 $31 zero at v0 v1 a0 a1 a2 a3 a4 a5 a6 a7 t0 t1 t2 t3 t4 t5 t6 t7 t8 t9 s0 s1 s2 s3 s4 s5 s6 s7 s8 k0 k1 gp sp fp ra $f0 $f1 $f2 $f2 $f4 $f5 $f6 $f7 $f8 $f9 $f10 $f11 $f12 $f13 $f14 $f15 $f16 $f17 $f18 $f19 $f20 $f21 $f22 $f23 $f24 $f25 $f26 $f27 $f28 $f29 $f30 $f31 Context Random EntryLo0 EntryLo1 Context PageMask Wired EntryHi HWREna BadVAddr Count Compare SR IntCtl SRSCtl SRSMap Cause EPC PRId EBase Config Config1 Config2 Config3 LLAddr Debug DEPC DESAVE CacheErr ECC ErrorEPC TagLo DataLo TagHi DataHi WatchLo WatchHi PerfCtl PerfCnt "
            },
            contains: [
                {
                    className: "keyword",
                    begin: "\\b(addi?u?|andi?|b(al)?|beql?|bgez(al)?l?|bgtzl?|blezl?|bltz(al)?l?|bnel?|cl[oz]|divu?|ext|ins|j(al)?|jalr(\\.hb)?|jr(\\.hb)?|lbu?|lhu?|ll|lui|lw[lr]?|maddu?|mfhi|mflo|movn|movz|move|msubu?|mthi|mtlo|mul|multu?|nop|nor|ori?|rotrv?|sb|sc|se[bh]|sh|sllv?|slti?u?|srav?|srlv?|subu?|sw[lr]?|xori?|wsbh|abs\\.[sd]|add\\.[sd]|alnv.ps|bc1[ft]l?|c\\.(s?f|un|u?eq|[ou]lt|[ou]le|ngle?|seq|l[et]|ng[et])\\.[sd]|(ceil|floor|round|trunc)\\.[lw]\\.[sd]|cfc1|cvt\\.d\\.[lsw]|cvt\\.l\\.[dsw]|cvt\\.ps\\.s|cvt\\.s\\.[dlw]|cvt\\.s\\.p[lu]|cvt\\.w\\.[dls]|div\\.[ds]|ldx?c1|luxc1|lwx?c1|madd\\.[sd]|mfc1|mov[fntz]?\\.[ds]|msub\\.[sd]|mth?c1|mul\\.[ds]|neg\\.[ds]|nmadd\\.[ds]|nmsub\\.[ds]|p[lu][lu]\\.ps|recip\\.fmt|r?sqrt\\.[ds]|sdx?c1|sub\\.[ds]|suxc1|swx?c1|break|cache|d?eret|[de]i|ehb|mfc0|mtc0|pause|prefx?|rdhwr|rdpgpr|sdbbp|ssnop|synci?|syscall|teqi?|tgei?u?|tlb(p|r|w[ir])|tlti?u?|tnei?|wait|wrpgpr)",
                    end: "\\s"
                },
                e.COMMENT("[;#](?!\\s*$)", "$"),
                e.C_BLOCK_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    begin: "'",
                    end: "[^\\\\]'",
                    relevance: 0
                },
                {
                    className: "title",
                    begin: "\\|",
                    end: "\\|",
                    illegal: "\\n",
                    relevance: 0
                },
                {
                    className: "number",
                    variants: [
                        {
                            begin: "0x[0-9a-f]+"
                        },
                        {
                            begin: "\\b-?\\d+"
                        }
                    ],
                    relevance: 0
                },
                {
                    className: "symbol",
                    variants: [
                        {
                            begin: "^\\s*[a-z_\\.\\$][a-z0-9_\\.\\$]+:"
                        },
                        {
                            begin: "^\\s*[0-9]+:"
                        },
                        {
                            begin: "[0-9]+[bf]"
                        }
                    ],
                    relevance: 0
                }
            ],
            illegal: /\//
        };
    }), Ei)), Cs.registerLanguage("mizar", (Ti || (Ti = 1, bi = function(e) {
        return {
            name: "Mizar",
            keywords: "environ vocabularies notations constructors definitions registrations theorems schemes requirements begin end definition registration cluster existence pred func defpred deffunc theorem proof let take assume then thus hence ex for st holds consider reconsider such that and in provided of as from be being by means equals implies iff redefine define now not or attr is mode suppose per cases set thesis contradiction scheme reserve struct correctness compatibility coherence symmetry assymetry reflexivity irreflexivity connectedness uniqueness commutativity idempotence involutiveness projectivity",
            contains: [
                e.COMMENT("::", "$")
            ]
        };
    }), bi)), Cs.registerLanguage("perl", (fi || (fi = 1, Ci = function(e) {
        const t = e.regex, a = /[dualxmsipngr]{0,12}/, n = {
            $pattern: /[\w.]+/,
            keyword: [
                "abs",
                "accept",
                "alarm",
                "and",
                "atan2",
                "bind",
                "binmode",
                "bless",
                "break",
                "caller",
                "chdir",
                "chmod",
                "chomp",
                "chop",
                "chown",
                "chr",
                "chroot",
                "close",
                "closedir",
                "connect",
                "continue",
                "cos",
                "crypt",
                "dbmclose",
                "dbmopen",
                "defined",
                "delete",
                "die",
                "do",
                "dump",
                "each",
                "else",
                "elsif",
                "endgrent",
                "endhostent",
                "endnetent",
                "endprotoent",
                "endpwent",
                "endservent",
                "eof",
                "eval",
                "exec",
                "exists",
                "exit",
                "exp",
                "fcntl",
                "fileno",
                "flock",
                "for",
                "foreach",
                "fork",
                "format",
                "formline",
                "getc",
                "getgrent",
                "getgrgid",
                "getgrnam",
                "gethostbyaddr",
                "gethostbyname",
                "gethostent",
                "getlogin",
                "getnetbyaddr",
                "getnetbyname",
                "getnetent",
                "getpeername",
                "getpgrp",
                "getpriority",
                "getprotobyname",
                "getprotobynumber",
                "getprotoent",
                "getpwent",
                "getpwnam",
                "getpwuid",
                "getservbyname",
                "getservbyport",
                "getservent",
                "getsockname",
                "getsockopt",
                "given",
                "glob",
                "gmtime",
                "goto",
                "grep",
                "gt",
                "hex",
                "if",
                "index",
                "int",
                "ioctl",
                "join",
                "keys",
                "kill",
                "last",
                "lc",
                "lcfirst",
                "length",
                "link",
                "listen",
                "local",
                "localtime",
                "log",
                "lstat",
                "lt",
                "ma",
                "map",
                "mkdir",
                "msgctl",
                "msgget",
                "msgrcv",
                "msgsnd",
                "my",
                "ne",
                "next",
                "no",
                "not",
                "oct",
                "open",
                "opendir",
                "or",
                "ord",
                "our",
                "pack",
                "package",
                "pipe",
                "pop",
                "pos",
                "print",
                "printf",
                "prototype",
                "push",
                "q|0",
                "qq",
                "quotemeta",
                "qw",
                "qx",
                "rand",
                "read",
                "readdir",
                "readline",
                "readlink",
                "readpipe",
                "recv",
                "redo",
                "ref",
                "rename",
                "require",
                "reset",
                "return",
                "reverse",
                "rewinddir",
                "rindex",
                "rmdir",
                "say",
                "scalar",
                "seek",
                "seekdir",
                "select",
                "semctl",
                "semget",
                "semop",
                "send",
                "setgrent",
                "sethostent",
                "setnetent",
                "setpgrp",
                "setpriority",
                "setprotoent",
                "setpwent",
                "setservent",
                "setsockopt",
                "shift",
                "shmctl",
                "shmget",
                "shmread",
                "shmwrite",
                "shutdown",
                "sin",
                "sleep",
                "socket",
                "socketpair",
                "sort",
                "splice",
                "split",
                "sprintf",
                "sqrt",
                "srand",
                "stat",
                "state",
                "study",
                "sub",
                "substr",
                "symlink",
                "syscall",
                "sysopen",
                "sysread",
                "sysseek",
                "system",
                "syswrite",
                "tell",
                "telldir",
                "tie",
                "tied",
                "time",
                "times",
                "tr",
                "truncate",
                "uc",
                "ucfirst",
                "umask",
                "undef",
                "unless",
                "unlink",
                "unpack",
                "unshift",
                "untie",
                "until",
                "use",
                "utime",
                "values",
                "vec",
                "wait",
                "waitpid",
                "wantarray",
                "warn",
                "when",
                "while",
                "write",
                "x|0",
                "xor",
                "y|0"
            ].join(" ")
        }, i = {
            className: "subst",
            begin: "[$@]\\{",
            end: "\\}",
            keywords: n
        }, r = {
            begin: /->\{/,
            end: /\}/
        }, o = {
            variants: [
                {
                    begin: /\$\d/
                },
                {
                    begin: t.concat(/[$%@](\^\w\b|#\w+(::\w+)*|\{\w+\}|\w+(::\w*)*)/, "(?![A-Za-z])(?![@$%])")
                },
                {
                    begin: /[$%@][^\s\w{]/,
                    relevance: 0
                }
            ]
        }, s = [
            e.BACKSLASH_ESCAPE,
            i,
            o
        ], l = [
            /!/,
            /\//,
            /\|/,
            /\?/,
            /'/,
            /"/,
            /#/
        ], c = (e, n, i = "\\1")=>{
            const r = "\\1" === i ? i : t.concat(i, n);
            return t.concat(t.concat("(?:", e, ")"), n, /(?:\\.|[^\\\/])*?/, r, /(?:\\.|[^\\\/])*?/, i, a);
        }, _ = (e, n, i)=>t.concat(t.concat("(?:", e, ")"), n, /(?:\\.|[^\\\/])*?/, i, a), d = [
            o,
            e.HASH_COMMENT_MODE,
            e.COMMENT(/^=\w/, /=cut/, {
                endsWithParent: !0
            }),
            r,
            {
                className: "string",
                contains: s,
                variants: [
                    {
                        begin: "q[qwxr]?\\s*\\(",
                        end: "\\)",
                        relevance: 5
                    },
                    {
                        begin: "q[qwxr]?\\s*\\[",
                        end: "\\]",
                        relevance: 5
                    },
                    {
                        begin: "q[qwxr]?\\s*\\{",
                        end: "\\}",
                        relevance: 5
                    },
                    {
                        begin: "q[qwxr]?\\s*\\|",
                        end: "\\|",
                        relevance: 5
                    },
                    {
                        begin: "q[qwxr]?\\s*<",
                        end: ">",
                        relevance: 5
                    },
                    {
                        begin: "qw\\s+q",
                        end: "q",
                        relevance: 5
                    },
                    {
                        begin: "'",
                        end: "'",
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: '"',
                        end: '"'
                    },
                    {
                        begin: "`",
                        end: "`",
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: /\{\w+\}/,
                        relevance: 0
                    },
                    {
                        begin: "-?\\w+\\s*=>",
                        relevance: 0
                    }
                ]
            },
            {
                className: "number",
                begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
                relevance: 0
            },
            {
                begin: "(\\/\\/|" + e.RE_STARTERS_RE + "|\\b(split|return|print|reverse|grep)\\b)\\s*",
                keywords: "split return print reverse grep",
                relevance: 0,
                contains: [
                    e.HASH_COMMENT_MODE,
                    {
                        className: "regexp",
                        variants: [
                            {
                                begin: c("s|tr|y", t.either(...l, {
                                    capture: !0
                                }))
                            },
                            {
                                begin: c("s|tr|y", "\\(", "\\)")
                            },
                            {
                                begin: c("s|tr|y", "\\[", "\\]")
                            },
                            {
                                begin: c("s|tr|y", "\\{", "\\}")
                            }
                        ],
                        relevance: 2
                    },
                    {
                        className: "regexp",
                        variants: [
                            {
                                begin: /(m|qr)\/\//,
                                relevance: 0
                            },
                            {
                                begin: _("(?:m|qr)?", /\//, /\//)
                            },
                            {
                                begin: _("m|qr", t.either(...l, {
                                    capture: !0
                                }), /\1/)
                            },
                            {
                                begin: _("m|qr", /\(/, /\)/)
                            },
                            {
                                begin: _("m|qr", /\[/, /\]/)
                            },
                            {
                                begin: _("m|qr", /\{/, /\}/)
                            }
                        ]
                    }
                ]
            },
            {
                className: "function",
                beginKeywords: "sub",
                end: "(\\s*\\(.*?\\))?[;{]",
                excludeEnd: !0,
                relevance: 5,
                contains: [
                    e.TITLE_MODE
                ]
            },
            {
                begin: "-\\w\\b",
                relevance: 0
            },
            {
                begin: "^__DATA__$",
                end: "^__END__$",
                subLanguage: "mojolicious",
                contains: [
                    {
                        begin: "^@@.*",
                        end: "$",
                        className: "comment"
                    }
                ]
            }
        ];
        return i.contains = d, r.contains = d, {
            name: "Perl",
            aliases: [
                "pl",
                "pm"
            ],
            keywords: n,
            contains: d
        };
    }), Ci)), Cs.registerLanguage("mojolicious", Ni ? Ri : (Ni = 1, Ri = function(e) {
        return {
            name: "Mojolicious",
            subLanguage: "xml",
            contains: [
                {
                    className: "meta",
                    begin: "^__(END|DATA)__$"
                },
                {
                    begin: "^\\s*%{1,2}={0,2}",
                    end: "$",
                    subLanguage: "perl"
                },
                {
                    begin: "<%{1,2}={0,2}",
                    end: "={0,1}%>",
                    subLanguage: "perl",
                    excludeBegin: !0,
                    excludeEnd: !0
                }
            ]
        };
    })), Cs.registerLanguage("monkey", (hi || (hi = 1, Oi = function(e) {
        const t = {
            className: "number",
            relevance: 0,
            variants: [
                {
                    begin: "[$][a-fA-F0-9]+"
                },
                e.NUMBER_MODE
            ]
        }, a = {
            variants: [
                {
                    match: [
                        /(function|method)/,
                        /\s+/,
                        e.UNDERSCORE_IDENT_RE
                    ]
                }
            ],
            scope: {
                1: "keyword",
                3: "title.function"
            }
        }, n = {
            variants: [
                {
                    match: [
                        /(class|interface|extends|implements)/,
                        /\s+/,
                        e.UNDERSCORE_IDENT_RE
                    ]
                }
            ],
            scope: {
                1: "keyword",
                3: "title.class"
            }
        };
        return {
            name: "Monkey",
            case_insensitive: !0,
            keywords: {
                keyword: [
                    "public",
                    "private",
                    "property",
                    "continue",
                    "exit",
                    "extern",
                    "new",
                    "try",
                    "catch",
                    "eachin",
                    "not",
                    "abstract",
                    "final",
                    "select",
                    "case",
                    "default",
                    "const",
                    "local",
                    "global",
                    "field",
                    "end",
                    "if",
                    "then",
                    "else",
                    "elseif",
                    "endif",
                    "while",
                    "wend",
                    "repeat",
                    "until",
                    "forever",
                    "for",
                    "to",
                    "step",
                    "next",
                    "return",
                    "module",
                    "inline",
                    "throw",
                    "import",
                    "and",
                    "or",
                    "shl",
                    "shr",
                    "mod"
                ],
                built_in: [
                    "DebugLog",
                    "DebugStop",
                    "Error",
                    "Print",
                    "ACos",
                    "ACosr",
                    "ASin",
                    "ASinr",
                    "ATan",
                    "ATan2",
                    "ATan2r",
                    "ATanr",
                    "Abs",
                    "Abs",
                    "Ceil",
                    "Clamp",
                    "Clamp",
                    "Cos",
                    "Cosr",
                    "Exp",
                    "Floor",
                    "Log",
                    "Max",
                    "Max",
                    "Min",
                    "Min",
                    "Pow",
                    "Sgn",
                    "Sgn",
                    "Sin",
                    "Sinr",
                    "Sqrt",
                    "Tan",
                    "Tanr",
                    "Seed",
                    "PI",
                    "HALFPI",
                    "TWOPI"
                ],
                literal: [
                    "true",
                    "false",
                    "null"
                ]
            },
            illegal: /\/\*/,
            contains: [
                e.COMMENT("#rem", "#end"),
                e.COMMENT("'", "$", {
                    relevance: 0
                }),
                a,
                n,
                {
                    className: "variable.language",
                    begin: /\b(self|super)\b/
                },
                {
                    className: "meta",
                    begin: /\s*#/,
                    end: "$",
                    keywords: {
                        keyword: "if else elseif endif end then"
                    }
                },
                {
                    match: [
                        /^\s*/,
                        /strict\b/
                    ],
                    scope: {
                        2: "meta"
                    }
                },
                {
                    beginKeywords: "alias",
                    end: "=",
                    contains: [
                        e.UNDERSCORE_TITLE_MODE
                    ]
                },
                e.QUOTE_STRING_MODE,
                t
            ]
        };
    }), Oi)), Cs.registerLanguage("moonscript", (Ii || (Ii = 1, vi = function(e) {
        const t = {
            keyword: "if then not for in while do return else elseif break continue switch and or unless when class extends super local import export from using",
            literal: "true false nil",
            built_in: "_G _VERSION assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall coroutine debug io math os package string table"
        }, a = "[A-Za-z$_][0-9A-Za-z$_]*", n = {
            className: "subst",
            begin: /#\{/,
            end: /\}/,
            keywords: t
        }, i = [
            e.inherit(e.C_NUMBER_MODE, {
                starts: {
                    end: "(\\s*/)?",
                    relevance: 0
                }
            }),
            {
                className: "string",
                variants: [
                    {
                        begin: /'/,
                        end: /'/,
                        contains: [
                            e.BACKSLASH_ESCAPE
                        ]
                    },
                    {
                        begin: /"/,
                        end: /"/,
                        contains: [
                            e.BACKSLASH_ESCAPE,
                            n
                        ]
                    }
                ]
            },
            {
                className: "built_in",
                begin: "@__" + e.IDENT_RE
            },
            {
                begin: "@" + e.IDENT_RE
            },
            {
                begin: e.IDENT_RE + "\\\\" + e.IDENT_RE
            }
        ];
        n.contains = i;
        const r = e.inherit(e.TITLE_MODE, {
            begin: a
        }), o = "(\\(.*\\)\\s*)?\\B[-=]>", s = {
            className: "params",
            begin: "\\([^\\(]",
            returnBegin: !0,
            contains: [
                {
                    begin: /\(/,
                    end: /\)/,
                    keywords: t,
                    contains: [
                        "self"
                    ].concat(i)
                }
            ]
        };
        return {
            name: "MoonScript",
            aliases: [
                "moon"
            ],
            keywords: t,
            illegal: /\/\*/,
            contains: i.concat([
                e.COMMENT("--", "$"),
                {
                    className: "function",
                    begin: "^\\s*" + a + "\\s*=\\s*" + o,
                    end: "[-=]>",
                    returnBegin: !0,
                    contains: [
                        r,
                        s
                    ]
                },
                {
                    begin: /[\(,:=]\s*/,
                    relevance: 0,
                    contains: [
                        {
                            className: "function",
                            begin: o,
                            end: "[-=]>",
                            returnBegin: !0,
                            contains: [
                                s
                            ]
                        }
                    ]
                },
                {
                    className: "class",
                    beginKeywords: "class",
                    end: "$",
                    illegal: /[:="\[\]]/,
                    contains: [
                        {
                            beginKeywords: "extends",
                            endsWithParent: !0,
                            illegal: /[:="\[\]]/,
                            contains: [
                                r
                            ]
                        },
                        r
                    ]
                },
                {
                    className: "name",
                    begin: a + ":",
                    end: ":",
                    returnBegin: !0,
                    returnEnd: !0,
                    relevance: 0
                }
            ])
        };
    }), vi)), Cs.registerLanguage("n1ql", (yi || (yi = 1, Ai = function(e) {
        return {
            name: "N1QL",
            case_insensitive: !0,
            contains: [
                {
                    beginKeywords: "build create index delete drop explain infer|10 insert merge prepare select update upsert|10",
                    end: /;/,
                    keywords: {
                        keyword: [
                            "all",
                            "alter",
                            "analyze",
                            "and",
                            "any",
                            "array",
                            "as",
                            "asc",
                            "begin",
                            "between",
                            "binary",
                            "boolean",
                            "break",
                            "bucket",
                            "build",
                            "by",
                            "call",
                            "case",
                            "cast",
                            "cluster",
                            "collate",
                            "collection",
                            "commit",
                            "connect",
                            "continue",
                            "correlate",
                            "cover",
                            "create",
                            "database",
                            "dataset",
                            "datastore",
                            "declare",
                            "decrement",
                            "delete",
                            "derived",
                            "desc",
                            "describe",
                            "distinct",
                            "do",
                            "drop",
                            "each",
                            "element",
                            "else",
                            "end",
                            "every",
                            "except",
                            "exclude",
                            "execute",
                            "exists",
                            "explain",
                            "fetch",
                            "first",
                            "flatten",
                            "for",
                            "force",
                            "from",
                            "function",
                            "grant",
                            "group",
                            "gsi",
                            "having",
                            "if",
                            "ignore",
                            "ilike",
                            "in",
                            "include",
                            "increment",
                            "index",
                            "infer",
                            "inline",
                            "inner",
                            "insert",
                            "intersect",
                            "into",
                            "is",
                            "join",
                            "key",
                            "keys",
                            "keyspace",
                            "known",
                            "last",
                            "left",
                            "let",
                            "letting",
                            "like",
                            "limit",
                            "lsm",
                            "map",
                            "mapping",
                            "matched",
                            "materialized",
                            "merge",
                            "minus",
                            "namespace",
                            "nest",
                            "not",
                            "number",
                            "object",
                            "offset",
                            "on",
                            "option",
                            "or",
                            "order",
                            "outer",
                            "over",
                            "parse",
                            "partition",
                            "password",
                            "path",
                            "pool",
                            "prepare",
                            "primary",
                            "private",
                            "privilege",
                            "procedure",
                            "public",
                            "raw",
                            "realm",
                            "reduce",
                            "rename",
                            "return",
                            "returning",
                            "revoke",
                            "right",
                            "role",
                            "rollback",
                            "satisfies",
                            "schema",
                            "select",
                            "self",
                            "semi",
                            "set",
                            "show",
                            "some",
                            "start",
                            "statistics",
                            "string",
                            "system",
                            "then",
                            "to",
                            "transaction",
                            "trigger",
                            "truncate",
                            "under",
                            "union",
                            "unique",
                            "unknown",
                            "unnest",
                            "unset",
                            "update",
                            "upsert",
                            "use",
                            "user",
                            "using",
                            "validate",
                            "value",
                            "valued",
                            "values",
                            "via",
                            "view",
                            "when",
                            "where",
                            "while",
                            "with",
                            "within",
                            "work",
                            "xor"
                        ],
                        literal: [
                            "true",
                            "false",
                            "null",
                            "missing|5"
                        ],
                        built_in: [
                            "array_agg",
                            "array_append",
                            "array_concat",
                            "array_contains",
                            "array_count",
                            "array_distinct",
                            "array_ifnull",
                            "array_length",
                            "array_max",
                            "array_min",
                            "array_position",
                            "array_prepend",
                            "array_put",
                            "array_range",
                            "array_remove",
                            "array_repeat",
                            "array_replace",
                            "array_reverse",
                            "array_sort",
                            "array_sum",
                            "avg",
                            "count",
                            "max",
                            "min",
                            "sum",
                            "greatest",
                            "least",
                            "ifmissing",
                            "ifmissingornull",
                            "ifnull",
                            "missingif",
                            "nullif",
                            "ifinf",
                            "ifnan",
                            "ifnanorinf",
                            "naninf",
                            "neginfif",
                            "posinfif",
                            "clock_millis",
                            "clock_str",
                            "date_add_millis",
                            "date_add_str",
                            "date_diff_millis",
                            "date_diff_str",
                            "date_part_millis",
                            "date_part_str",
                            "date_trunc_millis",
                            "date_trunc_str",
                            "duration_to_str",
                            "millis",
                            "str_to_millis",
                            "millis_to_str",
                            "millis_to_utc",
                            "millis_to_zone_name",
                            "now_millis",
                            "now_str",
                            "str_to_duration",
                            "str_to_utc",
                            "str_to_zone_name",
                            "decode_json",
                            "encode_json",
                            "encoded_size",
                            "poly_length",
                            "base64",
                            "base64_encode",
                            "base64_decode",
                            "meta",
                            "uuid",
                            "abs",
                            "acos",
                            "asin",
                            "atan",
                            "atan2",
                            "ceil",
                            "cos",
                            "degrees",
                            "e",
                            "exp",
                            "ln",
                            "log",
                            "floor",
                            "pi",
                            "power",
                            "radians",
                            "random",
                            "round",
                            "sign",
                            "sin",
                            "sqrt",
                            "tan",
                            "trunc",
                            "object_length",
                            "object_names",
                            "object_pairs",
                            "object_inner_pairs",
                            "object_values",
                            "object_inner_values",
                            "object_add",
                            "object_put",
                            "object_remove",
                            "object_unwrap",
                            "regexp_contains",
                            "regexp_like",
                            "regexp_position",
                            "regexp_replace",
                            "contains",
                            "initcap",
                            "length",
                            "lower",
                            "ltrim",
                            "position",
                            "repeat",
                            "replace",
                            "rtrim",
                            "split",
                            "substr",
                            "title",
                            "trim",
                            "upper",
                            "isarray",
                            "isatom",
                            "isboolean",
                            "isnumber",
                            "isobject",
                            "isstring",
                            "type",
                            "toarray",
                            "toatom",
                            "toboolean",
                            "tonumber",
                            "toobject",
                            "tostring"
                        ]
                    },
                    contains: [
                        {
                            className: "string",
                            begin: "'",
                            end: "'",
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            className: "string",
                            begin: '"',
                            end: '"',
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        {
                            className: "symbol",
                            begin: "`",
                            end: "`",
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        },
                        e.C_NUMBER_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                e.C_BLOCK_COMMENT_MODE
            ]
        };
    }), Ai)), Cs.registerLanguage("nestedtext", (Mi || (Mi = 1, Di = function(e) {
        return {
            name: "Nested Text",
            aliases: [
                "nt"
            ],
            contains: [
                e.inherit(e.HASH_COMMENT_MODE, {
                    begin: /^\s*(?=#)/,
                    excludeBegin: !0
                }),
                {
                    variants: [
                        {
                            match: [
                                /^\s*/,
                                /-/,
                                /[ ]/,
                                /.*$/
                            ]
                        },
                        {
                            match: [
                                /^\s*/,
                                /-$/
                            ]
                        }
                    ],
                    className: {
                        2: "bullet",
                        4: "string"
                    }
                },
                {
                    match: [
                        /^\s*/,
                        />/,
                        /[ ]/,
                        /.*$/
                    ],
                    className: {
                        2: "punctuation",
                        4: "string"
                    }
                },
                {
                    match: [
                        /^\s*(?=\S)/,
                        /[^:]+/,
                        /:\s*/,
                        /$/
                    ],
                    className: {
                        2: "attribute",
                        3: "punctuation"
                    }
                },
                {
                    match: [
                        /^\s*(?=\S)/,
                        /[^:]*[^: ]/,
                        /[ ]*:/,
                        /[ ]/,
                        /.*$/
                    ],
                    className: {
                        2: "attribute",
                        3: "punctuation",
                        5: "string"
                    }
                }
            ]
        };
    }), Di)), Cs.registerLanguage("nginx", (xi || (xi = 1, Li = function(e) {
        const t = e.regex, a = {
            className: "variable",
            variants: [
                {
                    begin: /\$\d+/
                },
                {
                    begin: /\$\{\w+\}/
                },
                {
                    begin: t.concat(/[$@]/, e.UNDERSCORE_IDENT_RE)
                }
            ]
        }, n = {
            endsWithParent: !0,
            keywords: {
                $pattern: /[a-z_]{2,}|\/dev\/poll/,
                literal: [
                    "on",
                    "off",
                    "yes",
                    "no",
                    "true",
                    "false",
                    "none",
                    "blocked",
                    "debug",
                    "info",
                    "notice",
                    "warn",
                    "error",
                    "crit",
                    "select",
                    "break",
                    "last",
                    "permanent",
                    "redirect",
                    "kqueue",
                    "rtsig",
                    "epoll",
                    "poll",
                    "/dev/poll"
                ]
            },
            relevance: 0,
            illegal: "=>",
            contains: [
                e.HASH_COMMENT_MODE,
                {
                    className: "string",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        a
                    ],
                    variants: [
                        {
                            begin: /"/,
                            end: /"/
                        },
                        {
                            begin: /'/,
                            end: /'/
                        }
                    ]
                },
                {
                    begin: "([a-z]+):/",
                    end: "\\s",
                    endsWithParent: !0,
                    excludeEnd: !0,
                    contains: [
                        a
                    ]
                },
                {
                    className: "regexp",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        a
                    ],
                    variants: [
                        {
                            begin: "\\s\\^",
                            end: "\\s|\\{|;",
                            returnEnd: !0
                        },
                        {
                            begin: "~\\*?\\s+",
                            end: "\\s|\\{|;",
                            returnEnd: !0
                        },
                        {
                            begin: "\\*(\\.[a-z\\-]+)+"
                        },
                        {
                            begin: "([a-z\\-]+\\.)+\\*"
                        }
                    ]
                },
                {
                    className: "number",
                    begin: "\\b\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}(:\\d{1,5})?\\b"
                },
                {
                    className: "number",
                    begin: "\\b\\d+[kKmMgGdshdwy]?\\b",
                    relevance: 0
                },
                a
            ]
        };
        return {
            name: "Nginx config",
            aliases: [
                "nginxconf"
            ],
            contains: [
                e.HASH_COMMENT_MODE,
                {
                    beginKeywords: "upstream location",
                    end: /;|\{/,
                    contains: n.contains,
                    keywords: {
                        section: "upstream location"
                    }
                },
                {
                    className: "section",
                    begin: t.concat(e.UNDERSCORE_IDENT_RE + t.lookahead(/\s+\{/)),
                    relevance: 0
                },
                {
                    begin: t.lookahead(e.UNDERSCORE_IDENT_RE + "\\s"),
                    end: ";|\\{",
                    contains: [
                        {
                            className: "attribute",
                            begin: e.UNDERSCORE_IDENT_RE,
                            starts: n
                        }
                    ],
                    relevance: 0
                }
            ],
            illegal: "[^\\s\\}\\{]"
        };
    }), Li)), Cs.registerLanguage("nim", (Pi || (Pi = 1, wi = function(e) {
        return {
            name: "Nim",
            keywords: {
                keyword: [
                    "addr",
                    "and",
                    "as",
                    "asm",
                    "bind",
                    "block",
                    "break",
                    "case",
                    "cast",
                    "const",
                    "continue",
                    "converter",
                    "discard",
                    "distinct",
                    "div",
                    "do",
                    "elif",
                    "else",
                    "end",
                    "enum",
                    "except",
                    "export",
                    "finally",
                    "for",
                    "from",
                    "func",
                    "generic",
                    "guarded",
                    "if",
                    "import",
                    "in",
                    "include",
                    "interface",
                    "is",
                    "isnot",
                    "iterator",
                    "let",
                    "macro",
                    "method",
                    "mixin",
                    "mod",
                    "nil",
                    "not",
                    "notin",
                    "object",
                    "of",
                    "or",
                    "out",
                    "proc",
                    "ptr",
                    "raise",
                    "ref",
                    "return",
                    "shared",
                    "shl",
                    "shr",
                    "static",
                    "template",
                    "try",
                    "tuple",
                    "type",
                    "using",
                    "var",
                    "when",
                    "while",
                    "with",
                    "without",
                    "xor",
                    "yield"
                ],
                literal: [
                    "true",
                    "false"
                ],
                type: [
                    "int",
                    "int8",
                    "int16",
                    "int32",
                    "int64",
                    "uint",
                    "uint8",
                    "uint16",
                    "uint32",
                    "uint64",
                    "float",
                    "float32",
                    "float64",
                    "bool",
                    "char",
                    "string",
                    "cstring",
                    "pointer",
                    "expr",
                    "stmt",
                    "void",
                    "auto",
                    "any",
                    "range",
                    "array",
                    "openarray",
                    "varargs",
                    "seq",
                    "set",
                    "clong",
                    "culong",
                    "cchar",
                    "cschar",
                    "cshort",
                    "cint",
                    "csize",
                    "clonglong",
                    "cfloat",
                    "cdouble",
                    "clongdouble",
                    "cuchar",
                    "cushort",
                    "cuint",
                    "culonglong",
                    "cstringarray",
                    "semistatic"
                ],
                built_in: [
                    "stdin",
                    "stdout",
                    "stderr",
                    "result"
                ]
            },
            contains: [
                {
                    className: "meta",
                    begin: /\{\./,
                    end: /\.\}/,
                    relevance: 10
                },
                {
                    className: "string",
                    begin: /[a-zA-Z]\w*"/,
                    end: /"/,
                    contains: [
                        {
                            begin: /""/
                        }
                    ]
                },
                {
                    className: "string",
                    begin: /([a-zA-Z]\w*)?"""/,
                    end: /"""/
                },
                e.QUOTE_STRING_MODE,
                {
                    className: "type",
                    begin: /\b[A-Z]\w+\b/,
                    relevance: 0
                },
                {
                    className: "number",
                    relevance: 0,
                    variants: [
                        {
                            begin: /\b(0[xX][0-9a-fA-F][_0-9a-fA-F]*)('?[iIuU](8|16|32|64))?/
                        },
                        {
                            begin: /\b(0o[0-7][_0-7]*)('?[iIuUfF](8|16|32|64))?/
                        },
                        {
                            begin: /\b(0(b|B)[01][_01]*)('?[iIuUfF](8|16|32|64))?/
                        },
                        {
                            begin: /\b(\d[_\d]*)('?[iIuUfF](8|16|32|64))?/
                        }
                    ]
                },
                e.HASH_COMMENT_MODE
            ]
        };
    }), wi)), Cs.registerLanguage("nix", (Ui || (Ui = 1, ki = function(e) {
        const t = {
            keyword: [
                "rec",
                "with",
                "let",
                "in",
                "inherit",
                "assert",
                "if",
                "else",
                "then"
            ],
            literal: [
                "true",
                "false",
                "or",
                "and",
                "null"
            ],
            built_in: [
                "import",
                "abort",
                "baseNameOf",
                "dirOf",
                "isNull",
                "builtins",
                "map",
                "removeAttrs",
                "throw",
                "toString",
                "derivation"
            ]
        }, a = {
            className: "subst",
            begin: /\$\{/,
            end: /\}/,
            keywords: t
        }, n = {
            className: "string",
            contains: [
                {
                    className: "char.escape",
                    begin: /''\$/
                },
                a
            ],
            variants: [
                {
                    begin: "''",
                    end: "''"
                },
                {
                    begin: '"',
                    end: '"'
                }
            ]
        }, i = [
            e.NUMBER_MODE,
            e.HASH_COMMENT_MODE,
            e.C_BLOCK_COMMENT_MODE,
            n,
            {
                begin: /[a-zA-Z0-9-_]+(\s*=)/,
                returnBegin: !0,
                relevance: 0,
                contains: [
                    {
                        className: "attr",
                        begin: /\S+/,
                        relevance: .2
                    }
                ]
            }
        ];
        return a.contains = i, {
            name: "Nix",
            aliases: [
                "nixos"
            ],
            keywords: t,
            contains: i
        };
    }), ki)), Cs.registerLanguage("node-repl", Bi ? Fi : (Bi = 1, Fi = function(e) {
        return {
            name: "Node REPL",
            contains: [
                {
                    className: "meta.prompt",
                    starts: {
                        end: / |$/,
                        starts: {
                            end: "$",
                            subLanguage: "javascript"
                        }
                    },
                    variants: [
                        {
                            begin: /^>(?=[ ]|$)/
                        },
                        {
                            begin: /^\.\.\.(?=[ ]|$)/
                        }
                    ]
                }
            ]
        };
    })), Cs.registerLanguage("nsis", (Yi || (Yi = 1, Gi = function(e) {
        const t = e.regex, a = {
            className: "variable.constant",
            begin: t.concat(/\$/, t.either("ADMINTOOLS", "APPDATA", "CDBURN_AREA", "CMDLINE", "COMMONFILES32", "COMMONFILES64", "COMMONFILES", "COOKIES", "DESKTOP", "DOCUMENTS", "EXEDIR", "EXEFILE", "EXEPATH", "FAVORITES", "FONTS", "HISTORY", "HWNDPARENT", "INSTDIR", "INTERNET_CACHE", "LANGUAGE", "LOCALAPPDATA", "MUSIC", "NETHOOD", "OUTDIR", "PICTURES", "PLUGINSDIR", "PRINTHOOD", "PROFILE", "PROGRAMFILES32", "PROGRAMFILES64", "PROGRAMFILES", "QUICKLAUNCH", "RECENT", "RESOURCES_LOCALIZED", "RESOURCES", "SENDTO", "SMPROGRAMS", "SMSTARTUP", "STARTMENU", "SYSDIR", "TEMP", "TEMPLATES", "VIDEOS", "WINDIR"))
        }, n = {
            className: "variable",
            begin: /\$+\{[\!\w.:-]+\}/
        }, i = {
            className: "variable",
            begin: /\$+\w[\w\.]*/,
            illegal: /\(\)\{\}/
        }, r = {
            className: "variable",
            begin: /\$+\([\w^.:!-]+\)/
        }, o = {
            className: "params",
            begin: t.either("ARCHIVE", "FILE_ATTRIBUTE_ARCHIVE", "FILE_ATTRIBUTE_NORMAL", "FILE_ATTRIBUTE_OFFLINE", "FILE_ATTRIBUTE_READONLY", "FILE_ATTRIBUTE_SYSTEM", "FILE_ATTRIBUTE_TEMPORARY", "HKCR", "HKCU", "HKDD", "HKEY_CLASSES_ROOT", "HKEY_CURRENT_CONFIG", "HKEY_CURRENT_USER", "HKEY_DYN_DATA", "HKEY_LOCAL_MACHINE", "HKEY_PERFORMANCE_DATA", "HKEY_USERS", "HKLM", "HKPD", "HKU", "IDABORT", "IDCANCEL", "IDIGNORE", "IDNO", "IDOK", "IDRETRY", "IDYES", "MB_ABORTRETRYIGNORE", "MB_DEFBUTTON1", "MB_DEFBUTTON2", "MB_DEFBUTTON3", "MB_DEFBUTTON4", "MB_ICONEXCLAMATION", "MB_ICONINFORMATION", "MB_ICONQUESTION", "MB_ICONSTOP", "MB_OK", "MB_OKCANCEL", "MB_RETRYCANCEL", "MB_RIGHT", "MB_RTLREADING", "MB_SETFOREGROUND", "MB_TOPMOST", "MB_USERICON", "MB_YESNO", "NORMAL", "OFFLINE", "READONLY", "SHCTX", "SHELL_CONTEXT", "SYSTEM|TEMPORARY")
        }, s = {
            className: "keyword",
            begin: t.concat(/!/, t.either("addincludedir", "addplugindir", "appendfile", "assert", "cd", "define", "delfile", "echo", "else", "endif", "error", "execute", "finalize", "getdllversion", "gettlbversion", "if", "ifdef", "ifmacrodef", "ifmacrondef", "ifndef", "include", "insertmacro", "macro", "macroend", "makensis", "packhdr", "searchparse", "searchreplace", "system", "tempfile", "undef", "uninstfinalize", "verbose", "warning"))
        }, l = {
            className: "string",
            variants: [
                {
                    begin: '"',
                    end: '"'
                },
                {
                    begin: "'",
                    end: "'"
                },
                {
                    begin: "`",
                    end: "`"
                }
            ],
            illegal: /\n/,
            contains: [
                {
                    className: "char.escape",
                    begin: /\$(\\[nrt]|\$)/
                },
                a,
                n,
                i,
                r
            ]
        }, c = {
            match: [
                /Function/,
                /\s+/,
                t.concat(/(\.)?/, e.IDENT_RE)
            ],
            scope: {
                1: "keyword",
                3: "title.function"
            }
        }, _ = {
            match: [
                /Var/,
                /\s+/,
                /(?:\/GLOBAL\s+)?/,
                /[A-Za-z][\w.]*/
            ],
            scope: {
                1: "keyword",
                3: "params",
                4: "variable"
            }
        };
        return {
            name: "NSIS",
            case_insensitive: !0,
            keywords: {
                keyword: [
                    "Abort",
                    "AddBrandingImage",
                    "AddSize",
                    "AllowRootDirInstall",
                    "AllowSkipFiles",
                    "AutoCloseWindow",
                    "BGFont",
                    "BGGradient",
                    "BrandingText",
                    "BringToFront",
                    "Call",
                    "CallInstDLL",
                    "Caption",
                    "ChangeUI",
                    "CheckBitmap",
                    "ClearErrors",
                    "CompletedText",
                    "ComponentText",
                    "CopyFiles",
                    "CRCCheck",
                    "CreateDirectory",
                    "CreateFont",
                    "CreateShortCut",
                    "Delete",
                    "DeleteINISec",
                    "DeleteINIStr",
                    "DeleteRegKey",
                    "DeleteRegValue",
                    "DetailPrint",
                    "DetailsButtonText",
                    "DirText",
                    "DirVar",
                    "DirVerify",
                    "EnableWindow",
                    "EnumRegKey",
                    "EnumRegValue",
                    "Exch",
                    "Exec",
                    "ExecShell",
                    "ExecShellWait",
                    "ExecWait",
                    "ExpandEnvStrings",
                    "File",
                    "FileBufSize",
                    "FileClose",
                    "FileErrorText",
                    "FileOpen",
                    "FileRead",
                    "FileReadByte",
                    "FileReadUTF16LE",
                    "FileReadWord",
                    "FileWriteUTF16LE",
                    "FileSeek",
                    "FileWrite",
                    "FileWriteByte",
                    "FileWriteWord",
                    "FindClose",
                    "FindFirst",
                    "FindNext",
                    "FindWindow",
                    "FlushINI",
                    "GetCurInstType",
                    "GetCurrentAddress",
                    "GetDlgItem",
                    "GetDLLVersion",
                    "GetDLLVersionLocal",
                    "GetErrorLevel",
                    "GetFileTime",
                    "GetFileTimeLocal",
                    "GetFullPathName",
                    "GetFunctionAddress",
                    "GetInstDirError",
                    "GetKnownFolderPath",
                    "GetLabelAddress",
                    "GetTempFileName",
                    "GetWinVer",
                    "Goto",
                    "HideWindow",
                    "Icon",
                    "IfAbort",
                    "IfErrors",
                    "IfFileExists",
                    "IfRebootFlag",
                    "IfRtlLanguage",
                    "IfShellVarContextAll",
                    "IfSilent",
                    "InitPluginsDir",
                    "InstallButtonText",
                    "InstallColors",
                    "InstallDir",
                    "InstallDirRegKey",
                    "InstProgressFlags",
                    "InstType",
                    "InstTypeGetText",
                    "InstTypeSetText",
                    "Int64Cmp",
                    "Int64CmpU",
                    "Int64Fmt",
                    "IntCmp",
                    "IntCmpU",
                    "IntFmt",
                    "IntOp",
                    "IntPtrCmp",
                    "IntPtrCmpU",
                    "IntPtrOp",
                    "IsWindow",
                    "LangString",
                    "LicenseBkColor",
                    "LicenseData",
                    "LicenseForceSelection",
                    "LicenseLangString",
                    "LicenseText",
                    "LoadAndSetImage",
                    "LoadLanguageFile",
                    "LockWindow",
                    "LogSet",
                    "LogText",
                    "ManifestDPIAware",
                    "ManifestLongPathAware",
                    "ManifestMaxVersionTested",
                    "ManifestSupportedOS",
                    "MessageBox",
                    "MiscButtonText",
                    "Name|0",
                    "Nop",
                    "OutFile",
                    "Page",
                    "PageCallbacks",
                    "PEAddResource",
                    "PEDllCharacteristics",
                    "PERemoveResource",
                    "PESubsysVer",
                    "Pop",
                    "Push",
                    "Quit",
                    "ReadEnvStr",
                    "ReadINIStr",
                    "ReadRegDWORD",
                    "ReadRegStr",
                    "Reboot",
                    "RegDLL",
                    "Rename",
                    "RequestExecutionLevel",
                    "ReserveFile",
                    "Return",
                    "RMDir",
                    "SearchPath",
                    "SectionGetFlags",
                    "SectionGetInstTypes",
                    "SectionGetSize",
                    "SectionGetText",
                    "SectionIn",
                    "SectionSetFlags",
                    "SectionSetInstTypes",
                    "SectionSetSize",
                    "SectionSetText",
                    "SendMessage",
                    "SetAutoClose",
                    "SetBrandingImage",
                    "SetCompress",
                    "SetCompressor",
                    "SetCompressorDictSize",
                    "SetCtlColors",
                    "SetCurInstType",
                    "SetDatablockOptimize",
                    "SetDateSave",
                    "SetDetailsPrint",
                    "SetDetailsView",
                    "SetErrorLevel",
                    "SetErrors",
                    "SetFileAttributes",
                    "SetFont",
                    "SetOutPath",
                    "SetOverwrite",
                    "SetRebootFlag",
                    "SetRegView",
                    "SetShellVarContext",
                    "SetSilent",
                    "ShowInstDetails",
                    "ShowUninstDetails",
                    "ShowWindow",
                    "SilentInstall",
                    "SilentUnInstall",
                    "Sleep",
                    "SpaceTexts",
                    "StrCmp",
                    "StrCmpS",
                    "StrCpy",
                    "StrLen",
                    "SubCaption",
                    "Unicode",
                    "UninstallButtonText",
                    "UninstallCaption",
                    "UninstallIcon",
                    "UninstallSubCaption",
                    "UninstallText",
                    "UninstPage",
                    "UnRegDLL",
                    "Var",
                    "VIAddVersionKey",
                    "VIFileVersion",
                    "VIProductVersion",
                    "WindowIcon",
                    "WriteINIStr",
                    "WriteRegBin",
                    "WriteRegDWORD",
                    "WriteRegExpandStr",
                    "WriteRegMultiStr",
                    "WriteRegNone",
                    "WriteRegStr",
                    "WriteUninstaller",
                    "XPStyle"
                ],
                literal: [
                    "admin",
                    "all",
                    "auto",
                    "both",
                    "bottom",
                    "bzip2",
                    "colored",
                    "components",
                    "current",
                    "custom",
                    "directory",
                    "false",
                    "force",
                    "hide",
                    "highest",
                    "ifdiff",
                    "ifnewer",
                    "instfiles",
                    "lastused",
                    "leave",
                    "left",
                    "license",
                    "listonly",
                    "lzma",
                    "nevershow",
                    "none",
                    "normal",
                    "notset",
                    "off",
                    "on",
                    "open",
                    "print",
                    "right",
                    "show",
                    "silent",
                    "silentlog",
                    "smooth",
                    "textonly",
                    "top",
                    "true",
                    "try",
                    "un.components",
                    "un.custom",
                    "un.directory",
                    "un.instfiles",
                    "un.license",
                    "uninstConfirm",
                    "user",
                    "Win10",
                    "Win7",
                    "Win8",
                    "WinVista",
                    "zlib"
                ]
            },
            contains: [
                e.HASH_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.COMMENT(";", "$", {
                    relevance: 0
                }),
                _,
                c,
                {
                    beginKeywords: "Function PageEx Section SectionGroup FunctionEnd SectionEnd"
                },
                l,
                s,
                n,
                i,
                r,
                o,
                {
                    className: "title.function",
                    begin: /\w+::\w+/
                },
                e.NUMBER_MODE
            ]
        };
    }), Gi)), Cs.registerLanguage("objectivec", (Vi || (Vi = 1, Hi = function(e) {
        const t = /[a-zA-Z@][a-zA-Z0-9_]*/, a = {
            $pattern: t,
            keyword: [
                "@interface",
                "@class",
                "@protocol",
                "@implementation"
            ]
        };
        return {
            name: "Objective-C",
            aliases: [
                "mm",
                "objc",
                "obj-c",
                "obj-c++",
                "objective-c++"
            ],
            keywords: {
                "variable.language": [
                    "this",
                    "super"
                ],
                $pattern: t,
                keyword: [
                    "while",
                    "export",
                    "sizeof",
                    "typedef",
                    "const",
                    "struct",
                    "for",
                    "union",
                    "volatile",
                    "static",
                    "mutable",
                    "if",
                    "do",
                    "return",
                    "goto",
                    "enum",
                    "else",
                    "break",
                    "extern",
                    "asm",
                    "case",
                    "default",
                    "register",
                    "explicit",
                    "typename",
                    "switch",
                    "continue",
                    "inline",
                    "readonly",
                    "assign",
                    "readwrite",
                    "self",
                    "@synchronized",
                    "id",
                    "typeof",
                    "nonatomic",
                    "IBOutlet",
                    "IBAction",
                    "strong",
                    "weak",
                    "copy",
                    "in",
                    "out",
                    "inout",
                    "bycopy",
                    "byref",
                    "oneway",
                    "__strong",
                    "__weak",
                    "__block",
                    "__autoreleasing",
                    "@private",
                    "@protected",
                    "@public",
                    "@try",
                    "@property",
                    "@end",
                    "@throw",
                    "@catch",
                    "@finally",
                    "@autoreleasepool",
                    "@synthesize",
                    "@dynamic",
                    "@selector",
                    "@optional",
                    "@required",
                    "@encode",
                    "@package",
                    "@import",
                    "@defs",
                    "@compatibility_alias",
                    "__bridge",
                    "__bridge_transfer",
                    "__bridge_retained",
                    "__bridge_retain",
                    "__covariant",
                    "__contravariant",
                    "__kindof",
                    "_Nonnull",
                    "_Nullable",
                    "_Null_unspecified",
                    "__FUNCTION__",
                    "__PRETTY_FUNCTION__",
                    "__attribute__",
                    "getter",
                    "setter",
                    "retain",
                    "unsafe_unretained",
                    "nonnull",
                    "nullable",
                    "null_unspecified",
                    "null_resettable",
                    "class",
                    "instancetype",
                    "NS_DESIGNATED_INITIALIZER",
                    "NS_UNAVAILABLE",
                    "NS_REQUIRES_SUPER",
                    "NS_RETURNS_INNER_POINTER",
                    "NS_INLINE",
                    "NS_AVAILABLE",
                    "NS_DEPRECATED",
                    "NS_ENUM",
                    "NS_OPTIONS",
                    "NS_SWIFT_UNAVAILABLE",
                    "NS_ASSUME_NONNULL_BEGIN",
                    "NS_ASSUME_NONNULL_END",
                    "NS_REFINED_FOR_SWIFT",
                    "NS_SWIFT_NAME",
                    "NS_SWIFT_NOTHROW",
                    "NS_DURING",
                    "NS_HANDLER",
                    "NS_ENDHANDLER",
                    "NS_VALUERETURN",
                    "NS_VOIDRETURN"
                ],
                literal: [
                    "false",
                    "true",
                    "FALSE",
                    "TRUE",
                    "nil",
                    "YES",
                    "NO",
                    "NULL"
                ],
                built_in: [
                    "dispatch_once_t",
                    "dispatch_queue_t",
                    "dispatch_sync",
                    "dispatch_async",
                    "dispatch_once"
                ],
                type: [
                    "int",
                    "float",
                    "char",
                    "unsigned",
                    "signed",
                    "short",
                    "long",
                    "double",
                    "wchar_t",
                    "unichar",
                    "void",
                    "bool",
                    "BOOL",
                    "id|0",
                    "_Bool"
                ]
            },
            illegal: "</",
            contains: [
                {
                    className: "built_in",
                    begin: "\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+"
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.C_NUMBER_MODE,
                e.QUOTE_STRING_MODE,
                e.APOS_STRING_MODE,
                {
                    className: "string",
                    variants: [
                        {
                            begin: '@"',
                            end: '"',
                            illegal: "\\n",
                            contains: [
                                e.BACKSLASH_ESCAPE
                            ]
                        }
                    ]
                },
                {
                    className: "meta",
                    begin: /#\s*[a-z]+\b/,
                    end: /$/,
                    keywords: {
                        keyword: "if else elif endif define undef warning error line pragma ifdef ifndef include"
                    },
                    contains: [
                        {
                            begin: /\\\n/,
                            relevance: 0
                        },
                        e.inherit(e.QUOTE_STRING_MODE, {
                            className: "string"
                        }),
                        {
                            className: "string",
                            begin: /<.*?>/,
                            end: /$/,
                            illegal: "\\n"
                        },
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                {
                    className: "class",
                    begin: "(" + a.keyword.join("|") + ")\\b",
                    end: /(\{|$)/,
                    excludeEnd: !0,
                    keywords: a,
                    contains: [
                        e.UNDERSCORE_TITLE_MODE
                    ]
                },
                {
                    begin: "\\." + e.UNDERSCORE_IDENT_RE,
                    relevance: 0
                }
            ]
        };
    }), Hi)), Cs.registerLanguage("ocaml", (zi || (zi = 1, qi = function(e) {
        return {
            name: "OCaml",
            aliases: [
                "ml"
            ],
            keywords: {
                $pattern: "[a-z_]\\w*!?",
                keyword: "and as assert asr begin class constraint do done downto else end exception external for fun function functor if in include inherit! inherit initializer land lazy let lor lsl lsr lxor match method!|10 method mod module mutable new object of open! open or private rec sig struct then to try type val! val virtual when while with parser value",
                built_in: "array bool bytes char exn|5 float int int32 int64 list lazy_t|5 nativeint|5 string unit in_channel out_channel ref",
                literal: "true false"
            },
            illegal: /\/\/|>>/,
            contains: [
                {
                    className: "literal",
                    begin: "\\[(\\|\\|)?\\]|\\(\\)",
                    relevance: 0
                },
                e.COMMENT("\\(\\*", "\\*\\)", {
                    contains: [
                        "self"
                    ]
                }),
                {
                    className: "symbol",
                    begin: "'[A-Za-z_](?!')[\\w']*"
                },
                {
                    className: "type",
                    begin: "`[A-Z][\\w']*"
                },
                {
                    className: "type",
                    begin: "\\b[A-Z][\\w']*",
                    relevance: 0
                },
                {
                    begin: "[a-z_]\\w*'[\\w']*",
                    relevance: 0
                },
                e.inherit(e.APOS_STRING_MODE, {
                    className: "string",
                    relevance: 0
                }),
                e.inherit(e.QUOTE_STRING_MODE, {
                    illegal: null
                }),
                {
                    className: "number",
                    begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
                    relevance: 0
                },
                {
                    begin: /->/
                }
            ]
        };
    }), qi)), Cs.registerLanguage("openscad", (Wi || (Wi = 1, $i = function(e) {
        const t = {
            className: "keyword",
            begin: "\\$(f[asn]|t|vp[rtd]|children)"
        }, a = {
            className: "number",
            begin: "\\b\\d+(\\.\\d+)?(e-?\\d+)?",
            relevance: 0
        }, n = e.inherit(e.QUOTE_STRING_MODE, {
            illegal: null
        }), i = {
            className: "function",
            beginKeywords: "module function",
            end: /=|\{/,
            contains: [
                {
                    className: "params",
                    begin: "\\(",
                    end: "\\)",
                    contains: [
                        "self",
                        a,
                        n,
                        t,
                        {
                            className: "literal",
                            begin: "false|true|PI|undef"
                        }
                    ]
                },
                e.UNDERSCORE_TITLE_MODE
            ]
        };
        return {
            name: "OpenSCAD",
            aliases: [
                "scad"
            ],
            keywords: {
                keyword: "function module include use for intersection_for if else \\%",
                literal: "false true PI undef",
                built_in: "circle square polygon text sphere cube cylinder polyhedron translate rotate scale resize mirror multmatrix color offset hull minkowski union difference intersection abs sign sin cos tan acos asin atan atan2 floor round ceil ln log pow sqrt exp rands min max concat lookup str chr search version version_num norm cross parent_module echo import import_dxf dxf_linear_extrude linear_extrude rotate_extrude surface projection render children dxf_cross dxf_dim let assign"
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                a,
                {
                    className: "meta",
                    keywords: {
                        keyword: "include use"
                    },
                    begin: "include|use <",
                    end: ">"
                },
                n,
                t,
                {
                    begin: "[*!#%]",
                    relevance: 0
                },
                i
            ]
        };
    }), $i)), Cs.registerLanguage("oxygene", (Ki || (Ki = 1, Qi = function(e) {
        const t = {
            $pattern: /\.?\w+/,
            keyword: "abstract add and array as asc aspect assembly async begin break block by case class concat const copy constructor continue create default delegate desc distinct div do downto dynamic each else empty end ensure enum equals event except exit extension external false final finalize finalizer finally flags for forward from function future global group has if implementation implements implies in index inherited inline interface into invariants is iterator join locked locking loop matching method mod module namespace nested new nil not notify nullable of old on operator or order out override parallel params partial pinned private procedure property protected public queryable raise read readonly record reintroduce remove repeat require result reverse sealed select self sequence set shl shr skip static step soft take then to true try tuple type union unit unsafe until uses using var virtual raises volatile where while with write xor yield await mapped deprecated stdcall cdecl pascal register safecall overload library platform reference packed strict published autoreleasepool selector strong weak unretained"
        }, a = e.COMMENT(/\{/, /\}/, {
            relevance: 0
        }), n = e.COMMENT("\\(\\*", "\\*\\)", {
            relevance: 10
        }), i = {
            className: "string",
            begin: "'",
            end: "'",
            contains: [
                {
                    begin: "''"
                }
            ]
        }, r = {
            className: "string",
            begin: "(#\\d+)+"
        }, o = {
            beginKeywords: "function constructor destructor procedure method",
            end: "[:;]",
            keywords: "function constructor|10 destructor|10 procedure|10 method|10",
            contains: [
                e.inherit(e.TITLE_MODE, {
                    scope: "title.function"
                }),
                {
                    className: "params",
                    begin: "\\(",
                    end: "\\)",
                    keywords: t,
                    contains: [
                        i,
                        r
                    ]
                },
                a,
                n
            ]
        };
        return {
            name: "Oxygene",
            case_insensitive: !0,
            keywords: t,
            illegal: '("|\\$[G-Zg-z]|\\/\\*|</|=>|->)',
            contains: [
                a,
                n,
                e.C_LINE_COMMENT_MODE,
                i,
                r,
                e.NUMBER_MODE,
                o,
                {
                    scope: "punctuation",
                    match: /;/,
                    relevance: 0
                }
            ]
        };
    }), Qi)), Cs.registerLanguage("parser3", (Xi || (Xi = 1, ji = function(e) {
        const t = e.COMMENT(/\{/, /\}/, {
            contains: [
                "self"
            ]
        });
        return {
            name: "Parser3",
            subLanguage: "xml",
            relevance: 0,
            contains: [
                e.COMMENT("^#", "$"),
                e.COMMENT(/\^rem\{/, /\}/, {
                    relevance: 10,
                    contains: [
                        t
                    ]
                }),
                {
                    className: "meta",
                    begin: "^@(?:BASE|USE|CLASS|OPTIONS)$",
                    relevance: 10
                },
                {
                    className: "title",
                    begin: "@[\\w\\-]+\\[[\\w^;\\-]*\\](?:\\[[\\w^;\\-]*\\])?(?:.*)$"
                },
                {
                    className: "variable",
                    begin: /\$\{?[\w\-.:]+\}?/
                },
                {
                    className: "keyword",
                    begin: /\^[\w\-.:]+/
                },
                {
                    className: "number",
                    begin: "\\^#[0-9a-fA-F]+"
                },
                e.C_NUMBER_MODE
            ]
        };
    }), ji)), Cs.registerLanguage("pf", (Ji || (Ji = 1, Zi = function(e) {
        return {
            name: "Packet Filter config",
            aliases: [
                "pf.conf"
            ],
            keywords: {
                $pattern: /[a-z0-9_<>-]+/,
                built_in: "block match pass load anchor|5 antispoof|10 set table",
                keyword: "in out log quick on rdomain inet inet6 proto from port os to route allow-opts divert-packet divert-reply divert-to flags group icmp-type icmp6-type label once probability recieved-on rtable prio queue tos tag tagged user keep fragment for os drop af-to|10 binat-to|10 nat-to|10 rdr-to|10 bitmask least-stats random round-robin source-hash static-port dup-to reply-to route-to parent bandwidth default min max qlimit block-policy debug fingerprints hostid limit loginterface optimization reassemble ruleset-optimization basic none profile skip state-defaults state-policy timeout const counters persist no modulate synproxy state|5 floating if-bound no-sync pflow|10 sloppy source-track global rule max-src-nodes max-src-states max-src-conn max-src-conn-rate overload flush scrub|5 max-mss min-ttl no-df|10 random-id",
                literal: "all any no-route self urpf-failed egress|5 unknown"
            },
            contains: [
                e.HASH_COMMENT_MODE,
                e.NUMBER_MODE,
                e.QUOTE_STRING_MODE,
                {
                    className: "variable",
                    begin: /\$[\w\d#@][\w\d_]*/,
                    relevance: 0
                },
                {
                    className: "variable",
                    begin: /<(?!\/)/,
                    end: />/
                }
            ]
        };
    }), Zi)), Cs.registerLanguage("pgsql", (tr || (tr = 1, er = function(e) {
        const t = e.COMMENT("--", "$"), a = "\\$([a-zA-Z_]?|[a-zA-Z_][a-zA-Z_0-9]*)\\$", n = "BIGINT INT8 BIGSERIAL SERIAL8 BIT VARYING VARBIT BOOLEAN BOOL BOX BYTEA CHARACTER CHAR VARCHAR CIDR CIRCLE DATE DOUBLE PRECISION FLOAT8 FLOAT INET INTEGER INT INT4 INTERVAL JSON JSONB LINE LSEG|10 MACADDR MACADDR8 MONEY NUMERIC DEC DECIMAL PATH POINT POLYGON REAL FLOAT4 SMALLINT INT2 SMALLSERIAL|10 SERIAL2|10 SERIAL|10 SERIAL4|10 TEXT TIME ZONE TIMETZ|10 TIMESTAMP TIMESTAMPTZ|10 TSQUERY|10 TSVECTOR|10 TXID_SNAPSHOT|10 UUID XML NATIONAL NCHAR INT4RANGE|10 INT8RANGE|10 NUMRANGE|10 TSRANGE|10 TSTZRANGE|10 DATERANGE|10 ANYELEMENT ANYARRAY ANYNONARRAY ANYENUM ANYRANGE CSTRING INTERNAL RECORD PG_DDL_COMMAND VOID UNKNOWN OPAQUE REFCURSOR NAME OID REGPROC|10 REGPROCEDURE|10 REGOPER|10 REGOPERATOR|10 REGCLASS|10 REGTYPE|10 REGROLE|10 REGNAMESPACE|10 REGCONFIG|10 REGDICTIONARY|10 ", i = n.trim().split(" ").map(function(e) {
            return e.split("|")[0];
        }).join("|"), r = "ARRAY_AGG AVG BIT_AND BIT_OR BOOL_AND BOOL_OR COUNT EVERY JSON_AGG JSONB_AGG JSON_OBJECT_AGG JSONB_OBJECT_AGG MAX MIN MODE STRING_AGG SUM XMLAGG CORR COVAR_POP COVAR_SAMP REGR_AVGX REGR_AVGY REGR_COUNT REGR_INTERCEPT REGR_R2 REGR_SLOPE REGR_SXX REGR_SXY REGR_SYY STDDEV STDDEV_POP STDDEV_SAMP VARIANCE VAR_POP VAR_SAMP PERCENTILE_CONT PERCENTILE_DISC ROW_NUMBER RANK DENSE_RANK PERCENT_RANK CUME_DIST NTILE LAG LEAD FIRST_VALUE LAST_VALUE NTH_VALUE NUM_NONNULLS NUM_NULLS ABS CBRT CEIL CEILING DEGREES DIV EXP FLOOR LN LOG MOD PI POWER RADIANS ROUND SCALE SIGN SQRT TRUNC WIDTH_BUCKET RANDOM SETSEED ACOS ACOSD ASIN ASIND ATAN ATAND ATAN2 ATAN2D COS COSD COT COTD SIN SIND TAN TAND BIT_LENGTH CHAR_LENGTH CHARACTER_LENGTH LOWER OCTET_LENGTH OVERLAY POSITION SUBSTRING TREAT TRIM UPPER ASCII BTRIM CHR CONCAT CONCAT_WS CONVERT CONVERT_FROM CONVERT_TO DECODE ENCODE INITCAP LEFT LENGTH LPAD LTRIM MD5 PARSE_IDENT PG_CLIENT_ENCODING QUOTE_IDENT|10 QUOTE_LITERAL|10 QUOTE_NULLABLE|10 REGEXP_MATCH REGEXP_MATCHES REGEXP_REPLACE REGEXP_SPLIT_TO_ARRAY REGEXP_SPLIT_TO_TABLE REPEAT REPLACE REVERSE RIGHT RPAD RTRIM SPLIT_PART STRPOS SUBSTR TO_ASCII TO_HEX TRANSLATE OCTET_LENGTH GET_BIT GET_BYTE SET_BIT SET_BYTE TO_CHAR TO_DATE TO_NUMBER TO_TIMESTAMP AGE CLOCK_TIMESTAMP|10 DATE_PART DATE_TRUNC ISFINITE JUSTIFY_DAYS JUSTIFY_HOURS JUSTIFY_INTERVAL MAKE_DATE MAKE_INTERVAL|10 MAKE_TIME MAKE_TIMESTAMP|10 MAKE_TIMESTAMPTZ|10 NOW STATEMENT_TIMESTAMP|10 TIMEOFDAY TRANSACTION_TIMESTAMP|10 ENUM_FIRST ENUM_LAST ENUM_RANGE AREA CENTER DIAMETER HEIGHT ISCLOSED ISOPEN NPOINTS PCLOSE POPEN RADIUS WIDTH BOX BOUND_BOX CIRCLE LINE LSEG PATH POLYGON ABBREV BROADCAST HOST HOSTMASK MASKLEN NETMASK NETWORK SET_MASKLEN TEXT INET_SAME_FAMILY INET_MERGE MACADDR8_SET7BIT ARRAY_TO_TSVECTOR GET_CURRENT_TS_CONFIG NUMNODE PLAINTO_TSQUERY PHRASETO_TSQUERY WEBSEARCH_TO_TSQUERY QUERYTREE SETWEIGHT STRIP TO_TSQUERY TO_TSVECTOR JSON_TO_TSVECTOR JSONB_TO_TSVECTOR TS_DELETE TS_FILTER TS_HEADLINE TS_RANK TS_RANK_CD TS_REWRITE TSQUERY_PHRASE TSVECTOR_TO_ARRAY TSVECTOR_UPDATE_TRIGGER TSVECTOR_UPDATE_TRIGGER_COLUMN XMLCOMMENT XMLCONCAT XMLELEMENT XMLFOREST XMLPI XMLROOT XMLEXISTS XML_IS_WELL_FORMED XML_IS_WELL_FORMED_DOCUMENT XML_IS_WELL_FORMED_CONTENT XPATH XPATH_EXISTS XMLTABLE XMLNAMESPACES TABLE_TO_XML TABLE_TO_XMLSCHEMA TABLE_TO_XML_AND_XMLSCHEMA QUERY_TO_XML QUERY_TO_XMLSCHEMA QUERY_TO_XML_AND_XMLSCHEMA CURSOR_TO_XML CURSOR_TO_XMLSCHEMA SCHEMA_TO_XML SCHEMA_TO_XMLSCHEMA SCHEMA_TO_XML_AND_XMLSCHEMA DATABASE_TO_XML DATABASE_TO_XMLSCHEMA DATABASE_TO_XML_AND_XMLSCHEMA XMLATTRIBUTES TO_JSON TO_JSONB ARRAY_TO_JSON ROW_TO_JSON JSON_BUILD_ARRAY JSONB_BUILD_ARRAY JSON_BUILD_OBJECT JSONB_BUILD_OBJECT JSON_OBJECT JSONB_OBJECT JSON_ARRAY_LENGTH JSONB_ARRAY_LENGTH JSON_EACH JSONB_EACH JSON_EACH_TEXT JSONB_EACH_TEXT JSON_EXTRACT_PATH JSONB_EXTRACT_PATH JSON_OBJECT_KEYS JSONB_OBJECT_KEYS JSON_POPULATE_RECORD JSONB_POPULATE_RECORD JSON_POPULATE_RECORDSET JSONB_POPULATE_RECORDSET JSON_ARRAY_ELEMENTS JSONB_ARRAY_ELEMENTS JSON_ARRAY_ELEMENTS_TEXT JSONB_ARRAY_ELEMENTS_TEXT JSON_TYPEOF JSONB_TYPEOF JSON_TO_RECORD JSONB_TO_RECORD JSON_TO_RECORDSET JSONB_TO_RECORDSET JSON_STRIP_NULLS JSONB_STRIP_NULLS JSONB_SET JSONB_INSERT JSONB_PRETTY CURRVAL LASTVAL NEXTVAL SETVAL COALESCE NULLIF GREATEST LEAST ARRAY_APPEND ARRAY_CAT ARRAY_NDIMS ARRAY_DIMS ARRAY_FILL ARRAY_LENGTH ARRAY_LOWER ARRAY_POSITION ARRAY_POSITIONS ARRAY_PREPEND ARRAY_REMOVE ARRAY_REPLACE ARRAY_TO_STRING ARRAY_UPPER CARDINALITY STRING_TO_ARRAY UNNEST ISEMPTY LOWER_INC UPPER_INC LOWER_INF UPPER_INF RANGE_MERGE GENERATE_SERIES GENERATE_SUBSCRIPTS CURRENT_DATABASE CURRENT_QUERY CURRENT_SCHEMA|10 CURRENT_SCHEMAS|10 INET_CLIENT_ADDR INET_CLIENT_PORT INET_SERVER_ADDR INET_SERVER_PORT ROW_SECURITY_ACTIVE FORMAT_TYPE TO_REGCLASS TO_REGPROC TO_REGPROCEDURE TO_REGOPER TO_REGOPERATOR TO_REGTYPE TO_REGNAMESPACE TO_REGROLE COL_DESCRIPTION OBJ_DESCRIPTION SHOBJ_DESCRIPTION TXID_CURRENT TXID_CURRENT_IF_ASSIGNED TXID_CURRENT_SNAPSHOT TXID_SNAPSHOT_XIP TXID_SNAPSHOT_XMAX TXID_SNAPSHOT_XMIN TXID_VISIBLE_IN_SNAPSHOT TXID_STATUS CURRENT_SETTING SET_CONFIG BRIN_SUMMARIZE_NEW_VALUES BRIN_SUMMARIZE_RANGE BRIN_DESUMMARIZE_RANGE GIN_CLEAN_PENDING_LIST SUPPRESS_REDUNDANT_UPDATES_TRIGGER LO_FROM_BYTEA LO_PUT LO_GET LO_CREAT LO_CREATE LO_UNLINK LO_IMPORT LO_EXPORT LOREAD LOWRITE GROUPING CAST ".trim().split(" ").map(function(e) {
            return e.split("|")[0];
        }).join("|");
        return {
            name: "PostgreSQL",
            aliases: [
                "postgres",
                "postgresql"
            ],
            supersetOf: "sql",
            case_insensitive: !0,
            keywords: {
                keyword: "ABORT ALTER ANALYZE BEGIN CALL CHECKPOINT|10 CLOSE CLUSTER COMMENT COMMIT COPY CREATE DEALLOCATE DECLARE DELETE DISCARD DO DROP END EXECUTE EXPLAIN FETCH GRANT IMPORT INSERT LISTEN LOAD LOCK MOVE NOTIFY PREPARE REASSIGN|10 REFRESH REINDEX RELEASE RESET REVOKE ROLLBACK SAVEPOINT SECURITY SELECT SET SHOW START TRUNCATE UNLISTEN|10 UPDATE VACUUM|10 VALUES AGGREGATE COLLATION CONVERSION|10 DATABASE DEFAULT PRIVILEGES DOMAIN TRIGGER EXTENSION FOREIGN WRAPPER|10 TABLE FUNCTION GROUP LANGUAGE LARGE OBJECT MATERIALIZED VIEW OPERATOR CLASS FAMILY POLICY PUBLICATION|10 ROLE RULE SCHEMA SEQUENCE SERVER STATISTICS SUBSCRIPTION SYSTEM TABLESPACE CONFIGURATION DICTIONARY PARSER TEMPLATE TYPE USER MAPPING PREPARED ACCESS METHOD CAST AS TRANSFORM TRANSACTION OWNED TO INTO SESSION AUTHORIZATION INDEX PROCEDURE ASSERTION ALL ANALYSE AND ANY ARRAY ASC ASYMMETRIC|10 BOTH CASE CHECK COLLATE COLUMN CONCURRENTLY|10 CONSTRAINT CROSS DEFERRABLE RANGE DESC DISTINCT ELSE EXCEPT FOR FREEZE|10 FROM FULL HAVING ILIKE IN INITIALLY INNER INTERSECT IS ISNULL JOIN LATERAL LEADING LIKE LIMIT NATURAL NOT NOTNULL NULL OFFSET ON ONLY OR ORDER OUTER OVERLAPS PLACING PRIMARY REFERENCES RETURNING SIMILAR SOME SYMMETRIC TABLESAMPLE THEN TRAILING UNION UNIQUE USING VARIADIC|10 VERBOSE WHEN WHERE WINDOW WITH BY RETURNS INOUT OUT SETOF|10 IF STRICT CURRENT CONTINUE OWNER LOCATION OVER PARTITION WITHIN BETWEEN ESCAPE EXTERNAL INVOKER DEFINER WORK RENAME VERSION CONNECTION CONNECT TABLES TEMP TEMPORARY FUNCTIONS SEQUENCES TYPES SCHEMAS OPTION CASCADE RESTRICT ADD ADMIN EXISTS VALID VALIDATE ENABLE DISABLE REPLICA|10 ALWAYS PASSING COLUMNS PATH REF VALUE OVERRIDING IMMUTABLE STABLE VOLATILE BEFORE AFTER EACH ROW PROCEDURAL ROUTINE NO HANDLER VALIDATOR OPTIONS STORAGE OIDS|10 WITHOUT INHERIT DEPENDS CALLED INPUT LEAKPROOF|10 COST ROWS NOWAIT SEARCH UNTIL ENCRYPTED|10 PASSWORD CONFLICT|10 INSTEAD INHERITS CHARACTERISTICS WRITE CURSOR ALSO STATEMENT SHARE EXCLUSIVE INLINE ISOLATION REPEATABLE READ COMMITTED SERIALIZABLE UNCOMMITTED LOCAL GLOBAL SQL PROCEDURES RECURSIVE SNAPSHOT ROLLUP CUBE TRUSTED|10 INCLUDE FOLLOWING PRECEDING UNBOUNDED RANGE GROUPS UNENCRYPTED|10 SYSID FORMAT DELIMITER HEADER QUOTE ENCODING FILTER OFF FORCE_QUOTE FORCE_NOT_NULL FORCE_NULL COSTS BUFFERS TIMING SUMMARY DISABLE_PAGE_SKIPPING RESTART CYCLE GENERATED IDENTITY DEFERRED IMMEDIATE LEVEL LOGGED UNLOGGED OF NOTHING NONE EXCLUDE ATTRIBUTE USAGE ROUTINES TRUE FALSE NAN INFINITY ALIAS BEGIN CONSTANT DECLARE END EXCEPTION RETURN PERFORM|10 RAISE GET DIAGNOSTICS STACKED|10 FOREACH LOOP ELSIF EXIT WHILE REVERSE SLICE DEBUG LOG INFO NOTICE WARNING ASSERT OPEN SUPERUSER NOSUPERUSER CREATEDB NOCREATEDB CREATEROLE NOCREATEROLE INHERIT NOINHERIT LOGIN NOLOGIN REPLICATION NOREPLICATION BYPASSRLS NOBYPASSRLS ",
                built_in: "CURRENT_TIME CURRENT_TIMESTAMP CURRENT_USER CURRENT_CATALOG|10 CURRENT_DATE LOCALTIME LOCALTIMESTAMP CURRENT_ROLE|10 CURRENT_SCHEMA|10 SESSION_USER PUBLIC FOUND NEW OLD TG_NAME|10 TG_WHEN|10 TG_LEVEL|10 TG_OP|10 TG_RELID|10 TG_RELNAME|10 TG_TABLE_NAME|10 TG_TABLE_SCHEMA|10 TG_NARGS|10 TG_ARGV|10 TG_EVENT|10 TG_TAG|10 ROW_COUNT RESULT_OID|10 PG_CONTEXT|10 RETURNED_SQLSTATE COLUMN_NAME CONSTRAINT_NAME PG_DATATYPE_NAME|10 MESSAGE_TEXT TABLE_NAME SCHEMA_NAME PG_EXCEPTION_DETAIL|10 PG_EXCEPTION_HINT|10 PG_EXCEPTION_CONTEXT|10 SQLSTATE SQLERRM|10 SUCCESSFUL_COMPLETION WARNING DYNAMIC_RESULT_SETS_RETURNED IMPLICIT_ZERO_BIT_PADDING NULL_VALUE_ELIMINATED_IN_SET_FUNCTION PRIVILEGE_NOT_GRANTED PRIVILEGE_NOT_REVOKED STRING_DATA_RIGHT_TRUNCATION DEPRECATED_FEATURE NO_DATA NO_ADDITIONAL_DYNAMIC_RESULT_SETS_RETURNED SQL_STATEMENT_NOT_YET_COMPLETE CONNECTION_EXCEPTION CONNECTION_DOES_NOT_EXIST CONNECTION_FAILURE SQLCLIENT_UNABLE_TO_ESTABLISH_SQLCONNECTION SQLSERVER_REJECTED_ESTABLISHMENT_OF_SQLCONNECTION TRANSACTION_RESOLUTION_UNKNOWN PROTOCOL_VIOLATION TRIGGERED_ACTION_EXCEPTION FEATURE_NOT_SUPPORTED INVALID_TRANSACTION_INITIATION LOCATOR_EXCEPTION INVALID_LOCATOR_SPECIFICATION INVALID_GRANTOR INVALID_GRANT_OPERATION INVALID_ROLE_SPECIFICATION DIAGNOSTICS_EXCEPTION STACKED_DIAGNOSTICS_ACCESSED_WITHOUT_ACTIVE_HANDLER CASE_NOT_FOUND CARDINALITY_VIOLATION DATA_EXCEPTION ARRAY_SUBSCRIPT_ERROR CHARACTER_NOT_IN_REPERTOIRE DATETIME_FIELD_OVERFLOW DIVISION_BY_ZERO ERROR_IN_ASSIGNMENT ESCAPE_CHARACTER_CONFLICT INDICATOR_OVERFLOW INTERVAL_FIELD_OVERFLOW INVALID_ARGUMENT_FOR_LOGARITHM INVALID_ARGUMENT_FOR_NTILE_FUNCTION INVALID_ARGUMENT_FOR_NTH_VALUE_FUNCTION INVALID_ARGUMENT_FOR_POWER_FUNCTION INVALID_ARGUMENT_FOR_WIDTH_BUCKET_FUNCTION INVALID_CHARACTER_VALUE_FOR_CAST INVALID_DATETIME_FORMAT INVALID_ESCAPE_CHARACTER INVALID_ESCAPE_OCTET INVALID_ESCAPE_SEQUENCE NONSTANDARD_USE_OF_ESCAPE_CHARACTER INVALID_INDICATOR_PARAMETER_VALUE INVALID_PARAMETER_VALUE INVALID_REGULAR_EXPRESSION INVALID_ROW_COUNT_IN_LIMIT_CLAUSE INVALID_ROW_COUNT_IN_RESULT_OFFSET_CLAUSE INVALID_TABLESAMPLE_ARGUMENT INVALID_TABLESAMPLE_REPEAT INVALID_TIME_ZONE_DISPLACEMENT_VALUE INVALID_USE_OF_ESCAPE_CHARACTER MOST_SPECIFIC_TYPE_MISMATCH NULL_VALUE_NOT_ALLOWED NULL_VALUE_NO_INDICATOR_PARAMETER NUMERIC_VALUE_OUT_OF_RANGE SEQUENCE_GENERATOR_LIMIT_EXCEEDED STRING_DATA_LENGTH_MISMATCH STRING_DATA_RIGHT_TRUNCATION SUBSTRING_ERROR TRIM_ERROR UNTERMINATED_C_STRING ZERO_LENGTH_CHARACTER_STRING FLOATING_POINT_EXCEPTION INVALID_TEXT_REPRESENTATION INVALID_BINARY_REPRESENTATION BAD_COPY_FILE_FORMAT UNTRANSLATABLE_CHARACTER NOT_AN_XML_DOCUMENT INVALID_XML_DOCUMENT INVALID_XML_CONTENT INVALID_XML_COMMENT INVALID_XML_PROCESSING_INSTRUCTION INTEGRITY_CONSTRAINT_VIOLATION RESTRICT_VIOLATION NOT_NULL_VIOLATION FOREIGN_KEY_VIOLATION UNIQUE_VIOLATION CHECK_VIOLATION EXCLUSION_VIOLATION INVALID_CURSOR_STATE INVALID_TRANSACTION_STATE ACTIVE_SQL_TRANSACTION BRANCH_TRANSACTION_ALREADY_ACTIVE HELD_CURSOR_REQUIRES_SAME_ISOLATION_LEVEL INAPPROPRIATE_ACCESS_MODE_FOR_BRANCH_TRANSACTION INAPPROPRIATE_ISOLATION_LEVEL_FOR_BRANCH_TRANSACTION NO_ACTIVE_SQL_TRANSACTION_FOR_BRANCH_TRANSACTION READ_ONLY_SQL_TRANSACTION SCHEMA_AND_DATA_STATEMENT_MIXING_NOT_SUPPORTED NO_ACTIVE_SQL_TRANSACTION IN_FAILED_SQL_TRANSACTION IDLE_IN_TRANSACTION_SESSION_TIMEOUT INVALID_SQL_STATEMENT_NAME TRIGGERED_DATA_CHANGE_VIOLATION INVALID_AUTHORIZATION_SPECIFICATION INVALID_PASSWORD DEPENDENT_PRIVILEGE_DESCRIPTORS_STILL_EXIST DEPENDENT_OBJECTS_STILL_EXIST INVALID_TRANSACTION_TERMINATION SQL_ROUTINE_EXCEPTION FUNCTION_EXECUTED_NO_RETURN_STATEMENT MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED INVALID_CURSOR_NAME EXTERNAL_ROUTINE_EXCEPTION CONTAINING_SQL_NOT_PERMITTED MODIFYING_SQL_DATA_NOT_PERMITTED PROHIBITED_SQL_STATEMENT_ATTEMPTED READING_SQL_DATA_NOT_PERMITTED EXTERNAL_ROUTINE_INVOCATION_EXCEPTION INVALID_SQLSTATE_RETURNED NULL_VALUE_NOT_ALLOWED TRIGGER_PROTOCOL_VIOLATED SRF_PROTOCOL_VIOLATED EVENT_TRIGGER_PROTOCOL_VIOLATED SAVEPOINT_EXCEPTION INVALID_SAVEPOINT_SPECIFICATION INVALID_CATALOG_NAME INVALID_SCHEMA_NAME TRANSACTION_ROLLBACK TRANSACTION_INTEGRITY_CONSTRAINT_VIOLATION SERIALIZATION_FAILURE STATEMENT_COMPLETION_UNKNOWN DEADLOCK_DETECTED SYNTAX_ERROR_OR_ACCESS_RULE_VIOLATION SYNTAX_ERROR INSUFFICIENT_PRIVILEGE CANNOT_COERCE GROUPING_ERROR WINDOWING_ERROR INVALID_RECURSION INVALID_FOREIGN_KEY INVALID_NAME NAME_TOO_LONG RESERVED_NAME DATATYPE_MISMATCH INDETERMINATE_DATATYPE COLLATION_MISMATCH INDETERMINATE_COLLATION WRONG_OBJECT_TYPE GENERATED_ALWAYS UNDEFINED_COLUMN UNDEFINED_FUNCTION UNDEFINED_TABLE UNDEFINED_PARAMETER UNDEFINED_OBJECT DUPLICATE_COLUMN DUPLICATE_CURSOR DUPLICATE_DATABASE DUPLICATE_FUNCTION DUPLICATE_PREPARED_STATEMENT DUPLICATE_SCHEMA DUPLICATE_TABLE DUPLICATE_ALIAS DUPLICATE_OBJECT AMBIGUOUS_COLUMN AMBIGUOUS_FUNCTION AMBIGUOUS_PARAMETER AMBIGUOUS_ALIAS INVALID_COLUMN_REFERENCE INVALID_COLUMN_DEFINITION INVALID_CURSOR_DEFINITION INVALID_DATABASE_DEFINITION INVALID_FUNCTION_DEFINITION INVALID_PREPARED_STATEMENT_DEFINITION INVALID_SCHEMA_DEFINITION INVALID_TABLE_DEFINITION INVALID_OBJECT_DEFINITION WITH_CHECK_OPTION_VIOLATION INSUFFICIENT_RESOURCES DISK_FULL OUT_OF_MEMORY TOO_MANY_CONNECTIONS CONFIGURATION_LIMIT_EXCEEDED PROGRAM_LIMIT_EXCEEDED STATEMENT_TOO_COMPLEX TOO_MANY_COLUMNS TOO_MANY_ARGUMENTS OBJECT_NOT_IN_PREREQUISITE_STATE OBJECT_IN_USE CANT_CHANGE_RUNTIME_PARAM LOCK_NOT_AVAILABLE OPERATOR_INTERVENTION QUERY_CANCELED ADMIN_SHUTDOWN CRASH_SHUTDOWN CANNOT_CONNECT_NOW DATABASE_DROPPED SYSTEM_ERROR IO_ERROR UNDEFINED_FILE DUPLICATE_FILE SNAPSHOT_TOO_OLD CONFIG_FILE_ERROR LOCK_FILE_EXISTS FDW_ERROR FDW_COLUMN_NAME_NOT_FOUND FDW_DYNAMIC_PARAMETER_VALUE_NEEDED FDW_FUNCTION_SEQUENCE_ERROR FDW_INCONSISTENT_DESCRIPTOR_INFORMATION FDW_INVALID_ATTRIBUTE_VALUE FDW_INVALID_COLUMN_NAME FDW_INVALID_COLUMN_NUMBER FDW_INVALID_DATA_TYPE FDW_INVALID_DATA_TYPE_DESCRIPTORS FDW_INVALID_DESCRIPTOR_FIELD_IDENTIFIER FDW_INVALID_HANDLE FDW_INVALID_OPTION_INDEX FDW_INVALID_OPTION_NAME FDW_INVALID_STRING_LENGTH_OR_BUFFER_LENGTH FDW_INVALID_STRING_FORMAT FDW_INVALID_USE_OF_NULL_POINTER FDW_TOO_MANY_HANDLES FDW_OUT_OF_MEMORY FDW_NO_SCHEMAS FDW_OPTION_NAME_NOT_FOUND FDW_REPLY_HANDLE FDW_SCHEMA_NOT_FOUND FDW_TABLE_NOT_FOUND FDW_UNABLE_TO_CREATE_EXECUTION FDW_UNABLE_TO_CREATE_REPLY FDW_UNABLE_TO_ESTABLISH_CONNECTION PLPGSQL_ERROR RAISE_EXCEPTION NO_DATA_FOUND TOO_MANY_ROWS ASSERT_FAILURE INTERNAL_ERROR DATA_CORRUPTED INDEX_CORRUPTED "
            },
            illegal: /:==|\W\s*\(\*|(^|\s)\$[a-z]|\{\{|[a-z]:\s*$|\.\.\.|TO:|DO:/,
            contains: [
                {
                    className: "keyword",
                    variants: [
                        {
                            begin: /\bTEXT\s*SEARCH\b/
                        },
                        {
                            begin: /\b(PRIMARY|FOREIGN|FOR(\s+NO)?)\s+KEY\b/
                        },
                        {
                            begin: /\bPARALLEL\s+(UNSAFE|RESTRICTED|SAFE)\b/
                        },
                        {
                            begin: /\bSTORAGE\s+(PLAIN|EXTERNAL|EXTENDED|MAIN)\b/
                        },
                        {
                            begin: /\bMATCH\s+(FULL|PARTIAL|SIMPLE)\b/
                        },
                        {
                            begin: /\bNULLS\s+(FIRST|LAST)\b/
                        },
                        {
                            begin: /\bEVENT\s+TRIGGER\b/
                        },
                        {
                            begin: /\b(MAPPING|OR)\s+REPLACE\b/
                        },
                        {
                            begin: /\b(FROM|TO)\s+(PROGRAM|STDIN|STDOUT)\b/
                        },
                        {
                            begin: /\b(SHARE|EXCLUSIVE)\s+MODE\b/
                        },
                        {
                            begin: /\b(LEFT|RIGHT)\s+(OUTER\s+)?JOIN\b/
                        },
                        {
                            begin: /\b(FETCH|MOVE)\s+(NEXT|PRIOR|FIRST|LAST|ABSOLUTE|RELATIVE|FORWARD|BACKWARD)\b/
                        },
                        {
                            begin: /\bPRESERVE\s+ROWS\b/
                        },
                        {
                            begin: /\bDISCARD\s+PLANS\b/
                        },
                        {
                            begin: /\bREFERENCING\s+(OLD|NEW)\b/
                        },
                        {
                            begin: /\bSKIP\s+LOCKED\b/
                        },
                        {
                            begin: /\bGROUPING\s+SETS\b/
                        },
                        {
                            begin: /\b(BINARY|INSENSITIVE|SCROLL|NO\s+SCROLL)\s+(CURSOR|FOR)\b/
                        },
                        {
                            begin: /\b(WITH|WITHOUT)\s+HOLD\b/
                        },
                        {
                            begin: /\bWITH\s+(CASCADED|LOCAL)\s+CHECK\s+OPTION\b/
                        },
                        {
                            begin: /\bEXCLUDE\s+(TIES|NO\s+OTHERS)\b/
                        },
                        {
                            begin: /\bFORMAT\s+(TEXT|XML|JSON|YAML)\b/
                        },
                        {
                            begin: /\bSET\s+((SESSION|LOCAL)\s+)?NAMES\b/
                        },
                        {
                            begin: /\bIS\s+(NOT\s+)?UNKNOWN\b/
                        },
                        {
                            begin: /\bSECURITY\s+LABEL\b/
                        },
                        {
                            begin: /\bSTANDALONE\s+(YES|NO|NO\s+VALUE)\b/
                        },
                        {
                            begin: /\bWITH\s+(NO\s+)?DATA\b/
                        },
                        {
                            begin: /\b(FOREIGN|SET)\s+DATA\b/
                        },
                        {
                            begin: /\bSET\s+(CATALOG|CONSTRAINTS)\b/
                        },
                        {
                            begin: /\b(WITH|FOR)\s+ORDINALITY\b/
                        },
                        {
                            begin: /\bIS\s+(NOT\s+)?DOCUMENT\b/
                        },
                        {
                            begin: /\bXML\s+OPTION\s+(DOCUMENT|CONTENT)\b/
                        },
                        {
                            begin: /\b(STRIP|PRESERVE)\s+WHITESPACE\b/
                        },
                        {
                            begin: /\bNO\s+(ACTION|MAXVALUE|MINVALUE)\b/
                        },
                        {
                            begin: /\bPARTITION\s+BY\s+(RANGE|LIST|HASH)\b/
                        },
                        {
                            begin: /\bAT\s+TIME\s+ZONE\b/
                        },
                        {
                            begin: /\bGRANTED\s+BY\b/
                        },
                        {
                            begin: /\bRETURN\s+(QUERY|NEXT)\b/
                        },
                        {
                            begin: /\b(ATTACH|DETACH)\s+PARTITION\b/
                        },
                        {
                            begin: /\bFORCE\s+ROW\s+LEVEL\s+SECURITY\b/
                        },
                        {
                            begin: /\b(INCLUDING|EXCLUDING)\s+(COMMENTS|CONSTRAINTS|DEFAULTS|IDENTITY|INDEXES|STATISTICS|STORAGE|ALL)\b/
                        },
                        {
                            begin: /\bAS\s+(ASSIGNMENT|IMPLICIT|PERMISSIVE|RESTRICTIVE|ENUM|RANGE)\b/
                        }
                    ]
                },
                {
                    begin: /\b(FORMAT|FAMILY|VERSION)\s*\(/
                },
                {
                    begin: /\bINCLUDE\s*\(/,
                    keywords: "INCLUDE"
                },
                {
                    begin: /\bRANGE(?!\s*(BETWEEN|UNBOUNDED|CURRENT|[-0-9]+))/
                },
                {
                    begin: /\b(VERSION|OWNER|TEMPLATE|TABLESPACE|CONNECTION\s+LIMIT|PROCEDURE|RESTRICT|JOIN|PARSER|COPY|START|END|COLLATION|INPUT|ANALYZE|STORAGE|LIKE|DEFAULT|DELIMITER|ENCODING|COLUMN|CONSTRAINT|TABLE|SCHEMA)\s*=/
                },
                {
                    begin: /\b(PG_\w+?|HAS_[A-Z_]+_PRIVILEGE)\b/,
                    relevance: 10
                },
                {
                    begin: /\bEXTRACT\s*\(/,
                    end: /\bFROM\b/,
                    returnEnd: !0,
                    keywords: {
                        type: "CENTURY DAY DECADE DOW DOY EPOCH HOUR ISODOW ISOYEAR MICROSECONDS MILLENNIUM MILLISECONDS MINUTE MONTH QUARTER SECOND TIMEZONE TIMEZONE_HOUR TIMEZONE_MINUTE WEEK YEAR"
                    }
                },
                {
                    begin: /\b(XMLELEMENT|XMLPI)\s*\(\s*NAME/,
                    keywords: {
                        keyword: "NAME"
                    }
                },
                {
                    begin: /\b(XMLPARSE|XMLSERIALIZE)\s*\(\s*(DOCUMENT|CONTENT)/,
                    keywords: {
                        keyword: "DOCUMENT CONTENT"
                    }
                },
                {
                    beginKeywords: "CACHE INCREMENT MAXVALUE MINVALUE",
                    end: e.C_NUMBER_RE,
                    returnEnd: !0,
                    keywords: "BY CACHE INCREMENT MAXVALUE MINVALUE"
                },
                {
                    className: "type",
                    begin: /\b(WITH|WITHOUT)\s+TIME\s+ZONE\b/
                },
                {
                    className: "type",
                    begin: /\bINTERVAL\s+(YEAR|MONTH|DAY|HOUR|MINUTE|SECOND)(\s+TO\s+(MONTH|HOUR|MINUTE|SECOND))?\b/
                },
                {
                    begin: /\bRETURNS\s+(LANGUAGE_HANDLER|TRIGGER|EVENT_TRIGGER|FDW_HANDLER|INDEX_AM_HANDLER|TSM_HANDLER)\b/,
                    keywords: {
                        keyword: "RETURNS",
                        type: "LANGUAGE_HANDLER TRIGGER EVENT_TRIGGER FDW_HANDLER INDEX_AM_HANDLER TSM_HANDLER"
                    }
                },
                {
                    begin: "\\b(" + r + ")\\s*\\("
                },
                {
                    begin: "\\.(" + i + ")\\b"
                },
                {
                    begin: "\\b(" + i + ")\\s+PATH\\b",
                    keywords: {
                        keyword: "PATH",
                        type: n.replace("PATH ", "")
                    }
                },
                {
                    className: "type",
                    begin: "\\b(" + i + ")\\b"
                },
                {
                    className: "string",
                    begin: "'",
                    end: "'",
                    contains: [
                        {
                            begin: "''"
                        }
                    ]
                },
                {
                    className: "string",
                    begin: "(e|E|u&|U&)'",
                    end: "'",
                    contains: [
                        {
                            begin: "\\\\."
                        }
                    ],
                    relevance: 10
                },
                e.END_SAME_AS_BEGIN({
                    begin: a,
                    end: a,
                    contains: [
                        {
                            subLanguage: [
                                "pgsql",
                                "perl",
                                "python",
                                "tcl",
                                "r",
                                "lua",
                                "java",
                                "php",
                                "ruby",
                                "bash",
                                "scheme",
                                "xml",
                                "json"
                            ],
                            endsWithParent: !0
                        }
                    ]
                }),
                {
                    begin: '"',
                    end: '"',
                    contains: [
                        {
                            begin: '""'
                        }
                    ]
                },
                e.C_NUMBER_MODE,
                e.C_BLOCK_COMMENT_MODE,
                t,
                {
                    className: "meta",
                    variants: [
                        {
                            begin: "%(ROW)?TYPE",
                            relevance: 10
                        },
                        {
                            begin: "\\$\\d+"
                        },
                        {
                            begin: "^#\\w",
                            end: "$"
                        }
                    ]
                },
                {
                    className: "symbol",
                    begin: "<<\\s*[a-zA-Z_][a-zA-Z_0-9$]*\\s*>>",
                    relevance: 10
                }
            ]
        };
    }), er)), Cs.registerLanguage("php", (nr || (nr = 1, ar = function(e) {
        const t = e.regex, a = /(?![A-Za-z0-9])(?![$])/, n = t.concat(/[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/, a), i = t.concat(/(\\?[A-Z][a-z0-9_\x7f-\xff]+|\\?[A-Z]+(?=[A-Z][a-z0-9_\x7f-\xff])){1,}/, a), r = {
            scope: "variable",
            match: "\\$+" + n
        }, o = {
            scope: "subst",
            variants: [
                {
                    begin: /\$\w+/
                },
                {
                    begin: /\{\$/,
                    end: /\}/
                }
            ]
        }, s = e.inherit(e.APOS_STRING_MODE, {
            illegal: null
        }), l = "[ \t\n]", c = {
            scope: "string",
            variants: [
                e.inherit(e.QUOTE_STRING_MODE, {
                    illegal: null,
                    contains: e.QUOTE_STRING_MODE.contains.concat(o)
                }),
                s,
                {
                    begin: /<<<[ \t]*(?:(\w+)|"(\w+)")\n/,
                    end: /[ \t]*(\w+)\b/,
                    contains: e.QUOTE_STRING_MODE.contains.concat(o),
                    "on:begin": (e, t)=>{
                        t.data._beginMatch = e[1] || e[2];
                    },
                    "on:end": (e, t)=>{
                        t.data._beginMatch !== e[1] && t.ignoreMatch();
                    }
                },
                e.END_SAME_AS_BEGIN({
                    begin: /<<<[ \t]*'(\w+)'\n/,
                    end: /[ \t]*(\w+)\b/
                })
            ]
        }, _ = {
            scope: "number",
            variants: [
                {
                    begin: "\\b0[bB][01]+(?:_[01]+)*\\b"
                },
                {
                    begin: "\\b0[oO][0-7]+(?:_[0-7]+)*\\b"
                },
                {
                    begin: "\\b0[xX][\\da-fA-F]+(?:_[\\da-fA-F]+)*\\b"
                },
                {
                    begin: "(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:[eE][+-]?\\d+)?"
                }
            ],
            relevance: 0
        }, d = [
            "false",
            "null",
            "true"
        ], m = [
            "__CLASS__",
            "__DIR__",
            "__FILE__",
            "__FUNCTION__",
            "__COMPILER_HALT_OFFSET__",
            "__LINE__",
            "__METHOD__",
            "__NAMESPACE__",
            "__TRAIT__",
            "die",
            "echo",
            "exit",
            "include",
            "include_once",
            "print",
            "require",
            "require_once",
            "array",
            "abstract",
            "and",
            "as",
            "binary",
            "bool",
            "boolean",
            "break",
            "callable",
            "case",
            "catch",
            "class",
            "clone",
            "const",
            "continue",
            "declare",
            "default",
            "do",
            "double",
            "else",
            "elseif",
            "empty",
            "enddeclare",
            "endfor",
            "endforeach",
            "endif",
            "endswitch",
            "endwhile",
            "enum",
            "eval",
            "extends",
            "final",
            "finally",
            "float",
            "for",
            "foreach",
            "from",
            "global",
            "goto",
            "if",
            "implements",
            "instanceof",
            "insteadof",
            "int",
            "integer",
            "interface",
            "isset",
            "iterable",
            "list",
            "match|0",
            "mixed",
            "new",
            "never",
            "object",
            "or",
            "private",
            "protected",
            "public",
            "readonly",
            "real",
            "return",
            "string",
            "switch",
            "throw",
            "trait",
            "try",
            "unset",
            "use",
            "var",
            "void",
            "while",
            "xor",
            "yield"
        ], p = [
            "Error|0",
            "AppendIterator",
            "ArgumentCountError",
            "ArithmeticError",
            "ArrayIterator",
            "ArrayObject",
            "AssertionError",
            "BadFunctionCallException",
            "BadMethodCallException",
            "CachingIterator",
            "CallbackFilterIterator",
            "CompileError",
            "Countable",
            "DirectoryIterator",
            "DivisionByZeroError",
            "DomainException",
            "EmptyIterator",
            "ErrorException",
            "Exception",
            "FilesystemIterator",
            "FilterIterator",
            "GlobIterator",
            "InfiniteIterator",
            "InvalidArgumentException",
            "IteratorIterator",
            "LengthException",
            "LimitIterator",
            "LogicException",
            "MultipleIterator",
            "NoRewindIterator",
            "OutOfBoundsException",
            "OutOfRangeException",
            "OuterIterator",
            "OverflowException",
            "ParentIterator",
            "ParseError",
            "RangeException",
            "RecursiveArrayIterator",
            "RecursiveCachingIterator",
            "RecursiveCallbackFilterIterator",
            "RecursiveDirectoryIterator",
            "RecursiveFilterIterator",
            "RecursiveIterator",
            "RecursiveIteratorIterator",
            "RecursiveRegexIterator",
            "RecursiveTreeIterator",
            "RegexIterator",
            "RuntimeException",
            "SeekableIterator",
            "SplDoublyLinkedList",
            "SplFileInfo",
            "SplFileObject",
            "SplFixedArray",
            "SplHeap",
            "SplMaxHeap",
            "SplMinHeap",
            "SplObjectStorage",
            "SplObserver",
            "SplPriorityQueue",
            "SplQueue",
            "SplStack",
            "SplSubject",
            "SplTempFileObject",
            "TypeError",
            "UnderflowException",
            "UnexpectedValueException",
            "UnhandledMatchError",
            "ArrayAccess",
            "BackedEnum",
            "Closure",
            "Fiber",
            "Generator",
            "Iterator",
            "IteratorAggregate",
            "Serializable",
            "Stringable",
            "Throwable",
            "Traversable",
            "UnitEnum",
            "WeakReference",
            "WeakMap",
            "Directory",
            "__PHP_Incomplete_Class",
            "parent",
            "php_user_filter",
            "self",
            "static",
            "stdClass"
        ], u = {
            keyword: m,
            literal: ((e)=>{
                const t = [];
                return e.forEach((e)=>{
                    t.push(e), e.toLowerCase() === e ? t.push(e.toUpperCase()) : t.push(e.toLowerCase());
                }), t;
            })(d),
            built_in: p
        }, g = (e)=>e.map((e)=>e.replace(/\|\d+$/, "")), E = {
            variants: [
                {
                    match: [
                        /new/,
                        t.concat(l, "+"),
                        t.concat("(?!", g(p).join("\\b|"), "\\b)"),
                        i
                    ],
                    scope: {
                        1: "keyword",
                        4: "title.class"
                    }
                }
            ]
        }, S = t.concat(n, "\\b(?!\\()"), b = {
            variants: [
                {
                    match: [
                        t.concat(/::/, t.lookahead(/(?!class\b)/)),
                        S
                    ],
                    scope: {
                        2: "variable.constant"
                    }
                },
                {
                    match: [
                        /::/,
                        /class/
                    ],
                    scope: {
                        2: "variable.language"
                    }
                },
                {
                    match: [
                        i,
                        t.concat(/::/, t.lookahead(/(?!class\b)/)),
                        S
                    ],
                    scope: {
                        1: "title.class",
                        3: "variable.constant"
                    }
                },
                {
                    match: [
                        i,
                        t.concat("::", t.lookahead(/(?!class\b)/))
                    ],
                    scope: {
                        1: "title.class"
                    }
                },
                {
                    match: [
                        i,
                        /::/,
                        /class/
                    ],
                    scope: {
                        1: "title.class",
                        3: "variable.language"
                    }
                }
            ]
        }, T = {
            scope: "attr",
            match: t.concat(n, t.lookahead(":"), t.lookahead(/(?!::)/))
        }, C = {
            relevance: 0,
            begin: /\(/,
            end: /\)/,
            keywords: u,
            contains: [
                T,
                r,
                b,
                e.C_BLOCK_COMMENT_MODE,
                c,
                _,
                E
            ]
        }, f = {
            relevance: 0,
            match: [
                /\b/,
                t.concat("(?!fn\\b|function\\b|", g(m).join("\\b|"), "|", g(p).join("\\b|"), "\\b)"),
                n,
                t.concat(l, "*"),
                t.lookahead(/(?=\()/)
            ],
            scope: {
                3: "title.function.invoke"
            },
            contains: [
                C
            ]
        };
        C.contains.push(f);
        const R = [
            T,
            b,
            e.C_BLOCK_COMMENT_MODE,
            c,
            _,
            E
        ];
        return {
            case_insensitive: !1,
            keywords: u,
            contains: [
                {
                    begin: t.concat(/#\[\s*/, i),
                    beginScope: "meta",
                    end: /]/,
                    endScope: "meta",
                    keywords: {
                        literal: d,
                        keyword: [
                            "new",
                            "array"
                        ]
                    },
                    contains: [
                        {
                            begin: /\[/,
                            end: /]/,
                            keywords: {
                                literal: d,
                                keyword: [
                                    "new",
                                    "array"
                                ]
                            },
                            contains: [
                                "self",
                                ...R
                            ]
                        },
                        ...R,
                        {
                            scope: "meta",
                            match: i
                        }
                    ]
                },
                e.HASH_COMMENT_MODE,
                e.COMMENT("//", "$"),
                e.COMMENT("/\\*", "\\*/", {
                    contains: [
                        {
                            scope: "doctag",
                            match: "@[A-Za-z]+"
                        }
                    ]
                }),
                {
                    match: /__halt_compiler\(\);/,
                    keywords: "__halt_compiler",
                    starts: {
                        scope: "comment",
                        end: e.MATCH_NOTHING_RE,
                        contains: [
                            {
                                match: /\?>/,
                                scope: "meta",
                                endsParent: !0
                            }
                        ]
                    }
                },
                {
                    scope: "meta",
                    variants: [
                        {
                            begin: /<\?php/,
                            relevance: 10
                        },
                        {
                            begin: /<\?=/
                        },
                        {
                            begin: /<\?/,
                            relevance: .1
                        },
                        {
                            begin: /\?>/
                        }
                    ]
                },
                {
                    scope: "variable.language",
                    match: /\$this\b/
                },
                r,
                f,
                b,
                {
                    match: [
                        /const/,
                        /\s/,
                        n
                    ],
                    scope: {
                        1: "keyword",
                        3: "variable.constant"
                    }
                },
                E,
                {
                    scope: "function",
                    relevance: 0,
                    beginKeywords: "fn function",
                    end: /[;{]/,
                    excludeEnd: !0,
                    illegal: "[$%\\[]",
                    contains: [
                        {
                            beginKeywords: "use"
                        },
                        e.UNDERSCORE_TITLE_MODE,
                        {
                            begin: "=>",
                            endsParent: !0
                        },
                        {
                            scope: "params",
                            begin: "\\(",
                            end: "\\)",
                            excludeBegin: !0,
                            excludeEnd: !0,
                            keywords: u,
                            contains: [
                                "self",
                                r,
                                b,
                                e.C_BLOCK_COMMENT_MODE,
                                c,
                                _
                            ]
                        }
                    ]
                },
                {
                    scope: "class",
                    variants: [
                        {
                            beginKeywords: "enum",
                            illegal: /[($"]/
                        },
                        {
                            beginKeywords: "class interface trait",
                            illegal: /[:($"]/
                        }
                    ],
                    relevance: 0,
                    end: /\{/,
                    excludeEnd: !0,
                    contains: [
                        {
                            beginKeywords: "extends implements"
                        },
                        e.UNDERSCORE_TITLE_MODE
                    ]
                },
                {
                    beginKeywords: "namespace",
                    relevance: 0,
                    end: ";",
                    illegal: /[.']/,
                    contains: [
                        e.inherit(e.UNDERSCORE_TITLE_MODE, {
                            scope: "title.class"
                        })
                    ]
                },
                {
                    beginKeywords: "use",
                    relevance: 0,
                    end: ";",
                    contains: [
                        {
                            match: /\b(as|const|function)\b/,
                            scope: "keyword"
                        },
                        e.UNDERSCORE_TITLE_MODE
                    ]
                },
                c,
                _
            ]
        };
    }), ar)), Cs.registerLanguage("php-template", (rr || (rr = 1, ir = function(e) {
        return {
            name: "PHP template",
            subLanguage: "xml",
            contains: [
                {
                    begin: /<\?(php|=)?/,
                    end: /\?>/,
                    subLanguage: "php",
                    contains: [
                        {
                            begin: "/\\*",
                            end: "\\*/",
                            skip: !0
                        },
                        {
                            begin: 'b"',
                            end: '"',
                            skip: !0
                        },
                        {
                            begin: "b'",
                            end: "'",
                            skip: !0
                        },
                        e.inherit(e.APOS_STRING_MODE, {
                            illegal: null,
                            className: null,
                            contains: null,
                            skip: !0
                        }),
                        e.inherit(e.QUOTE_STRING_MODE, {
                            illegal: null,
                            className: null,
                            contains: null,
                            skip: !0
                        })
                    ]
                }
            ]
        };
    }), ir)), Cs.registerLanguage("plaintext", sr ? or : (sr = 1, or = function(e) {
        return {
            name: "Plain text",
            aliases: [
                "text",
                "txt"
            ],
            disableAutodetect: !0
        };
    })), Cs.registerLanguage("pony", (cr || (cr = 1, lr = function(e) {
        return {
            name: "Pony",
            keywords: {
                keyword: "actor addressof and as be break class compile_error compile_intrinsic consume continue delegate digestof do else elseif embed end error for fun if ifdef in interface is isnt lambda let match new not object or primitive recover repeat return struct then trait try type until use var where while with xor",
                meta: "iso val tag trn box ref",
                literal: "this false true"
            },
            contains: [
                {
                    className: "type",
                    begin: "\\b_?[A-Z][\\w]*",
                    relevance: 0
                },
                {
                    className: "string",
                    begin: '"""',
                    end: '"""',
                    relevance: 10
                },
                {
                    className: "string",
                    begin: '"',
                    end: '"',
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    className: "string",
                    begin: "'",
                    end: "'",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ],
                    relevance: 0
                },
                {
                    begin: e.IDENT_RE + "'",
                    relevance: 0
                },
                {
                    className: "number",
                    begin: "(-?)(\\b0[xX][a-fA-F0-9]+|\\b0[bB][01]+|(\\b\\d+(_\\d+)?(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)",
                    relevance: 0
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE
            ]
        };
    }), lr)), Cs.registerLanguage("powershell", (dr || (dr = 1, _r = function(e) {
        const t = {
            $pattern: /-?[A-z\.\-]+\b/,
            keyword: "if else foreach return do while until elseif begin for trap data dynamicparam end break throw param continue finally in switch exit filter try process catch hidden static parameter",
            built_in: "ac asnp cat cd CFS chdir clc clear clhy cli clp cls clv cnsn compare copy cp cpi cpp curl cvpa dbp del diff dir dnsn ebp echo|0 epal epcsv epsn erase etsn exsn fc fhx fl ft fw gal gbp gc gcb gci gcm gcs gdr gerr ghy gi gin gjb gl gm gmo gp gps gpv group gsn gsnp gsv gtz gu gv gwmi h history icm iex ihy ii ipal ipcsv ipmo ipsn irm ise iwmi iwr kill lp ls man md measure mi mount move mp mv nal ndr ni nmo npssc nsn nv ogv oh popd ps pushd pwd r rbp rcjb rcsn rd rdr ren ri rjb rm rmdir rmo rni rnp rp rsn rsnp rujb rv rvpa rwmi sajb sal saps sasv sbp sc scb select set shcm si sl sleep sls sort sp spjb spps spsv start stz sujb sv swmi tee trcm type wget where wjb write"
        }, a = {
            begin: "`[\\s\\S]",
            relevance: 0
        }, n = {
            className: "variable",
            variants: [
                {
                    begin: /\$\B/
                },
                {
                    className: "keyword",
                    begin: /\$this/
                },
                {
                    begin: /\$[\w\d][\w\d_:]*/
                }
            ]
        }, i = {
            className: "string",
            variants: [
                {
                    begin: /"/,
                    end: /"/
                },
                {
                    begin: /@"/,
                    end: /^"@/
                }
            ],
            contains: [
                a,
                n,
                {
                    className: "variable",
                    begin: /\$[A-z]/,
                    end: /[^A-z]/
                }
            ]
        }, r = {
            className: "string",
            variants: [
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /@'/,
                    end: /^'@/
                }
            ]
        }, o = e.inherit(e.COMMENT(null, null), {
            variants: [
                {
                    begin: /#/,
                    end: /$/
                },
                {
                    begin: /<#/,
                    end: /#>/
                }
            ],
            contains: [
                {
                    className: "doctag",
                    variants: [
                        {
                            begin: /\.(synopsis|description|example|inputs|outputs|notes|link|component|role|functionality)/
                        },
                        {
                            begin: /\.(parameter|forwardhelptargetname|forwardhelpcategory|remotehelprunspace|externalhelp)\s+\S+/
                        }
                    ]
                }
            ]
        }), s = {
            className: "built_in",
            variants: [
                {
                    begin: "(".concat("Add|Clear|Close|Copy|Enter|Exit|Find|Format|Get|Hide|Join|Lock|Move|New|Open|Optimize|Pop|Push|Redo|Remove|Rename|Reset|Resize|Search|Select|Set|Show|Skip|Split|Step|Switch|Undo|Unlock|Watch|Backup|Checkpoint|Compare|Compress|Convert|ConvertFrom|ConvertTo|Dismount|Edit|Expand|Export|Group|Import|Initialize|Limit|Merge|Mount|Out|Publish|Restore|Save|Sync|Unpublish|Update|Approve|Assert|Build|Complete|Confirm|Deny|Deploy|Disable|Enable|Install|Invoke|Register|Request|Restart|Resume|Start|Stop|Submit|Suspend|Uninstall|Unregister|Wait|Debug|Measure|Ping|Repair|Resolve|Test|Trace|Connect|Disconnect|Read|Receive|Send|Write|Block|Grant|Protect|Revoke|Unblock|Unprotect|Use|ForEach|Sort|Tee|Where", ")+(-)[\\w\\d]+")
                }
            ]
        }, l = {
            className: "class",
            beginKeywords: "class enum",
            end: /\s*[{]/,
            excludeEnd: !0,
            relevance: 0,
            contains: [
                e.TITLE_MODE
            ]
        }, c = {
            className: "function",
            begin: /function\s+/,
            end: /\s*\{|$/,
            excludeEnd: !0,
            returnBegin: !0,
            relevance: 0,
            contains: [
                {
                    begin: "function",
                    relevance: 0,
                    className: "keyword"
                },
                {
                    className: "title",
                    begin: /\w[\w\d]*((-)[\w\d]+)*/,
                    relevance: 0
                },
                {
                    begin: /\(/,
                    end: /\)/,
                    className: "params",
                    relevance: 0,
                    contains: [
                        n
                    ]
                }
            ]
        }, _ = {
            begin: /using\s/,
            end: /$/,
            returnBegin: !0,
            contains: [
                i,
                r,
                {
                    className: "keyword",
                    begin: /(using|assembly|command|module|namespace|type)/
                }
            ]
        }, d = {
            variants: [
                {
                    className: "operator",
                    begin: "(".concat("-and|-as|-band|-bnot|-bor|-bxor|-casesensitive|-ccontains|-ceq|-cge|-cgt|-cle|-clike|-clt|-cmatch|-cne|-cnotcontains|-cnotlike|-cnotmatch|-contains|-creplace|-csplit|-eq|-exact|-f|-file|-ge|-gt|-icontains|-ieq|-ige|-igt|-ile|-ilike|-ilt|-imatch|-in|-ine|-inotcontains|-inotlike|-inotmatch|-ireplace|-is|-isnot|-isplit|-join|-le|-like|-lt|-match|-ne|-not|-notcontains|-notin|-notlike|-notmatch|-or|-regex|-replace|-shl|-shr|-split|-wildcard|-xor", ")\\b")
                },
                {
                    className: "literal",
                    begin: /(-){1,2}[\w\d-]+/,
                    relevance: 0
                }
            ]
        }, m = {
            className: "function",
            begin: /\[.*\]\s*[\w]+[ ]??\(/,
            end: /$/,
            returnBegin: !0,
            relevance: 0,
            contains: [
                {
                    className: "keyword",
                    begin: "(".concat(t.keyword.toString().replace(/\s/g, "|"), ")\\b"),
                    endsParent: !0,
                    relevance: 0
                },
                e.inherit(e.TITLE_MODE, {
                    endsParent: !0
                })
            ]
        }, p = [
            m,
            o,
            a,
            e.NUMBER_MODE,
            i,
            r,
            s,
            n,
            {
                className: "literal",
                begin: /\$(null|true|false)\b/
            },
            {
                className: "selector-tag",
                begin: /@\B/,
                relevance: 0
            }
        ], u = {
            begin: /\[/,
            end: /\]/,
            excludeBegin: !0,
            excludeEnd: !0,
            relevance: 0,
            contains: [].concat("self", p, {
                begin: "(" + [
                    "string",
                    "char",
                    "byte",
                    "int",
                    "long",
                    "bool",
                    "decimal",
                    "single",
                    "double",
                    "DateTime",
                    "xml",
                    "array",
                    "hashtable",
                    "void"
                ].join("|") + ")",
                className: "built_in",
                relevance: 0
            }, {
                className: "type",
                begin: /[\.\w\d]+/,
                relevance: 0
            })
        };
        return m.contains.unshift(u), {
            name: "PowerShell",
            aliases: [
                "pwsh",
                "ps",
                "ps1"
            ],
            case_insensitive: !0,
            keywords: t,
            contains: p.concat(l, c, _, d, u)
        };
    }), _r)), Cs.registerLanguage("processing", (pr || (pr = 1, mr = function(e) {
        const t = e.regex, a = [
            "displayHeight",
            "displayWidth",
            "mouseY",
            "mouseX",
            "mousePressed",
            "pmouseX",
            "pmouseY",
            "key",
            "keyCode",
            "pixels",
            "focused",
            "frameCount",
            "frameRate",
            "height",
            "width",
            "size",
            "createGraphics",
            "beginDraw",
            "createShape",
            "loadShape",
            "PShape",
            "arc",
            "ellipse",
            "line",
            "point",
            "quad",
            "rect",
            "triangle",
            "bezier",
            "bezierDetail",
            "bezierPoint",
            "bezierTangent",
            "curve",
            "curveDetail",
            "curvePoint",
            "curveTangent",
            "curveTightness",
            "shape",
            "shapeMode",
            "beginContour",
            "beginShape",
            "bezierVertex",
            "curveVertex",
            "endContour",
            "endShape",
            "quadraticVertex",
            "vertex",
            "ellipseMode",
            "noSmooth",
            "rectMode",
            "smooth",
            "strokeCap",
            "strokeJoin",
            "strokeWeight",
            "mouseClicked",
            "mouseDragged",
            "mouseMoved",
            "mousePressed",
            "mouseReleased",
            "mouseWheel",
            "keyPressed",
            "keyPressedkeyReleased",
            "keyTyped",
            "print",
            "println",
            "save",
            "saveFrame",
            "day",
            "hour",
            "millis",
            "minute",
            "month",
            "second",
            "year",
            "background",
            "clear",
            "colorMode",
            "fill",
            "noFill",
            "noStroke",
            "stroke",
            "alpha",
            "blue",
            "brightness",
            "color",
            "green",
            "hue",
            "lerpColor",
            "red",
            "saturation",
            "modelX",
            "modelY",
            "modelZ",
            "screenX",
            "screenY",
            "screenZ",
            "ambient",
            "emissive",
            "shininess",
            "specular",
            "add",
            "createImage",
            "beginCamera",
            "camera",
            "endCamera",
            "frustum",
            "ortho",
            "perspective",
            "printCamera",
            "printProjection",
            "cursor",
            "frameRate",
            "noCursor",
            "exit",
            "loop",
            "noLoop",
            "popStyle",
            "pushStyle",
            "redraw",
            "binary",
            "boolean",
            "byte",
            "char",
            "float",
            "hex",
            "int",
            "str",
            "unbinary",
            "unhex",
            "join",
            "match",
            "matchAll",
            "nf",
            "nfc",
            "nfp",
            "nfs",
            "split",
            "splitTokens",
            "trim",
            "append",
            "arrayCopy",
            "concat",
            "expand",
            "reverse",
            "shorten",
            "sort",
            "splice",
            "subset",
            "box",
            "sphere",
            "sphereDetail",
            "createInput",
            "createReader",
            "loadBytes",
            "loadJSONArray",
            "loadJSONObject",
            "loadStrings",
            "loadTable",
            "loadXML",
            "open",
            "parseXML",
            "saveTable",
            "selectFolder",
            "selectInput",
            "beginRaw",
            "beginRecord",
            "createOutput",
            "createWriter",
            "endRaw",
            "endRecord",
            "PrintWritersaveBytes",
            "saveJSONArray",
            "saveJSONObject",
            "saveStream",
            "saveStrings",
            "saveXML",
            "selectOutput",
            "popMatrix",
            "printMatrix",
            "pushMatrix",
            "resetMatrix",
            "rotate",
            "rotateX",
            "rotateY",
            "rotateZ",
            "scale",
            "shearX",
            "shearY",
            "translate",
            "ambientLight",
            "directionalLight",
            "lightFalloff",
            "lights",
            "lightSpecular",
            "noLights",
            "normal",
            "pointLight",
            "spotLight",
            "image",
            "imageMode",
            "loadImage",
            "noTint",
            "requestImage",
            "tint",
            "texture",
            "textureMode",
            "textureWrap",
            "blend",
            "copy",
            "filter",
            "get",
            "loadPixels",
            "set",
            "updatePixels",
            "blendMode",
            "loadShader",
            "PShaderresetShader",
            "shader",
            "createFont",
            "loadFont",
            "text",
            "textFont",
            "textAlign",
            "textLeading",
            "textMode",
            "textSize",
            "textWidth",
            "textAscent",
            "textDescent",
            "abs",
            "ceil",
            "constrain",
            "dist",
            "exp",
            "floor",
            "lerp",
            "log",
            "mag",
            "map",
            "max",
            "min",
            "norm",
            "pow",
            "round",
            "sq",
            "sqrt",
            "acos",
            "asin",
            "atan",
            "atan2",
            "cos",
            "degrees",
            "radians",
            "sin",
            "tan",
            "noise",
            "noiseDetail",
            "noiseSeed",
            "random",
            "randomGaussian",
            "randomSeed"
        ], n = e.IDENT_RE, i = {
            variants: [
                {
                    match: t.concat(t.either(...a), t.lookahead(/\s*\(/)),
                    className: "built_in"
                },
                {
                    relevance: 0,
                    match: t.concat(/\b(?!for|if|while)/, n, t.lookahead(/\s*\(/)),
                    className: "title.function"
                }
            ]
        }, r = {
            match: [
                /new\s+/,
                n
            ],
            className: {
                1: "keyword",
                2: "class.title"
            }
        }, o = {
            relevance: 0,
            match: [
                /\./,
                n
            ],
            className: {
                2: "property"
            }
        }, s = {
            variants: [
                {
                    match: [
                        /class/,
                        /\s+/,
                        n,
                        /\s+/,
                        /extends/,
                        /\s+/,
                        n
                    ]
                },
                {
                    match: [
                        /class/,
                        /\s+/,
                        n
                    ]
                }
            ],
            className: {
                1: "keyword",
                3: "title.class",
                5: "keyword",
                7: "title.class.inherited"
            }
        };
        return {
            name: "Processing",
            aliases: [
                "pde"
            ],
            keywords: {
                keyword: [
                    "abstract",
                    "assert",
                    "break",
                    "case",
                    "catch",
                    "const",
                    "continue",
                    "default",
                    "else",
                    "enum",
                    "final",
                    "finally",
                    "for",
                    "if",
                    "import",
                    "instanceof",
                    "long",
                    "native",
                    "new",
                    "package",
                    "private",
                    "private",
                    "protected",
                    "protected",
                    "public",
                    "public",
                    "return",
                    "static",
                    "strictfp",
                    "switch",
                    "synchronized",
                    "throw",
                    "throws",
                    "transient",
                    "try",
                    "void",
                    "volatile",
                    "while"
                ],
                literal: "P2D P3D HALF_PI PI QUARTER_PI TAU TWO_PI null true false",
                title: "setup draw",
                variable: "super this",
                built_in: [
                    ...a,
                    "BufferedReader",
                    "PVector",
                    "PFont",
                    "PImage",
                    "PGraphics",
                    "HashMap",
                    "String",
                    "Array",
                    "FloatDict",
                    "ArrayList",
                    "FloatList",
                    "IntDict",
                    "IntList",
                    "JSONArray",
                    "JSONObject",
                    "Object",
                    "StringDict",
                    "StringList",
                    "Table",
                    "TableRow",
                    "XML"
                ],
                type: [
                    "boolean",
                    "byte",
                    "char",
                    "color",
                    "double",
                    "float",
                    "int",
                    "long",
                    "short"
                ]
            },
            contains: [
                s,
                r,
                i,
                o,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE
            ]
        };
    }), mr)), Cs.registerLanguage("profile", (gr || (gr = 1, ur = function(e) {
        return {
            name: "Python profiler",
            contains: [
                e.C_NUMBER_MODE,
                {
                    begin: "[a-zA-Z_][\\da-zA-Z_]+\\.[\\da-zA-Z_]{1,3}",
                    end: ":",
                    excludeEnd: !0
                },
                {
                    begin: "(ncalls|tottime|cumtime)",
                    end: "$",
                    keywords: "ncalls tottime|10 cumtime|10 filename",
                    relevance: 10
                },
                {
                    begin: "function calls",
                    end: "$",
                    contains: [
                        e.C_NUMBER_MODE
                    ],
                    relevance: 10
                },
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    begin: "\\(",
                    end: "\\)$",
                    excludeBegin: !0,
                    excludeEnd: !0,
                    relevance: 0
                }
            ]
        };
    }), ur)), Cs.registerLanguage("prolog", (Sr || (Sr = 1, Er = function(e) {
        const t = {
            begin: /\(/,
            end: /\)/,
            relevance: 0
        }, a = {
            begin: /\[/,
            end: /\]/
        }, n = {
            className: "comment",
            begin: /%/,
            end: /$/,
            contains: [
                e.PHRASAL_WORDS_MODE
            ]
        }, i = {
            className: "string",
            begin: /`/,
            end: /`/,
            contains: [
                e.BACKSLASH_ESCAPE
            ]
        }, r = [
            {
                begin: /[a-z][A-Za-z0-9_]*/,
                relevance: 0
            },
            {
                className: "symbol",
                variants: [
                    {
                        begin: /[A-Z][a-zA-Z0-9_]*/
                    },
                    {
                        begin: /_[A-Za-z0-9_]*/
                    }
                ],
                relevance: 0
            },
            t,
            {
                begin: /:-/
            },
            a,
            n,
            e.C_BLOCK_COMMENT_MODE,
            e.QUOTE_STRING_MODE,
            e.APOS_STRING_MODE,
            i,
            {
                className: "string",
                begin: /0'(\\'|.)/
            },
            {
                className: "string",
                begin: /0'\\s/
            },
            e.C_NUMBER_MODE
        ];
        return t.contains = r, a.contains = r, {
            name: "Prolog",
            contains: r.concat([
                {
                    begin: /\.$/
                }
            ])
        };
    }), Er)), Cs.registerLanguage("properties", (Tr || (Tr = 1, br = function(e) {
        const t = "[ \\t\\f]*", a = t + "[:=]" + t, n = "[ \\t\\f]+", i = "([^\\\\:= \\t\\f\\n]|\\\\.)+", r = {
            end: "(" + a + "|" + n + ")",
            relevance: 0,
            starts: {
                className: "string",
                end: /$/,
                relevance: 0,
                contains: [
                    {
                        begin: "\\\\\\\\"
                    },
                    {
                        begin: "\\\\\\n"
                    }
                ]
            }
        };
        return {
            name: ".properties",
            disableAutodetect: !0,
            case_insensitive: !0,
            illegal: /\S/,
            contains: [
                e.COMMENT("^\\s*[!#]", "$"),
                {
                    returnBegin: !0,
                    variants: [
                        {
                            begin: i + a
                        },
                        {
                            begin: i + n
                        }
                    ],
                    contains: [
                        {
                            className: "attr",
                            begin: i,
                            endsParent: !0
                        }
                    ],
                    starts: r
                },
                {
                    className: "attr",
                    begin: i + t + "$"
                }
            ]
        };
    }), br)), Cs.registerLanguage("protobuf", (fr || (fr = 1, Cr = function(e) {
        const t = {
            match: [
                /(message|enum|service)\s+/,
                e.IDENT_RE
            ],
            scope: {
                1: "keyword",
                2: "title.class"
            }
        };
        return {
            name: "Protocol Buffers",
            aliases: [
                "proto"
            ],
            keywords: {
                keyword: [
                    "package",
                    "import",
                    "option",
                    "optional",
                    "required",
                    "repeated",
                    "group",
                    "oneof"
                ],
                type: [
                    "double",
                    "float",
                    "int32",
                    "int64",
                    "uint32",
                    "uint64",
                    "sint32",
                    "sint64",
                    "fixed32",
                    "fixed64",
                    "sfixed32",
                    "sfixed64",
                    "bool",
                    "string",
                    "bytes"
                ],
                literal: [
                    "true",
                    "false"
                ]
            },
            contains: [
                e.QUOTE_STRING_MODE,
                e.NUMBER_MODE,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                t,
                {
                    className: "function",
                    beginKeywords: "rpc",
                    end: /[{;]/,
                    excludeEnd: !0,
                    keywords: "rpc returns"
                },
                {
                    begin: /^\s*[A-Z_]+(?=\s*=[^\n]+;$)/
                }
            ]
        };
    }), Cr)), Cs.registerLanguage("puppet", (Nr || (Nr = 1, Rr = function(e) {
        const t = e.COMMENT("#", "$"), a = "([A-Za-z_]|::)(\\w|::)*", n = e.inherit(e.TITLE_MODE, {
            begin: a
        }), i = {
            className: "variable",
            begin: "\\$" + a
        }, r = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE,
                i
            ],
            variants: [
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /"/,
                    end: /"/
                }
            ]
        };
        return {
            name: "Puppet",
            aliases: [
                "pp"
            ],
            contains: [
                t,
                i,
                r,
                {
                    beginKeywords: "class",
                    end: "\\{|;",
                    illegal: /=/,
                    contains: [
                        n,
                        t
                    ]
                },
                {
                    beginKeywords: "define",
                    end: /\{/,
                    contains: [
                        {
                            className: "section",
                            begin: e.IDENT_RE,
                            endsParent: !0
                        }
                    ]
                },
                {
                    begin: e.IDENT_RE + "\\s+\\{",
                    returnBegin: !0,
                    end: /\S/,
                    contains: [
                        {
                            className: "keyword",
                            begin: e.IDENT_RE,
                            relevance: .2
                        },
                        {
                            begin: /\{/,
                            end: /\}/,
                            keywords: {
                                keyword: "and case default else elsif false if in import enherits node or true undef unless main settings $string ",
                                literal: "alias audit before loglevel noop require subscribe tag owner ensure group mode name|0 changes context force incl lens load_path onlyif provider returns root show_diff type_check en_address ip_address realname command environment hour monute month monthday special target weekday creates cwd ogoutput refresh refreshonly tries try_sleep umask backup checksum content ctime force ignore links mtime purge recurse recurselimit replace selinux_ignore_defaults selrange selrole seltype seluser source souirce_permissions sourceselect validate_cmd validate_replacement allowdupe attribute_membership auth_membership forcelocal gid ia_load_module members system host_aliases ip allowed_trunk_vlans description device_url duplex encapsulation etherchannel native_vlan speed principals allow_root auth_class auth_type authenticate_user k_of_n mechanisms rule session_owner shared options device fstype enable hasrestart directory present absent link atboot blockdevice device dump pass remounts poller_tag use message withpath adminfile allow_virtual allowcdrom category configfiles flavor install_options instance package_settings platform responsefile status uninstall_options vendor unless_system_user unless_uid binary control flags hasstatus manifest pattern restart running start stop allowdupe auths expiry gid groups home iterations key_membership keys managehome membership password password_max_age password_min_age profile_membership profiles project purge_ssh_keys role_membership roles salt shell uid baseurl cost descr enabled enablegroups exclude failovermethod gpgcheck gpgkey http_caching include includepkgs keepalive metadata_expire metalink mirrorlist priority protect proxy proxy_password proxy_username repo_gpgcheck s3_enabled skip_if_unavailable sslcacert sslclientcert sslclientkey sslverify mounted",
                                built_in: "architecture augeasversion blockdevices boardmanufacturer boardproductname boardserialnumber cfkey dhcp_servers domain ec2_ ec2_userdata facterversion filesystems ldom fqdn gid hardwareisa hardwaremodel hostname id|0 interfaces ipaddress ipaddress_ ipaddress6 ipaddress6_ iphostnumber is_virtual kernel kernelmajversion kernelrelease kernelversion kernelrelease kernelversion lsbdistcodename lsbdistdescription lsbdistid lsbdistrelease lsbmajdistrelease lsbminordistrelease lsbrelease macaddress macaddress_ macosx_buildversion macosx_productname macosx_productversion macosx_productverson_major macosx_productversion_minor manufacturer memoryfree memorysize netmask metmask_ network_ operatingsystem operatingsystemmajrelease operatingsystemrelease osfamily partitions path physicalprocessorcount processor processorcount productname ps puppetversion rubysitedir rubyversion selinux selinux_config_mode selinux_config_policy selinux_current_mode selinux_current_mode selinux_enforced selinux_policyversion serialnumber sp_ sshdsakey sshecdsakey sshrsakey swapencrypted swapfree swapsize timezone type uniqueid uptime uptime_days uptime_hours uptime_seconds uuid virtual vlans xendomains zfs_version zonenae zones zpool_version"
                            },
                            relevance: 0,
                            contains: [
                                r,
                                t,
                                {
                                    begin: "[a-zA-Z_]+\\s*=>",
                                    returnBegin: !0,
                                    end: "=>",
                                    contains: [
                                        {
                                            className: "attr",
                                            begin: e.IDENT_RE
                                        }
                                    ]
                                },
                                {
                                    className: "number",
                                    begin: "(\\b0[0-7_]+)|(\\b0x[0-9a-fA-F_]+)|(\\b[1-9][0-9_]*(\\.[0-9_]+)?)|[0_]\\b",
                                    relevance: 0
                                },
                                i
                            ]
                        }
                    ],
                    relevance: 0
                }
            ]
        };
    }), Rr)), Cs.registerLanguage("purebasic", (hr || (hr = 1, Or = function(e) {
        return {
            name: "PureBASIC",
            aliases: [
                "pb",
                "pbi"
            ],
            keywords: "Align And Array As Break CallDebugger Case CompilerCase CompilerDefault CompilerElse CompilerElseIf CompilerEndIf CompilerEndSelect CompilerError CompilerIf CompilerSelect CompilerWarning Continue Data DataSection Debug DebugLevel Declare DeclareC DeclareCDLL DeclareDLL DeclareModule Default Define Dim DisableASM DisableDebugger DisableExplicit Else ElseIf EnableASM EnableDebugger EnableExplicit End EndDataSection EndDeclareModule EndEnumeration EndIf EndImport EndInterface EndMacro EndModule EndProcedure EndSelect EndStructure EndStructureUnion EndWith Enumeration EnumerationBinary Extends FakeReturn For ForEach ForEver Global Gosub Goto If Import ImportC IncludeBinary IncludeFile IncludePath Interface List Macro MacroExpandedCount Map Module NewList NewMap Next Not Or Procedure ProcedureC ProcedureCDLL ProcedureDLL ProcedureReturn Protected Prototype PrototypeC ReDim Read Repeat Restore Return Runtime Select Shared Static Step Structure StructureUnion Swap Threaded To UndefineMacro Until Until  UnuseModule UseModule Wend While With XIncludeFile XOr",
            contains: [
                e.COMMENT(";", "$", {
                    relevance: 0
                }),
                {
                    className: "function",
                    begin: "\\b(Procedure|Declare)(C|CDLL|DLL)?\\b",
                    end: "\\(",
                    excludeEnd: !0,
                    returnBegin: !0,
                    contains: [
                        {
                            className: "keyword",
                            begin: "(Procedure|Declare)(C|CDLL|DLL)?",
                            excludeEnd: !0
                        },
                        {
                            className: "type",
                            begin: "\\.\\w*"
                        },
                        e.UNDERSCORE_TITLE_MODE
                    ]
                },
                {
                    className: "string",
                    begin: '(~)?"',
                    end: '"',
                    illegal: "\\n"
                },
                {
                    className: "symbol",
                    begin: "#[a-zA-Z_]\\w*\\$?"
                }
            ]
        };
    }), Or)), Cs.registerLanguage("python", (Ir || (Ir = 1, vr = function(e) {
        const t = e.regex, a = /[\p{XID_Start}_]\p{XID_Continue}*/u, n = [
            "and",
            "as",
            "assert",
            "async",
            "await",
            "break",
            "case",
            "class",
            "continue",
            "def",
            "del",
            "elif",
            "else",
            "except",
            "finally",
            "for",
            "from",
            "global",
            "if",
            "import",
            "in",
            "is",
            "lambda",
            "match",
            "nonlocal|10",
            "not",
            "or",
            "pass",
            "raise",
            "return",
            "try",
            "while",
            "with",
            "yield"
        ], i = {
            $pattern: /[A-Za-z]\w+|__\w+__/,
            keyword: n,
            built_in: [
                "__import__",
                "abs",
                "all",
                "any",
                "ascii",
                "bin",
                "bool",
                "breakpoint",
                "bytearray",
                "bytes",
                "callable",
                "chr",
                "classmethod",
                "compile",
                "complex",
                "delattr",
                "dict",
                "dir",
                "divmod",
                "enumerate",
                "eval",
                "exec",
                "filter",
                "float",
                "format",
                "frozenset",
                "getattr",
                "globals",
                "hasattr",
                "hash",
                "help",
                "hex",
                "id",
                "input",
                "int",
                "isinstance",
                "issubclass",
                "iter",
                "len",
                "list",
                "locals",
                "map",
                "max",
                "memoryview",
                "min",
                "next",
                "object",
                "oct",
                "open",
                "ord",
                "pow",
                "print",
                "property",
                "range",
                "repr",
                "reversed",
                "round",
                "set",
                "setattr",
                "slice",
                "sorted",
                "staticmethod",
                "str",
                "sum",
                "super",
                "tuple",
                "type",
                "vars",
                "zip"
            ],
            literal: [
                "__debug__",
                "Ellipsis",
                "False",
                "None",
                "NotImplemented",
                "True"
            ],
            type: [
                "Any",
                "Callable",
                "Coroutine",
                "Dict",
                "List",
                "Literal",
                "Generic",
                "Optional",
                "Sequence",
                "Set",
                "Tuple",
                "Type",
                "Union"
            ]
        }, r = {
            className: "meta",
            begin: /^(>>>|\.\.\.) /
        }, o = {
            className: "subst",
            begin: /\{/,
            end: /\}/,
            keywords: i,
            illegal: /#/
        }, s = {
            begin: /\{\{/,
            relevance: 0
        }, l = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE
            ],
            variants: [
                {
                    begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
                    end: /'''/,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        r
                    ],
                    relevance: 10
                },
                {
                    begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
                    end: /"""/,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        r
                    ],
                    relevance: 10
                },
                {
                    begin: /([fF][rR]|[rR][fF]|[fF])'''/,
                    end: /'''/,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        r,
                        s,
                        o
                    ]
                },
                {
                    begin: /([fF][rR]|[rR][fF]|[fF])"""/,
                    end: /"""/,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        r,
                        s,
                        o
                    ]
                },
                {
                    begin: /([uU]|[rR])'/,
                    end: /'/,
                    relevance: 10
                },
                {
                    begin: /([uU]|[rR])"/,
                    end: /"/,
                    relevance: 10
                },
                {
                    begin: /([bB]|[bB][rR]|[rR][bB])'/,
                    end: /'/
                },
                {
                    begin: /([bB]|[bB][rR]|[rR][bB])"/,
                    end: /"/
                },
                {
                    begin: /([fF][rR]|[rR][fF]|[fF])'/,
                    end: /'/,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        s,
                        o
                    ]
                },
                {
                    begin: /([fF][rR]|[rR][fF]|[fF])"/,
                    end: /"/,
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        s,
                        o
                    ]
                },
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE
            ]
        }, c = "[0-9](_?[0-9])*", _ = `(\\b(${c}))?\\.(${c})|\\b(${c})\\.`, d = `\\b|${n.join("|")}`, m = {
            className: "number",
            relevance: 0,
            variants: [
                {
                    begin: `(\\b(${c})|(${_}))[eE][+-]?(${c})[jJ]?(?=${d})`
                },
                {
                    begin: `(${_})[jJ]?`
                },
                {
                    begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${d})`
                },
                {
                    begin: `\\b0[bB](_?[01])+[lL]?(?=${d})`
                },
                {
                    begin: `\\b0[oO](_?[0-7])+[lL]?(?=${d})`
                },
                {
                    begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${d})`
                },
                {
                    begin: `\\b(${c})[jJ](?=${d})`
                }
            ]
        }, p = {
            className: "comment",
            begin: t.lookahead(/# type:/),
            end: /$/,
            keywords: i,
            contains: [
                {
                    begin: /# type:/
                },
                {
                    begin: /#/,
                    end: /\b\B/,
                    endsWithParent: !0
                }
            ]
        }, u = {
            className: "params",
            variants: [
                {
                    className: "",
                    begin: /\(\s*\)/,
                    skip: !0
                },
                {
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: i,
                    contains: [
                        "self",
                        r,
                        m,
                        l,
                        e.HASH_COMMENT_MODE
                    ]
                }
            ]
        };
        return o.contains = [
            l,
            m,
            r
        ], {
            name: "Python",
            aliases: [
                "py",
                "gyp",
                "ipython"
            ],
            unicodeRegex: !0,
            keywords: i,
            illegal: /(<\/|\?)|=>/,
            contains: [
                r,
                m,
                {
                    begin: /\bself\b/
                },
                {
                    beginKeywords: "if",
                    relevance: 0
                },
                l,
                p,
                e.HASH_COMMENT_MODE,
                {
                    match: [
                        /\bdef/,
                        /\s+/,
                        a
                    ],
                    scope: {
                        1: "keyword",
                        3: "title.function"
                    },
                    contains: [
                        u
                    ]
                },
                {
                    variants: [
                        {
                            match: [
                                /\bclass/,
                                /\s+/,
                                a,
                                /\s*/,
                                /\(\s*/,
                                a,
                                /\s*\)/
                            ]
                        },
                        {
                            match: [
                                /\bclass/,
                                /\s+/,
                                a
                            ]
                        }
                    ],
                    scope: {
                        1: "keyword",
                        3: "title.class",
                        6: "title.class.inherited"
                    }
                },
                {
                    className: "meta",
                    begin: /^[\t ]*@/,
                    end: /(?=#)|$/,
                    contains: [
                        m,
                        u,
                        l
                    ]
                }
            ]
        };
    }), vr)), Cs.registerLanguage("python-repl", yr ? Ar : (yr = 1, Ar = function(e) {
        return {
            aliases: [
                "pycon"
            ],
            contains: [
                {
                    className: "meta.prompt",
                    starts: {
                        end: / |$/,
                        starts: {
                            end: "$",
                            subLanguage: "python"
                        }
                    },
                    variants: [
                        {
                            begin: /^>>>(?=[ ]|$)/
                        },
                        {
                            begin: /^\.\.\.(?=[ ]|$)/
                        }
                    ]
                }
            ]
        };
    })), Cs.registerLanguage("q", (Mr || (Mr = 1, Dr = function(e) {
        return {
            name: "Q",
            aliases: [
                "k",
                "kdb"
            ],
            keywords: {
                $pattern: /(`?)[A-Za-z0-9_]+\b/,
                keyword: "do while select delete by update from",
                literal: "0b 1b",
                built_in: "neg not null string reciprocal floor ceiling signum mod xbar xlog and or each scan over prior mmu lsq inv md5 ltime gtime count first var dev med cov cor all any rand sums prds mins maxs fills deltas ratios avgs differ prev next rank reverse iasc idesc asc desc msum mcount mavg mdev xrank mmin mmax xprev rotate distinct group where flip type key til get value attr cut set upsert raze union inter except cross sv vs sublist enlist read0 read1 hopen hclose hdel hsym hcount peach system ltrim rtrim trim lower upper ssr view tables views cols xcols keys xkey xcol xasc xdesc fkeys meta lj aj aj0 ij pj asof uj ww wj wj1 fby xgroup ungroup ej save load rsave rload show csv parse eval min max avg wavg wsum sin cos tan sum",
                type: "`float `double int `timestamp `timespan `datetime `time `boolean `symbol `char `byte `short `long `real `month `date `minute `second `guid"
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE
            ]
        };
    }), Dr)), Cs.registerLanguage("qml", (xr || (xr = 1, Lr = function(e) {
        const t = "[a-zA-Z_][a-zA-Z0-9\\._]*", a = {
            className: "attribute",
            begin: "\\bid\\s*:",
            starts: {
                className: "string",
                end: t,
                returnEnd: !1
            }
        }, n = {
            begin: t + "\\s*:",
            returnBegin: !0,
            contains: [
                {
                    className: "attribute",
                    begin: t,
                    end: "\\s*:",
                    excludeEnd: !0,
                    relevance: 0
                }
            ],
            relevance: 0
        }, i = {
            begin: e.regex.concat(t, /\s*\{/),
            end: /\{/,
            returnBegin: !0,
            relevance: 0,
            contains: [
                e.inherit(e.TITLE_MODE, {
                    begin: t
                })
            ]
        };
        return {
            name: "QML",
            aliases: [
                "qt"
            ],
            case_insensitive: !1,
            keywords: {
                keyword: "in of on if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await import",
                literal: "true false null undefined NaN Infinity",
                built_in: "eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Behavior bool color coordinate date double enumeration font geocircle georectangle geoshape int list matrix4x4 parent point quaternion real rect size string url variant vector2d vector3d vector4d Promise"
            },
            contains: [
                {
                    className: "meta",
                    begin: /^\s*['"]use (strict|asm)['"]/
                },
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    begin: "`",
                    end: "`",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        {
                            className: "subst",
                            begin: "\\$\\{",
                            end: "\\}"
                        }
                    ]
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "number",
                    variants: [
                        {
                            begin: "\\b(0[bB][01]+)"
                        },
                        {
                            begin: "\\b(0[oO][0-7]+)"
                        },
                        {
                            begin: e.C_NUMBER_RE
                        }
                    ],
                    relevance: 0
                },
                {
                    begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                    keywords: "return throw case",
                    contains: [
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE,
                        e.REGEXP_MODE,
                        {
                            begin: /</,
                            end: />\s*[);\]]/,
                            relevance: 0,
                            subLanguage: "xml"
                        }
                    ],
                    relevance: 0
                },
                {
                    className: "keyword",
                    begin: "\\bsignal\\b",
                    starts: {
                        className: "string",
                        end: "(\\(|:|=|;|,|//|/\\*|$)",
                        returnEnd: !0
                    }
                },
                {
                    className: "keyword",
                    begin: "\\bproperty\\b",
                    starts: {
                        className: "string",
                        end: "(:|=|;|,|//|/\\*|$)",
                        returnEnd: !0
                    }
                },
                {
                    className: "function",
                    beginKeywords: "function",
                    end: /\{/,
                    excludeEnd: !0,
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            begin: /[A-Za-z$_][0-9A-Za-z$_]*/
                        }),
                        {
                            className: "params",
                            begin: /\(/,
                            end: /\)/,
                            excludeBegin: !0,
                            excludeEnd: !0,
                            contains: [
                                e.C_LINE_COMMENT_MODE,
                                e.C_BLOCK_COMMENT_MODE
                            ]
                        }
                    ],
                    illegal: /\[|%/
                },
                {
                    begin: "\\." + e.IDENT_RE,
                    relevance: 0
                },
                a,
                n,
                i
            ],
            illegal: /#/
        };
    }), Lr)), Cs.registerLanguage("r", (Pr || (Pr = 1, wr = function(e) {
        const t = e.regex, a = /(?:(?:[a-zA-Z]|\.[._a-zA-Z])[._a-zA-Z0-9]*)|\.(?!\d)/, n = t.either(/0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/, /0[xX][0-9a-fA-F]+(?:[pP][+-]?\d+)?[Li]?/, /(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?[Li]?/), i = /[=!<>:]=|\|\||&&|:::?|<-|<<-|->>|->|\|>|[-+*\/?!$&|:<=>@^~]|\*\*/, r = t.either(/[()]/, /[{}]/, /\[\[/, /[[\]]/, /\\/, /,/);
        return {
            name: "R",
            keywords: {
                $pattern: a,
                keyword: "function if in break next repeat else for while",
                literal: "NULL NA TRUE FALSE Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10",
                built_in: "LETTERS letters month.abb month.name pi T F abs acos acosh all any anyNA Arg as.call as.character as.complex as.double as.environment as.integer as.logical as.null.default as.numeric as.raw asin asinh atan atanh attr attributes baseenv browser c call ceiling class Conj cos cosh cospi cummax cummin cumprod cumsum digamma dim dimnames emptyenv exp expression floor forceAndCall gamma gc.time globalenv Im interactive invisible is.array is.atomic is.call is.character is.complex is.double is.environment is.expression is.finite is.function is.infinite is.integer is.language is.list is.logical is.matrix is.na is.name is.nan is.null is.numeric is.object is.pairlist is.raw is.recursive is.single is.symbol lazyLoadDBfetch length lgamma list log max min missing Mod names nargs nzchar oldClass on.exit pos.to.env proc.time prod quote range Re rep retracemem return round seq_along seq_len seq.int sign signif sin sinh sinpi sqrt standardGeneric substitute sum switch tan tanh tanpi tracemem trigamma trunc unclass untracemem UseMethod xtfrm"
            },
            contains: [
                e.COMMENT(/#'/, /$/, {
                    contains: [
                        {
                            scope: "doctag",
                            match: /@examples/,
                            starts: {
                                end: t.lookahead(t.either(/\n^#'\s*(?=@[a-zA-Z]+)/, /\n^(?!#')/)),
                                endsParent: !0
                            }
                        },
                        {
                            scope: "doctag",
                            begin: "@param",
                            end: /$/,
                            contains: [
                                {
                                    scope: "variable",
                                    variants: [
                                        {
                                            match: a
                                        },
                                        {
                                            match: /`(?:\\.|[^`\\])+`/
                                        }
                                    ],
                                    endsParent: !0
                                }
                            ]
                        },
                        {
                            scope: "doctag",
                            match: /@[a-zA-Z]+/
                        },
                        {
                            scope: "keyword",
                            match: /\\[a-zA-Z]+/
                        }
                    ]
                }),
                e.HASH_COMMENT_MODE,
                {
                    scope: "string",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ],
                    variants: [
                        e.END_SAME_AS_BEGIN({
                            begin: /[rR]"(-*)\(/,
                            end: /\)(-*)"/
                        }),
                        e.END_SAME_AS_BEGIN({
                            begin: /[rR]"(-*)\{/,
                            end: /\}(-*)"/
                        }),
                        e.END_SAME_AS_BEGIN({
                            begin: /[rR]"(-*)\[/,
                            end: /\](-*)"/
                        }),
                        e.END_SAME_AS_BEGIN({
                            begin: /[rR]'(-*)\(/,
                            end: /\)(-*)'/
                        }),
                        e.END_SAME_AS_BEGIN({
                            begin: /[rR]'(-*)\{/,
                            end: /\}(-*)'/
                        }),
                        e.END_SAME_AS_BEGIN({
                            begin: /[rR]'(-*)\[/,
                            end: /\](-*)'/
                        }),
                        {
                            begin: '"',
                            end: '"',
                            relevance: 0
                        },
                        {
                            begin: "'",
                            end: "'",
                            relevance: 0
                        }
                    ]
                },
                {
                    relevance: 0,
                    variants: [
                        {
                            scope: {
                                1: "operator",
                                2: "number"
                            },
                            match: [
                                i,
                                n
                            ]
                        },
                        {
                            scope: {
                                1: "operator",
                                2: "number"
                            },
                            match: [
                                /%[^%]*%/,
                                n
                            ]
                        },
                        {
                            scope: {
                                1: "punctuation",
                                2: "number"
                            },
                            match: [
                                r,
                                n
                            ]
                        },
                        {
                            scope: {
                                2: "number"
                            },
                            match: [
                                /[^a-zA-Z0-9._]|^/,
                                n
                            ]
                        }
                    ]
                },
                {
                    scope: {
                        3: "operator"
                    },
                    match: [
                        a,
                        /\s+/,
                        /<-/,
                        /\s+/
                    ]
                },
                {
                    scope: "operator",
                    relevance: 0,
                    variants: [
                        {
                            match: i
                        },
                        {
                            match: /%[^%]*%/
                        }
                    ]
                },
                {
                    scope: "punctuation",
                    relevance: 0,
                    match: r
                },
                {
                    begin: "`",
                    end: "`",
                    contains: [
                        {
                            begin: /\\./
                        }
                    ]
                }
            ]
        };
    }), wr)), Cs.registerLanguage("reasonml", (Ur || (Ur = 1, kr = function(e) {
        return {
            name: "ReasonML",
            aliases: [
                "re"
            ],
            keywords: {
                $pattern: /[a-z_]\w*!?/,
                keyword: [
                    "and",
                    "as",
                    "asr",
                    "assert",
                    "begin",
                    "class",
                    "constraint",
                    "do",
                    "done",
                    "downto",
                    "else",
                    "end",
                    "esfun",
                    "exception",
                    "external",
                    "for",
                    "fun",
                    "function",
                    "functor",
                    "if",
                    "in",
                    "include",
                    "inherit",
                    "initializer",
                    "land",
                    "lazy",
                    "let",
                    "lor",
                    "lsl",
                    "lsr",
                    "lxor",
                    "mod",
                    "module",
                    "mutable",
                    "new",
                    "nonrec",
                    "object",
                    "of",
                    "open",
                    "or",
                    "pri",
                    "pub",
                    "rec",
                    "sig",
                    "struct",
                    "switch",
                    "then",
                    "to",
                    "try",
                    "type",
                    "val",
                    "virtual",
                    "when",
                    "while",
                    "with"
                ],
                built_in: [
                    "array",
                    "bool",
                    "bytes",
                    "char",
                    "exn|5",
                    "float",
                    "int",
                    "int32",
                    "int64",
                    "list",
                    "lazy_t|5",
                    "nativeint|5",
                    "ref",
                    "string",
                    "unit"
                ],
                literal: [
                    "true",
                    "false"
                ]
            },
            illegal: /(:-|:=|\$\{|\+=)/,
            contains: [
                {
                    scope: "literal",
                    match: /\[(\|\|)?\]|\(\)/,
                    relevance: 0
                },
                e.C_LINE_COMMENT_MODE,
                e.COMMENT(/\/\*/, /\*\//, {
                    illegal: /^(#,\/\/)/
                }),
                {
                    scope: "symbol",
                    match: /\'[A-Za-z_](?!\')[\w\']*/
                },
                {
                    scope: "type",
                    match: /`[A-Z][\w\']*/
                },
                {
                    scope: "type",
                    match: /\b[A-Z][\w\']*/,
                    relevance: 0
                },
                {
                    match: /[a-z_]\w*\'[\w\']*/,
                    relevance: 0
                },
                {
                    scope: "operator",
                    match: /\s+(\|\||\+[\+\.]?|\*[\*\/\.]?|\/[\.]?|\.\.\.|\|>|&&|===?)\s+/,
                    relevance: 0
                },
                e.inherit(e.APOS_STRING_MODE, {
                    scope: "string",
                    relevance: 0
                }),
                e.inherit(e.QUOTE_STRING_MODE, {
                    illegal: null
                }),
                {
                    scope: "number",
                    variants: [
                        {
                            match: /\b0[xX][a-fA-F0-9_]+[Lln]?/
                        },
                        {
                            match: /\b0[oO][0-7_]+[Lln]?/
                        },
                        {
                            match: /\b0[bB][01_]+[Lln]?/
                        },
                        {
                            match: /\b[0-9][0-9_]*([Lln]|(\.[0-9_]*)?([eE][-+]?[0-9_]+)?)/
                        }
                    ],
                    relevance: 0
                }
            ]
        };
    }), kr)), Cs.registerLanguage("rib", (Br || (Br = 1, Fr = function(e) {
        return {
            name: "RenderMan RIB",
            keywords: "ArchiveRecord AreaLightSource Atmosphere Attribute AttributeBegin AttributeEnd Basis Begin Blobby Bound Clipping ClippingPlane Color ColorSamples ConcatTransform Cone CoordinateSystem CoordSysTransform CropWindow Curves Cylinder DepthOfField Detail DetailRange Disk Displacement Display End ErrorHandler Exposure Exterior Format FrameAspectRatio FrameBegin FrameEnd GeneralPolygon GeometricApproximation Geometry Hider Hyperboloid Identity Illuminate Imager Interior LightSource MakeCubeFaceEnvironment MakeLatLongEnvironment MakeShadow MakeTexture Matte MotionBegin MotionEnd NuPatch ObjectBegin ObjectEnd ObjectInstance Opacity Option Orientation Paraboloid Patch PatchMesh Perspective PixelFilter PixelSamples PixelVariance Points PointsGeneralPolygons PointsPolygons Polygon Procedural Projection Quantize ReadArchive RelativeDetail ReverseOrientation Rotate Scale ScreenWindow ShadingInterpolation ShadingRate Shutter Sides Skew SolidBegin SolidEnd Sphere SubdivisionMesh Surface TextureCoordinates Torus Transform TransformBegin TransformEnd TransformPoints Translate TrimCurve WorldBegin WorldEnd",
            illegal: "</",
            contains: [
                e.HASH_COMMENT_MODE,
                e.C_NUMBER_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE
            ]
        };
    }), Fr)), Cs.registerLanguage("roboconf", (Yr || (Yr = 1, Gr = function(e) {
        const t = "[a-zA-Z-_][^\\n{]+\\{", a = {
            className: "attribute",
            begin: /[a-zA-Z-_]+/,
            end: /\s*:/,
            excludeEnd: !0,
            starts: {
                end: ";",
                relevance: 0,
                contains: [
                    {
                        className: "variable",
                        begin: /\.[a-zA-Z-_]+/
                    },
                    {
                        className: "keyword",
                        begin: /\(optional\)/
                    }
                ]
            }
        };
        return {
            name: "Roboconf",
            aliases: [
                "graph",
                "instances"
            ],
            case_insensitive: !0,
            keywords: "import",
            contains: [
                {
                    begin: "^facet " + t,
                    end: /\}/,
                    keywords: "facet",
                    contains: [
                        a,
                        e.HASH_COMMENT_MODE
                    ]
                },
                {
                    begin: "^\\s*instance of " + t,
                    end: /\}/,
                    keywords: "name count channels instance-data instance-state instance of",
                    illegal: /\S/,
                    contains: [
                        "self",
                        a,
                        e.HASH_COMMENT_MODE
                    ]
                },
                {
                    begin: "^" + t,
                    end: /\}/,
                    contains: [
                        a,
                        e.HASH_COMMENT_MODE
                    ]
                },
                e.HASH_COMMENT_MODE
            ]
        };
    }), Gr)), Cs.registerLanguage("routeros", (Vr || (Vr = 1, Hr = function(e) {
        const t = "foreach do while for if from to step else on-error and or not in", a = "true false yes no nothing nil null", n = {
            className: "variable",
            variants: [
                {
                    begin: /\$[\w\d#@][\w\d_]*/
                },
                {
                    begin: /\$\{(.*?)\}/
                }
            ]
        }, i = {
            className: "string",
            begin: /"/,
            end: /"/,
            contains: [
                e.BACKSLASH_ESCAPE,
                n,
                {
                    className: "variable",
                    begin: /\$\(/,
                    end: /\)/,
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                }
            ]
        }, r = {
            className: "string",
            begin: /'/,
            end: /'/
        };
        return {
            name: "MikroTik RouterOS script",
            aliases: [
                "mikrotik"
            ],
            case_insensitive: !0,
            keywords: {
                $pattern: /:?[\w-]+/,
                literal: a,
                keyword: t + " :" + t.split(" ").join(" :") + " :" + "global local beep delay put len typeof pick log time set find environment terminal error execute parse resolve toarray tobool toid toip toip6 tonum tostr totime".split(" ").join(" :")
            },
            contains: [
                {
                    variants: [
                        {
                            begin: /\/\*/,
                            end: /\*\//
                        },
                        {
                            begin: /\/\//,
                            end: /$/
                        },
                        {
                            begin: /<\//,
                            end: />/
                        }
                    ],
                    illegal: /./
                },
                e.COMMENT("^#", "$"),
                i,
                r,
                n,
                {
                    begin: /[\w-]+=([^\s{}[\]()>]+)/,
                    relevance: 0,
                    returnBegin: !0,
                    contains: [
                        {
                            className: "attribute",
                            begin: /[^=]+/
                        },
                        {
                            begin: /=/,
                            endsWithParent: !0,
                            relevance: 0,
                            contains: [
                                i,
                                r,
                                n,
                                {
                                    className: "literal",
                                    begin: "\\b(" + a.split(" ").join("|") + ")\\b"
                                },
                                {
                                    begin: /("[^"]*"|[^\s{}[\]]+)/
                                }
                            ]
                        }
                    ]
                },
                {
                    className: "number",
                    begin: /\*[0-9a-fA-F]+/
                },
                {
                    begin: "\\b(" + "add remove enable disable set get print export edit find run debug error info warning".split(" ").join("|") + ")([\\s[(\\]|])",
                    returnBegin: !0,
                    contains: [
                        {
                            className: "built_in",
                            begin: /\w+/
                        }
                    ]
                },
                {
                    className: "built_in",
                    variants: [
                        {
                            begin: "(\\.\\./|/|\\s)((" + "traffic-flow traffic-generator firewall scheduler aaa accounting address-list address align area bandwidth-server bfd bgp bridge client clock community config connection console customer default dhcp-client dhcp-server discovery dns e-mail ethernet filter firmware gps graphing group hardware health hotspot identity igmp-proxy incoming instance interface ip ipsec ipv6 irq l2tp-server lcd ldp logging mac-server mac-winbox mangle manual mirror mme mpls nat nd neighbor network note ntp ospf ospf-v3 ovpn-server page peer pim ping policy pool port ppp pppoe-client pptp-server prefix profile proposal proxy queue radius resource rip ripng route routing screen script security-profiles server service service-port settings shares smb sms sniffer snmp snooper socks sstp-server system tool tracking type upgrade upnp user-manager users user vlan secret vrrp watchdog web-access wireless pptp pppoe lan wan layer7-protocol lease simple raw".split(" ").join("|") + ");?\\s)+"
                        },
                        {
                            begin: /\.\./,
                            relevance: 0
                        }
                    ]
                }
            ]
        };
    }), Hr)), Cs.registerLanguage("rsl", (zr || (zr = 1, qr = function(e) {
        const t = {
            match: [
                /(surface|displacement|light|volume|imager)/,
                /\s+/,
                e.IDENT_RE
            ],
            scope: {
                1: "keyword",
                3: "title.class"
            }
        };
        return {
            name: "RenderMan RSL",
            keywords: {
                keyword: [
                    "while",
                    "for",
                    "if",
                    "do",
                    "return",
                    "else",
                    "break",
                    "extern",
                    "continue"
                ],
                built_in: [
                    "abs",
                    "acos",
                    "ambient",
                    "area",
                    "asin",
                    "atan",
                    "atmosphere",
                    "attribute",
                    "calculatenormal",
                    "ceil",
                    "cellnoise",
                    "clamp",
                    "comp",
                    "concat",
                    "cos",
                    "degrees",
                    "depth",
                    "Deriv",
                    "diffuse",
                    "distance",
                    "Du",
                    "Dv",
                    "environment",
                    "exp",
                    "faceforward",
                    "filterstep",
                    "floor",
                    "format",
                    "fresnel",
                    "incident",
                    "length",
                    "lightsource",
                    "log",
                    "match",
                    "max",
                    "min",
                    "mod",
                    "noise",
                    "normalize",
                    "ntransform",
                    "opposite",
                    "option",
                    "phong",
                    "pnoise",
                    "pow",
                    "printf",
                    "ptlined",
                    "radians",
                    "random",
                    "reflect",
                    "refract",
                    "renderinfo",
                    "round",
                    "setcomp",
                    "setxcomp",
                    "setycomp",
                    "setzcomp",
                    "shadow",
                    "sign",
                    "sin",
                    "smoothstep",
                    "specular",
                    "specularbrdf",
                    "spline",
                    "sqrt",
                    "step",
                    "tan",
                    "texture",
                    "textureinfo",
                    "trace",
                    "transform",
                    "vtransform",
                    "xcomp",
                    "ycomp",
                    "zcomp"
                ],
                type: [
                    "matrix",
                    "float",
                    "color",
                    "point",
                    "normal",
                    "vector"
                ]
            },
            illegal: "</",
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                e.APOS_STRING_MODE,
                e.C_NUMBER_MODE,
                {
                    className: "meta",
                    begin: "#",
                    end: "$"
                },
                t,
                {
                    beginKeywords: "illuminate illuminance gather",
                    end: "\\("
                }
            ]
        };
    }), qr)), Cs.registerLanguage("ruleslanguage", (Wr || (Wr = 1, $r = function(e) {
        return {
            name: "Oracle Rules Language",
            keywords: {
                keyword: "BILL_PERIOD BILL_START BILL_STOP RS_EFFECTIVE_START RS_EFFECTIVE_STOP RS_JURIS_CODE RS_OPCO_CODE INTDADDATTRIBUTE|5 INTDADDVMSG|5 INTDBLOCKOP|5 INTDBLOCKOPNA|5 INTDCLOSE|5 INTDCOUNT|5 INTDCOUNTSTATUSCODE|5 INTDCREATEMASK|5 INTDCREATEDAYMASK|5 INTDCREATEFACTORMASK|5 INTDCREATEHANDLE|5 INTDCREATEOVERRIDEDAYMASK|5 INTDCREATEOVERRIDEMASK|5 INTDCREATESTATUSCODEMASK|5 INTDCREATETOUPERIOD|5 INTDDELETE|5 INTDDIPTEST|5 INTDEXPORT|5 INTDGETERRORCODE|5 INTDGETERRORMESSAGE|5 INTDISEQUAL|5 INTDJOIN|5 INTDLOAD|5 INTDLOADACTUALCUT|5 INTDLOADDATES|5 INTDLOADHIST|5 INTDLOADLIST|5 INTDLOADLISTDATES|5 INTDLOADLISTENERGY|5 INTDLOADLISTHIST|5 INTDLOADRELATEDCHANNEL|5 INTDLOADSP|5 INTDLOADSTAGING|5 INTDLOADUOM|5 INTDLOADUOMDATES|5 INTDLOADUOMHIST|5 INTDLOADVERSION|5 INTDOPEN|5 INTDREADFIRST|5 INTDREADNEXT|5 INTDRECCOUNT|5 INTDRELEASE|5 INTDREPLACE|5 INTDROLLAVG|5 INTDROLLPEAK|5 INTDSCALAROP|5 INTDSCALE|5 INTDSETATTRIBUTE|5 INTDSETDSTPARTICIPANT|5 INTDSETSTRING|5 INTDSETVALUE|5 INTDSETVALUESTATUS|5 INTDSHIFTSTARTTIME|5 INTDSMOOTH|5 INTDSORT|5 INTDSPIKETEST|5 INTDSUBSET|5 INTDTOU|5 INTDTOURELEASE|5 INTDTOUVALUE|5 INTDUPDATESTATS|5 INTDVALUE|5 STDEV INTDDELETEEX|5 INTDLOADEXACTUAL|5 INTDLOADEXCUT|5 INTDLOADEXDATES|5 INTDLOADEX|5 INTDLOADEXRELATEDCHANNEL|5 INTDSAVEEX|5 MVLOAD|5 MVLOADACCT|5 MVLOADACCTDATES|5 MVLOADACCTHIST|5 MVLOADDATES|5 MVLOADHIST|5 MVLOADLIST|5 MVLOADLISTDATES|5 MVLOADLISTHIST|5 IF FOR NEXT DONE SELECT END CALL ABORT CLEAR CHANNEL FACTOR LIST NUMBER OVERRIDE SET WEEK DISTRIBUTIONNODE ELSE WHEN THEN OTHERWISE IENUM CSV INCLUDE LEAVE RIDER SAVE DELETE NOVALUE SECTION WARN SAVE_UPDATE DETERMINANT LABEL REPORT REVENUE EACH IN FROM TOTAL CHARGE BLOCK AND OR CSV_FILE RATE_CODE AUXILIARY_DEMAND UIDACCOUNT RS BILL_PERIOD_SELECT HOURS_PER_MONTH INTD_ERROR_STOP SEASON_SCHEDULE_NAME ACCOUNTFACTOR ARRAYUPPERBOUND CALLSTOREDPROC GETADOCONNECTION GETCONNECT GETDATASOURCE GETQUALIFIER GETUSERID HASVALUE LISTCOUNT LISTOP LISTUPDATE LISTVALUE PRORATEFACTOR RSPRORATE SETBINPATH SETDBMONITOR WQ_OPEN BILLINGHOURS DATE DATEFROMFLOAT DATETIMEFROMSTRING DATETIMETOSTRING DATETOFLOAT DAY DAYDIFF DAYNAME DBDATETIME HOUR MINUTE MONTH MONTHDIFF MONTHHOURS MONTHNAME ROUNDDATE SAMEWEEKDAYLASTYEAR SECOND WEEKDAY WEEKDIFF YEAR YEARDAY YEARSTR COMPSUM HISTCOUNT HISTMAX HISTMIN HISTMINNZ HISTVALUE MAXNRANGE MAXRANGE MINRANGE COMPIKVA COMPKVA COMPKVARFROMKQKW COMPLF IDATTR FLAG LF2KW LF2KWH MAXKW POWERFACTOR READING2USAGE AVGSEASON MAXSEASON MONTHLYMERGE SEASONVALUE SUMSEASON ACCTREADDATES ACCTTABLELOAD CONFIGADD CONFIGGET CREATEOBJECT CREATEREPORT EMAILCLIENT EXPBLKMDMUSAGE EXPMDMUSAGE EXPORT_USAGE FACTORINEFFECT GETUSERSPECIFIEDSTOP INEFFECT ISHOLIDAY RUNRATE SAVE_PROFILE SETREPORTTITLE USEREXIT WATFORRUNRATE TO TABLE ACOS ASIN ATAN ATAN2 BITAND CEIL COS COSECANT COSH COTANGENT DIVQUOT DIVREM EXP FABS FLOOR FMOD FREPM FREXPN LOG LOG10 MAX MAXN MIN MINNZ MODF POW ROUND ROUND2VALUE ROUNDINT SECANT SIN SINH SQROOT TAN TANH FLOAT2STRING FLOAT2STRINGNC INSTR LEFT LEN LTRIM MID RIGHT RTRIM STRING STRINGNC TOLOWER TOUPPER TRIM NUMDAYS READ_DATE STAGING",
                built_in: "IDENTIFIER OPTIONS XML_ELEMENT XML_OP XML_ELEMENT_OF DOMDOCCREATE DOMDOCLOADFILE DOMDOCLOADXML DOMDOCSAVEFILE DOMDOCGETROOT DOMDOCADDPI DOMNODEGETNAME DOMNODEGETTYPE DOMNODEGETVALUE DOMNODEGETCHILDCT DOMNODEGETFIRSTCHILD DOMNODEGETSIBLING DOMNODECREATECHILDELEMENT DOMNODESETATTRIBUTE DOMNODEGETCHILDELEMENTCT DOMNODEGETFIRSTCHILDELEMENT DOMNODEGETSIBLINGELEMENT DOMNODEGETATTRIBUTECT DOMNODEGETATTRIBUTEI DOMNODEGETATTRIBUTEBYNAME DOMNODEGETBYNAME"
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE,
                {
                    className: "literal",
                    variants: [
                        {
                            begin: "#\\s+",
                            relevance: 0
                        },
                        {
                            begin: "#[a-zA-Z .]+"
                        }
                    ]
                }
            ]
        };
    }), $r)), Cs.registerLanguage("rust", (Kr || (Kr = 1, Qr = function(e) {
        const t = e.regex, a = {
            className: "title.function.invoke",
            relevance: 0,
            begin: t.concat(/\b/, /(?!let|for|while|if|else|match\b)/, e.IDENT_RE, t.lookahead(/\s*\(/))
        }, n = "([ui](8|16|32|64|128|size)|f(32|64))?", i = [
            "drop ",
            "Copy",
            "Send",
            "Sized",
            "Sync",
            "Drop",
            "Fn",
            "FnMut",
            "FnOnce",
            "ToOwned",
            "Clone",
            "Debug",
            "PartialEq",
            "PartialOrd",
            "Eq",
            "Ord",
            "AsRef",
            "AsMut",
            "Into",
            "From",
            "Default",
            "Iterator",
            "Extend",
            "IntoIterator",
            "DoubleEndedIterator",
            "ExactSizeIterator",
            "SliceConcatExt",
            "ToString",
            "assert!",
            "assert_eq!",
            "bitflags!",
            "bytes!",
            "cfg!",
            "col!",
            "concat!",
            "concat_idents!",
            "debug_assert!",
            "debug_assert_eq!",
            "env!",
            "eprintln!",
            "panic!",
            "file!",
            "format!",
            "format_args!",
            "include_bytes!",
            "include_str!",
            "line!",
            "local_data_key!",
            "module_path!",
            "option_env!",
            "print!",
            "println!",
            "select!",
            "stringify!",
            "try!",
            "unimplemented!",
            "unreachable!",
            "vec!",
            "write!",
            "writeln!",
            "macro_rules!",
            "assert_ne!",
            "debug_assert_ne!"
        ], r = [
            "i8",
            "i16",
            "i32",
            "i64",
            "i128",
            "isize",
            "u8",
            "u16",
            "u32",
            "u64",
            "u128",
            "usize",
            "f32",
            "f64",
            "str",
            "char",
            "bool",
            "Box",
            "Option",
            "Result",
            "String",
            "Vec"
        ];
        return {
            name: "Rust",
            aliases: [
                "rs"
            ],
            keywords: {
                $pattern: e.IDENT_RE + "!?",
                type: r,
                keyword: [
                    "abstract",
                    "as",
                    "async",
                    "await",
                    "become",
                    "box",
                    "break",
                    "const",
                    "continue",
                    "crate",
                    "do",
                    "dyn",
                    "else",
                    "enum",
                    "extern",
                    "false",
                    "final",
                    "fn",
                    "for",
                    "if",
                    "impl",
                    "in",
                    "let",
                    "loop",
                    "macro",
                    "match",
                    "mod",
                    "move",
                    "mut",
                    "override",
                    "priv",
                    "pub",
                    "ref",
                    "return",
                    "self",
                    "Self",
                    "static",
                    "struct",
                    "super",
                    "trait",
                    "true",
                    "try",
                    "type",
                    "typeof",
                    "unsafe",
                    "unsized",
                    "use",
                    "virtual",
                    "where",
                    "while",
                    "yield"
                ],
                literal: [
                    "true",
                    "false",
                    "Some",
                    "None",
                    "Ok",
                    "Err"
                ],
                built_in: i
            },
            illegal: "</",
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.COMMENT("/\\*", "\\*/", {
                    contains: [
                        "self"
                    ]
                }),
                e.inherit(e.QUOTE_STRING_MODE, {
                    begin: /b?"/,
                    illegal: null
                }),
                {
                    className: "string",
                    variants: [
                        {
                            begin: /b?r(#*)"(.|\n)*?"\1(?!#)/
                        },
                        {
                            begin: /b?'\\?(x\w{2}|u\w{4}|U\w{8}|.)'/
                        }
                    ]
                },
                {
                    className: "symbol",
                    begin: /'[a-zA-Z_][a-zA-Z0-9_]*/
                },
                {
                    className: "number",
                    variants: [
                        {
                            begin: "\\b0b([01_]+)" + n
                        },
                        {
                            begin: "\\b0o([0-7_]+)" + n
                        },
                        {
                            begin: "\\b0x([A-Fa-f0-9_]+)" + n
                        },
                        {
                            begin: "\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)" + n
                        }
                    ],
                    relevance: 0
                },
                {
                    begin: [
                        /fn/,
                        /\s+/,
                        e.UNDERSCORE_IDENT_RE
                    ],
                    className: {
                        1: "keyword",
                        3: "title.function"
                    }
                },
                {
                    className: "meta",
                    begin: "#!?\\[",
                    end: "\\]",
                    contains: [
                        {
                            className: "string",
                            begin: /"/,
                            end: /"/
                        }
                    ]
                },
                {
                    begin: [
                        /let/,
                        /\s+/,
                        /(?:mut\s+)?/,
                        e.UNDERSCORE_IDENT_RE
                    ],
                    className: {
                        1: "keyword",
                        3: "keyword",
                        4: "variable"
                    }
                },
                {
                    begin: [
                        /for/,
                        /\s+/,
                        e.UNDERSCORE_IDENT_RE,
                        /\s+/,
                        /in/
                    ],
                    className: {
                        1: "keyword",
                        3: "variable",
                        5: "keyword"
                    }
                },
                {
                    begin: [
                        /type/,
                        /\s+/,
                        e.UNDERSCORE_IDENT_RE
                    ],
                    className: {
                        1: "keyword",
                        3: "title.class"
                    }
                },
                {
                    begin: [
                        /(?:trait|enum|struct|union|impl|for)/,
                        /\s+/,
                        e.UNDERSCORE_IDENT_RE
                    ],
                    className: {
                        1: "keyword",
                        3: "title.class"
                    }
                },
                {
                    begin: e.IDENT_RE + "::",
                    keywords: {
                        keyword: "Self",
                        built_in: i,
                        type: r
                    }
                },
                {
                    className: "punctuation",
                    begin: "->"
                },
                a
            ]
        };
    }), Qr)), Cs.registerLanguage("sas", (Xr || (Xr = 1, jr = function(e) {
        const t = e.regex;
        return {
            name: "SAS",
            case_insensitive: !0,
            keywords: {
                literal: [
                    "null",
                    "missing",
                    "_all_",
                    "_automatic_",
                    "_character_",
                    "_infile_",
                    "_n_",
                    "_name_",
                    "_null_",
                    "_numeric_",
                    "_user_",
                    "_webout_"
                ],
                keyword: [
                    "do",
                    "if",
                    "then",
                    "else",
                    "end",
                    "until",
                    "while",
                    "abort",
                    "array",
                    "attrib",
                    "by",
                    "call",
                    "cards",
                    "cards4",
                    "catname",
                    "continue",
                    "datalines",
                    "datalines4",
                    "delete",
                    "delim",
                    "delimiter",
                    "display",
                    "dm",
                    "drop",
                    "endsas",
                    "error",
                    "file",
                    "filename",
                    "footnote",
                    "format",
                    "goto",
                    "in",
                    "infile",
                    "informat",
                    "input",
                    "keep",
                    "label",
                    "leave",
                    "length",
                    "libname",
                    "link",
                    "list",
                    "lostcard",
                    "merge",
                    "missing",
                    "modify",
                    "options",
                    "output",
                    "out",
                    "page",
                    "put",
                    "redirect",
                    "remove",
                    "rename",
                    "replace",
                    "retain",
                    "return",
                    "select",
                    "set",
                    "skip",
                    "startsas",
                    "stop",
                    "title",
                    "update",
                    "waitsas",
                    "where",
                    "window",
                    "x|0",
                    "systask",
                    "add",
                    "and",
                    "alter",
                    "as",
                    "cascade",
                    "check",
                    "create",
                    "delete",
                    "describe",
                    "distinct",
                    "drop",
                    "foreign",
                    "from",
                    "group",
                    "having",
                    "index",
                    "insert",
                    "into",
                    "in",
                    "key",
                    "like",
                    "message",
                    "modify",
                    "msgtype",
                    "not",
                    "null",
                    "on",
                    "or",
                    "order",
                    "primary",
                    "references",
                    "reset",
                    "restrict",
                    "select",
                    "set",
                    "table",
                    "unique",
                    "update",
                    "validate",
                    "view",
                    "where"
                ]
            },
            contains: [
                {
                    className: "keyword",
                    begin: /^\s*(proc [\w\d_]+|data|run|quit)[\s;]/
                },
                {
                    className: "variable",
                    begin: /&[a-zA-Z_&][a-zA-Z0-9_]*\.?/
                },
                {
                    begin: [
                        /^\s*/,
                        /datalines;|cards;/,
                        /(?:.*\n)+/,
                        /^\s*;\s*$/
                    ],
                    className: {
                        2: "keyword",
                        3: "string"
                    }
                },
                {
                    begin: [
                        /%mend|%macro/,
                        /\s+/,
                        /[a-zA-Z_&][a-zA-Z0-9_]*/
                    ],
                    className: {
                        1: "built_in",
                        3: "title.function"
                    }
                },
                {
                    className: "built_in",
                    begin: "%" + t.either("bquote", "nrbquote", "cmpres", "qcmpres", "compstor", "datatyp", "display", "do", "else", "end", "eval", "global", "goto", "if", "index", "input", "keydef", "label", "left", "length", "let", "local", "lowcase", "macro", "mend", "nrbquote", "nrquote", "nrstr", "put", "qcmpres", "qleft", "qlowcase", "qscan", "qsubstr", "qsysfunc", "qtrim", "quote", "qupcase", "scan", "str", "substr", "superq", "syscall", "sysevalf", "sysexec", "sysfunc", "sysget", "syslput", "sysprod", "sysrc", "sysrput", "then", "to", "trim", "unquote", "until", "upcase", "verify", "while", "window")
                },
                {
                    className: "title.function",
                    begin: /%[a-zA-Z_][a-zA-Z_0-9]*/
                },
                {
                    className: "meta",
                    begin: t.either("abs", "addr", "airy", "arcos", "arsin", "atan", "attrc", "attrn", "band", "betainv", "blshift", "bnot", "bor", "brshift", "bxor", "byte", "cdf", "ceil", "cexist", "cinv", "close", "cnonct", "collate", "compbl", "compound", "compress", "cos", "cosh", "css", "curobs", "cv", "daccdb", "daccdbsl", "daccsl", "daccsyd", "dacctab", "dairy", "date", "datejul", "datepart", "datetime", "day", "dclose", "depdb", "depdbsl", "depdbsl", "depsl", "depsl", "depsyd", "depsyd", "deptab", "deptab", "dequote", "dhms", "dif", "digamma", "dim", "dinfo", "dnum", "dopen", "doptname", "doptnum", "dread", "dropnote", "dsname", "erf", "erfc", "exist", "exp", "fappend", "fclose", "fcol", "fdelete", "fetch", "fetchobs", "fexist", "fget", "fileexist", "filename", "fileref", "finfo", "finv", "fipname", "fipnamel", "fipstate", "floor", "fnonct", "fnote", "fopen", "foptname", "foptnum", "fpoint", "fpos", "fput", "fread", "frewind", "frlen", "fsep", "fuzz", "fwrite", "gaminv", "gamma", "getoption", "getvarc", "getvarn", "hbound", "hms", "hosthelp", "hour", "ibessel", "index", "indexc", "indexw", "input", "inputc", "inputn", "int", "intck", "intnx", "intrr", "irr", "jbessel", "juldate", "kurtosis", "lag", "lbound", "left", "length", "lgamma", "libname", "libref", "log", "log10", "log2", "logpdf", "logpmf", "logsdf", "lowcase", "max", "mdy", "mean", "min", "minute", "mod", "month", "mopen", "mort", "n", "netpv", "nmiss", "normal", "note", "npv", "open", "ordinal", "pathname", "pdf", "peek", "peekc", "pmf", "point", "poisson", "poke", "probbeta", "probbnml", "probchi", "probf", "probgam", "probhypr", "probit", "probnegb", "probnorm", "probt", "put", "putc", "putn", "qtr", "quote", "ranbin", "rancau", "ranexp", "rangam", "range", "rank", "rannor", "ranpoi", "rantbl", "rantri", "ranuni", "repeat", "resolve", "reverse", "rewind", "right", "round", "saving", "scan", "sdf", "second", "sign", "sin", "sinh", "skewness", "soundex", "spedis", "sqrt", "std", "stderr", "stfips", "stname", "stnamel", "substr", "sum", "symget", "sysget", "sysmsg", "sysprod", "sysrc", "system", "tan", "tanh", "time", "timepart", "tinv", "tnonct", "today", "translate", "tranwrd", "trigamma", "trim", "trimn", "trunc", "uniform", "upcase", "uss", "var", "varfmt", "varinfmt", "varlabel", "varlen", "varname", "varnum", "varray", "varrayx", "vartype", "verify", "vformat", "vformatd", "vformatdx", "vformatn", "vformatnx", "vformatw", "vformatwx", "vformatx", "vinarray", "vinarrayx", "vinformat", "vinformatd", "vinformatdx", "vinformatn", "vinformatnx", "vinformatw", "vinformatwx", "vinformatx", "vlabel", "vlabelx", "vlength", "vlengthx", "vname", "vnamex", "vtype", "vtypex", "weekday", "year", "yyq", "zipfips", "zipname", "zipnamel", "zipstate") + "(?=\\()"
                },
                {
                    className: "string",
                    variants: [
                        e.APOS_STRING_MODE,
                        e.QUOTE_STRING_MODE
                    ]
                },
                e.COMMENT("\\*", ";"),
                e.C_BLOCK_COMMENT_MODE
            ]
        };
    }), jr)), Cs.registerLanguage("scala", (Jr || (Jr = 1, Zr = function(e) {
        const t = e.regex, a = {
            className: "subst",
            variants: [
                {
                    begin: "\\$[A-Za-z0-9_]+"
                },
                {
                    begin: /\$\{/,
                    end: /\}/
                }
            ]
        }, n = {
            className: "string",
            variants: [
                {
                    begin: '"""',
                    end: '"""'
                },
                {
                    begin: '"',
                    end: '"',
                    illegal: "\\n",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: '[a-z]+"',
                    end: '"',
                    illegal: "\\n",
                    contains: [
                        e.BACKSLASH_ESCAPE,
                        a
                    ]
                },
                {
                    className: "string",
                    begin: '[a-z]+"""',
                    end: '"""',
                    contains: [
                        a
                    ],
                    relevance: 10
                }
            ]
        }, i = {
            className: "type",
            begin: "\\b[A-Z][A-Za-z0-9_]*",
            relevance: 0
        }, r = {
            className: "title",
            begin: /[^0-9\n\t "'(),.`{}\[\]:;][^\n\t "'(),.`{}\[\]:;]+|[^0-9\n\t "'(),.`{}\[\]:;=]/,
            relevance: 0
        }, o = {
            className: "class",
            beginKeywords: "class object trait type",
            end: /[:={\[\n;]/,
            excludeEnd: !0,
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    beginKeywords: "extends with",
                    relevance: 10
                },
                {
                    begin: /\[/,
                    end: /\]/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    relevance: 0,
                    contains: [
                        i,
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                {
                    className: "params",
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    relevance: 0,
                    contains: [
                        i,
                        e.C_LINE_COMMENT_MODE,
                        e.C_BLOCK_COMMENT_MODE
                    ]
                },
                r
            ]
        }, s = {
            className: "function",
            beginKeywords: "def",
            end: t.lookahead(/[:={\[(\n;]/),
            contains: [
                r
            ]
        };
        return {
            name: "Scala",
            keywords: {
                literal: "true false null",
                keyword: "type yield lazy override def with val var sealed abstract private trait object if then forSome for while do throw finally protected extends import final return else break new catch super class case package default try this match continue throws implicit export enum given transparent"
            },
            contains: [
                {
                    begin: [
                        "//>",
                        /\s+/,
                        /using/,
                        /\s+/,
                        /\S+/
                    ],
                    beginScope: {
                        1: "comment",
                        3: "keyword",
                        5: "type"
                    },
                    end: /$/,
                    contains: [
                        {
                            className: "string",
                            begin: /\S+/
                        }
                    ]
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                n,
                i,
                s,
                o,
                e.C_NUMBER_MODE,
                {
                    begin: [
                        /^\s*/,
                        "extension",
                        /\s+(?=[[(])/
                    ],
                    beginScope: {
                        2: "keyword"
                    }
                },
                {
                    begin: [
                        /^\s*/,
                        /end/,
                        /\s+/,
                        /(extension\b)?/
                    ],
                    beginScope: {
                        2: "keyword",
                        4: "keyword"
                    }
                },
                {
                    match: /\.inline\b/
                },
                {
                    begin: /\binline(?=\s)/,
                    keywords: "inline"
                },
                {
                    begin: [
                        /\(\s*/,
                        /using/,
                        /\s+(?!\))/
                    ],
                    beginScope: {
                        2: "keyword"
                    }
                },
                {
                    className: "meta",
                    begin: "@[A-Za-z]+"
                }
            ]
        };
    }), Zr)), Cs.registerLanguage("scheme", (to || (to = 1, eo = function(e) {
        const t = "[^\\(\\)\\[\\]\\{\\}\",'`;#|\\\\\\s]+", a = "(-|\\+)?\\d+([./]\\d+)?", n = {
            $pattern: t,
            built_in: "case-lambda call/cc class define-class exit-handler field import inherit init-field interface let*-values let-values let/ec mixin opt-lambda override protect provide public rename require require-for-syntax syntax syntax-case syntax-error unit/sig unless when with-syntax and begin call-with-current-continuation call-with-input-file call-with-output-file case cond define define-syntax delay do dynamic-wind else for-each if lambda let let* let-syntax letrec letrec-syntax map or syntax-rules ' * + , ,@ - ... / ; < <= = => > >= ` abs acos angle append apply asin assoc assq assv atan boolean? caar cadr call-with-input-file call-with-output-file call-with-values car cdddar cddddr cdr ceiling char->integer char-alphabetic? char-ci<=? char-ci<? char-ci=? char-ci>=? char-ci>? char-downcase char-lower-case? char-numeric? char-ready? char-upcase char-upper-case? char-whitespace? char<=? char<? char=? char>=? char>? char? close-input-port close-output-port complex? cons cos current-input-port current-output-port denominator display eof-object? eq? equal? eqv? eval even? exact->inexact exact? exp expt floor force gcd imag-part inexact->exact inexact? input-port? integer->char integer? interaction-environment lcm length list list->string list->vector list-ref list-tail list? load log magnitude make-polar make-rectangular make-string make-vector max member memq memv min modulo negative? newline not null-environment null? number->string number? numerator odd? open-input-file open-output-file output-port? pair? peek-char port? positive? procedure? quasiquote quote quotient rational? rationalize read read-char real-part real? remainder reverse round scheme-report-environment set! set-car! set-cdr! sin sqrt string string->list string->number string->symbol string-append string-ci<=? string-ci<? string-ci=? string-ci>=? string-ci>? string-copy string-fill! string-length string-ref string-set! string<=? string<? string=? string>=? string>? string? substring symbol->string symbol? tan transcript-off transcript-on truncate values vector vector->list vector-fill! vector-length vector-ref vector-set! with-input-from-file with-output-to-file write write-char zero?"
        }, i = {
            className: "literal",
            begin: "(#t|#f|#\\\\" + t + "|#\\\\.)"
        }, r = {
            className: "number",
            variants: [
                {
                    begin: a,
                    relevance: 0
                },
                {
                    begin: a + "[+\\-]" + a + "i",
                    relevance: 0
                },
                {
                    begin: "#b[0-1]+(/[0-1]+)?"
                },
                {
                    begin: "#o[0-7]+(/[0-7]+)?"
                },
                {
                    begin: "#x[0-9a-f]+(/[0-9a-f]+)?"
                }
            ]
        }, o = e.QUOTE_STRING_MODE, s = [
            e.COMMENT(";", "$", {
                relevance: 0
            }),
            e.COMMENT("#\\|", "\\|#")
        ], l = {
            begin: t,
            relevance: 0
        }, c = {
            className: "symbol",
            begin: "'" + t
        }, _ = {
            endsWithParent: !0,
            relevance: 0
        }, d = {
            variants: [
                {
                    begin: /'/
                },
                {
                    begin: "`"
                }
            ],
            contains: [
                {
                    begin: "\\(",
                    end: "\\)",
                    contains: [
                        "self",
                        i,
                        o,
                        r,
                        l,
                        c
                    ]
                }
            ]
        }, m = {
            className: "name",
            relevance: 0,
            begin: t,
            keywords: n
        }, p = {
            variants: [
                {
                    begin: "\\(",
                    end: "\\)"
                },
                {
                    begin: "\\[",
                    end: "\\]"
                }
            ],
            contains: [
                {
                    begin: /lambda/,
                    endsWithParent: !0,
                    returnBegin: !0,
                    contains: [
                        m,
                        {
                            endsParent: !0,
                            variants: [
                                {
                                    begin: /\(/,
                                    end: /\)/
                                },
                                {
                                    begin: /\[/,
                                    end: /\]/
                                }
                            ],
                            contains: [
                                l
                            ]
                        }
                    ]
                },
                m,
                _
            ]
        };
        return _.contains = [
            i,
            r,
            o,
            l,
            c,
            d,
            p
        ].concat(s), {
            name: "Scheme",
            aliases: [
                "scm"
            ],
            illegal: /\S/,
            contains: [
                e.SHEBANG(),
                r,
                o,
                c,
                d,
                p
            ].concat(s)
        };
    }), eo)), Cs.registerLanguage("scilab", (no || (no = 1, ao = function(e) {
        const t = [
            e.C_NUMBER_MODE,
            {
                className: "string",
                begin: "'|\"",
                end: "'|\"",
                contains: [
                    e.BACKSLASH_ESCAPE,
                    {
                        begin: "''"
                    }
                ]
            }
        ];
        return {
            name: "Scilab",
            aliases: [
                "sci"
            ],
            keywords: {
                $pattern: /%?\w+/,
                keyword: "abort break case clear catch continue do elseif else endfunction end for function global if pause return resume select try then while",
                literal: "%f %F %t %T %pi %eps %inf %nan %e %i %z %s",
                built_in: "abs and acos asin atan ceil cd chdir clearglobal cosh cos cumprod deff disp error exec execstr exists exp eye gettext floor fprintf fread fsolve imag isdef isempty isinfisnan isvector lasterror length load linspace list listfiles log10 log2 log max min msprintf mclose mopen ones or pathconvert poly printf prod pwd rand real round sinh sin size gsort sprintf sqrt strcat strcmps tring sum system tanh tan type typename warning zeros matrix"
            },
            illegal: '("|#|/\\*|\\s+/\\w+)',
            contains: [
                {
                    className: "function",
                    beginKeywords: "function",
                    end: "$",
                    contains: [
                        e.UNDERSCORE_TITLE_MODE,
                        {
                            className: "params",
                            begin: "\\(",
                            end: "\\)"
                        }
                    ]
                },
                {
                    begin: "[a-zA-Z_][a-zA-Z_0-9]*[\\.']+",
                    relevance: 0
                },
                {
                    begin: "\\[",
                    end: "\\][\\.']*",
                    relevance: 0,
                    contains: t
                },
                e.COMMENT("//", "$")
            ].concat(t)
        };
    }), ao)), Cs.registerLanguage("scss", function() {
        if (ro) return io;
        ro = 1;
        const e = [
            "a",
            "abbr",
            "address",
            "article",
            "aside",
            "audio",
            "b",
            "blockquote",
            "body",
            "button",
            "canvas",
            "caption",
            "cite",
            "code",
            "dd",
            "del",
            "details",
            "dfn",
            "div",
            "dl",
            "dt",
            "em",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "html",
            "i",
            "iframe",
            "img",
            "input",
            "ins",
            "kbd",
            "label",
            "legend",
            "li",
            "main",
            "mark",
            "menu",
            "nav",
            "object",
            "ol",
            "p",
            "q",
            "quote",
            "samp",
            "section",
            "span",
            "strong",
            "summary",
            "sup",
            "table",
            "tbody",
            "td",
            "textarea",
            "tfoot",
            "th",
            "thead",
            "time",
            "tr",
            "ul",
            "var",
            "video"
        ], t = [
            "any-hover",
            "any-pointer",
            "aspect-ratio",
            "color",
            "color-gamut",
            "color-index",
            "device-aspect-ratio",
            "device-height",
            "device-width",
            "display-mode",
            "forced-colors",
            "grid",
            "height",
            "hover",
            "inverted-colors",
            "monochrome",
            "orientation",
            "overflow-block",
            "overflow-inline",
            "pointer",
            "prefers-color-scheme",
            "prefers-contrast",
            "prefers-reduced-motion",
            "prefers-reduced-transparency",
            "resolution",
            "scan",
            "scripting",
            "update",
            "width",
            "min-width",
            "max-width",
            "min-height",
            "max-height"
        ], a = [
            "active",
            "any-link",
            "blank",
            "checked",
            "current",
            "default",
            "defined",
            "dir",
            "disabled",
            "drop",
            "empty",
            "enabled",
            "first",
            "first-child",
            "first-of-type",
            "fullscreen",
            "future",
            "focus",
            "focus-visible",
            "focus-within",
            "has",
            "host",
            "host-context",
            "hover",
            "indeterminate",
            "in-range",
            "invalid",
            "is",
            "lang",
            "last-child",
            "last-of-type",
            "left",
            "link",
            "local-link",
            "not",
            "nth-child",
            "nth-col",
            "nth-last-child",
            "nth-last-col",
            "nth-last-of-type",
            "nth-of-type",
            "only-child",
            "only-of-type",
            "optional",
            "out-of-range",
            "past",
            "placeholder-shown",
            "read-only",
            "read-write",
            "required",
            "right",
            "root",
            "scope",
            "target",
            "target-within",
            "user-invalid",
            "valid",
            "visited",
            "where"
        ], n = [
            "after",
            "backdrop",
            "before",
            "cue",
            "cue-region",
            "first-letter",
            "first-line",
            "grammar-error",
            "marker",
            "part",
            "placeholder",
            "selection",
            "slotted",
            "spelling-error"
        ], i = [
            "align-content",
            "align-items",
            "align-self",
            "all",
            "animation",
            "animation-delay",
            "animation-direction",
            "animation-duration",
            "animation-fill-mode",
            "animation-iteration-count",
            "animation-name",
            "animation-play-state",
            "animation-timing-function",
            "backface-visibility",
            "background",
            "background-attachment",
            "background-blend-mode",
            "background-clip",
            "background-color",
            "background-image",
            "background-origin",
            "background-position",
            "background-repeat",
            "background-size",
            "block-size",
            "border",
            "border-block",
            "border-block-color",
            "border-block-end",
            "border-block-end-color",
            "border-block-end-style",
            "border-block-end-width",
            "border-block-start",
            "border-block-start-color",
            "border-block-start-style",
            "border-block-start-width",
            "border-block-style",
            "border-block-width",
            "border-bottom",
            "border-bottom-color",
            "border-bottom-left-radius",
            "border-bottom-right-radius",
            "border-bottom-style",
            "border-bottom-width",
            "border-collapse",
            "border-color",
            "border-image",
            "border-image-outset",
            "border-image-repeat",
            "border-image-slice",
            "border-image-source",
            "border-image-width",
            "border-inline",
            "border-inline-color",
            "border-inline-end",
            "border-inline-end-color",
            "border-inline-end-style",
            "border-inline-end-width",
            "border-inline-start",
            "border-inline-start-color",
            "border-inline-start-style",
            "border-inline-start-width",
            "border-inline-style",
            "border-inline-width",
            "border-left",
            "border-left-color",
            "border-left-style",
            "border-left-width",
            "border-radius",
            "border-right",
            "border-right-color",
            "border-right-style",
            "border-right-width",
            "border-spacing",
            "border-style",
            "border-top",
            "border-top-color",
            "border-top-left-radius",
            "border-top-right-radius",
            "border-top-style",
            "border-top-width",
            "border-width",
            "bottom",
            "box-decoration-break",
            "box-shadow",
            "box-sizing",
            "break-after",
            "break-before",
            "break-inside",
            "caption-side",
            "caret-color",
            "clear",
            "clip",
            "clip-path",
            "clip-rule",
            "color",
            "column-count",
            "column-fill",
            "column-gap",
            "column-rule",
            "column-rule-color",
            "column-rule-style",
            "column-rule-width",
            "column-span",
            "column-width",
            "columns",
            "contain",
            "content",
            "content-visibility",
            "counter-increment",
            "counter-reset",
            "cue",
            "cue-after",
            "cue-before",
            "cursor",
            "direction",
            "display",
            "empty-cells",
            "filter",
            "flex",
            "flex-basis",
            "flex-direction",
            "flex-flow",
            "flex-grow",
            "flex-shrink",
            "flex-wrap",
            "float",
            "flow",
            "font",
            "font-display",
            "font-family",
            "font-feature-settings",
            "font-kerning",
            "font-language-override",
            "font-size",
            "font-size-adjust",
            "font-smoothing",
            "font-stretch",
            "font-style",
            "font-synthesis",
            "font-variant",
            "font-variant-caps",
            "font-variant-east-asian",
            "font-variant-ligatures",
            "font-variant-numeric",
            "font-variant-position",
            "font-variation-settings",
            "font-weight",
            "gap",
            "glyph-orientation-vertical",
            "grid",
            "grid-area",
            "grid-auto-columns",
            "grid-auto-flow",
            "grid-auto-rows",
            "grid-column",
            "grid-column-end",
            "grid-column-start",
            "grid-gap",
            "grid-row",
            "grid-row-end",
            "grid-row-start",
            "grid-template",
            "grid-template-areas",
            "grid-template-columns",
            "grid-template-rows",
            "hanging-punctuation",
            "height",
            "hyphens",
            "icon",
            "image-orientation",
            "image-rendering",
            "image-resolution",
            "ime-mode",
            "inline-size",
            "isolation",
            "justify-content",
            "left",
            "letter-spacing",
            "line-break",
            "line-height",
            "list-style",
            "list-style-image",
            "list-style-position",
            "list-style-type",
            "margin",
            "margin-block",
            "margin-block-end",
            "margin-block-start",
            "margin-bottom",
            "margin-inline",
            "margin-inline-end",
            "margin-inline-start",
            "margin-left",
            "margin-right",
            "margin-top",
            "marks",
            "mask",
            "mask-border",
            "mask-border-mode",
            "mask-border-outset",
            "mask-border-repeat",
            "mask-border-slice",
            "mask-border-source",
            "mask-border-width",
            "mask-clip",
            "mask-composite",
            "mask-image",
            "mask-mode",
            "mask-origin",
            "mask-position",
            "mask-repeat",
            "mask-size",
            "mask-type",
            "max-block-size",
            "max-height",
            "max-inline-size",
            "max-width",
            "min-block-size",
            "min-height",
            "min-inline-size",
            "min-width",
            "mix-blend-mode",
            "nav-down",
            "nav-index",
            "nav-left",
            "nav-right",
            "nav-up",
            "none",
            "normal",
            "object-fit",
            "object-position",
            "opacity",
            "order",
            "orphans",
            "outline",
            "outline-color",
            "outline-offset",
            "outline-style",
            "outline-width",
            "overflow",
            "overflow-wrap",
            "overflow-x",
            "overflow-y",
            "padding",
            "padding-block",
            "padding-block-end",
            "padding-block-start",
            "padding-bottom",
            "padding-inline",
            "padding-inline-end",
            "padding-inline-start",
            "padding-left",
            "padding-right",
            "padding-top",
            "page-break-after",
            "page-break-before",
            "page-break-inside",
            "pause",
            "pause-after",
            "pause-before",
            "perspective",
            "perspective-origin",
            "pointer-events",
            "position",
            "quotes",
            "resize",
            "rest",
            "rest-after",
            "rest-before",
            "right",
            "row-gap",
            "scroll-margin",
            "scroll-margin-block",
            "scroll-margin-block-end",
            "scroll-margin-block-start",
            "scroll-margin-bottom",
            "scroll-margin-inline",
            "scroll-margin-inline-end",
            "scroll-margin-inline-start",
            "scroll-margin-left",
            "scroll-margin-right",
            "scroll-margin-top",
            "scroll-padding",
            "scroll-padding-block",
            "scroll-padding-block-end",
            "scroll-padding-block-start",
            "scroll-padding-bottom",
            "scroll-padding-inline",
            "scroll-padding-inline-end",
            "scroll-padding-inline-start",
            "scroll-padding-left",
            "scroll-padding-right",
            "scroll-padding-top",
            "scroll-snap-align",
            "scroll-snap-stop",
            "scroll-snap-type",
            "scrollbar-color",
            "scrollbar-gutter",
            "scrollbar-width",
            "shape-image-threshold",
            "shape-margin",
            "shape-outside",
            "speak",
            "speak-as",
            "src",
            "tab-size",
            "table-layout",
            "text-align",
            "text-align-all",
            "text-align-last",
            "text-combine-upright",
            "text-decoration",
            "text-decoration-color",
            "text-decoration-line",
            "text-decoration-style",
            "text-emphasis",
            "text-emphasis-color",
            "text-emphasis-position",
            "text-emphasis-style",
            "text-indent",
            "text-justify",
            "text-orientation",
            "text-overflow",
            "text-rendering",
            "text-shadow",
            "text-transform",
            "text-underline-position",
            "top",
            "transform",
            "transform-box",
            "transform-origin",
            "transform-style",
            "transition",
            "transition-delay",
            "transition-duration",
            "transition-property",
            "transition-timing-function",
            "unicode-bidi",
            "vertical-align",
            "visibility",
            "voice-balance",
            "voice-duration",
            "voice-family",
            "voice-pitch",
            "voice-range",
            "voice-rate",
            "voice-stress",
            "voice-volume",
            "white-space",
            "widows",
            "width",
            "will-change",
            "word-break",
            "word-spacing",
            "word-wrap",
            "writing-mode",
            "z-index"
        ].reverse();
        return io = function(r) {
            const o = ((e)=>({
                    IMPORTANT: {
                        scope: "meta",
                        begin: "!important"
                    },
                    BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
                    HEXCOLOR: {
                        scope: "number",
                        begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
                    },
                    FUNCTION_DISPATCH: {
                        className: "built_in",
                        begin: /[\w-]+(?=\()/
                    },
                    ATTRIBUTE_SELECTOR_MODE: {
                        scope: "selector-attr",
                        begin: /\[/,
                        end: /\]/,
                        illegal: "$",
                        contains: [
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    CSS_NUMBER_MODE: {
                        scope: "number",
                        begin: e.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
                        relevance: 0
                    },
                    CSS_VARIABLE: {
                        className: "attr",
                        begin: /--[A-Za-z_][A-Za-z0-9_-]*/
                    }
                }))(r), s = n, l = a, c = "@[a-z-]+", _ = {
                className: "variable",
                begin: "(\\$[a-zA-Z-][a-zA-Z0-9_-]*)\\b",
                relevance: 0
            };
            return {
                name: "SCSS",
                case_insensitive: !0,
                illegal: "[=/|']",
                contains: [
                    r.C_LINE_COMMENT_MODE,
                    r.C_BLOCK_COMMENT_MODE,
                    o.CSS_NUMBER_MODE,
                    {
                        className: "selector-id",
                        begin: "#[A-Za-z0-9_-]+",
                        relevance: 0
                    },
                    {
                        className: "selector-class",
                        begin: "\\.[A-Za-z0-9_-]+",
                        relevance: 0
                    },
                    o.ATTRIBUTE_SELECTOR_MODE,
                    {
                        className: "selector-tag",
                        begin: "\\b(" + e.join("|") + ")\\b",
                        relevance: 0
                    },
                    {
                        className: "selector-pseudo",
                        begin: ":(" + l.join("|") + ")"
                    },
                    {
                        className: "selector-pseudo",
                        begin: ":(:)?(" + s.join("|") + ")"
                    },
                    _,
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            o.CSS_NUMBER_MODE
                        ]
                    },
                    o.CSS_VARIABLE,
                    {
                        className: "attribute",
                        begin: "\\b(" + i.join("|") + ")\\b"
                    },
                    {
                        begin: "\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b"
                    },
                    {
                        begin: /:/,
                        end: /[;}{]/,
                        relevance: 0,
                        contains: [
                            o.BLOCK_COMMENT,
                            _,
                            o.HEXCOLOR,
                            o.CSS_NUMBER_MODE,
                            r.QUOTE_STRING_MODE,
                            r.APOS_STRING_MODE,
                            o.IMPORTANT,
                            o.FUNCTION_DISPATCH
                        ]
                    },
                    {
                        begin: "@(page|font-face)",
                        keywords: {
                            $pattern: c,
                            keyword: "@page @font-face"
                        }
                    },
                    {
                        begin: "@",
                        end: "[{;]",
                        returnBegin: !0,
                        keywords: {
                            $pattern: /[a-z-]+/,
                            keyword: "and or not only",
                            attribute: t.join(" ")
                        },
                        contains: [
                            {
                                begin: c,
                                className: "keyword"
                            },
                            {
                                begin: /[a-z-]+(?=:)/,
                                className: "attribute"
                            },
                            _,
                            r.QUOTE_STRING_MODE,
                            r.APOS_STRING_MODE,
                            o.HEXCOLOR,
                            o.CSS_NUMBER_MODE
                        ]
                    },
                    o.FUNCTION_DISPATCH
                ]
            };
        }, io;
    }()), Cs.registerLanguage("shell", so ? oo : (so = 1, oo = function(e) {
        return {
            name: "Shell Session",
            aliases: [
                "console",
                "shellsession"
            ],
            contains: [
                {
                    className: "meta.prompt",
                    begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#][ ]?/,
                    starts: {
                        end: /[^\\](?=\s*$)/,
                        subLanguage: "bash"
                    }
                }
            ]
        };
    })), Cs.registerLanguage("smali", (co || (co = 1, lo = function(e) {
        const t = [
            "add",
            "and",
            "cmp",
            "cmpg",
            "cmpl",
            "const",
            "div",
            "double",
            "float",
            "goto",
            "if",
            "int",
            "long",
            "move",
            "mul",
            "neg",
            "new",
            "nop",
            "not",
            "or",
            "rem",
            "return",
            "shl",
            "shr",
            "sput",
            "sub",
            "throw",
            "ushr",
            "xor"
        ];
        return {
            name: "Smali",
            contains: [
                {
                    className: "string",
                    begin: '"',
                    end: '"',
                    relevance: 0
                },
                e.COMMENT("#", "$", {
                    relevance: 0
                }),
                {
                    className: "keyword",
                    variants: [
                        {
                            begin: "\\s*\\.end\\s[a-zA-Z0-9]*"
                        },
                        {
                            begin: "^[ ]*\\.[a-zA-Z]*",
                            relevance: 0
                        },
                        {
                            begin: "\\s:[a-zA-Z_0-9]*",
                            relevance: 0
                        },
                        {
                            begin: "\\s(" + [
                                "transient",
                                "constructor",
                                "abstract",
                                "final",
                                "synthetic",
                                "public",
                                "private",
                                "protected",
                                "static",
                                "bridge",
                                "system"
                            ].join("|") + ")"
                        }
                    ]
                },
                {
                    className: "built_in",
                    variants: [
                        {
                            begin: "\\s(" + t.join("|") + ")\\s"
                        },
                        {
                            begin: "\\s(" + t.join("|") + ")((-|/)[a-zA-Z0-9]+)+\\s",
                            relevance: 10
                        },
                        {
                            begin: "\\s(" + [
                                "aget",
                                "aput",
                                "array",
                                "check",
                                "execute",
                                "fill",
                                "filled",
                                "goto/16",
                                "goto/32",
                                "iget",
                                "instance",
                                "invoke",
                                "iput",
                                "monitor",
                                "packed",
                                "sget",
                                "sparse"
                            ].join("|") + ")((-|/)[a-zA-Z0-9]+)*\\s",
                            relevance: 10
                        }
                    ]
                },
                {
                    className: "class",
                    begin: "L[^(;:\n]*;",
                    relevance: 0
                },
                {
                    begin: "[vp][0-9]+"
                }
            ]
        };
    }), lo)), Cs.registerLanguage("smalltalk", (mo || (mo = 1, _o = function(e) {
        const t = "[a-z][a-zA-Z0-9_]*", a = {
            className: "string",
            begin: "\\$.{1}"
        }, n = {
            className: "symbol",
            begin: "#" + e.UNDERSCORE_IDENT_RE
        };
        return {
            name: "Smalltalk",
            aliases: [
                "st"
            ],
            keywords: [
                "self",
                "super",
                "nil",
                "true",
                "false",
                "thisContext"
            ],
            contains: [
                e.COMMENT('"', '"'),
                e.APOS_STRING_MODE,
                {
                    className: "type",
                    begin: "\\b[A-Z][A-Za-z0-9_]*",
                    relevance: 0
                },
                {
                    begin: t + ":",
                    relevance: 0
                },
                e.C_NUMBER_MODE,
                n,
                a,
                {
                    begin: "\\|[ ]*" + t + "([ ]+" + t + ")*[ ]*\\|",
                    returnBegin: !0,
                    end: /\|/,
                    illegal: /\S/,
                    contains: [
                        {
                            begin: "(\\|[ ]*)?" + t
                        }
                    ]
                },
                {
                    begin: "#\\(",
                    end: "\\)",
                    contains: [
                        e.APOS_STRING_MODE,
                        a,
                        e.C_NUMBER_MODE,
                        n
                    ]
                }
            ]
        };
    }), _o)), Cs.registerLanguage("sml", (uo || (uo = 1, po = function(e) {
        return {
            name: "SML (Standard ML)",
            aliases: [
                "ml"
            ],
            keywords: {
                $pattern: "[a-z_]\\w*!?",
                keyword: "abstype and andalso as case datatype do else end eqtype exception fn fun functor handle if in include infix infixr let local nonfix of op open orelse raise rec sharing sig signature struct structure then type val with withtype where while",
                built_in: "array bool char exn int list option order real ref string substring vector unit word",
                literal: "true false NONE SOME LESS EQUAL GREATER nil"
            },
            illegal: /\/\/|>>/,
            contains: [
                {
                    className: "literal",
                    begin: /\[(\|\|)?\]|\(\)/,
                    relevance: 0
                },
                e.COMMENT("\\(\\*", "\\*\\)", {
                    contains: [
                        "self"
                    ]
                }),
                {
                    className: "symbol",
                    begin: "'[A-Za-z_](?!')[\\w']*"
                },
                {
                    className: "type",
                    begin: "`[A-Z][\\w']*"
                },
                {
                    className: "type",
                    begin: "\\b[A-Z][\\w']*",
                    relevance: 0
                },
                {
                    begin: "[a-z_]\\w*'[\\w']*"
                },
                e.inherit(e.APOS_STRING_MODE, {
                    className: "string",
                    relevance: 0
                }),
                e.inherit(e.QUOTE_STRING_MODE, {
                    illegal: null
                }),
                {
                    className: "number",
                    begin: "\\b(0[xX][a-fA-F0-9_]+[Lln]?|0[oO][0-7_]+[Lln]?|0[bB][01_]+[Lln]?|[0-9][0-9_]*([Lln]|(\\.[0-9_]*)?([eE][-+]?[0-9_]+)?)?)",
                    relevance: 0
                },
                {
                    begin: /[-=]>/
                }
            ]
        };
    }), po)), Cs.registerLanguage("sqf", (Eo || (Eo = 1, go = function(e) {
        const t = {
            className: "string",
            variants: [
                {
                    begin: '"',
                    end: '"',
                    contains: [
                        {
                            begin: '""',
                            relevance: 0
                        }
                    ]
                },
                {
                    begin: "'",
                    end: "'",
                    contains: [
                        {
                            begin: "''",
                            relevance: 0
                        }
                    ]
                }
            ]
        }, a = {
            className: "meta",
            begin: /#\s*[a-z]+\b/,
            end: /$/,
            keywords: "define undef ifdef ifndef else endif include if",
            contains: [
                {
                    begin: /\\\n/,
                    relevance: 0
                },
                e.inherit(t, {
                    className: "string"
                }),
                {
                    begin: /<[^\n>]*>/,
                    end: /$/,
                    illegal: "\\n"
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE
            ]
        };
        return {
            name: "SQF",
            case_insensitive: !0,
            keywords: {
                keyword: [
                    "break",
                    "breakWith",
                    "breakOut",
                    "breakTo",
                    "case",
                    "catch",
                    "continue",
                    "continueWith",
                    "default",
                    "do",
                    "else",
                    "exit",
                    "exitWith",
                    "for",
                    "forEach",
                    "from",
                    "if",
                    "local",
                    "private",
                    "switch",
                    "step",
                    "then",
                    "throw",
                    "to",
                    "try",
                    "waitUntil",
                    "while",
                    "with"
                ],
                built_in: [
                    "abs",
                    "accTime",
                    "acos",
                    "action",
                    "actionIDs",
                    "actionKeys",
                    "actionKeysEx",
                    "actionKeysImages",
                    "actionKeysNames",
                    "actionKeysNamesArray",
                    "actionName",
                    "actionParams",
                    "activateAddons",
                    "activatedAddons",
                    "activateKey",
                    "activeTitleEffectParams",
                    "add3DENConnection",
                    "add3DENEventHandler",
                    "add3DENLayer",
                    "addAction",
                    "addBackpack",
                    "addBackpackCargo",
                    "addBackpackCargoGlobal",
                    "addBackpackGlobal",
                    "addBinocularItem",
                    "addCamShake",
                    "addCuratorAddons",
                    "addCuratorCameraArea",
                    "addCuratorEditableObjects",
                    "addCuratorEditingArea",
                    "addCuratorPoints",
                    "addEditorObject",
                    "addEventHandler",
                    "addForce",
                    "addForceGeneratorRTD",
                    "addGoggles",
                    "addGroupIcon",
                    "addHandgunItem",
                    "addHeadgear",
                    "addItem",
                    "addItemCargo",
                    "addItemCargoGlobal",
                    "addItemPool",
                    "addItemToBackpack",
                    "addItemToUniform",
                    "addItemToVest",
                    "addLiveStats",
                    "addMagazine",
                    "addMagazineAmmoCargo",
                    "addMagazineCargo",
                    "addMagazineCargoGlobal",
                    "addMagazineGlobal",
                    "addMagazinePool",
                    "addMagazines",
                    "addMagazineTurret",
                    "addMenu",
                    "addMenuItem",
                    "addMissionEventHandler",
                    "addMPEventHandler",
                    "addMusicEventHandler",
                    "addonFiles",
                    "addOwnedMine",
                    "addPlayerScores",
                    "addPrimaryWeaponItem",
                    "addPublicVariableEventHandler",
                    "addRating",
                    "addResources",
                    "addScore",
                    "addScoreSide",
                    "addSecondaryWeaponItem",
                    "addSwitchableUnit",
                    "addTeamMember",
                    "addToRemainsCollector",
                    "addTorque",
                    "addUniform",
                    "addUserActionEventHandler",
                    "addVehicle",
                    "addVest",
                    "addWaypoint",
                    "addWeapon",
                    "addWeaponCargo",
                    "addWeaponCargoGlobal",
                    "addWeaponGlobal",
                    "addWeaponItem",
                    "addWeaponPool",
                    "addWeaponTurret",
                    "addWeaponWithAttachmentsCargo",
                    "addWeaponWithAttachmentsCargoGlobal",
                    "admin",
                    "agent",
                    "agents",
                    "AGLToASL",
                    "aimedAtTarget",
                    "aimPos",
                    "airDensityCurveRTD",
                    "airDensityRTD",
                    "airplaneThrottle",
                    "airportSide",
                    "AISFinishHeal",
                    "alive",
                    "all3DENEntities",
                    "allActiveTitleEffects",
                    "allAddonsInfo",
                    "allAirports",
                    "allControls",
                    "allCurators",
                    "allCutLayers",
                    "allDead",
                    "allDeadMen",
                    "allDiaryRecords",
                    "allDiarySubjects",
                    "allDisplays",
                    "allEnv3DSoundSources",
                    "allGroups",
                    "allLODs",
                    "allMapMarkers",
                    "allMines",
                    "allMissionObjects",
                    "allObjects",
                    "allow3DMode",
                    "allowCrewInImmobile",
                    "allowCuratorLogicIgnoreAreas",
                    "allowDamage",
                    "allowDammage",
                    "allowedService",
                    "allowFileOperations",
                    "allowFleeing",
                    "allowGetIn",
                    "allowService",
                    "allowSprint",
                    "allPlayers",
                    "allSimpleObjects",
                    "allSites",
                    "allTurrets",
                    "allUnits",
                    "allUnitsUAV",
                    "allUsers",
                    "allVariables",
                    "ambientTemperature",
                    "ammo",
                    "ammoOnPylon",
                    "and",
                    "animate",
                    "animateBay",
                    "animateDoor",
                    "animatePylon",
                    "animateSource",
                    "animationNames",
                    "animationPhase",
                    "animationSourcePhase",
                    "animationState",
                    "apertureParams",
                    "append",
                    "apply",
                    "armoryPoints",
                    "arrayIntersect",
                    "asin",
                    "ASLToAGL",
                    "ASLToATL",
                    "assert",
                    "assignAsCargo",
                    "assignAsCargoIndex",
                    "assignAsCommander",
                    "assignAsDriver",
                    "assignAsGunner",
                    "assignAsTurret",
                    "assignCurator",
                    "assignedCargo",
                    "assignedCommander",
                    "assignedDriver",
                    "assignedGroup",
                    "assignedGunner",
                    "assignedItems",
                    "assignedTarget",
                    "assignedTeam",
                    "assignedVehicle",
                    "assignedVehicleRole",
                    "assignedVehicles",
                    "assignItem",
                    "assignTeam",
                    "assignToAirport",
                    "atan",
                    "atan2",
                    "atg",
                    "ATLToASL",
                    "attachedObject",
                    "attachedObjects",
                    "attachedTo",
                    "attachObject",
                    "attachTo",
                    "attackEnabled",
                    "awake",
                    "backpack",
                    "backpackCargo",
                    "backpackContainer",
                    "backpackItems",
                    "backpackMagazines",
                    "backpackSpaceFor",
                    "behaviour",
                    "benchmark",
                    "bezierInterpolation",
                    "binocular",
                    "binocularItems",
                    "binocularMagazine",
                    "boundingBox",
                    "boundingBoxReal",
                    "boundingCenter",
                    "brakesDisabled",
                    "briefingName",
                    "buildingExit",
                    "buildingPos",
                    "buldozer_EnableRoadDiag",
                    "buldozer_IsEnabledRoadDiag",
                    "buldozer_LoadNewRoads",
                    "buldozer_reloadOperMap",
                    "buttonAction",
                    "buttonSetAction",
                    "cadetMode",
                    "calculatePath",
                    "calculatePlayerVisibilityByFriendly",
                    "call",
                    "callExtension",
                    "camCommand",
                    "camCommit",
                    "camCommitPrepared",
                    "camCommitted",
                    "camConstuctionSetParams",
                    "camCreate",
                    "camDestroy",
                    "cameraEffect",
                    "cameraEffectEnableHUD",
                    "cameraInterest",
                    "cameraOn",
                    "cameraView",
                    "campaignConfigFile",
                    "camPreload",
                    "camPreloaded",
                    "camPrepareBank",
                    "camPrepareDir",
                    "camPrepareDive",
                    "camPrepareFocus",
                    "camPrepareFov",
                    "camPrepareFovRange",
                    "camPreparePos",
                    "camPrepareRelPos",
                    "camPrepareTarget",
                    "camSetBank",
                    "camSetDir",
                    "camSetDive",
                    "camSetFocus",
                    "camSetFov",
                    "camSetFovRange",
                    "camSetPos",
                    "camSetRelPos",
                    "camSetTarget",
                    "camTarget",
                    "camUseNVG",
                    "canAdd",
                    "canAddItemToBackpack",
                    "canAddItemToUniform",
                    "canAddItemToVest",
                    "cancelSimpleTaskDestination",
                    "canDeployWeapon",
                    "canFire",
                    "canMove",
                    "canSlingLoad",
                    "canStand",
                    "canSuspend",
                    "canTriggerDynamicSimulation",
                    "canUnloadInCombat",
                    "canVehicleCargo",
                    "captive",
                    "captiveNum",
                    "cbChecked",
                    "cbSetChecked",
                    "ceil",
                    "channelEnabled",
                    "cheatsEnabled",
                    "checkAIFeature",
                    "checkVisibility",
                    "className",
                    "clear3DENAttribute",
                    "clear3DENInventory",
                    "clearAllItemsFromBackpack",
                    "clearBackpackCargo",
                    "clearBackpackCargoGlobal",
                    "clearForcesRTD",
                    "clearGroupIcons",
                    "clearItemCargo",
                    "clearItemCargoGlobal",
                    "clearItemPool",
                    "clearMagazineCargo",
                    "clearMagazineCargoGlobal",
                    "clearMagazinePool",
                    "clearOverlay",
                    "clearRadio",
                    "clearWeaponCargo",
                    "clearWeaponCargoGlobal",
                    "clearWeaponPool",
                    "clientOwner",
                    "closeDialog",
                    "closeDisplay",
                    "closeOverlay",
                    "collapseObjectTree",
                    "collect3DENHistory",
                    "collectiveRTD",
                    "collisionDisabledWith",
                    "combatBehaviour",
                    "combatMode",
                    "commandArtilleryFire",
                    "commandChat",
                    "commander",
                    "commandFire",
                    "commandFollow",
                    "commandFSM",
                    "commandGetOut",
                    "commandingMenu",
                    "commandMove",
                    "commandRadio",
                    "commandStop",
                    "commandSuppressiveFire",
                    "commandTarget",
                    "commandWatch",
                    "comment",
                    "commitOverlay",
                    "compatibleItems",
                    "compatibleMagazines",
                    "compile",
                    "compileFinal",
                    "compileScript",
                    "completedFSM",
                    "composeText",
                    "configClasses",
                    "configFile",
                    "configHierarchy",
                    "configName",
                    "configOf",
                    "configProperties",
                    "configSourceAddonList",
                    "configSourceMod",
                    "configSourceModList",
                    "confirmSensorTarget",
                    "connectTerminalToUAV",
                    "connectToServer",
                    "controlsGroupCtrl",
                    "conversationDisabled",
                    "copyFromClipboard",
                    "copyToClipboard",
                    "copyWaypoints",
                    "cos",
                    "count",
                    "countEnemy",
                    "countFriendly",
                    "countSide",
                    "countType",
                    "countUnknown",
                    "create3DENComposition",
                    "create3DENEntity",
                    "createAgent",
                    "createCenter",
                    "createDialog",
                    "createDiaryLink",
                    "createDiaryRecord",
                    "createDiarySubject",
                    "createDisplay",
                    "createGearDialog",
                    "createGroup",
                    "createGuardedPoint",
                    "createHashMap",
                    "createHashMapFromArray",
                    "createLocation",
                    "createMarker",
                    "createMarkerLocal",
                    "createMenu",
                    "createMine",
                    "createMissionDisplay",
                    "createMPCampaignDisplay",
                    "createSimpleObject",
                    "createSimpleTask",
                    "createSite",
                    "createSoundSource",
                    "createTask",
                    "createTeam",
                    "createTrigger",
                    "createUnit",
                    "createVehicle",
                    "createVehicleCrew",
                    "createVehicleLocal",
                    "crew",
                    "ctAddHeader",
                    "ctAddRow",
                    "ctClear",
                    "ctCurSel",
                    "ctData",
                    "ctFindHeaderRows",
                    "ctFindRowHeader",
                    "ctHeaderControls",
                    "ctHeaderCount",
                    "ctRemoveHeaders",
                    "ctRemoveRows",
                    "ctrlActivate",
                    "ctrlAddEventHandler",
                    "ctrlAngle",
                    "ctrlAnimateModel",
                    "ctrlAnimationPhaseModel",
                    "ctrlAt",
                    "ctrlAutoScrollDelay",
                    "ctrlAutoScrollRewind",
                    "ctrlAutoScrollSpeed",
                    "ctrlBackgroundColor",
                    "ctrlChecked",
                    "ctrlClassName",
                    "ctrlCommit",
                    "ctrlCommitted",
                    "ctrlCreate",
                    "ctrlDelete",
                    "ctrlEnable",
                    "ctrlEnabled",
                    "ctrlFade",
                    "ctrlFontHeight",
                    "ctrlForegroundColor",
                    "ctrlHTMLLoaded",
                    "ctrlIDC",
                    "ctrlIDD",
                    "ctrlMapAnimAdd",
                    "ctrlMapAnimClear",
                    "ctrlMapAnimCommit",
                    "ctrlMapAnimDone",
                    "ctrlMapCursor",
                    "ctrlMapMouseOver",
                    "ctrlMapPosition",
                    "ctrlMapScale",
                    "ctrlMapScreenToWorld",
                    "ctrlMapSetPosition",
                    "ctrlMapWorldToScreen",
                    "ctrlModel",
                    "ctrlModelDirAndUp",
                    "ctrlModelScale",
                    "ctrlMousePosition",
                    "ctrlParent",
                    "ctrlParentControlsGroup",
                    "ctrlPosition",
                    "ctrlRemoveAllEventHandlers",
                    "ctrlRemoveEventHandler",
                    "ctrlScale",
                    "ctrlScrollValues",
                    "ctrlSetActiveColor",
                    "ctrlSetAngle",
                    "ctrlSetAutoScrollDelay",
                    "ctrlSetAutoScrollRewind",
                    "ctrlSetAutoScrollSpeed",
                    "ctrlSetBackgroundColor",
                    "ctrlSetChecked",
                    "ctrlSetDisabledColor",
                    "ctrlSetEventHandler",
                    "ctrlSetFade",
                    "ctrlSetFocus",
                    "ctrlSetFont",
                    "ctrlSetFontH1",
                    "ctrlSetFontH1B",
                    "ctrlSetFontH2",
                    "ctrlSetFontH2B",
                    "ctrlSetFontH3",
                    "ctrlSetFontH3B",
                    "ctrlSetFontH4",
                    "ctrlSetFontH4B",
                    "ctrlSetFontH5",
                    "ctrlSetFontH5B",
                    "ctrlSetFontH6",
                    "ctrlSetFontH6B",
                    "ctrlSetFontHeight",
                    "ctrlSetFontHeightH1",
                    "ctrlSetFontHeightH2",
                    "ctrlSetFontHeightH3",
                    "ctrlSetFontHeightH4",
                    "ctrlSetFontHeightH5",
                    "ctrlSetFontHeightH6",
                    "ctrlSetFontHeightSecondary",
                    "ctrlSetFontP",
                    "ctrlSetFontPB",
                    "ctrlSetFontSecondary",
                    "ctrlSetForegroundColor",
                    "ctrlSetModel",
                    "ctrlSetModelDirAndUp",
                    "ctrlSetModelScale",
                    "ctrlSetMousePosition",
                    "ctrlSetPixelPrecision",
                    "ctrlSetPosition",
                    "ctrlSetPositionH",
                    "ctrlSetPositionW",
                    "ctrlSetPositionX",
                    "ctrlSetPositionY",
                    "ctrlSetScale",
                    "ctrlSetScrollValues",
                    "ctrlSetShadow",
                    "ctrlSetStructuredText",
                    "ctrlSetText",
                    "ctrlSetTextColor",
                    "ctrlSetTextColorSecondary",
                    "ctrlSetTextSecondary",
                    "ctrlSetTextSelection",
                    "ctrlSetTooltip",
                    "ctrlSetTooltipColorBox",
                    "ctrlSetTooltipColorShade",
                    "ctrlSetTooltipColorText",
                    "ctrlSetTooltipMaxWidth",
                    "ctrlSetURL",
                    "ctrlSetURLOverlayMode",
                    "ctrlShadow",
                    "ctrlShow",
                    "ctrlShown",
                    "ctrlStyle",
                    "ctrlText",
                    "ctrlTextColor",
                    "ctrlTextHeight",
                    "ctrlTextSecondary",
                    "ctrlTextSelection",
                    "ctrlTextWidth",
                    "ctrlTooltip",
                    "ctrlType",
                    "ctrlURL",
                    "ctrlURLOverlayMode",
                    "ctrlVisible",
                    "ctRowControls",
                    "ctRowCount",
                    "ctSetCurSel",
                    "ctSetData",
                    "ctSetHeaderTemplate",
                    "ctSetRowTemplate",
                    "ctSetValue",
                    "ctValue",
                    "curatorAddons",
                    "curatorCamera",
                    "curatorCameraArea",
                    "curatorCameraAreaCeiling",
                    "curatorCoef",
                    "curatorEditableObjects",
                    "curatorEditingArea",
                    "curatorEditingAreaType",
                    "curatorMouseOver",
                    "curatorPoints",
                    "curatorRegisteredObjects",
                    "curatorSelected",
                    "curatorWaypointCost",
                    "current3DENOperation",
                    "currentChannel",
                    "currentCommand",
                    "currentMagazine",
                    "currentMagazineDetail",
                    "currentMagazineDetailTurret",
                    "currentMagazineTurret",
                    "currentMuzzle",
                    "currentNamespace",
                    "currentPilot",
                    "currentTask",
                    "currentTasks",
                    "currentThrowable",
                    "currentVisionMode",
                    "currentWaypoint",
                    "currentWeapon",
                    "currentWeaponMode",
                    "currentWeaponTurret",
                    "currentZeroing",
                    "cursorObject",
                    "cursorTarget",
                    "customChat",
                    "customRadio",
                    "customWaypointPosition",
                    "cutFadeOut",
                    "cutObj",
                    "cutRsc",
                    "cutText",
                    "damage",
                    "date",
                    "dateToNumber",
                    "dayTime",
                    "deActivateKey",
                    "debriefingText",
                    "debugFSM",
                    "debugLog",
                    "decayGraphValues",
                    "deg",
                    "delete3DENEntities",
                    "deleteAt",
                    "deleteCenter",
                    "deleteCollection",
                    "deleteEditorObject",
                    "deleteGroup",
                    "deleteGroupWhenEmpty",
                    "deleteIdentity",
                    "deleteLocation",
                    "deleteMarker",
                    "deleteMarkerLocal",
                    "deleteRange",
                    "deleteResources",
                    "deleteSite",
                    "deleteStatus",
                    "deleteTeam",
                    "deleteVehicle",
                    "deleteVehicleCrew",
                    "deleteWaypoint",
                    "detach",
                    "detectedMines",
                    "diag_activeMissionFSMs",
                    "diag_activeScripts",
                    "diag_activeSQFScripts",
                    "diag_activeSQSScripts",
                    "diag_allMissionEventHandlers",
                    "diag_captureFrame",
                    "diag_captureFrameToFile",
                    "diag_captureSlowFrame",
                    "diag_codePerformance",
                    "diag_deltaTime",
                    "diag_drawmode",
                    "diag_dumpCalltraceToLog",
                    "diag_dumpScriptAssembly",
                    "diag_dumpTerrainSynth",
                    "diag_dynamicSimulationEnd",
                    "diag_enable",
                    "diag_enabled",
                    "diag_exportConfig",
                    "diag_exportTerrainSVG",
                    "diag_fps",
                    "diag_fpsmin",
                    "diag_frameno",
                    "diag_getTerrainSegmentOffset",
                    "diag_lightNewLoad",
                    "diag_list",
                    "diag_localized",
                    "diag_log",
                    "diag_logSlowFrame",
                    "diag_mergeConfigFile",
                    "diag_recordTurretLimits",
                    "diag_resetFSM",
                    "diag_resetshapes",
                    "diag_scope",
                    "diag_setLightNew",
                    "diag_stacktrace",
                    "diag_tickTime",
                    "diag_toggle",
                    "dialog",
                    "diarySubjectExists",
                    "didJIP",
                    "didJIPOwner",
                    "difficulty",
                    "difficultyEnabled",
                    "difficultyEnabledRTD",
                    "difficultyOption",
                    "direction",
                    "directionStabilizationEnabled",
                    "directSay",
                    "disableAI",
                    "disableBrakes",
                    "disableCollisionWith",
                    "disableConversation",
                    "disableDebriefingStats",
                    "disableMapIndicators",
                    "disableNVGEquipment",
                    "disableRemoteSensors",
                    "disableSerialization",
                    "disableTIEquipment",
                    "disableUAVConnectability",
                    "disableUserInput",
                    "displayAddEventHandler",
                    "displayChild",
                    "displayCtrl",
                    "displayParent",
                    "displayRemoveAllEventHandlers",
                    "displayRemoveEventHandler",
                    "displaySetEventHandler",
                    "displayUniqueName",
                    "displayUpdate",
                    "dissolveTeam",
                    "distance",
                    "distance2D",
                    "distanceSqr",
                    "distributionRegion",
                    "do3DENAction",
                    "doArtilleryFire",
                    "doFire",
                    "doFollow",
                    "doFSM",
                    "doGetOut",
                    "doMove",
                    "doorPhase",
                    "doStop",
                    "doSuppressiveFire",
                    "doTarget",
                    "doWatch",
                    "drawArrow",
                    "drawEllipse",
                    "drawIcon",
                    "drawIcon3D",
                    "drawLaser",
                    "drawLine",
                    "drawLine3D",
                    "drawLink",
                    "drawLocation",
                    "drawPolygon",
                    "drawRectangle",
                    "drawTriangle",
                    "driver",
                    "drop",
                    "dynamicSimulationDistance",
                    "dynamicSimulationDistanceCoef",
                    "dynamicSimulationEnabled",
                    "dynamicSimulationSystemEnabled",
                    "echo",
                    "edit3DENMissionAttributes",
                    "editObject",
                    "editorSetEventHandler",
                    "effectiveCommander",
                    "elevatePeriscope",
                    "emptyPositions",
                    "enableAI",
                    "enableAIFeature",
                    "enableAimPrecision",
                    "enableAttack",
                    "enableAudioFeature",
                    "enableAutoStartUpRTD",
                    "enableAutoTrimRTD",
                    "enableCamShake",
                    "enableCaustics",
                    "enableChannel",
                    "enableCollisionWith",
                    "enableCopilot",
                    "enableDebriefingStats",
                    "enableDiagLegend",
                    "enableDirectionStabilization",
                    "enableDynamicSimulation",
                    "enableDynamicSimulationSystem",
                    "enableEndDialog",
                    "enableEngineArtillery",
                    "enableEnvironment",
                    "enableFatigue",
                    "enableGunLights",
                    "enableInfoPanelComponent",
                    "enableIRLasers",
                    "enableMimics",
                    "enablePersonTurret",
                    "enableRadio",
                    "enableReload",
                    "enableRopeAttach",
                    "enableSatNormalOnDetail",
                    "enableSaving",
                    "enableSentences",
                    "enableSimulation",
                    "enableSimulationGlobal",
                    "enableStamina",
                    "enableStressDamage",
                    "enableTeamSwitch",
                    "enableTraffic",
                    "enableUAVConnectability",
                    "enableUAVWaypoints",
                    "enableVehicleCargo",
                    "enableVehicleSensor",
                    "enableWeaponDisassembly",
                    "endLoadingScreen",
                    "endMission",
                    "engineOn",
                    "enginesIsOnRTD",
                    "enginesPowerRTD",
                    "enginesRpmRTD",
                    "enginesTorqueRTD",
                    "entities",
                    "environmentEnabled",
                    "environmentVolume",
                    "equipmentDisabled",
                    "estimatedEndServerTime",
                    "estimatedTimeLeft",
                    "evalObjectArgument",
                    "everyBackpack",
                    "everyContainer",
                    "exec",
                    "execEditorScript",
                    "execFSM",
                    "execVM",
                    "exp",
                    "expectedDestination",
                    "exportJIPMessages",
                    "eyeDirection",
                    "eyePos",
                    "face",
                    "faction",
                    "fadeEnvironment",
                    "fadeMusic",
                    "fadeRadio",
                    "fadeSound",
                    "fadeSpeech",
                    "failMission",
                    "fileExists",
                    "fillWeaponsFromPool",
                    "find",
                    "findAny",
                    "findCover",
                    "findDisplay",
                    "findEditorObject",
                    "findEmptyPosition",
                    "findEmptyPositionReady",
                    "findIf",
                    "findNearestEnemy",
                    "finishMissionInit",
                    "finite",
                    "fire",
                    "fireAtTarget",
                    "firstBackpack",
                    "flag",
                    "flagAnimationPhase",
                    "flagOwner",
                    "flagSide",
                    "flagTexture",
                    "flatten",
                    "fleeing",
                    "floor",
                    "flyInHeight",
                    "flyInHeightASL",
                    "focusedCtrl",
                    "fog",
                    "fogForecast",
                    "fogParams",
                    "forceAddUniform",
                    "forceAtPositionRTD",
                    "forceCadetDifficulty",
                    "forcedMap",
                    "forceEnd",
                    "forceFlagTexture",
                    "forceFollowRoad",
                    "forceGeneratorRTD",
                    "forceMap",
                    "forceRespawn",
                    "forceSpeed",
                    "forceUnicode",
                    "forceWalk",
                    "forceWeaponFire",
                    "forceWeatherChange",
                    "forEachMember",
                    "forEachMemberAgent",
                    "forEachMemberTeam",
                    "forgetTarget",
                    "format",
                    "formation",
                    "formationDirection",
                    "formationLeader",
                    "formationMembers",
                    "formationPosition",
                    "formationTask",
                    "formatText",
                    "formLeader",
                    "freeExtension",
                    "freeLook",
                    "fromEditor",
                    "fuel",
                    "fullCrew",
                    "gearIDCAmmoCount",
                    "gearSlotAmmoCount",
                    "gearSlotData",
                    "gestureState",
                    "get",
                    "get3DENActionState",
                    "get3DENAttribute",
                    "get3DENCamera",
                    "get3DENConnections",
                    "get3DENEntity",
                    "get3DENEntityID",
                    "get3DENGrid",
                    "get3DENIconsVisible",
                    "get3DENLayerEntities",
                    "get3DENLinesVisible",
                    "get3DENMissionAttribute",
                    "get3DENMouseOver",
                    "get3DENSelected",
                    "getAimingCoef",
                    "getAllEnv3DSoundControllers",
                    "getAllEnvSoundControllers",
                    "getAllHitPointsDamage",
                    "getAllOwnedMines",
                    "getAllPylonsInfo",
                    "getAllSoundControllers",
                    "getAllUnitTraits",
                    "getAmmoCargo",
                    "getAnimAimPrecision",
                    "getAnimSpeedCoef",
                    "getArray",
                    "getArtilleryAmmo",
                    "getArtilleryComputerSettings",
                    "getArtilleryETA",
                    "getAssetDLCInfo",
                    "getAssignedCuratorLogic",
                    "getAssignedCuratorUnit",
                    "getAttackTarget",
                    "getAudioOptionVolumes",
                    "getBackpackCargo",
                    "getBleedingRemaining",
                    "getBurningValue",
                    "getCalculatePlayerVisibilityByFriendly",
                    "getCameraViewDirection",
                    "getCargoIndex",
                    "getCenterOfMass",
                    "getClientState",
                    "getClientStateNumber",
                    "getCompatiblePylonMagazines",
                    "getConnectedUAV",
                    "getConnectedUAVUnit",
                    "getContainerMaxLoad",
                    "getCorpse",
                    "getCruiseControl",
                    "getCursorObjectParams",
                    "getCustomAimCoef",
                    "getCustomSoundController",
                    "getCustomSoundControllerCount",
                    "getDammage",
                    "getDebriefingText",
                    "getDescription",
                    "getDir",
                    "getDirVisual",
                    "getDiverState",
                    "getDLCAssetsUsage",
                    "getDLCAssetsUsageByName",
                    "getDLCs",
                    "getDLCUsageTime",
                    "getEditorCamera",
                    "getEditorMode",
                    "getEditorObjectScope",
                    "getElevationOffset",
                    "getEngineTargetRPMRTD",
                    "getEnv3DSoundController",
                    "getEnvSoundController",
                    "getEventHandlerInfo",
                    "getFatigue",
                    "getFieldManualStartPage",
                    "getForcedFlagTexture",
                    "getForcedSpeed",
                    "getFriend",
                    "getFSMVariable",
                    "getFuelCargo",
                    "getGraphValues",
                    "getGroupIcon",
                    "getGroupIconParams",
                    "getGroupIcons",
                    "getHideFrom",
                    "getHit",
                    "getHitIndex",
                    "getHitPointDamage",
                    "getItemCargo",
                    "getLighting",
                    "getLightingAt",
                    "getLoadedModsInfo",
                    "getMagazineCargo",
                    "getMarkerColor",
                    "getMarkerPos",
                    "getMarkerSize",
                    "getMarkerType",
                    "getMass",
                    "getMissionConfig",
                    "getMissionConfigValue",
                    "getMissionDLCs",
                    "getMissionLayerEntities",
                    "getMissionLayers",
                    "getMissionPath",
                    "getModelInfo",
                    "getMousePosition",
                    "getMusicPlayedTime",
                    "getNumber",
                    "getObjectArgument",
                    "getObjectChildren",
                    "getObjectDLC",
                    "getObjectFOV",
                    "getObjectID",
                    "getObjectMaterials",
                    "getObjectProxy",
                    "getObjectScale",
                    "getObjectTextures",
                    "getObjectType",
                    "getObjectViewDistance",
                    "getOpticsMode",
                    "getOrDefault",
                    "getOrDefaultCall",
                    "getOxygenRemaining",
                    "getPersonUsedDLCs",
                    "getPilotCameraDirection",
                    "getPilotCameraPosition",
                    "getPilotCameraRotation",
                    "getPilotCameraTarget",
                    "getPiPViewDistance",
                    "getPlateNumber",
                    "getPlayerChannel",
                    "getPlayerID",
                    "getPlayerScores",
                    "getPlayerUID",
                    "getPlayerVoNVolume",
                    "getPos",
                    "getPosASL",
                    "getPosASLVisual",
                    "getPosASLW",
                    "getPosATL",
                    "getPosATLVisual",
                    "getPosVisual",
                    "getPosWorld",
                    "getPosWorldVisual",
                    "getPylonMagazines",
                    "getRelDir",
                    "getRelPos",
                    "getRemoteSensorsDisabled",
                    "getRepairCargo",
                    "getResolution",
                    "getRoadInfo",
                    "getRotorBrakeRTD",
                    "getSensorTargets",
                    "getSensorThreats",
                    "getShadowDistance",
                    "getShotParents",
                    "getSlingLoad",
                    "getSoundController",
                    "getSoundControllerResult",
                    "getSpeed",
                    "getStamina",
                    "getStatValue",
                    "getSteamFriendsServers",
                    "getSubtitleOptions",
                    "getSuppression",
                    "getTerrainGrid",
                    "getTerrainHeight",
                    "getTerrainHeightASL",
                    "getTerrainInfo",
                    "getText",
                    "getTextRaw",
                    "getTextureInfo",
                    "getTextWidth",
                    "getTiParameters",
                    "getTotalDLCUsageTime",
                    "getTrimOffsetRTD",
                    "getTurretLimits",
                    "getTurretOpticsMode",
                    "getUnitFreefallInfo",
                    "getUnitLoadout",
                    "getUnitTrait",
                    "getUnloadInCombat",
                    "getUserInfo",
                    "getUserMFDText",
                    "getUserMFDValue",
                    "getVariable",
                    "getVehicleCargo",
                    "getVehicleTiPars",
                    "getWeaponCargo",
                    "getWeaponSway",
                    "getWingsOrientationRTD",
                    "getWingsPositionRTD",
                    "getWPPos",
                    "glanceAt",
                    "globalChat",
                    "globalRadio",
                    "goggles",
                    "goto",
                    "group",
                    "groupChat",
                    "groupFromNetId",
                    "groupIconSelectable",
                    "groupIconsVisible",
                    "groupID",
                    "groupOwner",
                    "groupRadio",
                    "groups",
                    "groupSelectedUnits",
                    "groupSelectUnit",
                    "gunner",
                    "gusts",
                    "halt",
                    "handgunItems",
                    "handgunMagazine",
                    "handgunWeapon",
                    "handsHit",
                    "hashValue",
                    "hasInterface",
                    "hasPilotCamera",
                    "hasWeapon",
                    "hcAllGroups",
                    "hcGroupParams",
                    "hcLeader",
                    "hcRemoveAllGroups",
                    "hcRemoveGroup",
                    "hcSelected",
                    "hcSelectGroup",
                    "hcSetGroup",
                    "hcShowBar",
                    "hcShownBar",
                    "headgear",
                    "hideBody",
                    "hideObject",
                    "hideObjectGlobal",
                    "hideSelection",
                    "hint",
                    "hintC",
                    "hintCadet",
                    "hintSilent",
                    "hmd",
                    "hostMission",
                    "htmlLoad",
                    "HUDMovementLevels",
                    "humidity",
                    "image",
                    "importAllGroups",
                    "importance",
                    "in",
                    "inArea",
                    "inAreaArray",
                    "incapacitatedState",
                    "inflame",
                    "inflamed",
                    "infoPanel",
                    "infoPanelComponentEnabled",
                    "infoPanelComponents",
                    "infoPanels",
                    "inGameUISetEventHandler",
                    "inheritsFrom",
                    "initAmbientLife",
                    "inPolygon",
                    "inputAction",
                    "inputController",
                    "inputMouse",
                    "inRangeOfArtillery",
                    "insert",
                    "insertEditorObject",
                    "intersect",
                    "is3DEN",
                    "is3DENMultiplayer",
                    "is3DENPreview",
                    "isAbleToBreathe",
                    "isActionMenuVisible",
                    "isAgent",
                    "isAimPrecisionEnabled",
                    "isAllowedCrewInImmobile",
                    "isArray",
                    "isAutoHoverOn",
                    "isAutonomous",
                    "isAutoStartUpEnabledRTD",
                    "isAutotest",
                    "isAutoTrimOnRTD",
                    "isAwake",
                    "isBleeding",
                    "isBurning",
                    "isClass",
                    "isCollisionLightOn",
                    "isCopilotEnabled",
                    "isDamageAllowed",
                    "isDedicated",
                    "isDLCAvailable",
                    "isEngineOn",
                    "isEqualRef",
                    "isEqualTo",
                    "isEqualType",
                    "isEqualTypeAll",
                    "isEqualTypeAny",
                    "isEqualTypeArray",
                    "isEqualTypeParams",
                    "isFilePatchingEnabled",
                    "isFinal",
                    "isFlashlightOn",
                    "isFlatEmpty",
                    "isForcedWalk",
                    "isFormationLeader",
                    "isGameFocused",
                    "isGamePaused",
                    "isGroupDeletedWhenEmpty",
                    "isHidden",
                    "isInRemainsCollector",
                    "isInstructorFigureEnabled",
                    "isIRLaserOn",
                    "isKeyActive",
                    "isKindOf",
                    "isLaserOn",
                    "isLightOn",
                    "isLocalized",
                    "isManualFire",
                    "isMarkedForCollection",
                    "isMissionProfileNamespaceLoaded",
                    "isMultiplayer",
                    "isMultiplayerSolo",
                    "isNil",
                    "isNotEqualRef",
                    "isNotEqualTo",
                    "isNull",
                    "isNumber",
                    "isObjectHidden",
                    "isObjectRTD",
                    "isOnRoad",
                    "isPiPEnabled",
                    "isPlayer",
                    "isRealTime",
                    "isRemoteExecuted",
                    "isRemoteExecutedJIP",
                    "isSaving",
                    "isSensorTargetConfirmed",
                    "isServer",
                    "isShowing3DIcons",
                    "isSimpleObject",
                    "isSprintAllowed",
                    "isStaminaEnabled",
                    "isSteamMission",
                    "isSteamOverlayEnabled",
                    "isStreamFriendlyUIEnabled",
                    "isStressDamageEnabled",
                    "isText",
                    "isTouchingGround",
                    "isTurnedOut",
                    "isTutHintsEnabled",
                    "isUAVConnectable",
                    "isUAVConnected",
                    "isUIContext",
                    "isUniformAllowed",
                    "isVehicleCargo",
                    "isVehicleRadarOn",
                    "isVehicleSensorEnabled",
                    "isWalking",
                    "isWeaponDeployed",
                    "isWeaponRested",
                    "itemCargo",
                    "items",
                    "itemsWithMagazines",
                    "join",
                    "joinAs",
                    "joinAsSilent",
                    "joinSilent",
                    "joinString",
                    "kbAddDatabase",
                    "kbAddDatabaseTargets",
                    "kbAddTopic",
                    "kbHasTopic",
                    "kbReact",
                    "kbRemoveTopic",
                    "kbTell",
                    "kbWasSaid",
                    "keyImage",
                    "keyName",
                    "keys",
                    "knowsAbout",
                    "land",
                    "landAt",
                    "landResult",
                    "language",
                    "laserTarget",
                    "lbAdd",
                    "lbClear",
                    "lbColor",
                    "lbColorRight",
                    "lbCurSel",
                    "lbData",
                    "lbDelete",
                    "lbIsSelected",
                    "lbPicture",
                    "lbPictureRight",
                    "lbSelection",
                    "lbSetColor",
                    "lbSetColorRight",
                    "lbSetCurSel",
                    "lbSetData",
                    "lbSetPicture",
                    "lbSetPictureColor",
                    "lbSetPictureColorDisabled",
                    "lbSetPictureColorSelected",
                    "lbSetPictureRight",
                    "lbSetPictureRightColor",
                    "lbSetPictureRightColorDisabled",
                    "lbSetPictureRightColorSelected",
                    "lbSetSelectColor",
                    "lbSetSelectColorRight",
                    "lbSetSelected",
                    "lbSetText",
                    "lbSetTextRight",
                    "lbSetTooltip",
                    "lbSetValue",
                    "lbSize",
                    "lbSort",
                    "lbSortBy",
                    "lbSortByValue",
                    "lbText",
                    "lbTextRight",
                    "lbTooltip",
                    "lbValue",
                    "leader",
                    "leaderboardDeInit",
                    "leaderboardGetRows",
                    "leaderboardInit",
                    "leaderboardRequestRowsFriends",
                    "leaderboardRequestRowsGlobal",
                    "leaderboardRequestRowsGlobalAroundUser",
                    "leaderboardsRequestUploadScore",
                    "leaderboardsRequestUploadScoreKeepBest",
                    "leaderboardState",
                    "leaveVehicle",
                    "libraryCredits",
                    "libraryDisclaimers",
                    "lifeState",
                    "lightAttachObject",
                    "lightDetachObject",
                    "lightIsOn",
                    "lightnings",
                    "limitSpeed",
                    "linearConversion",
                    "lineIntersects",
                    "lineIntersectsObjs",
                    "lineIntersectsSurfaces",
                    "lineIntersectsWith",
                    "linkItem",
                    "list",
                    "listObjects",
                    "listRemoteTargets",
                    "listVehicleSensors",
                    "ln",
                    "lnbAddArray",
                    "lnbAddColumn",
                    "lnbAddRow",
                    "lnbClear",
                    "lnbColor",
                    "lnbColorRight",
                    "lnbCurSelRow",
                    "lnbData",
                    "lnbDeleteColumn",
                    "lnbDeleteRow",
                    "lnbGetColumnsPosition",
                    "lnbPicture",
                    "lnbPictureRight",
                    "lnbSetColor",
                    "lnbSetColorRight",
                    "lnbSetColumnsPos",
                    "lnbSetCurSelRow",
                    "lnbSetData",
                    "lnbSetPicture",
                    "lnbSetPictureColor",
                    "lnbSetPictureColorRight",
                    "lnbSetPictureColorSelected",
                    "lnbSetPictureColorSelectedRight",
                    "lnbSetPictureRight",
                    "lnbSetText",
                    "lnbSetTextRight",
                    "lnbSetTooltip",
                    "lnbSetValue",
                    "lnbSize",
                    "lnbSort",
                    "lnbSortBy",
                    "lnbSortByValue",
                    "lnbText",
                    "lnbTextRight",
                    "lnbValue",
                    "load",
                    "loadAbs",
                    "loadBackpack",
                    "loadConfig",
                    "loadFile",
                    "loadGame",
                    "loadIdentity",
                    "loadMagazine",
                    "loadOverlay",
                    "loadStatus",
                    "loadUniform",
                    "loadVest",
                    "localize",
                    "localNamespace",
                    "locationPosition",
                    "lock",
                    "lockCameraTo",
                    "lockCargo",
                    "lockDriver",
                    "locked",
                    "lockedCameraTo",
                    "lockedCargo",
                    "lockedDriver",
                    "lockedInventory",
                    "lockedTurret",
                    "lockIdentity",
                    "lockInventory",
                    "lockTurret",
                    "lockWp",
                    "log",
                    "logEntities",
                    "logNetwork",
                    "logNetworkTerminate",
                    "lookAt",
                    "lookAtPos",
                    "magazineCargo",
                    "magazines",
                    "magazinesAllTurrets",
                    "magazinesAmmo",
                    "magazinesAmmoCargo",
                    "magazinesAmmoFull",
                    "magazinesDetail",
                    "magazinesDetailBackpack",
                    "magazinesDetailUniform",
                    "magazinesDetailVest",
                    "magazinesTurret",
                    "magazineTurretAmmo",
                    "mapAnimAdd",
                    "mapAnimClear",
                    "mapAnimCommit",
                    "mapAnimDone",
                    "mapCenterOnCamera",
                    "mapGridPosition",
                    "markAsFinishedOnSteam",
                    "markerAlpha",
                    "markerBrush",
                    "markerChannel",
                    "markerColor",
                    "markerDir",
                    "markerPolyline",
                    "markerPos",
                    "markerShadow",
                    "markerShape",
                    "markerSize",
                    "markerText",
                    "markerType",
                    "matrixMultiply",
                    "matrixTranspose",
                    "max",
                    "maxLoad",
                    "members",
                    "menuAction",
                    "menuAdd",
                    "menuChecked",
                    "menuClear",
                    "menuCollapse",
                    "menuData",
                    "menuDelete",
                    "menuEnable",
                    "menuEnabled",
                    "menuExpand",
                    "menuHover",
                    "menuPicture",
                    "menuSetAction",
                    "menuSetCheck",
                    "menuSetData",
                    "menuSetPicture",
                    "menuSetShortcut",
                    "menuSetText",
                    "menuSetURL",
                    "menuSetValue",
                    "menuShortcut",
                    "menuShortcutText",
                    "menuSize",
                    "menuSort",
                    "menuText",
                    "menuURL",
                    "menuValue",
                    "merge",
                    "min",
                    "mineActive",
                    "mineDetectedBy",
                    "missileTarget",
                    "missileTargetPos",
                    "missionConfigFile",
                    "missionDifficulty",
                    "missionEnd",
                    "missionName",
                    "missionNameSource",
                    "missionNamespace",
                    "missionProfileNamespace",
                    "missionStart",
                    "missionVersion",
                    "mod",
                    "modelToWorld",
                    "modelToWorldVisual",
                    "modelToWorldVisualWorld",
                    "modelToWorldWorld",
                    "modParams",
                    "moonIntensity",
                    "moonPhase",
                    "morale",
                    "move",
                    "move3DENCamera",
                    "moveInAny",
                    "moveInCargo",
                    "moveInCommander",
                    "moveInDriver",
                    "moveInGunner",
                    "moveInTurret",
                    "moveObjectToEnd",
                    "moveOut",
                    "moveTime",
                    "moveTo",
                    "moveToCompleted",
                    "moveToFailed",
                    "musicVolume",
                    "name",
                    "namedProperties",
                    "nameSound",
                    "nearEntities",
                    "nearestBuilding",
                    "nearestLocation",
                    "nearestLocations",
                    "nearestLocationWithDubbing",
                    "nearestMines",
                    "nearestObject",
                    "nearestObjects",
                    "nearestTerrainObjects",
                    "nearObjects",
                    "nearObjectsReady",
                    "nearRoads",
                    "nearSupplies",
                    "nearTargets",
                    "needReload",
                    "needService",
                    "netId",
                    "netObjNull",
                    "newOverlay",
                    "nextMenuItemIndex",
                    "nextWeatherChange",
                    "nMenuItems",
                    "not",
                    "numberOfEnginesRTD",
                    "numberToDate",
                    "objectCurators",
                    "objectFromNetId",
                    "objectParent",
                    "objStatus",
                    "onBriefingGroup",
                    "onBriefingNotes",
                    "onBriefingPlan",
                    "onBriefingTeamSwitch",
                    "onCommandModeChanged",
                    "onDoubleClick",
                    "onEachFrame",
                    "onGroupIconClick",
                    "onGroupIconOverEnter",
                    "onGroupIconOverLeave",
                    "onHCGroupSelectionChanged",
                    "onMapSingleClick",
                    "onPlayerConnected",
                    "onPlayerDisconnected",
                    "onPreloadFinished",
                    "onPreloadStarted",
                    "onShowNewObject",
                    "onTeamSwitch",
                    "openCuratorInterface",
                    "openDLCPage",
                    "openGPS",
                    "openMap",
                    "openSteamApp",
                    "openYoutubeVideo",
                    "or",
                    "orderGetIn",
                    "overcast",
                    "overcastForecast",
                    "owner",
                    "param",
                    "params",
                    "parseNumber",
                    "parseSimpleArray",
                    "parseText",
                    "parsingNamespace",
                    "particlesQuality",
                    "periscopeElevation",
                    "pickWeaponPool",
                    "pitch",
                    "pixelGrid",
                    "pixelGridBase",
                    "pixelGridNoUIScale",
                    "pixelH",
                    "pixelW",
                    "playableSlotsNumber",
                    "playableUnits",
                    "playAction",
                    "playActionNow",
                    "player",
                    "playerRespawnTime",
                    "playerSide",
                    "playersNumber",
                    "playGesture",
                    "playMission",
                    "playMove",
                    "playMoveNow",
                    "playMusic",
                    "playScriptedMission",
                    "playSound",
                    "playSound3D",
                    "playSoundUI",
                    "pose",
                    "position",
                    "positionCameraToWorld",
                    "posScreenToWorld",
                    "posWorldToScreen",
                    "ppEffectAdjust",
                    "ppEffectCommit",
                    "ppEffectCommitted",
                    "ppEffectCreate",
                    "ppEffectDestroy",
                    "ppEffectEnable",
                    "ppEffectEnabled",
                    "ppEffectForceInNVG",
                    "precision",
                    "preloadCamera",
                    "preloadObject",
                    "preloadSound",
                    "preloadTitleObj",
                    "preloadTitleRsc",
                    "preprocessFile",
                    "preprocessFileLineNumbers",
                    "primaryWeapon",
                    "primaryWeaponItems",
                    "primaryWeaponMagazine",
                    "priority",
                    "processDiaryLink",
                    "productVersion",
                    "profileName",
                    "profileNamespace",
                    "profileNameSteam",
                    "progressLoadingScreen",
                    "progressPosition",
                    "progressSetPosition",
                    "publicVariable",
                    "publicVariableClient",
                    "publicVariableServer",
                    "pushBack",
                    "pushBackUnique",
                    "putWeaponPool",
                    "queryItemsPool",
                    "queryMagazinePool",
                    "queryWeaponPool",
                    "rad",
                    "radioChannelAdd",
                    "radioChannelCreate",
                    "radioChannelInfo",
                    "radioChannelRemove",
                    "radioChannelSetCallSign",
                    "radioChannelSetLabel",
                    "radioEnabled",
                    "radioVolume",
                    "rain",
                    "rainbow",
                    "rainParams",
                    "random",
                    "rank",
                    "rankId",
                    "rating",
                    "rectangular",
                    "regexFind",
                    "regexMatch",
                    "regexReplace",
                    "registeredTasks",
                    "registerTask",
                    "reload",
                    "reloadEnabled",
                    "remoteControl",
                    "remoteExec",
                    "remoteExecCall",
                    "remoteExecutedOwner",
                    "remove3DENConnection",
                    "remove3DENEventHandler",
                    "remove3DENLayer",
                    "removeAction",
                    "removeAll3DENEventHandlers",
                    "removeAllActions",
                    "removeAllAssignedItems",
                    "removeAllBinocularItems",
                    "removeAllContainers",
                    "removeAllCuratorAddons",
                    "removeAllCuratorCameraAreas",
                    "removeAllCuratorEditingAreas",
                    "removeAllEventHandlers",
                    "removeAllHandgunItems",
                    "removeAllItems",
                    "removeAllItemsWithMagazines",
                    "removeAllMissionEventHandlers",
                    "removeAllMPEventHandlers",
                    "removeAllMusicEventHandlers",
                    "removeAllOwnedMines",
                    "removeAllPrimaryWeaponItems",
                    "removeAllSecondaryWeaponItems",
                    "removeAllUserActionEventHandlers",
                    "removeAllWeapons",
                    "removeBackpack",
                    "removeBackpackGlobal",
                    "removeBinocularItem",
                    "removeCuratorAddons",
                    "removeCuratorCameraArea",
                    "removeCuratorEditableObjects",
                    "removeCuratorEditingArea",
                    "removeDiaryRecord",
                    "removeDiarySubject",
                    "removeDrawIcon",
                    "removeDrawLinks",
                    "removeEventHandler",
                    "removeFromRemainsCollector",
                    "removeGoggles",
                    "removeGroupIcon",
                    "removeHandgunItem",
                    "removeHeadgear",
                    "removeItem",
                    "removeItemFromBackpack",
                    "removeItemFromUniform",
                    "removeItemFromVest",
                    "removeItems",
                    "removeMagazine",
                    "removeMagazineGlobal",
                    "removeMagazines",
                    "removeMagazinesTurret",
                    "removeMagazineTurret",
                    "removeMenuItem",
                    "removeMissionEventHandler",
                    "removeMPEventHandler",
                    "removeMusicEventHandler",
                    "removeOwnedMine",
                    "removePrimaryWeaponItem",
                    "removeSecondaryWeaponItem",
                    "removeSimpleTask",
                    "removeSwitchableUnit",
                    "removeTeamMember",
                    "removeUniform",
                    "removeUserActionEventHandler",
                    "removeVest",
                    "removeWeapon",
                    "removeWeaponAttachmentCargo",
                    "removeWeaponCargo",
                    "removeWeaponGlobal",
                    "removeWeaponTurret",
                    "reportRemoteTarget",
                    "requiredVersion",
                    "resetCamShake",
                    "resetSubgroupDirection",
                    "resize",
                    "resources",
                    "respawnVehicle",
                    "restartEditorCamera",
                    "reveal",
                    "revealMine",
                    "reverse",
                    "reversedMouseY",
                    "roadAt",
                    "roadsConnectedTo",
                    "roleDescription",
                    "ropeAttachedObjects",
                    "ropeAttachedTo",
                    "ropeAttachEnabled",
                    "ropeAttachTo",
                    "ropeCreate",
                    "ropeCut",
                    "ropeDestroy",
                    "ropeDetach",
                    "ropeEndPosition",
                    "ropeLength",
                    "ropes",
                    "ropesAttachedTo",
                    "ropeSegments",
                    "ropeUnwind",
                    "ropeUnwound",
                    "rotorsForcesRTD",
                    "rotorsRpmRTD",
                    "round",
                    "runInitScript",
                    "safeZoneH",
                    "safeZoneW",
                    "safeZoneWAbs",
                    "safeZoneX",
                    "safeZoneXAbs",
                    "safeZoneY",
                    "save3DENInventory",
                    "saveGame",
                    "saveIdentity",
                    "saveJoysticks",
                    "saveMissionProfileNamespace",
                    "saveOverlay",
                    "saveProfileNamespace",
                    "saveStatus",
                    "saveVar",
                    "savingEnabled",
                    "say",
                    "say2D",
                    "say3D",
                    "scopeName",
                    "score",
                    "scoreSide",
                    "screenshot",
                    "screenToWorld",
                    "scriptDone",
                    "scriptName",
                    "scudState",
                    "secondaryWeapon",
                    "secondaryWeaponItems",
                    "secondaryWeaponMagazine",
                    "select",
                    "selectBestPlaces",
                    "selectDiarySubject",
                    "selectedEditorObjects",
                    "selectEditorObject",
                    "selectionNames",
                    "selectionPosition",
                    "selectionVectorDirAndUp",
                    "selectLeader",
                    "selectMax",
                    "selectMin",
                    "selectNoPlayer",
                    "selectPlayer",
                    "selectRandom",
                    "selectRandomWeighted",
                    "selectWeapon",
                    "selectWeaponTurret",
                    "sendAUMessage",
                    "sendSimpleCommand",
                    "sendTask",
                    "sendTaskResult",
                    "sendUDPMessage",
                    "sentencesEnabled",
                    "serverCommand",
                    "serverCommandAvailable",
                    "serverCommandExecutable",
                    "serverName",
                    "serverNamespace",
                    "serverTime",
                    "set",
                    "set3DENAttribute",
                    "set3DENAttributes",
                    "set3DENGrid",
                    "set3DENIconsVisible",
                    "set3DENLayer",
                    "set3DENLinesVisible",
                    "set3DENLogicType",
                    "set3DENMissionAttribute",
                    "set3DENMissionAttributes",
                    "set3DENModelsVisible",
                    "set3DENObjectType",
                    "set3DENSelected",
                    "setAccTime",
                    "setActualCollectiveRTD",
                    "setAirplaneThrottle",
                    "setAirportSide",
                    "setAmmo",
                    "setAmmoCargo",
                    "setAmmoOnPylon",
                    "setAnimSpeedCoef",
                    "setAperture",
                    "setApertureNew",
                    "setArmoryPoints",
                    "setAttributes",
                    "setAutonomous",
                    "setBehaviour",
                    "setBehaviourStrong",
                    "setBleedingRemaining",
                    "setBrakesRTD",
                    "setCameraInterest",
                    "setCamShakeDefParams",
                    "setCamShakeParams",
                    "setCamUseTi",
                    "setCaptive",
                    "setCenterOfMass",
                    "setCollisionLight",
                    "setCombatBehaviour",
                    "setCombatMode",
                    "setCompassOscillation",
                    "setConvoySeparation",
                    "setCruiseControl",
                    "setCuratorCameraAreaCeiling",
                    "setCuratorCoef",
                    "setCuratorEditingAreaType",
                    "setCuratorWaypointCost",
                    "setCurrentChannel",
                    "setCurrentTask",
                    "setCurrentWaypoint",
                    "setCustomAimCoef",
                    "SetCustomMissionData",
                    "setCustomSoundController",
                    "setCustomWeightRTD",
                    "setDamage",
                    "setDammage",
                    "setDate",
                    "setDebriefingText",
                    "setDefaultCamera",
                    "setDestination",
                    "setDetailMapBlendPars",
                    "setDiaryRecordText",
                    "setDiarySubjectPicture",
                    "setDir",
                    "setDirection",
                    "setDrawIcon",
                    "setDriveOnPath",
                    "setDropInterval",
                    "setDynamicSimulationDistance",
                    "setDynamicSimulationDistanceCoef",
                    "setEditorMode",
                    "setEditorObjectScope",
                    "setEffectCondition",
                    "setEffectiveCommander",
                    "setEngineRpmRTD",
                    "setFace",
                    "setFaceanimation",
                    "setFatigue",
                    "setFeatureType",
                    "setFlagAnimationPhase",
                    "setFlagOwner",
                    "setFlagSide",
                    "setFlagTexture",
                    "setFog",
                    "setForceGeneratorRTD",
                    "setFormation",
                    "setFormationTask",
                    "setFormDir",
                    "setFriend",
                    "setFromEditor",
                    "setFSMVariable",
                    "setFuel",
                    "setFuelCargo",
                    "setGroupIcon",
                    "setGroupIconParams",
                    "setGroupIconsSelectable",
                    "setGroupIconsVisible",
                    "setGroupid",
                    "setGroupIdGlobal",
                    "setGroupOwner",
                    "setGusts",
                    "setHideBehind",
                    "setHit",
                    "setHitIndex",
                    "setHitPointDamage",
                    "setHorizonParallaxCoef",
                    "setHUDMovementLevels",
                    "setHumidity",
                    "setIdentity",
                    "setImportance",
                    "setInfoPanel",
                    "setLeader",
                    "setLightAmbient",
                    "setLightAttenuation",
                    "setLightBrightness",
                    "setLightColor",
                    "setLightConePars",
                    "setLightDayLight",
                    "setLightFlareMaxDistance",
                    "setLightFlareSize",
                    "setLightIntensity",
                    "setLightIR",
                    "setLightnings",
                    "setLightUseFlare",
                    "setLightVolumeShape",
                    "setLocalWindParams",
                    "setMagazineTurretAmmo",
                    "setMarkerAlpha",
                    "setMarkerAlphaLocal",
                    "setMarkerBrush",
                    "setMarkerBrushLocal",
                    "setMarkerColor",
                    "setMarkerColorLocal",
                    "setMarkerDir",
                    "setMarkerDirLocal",
                    "setMarkerPolyline",
                    "setMarkerPolylineLocal",
                    "setMarkerPos",
                    "setMarkerPosLocal",
                    "setMarkerShadow",
                    "setMarkerShadowLocal",
                    "setMarkerShape",
                    "setMarkerShapeLocal",
                    "setMarkerSize",
                    "setMarkerSizeLocal",
                    "setMarkerText",
                    "setMarkerTextLocal",
                    "setMarkerType",
                    "setMarkerTypeLocal",
                    "setMass",
                    "setMaxLoad",
                    "setMimic",
                    "setMissileTarget",
                    "setMissileTargetPos",
                    "setMousePosition",
                    "setMusicEffect",
                    "setMusicEventHandler",
                    "setName",
                    "setNameSound",
                    "setObjectArguments",
                    "setObjectMaterial",
                    "setObjectMaterialGlobal",
                    "setObjectProxy",
                    "setObjectScale",
                    "setObjectTexture",
                    "setObjectTextureGlobal",
                    "setObjectViewDistance",
                    "setOpticsMode",
                    "setOvercast",
                    "setOwner",
                    "setOxygenRemaining",
                    "setParticleCircle",
                    "setParticleClass",
                    "setParticleFire",
                    "setParticleParams",
                    "setParticleRandom",
                    "setPilotCameraDirection",
                    "setPilotCameraRotation",
                    "setPilotCameraTarget",
                    "setPilotLight",
                    "setPiPEffect",
                    "setPiPViewDistance",
                    "setPitch",
                    "setPlateNumber",
                    "setPlayable",
                    "setPlayerRespawnTime",
                    "setPlayerVoNVolume",
                    "setPos",
                    "setPosASL",
                    "setPosASL2",
                    "setPosASLW",
                    "setPosATL",
                    "setPosition",
                    "setPosWorld",
                    "setPylonLoadout",
                    "setPylonsPriority",
                    "setRadioMsg",
                    "setRain",
                    "setRainbow",
                    "setRandomLip",
                    "setRank",
                    "setRectangular",
                    "setRepairCargo",
                    "setRotorBrakeRTD",
                    "setShadowDistance",
                    "setShotParents",
                    "setSide",
                    "setSimpleTaskAlwaysVisible",
                    "setSimpleTaskCustomData",
                    "setSimpleTaskDescription",
                    "setSimpleTaskDestination",
                    "setSimpleTaskTarget",
                    "setSimpleTaskType",
                    "setSimulWeatherLayers",
                    "setSize",
                    "setSkill",
                    "setSlingLoad",
                    "setSoundEffect",
                    "setSpeaker",
                    "setSpeech",
                    "setSpeedMode",
                    "setStamina",
                    "setStaminaScheme",
                    "setStatValue",
                    "setSuppression",
                    "setSystemOfUnits",
                    "setTargetAge",
                    "setTaskMarkerOffset",
                    "setTaskResult",
                    "setTaskState",
                    "setTerrainGrid",
                    "setTerrainHeight",
                    "setText",
                    "setTimeMultiplier",
                    "setTiParameter",
                    "setTitleEffect",
                    "setTowParent",
                    "setTrafficDensity",
                    "setTrafficDistance",
                    "setTrafficGap",
                    "setTrafficSpeed",
                    "setTriggerActivation",
                    "setTriggerArea",
                    "setTriggerInterval",
                    "setTriggerStatements",
                    "setTriggerText",
                    "setTriggerTimeout",
                    "setTriggerType",
                    "setTurretLimits",
                    "setTurretOpticsMode",
                    "setType",
                    "setUnconscious",
                    "setUnitAbility",
                    "setUnitCombatMode",
                    "setUnitFreefallHeight",
                    "setUnitLoadout",
                    "setUnitPos",
                    "setUnitPosWeak",
                    "setUnitRank",
                    "setUnitRecoilCoefficient",
                    "setUnitTrait",
                    "setUnloadInCombat",
                    "setUserActionText",
                    "setUserMFDText",
                    "setUserMFDValue",
                    "setVariable",
                    "setVectorDir",
                    "setVectorDirAndUp",
                    "setVectorUp",
                    "setVehicleAmmo",
                    "setVehicleAmmoDef",
                    "setVehicleArmor",
                    "setVehicleCargo",
                    "setVehicleId",
                    "setVehicleLock",
                    "setVehiclePosition",
                    "setVehicleRadar",
                    "setVehicleReceiveRemoteTargets",
                    "setVehicleReportOwnPosition",
                    "setVehicleReportRemoteTargets",
                    "setVehicleTiPars",
                    "setVehicleVarName",
                    "setVelocity",
                    "setVelocityModelSpace",
                    "setVelocityTransformation",
                    "setViewDistance",
                    "setVisibleIfTreeCollapsed",
                    "setWantedRPMRTD",
                    "setWaves",
                    "setWaypointBehaviour",
                    "setWaypointCombatMode",
                    "setWaypointCompletionRadius",
                    "setWaypointDescription",
                    "setWaypointForceBehaviour",
                    "setWaypointFormation",
                    "setWaypointHousePosition",
                    "setWaypointLoiterAltitude",
                    "setWaypointLoiterRadius",
                    "setWaypointLoiterType",
                    "setWaypointName",
                    "setWaypointPosition",
                    "setWaypointScript",
                    "setWaypointSpeed",
                    "setWaypointStatements",
                    "setWaypointTimeout",
                    "setWaypointType",
                    "setWaypointVisible",
                    "setWeaponReloadingTime",
                    "setWeaponZeroing",
                    "setWind",
                    "setWindDir",
                    "setWindForce",
                    "setWindStr",
                    "setWingForceScaleRTD",
                    "setWPPos",
                    "show3DIcons",
                    "showChat",
                    "showCinemaBorder",
                    "showCommandingMenu",
                    "showCompass",
                    "showCuratorCompass",
                    "showGps",
                    "showHUD",
                    "showLegend",
                    "showMap",
                    "shownArtilleryComputer",
                    "shownChat",
                    "shownCompass",
                    "shownCuratorCompass",
                    "showNewEditorObject",
                    "shownGps",
                    "shownHUD",
                    "shownMap",
                    "shownPad",
                    "shownRadio",
                    "shownScoretable",
                    "shownSubtitles",
                    "shownUAVFeed",
                    "shownWarrant",
                    "shownWatch",
                    "showPad",
                    "showRadio",
                    "showScoretable",
                    "showSubtitles",
                    "showUAVFeed",
                    "showWarrant",
                    "showWatch",
                    "showWaypoint",
                    "showWaypoints",
                    "side",
                    "sideChat",
                    "sideRadio",
                    "simpleTasks",
                    "simulationEnabled",
                    "simulCloudDensity",
                    "simulCloudOcclusion",
                    "simulInClouds",
                    "simulWeatherSync",
                    "sin",
                    "size",
                    "sizeOf",
                    "skill",
                    "skillFinal",
                    "skipTime",
                    "sleep",
                    "sliderPosition",
                    "sliderRange",
                    "sliderSetPosition",
                    "sliderSetRange",
                    "sliderSetSpeed",
                    "sliderSpeed",
                    "slingLoadAssistantShown",
                    "soldierMagazines",
                    "someAmmo",
                    "sort",
                    "soundVolume",
                    "spawn",
                    "speaker",
                    "speechVolume",
                    "speed",
                    "speedMode",
                    "splitString",
                    "sqrt",
                    "squadParams",
                    "stance",
                    "startLoadingScreen",
                    "stop",
                    "stopEngineRTD",
                    "stopped",
                    "str",
                    "sunOrMoon",
                    "supportInfo",
                    "suppressFor",
                    "surfaceIsWater",
                    "surfaceNormal",
                    "surfaceTexture",
                    "surfaceType",
                    "swimInDepth",
                    "switchableUnits",
                    "switchAction",
                    "switchCamera",
                    "switchGesture",
                    "switchLight",
                    "switchMove",
                    "synchronizedObjects",
                    "synchronizedTriggers",
                    "synchronizedWaypoints",
                    "synchronizeObjectsAdd",
                    "synchronizeObjectsRemove",
                    "synchronizeTrigger",
                    "synchronizeWaypoint",
                    "systemChat",
                    "systemOfUnits",
                    "systemTime",
                    "systemTimeUTC",
                    "tan",
                    "targetKnowledge",
                    "targets",
                    "targetsAggregate",
                    "targetsQuery",
                    "taskAlwaysVisible",
                    "taskChildren",
                    "taskCompleted",
                    "taskCustomData",
                    "taskDescription",
                    "taskDestination",
                    "taskHint",
                    "taskMarkerOffset",
                    "taskName",
                    "taskParent",
                    "taskResult",
                    "taskState",
                    "taskType",
                    "teamMember",
                    "teamName",
                    "teams",
                    "teamSwitch",
                    "teamSwitchEnabled",
                    "teamType",
                    "terminate",
                    "terrainIntersect",
                    "terrainIntersectASL",
                    "terrainIntersectAtASL",
                    "text",
                    "textLog",
                    "textLogFormat",
                    "tg",
                    "time",
                    "timeMultiplier",
                    "titleCut",
                    "titleFadeOut",
                    "titleObj",
                    "titleRsc",
                    "titleText",
                    "toArray",
                    "toFixed",
                    "toLower",
                    "toLowerANSI",
                    "toString",
                    "toUpper",
                    "toUpperANSI",
                    "triggerActivated",
                    "triggerActivation",
                    "triggerAmmo",
                    "triggerArea",
                    "triggerAttachedVehicle",
                    "triggerAttachObject",
                    "triggerAttachVehicle",
                    "triggerDynamicSimulation",
                    "triggerInterval",
                    "triggerStatements",
                    "triggerText",
                    "triggerTimeout",
                    "triggerTimeoutCurrent",
                    "triggerType",
                    "trim",
                    "turretLocal",
                    "turretOwner",
                    "turretUnit",
                    "tvAdd",
                    "tvClear",
                    "tvCollapse",
                    "tvCollapseAll",
                    "tvCount",
                    "tvCurSel",
                    "tvData",
                    "tvDelete",
                    "tvExpand",
                    "tvExpandAll",
                    "tvIsSelected",
                    "tvPicture",
                    "tvPictureRight",
                    "tvSelection",
                    "tvSetColor",
                    "tvSetCurSel",
                    "tvSetData",
                    "tvSetPicture",
                    "tvSetPictureColor",
                    "tvSetPictureColorDisabled",
                    "tvSetPictureColorSelected",
                    "tvSetPictureRight",
                    "tvSetPictureRightColor",
                    "tvSetPictureRightColorDisabled",
                    "tvSetPictureRightColorSelected",
                    "tvSetSelectColor",
                    "tvSetSelected",
                    "tvSetText",
                    "tvSetTooltip",
                    "tvSetValue",
                    "tvSort",
                    "tvSortAll",
                    "tvSortByValue",
                    "tvSortByValueAll",
                    "tvText",
                    "tvTooltip",
                    "tvValue",
                    "type",
                    "typeName",
                    "typeOf",
                    "UAVControl",
                    "uiNamespace",
                    "uiSleep",
                    "unassignCurator",
                    "unassignItem",
                    "unassignTeam",
                    "unassignVehicle",
                    "underwater",
                    "uniform",
                    "uniformContainer",
                    "uniformItems",
                    "uniformMagazines",
                    "uniqueUnitItems",
                    "unitAddons",
                    "unitAimPosition",
                    "unitAimPositionVisual",
                    "unitBackpack",
                    "unitCombatMode",
                    "unitIsUAV",
                    "unitPos",
                    "unitReady",
                    "unitRecoilCoefficient",
                    "units",
                    "unitsBelowHeight",
                    "unitTurret",
                    "unlinkItem",
                    "unlockAchievement",
                    "unregisterTask",
                    "updateDrawIcon",
                    "updateMenuItem",
                    "updateObjectTree",
                    "useAIOperMapObstructionTest",
                    "useAISteeringComponent",
                    "useAudioTimeForMoves",
                    "userInputDisabled",
                    "values",
                    "vectorAdd",
                    "vectorCos",
                    "vectorCrossProduct",
                    "vectorDiff",
                    "vectorDir",
                    "vectorDirVisual",
                    "vectorDistance",
                    "vectorDistanceSqr",
                    "vectorDotProduct",
                    "vectorFromTo",
                    "vectorLinearConversion",
                    "vectorMagnitude",
                    "vectorMagnitudeSqr",
                    "vectorModelToWorld",
                    "vectorModelToWorldVisual",
                    "vectorMultiply",
                    "vectorNormalized",
                    "vectorUp",
                    "vectorUpVisual",
                    "vectorWorldToModel",
                    "vectorWorldToModelVisual",
                    "vehicle",
                    "vehicleCargoEnabled",
                    "vehicleChat",
                    "vehicleMoveInfo",
                    "vehicleRadio",
                    "vehicleReceiveRemoteTargets",
                    "vehicleReportOwnPosition",
                    "vehicleReportRemoteTargets",
                    "vehicles",
                    "vehicleVarName",
                    "velocity",
                    "velocityModelSpace",
                    "verifySignature",
                    "vest",
                    "vestContainer",
                    "vestItems",
                    "vestMagazines",
                    "viewDistance",
                    "visibleCompass",
                    "visibleGps",
                    "visibleMap",
                    "visiblePosition",
                    "visiblePositionASL",
                    "visibleScoretable",
                    "visibleWatch",
                    "waves",
                    "waypointAttachedObject",
                    "waypointAttachedVehicle",
                    "waypointAttachObject",
                    "waypointAttachVehicle",
                    "waypointBehaviour",
                    "waypointCombatMode",
                    "waypointCompletionRadius",
                    "waypointDescription",
                    "waypointForceBehaviour",
                    "waypointFormation",
                    "waypointHousePosition",
                    "waypointLoiterAltitude",
                    "waypointLoiterRadius",
                    "waypointLoiterType",
                    "waypointName",
                    "waypointPosition",
                    "waypoints",
                    "waypointScript",
                    "waypointsEnabledUAV",
                    "waypointShow",
                    "waypointSpeed",
                    "waypointStatements",
                    "waypointTimeout",
                    "waypointTimeoutCurrent",
                    "waypointType",
                    "waypointVisible",
                    "weaponAccessories",
                    "weaponAccessoriesCargo",
                    "weaponCargo",
                    "weaponDirection",
                    "weaponInertia",
                    "weaponLowered",
                    "weaponReloadingTime",
                    "weapons",
                    "weaponsInfo",
                    "weaponsItems",
                    "weaponsItemsCargo",
                    "weaponState",
                    "weaponsTurret",
                    "weightRTD",
                    "WFSideText",
                    "wind",
                    "windDir",
                    "windRTD",
                    "windStr",
                    "wingsForcesRTD",
                    "worldName",
                    "worldSize",
                    "worldToModel",
                    "worldToModelVisual",
                    "worldToScreen"
                ],
                literal: [
                    "blufor",
                    "civilian",
                    "configNull",
                    "controlNull",
                    "displayNull",
                    "diaryRecordNull",
                    "east",
                    "endl",
                    "false",
                    "grpNull",
                    "independent",
                    "lineBreak",
                    "locationNull",
                    "nil",
                    "objNull",
                    "opfor",
                    "pi",
                    "resistance",
                    "scriptNull",
                    "sideAmbientLife",
                    "sideEmpty",
                    "sideEnemy",
                    "sideFriendly",
                    "sideLogic",
                    "sideUnknown",
                    "taskNull",
                    "teamMemberNull",
                    "true",
                    "west"
                ]
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.NUMBER_MODE,
                {
                    className: "variable",
                    begin: /\b_+[a-zA-Z]\w*/
                },
                {
                    className: "title",
                    begin: /[a-zA-Z][a-zA-Z_0-9]*_fnc_[a-zA-Z_0-9]+/
                },
                t,
                a
            ],
            illegal: [
                /\$[^a-fA-F0-9]/,
                /\w\$/,
                /\?/,
                /@/,
                / \| /,
                /[a-zA-Z_]\./,
                /\:\=/,
                /\[\:/
            ]
        };
    }), go)), Cs.registerLanguage("sql", (bo || (bo = 1, So = function(e) {
        const t = e.regex, a = e.COMMENT("--", "$"), n = [
            "true",
            "false",
            "unknown"
        ], i = [
            "bigint",
            "binary",
            "blob",
            "boolean",
            "char",
            "character",
            "clob",
            "date",
            "dec",
            "decfloat",
            "decimal",
            "float",
            "int",
            "integer",
            "interval",
            "nchar",
            "nclob",
            "national",
            "numeric",
            "real",
            "row",
            "smallint",
            "time",
            "timestamp",
            "varchar",
            "varying",
            "varbinary"
        ], r = [
            "abs",
            "acos",
            "array_agg",
            "asin",
            "atan",
            "avg",
            "cast",
            "ceil",
            "ceiling",
            "coalesce",
            "corr",
            "cos",
            "cosh",
            "count",
            "covar_pop",
            "covar_samp",
            "cume_dist",
            "dense_rank",
            "deref",
            "element",
            "exp",
            "extract",
            "first_value",
            "floor",
            "json_array",
            "json_arrayagg",
            "json_exists",
            "json_object",
            "json_objectagg",
            "json_query",
            "json_table",
            "json_table_primitive",
            "json_value",
            "lag",
            "last_value",
            "lead",
            "listagg",
            "ln",
            "log",
            "log10",
            "lower",
            "max",
            "min",
            "mod",
            "nth_value",
            "ntile",
            "nullif",
            "percent_rank",
            "percentile_cont",
            "percentile_disc",
            "position",
            "position_regex",
            "power",
            "rank",
            "regr_avgx",
            "regr_avgy",
            "regr_count",
            "regr_intercept",
            "regr_r2",
            "regr_slope",
            "regr_sxx",
            "regr_sxy",
            "regr_syy",
            "row_number",
            "sin",
            "sinh",
            "sqrt",
            "stddev_pop",
            "stddev_samp",
            "substring",
            "substring_regex",
            "sum",
            "tan",
            "tanh",
            "translate",
            "translate_regex",
            "treat",
            "trim",
            "trim_array",
            "unnest",
            "upper",
            "value_of",
            "var_pop",
            "var_samp",
            "width_bucket"
        ], o = [
            "create table",
            "insert into",
            "primary key",
            "foreign key",
            "not null",
            "alter table",
            "add constraint",
            "grouping sets",
            "on overflow",
            "character set",
            "respect nulls",
            "ignore nulls",
            "nulls first",
            "nulls last",
            "depth first",
            "breadth first"
        ], s = r, l = [
            "abs",
            "acos",
            "all",
            "allocate",
            "alter",
            "and",
            "any",
            "are",
            "array",
            "array_agg",
            "array_max_cardinality",
            "as",
            "asensitive",
            "asin",
            "asymmetric",
            "at",
            "atan",
            "atomic",
            "authorization",
            "avg",
            "begin",
            "begin_frame",
            "begin_partition",
            "between",
            "bigint",
            "binary",
            "blob",
            "boolean",
            "both",
            "by",
            "call",
            "called",
            "cardinality",
            "cascaded",
            "case",
            "cast",
            "ceil",
            "ceiling",
            "char",
            "char_length",
            "character",
            "character_length",
            "check",
            "classifier",
            "clob",
            "close",
            "coalesce",
            "collate",
            "collect",
            "column",
            "commit",
            "condition",
            "connect",
            "constraint",
            "contains",
            "convert",
            "copy",
            "corr",
            "corresponding",
            "cos",
            "cosh",
            "count",
            "covar_pop",
            "covar_samp",
            "create",
            "cross",
            "cube",
            "cume_dist",
            "current",
            "current_catalog",
            "current_date",
            "current_default_transform_group",
            "current_path",
            "current_role",
            "current_row",
            "current_schema",
            "current_time",
            "current_timestamp",
            "current_path",
            "current_role",
            "current_transform_group_for_type",
            "current_user",
            "cursor",
            "cycle",
            "date",
            "day",
            "deallocate",
            "dec",
            "decimal",
            "decfloat",
            "declare",
            "default",
            "define",
            "delete",
            "dense_rank",
            "deref",
            "describe",
            "deterministic",
            "disconnect",
            "distinct",
            "double",
            "drop",
            "dynamic",
            "each",
            "element",
            "else",
            "empty",
            "end",
            "end_frame",
            "end_partition",
            "end-exec",
            "equals",
            "escape",
            "every",
            "except",
            "exec",
            "execute",
            "exists",
            "exp",
            "external",
            "extract",
            "false",
            "fetch",
            "filter",
            "first_value",
            "float",
            "floor",
            "for",
            "foreign",
            "frame_row",
            "free",
            "from",
            "full",
            "function",
            "fusion",
            "get",
            "global",
            "grant",
            "group",
            "grouping",
            "groups",
            "having",
            "hold",
            "hour",
            "identity",
            "in",
            "indicator",
            "initial",
            "inner",
            "inout",
            "insensitive",
            "insert",
            "int",
            "integer",
            "intersect",
            "intersection",
            "interval",
            "into",
            "is",
            "join",
            "json_array",
            "json_arrayagg",
            "json_exists",
            "json_object",
            "json_objectagg",
            "json_query",
            "json_table",
            "json_table_primitive",
            "json_value",
            "lag",
            "language",
            "large",
            "last_value",
            "lateral",
            "lead",
            "leading",
            "left",
            "like",
            "like_regex",
            "listagg",
            "ln",
            "local",
            "localtime",
            "localtimestamp",
            "log",
            "log10",
            "lower",
            "match",
            "match_number",
            "match_recognize",
            "matches",
            "max",
            "member",
            "merge",
            "method",
            "min",
            "minute",
            "mod",
            "modifies",
            "module",
            "month",
            "multiset",
            "national",
            "natural",
            "nchar",
            "nclob",
            "new",
            "no",
            "none",
            "normalize",
            "not",
            "nth_value",
            "ntile",
            "null",
            "nullif",
            "numeric",
            "octet_length",
            "occurrences_regex",
            "of",
            "offset",
            "old",
            "omit",
            "on",
            "one",
            "only",
            "open",
            "or",
            "order",
            "out",
            "outer",
            "over",
            "overlaps",
            "overlay",
            "parameter",
            "partition",
            "pattern",
            "per",
            "percent",
            "percent_rank",
            "percentile_cont",
            "percentile_disc",
            "period",
            "portion",
            "position",
            "position_regex",
            "power",
            "precedes",
            "precision",
            "prepare",
            "primary",
            "procedure",
            "ptf",
            "range",
            "rank",
            "reads",
            "real",
            "recursive",
            "ref",
            "references",
            "referencing",
            "regr_avgx",
            "regr_avgy",
            "regr_count",
            "regr_intercept",
            "regr_r2",
            "regr_slope",
            "regr_sxx",
            "regr_sxy",
            "regr_syy",
            "release",
            "result",
            "return",
            "returns",
            "revoke",
            "right",
            "rollback",
            "rollup",
            "row",
            "row_number",
            "rows",
            "running",
            "savepoint",
            "scope",
            "scroll",
            "search",
            "second",
            "seek",
            "select",
            "sensitive",
            "session_user",
            "set",
            "show",
            "similar",
            "sin",
            "sinh",
            "skip",
            "smallint",
            "some",
            "specific",
            "specifictype",
            "sql",
            "sqlexception",
            "sqlstate",
            "sqlwarning",
            "sqrt",
            "start",
            "static",
            "stddev_pop",
            "stddev_samp",
            "submultiset",
            "subset",
            "substring",
            "substring_regex",
            "succeeds",
            "sum",
            "symmetric",
            "system",
            "system_time",
            "system_user",
            "table",
            "tablesample",
            "tan",
            "tanh",
            "then",
            "time",
            "timestamp",
            "timezone_hour",
            "timezone_minute",
            "to",
            "trailing",
            "translate",
            "translate_regex",
            "translation",
            "treat",
            "trigger",
            "trim",
            "trim_array",
            "true",
            "truncate",
            "uescape",
            "union",
            "unique",
            "unknown",
            "unnest",
            "update",
            "upper",
            "user",
            "using",
            "value",
            "values",
            "value_of",
            "var_pop",
            "var_samp",
            "varbinary",
            "varchar",
            "varying",
            "versioning",
            "when",
            "whenever",
            "where",
            "width_bucket",
            "window",
            "with",
            "within",
            "without",
            "year",
            "add",
            "asc",
            "collation",
            "desc",
            "final",
            "first",
            "last",
            "view"
        ].filter((e)=>!r.includes(e)), c = {
            begin: t.concat(/\b/, t.either(...s), /\s*\(/),
            relevance: 0,
            keywords: {
                built_in: s
            }
        };
        return {
            name: "SQL",
            case_insensitive: !0,
            illegal: /[{}]|<\//,
            keywords: {
                $pattern: /\b[\w\.]+/,
                keyword: function(e, { exceptions: t, when: a } = {}) {
                    const n = a;
                    return t = t || [], e.map((e)=>e.match(/\|\d+$/) || t.includes(e) ? e : n(e) ? `${e}|0` : e);
                }(l, {
                    when: (e)=>e.length < 3
                }),
                literal: n,
                type: i,
                built_in: [
                    "current_catalog",
                    "current_date",
                    "current_default_transform_group",
                    "current_path",
                    "current_role",
                    "current_schema",
                    "current_transform_group_for_type",
                    "current_user",
                    "session_user",
                    "system_time",
                    "system_user",
                    "current_time",
                    "localtime",
                    "current_timestamp",
                    "localtimestamp"
                ]
            },
            contains: [
                {
                    begin: t.either(...o),
                    relevance: 0,
                    keywords: {
                        $pattern: /[\w\.]+/,
                        keyword: l.concat(o),
                        literal: n,
                        type: i
                    }
                },
                {
                    className: "type",
                    begin: t.either("double precision", "large object", "with timezone", "without timezone")
                },
                c,
                {
                    className: "variable",
                    begin: /@[a-z0-9][a-z0-9_]*/
                },
                {
                    className: "string",
                    variants: [
                        {
                            begin: /'/,
                            end: /'/,
                            contains: [
                                {
                                    begin: /''/
                                }
                            ]
                        }
                    ]
                },
                {
                    begin: /"/,
                    end: /"/,
                    contains: [
                        {
                            begin: /""/
                        }
                    ]
                },
                e.C_NUMBER_MODE,
                e.C_BLOCK_COMMENT_MODE,
                a,
                {
                    className: "operator",
                    begin: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
                    relevance: 0
                }
            ]
        };
    }), So)), Cs.registerLanguage("stan", (Co || (Co = 1, To = function(e) {
        const t = e.regex, a = [
            "bernoulli",
            "bernoulli_logit",
            "bernoulli_logit_glm",
            "beta",
            "beta_binomial",
            "beta_proportion",
            "binomial",
            "binomial_logit",
            "categorical",
            "categorical_logit",
            "categorical_logit_glm",
            "cauchy",
            "chi_square",
            "dirichlet",
            "discrete_range",
            "double_exponential",
            "exp_mod_normal",
            "exponential",
            "frechet",
            "gamma",
            "gaussian_dlm_obs",
            "gumbel",
            "hmm_latent",
            "hypergeometric",
            "inv_chi_square",
            "inv_gamma",
            "inv_wishart",
            "inv_wishart_cholesky",
            "lkj_corr",
            "lkj_corr_cholesky",
            "logistic",
            "loglogistic",
            "lognormal",
            "multi_gp",
            "multi_gp_cholesky",
            "multinomial",
            "multinomial_logit",
            "multi_normal",
            "multi_normal_cholesky",
            "multi_normal_prec",
            "multi_student_cholesky_t",
            "multi_student_t",
            "multi_student_t_cholesky",
            "neg_binomial",
            "neg_binomial_2",
            "neg_binomial_2_log",
            "neg_binomial_2_log_glm",
            "normal",
            "normal_id_glm",
            "ordered_logistic",
            "ordered_logistic_glm",
            "ordered_probit",
            "pareto",
            "pareto_type_2",
            "poisson",
            "poisson_log",
            "poisson_log_glm",
            "rayleigh",
            "scaled_inv_chi_square",
            "skew_double_exponential",
            "skew_normal",
            "std_normal",
            "std_normal_log",
            "student_t",
            "uniform",
            "von_mises",
            "weibull",
            "wiener",
            "wishart",
            "wishart_cholesky"
        ], n = e.COMMENT(/\/\*/, /\*\//, {
            relevance: 0,
            contains: [
                {
                    scope: "doctag",
                    match: /@(return|param)/
                }
            ]
        }), i = {
            scope: "meta",
            begin: /#include\b/,
            end: /$/,
            contains: [
                {
                    match: /[a-z][a-z-._]+/,
                    scope: "string"
                },
                e.C_LINE_COMMENT_MODE
            ]
        }, r = [
            "lower",
            "upper",
            "offset",
            "multiplier"
        ];
        return {
            name: "Stan",
            aliases: [
                "stanfuncs"
            ],
            keywords: {
                $pattern: e.IDENT_RE,
                title: [
                    "functions",
                    "model",
                    "data",
                    "parameters",
                    "quantities",
                    "transformed",
                    "generated"
                ],
                type: [
                    "array",
                    "tuple",
                    "complex",
                    "int",
                    "real",
                    "vector",
                    "complex_vector",
                    "ordered",
                    "positive_ordered",
                    "simplex",
                    "unit_vector",
                    "row_vector",
                    "complex_row_vector",
                    "matrix",
                    "complex_matrix",
                    "cholesky_factor_corr|10",
                    "cholesky_factor_cov|10",
                    "corr_matrix|10",
                    "cov_matrix|10",
                    "void"
                ],
                keyword: [
                    "for",
                    "in",
                    "if",
                    "else",
                    "while",
                    "break",
                    "continue",
                    "return"
                ],
                built_in: [
                    "abs",
                    "acos",
                    "acosh",
                    "add_diag",
                    "algebra_solver",
                    "algebra_solver_newton",
                    "append_array",
                    "append_col",
                    "append_row",
                    "asin",
                    "asinh",
                    "atan",
                    "atan2",
                    "atanh",
                    "bessel_first_kind",
                    "bessel_second_kind",
                    "binary_log_loss",
                    "block",
                    "cbrt",
                    "ceil",
                    "chol2inv",
                    "cholesky_decompose",
                    "choose",
                    "col",
                    "cols",
                    "columns_dot_product",
                    "columns_dot_self",
                    "complex_schur_decompose",
                    "complex_schur_decompose_t",
                    "complex_schur_decompose_u",
                    "conj",
                    "cos",
                    "cosh",
                    "cov_exp_quad",
                    "crossprod",
                    "csr_extract",
                    "csr_extract_u",
                    "csr_extract_v",
                    "csr_extract_w",
                    "csr_matrix_times_vector",
                    "csr_to_dense_matrix",
                    "cumulative_sum",
                    "dae",
                    "dae_tol",
                    "determinant",
                    "diag_matrix",
                    "diagonal",
                    "diag_post_multiply",
                    "diag_pre_multiply",
                    "digamma",
                    "dims",
                    "distance",
                    "dot_product",
                    "dot_self",
                    "eigendecompose",
                    "eigendecompose_sym",
                    "eigenvalues",
                    "eigenvalues_sym",
                    "eigenvectors",
                    "eigenvectors_sym",
                    "erf",
                    "erfc",
                    "exp",
                    "exp2",
                    "expm1",
                    "falling_factorial",
                    "fdim",
                    "fft",
                    "fft2",
                    "floor",
                    "fma",
                    "fmax",
                    "fmin",
                    "fmod",
                    "gamma_p",
                    "gamma_q",
                    "generalized_inverse",
                    "get_imag",
                    "get_real",
                    "head",
                    "hmm_hidden_state_prob",
                    "hmm_marginal",
                    "hypot",
                    "identity_matrix",
                    "inc_beta",
                    "integrate_1d",
                    "integrate_ode",
                    "integrate_ode_adams",
                    "integrate_ode_bdf",
                    "integrate_ode_rk45",
                    "int_step",
                    "inv",
                    "inv_cloglog",
                    "inv_erfc",
                    "inverse",
                    "inverse_spd",
                    "inv_fft",
                    "inv_fft2",
                    "inv_inc_beta",
                    "inv_logit",
                    "inv_Phi",
                    "inv_sqrt",
                    "inv_square",
                    "is_inf",
                    "is_nan",
                    "lambert_w0",
                    "lambert_wm1",
                    "lbeta",
                    "lchoose",
                    "ldexp",
                    "lgamma",
                    "linspaced_array",
                    "linspaced_int_array",
                    "linspaced_row_vector",
                    "linspaced_vector",
                    "lmgamma",
                    "lmultiply",
                    "log",
                    "log1m",
                    "log1m_exp",
                    "log1m_inv_logit",
                    "log1p",
                    "log1p_exp",
                    "log_determinant",
                    "log_diff_exp",
                    "log_falling_factorial",
                    "log_inv_logit",
                    "log_inv_logit_diff",
                    "logit",
                    "log_mix",
                    "log_modified_bessel_first_kind",
                    "log_rising_factorial",
                    "log_softmax",
                    "log_sum_exp",
                    "machine_precision",
                    "map_rect",
                    "matrix_exp",
                    "matrix_exp_multiply",
                    "matrix_power",
                    "max",
                    "mdivide_left_spd",
                    "mdivide_left_tri_low",
                    "mdivide_right_spd",
                    "mdivide_right_tri_low",
                    "mean",
                    "min",
                    "modified_bessel_first_kind",
                    "modified_bessel_second_kind",
                    "multiply_lower_tri_self_transpose",
                    "negative_infinity",
                    "norm",
                    "norm1",
                    "norm2",
                    "not_a_number",
                    "num_elements",
                    "ode_adams",
                    "ode_adams_tol",
                    "ode_adjoint_tol_ctl",
                    "ode_bdf",
                    "ode_bdf_tol",
                    "ode_ckrk",
                    "ode_ckrk_tol",
                    "ode_rk45",
                    "ode_rk45_tol",
                    "one_hot_array",
                    "one_hot_int_array",
                    "one_hot_row_vector",
                    "one_hot_vector",
                    "ones_array",
                    "ones_int_array",
                    "ones_row_vector",
                    "ones_vector",
                    "owens_t",
                    "Phi",
                    "Phi_approx",
                    "polar",
                    "positive_infinity",
                    "pow",
                    "print",
                    "prod",
                    "proj",
                    "qr",
                    "qr_Q",
                    "qr_R",
                    "qr_thin",
                    "qr_thin_Q",
                    "qr_thin_R",
                    "quad_form",
                    "quad_form_diag",
                    "quad_form_sym",
                    "quantile",
                    "rank",
                    "reduce_sum",
                    "reject",
                    "rep_array",
                    "rep_matrix",
                    "rep_row_vector",
                    "rep_vector",
                    "reverse",
                    "rising_factorial",
                    "round",
                    "row",
                    "rows",
                    "rows_dot_product",
                    "rows_dot_self",
                    "scale_matrix_exp_multiply",
                    "sd",
                    "segment",
                    "sin",
                    "singular_values",
                    "sinh",
                    "size",
                    "softmax",
                    "sort_asc",
                    "sort_desc",
                    "sort_indices_asc",
                    "sort_indices_desc",
                    "sqrt",
                    "square",
                    "squared_distance",
                    "step",
                    "sub_col",
                    "sub_row",
                    "sum",
                    "svd",
                    "svd_U",
                    "svd_V",
                    "symmetrize_from_lower_tri",
                    "tail",
                    "tan",
                    "tanh",
                    "target",
                    "tcrossprod",
                    "tgamma",
                    "to_array_1d",
                    "to_array_2d",
                    "to_complex",
                    "to_int",
                    "to_matrix",
                    "to_row_vector",
                    "to_vector",
                    "trace",
                    "trace_gen_quad_form",
                    "trace_quad_form",
                    "trigamma",
                    "trunc",
                    "uniform_simplex",
                    "variance",
                    "zeros_array",
                    "zeros_int_array",
                    "zeros_row_vector"
                ]
            },
            contains: [
                e.C_LINE_COMMENT_MODE,
                i,
                e.HASH_COMMENT_MODE,
                n,
                {
                    scope: "built_in",
                    match: /\s(pi|e|sqrt2|log2|log10)(?=\()/,
                    relevance: 0
                },
                {
                    match: t.concat(/[<,]\s*/, t.either(...r), /\s*=/),
                    keywords: r
                },
                {
                    scope: "keyword",
                    match: /\btarget(?=\s*\+=)/
                },
                {
                    match: [
                        /~\s*/,
                        t.either(...a),
                        /(?:\(\))/,
                        /\s*T(?=\s*\[)/
                    ],
                    scope: {
                        2: "built_in",
                        4: "keyword"
                    }
                },
                {
                    scope: "built_in",
                    keywords: a,
                    begin: t.concat(/\w*/, t.either(...a), /(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\s*[\(.*\)])/)
                },
                {
                    begin: [
                        /~/,
                        /\s*/,
                        t.concat(t.either(...a), /(?=\s*[\(.*\)])/)
                    ],
                    scope: {
                        3: "built_in"
                    }
                },
                {
                    begin: [
                        /~/,
                        /\s*\w+(?=\s*[\(.*\)])/,
                        "(?!.*/\b(" + t.either(...a) + ")\b)"
                    ],
                    scope: {
                        2: "title.function"
                    }
                },
                {
                    scope: "title.function",
                    begin: /\w*(_lpdf|_lupdf|_lpmf|_cdf|_lcdf|_lccdf|_qf)(?=\s*[\(.*\)])/
                },
                {
                    scope: "number",
                    match: t.concat(/(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)/, /(?:[eE][+-]?\d+(?:_\d+)*)?i?(?!\w)/),
                    relevance: 0
                },
                {
                    scope: "string",
                    begin: /"/,
                    end: /"/
                }
            ]
        };
    }), To)), Cs.registerLanguage("stata", (Ro || (Ro = 1, fo = function(e) {
        return {
            name: "Stata",
            aliases: [
                "do",
                "ado"
            ],
            case_insensitive: !0,
            keywords: "if else in foreach for forv forva forval forvalu forvalue forvalues by bys bysort xi quietly qui capture about ac ac_7 acprplot acprplot_7 adjust ado adopath adoupdate alpha ameans an ano anov anova anova_estat anova_terms anovadef aorder ap app appe appen append arch arch_dr arch_estat arch_p archlm areg areg_p args arima arima_dr arima_estat arima_p as asmprobit asmprobit_estat asmprobit_lf asmprobit_mfx__dlg asmprobit_p ass asse asser assert avplot avplot_7 avplots avplots_7 bcskew0 bgodfrey bias binreg bip0_lf biplot bipp_lf bipr_lf bipr_p biprobit bitest bitesti bitowt blogit bmemsize boot bootsamp bootstrap bootstrap_8 boxco_l boxco_p boxcox boxcox_6 boxcox_p bprobit br break brier bro brow brows browse brr brrstat bs bs_7 bsampl_w bsample bsample_7 bsqreg bstat bstat_7 bstat_8 bstrap bstrap_7 bubble bubbleplot ca ca_estat ca_p cabiplot camat canon canon_8 canon_8_p canon_estat canon_p cap caprojection capt captu captur capture cat cc cchart cchart_7 cci cd censobs_table centile cf char chdir checkdlgfiles checkestimationsample checkhlpfiles checksum chelp ci cii cl class classutil clear cli clis clist clo clog clog_lf clog_p clogi clogi_sw clogit clogit_lf clogit_p clogitp clogl_sw cloglog clonevar clslistarray cluster cluster_measures cluster_stop cluster_tree cluster_tree_8 clustermat cmdlog cnr cnre cnreg cnreg_p cnreg_sw cnsreg codebook collaps4 collapse colormult_nb colormult_nw compare compress conf confi confir confirm conren cons const constr constra constrai constrain constraint continue contract copy copyright copysource cor corc corr corr2data corr_anti corr_kmo corr_smc corre correl correla correlat correlate corrgram cou coun count cox cox_p cox_sw coxbase coxhaz coxvar cprplot cprplot_7 crc cret cretu cretur creturn cross cs cscript cscript_log csi ct ct_is ctset ctst_5 ctst_st cttost cumsp cumsp_7 cumul cusum cusum_7 cutil d|0 datasig datasign datasigna datasignat datasignatu datasignatur datasignature datetof db dbeta de dec deco decod decode deff des desc descr descri describ describe destring dfbeta dfgls dfuller di di_g dir dirstats dis discard disp disp_res disp_s displ displa display distinct do doe doed doedi doedit dotplot dotplot_7 dprobit drawnorm drop ds ds_util dstdize duplicates durbina dwstat dydx e|0 ed edi edit egen eivreg emdef en enc enco encod encode eq erase ereg ereg_lf ereg_p ereg_sw ereghet ereghet_glf ereghet_glf_sh ereghet_gp ereghet_ilf ereghet_ilf_sh ereghet_ip eret eretu eretur ereturn err erro error esize est est_cfexist est_cfname est_clickable est_expand est_hold est_table est_unhold est_unholdok estat estat_default estat_summ estat_vce_only esti estimates etodow etof etomdy ex exi exit expand expandcl fac fact facto factor factor_estat factor_p factor_pca_rotated factor_rotate factormat fcast fcast_compute fcast_graph fdades fdadesc fdadescr fdadescri fdadescrib fdadescribe fdasav fdasave fdause fh_st file open file read file close file filefilter fillin find_hlp_file findfile findit findit_7 fit fl fli flis flist for5_0 forest forestplot form forma format fpredict frac_154 frac_adj frac_chk frac_cox frac_ddp frac_dis frac_dv frac_in frac_mun frac_pp frac_pq frac_pv frac_wgt frac_xo fracgen fracplot fracplot_7 fracpoly fracpred fron_ex fron_hn fron_p fron_tn fron_tn2 frontier ftodate ftoe ftomdy ftowdate funnel funnelplot g|0 gamhet_glf gamhet_gp gamhet_ilf gamhet_ip gamma gamma_d2 gamma_p gamma_sw gammahet gdi_hexagon gdi_spokes ge gen gene gener genera generat generate genrank genstd genvmean gettoken gl gladder gladder_7 glim_l01 glim_l02 glim_l03 glim_l04 glim_l05 glim_l06 glim_l07 glim_l08 glim_l09 glim_l10 glim_l11 glim_l12 glim_lf glim_mu glim_nw1 glim_nw2 glim_nw3 glim_p glim_v1 glim_v2 glim_v3 glim_v4 glim_v5 glim_v6 glim_v7 glm glm_6 glm_p glm_sw glmpred glo glob globa global glogit glogit_8 glogit_p gmeans gnbre_lf gnbreg gnbreg_5 gnbreg_p gomp_lf gompe_sw gomper_p gompertz gompertzhet gomphet_glf gomphet_glf_sh gomphet_gp gomphet_ilf gomphet_ilf_sh gomphet_ip gphdot gphpen gphprint gprefs gprobi_p gprobit gprobit_8 gr gr7 gr_copy gr_current gr_db gr_describe gr_dir gr_draw gr_draw_replay gr_drop gr_edit gr_editviewopts gr_example gr_example2 gr_export gr_print gr_qscheme gr_query gr_read gr_rename gr_replay gr_save gr_set gr_setscheme gr_table gr_undo gr_use graph graph7 grebar greigen greigen_7 greigen_8 grmeanby grmeanby_7 gs_fileinfo gs_filetype gs_graphinfo gs_stat gsort gwood h|0 hadimvo hareg hausman haver he heck_d2 heckma_p heckman heckp_lf heckpr_p heckprob hel help hereg hetpr_lf hetpr_p hetprob hettest hexdump hilite hist hist_7 histogram hlogit hlu hmeans hotel hotelling hprobit hreg hsearch icd9 icd9_ff icd9p iis impute imtest inbase include inf infi infil infile infix inp inpu input ins insheet insp inspe inspec inspect integ inten intreg intreg_7 intreg_p intrg2_ll intrg_ll intrg_ll2 ipolate iqreg ir irf irf_create irfm iri is_svy is_svysum isid istdize ivprob_1_lf ivprob_lf ivprobit ivprobit_p ivreg ivreg_footnote ivtob_1_lf ivtob_lf ivtobit ivtobit_p jackknife jacknife jknife jknife_6 jknife_8 jkstat joinby kalarma1 kap kap_3 kapmeier kappa kapwgt kdensity kdensity_7 keep ksm ksmirnov ktau kwallis l|0 la lab labbe labbeplot labe label labelbook ladder levels levelsof leverage lfit lfit_p li lincom line linktest lis list lloghet_glf lloghet_glf_sh lloghet_gp lloghet_ilf lloghet_ilf_sh lloghet_ip llogi_sw llogis_p llogist llogistic llogistichet lnorm_lf lnorm_sw lnorma_p lnormal lnormalhet lnormhet_glf lnormhet_glf_sh lnormhet_gp lnormhet_ilf lnormhet_ilf_sh lnormhet_ip lnskew0 loadingplot loc loca local log logi logis_lf logistic logistic_p logit logit_estat logit_p loglogs logrank loneway lookfor lookup lowess lowess_7 lpredict lrecomp lroc lroc_7 lrtest ls lsens lsens_7 lsens_x lstat ltable ltable_7 ltriang lv lvr2plot lvr2plot_7 m|0 ma mac macr macro makecns man manova manova_estat manova_p manovatest mantel mark markin markout marksample mat mat_capp mat_order mat_put_rr mat_rapp mata mata_clear mata_describe mata_drop mata_matdescribe mata_matsave mata_matuse mata_memory mata_mlib mata_mosave mata_rename mata_which matalabel matcproc matlist matname matr matri matrix matrix_input__dlg matstrik mcc mcci md0_ md1_ md1debug_ md2_ md2debug_ mds mds_estat mds_p mdsconfig mdslong mdsmat mdsshepard mdytoe mdytof me_derd mean means median memory memsize menl meqparse mer merg merge meta mfp mfx mhelp mhodds minbound mixed_ll mixed_ll_reparm mkassert mkdir mkmat mkspline ml ml_5 ml_adjs ml_bhhhs ml_c_d ml_check ml_clear ml_cnt ml_debug ml_defd ml_e0 ml_e0_bfgs ml_e0_cycle ml_e0_dfp ml_e0i ml_e1 ml_e1_bfgs ml_e1_bhhh ml_e1_cycle ml_e1_dfp ml_e2 ml_e2_cycle ml_ebfg0 ml_ebfr0 ml_ebfr1 ml_ebh0q ml_ebhh0 ml_ebhr0 ml_ebr0i ml_ecr0i ml_edfp0 ml_edfr0 ml_edfr1 ml_edr0i ml_eds ml_eer0i ml_egr0i ml_elf ml_elf_bfgs ml_elf_bhhh ml_elf_cycle ml_elf_dfp ml_elfi ml_elfs ml_enr0i ml_enrr0 ml_erdu0 ml_erdu0_bfgs ml_erdu0_bhhh ml_erdu0_bhhhq ml_erdu0_cycle ml_erdu0_dfp ml_erdu0_nrbfgs ml_exde ml_footnote ml_geqnr ml_grad0 ml_graph ml_hbhhh ml_hd0 ml_hold ml_init ml_inv ml_log ml_max ml_mlout ml_mlout_8 ml_model ml_nb0 ml_opt ml_p ml_plot ml_query ml_rdgrd ml_repor ml_s_e ml_score ml_searc ml_technique ml_unhold mleval mlf_ mlmatbysum mlmatsum mlog mlogi mlogit mlogit_footnote mlogit_p mlopts mlsum mlvecsum mnl0_ mor more mov move mprobit mprobit_lf mprobit_p mrdu0_ mrdu1_ mvdecode mvencode mvreg mvreg_estat n|0 nbreg nbreg_al nbreg_lf nbreg_p nbreg_sw nestreg net newey newey_7 newey_p news nl nl_7 nl_9 nl_9_p nl_p nl_p_7 nlcom nlcom_p nlexp2 nlexp2_7 nlexp2a nlexp2a_7 nlexp3 nlexp3_7 nlgom3 nlgom3_7 nlgom4 nlgom4_7 nlinit nllog3 nllog3_7 nllog4 nllog4_7 nlog_rd nlogit nlogit_p nlogitgen nlogittree nlpred no nobreak noi nois noisi noisil noisily note notes notes_dlg nptrend numlabel numlist odbc old_ver olo olog ologi ologi_sw ologit ologit_p ologitp on one onew onewa oneway op_colnm op_comp op_diff op_inv op_str opr opro oprob oprob_sw oprobi oprobi_p oprobit oprobitp opts_exclusive order orthog orthpoly ou out outf outfi outfil outfile outs outsh outshe outshee outsheet ovtest pac pac_7 palette parse parse_dissim pause pca pca_8 pca_display pca_estat pca_p pca_rotate pcamat pchart pchart_7 pchi pchi_7 pcorr pctile pentium pergram pergram_7 permute permute_8 personal peto_st pkcollapse pkcross pkequiv pkexamine pkexamine_7 pkshape pksumm pksumm_7 pl plo plot plugin pnorm pnorm_7 poisgof poiss_lf poiss_sw poisso_p poisson poisson_estat post postclose postfile postutil pperron pr prais prais_e prais_e2 prais_p predict predictnl preserve print pro prob probi probit probit_estat probit_p proc_time procoverlay procrustes procrustes_estat procrustes_p profiler prog progr progra program prop proportion prtest prtesti pwcorr pwd q\\s qby qbys qchi qchi_7 qladder qladder_7 qnorm qnorm_7 qqplot qqplot_7 qreg qreg_c qreg_p qreg_sw qu quadchk quantile quantile_7 que quer query range ranksum ratio rchart rchart_7 rcof recast reclink recode reg reg3 reg3_p regdw regr regre regre_p2 regres regres_p regress regress_estat regriv_p remap ren rena renam rename renpfix repeat replace report reshape restore ret retu retur return rm rmdir robvar roccomp roccomp_7 roccomp_8 rocf_lf rocfit rocfit_8 rocgold rocplot rocplot_7 roctab roctab_7 rolling rologit rologit_p rot rota rotat rotate rotatemat rreg rreg_p ru run runtest rvfplot rvfplot_7 rvpplot rvpplot_7 sa safesum sample sampsi sav save savedresults saveold sc sca scal scala scalar scatter scm_mine sco scob_lf scob_p scobi_sw scobit scor score scoreplot scoreplot_help scree screeplot screeplot_help sdtest sdtesti se search separate seperate serrbar serrbar_7 serset set set_defaults sfrancia sh she shel shell shewhart shewhart_7 signestimationsample signrank signtest simul simul_7 simulate simulate_8 sktest sleep slogit slogit_d2 slogit_p smooth snapspan so sor sort spearman spikeplot spikeplot_7 spikeplt spline_x split sqreg sqreg_p sret sretu sretur sreturn ssc st st_ct st_hc st_hcd st_hcd_sh st_is st_issys st_note st_promo st_set st_show st_smpl st_subid stack statsby statsby_8 stbase stci stci_7 stcox stcox_estat stcox_fr stcox_fr_ll stcox_p stcox_sw stcoxkm stcoxkm_7 stcstat stcurv stcurve stcurve_7 stdes stem stepwise stereg stfill stgen stir stjoin stmc stmh stphplot stphplot_7 stphtest stphtest_7 stptime strate strate_7 streg streg_sw streset sts sts_7 stset stsplit stsum sttocc sttoct stvary stweib su suest suest_8 sum summ summa summar summari summariz summarize sunflower sureg survcurv survsum svar svar_p svmat svy svy_disp svy_dreg svy_est svy_est_7 svy_estat svy_get svy_gnbreg_p svy_head svy_header svy_heckman_p svy_heckprob_p svy_intreg_p svy_ivreg_p svy_logistic_p svy_logit_p svy_mlogit_p svy_nbreg_p svy_ologit_p svy_oprobit_p svy_poisson_p svy_probit_p svy_regress_p svy_sub svy_sub_7 svy_x svy_x_7 svy_x_p svydes svydes_8 svygen svygnbreg svyheckman svyheckprob svyintreg svyintreg_7 svyintrg svyivreg svylc svylog_p svylogit svymarkout svymarkout_8 svymean svymlog svymlogit svynbreg svyolog svyologit svyoprob svyoprobit svyopts svypois svypois_7 svypoisson svyprobit svyprobt svyprop svyprop_7 svyratio svyreg svyreg_p svyregress svyset svyset_7 svyset_8 svytab svytab_7 svytest svytotal sw sw_8 swcnreg swcox swereg swilk swlogis swlogit swologit swoprbt swpois swprobit swqreg swtobit swweib symmetry symmi symplot symplot_7 syntax sysdescribe sysdir sysuse szroeter ta tab tab1 tab2 tab_or tabd tabdi tabdis tabdisp tabi table tabodds tabodds_7 tabstat tabu tabul tabula tabulat tabulate te tempfile tempname tempvar tes test testnl testparm teststd tetrachoric time_it timer tis tob tobi tobit tobit_p tobit_sw token tokeni tokeniz tokenize tostring total translate translator transmap treat_ll treatr_p treatreg trim trimfill trnb_cons trnb_mean trpoiss_d2 trunc_ll truncr_p truncreg tsappend tset tsfill tsline tsline_ex tsreport tsrevar tsrline tsset tssmooth tsunab ttest ttesti tut_chk tut_wait tutorial tw tware_st two twoway twoway__fpfit_serset twoway__function_gen twoway__histogram_gen twoway__ipoint_serset twoway__ipoints_serset twoway__kdensity_gen twoway__lfit_serset twoway__normgen_gen twoway__pci_serset twoway__qfit_serset twoway__scatteri_serset twoway__sunflower_gen twoway_ksm_serset ty typ type typeof u|0 unab unabbrev unabcmd update us use uselabel var var_mkcompanion var_p varbasic varfcast vargranger varirf varirf_add varirf_cgraph varirf_create varirf_ctable varirf_describe varirf_dir varirf_drop varirf_erase varirf_graph varirf_ograph varirf_rename varirf_set varirf_table varlist varlmar varnorm varsoc varstable varstable_w varstable_w2 varwle vce vec vec_fevd vec_mkphi vec_p vec_p_w vecirf_create veclmar veclmar_w vecnorm vecnorm_w vecrank vecstable verinst vers versi versio version view viewsource vif vwls wdatetof webdescribe webseek webuse weib1_lf weib2_lf weib_lf weib_lf0 weibhet_glf weibhet_glf_sh weibhet_glfa weibhet_glfa_sh weibhet_gp weibhet_ilf weibhet_ilf_sh weibhet_ilfa weibhet_ilfa_sh weibhet_ip weibu_sw weibul_p weibull weibull_c weibull_s weibullhet wh whelp whi which whil while wilc_st wilcoxon win wind windo window winexec wntestb wntestb_7 wntestq xchart xchart_7 xcorr xcorr_7 xi xi_6 xmlsav xmlsave xmluse xpose xsh xshe xshel xshell xt_iis xt_tis xtab_p xtabond xtbin_p xtclog xtcloglog xtcloglog_8 xtcloglog_d2 xtcloglog_pa_p xtcloglog_re_p xtcnt_p xtcorr xtdata xtdes xtfront_p xtfrontier xtgee xtgee_elink xtgee_estat xtgee_makeivar xtgee_p xtgee_plink xtgls xtgls_p xthaus xthausman xtht_p xthtaylor xtile xtint_p xtintreg xtintreg_8 xtintreg_d2 xtintreg_p xtivp_1 xtivp_2 xtivreg xtline xtline_ex xtlogit xtlogit_8 xtlogit_d2 xtlogit_fe_p xtlogit_pa_p xtlogit_re_p xtmixed xtmixed_estat xtmixed_p xtnb_fe xtnb_lf xtnbreg xtnbreg_pa_p xtnbreg_refe_p xtpcse xtpcse_p xtpois xtpoisson xtpoisson_d2 xtpoisson_pa_p xtpoisson_refe_p xtpred xtprobit xtprobit_8 xtprobit_d2 xtprobit_re_p xtps_fe xtps_lf xtps_ren xtps_ren_8 xtrar_p xtrc xtrc_p xtrchh xtrefe_p xtreg xtreg_be xtreg_fe xtreg_ml xtreg_pa_p xtreg_re xtregar xtrere_p xtset xtsf_ll xtsf_llti xtsum xttab xttest0 xttobit xttobit_8 xttobit_p xttrans yx yxview__barlike_draw yxview_area_draw yxview_bar_draw yxview_dot_draw yxview_dropline_draw yxview_function_draw yxview_iarrow_draw yxview_ilabels_draw yxview_normal_draw yxview_pcarrow_draw yxview_pcbarrow_draw yxview_pccapsym_draw yxview_pcscatter_draw yxview_pcspike_draw yxview_rarea_draw yxview_rbar_draw yxview_rbarm_draw yxview_rcap_draw yxview_rcapsym_draw yxview_rconnected_draw yxview_rline_draw yxview_rscatter_draw yxview_rspike_draw yxview_spike_draw yxview_sunflower_draw zap_s zinb zinb_llf zinb_plf zip zip_llf zip_p zip_plf zt_ct_5 zt_hc_5 zt_hcd_5 zt_is_5 zt_iss_5 zt_sho_5 zt_smp_5 ztbase_5 ztcox_5 ztdes_5 ztereg_5 ztfill_5 ztgen_5 ztir_5 ztjoin_5 ztnb ztnb_p ztp ztp_p zts_5 ztset_5 ztspli_5 ztsum_5 zttoct_5 ztvary_5 ztweib_5",
            contains: [
                {
                    className: "symbol",
                    begin: /`[a-zA-Z0-9_]+'/
                },
                {
                    className: "variable",
                    begin: /\$\{?[a-zA-Z0-9_]+\}?/,
                    relevance: 0
                },
                {
                    className: "string",
                    variants: [
                        {
                            begin: '`"[^\r\n]*?"\''
                        },
                        {
                            begin: '"[^\r\n"]*"'
                        }
                    ]
                },
                {
                    className: "built_in",
                    variants: [
                        {
                            begin: "\\b(abs|acos|asin|atan|atan2|atanh|ceil|cloglog|comb|cos|digamma|exp|floor|invcloglog|invlogit|ln|lnfact|lnfactorial|lngamma|log|log10|max|min|mod|reldif|round|sign|sin|sqrt|sum|tan|tanh|trigamma|trunc|betaden|Binomial|binorm|binormal|chi2|chi2tail|dgammapda|dgammapdada|dgammapdadx|dgammapdx|dgammapdxdx|F|Fden|Ftail|gammaden|gammap|ibeta|invbinomial|invchi2|invchi2tail|invF|invFtail|invgammap|invibeta|invnchi2|invnFtail|invnibeta|invnorm|invnormal|invttail|nbetaden|nchi2|nFden|nFtail|nibeta|norm|normal|normalden|normd|npnchi2|tden|ttail|uniform|abbrev|char|index|indexnot|length|lower|ltrim|match|plural|proper|real|regexm|regexr|regexs|reverse|rtrim|string|strlen|strlower|strltrim|strmatch|strofreal|strpos|strproper|strreverse|strrtrim|strtrim|strupper|subinstr|subinword|substr|trim|upper|word|wordcount|_caller|autocode|byteorder|chop|clip|cond|e|epsdouble|epsfloat|group|inlist|inrange|irecode|matrix|maxbyte|maxdouble|maxfloat|maxint|maxlong|mi|minbyte|mindouble|minfloat|minint|minlong|missing|r|recode|replay|return|s|scalar|d|date|day|dow|doy|halfyear|mdy|month|quarter|week|year|d|daily|dofd|dofh|dofm|dofq|dofw|dofy|h|halfyearly|hofd|m|mofd|monthly|q|qofd|quarterly|tin|twithin|w|weekly|wofd|y|yearly|yh|ym|yofd|yq|yw|cholesky|colnumb|colsof|corr|det|diag|diag0cnt|el|get|hadamard|I|inv|invsym|issym|issymmetric|J|matmissing|matuniform|mreldif|nullmat|rownumb|rowsof|sweep|syminv|trace|vec|vecdiag)(?=\\()"
                        }
                    ]
                },
                e.COMMENT("^[ \t]*\\*.*$", !1),
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE
            ]
        };
    }), fo)), Cs.registerLanguage("step21", (Oo || (Oo = 1, No = function(e) {
        return {
            name: "STEP Part 21",
            aliases: [
                "p21",
                "step",
                "stp"
            ],
            case_insensitive: !0,
            keywords: {
                $pattern: "[A-Z_][A-Z0-9_.]*",
                keyword: [
                    "HEADER",
                    "ENDSEC",
                    "DATA"
                ]
            },
            contains: [
                {
                    className: "meta",
                    begin: "ISO-10303-21;",
                    relevance: 10
                },
                {
                    className: "meta",
                    begin: "END-ISO-10303-21;",
                    relevance: 10
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                e.COMMENT("/\\*\\*!", "\\*/"),
                e.C_NUMBER_MODE,
                e.inherit(e.APOS_STRING_MODE, {
                    illegal: null
                }),
                e.inherit(e.QUOTE_STRING_MODE, {
                    illegal: null
                }),
                {
                    className: "string",
                    begin: "'",
                    end: "'"
                },
                {
                    className: "symbol",
                    variants: [
                        {
                            begin: "#",
                            end: "\\d+",
                            illegal: "\\W"
                        }
                    ]
                }
            ]
        };
    }), No)), Cs.registerLanguage("stylus", function() {
        if (vo) return ho;
        vo = 1;
        const e = [
            "a",
            "abbr",
            "address",
            "article",
            "aside",
            "audio",
            "b",
            "blockquote",
            "body",
            "button",
            "canvas",
            "caption",
            "cite",
            "code",
            "dd",
            "del",
            "details",
            "dfn",
            "div",
            "dl",
            "dt",
            "em",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "html",
            "i",
            "iframe",
            "img",
            "input",
            "ins",
            "kbd",
            "label",
            "legend",
            "li",
            "main",
            "mark",
            "menu",
            "nav",
            "object",
            "ol",
            "p",
            "q",
            "quote",
            "samp",
            "section",
            "span",
            "strong",
            "summary",
            "sup",
            "table",
            "tbody",
            "td",
            "textarea",
            "tfoot",
            "th",
            "thead",
            "time",
            "tr",
            "ul",
            "var",
            "video"
        ], t = [
            "any-hover",
            "any-pointer",
            "aspect-ratio",
            "color",
            "color-gamut",
            "color-index",
            "device-aspect-ratio",
            "device-height",
            "device-width",
            "display-mode",
            "forced-colors",
            "grid",
            "height",
            "hover",
            "inverted-colors",
            "monochrome",
            "orientation",
            "overflow-block",
            "overflow-inline",
            "pointer",
            "prefers-color-scheme",
            "prefers-contrast",
            "prefers-reduced-motion",
            "prefers-reduced-transparency",
            "resolution",
            "scan",
            "scripting",
            "update",
            "width",
            "min-width",
            "max-width",
            "min-height",
            "max-height"
        ], a = [
            "active",
            "any-link",
            "blank",
            "checked",
            "current",
            "default",
            "defined",
            "dir",
            "disabled",
            "drop",
            "empty",
            "enabled",
            "first",
            "first-child",
            "first-of-type",
            "fullscreen",
            "future",
            "focus",
            "focus-visible",
            "focus-within",
            "has",
            "host",
            "host-context",
            "hover",
            "indeterminate",
            "in-range",
            "invalid",
            "is",
            "lang",
            "last-child",
            "last-of-type",
            "left",
            "link",
            "local-link",
            "not",
            "nth-child",
            "nth-col",
            "nth-last-child",
            "nth-last-col",
            "nth-last-of-type",
            "nth-of-type",
            "only-child",
            "only-of-type",
            "optional",
            "out-of-range",
            "past",
            "placeholder-shown",
            "read-only",
            "read-write",
            "required",
            "right",
            "root",
            "scope",
            "target",
            "target-within",
            "user-invalid",
            "valid",
            "visited",
            "where"
        ], n = [
            "after",
            "backdrop",
            "before",
            "cue",
            "cue-region",
            "first-letter",
            "first-line",
            "grammar-error",
            "marker",
            "part",
            "placeholder",
            "selection",
            "slotted",
            "spelling-error"
        ], i = [
            "align-content",
            "align-items",
            "align-self",
            "all",
            "animation",
            "animation-delay",
            "animation-direction",
            "animation-duration",
            "animation-fill-mode",
            "animation-iteration-count",
            "animation-name",
            "animation-play-state",
            "animation-timing-function",
            "backface-visibility",
            "background",
            "background-attachment",
            "background-blend-mode",
            "background-clip",
            "background-color",
            "background-image",
            "background-origin",
            "background-position",
            "background-repeat",
            "background-size",
            "block-size",
            "border",
            "border-block",
            "border-block-color",
            "border-block-end",
            "border-block-end-color",
            "border-block-end-style",
            "border-block-end-width",
            "border-block-start",
            "border-block-start-color",
            "border-block-start-style",
            "border-block-start-width",
            "border-block-style",
            "border-block-width",
            "border-bottom",
            "border-bottom-color",
            "border-bottom-left-radius",
            "border-bottom-right-radius",
            "border-bottom-style",
            "border-bottom-width",
            "border-collapse",
            "border-color",
            "border-image",
            "border-image-outset",
            "border-image-repeat",
            "border-image-slice",
            "border-image-source",
            "border-image-width",
            "border-inline",
            "border-inline-color",
            "border-inline-end",
            "border-inline-end-color",
            "border-inline-end-style",
            "border-inline-end-width",
            "border-inline-start",
            "border-inline-start-color",
            "border-inline-start-style",
            "border-inline-start-width",
            "border-inline-style",
            "border-inline-width",
            "border-left",
            "border-left-color",
            "border-left-style",
            "border-left-width",
            "border-radius",
            "border-right",
            "border-right-color",
            "border-right-style",
            "border-right-width",
            "border-spacing",
            "border-style",
            "border-top",
            "border-top-color",
            "border-top-left-radius",
            "border-top-right-radius",
            "border-top-style",
            "border-top-width",
            "border-width",
            "bottom",
            "box-decoration-break",
            "box-shadow",
            "box-sizing",
            "break-after",
            "break-before",
            "break-inside",
            "caption-side",
            "caret-color",
            "clear",
            "clip",
            "clip-path",
            "clip-rule",
            "color",
            "column-count",
            "column-fill",
            "column-gap",
            "column-rule",
            "column-rule-color",
            "column-rule-style",
            "column-rule-width",
            "column-span",
            "column-width",
            "columns",
            "contain",
            "content",
            "content-visibility",
            "counter-increment",
            "counter-reset",
            "cue",
            "cue-after",
            "cue-before",
            "cursor",
            "direction",
            "display",
            "empty-cells",
            "filter",
            "flex",
            "flex-basis",
            "flex-direction",
            "flex-flow",
            "flex-grow",
            "flex-shrink",
            "flex-wrap",
            "float",
            "flow",
            "font",
            "font-display",
            "font-family",
            "font-feature-settings",
            "font-kerning",
            "font-language-override",
            "font-size",
            "font-size-adjust",
            "font-smoothing",
            "font-stretch",
            "font-style",
            "font-synthesis",
            "font-variant",
            "font-variant-caps",
            "font-variant-east-asian",
            "font-variant-ligatures",
            "font-variant-numeric",
            "font-variant-position",
            "font-variation-settings",
            "font-weight",
            "gap",
            "glyph-orientation-vertical",
            "grid",
            "grid-area",
            "grid-auto-columns",
            "grid-auto-flow",
            "grid-auto-rows",
            "grid-column",
            "grid-column-end",
            "grid-column-start",
            "grid-gap",
            "grid-row",
            "grid-row-end",
            "grid-row-start",
            "grid-template",
            "grid-template-areas",
            "grid-template-columns",
            "grid-template-rows",
            "hanging-punctuation",
            "height",
            "hyphens",
            "icon",
            "image-orientation",
            "image-rendering",
            "image-resolution",
            "ime-mode",
            "inline-size",
            "isolation",
            "justify-content",
            "left",
            "letter-spacing",
            "line-break",
            "line-height",
            "list-style",
            "list-style-image",
            "list-style-position",
            "list-style-type",
            "margin",
            "margin-block",
            "margin-block-end",
            "margin-block-start",
            "margin-bottom",
            "margin-inline",
            "margin-inline-end",
            "margin-inline-start",
            "margin-left",
            "margin-right",
            "margin-top",
            "marks",
            "mask",
            "mask-border",
            "mask-border-mode",
            "mask-border-outset",
            "mask-border-repeat",
            "mask-border-slice",
            "mask-border-source",
            "mask-border-width",
            "mask-clip",
            "mask-composite",
            "mask-image",
            "mask-mode",
            "mask-origin",
            "mask-position",
            "mask-repeat",
            "mask-size",
            "mask-type",
            "max-block-size",
            "max-height",
            "max-inline-size",
            "max-width",
            "min-block-size",
            "min-height",
            "min-inline-size",
            "min-width",
            "mix-blend-mode",
            "nav-down",
            "nav-index",
            "nav-left",
            "nav-right",
            "nav-up",
            "none",
            "normal",
            "object-fit",
            "object-position",
            "opacity",
            "order",
            "orphans",
            "outline",
            "outline-color",
            "outline-offset",
            "outline-style",
            "outline-width",
            "overflow",
            "overflow-wrap",
            "overflow-x",
            "overflow-y",
            "padding",
            "padding-block",
            "padding-block-end",
            "padding-block-start",
            "padding-bottom",
            "padding-inline",
            "padding-inline-end",
            "padding-inline-start",
            "padding-left",
            "padding-right",
            "padding-top",
            "page-break-after",
            "page-break-before",
            "page-break-inside",
            "pause",
            "pause-after",
            "pause-before",
            "perspective",
            "perspective-origin",
            "pointer-events",
            "position",
            "quotes",
            "resize",
            "rest",
            "rest-after",
            "rest-before",
            "right",
            "row-gap",
            "scroll-margin",
            "scroll-margin-block",
            "scroll-margin-block-end",
            "scroll-margin-block-start",
            "scroll-margin-bottom",
            "scroll-margin-inline",
            "scroll-margin-inline-end",
            "scroll-margin-inline-start",
            "scroll-margin-left",
            "scroll-margin-right",
            "scroll-margin-top",
            "scroll-padding",
            "scroll-padding-block",
            "scroll-padding-block-end",
            "scroll-padding-block-start",
            "scroll-padding-bottom",
            "scroll-padding-inline",
            "scroll-padding-inline-end",
            "scroll-padding-inline-start",
            "scroll-padding-left",
            "scroll-padding-right",
            "scroll-padding-top",
            "scroll-snap-align",
            "scroll-snap-stop",
            "scroll-snap-type",
            "scrollbar-color",
            "scrollbar-gutter",
            "scrollbar-width",
            "shape-image-threshold",
            "shape-margin",
            "shape-outside",
            "speak",
            "speak-as",
            "src",
            "tab-size",
            "table-layout",
            "text-align",
            "text-align-all",
            "text-align-last",
            "text-combine-upright",
            "text-decoration",
            "text-decoration-color",
            "text-decoration-line",
            "text-decoration-style",
            "text-emphasis",
            "text-emphasis-color",
            "text-emphasis-position",
            "text-emphasis-style",
            "text-indent",
            "text-justify",
            "text-orientation",
            "text-overflow",
            "text-rendering",
            "text-shadow",
            "text-transform",
            "text-underline-position",
            "top",
            "transform",
            "transform-box",
            "transform-origin",
            "transform-style",
            "transition",
            "transition-delay",
            "transition-duration",
            "transition-property",
            "transition-timing-function",
            "unicode-bidi",
            "vertical-align",
            "visibility",
            "voice-balance",
            "voice-duration",
            "voice-family",
            "voice-pitch",
            "voice-range",
            "voice-rate",
            "voice-stress",
            "voice-volume",
            "white-space",
            "widows",
            "width",
            "will-change",
            "word-break",
            "word-spacing",
            "word-wrap",
            "writing-mode",
            "z-index"
        ].reverse();
        return ho = function(r) {
            const o = ((e)=>({
                    IMPORTANT: {
                        scope: "meta",
                        begin: "!important"
                    },
                    BLOCK_COMMENT: e.C_BLOCK_COMMENT_MODE,
                    HEXCOLOR: {
                        scope: "number",
                        begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
                    },
                    FUNCTION_DISPATCH: {
                        className: "built_in",
                        begin: /[\w-]+(?=\()/
                    },
                    ATTRIBUTE_SELECTOR_MODE: {
                        scope: "selector-attr",
                        begin: /\[/,
                        end: /\]/,
                        illegal: "$",
                        contains: [
                            e.APOS_STRING_MODE,
                            e.QUOTE_STRING_MODE
                        ]
                    },
                    CSS_NUMBER_MODE: {
                        scope: "number",
                        begin: e.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
                        relevance: 0
                    },
                    CSS_VARIABLE: {
                        className: "attr",
                        begin: /--[A-Za-z_][A-Za-z0-9_-]*/
                    }
                }))(r), s = {
                className: "variable",
                begin: "\\$" + r.IDENT_RE
            }, l = "(?=[.\\s\\n[:,(])";
            return {
                name: "Stylus",
                aliases: [
                    "styl"
                ],
                case_insensitive: !1,
                keywords: "if else for in",
                illegal: "(" + [
                    "\\?",
                    "(\\bReturn\\b)",
                    "(\\bEnd\\b)",
                    "(\\bend\\b)",
                    "(\\bdef\\b)",
                    ";",
                    "#\\s",
                    "\\*\\s",
                    "===\\s",
                    "\\|",
                    "%"
                ].join("|") + ")",
                contains: [
                    r.QUOTE_STRING_MODE,
                    r.APOS_STRING_MODE,
                    r.C_LINE_COMMENT_MODE,
                    r.C_BLOCK_COMMENT_MODE,
                    o.HEXCOLOR,
                    {
                        begin: "\\.[a-zA-Z][a-zA-Z0-9_-]*" + l,
                        className: "selector-class"
                    },
                    {
                        begin: "#[a-zA-Z][a-zA-Z0-9_-]*" + l,
                        className: "selector-id"
                    },
                    {
                        begin: "\\b(" + e.join("|") + ")" + l,
                        className: "selector-tag"
                    },
                    {
                        className: "selector-pseudo",
                        begin: "&?:(" + a.join("|") + ")" + l
                    },
                    {
                        className: "selector-pseudo",
                        begin: "&?:(:)?(" + n.join("|") + ")" + l
                    },
                    o.ATTRIBUTE_SELECTOR_MODE,
                    {
                        className: "keyword",
                        begin: /@media/,
                        starts: {
                            end: /[{;}]/,
                            keywords: {
                                $pattern: /[a-z-]+/,
                                keyword: "and or not only",
                                attribute: t.join(" ")
                            },
                            contains: [
                                o.CSS_NUMBER_MODE
                            ]
                        }
                    },
                    {
                        className: "keyword",
                        begin: "@((-(o|moz|ms|webkit)-)?(" + [
                            "charset",
                            "css",
                            "debug",
                            "extend",
                            "font-face",
                            "for",
                            "import",
                            "include",
                            "keyframes",
                            "media",
                            "mixin",
                            "page",
                            "warn",
                            "while"
                        ].join("|") + "))\\b"
                    },
                    s,
                    o.CSS_NUMBER_MODE,
                    {
                        className: "function",
                        begin: "^[a-zA-Z][a-zA-Z0-9_-]*\\(.*\\)",
                        illegal: "[\\n]",
                        returnBegin: !0,
                        contains: [
                            {
                                className: "title",
                                begin: "\\b[a-zA-Z][a-zA-Z0-9_-]*"
                            },
                            {
                                className: "params",
                                begin: /\(/,
                                end: /\)/,
                                contains: [
                                    o.HEXCOLOR,
                                    s,
                                    r.APOS_STRING_MODE,
                                    o.CSS_NUMBER_MODE,
                                    r.QUOTE_STRING_MODE
                                ]
                            }
                        ]
                    },
                    o.CSS_VARIABLE,
                    {
                        className: "attribute",
                        begin: "\\b(" + i.join("|") + ")\\b",
                        starts: {
                            end: /;|$/,
                            contains: [
                                o.HEXCOLOR,
                                s,
                                r.APOS_STRING_MODE,
                                r.QUOTE_STRING_MODE,
                                o.CSS_NUMBER_MODE,
                                r.C_BLOCK_COMMENT_MODE,
                                o.IMPORTANT,
                                o.FUNCTION_DISPATCH
                            ],
                            illegal: /\./,
                            relevance: 0
                        }
                    },
                    o.FUNCTION_DISPATCH
                ]
            };
        }, ho;
    }()), Cs.registerLanguage("subunit", Ao ? Io : (Ao = 1, Io = function(e) {
        return {
            name: "SubUnit",
            case_insensitive: !0,
            contains: [
                {
                    className: "string",
                    begin: "\\[\n(multipart)?",
                    end: "\\]\n"
                },
                {
                    className: "string",
                    begin: "\\d{4}-\\d{2}-\\d{2}(\\s+)\\d{2}:\\d{2}:\\d{2}.\\d+Z"
                },
                {
                    className: "string",
                    begin: "(\\+|-)\\d+"
                },
                {
                    className: "keyword",
                    relevance: 10,
                    variants: [
                        {
                            begin: "^(test|testing|success|successful|failure|error|skip|xfail|uxsuccess)(:?)\\s+(test)?"
                        },
                        {
                            begin: "^progress(:?)(\\s+)?(pop|push)?"
                        },
                        {
                            begin: "^tags:"
                        },
                        {
                            begin: "^time:"
                        }
                    ]
                }
            ]
        };
    })), Cs.registerLanguage("swift", function() {
        if (Do) return yo;
        function e(e) {
            return e ? "string" == typeof e ? e : e.source : null;
        }
        function t(e) {
            return a("(?=", e, ")");
        }
        function a(...t) {
            return t.map((t)=>e(t)).join("");
        }
        function n(...t) {
            const a = function(e) {
                const t = e[e.length - 1];
                return "object" == typeof t && t.constructor === Object ? (e.splice(e.length - 1, 1), t) : {};
            }(t);
            return "(" + (a.capture ? "" : "?:") + t.map((t)=>e(t)).join("|") + ")";
        }
        Do = 1;
        const i = (e)=>a(/\b/, e, /\w$/.test(e) ? /\b/ : /\B/), r = [
            "Protocol",
            "Type"
        ].map(i), o = [
            "init",
            "self"
        ].map(i), s = [
            "Any",
            "Self"
        ], l = [
            "actor",
            "any",
            "associatedtype",
            "async",
            "await",
            /as\?/,
            /as!/,
            "as",
            "borrowing",
            "break",
            "case",
            "catch",
            "class",
            "consume",
            "consuming",
            "continue",
            "convenience",
            "copy",
            "default",
            "defer",
            "deinit",
            "didSet",
            "distributed",
            "do",
            "dynamic",
            "each",
            "else",
            "enum",
            "extension",
            "fallthrough",
            /fileprivate\(set\)/,
            "fileprivate",
            "final",
            "for",
            "func",
            "get",
            "guard",
            "if",
            "import",
            "indirect",
            "infix",
            /init\?/,
            /init!/,
            "inout",
            /internal\(set\)/,
            "internal",
            "in",
            "is",
            "isolated",
            "nonisolated",
            "lazy",
            "let",
            "macro",
            "mutating",
            "nonmutating",
            /open\(set\)/,
            "open",
            "operator",
            "optional",
            "override",
            "postfix",
            "precedencegroup",
            "prefix",
            /private\(set\)/,
            "private",
            "protocol",
            /public\(set\)/,
            "public",
            "repeat",
            "required",
            "rethrows",
            "return",
            "set",
            "some",
            "static",
            "struct",
            "subscript",
            "super",
            "switch",
            "throws",
            "throw",
            /try\?/,
            /try!/,
            "try",
            "typealias",
            /unowned\(safe\)/,
            /unowned\(unsafe\)/,
            "unowned",
            "var",
            "weak",
            "where",
            "while",
            "willSet"
        ], c = [
            "false",
            "nil",
            "true"
        ], _ = [
            "assignment",
            "associativity",
            "higherThan",
            "left",
            "lowerThan",
            "none",
            "right"
        ], d = [
            "#colorLiteral",
            "#column",
            "#dsohandle",
            "#else",
            "#elseif",
            "#endif",
            "#error",
            "#file",
            "#fileID",
            "#fileLiteral",
            "#filePath",
            "#function",
            "#if",
            "#imageLiteral",
            "#keyPath",
            "#line",
            "#selector",
            "#sourceLocation",
            "#warning"
        ], m = [
            "abs",
            "all",
            "any",
            "assert",
            "assertionFailure",
            "debugPrint",
            "dump",
            "fatalError",
            "getVaList",
            "isKnownUniquelyReferenced",
            "max",
            "min",
            "numericCast",
            "pointwiseMax",
            "pointwiseMin",
            "precondition",
            "preconditionFailure",
            "print",
            "readLine",
            "repeatElement",
            "sequence",
            "stride",
            "swap",
            "swift_unboxFromSwiftValueWithType",
            "transcode",
            "type",
            "unsafeBitCast",
            "unsafeDowncast",
            "withExtendedLifetime",
            "withUnsafeMutablePointer",
            "withUnsafePointer",
            "withVaList",
            "withoutActuallyEscaping",
            "zip"
        ], p = n(/[/=\-+!*%<>&|^~?]/, /[\u00A1-\u00A7]/, /[\u00A9\u00AB]/, /[\u00AC\u00AE]/, /[\u00B0\u00B1]/, /[\u00B6\u00BB\u00BF\u00D7\u00F7]/, /[\u2016-\u2017]/, /[\u2020-\u2027]/, /[\u2030-\u203E]/, /[\u2041-\u2053]/, /[\u2055-\u205E]/, /[\u2190-\u23FF]/, /[\u2500-\u2775]/, /[\u2794-\u2BFF]/, /[\u2E00-\u2E7F]/, /[\u3001-\u3003]/, /[\u3008-\u3020]/, /[\u3030]/), u = n(p, /[\u0300-\u036F]/, /[\u1DC0-\u1DFF]/, /[\u20D0-\u20FF]/, /[\uFE00-\uFE0F]/, /[\uFE20-\uFE2F]/), g = a(p, u, "*"), E = n(/[a-zA-Z_]/, /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/, /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/, /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/, /[\u1E00-\u1FFF]/, /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/, /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/, /[\u2C00-\u2DFF\u2E80-\u2FFF]/, /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/, /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/, /[\uFE47-\uFEFE\uFF00-\uFFFD]/), S = n(E, /\d/, /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/), b = a(E, S, "*"), T = a(/[A-Z]/, S, "*"), C = [
            "attached",
            "autoclosure",
            a(/convention\(/, n("swift", "block", "c"), /\)/),
            "discardableResult",
            "dynamicCallable",
            "dynamicMemberLookup",
            "escaping",
            "freestanding",
            "frozen",
            "GKInspectable",
            "IBAction",
            "IBDesignable",
            "IBInspectable",
            "IBOutlet",
            "IBSegueAction",
            "inlinable",
            "main",
            "nonobjc",
            "NSApplicationMain",
            "NSCopying",
            "NSManaged",
            a(/objc\(/, b, /\)/),
            "objc",
            "objcMembers",
            "propertyWrapper",
            "requires_stored_property_inits",
            "resultBuilder",
            "Sendable",
            "testable",
            "UIApplicationMain",
            "unchecked",
            "unknown",
            "usableFromInline",
            "warn_unqualified_access"
        ], f = [
            "iOS",
            "iOSApplicationExtension",
            "macOS",
            "macOSApplicationExtension",
            "macCatalyst",
            "macCatalystApplicationExtension",
            "watchOS",
            "watchOSApplicationExtension",
            "tvOS",
            "tvOSApplicationExtension",
            "swift"
        ];
        return yo = function(e) {
            const p = {
                match: /\s+/,
                relevance: 0
            }, E = e.COMMENT("/\\*", "\\*/", {
                contains: [
                    "self"
                ]
            }), R = [
                e.C_LINE_COMMENT_MODE,
                E
            ], N = {
                match: [
                    /\./,
                    n(...r, ...o)
                ],
                className: {
                    2: "keyword"
                }
            }, O = {
                match: a(/\./, n(...l)),
                relevance: 0
            }, h = l.filter((e)=>"string" == typeof e).concat([
                "_|0"
            ]), v = {
                variants: [
                    {
                        className: "keyword",
                        match: n(...l.filter((e)=>"string" != typeof e).concat(s).map(i), ...o)
                    }
                ]
            }, I = {
                $pattern: n(/\b\w+/, /#\w+/),
                keyword: h.concat(d),
                literal: c
            }, A = [
                N,
                O,
                v
            ], y = [
                {
                    match: a(/\./, n(...m)),
                    relevance: 0
                },
                {
                    className: "built_in",
                    match: a(/\b/, n(...m), /(?=\()/)
                }
            ], D = {
                match: /->/,
                relevance: 0
            }, M = [
                D,
                {
                    className: "operator",
                    relevance: 0,
                    variants: [
                        {
                            match: g
                        },
                        {
                            match: `\\.(\\.|${u})+`
                        }
                    ]
                }
            ], L = "([0-9]_*)+", x = "([0-9a-fA-F]_*)+", w = {
                className: "number",
                relevance: 0,
                variants: [
                    {
                        match: `\\b(${L})(\\.(${L}))?([eE][+-]?(${L}))?\\b`
                    },
                    {
                        match: `\\b0x(${x})(\\.(${x}))?([pP][+-]?(${L}))?\\b`
                    },
                    {
                        match: /\b0o([0-7]_*)+\b/
                    },
                    {
                        match: /\b0b([01]_*)+\b/
                    }
                ]
            }, P = (e = "")=>({
                    className: "subst",
                    variants: [
                        {
                            match: a(/\\/, e, /[0\\tnr"']/)
                        },
                        {
                            match: a(/\\/, e, /u\{[0-9a-fA-F]{1,8}\}/)
                        }
                    ]
                }), k = (e = "")=>({
                    className: "subst",
                    match: a(/\\/, e, /[\t ]*(?:[\r\n]|\r\n)/)
                }), U = (e = "")=>({
                    className: "subst",
                    label: "interpol",
                    begin: a(/\\/, e, /\(/),
                    end: /\)/
                }), F = (e = "")=>({
                    begin: a(e, /"""/),
                    end: a(/"""/, e),
                    contains: [
                        P(e),
                        k(e),
                        U(e)
                    ]
                }), B = (e = "")=>({
                    begin: a(e, /"/),
                    end: a(/"/, e),
                    contains: [
                        P(e),
                        U(e)
                    ]
                }), G = {
                className: "string",
                variants: [
                    F(),
                    F("#"),
                    F("##"),
                    F("###"),
                    B(),
                    B("#"),
                    B("##"),
                    B("###")
                ]
            }, Y = [
                e.BACKSLASH_ESCAPE,
                {
                    begin: /\[/,
                    end: /\]/,
                    relevance: 0,
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                }
            ], H = {
                begin: /\/[^\s](?=[^/\n]*\/)/,
                end: /\//,
                contains: Y
            }, V = (e)=>{
                const t = a(e, /\//), n = a(/\//, e);
                return {
                    begin: t,
                    end: n,
                    contains: [
                        ...Y,
                        {
                            scope: "comment",
                            begin: `#(?!.*${n})`,
                            end: /$/
                        }
                    ]
                };
            }, q = {
                scope: "regexp",
                variants: [
                    V("###"),
                    V("##"),
                    V("#"),
                    H
                ]
            }, z = {
                match: a(/`/, b, /`/)
            }, $ = [
                z,
                {
                    className: "variable",
                    match: /\$\d+/
                },
                {
                    className: "variable",
                    match: `\\$${S}+`
                }
            ], W = [
                {
                    match: /(@|#(un)?)available/,
                    scope: "keyword",
                    starts: {
                        contains: [
                            {
                                begin: /\(/,
                                end: /\)/,
                                keywords: f,
                                contains: [
                                    ...M,
                                    w,
                                    G
                                ]
                            }
                        ]
                    }
                },
                {
                    scope: "keyword",
                    match: a(/@/, n(...C))
                },
                {
                    scope: "meta",
                    match: a(/@/, b)
                }
            ], Q = {
                match: t(/\b[A-Z]/),
                relevance: 0,
                contains: [
                    {
                        className: "type",
                        match: a(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, S, "+")
                    },
                    {
                        className: "type",
                        match: T,
                        relevance: 0
                    },
                    {
                        match: /[?!]+/,
                        relevance: 0
                    },
                    {
                        match: /\.\.\./,
                        relevance: 0
                    },
                    {
                        match: a(/\s+&\s+/, t(T)),
                        relevance: 0
                    }
                ]
            }, K = {
                begin: /</,
                end: />/,
                keywords: I,
                contains: [
                    ...R,
                    ...A,
                    ...W,
                    D,
                    Q
                ]
            };
            Q.contains.push(K);
            const j = {
                begin: /\(/,
                end: /\)/,
                relevance: 0,
                keywords: I,
                contains: [
                    "self",
                    {
                        match: a(b, /\s*:/),
                        keywords: "_|0",
                        relevance: 0
                    },
                    ...R,
                    q,
                    ...A,
                    ...y,
                    ...M,
                    w,
                    G,
                    ...$,
                    ...W,
                    Q
                ]
            }, X = {
                begin: /</,
                end: />/,
                keywords: "repeat each",
                contains: [
                    ...R,
                    Q
                ]
            }, Z = {
                begin: /\(/,
                end: /\)/,
                keywords: I,
                contains: [
                    {
                        begin: n(t(a(b, /\s*:/)), t(a(b, /\s+/, b, /\s*:/))),
                        end: /:/,
                        relevance: 0,
                        contains: [
                            {
                                className: "keyword",
                                match: /\b_\b/
                            },
                            {
                                className: "params",
                                match: b
                            }
                        ]
                    },
                    ...R,
                    ...A,
                    ...M,
                    w,
                    G,
                    ...W,
                    Q,
                    j
                ],
                endsParent: !0,
                illegal: /["']/
            }, J = {
                match: [
                    /(func|macro)/,
                    /\s+/,
                    n(z.match, b, g)
                ],
                className: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    X,
                    Z,
                    p
                ],
                illegal: [
                    /\[/,
                    /%/
                ]
            }, ee = {
                match: [
                    /\b(?:subscript|init[?!]?)/,
                    /\s*(?=[<(])/
                ],
                className: {
                    1: "keyword"
                },
                contains: [
                    X,
                    Z,
                    p
                ],
                illegal: /\[|%/
            }, te = {
                match: [
                    /operator/,
                    /\s+/,
                    g
                ],
                className: {
                    1: "keyword",
                    3: "title"
                }
            }, ae = {
                begin: [
                    /precedencegroup/,
                    /\s+/,
                    T
                ],
                className: {
                    1: "keyword",
                    3: "title"
                },
                contains: [
                    Q
                ],
                keywords: [
                    ..._,
                    ...c
                ],
                end: /}/
            };
            for (const e of G.variants){
                const t = e.contains.find((e)=>"interpol" === e.label);
                t.keywords = I;
                const a = [
                    ...A,
                    ...y,
                    ...M,
                    w,
                    G,
                    ...$
                ];
                t.contains = [
                    ...a,
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            "self",
                            ...a
                        ]
                    }
                ];
            }
            return {
                name: "Swift",
                keywords: I,
                contains: [
                    ...R,
                    J,
                    ee,
                    {
                        beginKeywords: "struct protocol class extension enum actor",
                        end: "\\{",
                        excludeEnd: !0,
                        keywords: I,
                        contains: [
                            e.inherit(e.TITLE_MODE, {
                                className: "title.class",
                                begin: /[A-Za-z$_][\u00C0-\u02B80-9A-Za-z$_]*/
                            }),
                            ...A
                        ]
                    },
                    te,
                    ae,
                    {
                        beginKeywords: "import",
                        end: /$/,
                        contains: [
                            ...R
                        ],
                        relevance: 0
                    },
                    q,
                    ...A,
                    ...y,
                    ...M,
                    w,
                    G,
                    ...$,
                    ...W,
                    Q,
                    j
                ]
            };
        }, yo;
    }()), Cs.registerLanguage("taggerscript", Lo ? Mo : (Lo = 1, Mo = function(e) {
        return {
            name: "Tagger Script",
            contains: [
                {
                    className: "comment",
                    begin: /\$noop\(/,
                    end: /\)/,
                    contains: [
                        {
                            begin: /\\[()]/
                        },
                        {
                            begin: /\(/,
                            end: /\)/,
                            contains: [
                                {
                                    begin: /\\[()]/
                                },
                                "self"
                            ]
                        }
                    ],
                    relevance: 10
                },
                {
                    className: "keyword",
                    begin: /\$[_a-zA-Z0-9]+(?=\()/
                },
                {
                    className: "variable",
                    begin: /%[_a-zA-Z0-9:]+%/
                },
                {
                    className: "symbol",
                    begin: /\\[\\nt$%,()]/
                },
                {
                    className: "symbol",
                    begin: /\\u[a-fA-F0-9]{4}/
                }
            ]
        };
    })), Cs.registerLanguage("yaml", (wo || (wo = 1, xo = function(e) {
        const t = "true false yes no null", a = "[\\w#;/?:@&=+$,.~*'()[\\]]+", n = {
            className: "string",
            relevance: 0,
            variants: [
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /"/,
                    end: /"/
                },
                {
                    begin: /\S+/
                }
            ],
            contains: [
                e.BACKSLASH_ESCAPE,
                {
                    className: "template-variable",
                    variants: [
                        {
                            begin: /\{\{/,
                            end: /\}\}/
                        },
                        {
                            begin: /%\{/,
                            end: /\}/
                        }
                    ]
                }
            ]
        }, i = e.inherit(n, {
            variants: [
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /"/,
                    end: /"/
                },
                {
                    begin: /[^\s,{}[\]]+/
                }
            ]
        }), r = {
            className: "number",
            begin: "\\b[0-9]{4}(-[0-9][0-9]){0,2}([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?(\\.[0-9]*)?([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?\\b"
        }, o = {
            end: ",",
            endsWithParent: !0,
            excludeEnd: !0,
            keywords: t,
            relevance: 0
        }, s = {
            begin: /\{/,
            end: /\}/,
            contains: [
                o
            ],
            illegal: "\\n",
            relevance: 0
        }, l = {
            begin: "\\[",
            end: "\\]",
            contains: [
                o
            ],
            illegal: "\\n",
            relevance: 0
        }, c = [
            {
                className: "attr",
                variants: [
                    {
                        begin: "\\w[\\w :\\/.-]*:(?=[ \t]|$)"
                    },
                    {
                        begin: '"\\w[\\w :\\/.-]*":(?=[ \t]|$)'
                    },
                    {
                        begin: "'\\w[\\w :\\/.-]*':(?=[ \t]|$)"
                    }
                ]
            },
            {
                className: "meta",
                begin: "^---\\s*$",
                relevance: 10
            },
            {
                className: "string",
                begin: "[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*"
            },
            {
                begin: "<%[%=-]?",
                end: "[%-]?%>",
                subLanguage: "ruby",
                excludeBegin: !0,
                excludeEnd: !0,
                relevance: 0
            },
            {
                className: "type",
                begin: "!\\w+!" + a
            },
            {
                className: "type",
                begin: "!<" + a + ">"
            },
            {
                className: "type",
                begin: "!" + a
            },
            {
                className: "type",
                begin: "!!" + a
            },
            {
                className: "meta",
                begin: "&" + e.UNDERSCORE_IDENT_RE + "$"
            },
            {
                className: "meta",
                begin: "\\*" + e.UNDERSCORE_IDENT_RE + "$"
            },
            {
                className: "bullet",
                begin: "-(?=[ ]|$)",
                relevance: 0
            },
            e.HASH_COMMENT_MODE,
            {
                beginKeywords: t,
                keywords: {
                    literal: t
                }
            },
            r,
            {
                className: "number",
                begin: e.C_NUMBER_RE + "\\b",
                relevance: 0
            },
            s,
            l,
            n
        ], _ = [
            ...c
        ];
        return _.pop(), _.push(i), o.contains = _, {
            name: "YAML",
            case_insensitive: !0,
            aliases: [
                "yml"
            ],
            contains: c
        };
    }), xo)), Cs.registerLanguage("tap", (ko || (ko = 1, Po = function(e) {
        return {
            name: "Test Anything Protocol",
            case_insensitive: !0,
            contains: [
                e.HASH_COMMENT_MODE,
                {
                    className: "meta",
                    variants: [
                        {
                            begin: "^TAP version (\\d+)$"
                        },
                        {
                            begin: "^1\\.\\.(\\d+)$"
                        }
                    ]
                },
                {
                    begin: /---$/,
                    end: "\\.\\.\\.$",
                    subLanguage: "yaml",
                    relevance: 0
                },
                {
                    className: "number",
                    begin: " (\\d+) "
                },
                {
                    className: "symbol",
                    variants: [
                        {
                            begin: "^ok"
                        },
                        {
                            begin: "^not ok"
                        }
                    ]
                }
            ]
        };
    }), Po)), Cs.registerLanguage("tcl", (Fo || (Fo = 1, Uo = function(e) {
        const t = e.regex, a = /[a-zA-Z_][a-zA-Z0-9_]*/, n = {
            className: "number",
            variants: [
                e.BINARY_NUMBER_MODE,
                e.C_NUMBER_MODE
            ]
        };
        return {
            name: "Tcl",
            aliases: [
                "tk"
            ],
            keywords: [
                "after",
                "append",
                "apply",
                "array",
                "auto_execok",
                "auto_import",
                "auto_load",
                "auto_mkindex",
                "auto_mkindex_old",
                "auto_qualify",
                "auto_reset",
                "bgerror",
                "binary",
                "break",
                "catch",
                "cd",
                "chan",
                "clock",
                "close",
                "concat",
                "continue",
                "dde",
                "dict",
                "encoding",
                "eof",
                "error",
                "eval",
                "exec",
                "exit",
                "expr",
                "fblocked",
                "fconfigure",
                "fcopy",
                "file",
                "fileevent",
                "filename",
                "flush",
                "for",
                "foreach",
                "format",
                "gets",
                "glob",
                "global",
                "history",
                "http",
                "if",
                "incr",
                "info",
                "interp",
                "join",
                "lappend|10",
                "lassign|10",
                "lindex|10",
                "linsert|10",
                "list",
                "llength|10",
                "load",
                "lrange|10",
                "lrepeat|10",
                "lreplace|10",
                "lreverse|10",
                "lsearch|10",
                "lset|10",
                "lsort|10",
                "mathfunc",
                "mathop",
                "memory",
                "msgcat",
                "namespace",
                "open",
                "package",
                "parray",
                "pid",
                "pkg::create",
                "pkg_mkIndex",
                "platform",
                "platform::shell",
                "proc",
                "puts",
                "pwd",
                "read",
                "refchan",
                "regexp",
                "registry",
                "regsub|10",
                "rename",
                "return",
                "safe",
                "scan",
                "seek",
                "set",
                "socket",
                "source",
                "split",
                "string",
                "subst",
                "switch",
                "tcl_endOfWord",
                "tcl_findLibrary",
                "tcl_startOfNextWord",
                "tcl_startOfPreviousWord",
                "tcl_wordBreakAfter",
                "tcl_wordBreakBefore",
                "tcltest",
                "tclvars",
                "tell",
                "time",
                "tm",
                "trace",
                "unknown",
                "unload",
                "unset",
                "update",
                "uplevel",
                "upvar",
                "variable",
                "vwait",
                "while"
            ],
            contains: [
                e.COMMENT(";[ \\t]*#", "$"),
                e.COMMENT("^[ \\t]*#", "$"),
                {
                    beginKeywords: "proc",
                    end: "[\\{]",
                    excludeEnd: !0,
                    contains: [
                        {
                            className: "title",
                            begin: "[ \\t\\n\\r]+(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
                            end: "[ \\t\\n\\r]",
                            endsWithParent: !0,
                            excludeEnd: !0
                        }
                    ]
                },
                {
                    className: "variable",
                    variants: [
                        {
                            begin: t.concat(/\$/, t.optional(/::/), a, "(::", a, ")*")
                        },
                        {
                            begin: "\\$\\{(::)?[a-zA-Z_]((::)?[a-zA-Z0-9_])*",
                            end: "\\}",
                            contains: [
                                n
                            ]
                        }
                    ]
                },
                {
                    className: "string",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ],
                    variants: [
                        e.inherit(e.QUOTE_STRING_MODE, {
                            illegal: null
                        })
                    ]
                },
                n
            ]
        };
    }), Uo)), Cs.registerLanguage("thrift", (Go || (Go = 1, Bo = function(e) {
        const t = [
            "bool",
            "byte",
            "i16",
            "i32",
            "i64",
            "double",
            "string",
            "binary"
        ];
        return {
            name: "Thrift",
            keywords: {
                keyword: [
                    "namespace",
                    "const",
                    "typedef",
                    "struct",
                    "enum",
                    "service",
                    "exception",
                    "void",
                    "oneway",
                    "set",
                    "list",
                    "map",
                    "required",
                    "optional"
                ],
                type: t,
                literal: "true false"
            },
            contains: [
                e.QUOTE_STRING_MODE,
                e.NUMBER_MODE,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "class",
                    beginKeywords: "struct enum service exception",
                    end: /\{/,
                    illegal: /\n/,
                    contains: [
                        e.inherit(e.TITLE_MODE, {
                            starts: {
                                endsWithParent: !0,
                                excludeEnd: !0
                            }
                        })
                    ]
                },
                {
                    begin: "\\b(set|list|map)\\s*<",
                    keywords: {
                        type: [
                            ...t,
                            "set",
                            "list",
                            "map"
                        ]
                    },
                    end: ">",
                    contains: [
                        "self"
                    ]
                }
            ]
        };
    }), Bo)), Cs.registerLanguage("tp", (Ho || (Ho = 1, Yo = function(e) {
        const t = {
            className: "number",
            begin: "[1-9][0-9]*",
            relevance: 0
        }, a = {
            className: "symbol",
            begin: ":[^\\]]+"
        };
        return {
            name: "TP",
            keywords: {
                keyword: [
                    "ABORT",
                    "ACC",
                    "ADJUST",
                    "AND",
                    "AP_LD",
                    "BREAK",
                    "CALL",
                    "CNT",
                    "COL",
                    "CONDITION",
                    "CONFIG",
                    "DA",
                    "DB",
                    "DIV",
                    "DETECT",
                    "ELSE",
                    "END",
                    "ENDFOR",
                    "ERR_NUM",
                    "ERROR_PROG",
                    "FINE",
                    "FOR",
                    "GP",
                    "GUARD",
                    "INC",
                    "IF",
                    "JMP",
                    "LINEAR_MAX_SPEED",
                    "LOCK",
                    "MOD",
                    "MONITOR",
                    "OFFSET",
                    "Offset",
                    "OR",
                    "OVERRIDE",
                    "PAUSE",
                    "PREG",
                    "PTH",
                    "RT_LD",
                    "RUN",
                    "SELECT",
                    "SKIP",
                    "Skip",
                    "TA",
                    "TB",
                    "TO",
                    "TOOL_OFFSET",
                    "Tool_Offset",
                    "UF",
                    "UT",
                    "UFRAME_NUM",
                    "UTOOL_NUM",
                    "UNLOCK",
                    "WAIT",
                    "X",
                    "Y",
                    "Z",
                    "W",
                    "P",
                    "R",
                    "STRLEN",
                    "SUBSTR",
                    "FINDSTR",
                    "VOFFSET",
                    "PROG",
                    "ATTR",
                    "MN",
                    "POS"
                ],
                literal: [
                    "ON",
                    "OFF",
                    "max_speed",
                    "LPOS",
                    "JPOS",
                    "ENABLE",
                    "DISABLE",
                    "START",
                    "STOP",
                    "RESET"
                ]
            },
            contains: [
                {
                    className: "built_in",
                    begin: "(AR|P|PAYLOAD|PR|R|SR|RSR|LBL|VR|UALM|MESSAGE|UTOOL|UFRAME|TIMER|TIMER_OVERFLOW|JOINT_MAX_SPEED|RESUME_PROG|DIAG_REC)\\[",
                    end: "\\]",
                    contains: [
                        "self",
                        t,
                        a
                    ]
                },
                {
                    className: "built_in",
                    begin: "(AI|AO|DI|DO|F|RI|RO|UI|UO|GI|GO|SI|SO)\\[",
                    end: "\\]",
                    contains: [
                        "self",
                        t,
                        e.QUOTE_STRING_MODE,
                        a
                    ]
                },
                {
                    className: "keyword",
                    begin: "/(PROG|ATTR|MN|POS|END)\\b"
                },
                {
                    className: "keyword",
                    begin: "(CALL|RUN|POINT_LOGIC|LBL)\\b"
                },
                {
                    className: "keyword",
                    begin: "\\b(ACC|CNT|Skip|Offset|PSPD|RT_LD|AP_LD|Tool_Offset)"
                },
                {
                    className: "number",
                    begin: "\\d+(sec|msec|mm/sec|cm/min|inch/min|deg/sec|mm|in|cm)?\\b",
                    relevance: 0
                },
                e.COMMENT("//", "[;$]"),
                e.COMMENT("!", "[;$]"),
                e.COMMENT("--eg:", "$"),
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    begin: "'",
                    end: "'"
                },
                e.C_NUMBER_MODE,
                {
                    className: "variable",
                    begin: "\\$[A-Za-z0-9_]+"
                }
            ]
        };
    }), Yo)), Cs.registerLanguage("twig", (qo || (qo = 1, Vo = function(e) {
        const t = e.regex, a = [
            "absolute_url",
            "asset|0",
            "asset_version",
            "attribute",
            "block",
            "constant",
            "controller|0",
            "country_timezones",
            "csrf_token",
            "cycle",
            "date",
            "dump",
            "expression",
            "form|0",
            "form_end",
            "form_errors",
            "form_help",
            "form_label",
            "form_rest",
            "form_row",
            "form_start",
            "form_widget",
            "html_classes",
            "include",
            "is_granted",
            "logout_path",
            "logout_url",
            "max",
            "min",
            "parent",
            "path|0",
            "random",
            "range",
            "relative_path",
            "render",
            "render_esi",
            "source",
            "template_from_string",
            "url|0"
        ];
        let n = [
            "apply",
            "autoescape",
            "block",
            "cache",
            "deprecated",
            "do",
            "embed",
            "extends",
            "filter",
            "flush",
            "for",
            "form_theme",
            "from",
            "if",
            "import",
            "include",
            "macro",
            "sandbox",
            "set",
            "stopwatch",
            "trans",
            "trans_default_domain",
            "transchoice",
            "use",
            "verbatim",
            "with"
        ];
        n = n.concat(n.map((e)=>`end${e}`));
        const i = {
            scope: "string",
            variants: [
                {
                    begin: /'/,
                    end: /'/
                },
                {
                    begin: /"/,
                    end: /"/
                }
            ]
        }, r = {
            scope: "number",
            match: /\d+/
        }, o = {
            begin: /\(/,
            end: /\)/,
            excludeBegin: !0,
            excludeEnd: !0,
            contains: [
                i,
                r
            ]
        }, s = {
            beginKeywords: a.join(" "),
            keywords: {
                name: a
            },
            relevance: 0,
            contains: [
                o
            ]
        }, l = {
            match: /\|(?=[A-Za-z_]+:?)/,
            beginScope: "punctuation",
            relevance: 0,
            contains: [
                {
                    match: /[A-Za-z_]+:?/,
                    keywords: [
                        "abs",
                        "abbr_class",
                        "abbr_method",
                        "batch",
                        "capitalize",
                        "column",
                        "convert_encoding",
                        "country_name",
                        "currency_name",
                        "currency_symbol",
                        "data_uri",
                        "date",
                        "date_modify",
                        "default",
                        "escape",
                        "file_excerpt",
                        "file_link",
                        "file_relative",
                        "filter",
                        "first",
                        "format",
                        "format_args",
                        "format_args_as_text",
                        "format_currency",
                        "format_date",
                        "format_datetime",
                        "format_file",
                        "format_file_from_text",
                        "format_number",
                        "format_time",
                        "html_to_markdown",
                        "humanize",
                        "inky_to_html",
                        "inline_css",
                        "join",
                        "json_encode",
                        "keys",
                        "language_name",
                        "last",
                        "length",
                        "locale_name",
                        "lower",
                        "map",
                        "markdown",
                        "markdown_to_html",
                        "merge",
                        "nl2br",
                        "number_format",
                        "raw",
                        "reduce",
                        "replace",
                        "reverse",
                        "round",
                        "slice",
                        "slug",
                        "sort",
                        "spaceless",
                        "split",
                        "striptags",
                        "timezone_name",
                        "title",
                        "trans",
                        "transchoice",
                        "trim",
                        "u|0",
                        "upper",
                        "url_encode",
                        "yaml_dump",
                        "yaml_encode"
                    ]
                }
            ]
        }, c = (e, { relevance: a })=>({
                beginScope: {
                    1: "template-tag",
                    3: "name"
                },
                relevance: a || 2,
                endScope: "template-tag",
                begin: [
                    /\{%/,
                    /\s*/,
                    t.either(...e)
                ],
                end: /%\}/,
                keywords: "in",
                contains: [
                    l,
                    s,
                    i,
                    r
                ]
            }), _ = c(n, {
            relevance: 2
        }), d = c([
            /[a-z_]+/
        ], {
            relevance: 1
        });
        return {
            name: "Twig",
            aliases: [
                "craftcms"
            ],
            case_insensitive: !0,
            subLanguage: "xml",
            contains: [
                e.COMMENT(/\{#/, /#\}/),
                _,
                d,
                {
                    className: "template-variable",
                    begin: /\{\{/,
                    end: /\}\}/,
                    contains: [
                        "self",
                        l,
                        s,
                        i,
                        r
                    ]
                }
            ]
        };
    }), Vo)), Cs.registerLanguage("typescript", function() {
        if ($o) return zo;
        $o = 1;
        const e = "[A-Za-z$_][0-9A-Za-z$_]*", t = [
            "as",
            "in",
            "of",
            "if",
            "for",
            "while",
            "finally",
            "var",
            "new",
            "function",
            "do",
            "return",
            "void",
            "else",
            "break",
            "catch",
            "instanceof",
            "with",
            "throw",
            "case",
            "default",
            "try",
            "switch",
            "continue",
            "typeof",
            "delete",
            "let",
            "yield",
            "const",
            "class",
            "debugger",
            "async",
            "await",
            "static",
            "import",
            "from",
            "export",
            "extends"
        ], a = [
            "true",
            "false",
            "null",
            "undefined",
            "NaN",
            "Infinity"
        ], n = [
            "Object",
            "Function",
            "Boolean",
            "Symbol",
            "Math",
            "Date",
            "Number",
            "BigInt",
            "String",
            "RegExp",
            "Array",
            "Float32Array",
            "Float64Array",
            "Int8Array",
            "Uint8Array",
            "Uint8ClampedArray",
            "Int16Array",
            "Int32Array",
            "Uint16Array",
            "Uint32Array",
            "BigInt64Array",
            "BigUint64Array",
            "Set",
            "Map",
            "WeakSet",
            "WeakMap",
            "ArrayBuffer",
            "SharedArrayBuffer",
            "Atomics",
            "DataView",
            "JSON",
            "Promise",
            "Generator",
            "GeneratorFunction",
            "AsyncFunction",
            "Reflect",
            "Proxy",
            "Intl",
            "WebAssembly"
        ], i = [
            "Error",
            "EvalError",
            "InternalError",
            "RangeError",
            "ReferenceError",
            "SyntaxError",
            "TypeError",
            "URIError"
        ], r = [
            "setInterval",
            "setTimeout",
            "clearInterval",
            "clearTimeout",
            "require",
            "exports",
            "eval",
            "isFinite",
            "isNaN",
            "parseFloat",
            "parseInt",
            "decodeURI",
            "decodeURIComponent",
            "encodeURI",
            "encodeURIComponent",
            "escape",
            "unescape"
        ], o = [
            "arguments",
            "this",
            "super",
            "console",
            "window",
            "document",
            "localStorage",
            "sessionStorage",
            "module",
            "global"
        ], s = [].concat(r, n, i);
        function l(l) {
            const c = l.regex, _ = e, d = "<>", m = "</>", p = {
                begin: /<[A-Za-z0-9\\._:-]+/,
                end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
                isTrulyOpeningTag: (e, t)=>{
                    const a = e[0].length + e.index, n = e.input[a];
                    if ("<" === n || "," === n) return void t.ignoreMatch();
                    let i;
                    ">" === n && (((e, { after: t })=>{
                        const a = "</" + e[0].slice(1);
                        return -1 !== e.input.indexOf(a, t);
                    })(e, {
                        after: a
                    }) || t.ignoreMatch());
                    const r = e.input.substring(a);
                    ((i = r.match(/^\s*=/)) || (i = r.match(/^\s+extends\s+/)) && 0 === i.index) && t.ignoreMatch();
                }
            }, u = {
                $pattern: e,
                keyword: t,
                literal: a,
                built_in: s,
                "variable.language": o
            }, g = "[0-9](_?[0-9])*", E = `\\.(${g})`, S = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", b = {
                className: "number",
                variants: [
                    {
                        begin: `(\\b(${S})((${E})|\\.)?|(${E}))[eE][+-]?(${g})\\b`
                    },
                    {
                        begin: `\\b(${S})\\b((${E})\\b|\\.)?|(${E})\\b`
                    },
                    {
                        begin: "\\b(0|[1-9](_?[0-9])*)n\\b"
                    },
                    {
                        begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b"
                    },
                    {
                        begin: "\\b0[bB][0-1](_?[0-1])*n?\\b"
                    },
                    {
                        begin: "\\b0[oO][0-7](_?[0-7])*n?\\b"
                    },
                    {
                        begin: "\\b0[0-7]+n?\\b"
                    }
                ],
                relevance: 0
            }, T = {
                className: "subst",
                begin: "\\$\\{",
                end: "\\}",
                keywords: u,
                contains: []
            }, C = {
                begin: "html`",
                end: "",
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        l.BACKSLASH_ESCAPE,
                        T
                    ],
                    subLanguage: "xml"
                }
            }, f = {
                begin: "css`",
                end: "",
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        l.BACKSLASH_ESCAPE,
                        T
                    ],
                    subLanguage: "css"
                }
            }, R = {
                begin: "gql`",
                end: "",
                starts: {
                    end: "`",
                    returnEnd: !1,
                    contains: [
                        l.BACKSLASH_ESCAPE,
                        T
                    ],
                    subLanguage: "graphql"
                }
            }, N = {
                className: "string",
                begin: "`",
                end: "`",
                contains: [
                    l.BACKSLASH_ESCAPE,
                    T
                ]
            }, O = {
                className: "comment",
                variants: [
                    l.COMMENT(/\/\*\*(?!\/)/, "\\*/", {
                        relevance: 0,
                        contains: [
                            {
                                begin: "(?=@[A-Za-z]+)",
                                relevance: 0,
                                contains: [
                                    {
                                        className: "doctag",
                                        begin: "@[A-Za-z]+"
                                    },
                                    {
                                        className: "type",
                                        begin: "\\{",
                                        end: "\\}",
                                        excludeEnd: !0,
                                        excludeBegin: !0,
                                        relevance: 0
                                    },
                                    {
                                        className: "variable",
                                        begin: _ + "(?=\\s*(-)|$)",
                                        endsParent: !0,
                                        relevance: 0
                                    },
                                    {
                                        begin: /(?=[^\n])\s/,
                                        relevance: 0
                                    }
                                ]
                            }
                        ]
                    }),
                    l.C_BLOCK_COMMENT_MODE,
                    l.C_LINE_COMMENT_MODE
                ]
            }, h = [
                l.APOS_STRING_MODE,
                l.QUOTE_STRING_MODE,
                C,
                f,
                R,
                N,
                {
                    match: /\$\d+/
                },
                b
            ];
            T.contains = h.concat({
                begin: /\{/,
                end: /\}/,
                keywords: u,
                contains: [
                    "self"
                ].concat(h)
            });
            const v = [].concat(O, T.contains), I = v.concat([
                {
                    begin: /\(/,
                    end: /\)/,
                    keywords: u,
                    contains: [
                        "self"
                    ].concat(v)
                }
            ]), A = {
                className: "params",
                begin: /\(/,
                end: /\)/,
                excludeBegin: !0,
                excludeEnd: !0,
                keywords: u,
                contains: I
            }, y = {
                variants: [
                    {
                        match: [
                            /class/,
                            /\s+/,
                            _,
                            /\s+/,
                            /extends/,
                            /\s+/,
                            c.concat(_, "(", c.concat(/\./, _), ")*")
                        ],
                        scope: {
                            1: "keyword",
                            3: "title.class",
                            5: "keyword",
                            7: "title.class.inherited"
                        }
                    },
                    {
                        match: [
                            /class/,
                            /\s+/,
                            _
                        ],
                        scope: {
                            1: "keyword",
                            3: "title.class"
                        }
                    }
                ]
            }, D = {
                relevance: 0,
                match: c.either(/\bJSON/, /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/, /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/, /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/),
                className: "title.class",
                keywords: {
                    _: [
                        ...n,
                        ...i
                    ]
                }
            }, M = {
                variants: [
                    {
                        match: [
                            /function/,
                            /\s+/,
                            _,
                            /(?=\s*\()/
                        ]
                    },
                    {
                        match: [
                            /function/,
                            /\s*(?=\()/
                        ]
                    }
                ],
                className: {
                    1: "keyword",
                    3: "title.function"
                },
                label: "func.def",
                contains: [
                    A
                ],
                illegal: /%/
            };
            const L = {
                match: c.concat(/\b/, (x = [
                    ...r,
                    "super",
                    "import"
                ], c.concat("(?!", x.join("|"), ")")), _, c.lookahead(/\(/)),
                className: "title.function",
                relevance: 0
            };
            var x;
            const w = {
                begin: c.concat(/\./, c.lookahead(c.concat(_, /(?![0-9A-Za-z$_(])/))),
                end: _,
                excludeBegin: !0,
                keywords: "prototype",
                className: "property",
                relevance: 0
            }, P = {
                match: [
                    /get|set/,
                    /\s+/,
                    _,
                    /(?=\()/
                ],
                className: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    {
                        begin: /\(\)/
                    },
                    A
                ]
            }, k = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + l.UNDERSCORE_IDENT_RE + ")\\s*=>", U = {
                match: [
                    /const|var|let/,
                    /\s+/,
                    _,
                    /\s*/,
                    /=\s*/,
                    /(async\s*)?/,
                    c.lookahead(k)
                ],
                keywords: "async",
                className: {
                    1: "keyword",
                    3: "title.function"
                },
                contains: [
                    A
                ]
            };
            return {
                name: "JavaScript",
                aliases: [
                    "js",
                    "jsx",
                    "mjs",
                    "cjs"
                ],
                keywords: u,
                exports: {
                    PARAMS_CONTAINS: I,
                    CLASS_REFERENCE: D
                },
                illegal: /#(?![$_A-z])/,
                contains: [
                    l.SHEBANG({
                        label: "shebang",
                        binary: "node",
                        relevance: 5
                    }),
                    {
                        label: "use_strict",
                        className: "meta",
                        relevance: 10,
                        begin: /^\s*['"]use (strict|asm)['"]/
                    },
                    l.APOS_STRING_MODE,
                    l.QUOTE_STRING_MODE,
                    C,
                    f,
                    R,
                    N,
                    O,
                    {
                        match: /\$\d+/
                    },
                    b,
                    D,
                    {
                        className: "attr",
                        begin: _ + c.lookahead(":"),
                        relevance: 0
                    },
                    U,
                    {
                        begin: "(" + l.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
                        keywords: "return throw case",
                        relevance: 0,
                        contains: [
                            O,
                            l.REGEXP_MODE,
                            {
                                className: "function",
                                begin: k,
                                returnBegin: !0,
                                end: "\\s*=>",
                                contains: [
                                    {
                                        className: "params",
                                        variants: [
                                            {
                                                begin: l.UNDERSCORE_IDENT_RE,
                                                relevance: 0
                                            },
                                            {
                                                className: null,
                                                begin: /\(\s*\)/,
                                                skip: !0
                                            },
                                            {
                                                begin: /\(/,
                                                end: /\)/,
                                                excludeBegin: !0,
                                                excludeEnd: !0,
                                                keywords: u,
                                                contains: I
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                begin: /,/,
                                relevance: 0
                            },
                            {
                                match: /\s+/,
                                relevance: 0
                            },
                            {
                                variants: [
                                    {
                                        begin: d,
                                        end: m
                                    },
                                    {
                                        match: /<[A-Za-z0-9\\._:-]+\s*\/>/
                                    },
                                    {
                                        begin: p.begin,
                                        "on:begin": p.isTrulyOpeningTag,
                                        end: p.end
                                    }
                                ],
                                subLanguage: "xml",
                                contains: [
                                    {
                                        begin: p.begin,
                                        end: p.end,
                                        skip: !0,
                                        contains: [
                                            "self"
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    M,
                    {
                        beginKeywords: "while if switch catch for"
                    },
                    {
                        begin: "\\b(?!function)" + l.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
                        returnBegin: !0,
                        label: "func.def",
                        contains: [
                            A,
                            l.inherit(l.TITLE_MODE, {
                                begin: _,
                                className: "title.function"
                            })
                        ]
                    },
                    {
                        match: /\.\.\./,
                        relevance: 0
                    },
                    w,
                    {
                        match: "\\$" + _,
                        relevance: 0
                    },
                    {
                        match: [
                            /\bconstructor(?=\s*\()/
                        ],
                        className: {
                            1: "title.function"
                        },
                        contains: [
                            A
                        ]
                    },
                    L,
                    {
                        relevance: 0,
                        match: /\b[A-Z][A-Z_0-9]+\b/,
                        className: "variable.constant"
                    },
                    y,
                    P,
                    {
                        match: /\$[(.]/
                    }
                ]
            };
        }
        return zo = function(n) {
            const i = l(n), r = e, c = [
                "any",
                "void",
                "number",
                "boolean",
                "string",
                "object",
                "never",
                "symbol",
                "bigint",
                "unknown"
            ], _ = {
                beginKeywords: "namespace",
                end: /\{/,
                excludeEnd: !0,
                contains: [
                    i.exports.CLASS_REFERENCE
                ]
            }, d = {
                beginKeywords: "interface",
                end: /\{/,
                excludeEnd: !0,
                keywords: {
                    keyword: "interface extends",
                    built_in: c
                },
                contains: [
                    i.exports.CLASS_REFERENCE
                ]
            }, m = {
                $pattern: e,
                keyword: t.concat([
                    "type",
                    "namespace",
                    "interface",
                    "public",
                    "private",
                    "protected",
                    "implements",
                    "declare",
                    "abstract",
                    "readonly",
                    "enum",
                    "override"
                ]),
                literal: a,
                built_in: s.concat(c),
                "variable.language": o
            }, p = {
                className: "meta",
                begin: "@" + r
            }, u = (e, t, a)=>{
                const n = e.contains.findIndex((e)=>e.label === t);
                if (-1 === n) throw new Error("can not find mode to replace");
                e.contains.splice(n, 1, a);
            };
            return Object.assign(i.keywords, m), i.exports.PARAMS_CONTAINS.push(p), i.contains = i.contains.concat([
                p,
                _,
                d
            ]), u(i, "shebang", n.SHEBANG()), u(i, "use_strict", {
                className: "meta",
                relevance: 10,
                begin: /^\s*['"]use strict['"]/
            }), i.contains.find((e)=>"func.def" === e.label).relevance = 0, Object.assign(i, {
                name: "TypeScript",
                aliases: [
                    "ts",
                    "tsx",
                    "mts",
                    "cts"
                ]
            }), i;
        }, zo;
    }()), Cs.registerLanguage("vala", (Qo || (Qo = 1, Wo = function(e) {
        return {
            name: "Vala",
            keywords: {
                keyword: "char uchar unichar int uint long ulong short ushort int8 int16 int32 int64 uint8 uint16 uint32 uint64 float double bool struct enum string void weak unowned owned async signal static abstract interface override virtual delegate if while do for foreach else switch case break default return try catch public private protected internal using new this get set const stdout stdin stderr var",
                built_in: "DBus GLib CCode Gee Object Gtk Posix",
                literal: "false true null"
            },
            contains: [
                {
                    className: "class",
                    beginKeywords: "class interface namespace",
                    end: /\{/,
                    excludeEnd: !0,
                    illegal: "[^,:\\n\\s\\.]",
                    contains: [
                        e.UNDERSCORE_TITLE_MODE
                    ]
                },
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                {
                    className: "string",
                    begin: '"""',
                    end: '"""',
                    relevance: 5
                },
                e.APOS_STRING_MODE,
                e.QUOTE_STRING_MODE,
                e.C_NUMBER_MODE,
                {
                    className: "meta",
                    begin: "^#",
                    end: "$"
                }
            ]
        };
    }), Wo)), Cs.registerLanguage("vbnet", (jo || (jo = 1, Ko = function(e) {
        const t = e.regex, a = /\d{1,2}\/\d{1,2}\/\d{4}/, n = /\d{4}-\d{1,2}-\d{1,2}/, i = /(\d|1[012])(:\d+){0,2} *(AM|PM)/, r = /\d{1,2}(:\d{1,2}){1,2}/, o = {
            className: "literal",
            variants: [
                {
                    begin: t.concat(/# */, t.either(n, a), / *#/)
                },
                {
                    begin: t.concat(/# */, r, / *#/)
                },
                {
                    begin: t.concat(/# */, i, / *#/)
                },
                {
                    begin: t.concat(/# */, t.either(n, a), / +/, t.either(i, r), / *#/)
                }
            ]
        }, s = e.COMMENT(/'''/, /$/, {
            contains: [
                {
                    className: "doctag",
                    begin: /<\/?/,
                    end: />/
                }
            ]
        }), l = e.COMMENT(null, /$/, {
            variants: [
                {
                    begin: /'/
                },
                {
                    begin: /([\t ]|^)REM(?=\s)/
                }
            ]
        });
        return {
            name: "Visual Basic .NET",
            aliases: [
                "vb"
            ],
            case_insensitive: !0,
            classNameAliases: {
                label: "symbol"
            },
            keywords: {
                keyword: "addhandler alias aggregate ansi as async assembly auto binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into iterator join key let lib loop me mid module mustinherit mustoverride mybase myclass namespace narrowing new next notinheritable notoverridable of off on operator option optional order overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly yield",
                built_in: "addressof and andalso await directcast gettype getxmlnamespace is isfalse isnot istrue like mod nameof new not or orelse trycast typeof xor cbool cbyte cchar cdate cdbl cdec cint clng cobj csbyte cshort csng cstr cuint culng cushort",
                type: "boolean byte char date decimal double integer long object sbyte short single string uinteger ulong ushort",
                literal: "true false nothing"
            },
            illegal: "//|\\{|\\}|endif|gosub|variant|wend|^\\$ ",
            contains: [
                {
                    className: "string",
                    begin: /"(""|[^/n])"C\b/
                },
                {
                    className: "string",
                    begin: /"/,
                    end: /"/,
                    illegal: /\n/,
                    contains: [
                        {
                            begin: /""/
                        }
                    ]
                },
                o,
                {
                    className: "number",
                    relevance: 0,
                    variants: [
                        {
                            begin: /\b\d[\d_]*((\.[\d_]+(E[+-]?[\d_]+)?)|(E[+-]?[\d_]+))[RFD@!#]?/
                        },
                        {
                            begin: /\b\d[\d_]*((U?[SIL])|[%&])?/
                        },
                        {
                            begin: /&H[\dA-F_]+((U?[SIL])|[%&])?/
                        },
                        {
                            begin: /&O[0-7_]+((U?[SIL])|[%&])?/
                        },
                        {
                            begin: /&B[01_]+((U?[SIL])|[%&])?/
                        }
                    ]
                },
                {
                    className: "label",
                    begin: /^\w+:/
                },
                s,
                l,
                {
                    className: "meta",
                    begin: /[\t ]*#(const|disable|else|elseif|enable|end|externalsource|if|region)\b/,
                    end: /$/,
                    keywords: {
                        keyword: "const disable else elseif enable end externalsource if region then"
                    },
                    contains: [
                        l
                    ]
                }
            ]
        };
    }), Ko)), Cs.registerLanguage("vbscript", (Zo || (Zo = 1, Xo = function(e) {
        const t = e.regex, a = [
            "lcase",
            "month",
            "vartype",
            "instrrev",
            "ubound",
            "setlocale",
            "getobject",
            "rgb",
            "getref",
            "string",
            "weekdayname",
            "rnd",
            "dateadd",
            "monthname",
            "now",
            "day",
            "minute",
            "isarray",
            "cbool",
            "round",
            "formatcurrency",
            "conversions",
            "csng",
            "timevalue",
            "second",
            "year",
            "space",
            "abs",
            "clng",
            "timeserial",
            "fixs",
            "len",
            "asc",
            "isempty",
            "maths",
            "dateserial",
            "atn",
            "timer",
            "isobject",
            "filter",
            "weekday",
            "datevalue",
            "ccur",
            "isdate",
            "instr",
            "datediff",
            "formatdatetime",
            "replace",
            "isnull",
            "right",
            "sgn",
            "array",
            "snumeric",
            "log",
            "cdbl",
            "hex",
            "chr",
            "lbound",
            "msgbox",
            "ucase",
            "getlocale",
            "cos",
            "cdate",
            "cbyte",
            "rtrim",
            "join",
            "hour",
            "oct",
            "typename",
            "trim",
            "strcomp",
            "int",
            "createobject",
            "loadpicture",
            "tan",
            "formatnumber",
            "mid",
            "split",
            "cint",
            "sin",
            "datepart",
            "ltrim",
            "sqr",
            "time",
            "derived",
            "eval",
            "date",
            "formatpercent",
            "exp",
            "inputbox",
            "left",
            "ascw",
            "chrw",
            "regexp",
            "cstr",
            "err"
        ];
        return {
            name: "VBScript",
            aliases: [
                "vbs"
            ],
            case_insensitive: !0,
            keywords: {
                keyword: [
                    "call",
                    "class",
                    "const",
                    "dim",
                    "do",
                    "loop",
                    "erase",
                    "execute",
                    "executeglobal",
                    "exit",
                    "for",
                    "each",
                    "next",
                    "function",
                    "if",
                    "then",
                    "else",
                    "on",
                    "error",
                    "option",
                    "explicit",
                    "new",
                    "private",
                    "property",
                    "let",
                    "get",
                    "public",
                    "randomize",
                    "redim",
                    "rem",
                    "select",
                    "case",
                    "set",
                    "stop",
                    "sub",
                    "while",
                    "wend",
                    "with",
                    "end",
                    "to",
                    "elseif",
                    "is",
                    "or",
                    "xor",
                    "and",
                    "not",
                    "class_initialize",
                    "class_terminate",
                    "default",
                    "preserve",
                    "in",
                    "me",
                    "byval",
                    "byref",
                    "step",
                    "resume",
                    "goto"
                ],
                built_in: [
                    "server",
                    "response",
                    "request",
                    "scriptengine",
                    "scriptenginebuildversion",
                    "scriptengineminorversion",
                    "scriptenginemajorversion"
                ],
                literal: [
                    "true",
                    "false",
                    "null",
                    "nothing",
                    "empty"
                ]
            },
            illegal: "//",
            contains: [
                {
                    begin: t.concat(t.either(...a), "\\s*\\("),
                    relevance: 0,
                    keywords: {
                        built_in: a
                    }
                },
                e.inherit(e.QUOTE_STRING_MODE, {
                    contains: [
                        {
                            begin: '""'
                        }
                    ]
                }),
                e.COMMENT(/'/, /$/, {
                    relevance: 0
                }),
                e.C_NUMBER_MODE
            ]
        };
    }), Xo)), Cs.registerLanguage("vbscript-html", es ? Jo : (es = 1, Jo = function(e) {
        return {
            name: "VBScript in HTML",
            subLanguage: "xml",
            contains: [
                {
                    begin: "<%",
                    end: "%>",
                    subLanguage: "vbscript"
                }
            ]
        };
    })), Cs.registerLanguage("verilog", (as || (as = 1, ts = function(e) {
        const t = e.regex, a = [
            "begin_keywords",
            "celldefine",
            "default_nettype",
            "default_decay_time",
            "default_trireg_strength",
            "define",
            "delay_mode_distributed",
            "delay_mode_path",
            "delay_mode_unit",
            "delay_mode_zero",
            "else",
            "elsif",
            "end_keywords",
            "endcelldefine",
            "endif",
            "ifdef",
            "ifndef",
            "include",
            "line",
            "nounconnected_drive",
            "pragma",
            "resetall",
            "timescale",
            "unconnected_drive",
            "undef",
            "undefineall"
        ];
        return {
            name: "Verilog",
            aliases: [
                "v",
                "sv",
                "svh"
            ],
            case_insensitive: !1,
            keywords: {
                $pattern: /\$?[\w]+(\$[\w]+)*/,
                keyword: [
                    "accept_on",
                    "alias",
                    "always",
                    "always_comb",
                    "always_ff",
                    "always_latch",
                    "and",
                    "assert",
                    "assign",
                    "assume",
                    "automatic",
                    "before",
                    "begin",
                    "bind",
                    "bins",
                    "binsof",
                    "bit",
                    "break",
                    "buf|0",
                    "bufif0",
                    "bufif1",
                    "byte",
                    "case",
                    "casex",
                    "casez",
                    "cell",
                    "chandle",
                    "checker",
                    "class",
                    "clocking",
                    "cmos",
                    "config",
                    "const",
                    "constraint",
                    "context",
                    "continue",
                    "cover",
                    "covergroup",
                    "coverpoint",
                    "cross",
                    "deassign",
                    "default",
                    "defparam",
                    "design",
                    "disable",
                    "dist",
                    "do",
                    "edge",
                    "else",
                    "end",
                    "endcase",
                    "endchecker",
                    "endclass",
                    "endclocking",
                    "endconfig",
                    "endfunction",
                    "endgenerate",
                    "endgroup",
                    "endinterface",
                    "endmodule",
                    "endpackage",
                    "endprimitive",
                    "endprogram",
                    "endproperty",
                    "endspecify",
                    "endsequence",
                    "endtable",
                    "endtask",
                    "enum",
                    "event",
                    "eventually",
                    "expect",
                    "export",
                    "extends",
                    "extern",
                    "final",
                    "first_match",
                    "for",
                    "force",
                    "foreach",
                    "forever",
                    "fork",
                    "forkjoin",
                    "function",
                    "generate|5",
                    "genvar",
                    "global",
                    "highz0",
                    "highz1",
                    "if",
                    "iff",
                    "ifnone",
                    "ignore_bins",
                    "illegal_bins",
                    "implements",
                    "implies",
                    "import",
                    "incdir",
                    "include",
                    "initial",
                    "inout",
                    "input",
                    "inside",
                    "instance",
                    "int",
                    "integer",
                    "interconnect",
                    "interface",
                    "intersect",
                    "join",
                    "join_any",
                    "join_none",
                    "large",
                    "let",
                    "liblist",
                    "library",
                    "local",
                    "localparam",
                    "logic",
                    "longint",
                    "macromodule",
                    "matches",
                    "medium",
                    "modport",
                    "module",
                    "nand",
                    "negedge",
                    "nettype",
                    "new",
                    "nexttime",
                    "nmos",
                    "nor",
                    "noshowcancelled",
                    "not",
                    "notif0",
                    "notif1",
                    "or",
                    "output",
                    "package",
                    "packed",
                    "parameter",
                    "pmos",
                    "posedge",
                    "primitive",
                    "priority",
                    "program",
                    "property",
                    "protected",
                    "pull0",
                    "pull1",
                    "pulldown",
                    "pullup",
                    "pulsestyle_ondetect",
                    "pulsestyle_onevent",
                    "pure",
                    "rand",
                    "randc",
                    "randcase",
                    "randsequence",
                    "rcmos",
                    "real",
                    "realtime",
                    "ref",
                    "reg",
                    "reject_on",
                    "release",
                    "repeat",
                    "restrict",
                    "return",
                    "rnmos",
                    "rpmos",
                    "rtran",
                    "rtranif0",
                    "rtranif1",
                    "s_always",
                    "s_eventually",
                    "s_nexttime",
                    "s_until",
                    "s_until_with",
                    "scalared",
                    "sequence",
                    "shortint",
                    "shortreal",
                    "showcancelled",
                    "signed",
                    "small",
                    "soft",
                    "solve",
                    "specify",
                    "specparam",
                    "static",
                    "string",
                    "strong",
                    "strong0",
                    "strong1",
                    "struct",
                    "super",
                    "supply0",
                    "supply1",
                    "sync_accept_on",
                    "sync_reject_on",
                    "table",
                    "tagged",
                    "task",
                    "this",
                    "throughout",
                    "time",
                    "timeprecision",
                    "timeunit",
                    "tran",
                    "tranif0",
                    "tranif1",
                    "tri",
                    "tri0",
                    "tri1",
                    "triand",
                    "trior",
                    "trireg",
                    "type",
                    "typedef",
                    "union",
                    "unique",
                    "unique0",
                    "unsigned",
                    "until",
                    "until_with",
                    "untyped",
                    "use",
                    "uwire",
                    "var",
                    "vectored",
                    "virtual",
                    "void",
                    "wait",
                    "wait_order",
                    "wand",
                    "weak",
                    "weak0",
                    "weak1",
                    "while",
                    "wildcard",
                    "wire",
                    "with",
                    "within",
                    "wor",
                    "xnor",
                    "xor"
                ],
                literal: [
                    "null"
                ],
                built_in: [
                    "$finish",
                    "$stop",
                    "$exit",
                    "$fatal",
                    "$error",
                    "$warning",
                    "$info",
                    "$realtime",
                    "$time",
                    "$printtimescale",
                    "$bitstoreal",
                    "$bitstoshortreal",
                    "$itor",
                    "$signed",
                    "$cast",
                    "$bits",
                    "$stime",
                    "$timeformat",
                    "$realtobits",
                    "$shortrealtobits",
                    "$rtoi",
                    "$unsigned",
                    "$asserton",
                    "$assertkill",
                    "$assertpasson",
                    "$assertfailon",
                    "$assertnonvacuouson",
                    "$assertoff",
                    "$assertcontrol",
                    "$assertpassoff",
                    "$assertfailoff",
                    "$assertvacuousoff",
                    "$isunbounded",
                    "$sampled",
                    "$fell",
                    "$changed",
                    "$past_gclk",
                    "$fell_gclk",
                    "$changed_gclk",
                    "$rising_gclk",
                    "$steady_gclk",
                    "$coverage_control",
                    "$coverage_get",
                    "$coverage_save",
                    "$set_coverage_db_name",
                    "$rose",
                    "$stable",
                    "$past",
                    "$rose_gclk",
                    "$stable_gclk",
                    "$future_gclk",
                    "$falling_gclk",
                    "$changing_gclk",
                    "$display",
                    "$coverage_get_max",
                    "$coverage_merge",
                    "$get_coverage",
                    "$load_coverage_db",
                    "$typename",
                    "$unpacked_dimensions",
                    "$left",
                    "$low",
                    "$increment",
                    "$clog2",
                    "$ln",
                    "$log10",
                    "$exp",
                    "$sqrt",
                    "$pow",
                    "$floor",
                    "$ceil",
                    "$sin",
                    "$cos",
                    "$tan",
                    "$countbits",
                    "$onehot",
                    "$isunknown",
                    "$fatal",
                    "$warning",
                    "$dimensions",
                    "$right",
                    "$high",
                    "$size",
                    "$asin",
                    "$acos",
                    "$atan",
                    "$atan2",
                    "$hypot",
                    "$sinh",
                    "$cosh",
                    "$tanh",
                    "$asinh",
                    "$acosh",
                    "$atanh",
                    "$countones",
                    "$onehot0",
                    "$error",
                    "$info",
                    "$random",
                    "$dist_chi_square",
                    "$dist_erlang",
                    "$dist_exponential",
                    "$dist_normal",
                    "$dist_poisson",
                    "$dist_t",
                    "$dist_uniform",
                    "$q_initialize",
                    "$q_remove",
                    "$q_exam",
                    "$async$and$array",
                    "$async$nand$array",
                    "$async$or$array",
                    "$async$nor$array",
                    "$sync$and$array",
                    "$sync$nand$array",
                    "$sync$or$array",
                    "$sync$nor$array",
                    "$q_add",
                    "$q_full",
                    "$psprintf",
                    "$async$and$plane",
                    "$async$nand$plane",
                    "$async$or$plane",
                    "$async$nor$plane",
                    "$sync$and$plane",
                    "$sync$nand$plane",
                    "$sync$or$plane",
                    "$sync$nor$plane",
                    "$system",
                    "$display",
                    "$displayb",
                    "$displayh",
                    "$displayo",
                    "$strobe",
                    "$strobeb",
                    "$strobeh",
                    "$strobeo",
                    "$write",
                    "$readmemb",
                    "$readmemh",
                    "$writememh",
                    "$value$plusargs",
                    "$dumpvars",
                    "$dumpon",
                    "$dumplimit",
                    "$dumpports",
                    "$dumpportson",
                    "$dumpportslimit",
                    "$writeb",
                    "$writeh",
                    "$writeo",
                    "$monitor",
                    "$monitorb",
                    "$monitorh",
                    "$monitoro",
                    "$writememb",
                    "$dumpfile",
                    "$dumpoff",
                    "$dumpall",
                    "$dumpflush",
                    "$dumpportsoff",
                    "$dumpportsall",
                    "$dumpportsflush",
                    "$fclose",
                    "$fdisplay",
                    "$fdisplayb",
                    "$fdisplayh",
                    "$fdisplayo",
                    "$fstrobe",
                    "$fstrobeb",
                    "$fstrobeh",
                    "$fstrobeo",
                    "$swrite",
                    "$swriteb",
                    "$swriteh",
                    "$swriteo",
                    "$fscanf",
                    "$fread",
                    "$fseek",
                    "$fflush",
                    "$feof",
                    "$fopen",
                    "$fwrite",
                    "$fwriteb",
                    "$fwriteh",
                    "$fwriteo",
                    "$fmonitor",
                    "$fmonitorb",
                    "$fmonitorh",
                    "$fmonitoro",
                    "$sformat",
                    "$sformatf",
                    "$fgetc",
                    "$ungetc",
                    "$fgets",
                    "$sscanf",
                    "$rewind",
                    "$ftell",
                    "$ferror"
                ]
            },
            contains: [
                e.C_BLOCK_COMMENT_MODE,
                e.C_LINE_COMMENT_MODE,
                e.QUOTE_STRING_MODE,
                {
                    scope: "number",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ],
                    variants: [
                        {
                            begin: /\b((\d+'([bhodBHOD]))[0-9xzXZa-fA-F_]+)/
                        },
                        {
                            begin: /\B(('([bhodBHOD]))[0-9xzXZa-fA-F_]+)/
                        },
                        {
                            begin: /\b[0-9][0-9_]*/,
                            relevance: 0
                        }
                    ]
                },
                {
                    scope: "variable",
                    variants: [
                        {
                            begin: "#\\((?!parameter).+\\)"
                        },
                        {
                            begin: "\\.\\w+",
                            relevance: 0
                        }
                    ]
                },
                {
                    scope: "variable.constant",
                    match: t.concat(/`/, t.either("__FILE__", "__LINE__"))
                },
                {
                    scope: "meta",
                    begin: t.concat(/`/, t.either(...a)),
                    end: /$|\/\/|\/\*/,
                    returnEnd: !0,
                    keywords: a
                }
            ]
        };
    }), ts)), Cs.registerLanguage("vhdl", (is || (is = 1, ns = function(e) {
        const t = "\\d(_|\\d)*", a = "[eE][-+]?" + t, n = "\\b(" + t + "#\\w+(\\.\\w+)?#(" + a + ")?|" + t + "(\\." + t + ")?(" + a + ")?)";
        return {
            name: "VHDL",
            case_insensitive: !0,
            keywords: {
                keyword: [
                    "abs",
                    "access",
                    "after",
                    "alias",
                    "all",
                    "and",
                    "architecture",
                    "array",
                    "assert",
                    "assume",
                    "assume_guarantee",
                    "attribute",
                    "begin",
                    "block",
                    "body",
                    "buffer",
                    "bus",
                    "case",
                    "component",
                    "configuration",
                    "constant",
                    "context",
                    "cover",
                    "disconnect",
                    "downto",
                    "default",
                    "else",
                    "elsif",
                    "end",
                    "entity",
                    "exit",
                    "fairness",
                    "file",
                    "for",
                    "force",
                    "function",
                    "generate",
                    "generic",
                    "group",
                    "guarded",
                    "if",
                    "impure",
                    "in",
                    "inertial",
                    "inout",
                    "is",
                    "label",
                    "library",
                    "linkage",
                    "literal",
                    "loop",
                    "map",
                    "mod",
                    "nand",
                    "new",
                    "next",
                    "nor",
                    "not",
                    "null",
                    "of",
                    "on",
                    "open",
                    "or",
                    "others",
                    "out",
                    "package",
                    "parameter",
                    "port",
                    "postponed",
                    "procedure",
                    "process",
                    "property",
                    "protected",
                    "pure",
                    "range",
                    "record",
                    "register",
                    "reject",
                    "release",
                    "rem",
                    "report",
                    "restrict",
                    "restrict_guarantee",
                    "return",
                    "rol",
                    "ror",
                    "select",
                    "sequence",
                    "severity",
                    "shared",
                    "signal",
                    "sla",
                    "sll",
                    "sra",
                    "srl",
                    "strong",
                    "subtype",
                    "then",
                    "to",
                    "transport",
                    "type",
                    "unaffected",
                    "units",
                    "until",
                    "use",
                    "variable",
                    "view",
                    "vmode",
                    "vprop",
                    "vunit",
                    "wait",
                    "when",
                    "while",
                    "with",
                    "xnor",
                    "xor"
                ],
                built_in: [
                    "boolean",
                    "bit",
                    "character",
                    "integer",
                    "time",
                    "delay_length",
                    "natural",
                    "positive",
                    "string",
                    "bit_vector",
                    "file_open_kind",
                    "file_open_status",
                    "std_logic",
                    "std_logic_vector",
                    "unsigned",
                    "signed",
                    "boolean_vector",
                    "integer_vector",
                    "std_ulogic",
                    "std_ulogic_vector",
                    "unresolved_unsigned",
                    "u_unsigned",
                    "unresolved_signed",
                    "u_signed",
                    "real_vector",
                    "time_vector"
                ],
                literal: [
                    "false",
                    "true",
                    "note",
                    "warning",
                    "error",
                    "failure",
                    "line",
                    "text",
                    "side",
                    "width"
                ]
            },
            illegal: /\{/,
            contains: [
                e.C_BLOCK_COMMENT_MODE,
                e.COMMENT("--", "$"),
                e.QUOTE_STRING_MODE,
                {
                    className: "number",
                    begin: n,
                    relevance: 0
                },
                {
                    className: "string",
                    begin: "'(U|X|0|1|Z|W|L|H|-)'",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    className: "symbol",
                    begin: "'[A-Za-z](_?[A-Za-z0-9])*",
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                }
            ]
        };
    }), ns)), Cs.registerLanguage("vim", (os || (os = 1, rs = function(e) {
        return {
            name: "Vim Script",
            keywords: {
                $pattern: /[!#@\w]+/,
                keyword: "N|0 P|0 X|0 a|0 ab abc abo al am an|0 ar arga argd arge argdo argg argl argu as au aug aun b|0 bN ba bad bd be bel bf bl bm bn bo bp br brea breaka breakd breakl bro bufdo buffers bun bw c|0 cN cNf ca cabc caddb cad caddf cal cat cb cc ccl cd ce cex cf cfir cgetb cgete cg changes chd che checkt cl cla clo cm cmapc cme cn cnew cnf cno cnorea cnoreme co col colo com comc comp con conf cope cp cpf cq cr cs cst cu cuna cunme cw delm deb debugg delc delf dif diffg diffo diffp diffpu diffs diffthis dig di dl dell dj dli do doautoa dp dr ds dsp e|0 ea ec echoe echoh echom echon el elsei em en endfo endf endt endw ene ex exe exi exu f|0 files filet fin fina fini fir fix fo foldc foldd folddoc foldo for fu go gr grepa gu gv ha helpf helpg helpt hi hid his ia iabc if ij il im imapc ime ino inorea inoreme int is isp iu iuna iunme j|0 ju k|0 keepa kee keepj lN lNf l|0 lad laddb laddf la lan lat lb lc lch lcl lcs le lefta let lex lf lfir lgetb lgete lg lgr lgrepa lh ll lla lli lmak lm lmapc lne lnew lnf ln loadk lo loc lockv lol lope lp lpf lr ls lt lu lua luad luaf lv lvimgrepa lw m|0 ma mak map mapc marks mat me menut mes mk mks mksp mkv mkvie mod mz mzf nbc nb nbs new nm nmapc nme nn nnoreme noa no noh norea noreme norm nu nun nunme ol o|0 om omapc ome on ono onoreme opt ou ounme ow p|0 profd prof pro promptr pc ped pe perld po popu pp pre prev ps pt ptN ptf ptj ptl ptn ptp ptr pts pu pw py3 python3 py3d py3f py pyd pyf quita qa rec red redi redr redraws reg res ret retu rew ri rightb rub rubyd rubyf rund ru rv sN san sa sal sav sb sbN sba sbf sbl sbm sbn sbp sbr scrip scripte scs se setf setg setl sf sfir sh sim sig sil sl sla sm smap smapc sme sn sni sno snor snoreme sor so spelld spe spelli spellr spellu spellw sp spr sre st sta startg startr star stopi stj sts sun sunm sunme sus sv sw sy synti sync tN tabN tabc tabdo tabe tabf tabfir tabl tabm tabnew tabn tabo tabp tabr tabs tab ta tags tc tcld tclf te tf th tj tl tm tn to tp tr try ts tu u|0 undoj undol una unh unl unlo unm unme uns up ve verb vert vim vimgrepa vi viu vie vm vmapc vme vne vn vnoreme vs vu vunme windo w|0 wN wa wh wi winc winp wn wp wq wqa ws wu wv x|0 xa xmapc xm xme xn xnoreme xu xunme y|0 z|0 ~ Next Print append abbreviate abclear aboveleft all amenu anoremenu args argadd argdelete argedit argglobal arglocal argument ascii autocmd augroup aunmenu buffer bNext ball badd bdelete behave belowright bfirst blast bmodified bnext botright bprevious brewind break breakadd breakdel breaklist browse bunload bwipeout change cNext cNfile cabbrev cabclear caddbuffer caddexpr caddfile call catch cbuffer cclose center cexpr cfile cfirst cgetbuffer cgetexpr cgetfile chdir checkpath checktime clist clast close cmap cmapclear cmenu cnext cnewer cnfile cnoremap cnoreabbrev cnoremenu copy colder colorscheme command comclear compiler continue confirm copen cprevious cpfile cquit crewind cscope cstag cunmap cunabbrev cunmenu cwindow delete delmarks debug debuggreedy delcommand delfunction diffupdate diffget diffoff diffpatch diffput diffsplit digraphs display deletel djump dlist doautocmd doautoall deletep drop dsearch dsplit edit earlier echo echoerr echohl echomsg else elseif emenu endif endfor endfunction endtry endwhile enew execute exit exusage file filetype find finally finish first fixdel fold foldclose folddoopen folddoclosed foldopen function global goto grep grepadd gui gvim hardcopy help helpfind helpgrep helptags highlight hide history insert iabbrev iabclear ijump ilist imap imapclear imenu inoremap inoreabbrev inoremenu intro isearch isplit iunmap iunabbrev iunmenu join jumps keepalt keepmarks keepjumps lNext lNfile list laddexpr laddbuffer laddfile last language later lbuffer lcd lchdir lclose lcscope left leftabove lexpr lfile lfirst lgetbuffer lgetexpr lgetfile lgrep lgrepadd lhelpgrep llast llist lmake lmap lmapclear lnext lnewer lnfile lnoremap loadkeymap loadview lockmarks lockvar lolder lopen lprevious lpfile lrewind ltag lunmap luado luafile lvimgrep lvimgrepadd lwindow move mark make mapclear match menu menutranslate messages mkexrc mksession mkspell mkvimrc mkview mode mzscheme mzfile nbclose nbkey nbsart next nmap nmapclear nmenu nnoremap nnoremenu noautocmd noremap nohlsearch noreabbrev noremenu normal number nunmap nunmenu oldfiles open omap omapclear omenu only onoremap onoremenu options ounmap ounmenu ownsyntax print profdel profile promptfind promptrepl pclose pedit perl perldo pop popup ppop preserve previous psearch ptag ptNext ptfirst ptjump ptlast ptnext ptprevious ptrewind ptselect put pwd py3do py3file python pydo pyfile quit quitall qall read recover redo redir redraw redrawstatus registers resize retab return rewind right rightbelow ruby rubydo rubyfile rundo runtime rviminfo substitute sNext sandbox sargument sall saveas sbuffer sbNext sball sbfirst sblast sbmodified sbnext sbprevious sbrewind scriptnames scriptencoding scscope set setfiletype setglobal setlocal sfind sfirst shell simalt sign silent sleep slast smagic smapclear smenu snext sniff snomagic snoremap snoremenu sort source spelldump spellgood spellinfo spellrepall spellundo spellwrong split sprevious srewind stop stag startgreplace startreplace startinsert stopinsert stjump stselect sunhide sunmap sunmenu suspend sview swapname syntax syntime syncbind tNext tabNext tabclose tabedit tabfind tabfirst tablast tabmove tabnext tabonly tabprevious tabrewind tag tcl tcldo tclfile tearoff tfirst throw tjump tlast tmenu tnext topleft tprevious trewind tselect tunmenu undo undojoin undolist unabbreviate unhide unlet unlockvar unmap unmenu unsilent update vglobal version verbose vertical vimgrep vimgrepadd visual viusage view vmap vmapclear vmenu vnew vnoremap vnoremenu vsplit vunmap vunmenu write wNext wall while winsize wincmd winpos wnext wprevious wqall wsverb wundo wviminfo xit xall xmapclear xmap xmenu xnoremap xnoremenu xunmap xunmenu yank",
                built_in: "synIDtrans atan2 range matcharg did_filetype asin feedkeys xor argv complete_check add getwinposx getqflist getwinposy screencol clearmatches empty extend getcmdpos mzeval garbagecollect setreg ceil sqrt diff_hlID inputsecret get getfperm getpid filewritable shiftwidth max sinh isdirectory synID system inputrestore winline atan visualmode inputlist tabpagewinnr round getregtype mapcheck hasmapto histdel argidx findfile sha256 exists toupper getcmdline taglist string getmatches bufnr strftime winwidth bufexists strtrans tabpagebuflist setcmdpos remote_read printf setloclist getpos getline bufwinnr float2nr len getcmdtype diff_filler luaeval resolve libcallnr foldclosedend reverse filter has_key bufname str2float strlen setline getcharmod setbufvar index searchpos shellescape undofile foldclosed setqflist buflisted strchars str2nr virtcol floor remove undotree remote_expr winheight gettabwinvar reltime cursor tabpagenr finddir localtime acos getloclist search tanh matchend rename gettabvar strdisplaywidth type abs py3eval setwinvar tolower wildmenumode log10 spellsuggest bufloaded synconcealed nextnonblank server2client complete settabwinvar executable input wincol setmatches getftype hlID inputsave searchpair or screenrow line settabvar histadd deepcopy strpart remote_peek and eval getftime submatch screenchar winsaveview matchadd mkdir screenattr getfontname libcall reltimestr getfsize winnr invert pow getbufline byte2line soundfold repeat fnameescape tagfiles sin strwidth spellbadword trunc maparg log lispindent hostname setpos globpath remote_foreground getchar synIDattr fnamemodify cscope_connection stridx winbufnr indent min complete_add nr2char searchpairpos inputdialog values matchlist items hlexists strridx browsedir expand fmod pathshorten line2byte argc count getwinvar glob foldtextresult getreg foreground cosh matchdelete has char2nr simplify histget searchdecl iconv winrestcmd pumvisible writefile foldlevel haslocaldir keys cos matchstr foldtext histnr tan tempname getcwd byteidx getbufvar islocked escape eventhandler remote_send serverlist winrestview synstack pyeval prevnonblank readfile cindent filereadable changenr exp"
            },
            illegal: /;/,
            contains: [
                e.NUMBER_MODE,
                {
                    className: "string",
                    begin: "'",
                    end: "'",
                    illegal: "\\n"
                },
                {
                    className: "string",
                    begin: /"(\\"|\n\\|[^"\n])*"/
                },
                e.COMMENT('"', "$"),
                {
                    className: "variable",
                    begin: /[bwtglsav]:[\w\d_]+/
                },
                {
                    begin: [
                        /\b(?:function|function!)/,
                        /\s+/,
                        e.IDENT_RE
                    ],
                    className: {
                        1: "keyword",
                        3: "title"
                    },
                    end: "$",
                    relevance: 0,
                    contains: [
                        {
                            className: "params",
                            begin: "\\(",
                            end: "\\)"
                        }
                    ]
                },
                {
                    className: "symbol",
                    begin: /<[\w-]+>/
                }
            ]
        };
    }), rs)), Cs.registerLanguage("wasm", (ls || (ls = 1, ss = function(e) {
        e.regex;
        const t = e.COMMENT(/\(;/, /;\)/);
        return t.contains.push("self"), {
            name: "WebAssembly",
            keywords: {
                $pattern: /[\w.]+/,
                keyword: [
                    "anyfunc",
                    "block",
                    "br",
                    "br_if",
                    "br_table",
                    "call",
                    "call_indirect",
                    "data",
                    "drop",
                    "elem",
                    "else",
                    "end",
                    "export",
                    "func",
                    "global.get",
                    "global.set",
                    "local.get",
                    "local.set",
                    "local.tee",
                    "get_global",
                    "get_local",
                    "global",
                    "if",
                    "import",
                    "local",
                    "loop",
                    "memory",
                    "memory.grow",
                    "memory.size",
                    "module",
                    "mut",
                    "nop",
                    "offset",
                    "param",
                    "result",
                    "return",
                    "select",
                    "set_global",
                    "set_local",
                    "start",
                    "table",
                    "tee_local",
                    "then",
                    "type",
                    "unreachable"
                ]
            },
            contains: [
                e.COMMENT(/;;/, /$/),
                t,
                {
                    match: [
                        /(?:offset|align)/,
                        /\s*/,
                        /=/
                    ],
                    className: {
                        1: "keyword",
                        3: "operator"
                    }
                },
                {
                    className: "variable",
                    begin: /\$[\w_]+/
                },
                {
                    match: /(\((?!;)|\))+/,
                    className: "punctuation",
                    relevance: 0
                },
                {
                    begin: [
                        /(?:func|call|call_indirect)/,
                        /\s+/,
                        /\$[^\s)]+/
                    ],
                    className: {
                        1: "keyword",
                        3: "title.function"
                    }
                },
                e.QUOTE_STRING_MODE,
                {
                    match: /(i32|i64|f32|f64)(?!\.)/,
                    className: "type"
                },
                {
                    className: "keyword",
                    match: /\b(f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|nearest|neg?|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|store(?:8|16|32)?|sqrt|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))\b/
                },
                {
                    className: "number",
                    relevance: 0,
                    match: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/
                }
            ]
        };
    }), ss)), Cs.registerLanguage("wren", (_s || (_s = 1, cs = function(e) {
        const t = e.regex, a = /[a-zA-Z]\w*/, n = [
            "as",
            "break",
            "class",
            "construct",
            "continue",
            "else",
            "for",
            "foreign",
            "if",
            "import",
            "in",
            "is",
            "return",
            "static",
            "var",
            "while"
        ], i = [
            "true",
            "false",
            "null"
        ], r = [
            "this",
            "super"
        ], o = [
            "-",
            "~",
            /\*/,
            "%",
            /\.\.\./,
            /\.\./,
            /\+/,
            "<<",
            ">>",
            ">=",
            "<=",
            "<",
            ">",
            /\^/,
            /!=/,
            /!/,
            /\bis\b/,
            "==",
            "&&",
            "&",
            /\|\|/,
            /\|/,
            /\?:/,
            "="
        ], s = {
            relevance: 0,
            match: t.concat(/\b(?!(if|while|for|else|super)\b)/, a, /(?=\s*[({])/),
            className: "title.function"
        }, l = {
            match: t.concat(t.either(t.concat(/\b(?!(if|while|for|else|super)\b)/, a), t.either(...o)), /(?=\s*\([^)]+\)\s*\{)/),
            className: "title.function",
            starts: {
                contains: [
                    {
                        begin: /\(/,
                        end: /\)/,
                        contains: [
                            {
                                relevance: 0,
                                scope: "params",
                                match: a
                            }
                        ]
                    }
                ]
            }
        }, c = {
            variants: [
                {
                    match: [
                        /class\s+/,
                        a,
                        /\s+is\s+/,
                        a
                    ]
                },
                {
                    match: [
                        /class\s+/,
                        a
                    ]
                }
            ],
            scope: {
                2: "title.class",
                4: "title.class.inherited"
            },
            keywords: n
        }, _ = {
            relevance: 0,
            match: t.either(...o),
            className: "operator"
        }, d = {
            className: "property",
            begin: t.concat(/\./, t.lookahead(a)),
            end: a,
            excludeBegin: !0,
            relevance: 0
        }, m = {
            relevance: 0,
            match: t.concat(/\b_/, a),
            scope: "variable"
        }, p = {
            relevance: 0,
            match: /\b[A-Z]+[a-z]+([A-Z]+[a-z]+)*/,
            scope: "title.class",
            keywords: {
                _: [
                    "Bool",
                    "Class",
                    "Fiber",
                    "Fn",
                    "List",
                    "Map",
                    "Null",
                    "Num",
                    "Object",
                    "Range",
                    "Sequence",
                    "String",
                    "System"
                ]
            }
        }, u = e.C_NUMBER_MODE, g = {
            match: [
                a,
                /\s*/,
                /=/,
                /\s*/,
                /\(/,
                a,
                /\)\s*\{/
            ],
            scope: {
                1: "title.function",
                3: "operator",
                6: "params"
            }
        }, E = e.COMMENT(/\/\*\*/, /\*\//, {
            contains: [
                {
                    match: /@[a-z]+/,
                    scope: "doctag"
                },
                "self"
            ]
        }), S = {
            scope: "subst",
            begin: /%\(/,
            end: /\)/,
            contains: [
                u,
                p,
                s,
                m,
                _
            ]
        }, b = {
            scope: "string",
            begin: /"/,
            end: /"/,
            contains: [
                S,
                {
                    scope: "char.escape",
                    variants: [
                        {
                            match: /\\\\|\\["0%abefnrtv]/
                        },
                        {
                            match: /\\x[0-9A-F]{2}/
                        },
                        {
                            match: /\\u[0-9A-F]{4}/
                        },
                        {
                            match: /\\U[0-9A-F]{8}/
                        }
                    ]
                }
            ]
        };
        S.contains.push(b);
        const T = [
            ...n,
            ...r,
            ...i
        ], C = {
            relevance: 0,
            match: t.concat("\\b(?!", T.join("|"), "\\b)", /[a-zA-Z_]\w*(?:[?!]|\b)/),
            className: "variable"
        };
        return {
            name: "Wren",
            keywords: {
                keyword: n,
                "variable.language": r,
                literal: i
            },
            contains: [
                {
                    scope: "comment",
                    variants: [
                        {
                            begin: [
                                /#!?/,
                                /[A-Za-z_]+(?=\()/
                            ],
                            beginScope: {},
                            keywords: {
                                literal: i
                            },
                            contains: [],
                            end: /\)/
                        },
                        {
                            begin: [
                                /#!?/,
                                /[A-Za-z_]+/
                            ],
                            beginScope: {},
                            end: /$/
                        }
                    ]
                },
                u,
                b,
                {
                    className: "string",
                    begin: /"""/,
                    end: /"""/
                },
                E,
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                p,
                c,
                g,
                l,
                s,
                _,
                m,
                d,
                C
            ]
        };
    }), cs)), Cs.registerLanguage("x86asm", (ms || (ms = 1, ds = function(e) {
        return {
            name: "Intel x86 Assembly",
            case_insensitive: !0,
            keywords: {
                $pattern: "[.%]?" + e.IDENT_RE,
                keyword: "lock rep repe repz repne repnz xaquire xrelease bnd nobnd aaa aad aam aas adc add and arpl bb0_reset bb1_reset bound bsf bsr bswap bt btc btr bts call cbw cdq cdqe clc cld cli clts cmc cmp cmpsb cmpsd cmpsq cmpsw cmpxchg cmpxchg486 cmpxchg8b cmpxchg16b cpuid cpu_read cpu_write cqo cwd cwde daa das dec div dmint emms enter equ f2xm1 fabs fadd faddp fbld fbstp fchs fclex fcmovb fcmovbe fcmove fcmovnb fcmovnbe fcmovne fcmovnu fcmovu fcom fcomi fcomip fcomp fcompp fcos fdecstp fdisi fdiv fdivp fdivr fdivrp femms feni ffree ffreep fiadd ficom ficomp fidiv fidivr fild fimul fincstp finit fist fistp fisttp fisub fisubr fld fld1 fldcw fldenv fldl2e fldl2t fldlg2 fldln2 fldpi fldz fmul fmulp fnclex fndisi fneni fninit fnop fnsave fnstcw fnstenv fnstsw fpatan fprem fprem1 fptan frndint frstor fsave fscale fsetpm fsin fsincos fsqrt fst fstcw fstenv fstp fstsw fsub fsubp fsubr fsubrp ftst fucom fucomi fucomip fucomp fucompp fxam fxch fxtract fyl2x fyl2xp1 hlt ibts icebp idiv imul in inc incbin insb insd insw int int01 int1 int03 int3 into invd invpcid invlpg invlpga iret iretd iretq iretw jcxz jecxz jrcxz jmp jmpe lahf lar lds lea leave les lfence lfs lgdt lgs lidt lldt lmsw loadall loadall286 lodsb lodsd lodsq lodsw loop loope loopne loopnz loopz lsl lss ltr mfence monitor mov movd movq movsb movsd movsq movsw movsx movsxd movzx mul mwait neg nop not or out outsb outsd outsw packssdw packsswb packuswb paddb paddd paddsb paddsiw paddsw paddusb paddusw paddw pand pandn pause paveb pavgusb pcmpeqb pcmpeqd pcmpeqw pcmpgtb pcmpgtd pcmpgtw pdistib pf2id pfacc pfadd pfcmpeq pfcmpge pfcmpgt pfmax pfmin pfmul pfrcp pfrcpit1 pfrcpit2 pfrsqit1 pfrsqrt pfsub pfsubr pi2fd pmachriw pmaddwd pmagw pmulhriw pmulhrwa pmulhrwc pmulhw pmullw pmvgezb pmvlzb pmvnzb pmvzb pop popa popad popaw popf popfd popfq popfw por prefetch prefetchw pslld psllq psllw psrad psraw psrld psrlq psrlw psubb psubd psubsb psubsiw psubsw psubusb psubusw psubw punpckhbw punpckhdq punpckhwd punpcklbw punpckldq punpcklwd push pusha pushad pushaw pushf pushfd pushfq pushfw pxor rcl rcr rdshr rdmsr rdpmc rdtsc rdtscp ret retf retn rol ror rdm rsdc rsldt rsm rsts sahf sal salc sar sbb scasb scasd scasq scasw sfence sgdt shl shld shr shrd sidt sldt skinit smi smint smintold smsw stc std sti stosb stosd stosq stosw str sub svdc svldt svts swapgs syscall sysenter sysexit sysret test ud0 ud1 ud2b ud2 ud2a umov verr verw fwait wbinvd wrshr wrmsr xadd xbts xchg xlatb xlat xor cmove cmovz cmovne cmovnz cmova cmovnbe cmovae cmovnb cmovb cmovnae cmovbe cmovna cmovg cmovnle cmovge cmovnl cmovl cmovnge cmovle cmovng cmovc cmovnc cmovo cmovno cmovs cmovns cmovp cmovpe cmovnp cmovpo je jz jne jnz ja jnbe jae jnb jb jnae jbe jna jg jnle jge jnl jl jnge jle jng jc jnc jo jno js jns jpo jnp jpe jp sete setz setne setnz seta setnbe setae setnb setnc setb setnae setcset setbe setna setg setnle setge setnl setl setnge setle setng sets setns seto setno setpe setp setpo setnp addps addss andnps andps cmpeqps cmpeqss cmpleps cmpless cmpltps cmpltss cmpneqps cmpneqss cmpnleps cmpnless cmpnltps cmpnltss cmpordps cmpordss cmpunordps cmpunordss cmpps cmpss comiss cvtpi2ps cvtps2pi cvtsi2ss cvtss2si cvttps2pi cvttss2si divps divss ldmxcsr maxps maxss minps minss movaps movhps movlhps movlps movhlps movmskps movntps movss movups mulps mulss orps rcpps rcpss rsqrtps rsqrtss shufps sqrtps sqrtss stmxcsr subps subss ucomiss unpckhps unpcklps xorps fxrstor fxrstor64 fxsave fxsave64 xgetbv xsetbv xsave xsave64 xsaveopt xsaveopt64 xrstor xrstor64 prefetchnta prefetcht0 prefetcht1 prefetcht2 maskmovq movntq pavgb pavgw pextrw pinsrw pmaxsw pmaxub pminsw pminub pmovmskb pmulhuw psadbw pshufw pf2iw pfnacc pfpnacc pi2fw pswapd maskmovdqu clflush movntdq movnti movntpd movdqa movdqu movdq2q movq2dq paddq pmuludq pshufd pshufhw pshuflw pslldq psrldq psubq punpckhqdq punpcklqdq addpd addsd andnpd andpd cmpeqpd cmpeqsd cmplepd cmplesd cmpltpd cmpltsd cmpneqpd cmpneqsd cmpnlepd cmpnlesd cmpnltpd cmpnltsd cmpordpd cmpordsd cmpunordpd cmpunordsd cmppd comisd cvtdq2pd cvtdq2ps cvtpd2dq cvtpd2pi cvtpd2ps cvtpi2pd cvtps2dq cvtps2pd cvtsd2si cvtsd2ss cvtsi2sd cvtss2sd cvttpd2pi cvttpd2dq cvttps2dq cvttsd2si divpd divsd maxpd maxsd minpd minsd movapd movhpd movlpd movmskpd movupd mulpd mulsd orpd shufpd sqrtpd sqrtsd subpd subsd ucomisd unpckhpd unpcklpd xorpd addsubpd addsubps haddpd haddps hsubpd hsubps lddqu movddup movshdup movsldup clgi stgi vmcall vmclear vmfunc vmlaunch vmload vmmcall vmptrld vmptrst vmread vmresume vmrun vmsave vmwrite vmxoff vmxon invept invvpid pabsb pabsw pabsd palignr phaddw phaddd phaddsw phsubw phsubd phsubsw pmaddubsw pmulhrsw pshufb psignb psignw psignd extrq insertq movntsd movntss lzcnt blendpd blendps blendvpd blendvps dppd dpps extractps insertps movntdqa mpsadbw packusdw pblendvb pblendw pcmpeqq pextrb pextrd pextrq phminposuw pinsrb pinsrd pinsrq pmaxsb pmaxsd pmaxud pmaxuw pminsb pminsd pminud pminuw pmovsxbw pmovsxbd pmovsxbq pmovsxwd pmovsxwq pmovsxdq pmovzxbw pmovzxbd pmovzxbq pmovzxwd pmovzxwq pmovzxdq pmuldq pmulld ptest roundpd roundps roundsd roundss crc32 pcmpestri pcmpestrm pcmpistri pcmpistrm pcmpgtq popcnt getsec pfrcpv pfrsqrtv movbe aesenc aesenclast aesdec aesdeclast aesimc aeskeygenassist vaesenc vaesenclast vaesdec vaesdeclast vaesimc vaeskeygenassist vaddpd vaddps vaddsd vaddss vaddsubpd vaddsubps vandpd vandps vandnpd vandnps vblendpd vblendps vblendvpd vblendvps vbroadcastss vbroadcastsd vbroadcastf128 vcmpeq_ospd vcmpeqpd vcmplt_ospd vcmpltpd vcmple_ospd vcmplepd vcmpunord_qpd vcmpunordpd vcmpneq_uqpd vcmpneqpd vcmpnlt_uspd vcmpnltpd vcmpnle_uspd vcmpnlepd vcmpord_qpd vcmpordpd vcmpeq_uqpd vcmpnge_uspd vcmpngepd vcmpngt_uspd vcmpngtpd vcmpfalse_oqpd vcmpfalsepd vcmpneq_oqpd vcmpge_ospd vcmpgepd vcmpgt_ospd vcmpgtpd vcmptrue_uqpd vcmptruepd vcmplt_oqpd vcmple_oqpd vcmpunord_spd vcmpneq_uspd vcmpnlt_uqpd vcmpnle_uqpd vcmpord_spd vcmpeq_uspd vcmpnge_uqpd vcmpngt_uqpd vcmpfalse_ospd vcmpneq_ospd vcmpge_oqpd vcmpgt_oqpd vcmptrue_uspd vcmppd vcmpeq_osps vcmpeqps vcmplt_osps vcmpltps vcmple_osps vcmpleps vcmpunord_qps vcmpunordps vcmpneq_uqps vcmpneqps vcmpnlt_usps vcmpnltps vcmpnle_usps vcmpnleps vcmpord_qps vcmpordps vcmpeq_uqps vcmpnge_usps vcmpngeps vcmpngt_usps vcmpngtps vcmpfalse_oqps vcmpfalseps vcmpneq_oqps vcmpge_osps vcmpgeps vcmpgt_osps vcmpgtps vcmptrue_uqps vcmptrueps vcmplt_oqps vcmple_oqps vcmpunord_sps vcmpneq_usps vcmpnlt_uqps vcmpnle_uqps vcmpord_sps vcmpeq_usps vcmpnge_uqps vcmpngt_uqps vcmpfalse_osps vcmpneq_osps vcmpge_oqps vcmpgt_oqps vcmptrue_usps vcmpps vcmpeq_ossd vcmpeqsd vcmplt_ossd vcmpltsd vcmple_ossd vcmplesd vcmpunord_qsd vcmpunordsd vcmpneq_uqsd vcmpneqsd vcmpnlt_ussd vcmpnltsd vcmpnle_ussd vcmpnlesd vcmpord_qsd vcmpordsd vcmpeq_uqsd vcmpnge_ussd vcmpngesd vcmpngt_ussd vcmpngtsd vcmpfalse_oqsd vcmpfalsesd vcmpneq_oqsd vcmpge_ossd vcmpgesd vcmpgt_ossd vcmpgtsd vcmptrue_uqsd vcmptruesd vcmplt_oqsd vcmple_oqsd vcmpunord_ssd vcmpneq_ussd vcmpnlt_uqsd vcmpnle_uqsd vcmpord_ssd vcmpeq_ussd vcmpnge_uqsd vcmpngt_uqsd vcmpfalse_ossd vcmpneq_ossd vcmpge_oqsd vcmpgt_oqsd vcmptrue_ussd vcmpsd vcmpeq_osss vcmpeqss vcmplt_osss vcmpltss vcmple_osss vcmpless vcmpunord_qss vcmpunordss vcmpneq_uqss vcmpneqss vcmpnlt_usss vcmpnltss vcmpnle_usss vcmpnless vcmpord_qss vcmpordss vcmpeq_uqss vcmpnge_usss vcmpngess vcmpngt_usss vcmpngtss vcmpfalse_oqss vcmpfalsess vcmpneq_oqss vcmpge_osss vcmpgess vcmpgt_osss vcmpgtss vcmptrue_uqss vcmptruess vcmplt_oqss vcmple_oqss vcmpunord_sss vcmpneq_usss vcmpnlt_uqss vcmpnle_uqss vcmpord_sss vcmpeq_usss vcmpnge_uqss vcmpngt_uqss vcmpfalse_osss vcmpneq_osss vcmpge_oqss vcmpgt_oqss vcmptrue_usss vcmpss vcomisd vcomiss vcvtdq2pd vcvtdq2ps vcvtpd2dq vcvtpd2ps vcvtps2dq vcvtps2pd vcvtsd2si vcvtsd2ss vcvtsi2sd vcvtsi2ss vcvtss2sd vcvtss2si vcvttpd2dq vcvttps2dq vcvttsd2si vcvttss2si vdivpd vdivps vdivsd vdivss vdppd vdpps vextractf128 vextractps vhaddpd vhaddps vhsubpd vhsubps vinsertf128 vinsertps vlddqu vldqqu vldmxcsr vmaskmovdqu vmaskmovps vmaskmovpd vmaxpd vmaxps vmaxsd vmaxss vminpd vminps vminsd vminss vmovapd vmovaps vmovd vmovq vmovddup vmovdqa vmovqqa vmovdqu vmovqqu vmovhlps vmovhpd vmovhps vmovlhps vmovlpd vmovlps vmovmskpd vmovmskps vmovntdq vmovntqq vmovntdqa vmovntpd vmovntps vmovsd vmovshdup vmovsldup vmovss vmovupd vmovups vmpsadbw vmulpd vmulps vmulsd vmulss vorpd vorps vpabsb vpabsw vpabsd vpacksswb vpackssdw vpackuswb vpackusdw vpaddb vpaddw vpaddd vpaddq vpaddsb vpaddsw vpaddusb vpaddusw vpalignr vpand vpandn vpavgb vpavgw vpblendvb vpblendw vpcmpestri vpcmpestrm vpcmpistri vpcmpistrm vpcmpeqb vpcmpeqw vpcmpeqd vpcmpeqq vpcmpgtb vpcmpgtw vpcmpgtd vpcmpgtq vpermilpd vpermilps vperm2f128 vpextrb vpextrw vpextrd vpextrq vphaddw vphaddd vphaddsw vphminposuw vphsubw vphsubd vphsubsw vpinsrb vpinsrw vpinsrd vpinsrq vpmaddwd vpmaddubsw vpmaxsb vpmaxsw vpmaxsd vpmaxub vpmaxuw vpmaxud vpminsb vpminsw vpminsd vpminub vpminuw vpminud vpmovmskb vpmovsxbw vpmovsxbd vpmovsxbq vpmovsxwd vpmovsxwq vpmovsxdq vpmovzxbw vpmovzxbd vpmovzxbq vpmovzxwd vpmovzxwq vpmovzxdq vpmulhuw vpmulhrsw vpmulhw vpmullw vpmulld vpmuludq vpmuldq vpor vpsadbw vpshufb vpshufd vpshufhw vpshuflw vpsignb vpsignw vpsignd vpslldq vpsrldq vpsllw vpslld vpsllq vpsraw vpsrad vpsrlw vpsrld vpsrlq vptest vpsubb vpsubw vpsubd vpsubq vpsubsb vpsubsw vpsubusb vpsubusw vpunpckhbw vpunpckhwd vpunpckhdq vpunpckhqdq vpunpcklbw vpunpcklwd vpunpckldq vpunpcklqdq vpxor vrcpps vrcpss vrsqrtps vrsqrtss vroundpd vroundps vroundsd vroundss vshufpd vshufps vsqrtpd vsqrtps vsqrtsd vsqrtss vstmxcsr vsubpd vsubps vsubsd vsubss vtestps vtestpd vucomisd vucomiss vunpckhpd vunpckhps vunpcklpd vunpcklps vxorpd vxorps vzeroall vzeroupper pclmullqlqdq pclmulhqlqdq pclmullqhqdq pclmulhqhqdq pclmulqdq vpclmullqlqdq vpclmulhqlqdq vpclmullqhqdq vpclmulhqhqdq vpclmulqdq vfmadd132ps vfmadd132pd vfmadd312ps vfmadd312pd vfmadd213ps vfmadd213pd vfmadd123ps vfmadd123pd vfmadd231ps vfmadd231pd vfmadd321ps vfmadd321pd vfmaddsub132ps vfmaddsub132pd vfmaddsub312ps vfmaddsub312pd vfmaddsub213ps vfmaddsub213pd vfmaddsub123ps vfmaddsub123pd vfmaddsub231ps vfmaddsub231pd vfmaddsub321ps vfmaddsub321pd vfmsub132ps vfmsub132pd vfmsub312ps vfmsub312pd vfmsub213ps vfmsub213pd vfmsub123ps vfmsub123pd vfmsub231ps vfmsub231pd vfmsub321ps vfmsub321pd vfmsubadd132ps vfmsubadd132pd vfmsubadd312ps vfmsubadd312pd vfmsubadd213ps vfmsubadd213pd vfmsubadd123ps vfmsubadd123pd vfmsubadd231ps vfmsubadd231pd vfmsubadd321ps vfmsubadd321pd vfnmadd132ps vfnmadd132pd vfnmadd312ps vfnmadd312pd vfnmadd213ps vfnmadd213pd vfnmadd123ps vfnmadd123pd vfnmadd231ps vfnmadd231pd vfnmadd321ps vfnmadd321pd vfnmsub132ps vfnmsub132pd vfnmsub312ps vfnmsub312pd vfnmsub213ps vfnmsub213pd vfnmsub123ps vfnmsub123pd vfnmsub231ps vfnmsub231pd vfnmsub321ps vfnmsub321pd vfmadd132ss vfmadd132sd vfmadd312ss vfmadd312sd vfmadd213ss vfmadd213sd vfmadd123ss vfmadd123sd vfmadd231ss vfmadd231sd vfmadd321ss vfmadd321sd vfmsub132ss vfmsub132sd vfmsub312ss vfmsub312sd vfmsub213ss vfmsub213sd vfmsub123ss vfmsub123sd vfmsub231ss vfmsub231sd vfmsub321ss vfmsub321sd vfnmadd132ss vfnmadd132sd vfnmadd312ss vfnmadd312sd vfnmadd213ss vfnmadd213sd vfnmadd123ss vfnmadd123sd vfnmadd231ss vfnmadd231sd vfnmadd321ss vfnmadd321sd vfnmsub132ss vfnmsub132sd vfnmsub312ss vfnmsub312sd vfnmsub213ss vfnmsub213sd vfnmsub123ss vfnmsub123sd vfnmsub231ss vfnmsub231sd vfnmsub321ss vfnmsub321sd rdfsbase rdgsbase rdrand wrfsbase wrgsbase vcvtph2ps vcvtps2ph adcx adox rdseed clac stac xstore xcryptecb xcryptcbc xcryptctr xcryptcfb xcryptofb montmul xsha1 xsha256 llwpcb slwpcb lwpval lwpins vfmaddpd vfmaddps vfmaddsd vfmaddss vfmaddsubpd vfmaddsubps vfmsubaddpd vfmsubaddps vfmsubpd vfmsubps vfmsubsd vfmsubss vfnmaddpd vfnmaddps vfnmaddsd vfnmaddss vfnmsubpd vfnmsubps vfnmsubsd vfnmsubss vfrczpd vfrczps vfrczsd vfrczss vpcmov vpcomb vpcomd vpcomq vpcomub vpcomud vpcomuq vpcomuw vpcomw vphaddbd vphaddbq vphaddbw vphadddq vphaddubd vphaddubq vphaddubw vphaddudq vphadduwd vphadduwq vphaddwd vphaddwq vphsubbw vphsubdq vphsubwd vpmacsdd vpmacsdqh vpmacsdql vpmacssdd vpmacssdqh vpmacssdql vpmacsswd vpmacssww vpmacswd vpmacsww vpmadcsswd vpmadcswd vpperm vprotb vprotd vprotq vprotw vpshab vpshad vpshaq vpshaw vpshlb vpshld vpshlq vpshlw vbroadcasti128 vpblendd vpbroadcastb vpbroadcastw vpbroadcastd vpbroadcastq vpermd vpermpd vpermps vpermq vperm2i128 vextracti128 vinserti128 vpmaskmovd vpmaskmovq vpsllvd vpsllvq vpsravd vpsrlvd vpsrlvq vgatherdpd vgatherqpd vgatherdps vgatherqps vpgatherdd vpgatherqd vpgatherdq vpgatherqq xabort xbegin xend xtest andn bextr blci blcic blsi blsic blcfill blsfill blcmsk blsmsk blsr blcs bzhi mulx pdep pext rorx sarx shlx shrx tzcnt tzmsk t1mskc valignd valignq vblendmpd vblendmps vbroadcastf32x4 vbroadcastf64x4 vbroadcasti32x4 vbroadcasti64x4 vcompresspd vcompressps vcvtpd2udq vcvtps2udq vcvtsd2usi vcvtss2usi vcvttpd2udq vcvttps2udq vcvttsd2usi vcvttss2usi vcvtudq2pd vcvtudq2ps vcvtusi2sd vcvtusi2ss vexpandpd vexpandps vextractf32x4 vextractf64x4 vextracti32x4 vextracti64x4 vfixupimmpd vfixupimmps vfixupimmsd vfixupimmss vgetexppd vgetexpps vgetexpsd vgetexpss vgetmantpd vgetmantps vgetmantsd vgetmantss vinsertf32x4 vinsertf64x4 vinserti32x4 vinserti64x4 vmovdqa32 vmovdqa64 vmovdqu32 vmovdqu64 vpabsq vpandd vpandnd vpandnq vpandq vpblendmd vpblendmq vpcmpltd vpcmpled vpcmpneqd vpcmpnltd vpcmpnled vpcmpd vpcmpltq vpcmpleq vpcmpneqq vpcmpnltq vpcmpnleq vpcmpq vpcmpequd vpcmpltud vpcmpleud vpcmpnequd vpcmpnltud vpcmpnleud vpcmpud vpcmpequq vpcmpltuq vpcmpleuq vpcmpnequq vpcmpnltuq vpcmpnleuq vpcmpuq vpcompressd vpcompressq vpermi2d vpermi2pd vpermi2ps vpermi2q vpermt2d vpermt2pd vpermt2ps vpermt2q vpexpandd vpexpandq vpmaxsq vpmaxuq vpminsq vpminuq vpmovdb vpmovdw vpmovqb vpmovqd vpmovqw vpmovsdb vpmovsdw vpmovsqb vpmovsqd vpmovsqw vpmovusdb vpmovusdw vpmovusqb vpmovusqd vpmovusqw vpord vporq vprold vprolq vprolvd vprolvq vprord vprorq vprorvd vprorvq vpscatterdd vpscatterdq vpscatterqd vpscatterqq vpsraq vpsravq vpternlogd vpternlogq vptestmd vptestmq vptestnmd vptestnmq vpxord vpxorq vrcp14pd vrcp14ps vrcp14sd vrcp14ss vrndscalepd vrndscaleps vrndscalesd vrndscaless vrsqrt14pd vrsqrt14ps vrsqrt14sd vrsqrt14ss vscalefpd vscalefps vscalefsd vscalefss vscatterdpd vscatterdps vscatterqpd vscatterqps vshuff32x4 vshuff64x2 vshufi32x4 vshufi64x2 kandnw kandw kmovw knotw kortestw korw kshiftlw kshiftrw kunpckbw kxnorw kxorw vpbroadcastmb2q vpbroadcastmw2d vpconflictd vpconflictq vplzcntd vplzcntq vexp2pd vexp2ps vrcp28pd vrcp28ps vrcp28sd vrcp28ss vrsqrt28pd vrsqrt28ps vrsqrt28sd vrsqrt28ss vgatherpf0dpd vgatherpf0dps vgatherpf0qpd vgatherpf0qps vgatherpf1dpd vgatherpf1dps vgatherpf1qpd vgatherpf1qps vscatterpf0dpd vscatterpf0dps vscatterpf0qpd vscatterpf0qps vscatterpf1dpd vscatterpf1dps vscatterpf1qpd vscatterpf1qps prefetchwt1 bndmk bndcl bndcu bndcn bndmov bndldx bndstx sha1rnds4 sha1nexte sha1msg1 sha1msg2 sha256rnds2 sha256msg1 sha256msg2 hint_nop0 hint_nop1 hint_nop2 hint_nop3 hint_nop4 hint_nop5 hint_nop6 hint_nop7 hint_nop8 hint_nop9 hint_nop10 hint_nop11 hint_nop12 hint_nop13 hint_nop14 hint_nop15 hint_nop16 hint_nop17 hint_nop18 hint_nop19 hint_nop20 hint_nop21 hint_nop22 hint_nop23 hint_nop24 hint_nop25 hint_nop26 hint_nop27 hint_nop28 hint_nop29 hint_nop30 hint_nop31 hint_nop32 hint_nop33 hint_nop34 hint_nop35 hint_nop36 hint_nop37 hint_nop38 hint_nop39 hint_nop40 hint_nop41 hint_nop42 hint_nop43 hint_nop44 hint_nop45 hint_nop46 hint_nop47 hint_nop48 hint_nop49 hint_nop50 hint_nop51 hint_nop52 hint_nop53 hint_nop54 hint_nop55 hint_nop56 hint_nop57 hint_nop58 hint_nop59 hint_nop60 hint_nop61 hint_nop62 hint_nop63",
                built_in: "ip eip rip al ah bl bh cl ch dl dh sil dil bpl spl r8b r9b r10b r11b r12b r13b r14b r15b ax bx cx dx si di bp sp r8w r9w r10w r11w r12w r13w r14w r15w eax ebx ecx edx esi edi ebp esp eip r8d r9d r10d r11d r12d r13d r14d r15d rax rbx rcx rdx rsi rdi rbp rsp r8 r9 r10 r11 r12 r13 r14 r15 cs ds es fs gs ss st st0 st1 st2 st3 st4 st5 st6 st7 mm0 mm1 mm2 mm3 mm4 mm5 mm6 mm7 xmm0  xmm1  xmm2  xmm3  xmm4  xmm5  xmm6  xmm7  xmm8  xmm9 xmm10  xmm11 xmm12 xmm13 xmm14 xmm15 xmm16 xmm17 xmm18 xmm19 xmm20 xmm21 xmm22 xmm23 xmm24 xmm25 xmm26 xmm27 xmm28 xmm29 xmm30 xmm31 ymm0  ymm1  ymm2  ymm3  ymm4  ymm5  ymm6  ymm7  ymm8  ymm9 ymm10  ymm11 ymm12 ymm13 ymm14 ymm15 ymm16 ymm17 ymm18 ymm19 ymm20 ymm21 ymm22 ymm23 ymm24 ymm25 ymm26 ymm27 ymm28 ymm29 ymm30 ymm31 zmm0  zmm1  zmm2  zmm3  zmm4  zmm5  zmm6  zmm7  zmm8  zmm9 zmm10  zmm11 zmm12 zmm13 zmm14 zmm15 zmm16 zmm17 zmm18 zmm19 zmm20 zmm21 zmm22 zmm23 zmm24 zmm25 zmm26 zmm27 zmm28 zmm29 zmm30 zmm31 k0 k1 k2 k3 k4 k5 k6 k7 bnd0 bnd1 bnd2 bnd3 cr0 cr1 cr2 cr3 cr4 cr8 dr0 dr1 dr2 dr3 dr8 tr3 tr4 tr5 tr6 tr7 r0 r1 r2 r3 r4 r5 r6 r7 r0b r1b r2b r3b r4b r5b r6b r7b r0w r1w r2w r3w r4w r5w r6w r7w r0d r1d r2d r3d r4d r5d r6d r7d r0h r1h r2h r3h r0l r1l r2l r3l r4l r5l r6l r7l r8l r9l r10l r11l r12l r13l r14l r15l db dw dd dq dt ddq do dy dz resb resw resd resq rest resdq reso resy resz incbin equ times byte word dword qword nosplit rel abs seg wrt strict near far a32 ptr",
                meta: "%define %xdefine %+ %undef %defstr %deftok %assign %strcat %strlen %substr %rotate %elif %else %endif %if %ifmacro %ifctx %ifidn %ifidni %ifid %ifnum %ifstr %iftoken %ifempty %ifenv %error %warning %fatal %rep %endrep %include %push %pop %repl %pathsearch %depend %use %arg %stacksize %local %line %comment %endcomment .nolist __FILE__ __LINE__ __SECT__  __BITS__ __OUTPUT_FORMAT__ __DATE__ __TIME__ __DATE_NUM__ __TIME_NUM__ __UTC_DATE__ __UTC_TIME__ __UTC_DATE_NUM__ __UTC_TIME_NUM__  __PASS__ struc endstruc istruc at iend align alignb sectalign daz nodaz up down zero default option assume public bits use16 use32 use64 default section segment absolute extern global common cpu float __utf16__ __utf16le__ __utf16be__ __utf32__ __utf32le__ __utf32be__ __float8__ __float16__ __float32__ __float64__ __float80m__ __float80e__ __float128l__ __float128h__ __Infinity__ __QNaN__ __SNaN__ Inf NaN QNaN SNaN float8 float16 float32 float64 float80m float80e float128l float128h __FLOAT_DAZ__ __FLOAT_ROUND__ __FLOAT__"
            },
            contains: [
                e.COMMENT(";", "$", {
                    relevance: 0
                }),
                {
                    className: "number",
                    variants: [
                        {
                            begin: "\\b(?:([0-9][0-9_]*)?\\.[0-9_]*(?:[eE][+-]?[0-9_]+)?|(0[Xx])?[0-9][0-9_]*(\\.[0-9_]*)?(?:[pP](?:[+-]?[0-9_]+)?)?)\\b",
                            relevance: 0
                        },
                        {
                            begin: "\\$[0-9][0-9A-Fa-f]*",
                            relevance: 0
                        },
                        {
                            begin: "\\b(?:[0-9A-Fa-f][0-9A-Fa-f_]*[Hh]|[0-9][0-9_]*[DdTt]?|[0-7][0-7_]*[QqOo]|[0-1][0-1_]*[BbYy])\\b"
                        },
                        {
                            begin: "\\b(?:0[Xx][0-9A-Fa-f_]+|0[DdTt][0-9_]+|0[QqOo][0-7_]+|0[BbYy][0-1_]+)\\b"
                        }
                    ]
                },
                e.QUOTE_STRING_MODE,
                {
                    className: "string",
                    variants: [
                        {
                            begin: "'",
                            end: "[^\\\\]'"
                        },
                        {
                            begin: "`",
                            end: "[^\\\\]`"
                        }
                    ],
                    relevance: 0
                },
                {
                    className: "symbol",
                    variants: [
                        {
                            begin: "^\\s*[A-Za-z._?][A-Za-z0-9_$#@~.?]*(:|\\s+label)"
                        },
                        {
                            begin: "^\\s*%%[A-Za-z0-9_$#@~.?]*:"
                        }
                    ],
                    relevance: 0
                },
                {
                    className: "subst",
                    begin: "%[0-9]+",
                    relevance: 0
                },
                {
                    className: "subst",
                    begin: "%!S+",
                    relevance: 0
                },
                {
                    className: "meta",
                    begin: /^\s*\.[\w_-]+/
                }
            ]
        };
    }), ds)), Cs.registerLanguage("xl", (us || (us = 1, ps = function(e) {
        const t = {
            $pattern: /[a-zA-Z][a-zA-Z0-9_?]*/,
            keyword: [
                "if",
                "then",
                "else",
                "do",
                "while",
                "until",
                "for",
                "loop",
                "import",
                "with",
                "is",
                "as",
                "where",
                "when",
                "by",
                "data",
                "constant",
                "integer",
                "real",
                "text",
                "name",
                "boolean",
                "symbol",
                "infix",
                "prefix",
                "postfix",
                "block",
                "tree"
            ],
            literal: [
                "true",
                "false",
                "nil"
            ],
            built_in: [
                "in",
                "mod",
                "rem",
                "and",
                "or",
                "xor",
                "not",
                "abs",
                "sign",
                "floor",
                "ceil",
                "sqrt",
                "sin",
                "cos",
                "tan",
                "asin",
                "acos",
                "atan",
                "exp",
                "expm1",
                "log",
                "log2",
                "log10",
                "log1p",
                "pi",
                "at",
                "text_length",
                "text_range",
                "text_find",
                "text_replace",
                "contains",
                "page",
                "slide",
                "basic_slide",
                "title_slide",
                "title",
                "subtitle",
                "fade_in",
                "fade_out",
                "fade_at",
                "clear_color",
                "color",
                "line_color",
                "line_width",
                "texture_wrap",
                "texture_transform",
                "texture",
                "scale_?x",
                "scale_?y",
                "scale_?z?",
                "translate_?x",
                "translate_?y",
                "translate_?z?",
                "rotate_?x",
                "rotate_?y",
                "rotate_?z?",
                "rectangle",
                "circle",
                "ellipse",
                "sphere",
                "path",
                "line_to",
                "move_to",
                "quad_to",
                "curve_to",
                "theme",
                "background",
                "contents",
                "locally",
                "time",
                "mouse_?x",
                "mouse_?y",
                "mouse_buttons"
            ].concat([
                "ObjectLoader",
                "Animate",
                "MovieCredits",
                "Slides",
                "Filters",
                "Shading",
                "Materials",
                "LensFlare",
                "Mapping",
                "VLCAudioVideo",
                "StereoDecoder",
                "PointCloud",
                "NetworkAccess",
                "RemoteControl",
                "RegExp",
                "ChromaKey",
                "Snowfall",
                "NodeJS",
                "Speech",
                "Charts"
            ])
        }, a = {
            className: "string",
            begin: '"',
            end: '"',
            illegal: "\\n"
        }, n = {
            beginKeywords: "import",
            end: "$",
            keywords: t,
            contains: [
                a
            ]
        }, i = {
            className: "function",
            begin: /[a-z][^\n]*->/,
            returnBegin: !0,
            end: /->/,
            contains: [
                e.inherit(e.TITLE_MODE, {
                    starts: {
                        endsWithParent: !0,
                        keywords: t
                    }
                })
            ]
        };
        return {
            name: "XL",
            aliases: [
                "tao"
            ],
            keywords: t,
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.C_BLOCK_COMMENT_MODE,
                a,
                {
                    className: "string",
                    begin: "'",
                    end: "'",
                    illegal: "\\n"
                },
                {
                    className: "string",
                    begin: "<<",
                    end: ">>"
                },
                i,
                n,
                {
                    className: "number",
                    begin: "[0-9]+#[0-9A-Z_]+(\\.[0-9-A-Z_]+)?#?([Ee][+-]?[0-9]+)?"
                },
                e.NUMBER_MODE
            ]
        };
    }), ps)), Cs.registerLanguage("xquery", Es ? gs : (Es = 1, gs = function(e) {
        return {
            name: "XQuery",
            aliases: [
                "xpath",
                "xq",
                "xqm"
            ],
            case_insensitive: !1,
            illegal: /(proc)|(abstract)|(extends)|(until)|(#)/,
            keywords: {
                $pattern: /[a-zA-Z$][a-zA-Z0-9_:-]*/,
                keyword: [
                    "module",
                    "schema",
                    "namespace",
                    "boundary-space",
                    "preserve",
                    "no-preserve",
                    "strip",
                    "default",
                    "collation",
                    "base-uri",
                    "ordering",
                    "context",
                    "decimal-format",
                    "decimal-separator",
                    "copy-namespaces",
                    "empty-sequence",
                    "except",
                    "exponent-separator",
                    "external",
                    "grouping-separator",
                    "inherit",
                    "no-inherit",
                    "lax",
                    "minus-sign",
                    "per-mille",
                    "percent",
                    "schema-attribute",
                    "schema-element",
                    "strict",
                    "unordered",
                    "zero-digit",
                    "declare",
                    "import",
                    "option",
                    "function",
                    "validate",
                    "variable",
                    "for",
                    "at",
                    "in",
                    "let",
                    "where",
                    "order",
                    "group",
                    "by",
                    "return",
                    "if",
                    "then",
                    "else",
                    "tumbling",
                    "sliding",
                    "window",
                    "start",
                    "when",
                    "only",
                    "end",
                    "previous",
                    "next",
                    "stable",
                    "ascending",
                    "descending",
                    "allowing",
                    "empty",
                    "greatest",
                    "least",
                    "some",
                    "every",
                    "satisfies",
                    "switch",
                    "case",
                    "typeswitch",
                    "try",
                    "catch",
                    "and",
                    "or",
                    "to",
                    "union",
                    "intersect",
                    "instance",
                    "of",
                    "treat",
                    "as",
                    "castable",
                    "cast",
                    "map",
                    "array",
                    "delete",
                    "insert",
                    "into",
                    "replace",
                    "value",
                    "rename",
                    "copy",
                    "modify",
                    "update"
                ],
                type: [
                    "item",
                    "document-node",
                    "node",
                    "attribute",
                    "document",
                    "element",
                    "comment",
                    "namespace",
                    "namespace-node",
                    "processing-instruction",
                    "text",
                    "construction",
                    "xs:anyAtomicType",
                    "xs:untypedAtomic",
                    "xs:duration",
                    "xs:time",
                    "xs:decimal",
                    "xs:float",
                    "xs:double",
                    "xs:gYearMonth",
                    "xs:gYear",
                    "xs:gMonthDay",
                    "xs:gMonth",
                    "xs:gDay",
                    "xs:boolean",
                    "xs:base64Binary",
                    "xs:hexBinary",
                    "xs:anyURI",
                    "xs:QName",
                    "xs:NOTATION",
                    "xs:dateTime",
                    "xs:dateTimeStamp",
                    "xs:date",
                    "xs:string",
                    "xs:normalizedString",
                    "xs:token",
                    "xs:language",
                    "xs:NMTOKEN",
                    "xs:Name",
                    "xs:NCName",
                    "xs:ID",
                    "xs:IDREF",
                    "xs:ENTITY",
                    "xs:integer",
                    "xs:nonPositiveInteger",
                    "xs:negativeInteger",
                    "xs:long",
                    "xs:int",
                    "xs:short",
                    "xs:byte",
                    "xs:nonNegativeInteger",
                    "xs:unisignedLong",
                    "xs:unsignedInt",
                    "xs:unsignedShort",
                    "xs:unsignedByte",
                    "xs:positiveInteger",
                    "xs:yearMonthDuration",
                    "xs:dayTimeDuration"
                ],
                literal: [
                    "eq",
                    "ne",
                    "lt",
                    "le",
                    "gt",
                    "ge",
                    "is",
                    "self::",
                    "child::",
                    "descendant::",
                    "descendant-or-self::",
                    "attribute::",
                    "following::",
                    "following-sibling::",
                    "parent::",
                    "ancestor::",
                    "ancestor-or-self::",
                    "preceding::",
                    "preceding-sibling::",
                    "NaN"
                ]
            },
            contains: [
                {
                    className: "variable",
                    begin: /[$][\w\-:]+/
                },
                {
                    className: "built_in",
                    variants: [
                        {
                            begin: /\barray:/,
                            end: /(?:append|filter|flatten|fold-(?:left|right)|for-each(?:-pair)?|get|head|insert-before|join|put|remove|reverse|size|sort|subarray|tail)\b/
                        },
                        {
                            begin: /\bmap:/,
                            end: /(?:contains|entry|find|for-each|get|keys|merge|put|remove|size)\b/
                        },
                        {
                            begin: /\bmath:/,
                            end: /(?:a(?:cos|sin|tan[2]?)|cos|exp(?:10)?|log(?:10)?|pi|pow|sin|sqrt|tan)\b/
                        },
                        {
                            begin: /\bop:/,
                            end: /\(/,
                            excludeEnd: !0
                        },
                        {
                            begin: /\bfn:/,
                            end: /\(/,
                            excludeEnd: !0
                        },
                        {
                            begin: /[^</$:'"-]\b(?:abs|accumulator-(?:after|before)|adjust-(?:date(?:Time)?|time)-to-timezone|analyze-string|apply|available-(?:environment-variables|system-properties)|avg|base-uri|boolean|ceiling|codepoints?-(?:equal|to-string)|collation-key|collection|compare|concat|contains(?:-token)?|copy-of|count|current(?:-)?(?:date(?:Time)?|time|group(?:ing-key)?|output-uri|merge-(?:group|key))?data|dateTime|days?-from-(?:date(?:Time)?|duration)|deep-equal|default-(?:collation|language)|distinct-values|document(?:-uri)?|doc(?:-available)?|element-(?:available|with-id)|empty|encode-for-uri|ends-with|environment-variable|error|escape-html-uri|exactly-one|exists|false|filter|floor|fold-(?:left|right)|for-each(?:-pair)?|format-(?:date(?:Time)?|time|integer|number)|function-(?:arity|available|lookup|name)|generate-id|has-children|head|hours-from-(?:dateTime|duration|time)|id(?:ref)?|implicit-timezone|in-scope-prefixes|index-of|innermost|insert-before|iri-to-uri|json-(?:doc|to-xml)|key|lang|last|load-xquery-module|local-name(?:-from-QName)?|(?:lower|upper)-case|matches|max|minutes-from-(?:dateTime|duration|time)|min|months?-from-(?:date(?:Time)?|duration)|name(?:space-uri-?(?:for-prefix|from-QName)?)?|nilled|node-name|normalize-(?:space|unicode)|not|number|one-or-more|outermost|parse-(?:ietf-date|json)|path|position|(?:prefix-from-)?QName|random-number-generator|regex-group|remove|replace|resolve-(?:QName|uri)|reverse|root|round(?:-half-to-even)?|seconds-from-(?:dateTime|duration|time)|snapshot|sort|starts-with|static-base-uri|stream-available|string-?(?:join|length|to-codepoints)?|subsequence|substring-?(?:after|before)?|sum|system-property|tail|timezone-from-(?:date(?:Time)?|time)|tokenize|trace|trans(?:form|late)|true|type-available|unordered|unparsed-(?:entity|text)?-?(?:public-id|uri|available|lines)?|uri-collection|xml-to-json|years?-from-(?:date(?:Time)?|duration)|zero-or-one)\b/
                        },
                        {
                            begin: /\blocal:/,
                            end: /\(/,
                            excludeEnd: !0
                        },
                        {
                            begin: /\bzip:/,
                            end: /(?:zip-file|(?:xml|html|text|binary)-entry| (?:update-)?entries)\b/
                        },
                        {
                            begin: /\b(?:util|db|functx|app|xdmp|xmldb):/,
                            end: /\(/,
                            excludeEnd: !0
                        }
                    ]
                },
                {
                    className: "string",
                    variants: [
                        {
                            begin: /"/,
                            end: /"/,
                            contains: [
                                {
                                    begin: /""/,
                                    relevance: 0
                                }
                            ]
                        },
                        {
                            begin: /'/,
                            end: /'/,
                            contains: [
                                {
                                    begin: /''/,
                                    relevance: 0
                                }
                            ]
                        }
                    ]
                },
                {
                    className: "number",
                    begin: /(\b0[0-7_]+)|(\b0x[0-9a-fA-F_]+)|(\b[1-9][0-9_]*(\.[0-9_]+)?)|[0_]\b/,
                    relevance: 0
                },
                {
                    className: "comment",
                    begin: /\(:/,
                    end: /:\)/,
                    relevance: 10,
                    contains: [
                        {
                            className: "doctag",
                            begin: /@\w+/
                        }
                    ]
                },
                {
                    className: "meta",
                    begin: /%[\w\-:]+/
                },
                {
                    className: "title",
                    begin: /\bxquery version "[13]\.[01]"\s?(?:encoding ".+")?/,
                    end: /;/
                },
                {
                    beginKeywords: "element attribute comment document processing-instruction",
                    end: /\{/,
                    excludeEnd: !0
                },
                {
                    begin: /<([\w._:-]+)(\s+\S*=('|").*('|"))?>/,
                    end: /(\/[\w._:-]+>)/,
                    subLanguage: "xml",
                    contains: [
                        {
                            begin: /\{/,
                            end: /\}/,
                            subLanguage: "xquery"
                        },
                        "self"
                    ]
                }
            ]
        };
    })), Cs.registerLanguage("zephir", (bs || (bs = 1, Ss = function(e) {
        const t = {
            className: "string",
            contains: [
                e.BACKSLASH_ESCAPE
            ],
            variants: [
                e.inherit(e.APOS_STRING_MODE, {
                    illegal: null
                }),
                e.inherit(e.QUOTE_STRING_MODE, {
                    illegal: null
                })
            ]
        }, a = e.UNDERSCORE_TITLE_MODE, n = {
            variants: [
                e.BINARY_NUMBER_MODE,
                e.C_NUMBER_MODE
            ]
        }, i = "namespace class interface use extends function return abstract final public protected private static deprecated throw try catch Exception echo empty isset instanceof unset let var new const self require if else elseif switch case default do while loop for continue break likely unlikely __LINE__ __FILE__ __DIR__ __FUNCTION__ __CLASS__ __TRAIT__ __METHOD__ __NAMESPACE__ array boolean float double integer object resource string char long unsigned bool int uint ulong uchar true false null undefined";
        return {
            name: "Zephir",
            aliases: [
                "zep"
            ],
            keywords: i,
            contains: [
                e.C_LINE_COMMENT_MODE,
                e.COMMENT(/\/\*/, /\*\//, {
                    contains: [
                        {
                            className: "doctag",
                            begin: /@[A-Za-z]+/
                        }
                    ]
                }),
                {
                    className: "string",
                    begin: /<<<['"]?\w+['"]?$/,
                    end: /^\w+;/,
                    contains: [
                        e.BACKSLASH_ESCAPE
                    ]
                },
                {
                    begin: /(::|->)+[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/
                },
                {
                    className: "function",
                    beginKeywords: "function fn",
                    end: /[;{]/,
                    excludeEnd: !0,
                    illegal: /\$|\[|%/,
                    contains: [
                        a,
                        {
                            className: "params",
                            begin: /\(/,
                            end: /\)/,
                            keywords: i,
                            contains: [
                                "self",
                                e.C_BLOCK_COMMENT_MODE,
                                t,
                                n
                            ]
                        }
                    ]
                },
                {
                    className: "class",
                    beginKeywords: "class interface",
                    end: /\{/,
                    excludeEnd: !0,
                    illegal: /[:($"]/,
                    contains: [
                        {
                            beginKeywords: "extends implements"
                        },
                        a
                    ]
                },
                {
                    beginKeywords: "namespace",
                    end: /;/,
                    illegal: /[.']/,
                    contains: [
                        a
                    ]
                },
                {
                    beginKeywords: "use",
                    end: /;/,
                    contains: [
                        a
                    ]
                },
                {
                    begin: /=>/
                },
                t,
                n
            ]
        };
    }), Ss)), Cs.HighlightJS = Cs, Cs.default = Cs;
    var fs = e(Cs);
    !function(e, t) {
        var a, n = "hljs-ln", i = "hljs-ln-line", r = "hljs-ln-code", o = "hljs-ln-numbers", s = "hljs-ln-n", l = "data-line-number", c = /\r\n|\r|\n/g;
        function _(a) {
            try {
                var n = t.querySelectorAll("code.hljs,code.nohighlight");
                for(var i in n)n.hasOwnProperty(i) && (n[i].classList.contains("nohljsln") || d(n[i], a));
            } catch (a) {
                e.console.error("LineNumbers error: ", a);
            }
        }
        function d(e, t) {
            "object" == typeof e && (e.innerHTML = m(e, t));
        }
        function m(e, t) {
            var a, _, d = (a = e, {
                singleLine: function(e) {
                    return !!e.singleLine && e.singleLine;
                }(_ = (_ = t) || {}),
                startFrom: function(e, t) {
                    var a = 1;
                    isFinite(t.startFrom) && (a = t.startFrom);
                    var n = function(e, t) {
                        return e.hasAttribute(t) ? e.getAttribute(t) : null;
                    }(e, "data-ln-start-from");
                    return null !== n && (a = function(e, t) {
                        if (!e) return 1;
                        var a = Number(e);
                        return isFinite(a) ? a : 1;
                    }(n)), a;
                }(a, _)
            });
            return function e(t) {
                var a = t.childNodes;
                for(var n in a){
                    var i;
                    a.hasOwnProperty(n) && 0 < ((i = a[n]).textContent.trim().match(c) || []).length && (0 < i.childNodes.length ? e(i) : p(i.parentNode));
                }
            }(e), function(e, t) {
                var a = u(e);
                if ("" === a[a.length - 1].trim() && a.pop(), 1 < a.length || t.singleLine) {
                    for(var c = "", _ = 0, d = a.length; _ < d; _++)c += g('<tr><td class="{0} {1}" {3}="{5}"><div class="{2}" {3}="{5}"></div></td><td class="{0} {4}" {3}="{5}">{6}</td></tr>', [
                        i,
                        o,
                        s,
                        l,
                        r,
                        _ + t.startFrom,
                        0 < a[_].length ? a[_] : " "
                    ]);
                    return g('<table class="{0}">{1}</table>', [
                        n,
                        c
                    ]);
                }
                return e;
            }(e.innerHTML, d);
        }
        function p(e) {
            var t = e.className;
            if (/hljs-/.test(t)) {
                for(var a = u(e.innerHTML), n = 0, i = ""; n < a.length; n++)i += g('<span class="{0}">{1}</span>\n', [
                    t,
                    0 < a[n].length ? a[n] : " "
                ]);
                e.innerHTML = i.trim();
            }
        }
        function u(e) {
            return 0 === e.length ? [] : e.split(c);
        }
        function g(e, t) {
            return e.replace(/\{(\d+)\}/g, function(e, a) {
                return void 0 !== t[a] ? t[a] : e;
            });
        }
        fs ? (fs.initLineNumbersOnLoad = function(a) {
            "interactive" === t.readyState || "complete" === t.readyState ? _(a) : e.addEventListener("DOMContentLoaded", function() {
                _(a);
            });
        }, fs.lineNumbersBlock = d, fs.lineNumbersValue = function(e, t) {
            if ("string" == typeof e) {
                var a = document.createElement("code");
                return a.innerHTML = e, m(a, t);
            }
        }, (a = t.createElement("style")).type = "text/css", a.innerHTML = g(".{0}{border-collapse:collapse}.{0} td{padding:0}.{1}:before{content:attr({2})}", [
            n,
            s,
            l
        ]), t.getElementsByTagName("head")[0].appendChild(a)) : e.console.error("highlight.js not detected!"), document.addEventListener("copy", function(e) {
            var t, a = window.getSelection();
            !function(e) {
                for(var t = e; t;){
                    if (t.className && -1 !== t.className.indexOf("hljs-ln-code")) return 1;
                    t = t.parentNode;
                }
            }(a.anchorNode) || (t = -1 !== window.navigator.userAgent.indexOf("Edge") ? function(e) {
                for(var t = e.toString(), a = e.anchorNode; "TD" !== a.nodeName;)a = a.parentNode;
                for(var n = e.focusNode; "TD" !== n.nodeName;)n = n.parentNode;
                var i = parseInt(a.dataset.lineNumber), o = parseInt(n.dataset.lineNumber);
                if (i == o) return t;
                var s, c = a.textContent, _ = n.textContent;
                for(o < i && (s = i, i = o, o = s, s = c, c = _, _ = s); 0 !== t.indexOf(c);)c = c.slice(1);
                for(; -1 === t.lastIndexOf(_);)_ = _.slice(0, -1);
                for(var d = c, m = function(e) {
                    for(var t = e; "TABLE" !== t.nodeName;)t = t.parentNode;
                    return t;
                }(a), p = i + 1; p < o; ++p){
                    var u = g('.{0}[{1}="{2}"]', [
                        r,
                        l,
                        p
                    ]);
                    d += "\n" + m.querySelector(u).textContent;
                }
                return d + "\n" + _;
            }(a) : a.toString(), e.clipboardData.setData("text/plain", t), e.preventDefault());
        });
    }(window, document);
    /*!
	 * reveal.js plugin that adds syntax highlight support.
	 */ const Rs = {
        id: "highlight",
        HIGHLIGHT_STEP_DELIMITER: "|",
        HIGHLIGHT_LINE_DELIMITER: ",",
        HIGHLIGHT_LINE_RANGE_DELIMITER: "-",
        hljs: fs,
        init: function(e) {
            let t = e.getConfig().highlight || {};
            t.highlightOnLoad = "boolean" != typeof t.highlightOnLoad || t.highlightOnLoad, t.escapeHTML = "boolean" != typeof t.escapeHTML || t.escapeHTML, Array.from(e.getRevealElement().querySelectorAll("pre code")).forEach((e)=>{
                e.parentNode.classList.add("code-wrapper");
                let a = e.querySelector('script[type="text/template"]');
                a && (e.textContent = a.innerHTML), e.hasAttribute("data-trim") && "function" == typeof e.innerHTML.trim && (e.innerHTML = function(e) {
                    function t(e) {
                        return e.replace(/^[\s\uFEFF\xA0]+/g, "");
                    }
                    function a(e) {
                        for(var t = e.split("\n"), a = 0; a < t.length && "" === t[a].trim(); a++)t.splice(a--, 1);
                        for(a = t.length - 1; a >= 0 && "" === t[a].trim(); a--)t.splice(a, 1);
                        return t.join("\n");
                    }
                    return function(e) {
                        var n = a(e.innerHTML).split("\n"), i = n.reduce(function(e, a) {
                            return a.length > 0 && t(a).length > 0 && e > a.length - t(a).length ? a.length - t(a).length : e;
                        }, Number.POSITIVE_INFINITY);
                        return n.map(function(e, t) {
                            return e.slice(i);
                        }).join("\n");
                    }(e);
                }(e)), t.escapeHTML && !e.hasAttribute("data-noescape") && (e.innerHTML = e.innerHTML.replace(/</g, "&lt;").replace(/>/g, "&gt;")), e.addEventListener("focusout", function(e) {
                    fs.highlightElement(e.currentTarget);
                }, !1);
            }), "function" == typeof t.beforeHighlight && t.beforeHighlight(fs), t.highlightOnLoad && Array.from(e.getRevealElement().querySelectorAll("pre code")).forEach((e)=>{
                Rs.highlightBlock(e);
            }), e.on("pdf-ready", function() {
                [].slice.call(e.getRevealElement().querySelectorAll("pre code[data-line-numbers].current-fragment")).forEach(function(e) {
                    Rs.scrollHighlightedLineIntoView(e, {}, !0);
                });
            });
        },
        highlightBlock: function(e) {
            if (fs.highlightElement(e), 0 !== e.innerHTML.trim().length && e.hasAttribute("data-line-numbers")) {
                fs.lineNumbersBlock(e, {
                    singleLine: !0
                });
                var t = {
                    currentBlock: e
                }, a = Rs.deserializeHighlightSteps(e.getAttribute("data-line-numbers"));
                if (a.length > 1) {
                    var n = parseInt(e.getAttribute("data-fragment-index"), 10);
                    ("number" != typeof n || isNaN(n)) && (n = null), a.slice(1).forEach(function(a) {
                        var i = e.cloneNode(!0);
                        i.setAttribute("data-line-numbers", Rs.serializeHighlightSteps([
                            a
                        ])), i.classList.add("fragment"), e.parentNode.appendChild(i), Rs.highlightLines(i), "number" == typeof n ? (i.setAttribute("data-fragment-index", n), n += 1) : i.removeAttribute("data-fragment-index"), i.addEventListener("visible", Rs.scrollHighlightedLineIntoView.bind(Rs, i, t)), i.addEventListener("hidden", Rs.scrollHighlightedLineIntoView.bind(Rs, i.previousSibling, t));
                    }), e.removeAttribute("data-fragment-index"), e.setAttribute("data-line-numbers", Rs.serializeHighlightSteps([
                        a[0]
                    ]));
                }
                var i = "function" == typeof e.closest ? e.closest("section:not(.stack)") : null;
                if (i) {
                    var r = function() {
                        Rs.scrollHighlightedLineIntoView(e, t, !0), i.removeEventListener("visible", r);
                    };
                    i.addEventListener("visible", r);
                }
                Rs.highlightLines(e);
            }
        },
        scrollHighlightedLineIntoView: function(e, t, a) {
            cancelAnimationFrame(t.animationFrameID), t.currentBlock && (e.scrollTop = t.currentBlock.scrollTop), t.currentBlock = e;
            var n = this.getHighlightedLineBounds(e), i = e.offsetHeight, r = getComputedStyle(e);
            i -= parseInt(r.paddingTop) + parseInt(r.paddingBottom);
            var o = e.scrollTop, s = n.top + (Math.min(n.bottom - n.top, i) - i) / 2, l = e.querySelector(".hljs-ln");
            if (l && (s += l.offsetTop - parseInt(r.paddingTop)), s = Math.max(Math.min(s, e.scrollHeight - i), 0), !0 === a || o === s) e.scrollTop = s;
            else {
                if (e.scrollHeight <= i) return;
                var c = 0, _ = function() {
                    c = Math.min(c + .02, 1), e.scrollTop = o + (s - o) * Rs.easeInOutQuart(c), c < 1 && (t.animationFrameID = requestAnimationFrame(_));
                };
                _();
            }
        },
        easeInOutQuart: function(e) {
            return e < .5 ? 8 * e * e * e * e : 1 - 8 * --e * e * e * e;
        },
        getHighlightedLineBounds: function(e) {
            var t = e.querySelectorAll(".highlight-line");
            if (0 === t.length) return {
                top: 0,
                bottom: 0
            };
            var a = t[0], n = t[t.length - 1];
            return {
                top: a.offsetTop,
                bottom: n.offsetTop + n.offsetHeight
            };
        },
        highlightLines: function(e, t) {
            var a = Rs.deserializeHighlightSteps(t || e.getAttribute("data-line-numbers"));
            a.length && a[0].forEach(function(t) {
                var a = [];
                "number" == typeof t.end ? a = [].slice.call(e.querySelectorAll("table tr:nth-child(n+" + t.start + "):nth-child(-n+" + t.end + ")")) : "number" == typeof t.start && (a = [].slice.call(e.querySelectorAll("table tr:nth-child(" + t.start + ")"))), a.length && (a.forEach(function(e) {
                    e.classList.add("highlight-line");
                }), e.classList.add("has-highlights"));
            });
        },
        deserializeHighlightSteps: function(e) {
            return (e = (e = e.replace(/\s/g, "")).split(Rs.HIGHLIGHT_STEP_DELIMITER)).map(function(e) {
                return e.split(Rs.HIGHLIGHT_LINE_DELIMITER).map(function(e) {
                    if (/^[\d-]+$/.test(e)) {
                        e = e.split(Rs.HIGHLIGHT_LINE_RANGE_DELIMITER);
                        var t = parseInt(e[0], 10), a = parseInt(e[1], 10);
                        return isNaN(a) ? {
                            start: t
                        } : {
                            start: t,
                            end: a
                        };
                    }
                    return {};
                });
            });
        },
        serializeHighlightSteps: function(e) {
            return e.map(function(e) {
                return e.map(function(e) {
                    return "number" == typeof e.end ? e.start + Rs.HIGHLIGHT_LINE_RANGE_DELIMITER + e.end : "number" == typeof e.start ? e.start : "";
                }).join(Rs.HIGHLIGHT_LINE_DELIMITER);
            }).join(Rs.HIGHLIGHT_STEP_DELIMITER);
        }
    };
    return ()=>Rs;
});

//# sourceMappingURL=tooling.reveal.f6a6f820.js.map
